module.exports={
"label_emailtocloudcc_department":`Департамент`,
"label.wei.weiresearch":`Микро Голос`,
"message.error.appsecret.null":`Пароль секретного ключа не может быть нулевым!`,
"label.file.orderbylastmodifydate":`Отсортировано по последнему измененному времени`,
"label.minus":`-Минус`,
"label.horizontalbar":`Горизонтальные линии`,
"label.emailobject.emailsentfailed":`Почта не пришла на send！.`,
"assignedresource.check":`Этот сервисный ресурс был назначен на сервисный прием. Пожалуйста, не добавляйте его повторно.`,
"label.finish":`Полный`,
"label.document.history":`История загрузки`,
"label.customfields.number.numberLengthHelpText":`1.Пожалуйста, введите длину числа и количество знаков после запятой. Например, число с длиной 8 и 2 знаками после запятой может принимать значения до "12345678.90".`,
"label.standard.buttonandlink.info":`Переопределение стандартных кнопок и ссылок меняет значение URL CloudCC.com и любые вызовы на этот URL, такие как пользовательская страница CloudCC.com, ярлык браузера или внешняя система. URL CloudCC.com можно заменить стандартной кнопкой или ссылкой на пользовательскую страницу.`,
"front-epwechat-module-v1-contacts-desc":`При включении этой опции в системе CloudCC будет добавлен объект WeCom Contacts, информация о клиентах из WeCom будет синхронизироваться с этим объектом.`,
"label.mr.caption.contact.result":`Поиск дубликатов и слияние: Результаты запроса дубликатов Контактов`,
"label.ems.selectaccount":`Выберите счёт`,
"label.group.no.activity":`Нет соответствующих активных групп.`,
"label.call.for":`Приглашённый`,
"label.newreportguide":`Новое руководство по составлению отчётов`,
"component.telerecord.label.name":`Имена`,
"vue.add.dashboard.component":`Добавить компонент {titleName}`,
"label.chatter.sendEmailToGroupMember.check.V":`Просмотреть голоса`,
"UG.ST.002":`Определить`,
"label.setting.intergrationmanage":`Управление интеграцией`,
"label.field.apiname.validate":`Пожалуйста, введите число от 0 до 6.`,
"label.emailmerge.list.deletefolder":`Удалить папку`,
"vue_label_pool_received":`Получен`,
"label_emailtocloudcc_step1_case1":`Электронная почта на имя дела`,
"message.sumlength":`Суммарная длина и количество знаков после запятой не может превышать 18 пальцев.`,
"vue_label_approve_reassignapproval":`...переназначил это одобрение людям...`,
"label.specify.time":`Время: 13:00 21 июня 2016 г.`,
"vue_label_report_sortdown":`Сортировать в порядке убывания`,
"chatter.login.now":`Загрузка...`,
"label.import.page2.notsuited":`Нерассмотренный`,
"label.please.fill.out":`Пожалуйста, заполните`,
"label.recordtype.edit.description":`Выберите значение из "Available Values", затем добавьте его в "Selected Values" и сделайте его значением пикилиста для данного типа записи. Обратите внимание, что удаление значения из списка не удаляет это значение ни из одной существующей записи. Наконец, выберите значение по умолчанию для типа записи.`,
"label.customer.tab.new":`Новая вкладка клиента`,
"label.sameas":`Как и`,
"front-filter-module-v1-filter-a-week-ago":`Неделю назад`,
"label.processsetting.disable.process.failed":`Не удалось отключить процесс!`,
"label.summaryreport.2018.step4":`Шаг 4 Выберите критерии отчета`,
"label.secrecyinfo":`Конфиденциальная информация, не распространяйте`,
"label.custom.page.component.general.settings":`Общие настройки компонентов`,
"label.ccpeak.folder":`Нефилированные папки класса`,
"vue_label_homepage_select_button_operation":`Кнопка выбора`,
"message.pleaseinputrightdistance":`Пожалуйста, введите правильный интервал дней`,
"label.mobile.phone.required.short":`требуется`,
"vue_label_account_equityseructure":`Структура собственности`,
"label.file.library.error1":`Этот файл уже находится в этой библиотеке.`,
"fliter.nextmonth":`Следующий месяц`,
"label.mr.descreption.oneGroupNote2":`набор информации о предприятии, есть`,
"label.allfolderdashboard":`Все папки приборной панели`,
"lable.opppdt.selPdt.bykeywords":`По ключевому слову`,
"setup_layout_label_selectedfield":`Выберите поля`,
"label.file.preview.convert.firstpage.failure":`Ошибка произошла при предварительном просмотре, пожалуйста, нажмите кнопку предварительного просмотра деталей или скачать для просмотра`,
"vue_label_systemSettings_companie":`Создание компании`,
"label.loginhis.recently":`Недавняя история входа`,
"label.permission.visualpagepermission.edit":`Пользовательское назначение страницы`,
"label.ccservice.validate.email":`Формат соответствующего значения {2} поля {1} под API объекта {0} некорректен. Пожалуйста, введите правильный адрес электронной почты!`,
"label.sms.companyname.gm":`Настройка SMS-2`,
"lable.opppdt.addpdt.table.discount":`Скидка (% скидка)`,
"Lead.Scoring.Setting.LevelSetting":`Свинцовые настройки популярности`,
"message.duplication.label.duplicationremark":`операция запроса дубликатов данных при создании новых или редактировании записей.`,
"label.file.preview.error":`Произошла ошибка при предварительном просмотре, пожалуйста, скачайте для просмотра`,
"label.imgfield.type.input":`Вставить изображение`,
"label.file.share.email.content1":`Имя файла: #имя файла`,
"vue_label_notice_batchedit_fail":`Обновление данных с id {0} не удается по причине отказа {1}.`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.four":`Четыре`,
"label.view.sortview.printview":`Печать`,
"label.projectManagement.Addposttask":`Добавить постзадачное задание`,
"vue_label_commonobjects_view_fail":`Не установлен вид по умолчанию`,
"label.dayinweek":`недельный`,
"label.layout.notexist":`Макета не существует.`,
"label.brief.total":`Рекорд {всего}`,
"label.dashboardSetup.tz.bb":`Перейти к Отчётам`,
"label_emailtocloudcc_select3":`Пожалуйста, выберите владельца записи`,
"label.input.least.string":`Пожалуйста, введите не менее {0} символов`,
"label.app.step2":`Шаг 2 Введите детали`,
"lable.account.LastWeek":`прошлая неделя`,
"label.notifications":`Уведомления`,
"label.tabpage.viewname":`Название вида`,
"label.knowledge.language.italian":`Итальянский`,
"label.sendmail.step2.introduce":`Пожалуйста, выберите шаблоны электронной почты`,
"label_enable_or_no":`Хочешь включить?`,
"pagecreator_button_save":`Сохранить`,
"template.chart.cplb":`Категория продукта`,
"label.knowledge.publish":`Не может быть опубликован, так как не имеет квалификации.`,
"label.name.required":`Поле имени является обязательным`,
"component.chatter.label.myfans":`Мои последователи`,
"label.rejectoperate":`Действия по отклонению`,
"label.report.action.addtodashboard3":`Выберите Приборную панель`,
"label.icon.101":`Учебник`,
"label.data.exp.su.ok":`Экспорт`,
"label.appupload.component.type.layout":`Макеты страниц`,
"template.chart.yscb":`Бюджетная стоимость`,
"label.tabularreport.selectorder":`Определите вид отображения каждого столбца отчета`,
"email.title.one":`Восстановить пароль`,
"label.case.copy.link":`Копирование вебссылки`,
"label.mr.descreption.oneGroupReData4":`группа, остаётся`,
"label.newprocess5.error.des":`Вы можете вводить только цифры.`,
"label.partnerCloud.loginButton":`Кнопка входа в систему`,
"label.interfaceconstraint.adminonly":`Только администраторы могут использовать этот интерфейс.`,
"label.campaign.channel.input.date":`2.Пожалуйста, установите периорд действия для вашего канала сбыта:`,
"label.clientwebsiteentranceprofile":`Профиль портала клиента`,
"UG.opportunity.011":`импортная сделка`,
"label.page.copy.value.paste.template":`Скопируйте и вставьте значение поля слияния в ваш шаблон ниже.`,
"label.notselect":`Нет Выбор`,
"label.weixin.input.password":`Пожалуйста, введите ваш пароль.`,
"label.email.select.template":`Выберите шаблон`,
"label_chatter_ok":`Подтвердить`,
"permissionService.error":`Назначение набора разрешений не удалось, пожалуйста, проверьте, не истек ли срок действия лицензии приложения или не достигло ли назначение верхнего предела.`,
"label.webtocloudcc.sorry":`К сожалению, ошибка на странице, попробуйте еще раз или свяжитесь с вашим администратором.`,
"UG.opportunity.007":`Контактная роль`,
"label.manageAll.forapproval":`Пункты для утверждения`,
"label.imgfield.type.ref":`Формула изображения`,
"label.profile.setcustomtab":`Настройки пользовательской вкладки`,
"label.tabpage.datatyoez":`Тип данных`,
"label.partnerCloud.basicSetting.editPersonal":`Предоставление пользователям партнерского облака возможности редактировать личную информацию`,
"label.mr.caption.account":`Поиск дубликатов и слияние: Кодировки для запроса дубликатов учетных записей`,
"message.serviceterritoryMe.time.violation":`Нарушение времени отправки: период отправки не входит в диапазон времени региональных членов.`,
"pagecreator_page_message_publish_success":`Страница успешно опубликована`,
"label.field.formula.timezonetip":`Обратите внимание на поддержку множественных часовых поясов для работы с функциями типа дата/время. При использовании системной функции, такой как sysdate в формуле для получения текущего времени, она должна быть заменена на свою соответствующую функцию множественных часовых поясов, такую как current_date.`,
"label.marketseamemset.specialuser":`Специальный член`,
"label.staticresource.message":`Детали статических ресурсов`,
"label.workflow.rulecondition":`Критерии правила`,
"component_salesperformance_label_nodata":`Добавьте свою бизнес-возможность и вернитесь сюда, чтобы просмотреть график производительности.`,
"label.customfields.textarea.tip":`Позволяет пользователям вводить несколько строк текста, до 4000 символов.`,
"font-evaluate-module-v1-template":`Пользовательский шаблон`,
"label.step3.total5":`Шаг 3 из 5`,
"label.customfields.formula.percent.tip":`Вычислите процент и автоматически добавьте знак процента к числу.`,
"label.sortdesc":`Отправить`,
"lable.PowerProcess.edit":`Редактирование процесса получения прав`,
"label.dongshifang.description":`Настройте информацию Донгшифанга для удовлетворения потребностей вашей организации в услугах по отправке и получению SMS-сообщений.`,
"label.chatter.addressee":`Получатель`,
"vue_label_systemSettings_obj2":`Консоль управления объектами`,
"label.selectreporttype.tip":`Выберите тип данных, который вы хотите включить в этот отчет.`,
"label.version.enterprise":`Корпоративная версия`,
"label.area.add":`Добавить территорию`,
"label.h5.bookmarked":`Закладки`,
"label.step5.total7":`Шаг 5 из 7`,
"front-lightning-module-v1-title-quotation":`Предварительный просмотр Цитата`,
"label.search.onlymyrecords":`Ограничение на предметы, которыми я владею`,
"vue_label_commonobjects_noduplication":`Дубликат {字段} в {记录}`,
"label.customerpage.edit":`Редактирование вкладок на пользовательских страницах`,
"message.please.choose.user":`Пожалуйста, выберите пользователя`,
"label.approval.his.currentactor":`Текущий утверждающий`,
"label.field.duplicate.error.msg3":`Не более 3-х уникальных полей недвижимости.`,
"label.page_url":`URL страницы`,
"label.permission.goback":`Вернуться к наборам разрешений`,
"vue_label_commonobjects_view_kanban_notice2":`Для просмотра всех записей используйте просмотр списка или разделенного экрана.`,
"label.group.no.recent.searchs":`Совпадений между недавно просмотренными группами нет.`,
"label.event.fiducial.point":`точный`,
"label.integrations.mailchimp.addtolist":`Добавьте выбранные ссылки и контакты из вашего аккаунта CloudCC в ваш список Mailchimp.`,
"label.workflow.configrule.introduce":`Введите имя, описание и критерии для запуска вашего правила документооборота. На следующем этапе ассоциировать действия в рамках процесса с этим правилом.`,
"label.icon.161":`Чемодан`,
"label.recordtype.enable":`Активный сайт`,
"label_mailboxes_limit":`Количество почтовых ящиков превышает лимит.`,
"label.notification.time3":`{0} часов назад`,
"label.setsharerule.step2":`Шаг 2 Выберите записи для совместного использования`,
"vue_label_homepage_somecomponents":`Внимание! После добавления компонента высота превышает предельное значение, что приводит к неполному отображению. Пожалуйста, удалите некоторые компоненты`,
"label.icon.63":`Подземный колодец`,
"label.use.standard.sharerules":`Используйте стандартные правила долевого участия`,
"label.button.step2.select.required.field":`Шаг 2 Выберите необходимые поля`,
"lable.Confirm.collect.potential.customers":`Подтвердите получение лида {имя}`,
"label.version.sum.custompage":`пользовательские страницы`,
"label.file.ccchat.changefile":`Файл изменений`,
"label.mobile.phone.phone.call":`Звоните на .`,
"label.appupload.managed.img":`Контролируемый`,
"vue_label_chatter_comment":`комментарий`,
"label.central.european.time":`Центральноевропейское время`,
"label.three.quarter":`Третий квартал`,
"label.service.newBuildDialog.filter.editor":`Редактор фильтров`,
"pagecreator_systemstyle_funcpath":`/ строитель / библиотека фирменного стиля`,
"label_chatter_collect":`Закладка`,
"label.custom.page.component.window.settings":`Настройки окна компонентов`,
"component_chatter_file_label_title":`Загрузка файлов`,
"label.marketsea.button.discard":`Бросить`,
"label.Batch.input":`Пакетный ввод`,
"vue_label_campaign_market_members":`Существующие участники рынка`,
"label.salescloud.salesdashboard":`Приборные панели продаж`,
"message.summaryconditionrepeated":`Извините, дубликаты кратких условий, пожалуйста, переselect!`,
"label.tianyancha.h5.companycode":`Код компании`,
"label.quickbooks.description":`Следите за вашими счетами в QuickBooks Online, платежами и оценками.`,
"label.colombia.time":`Колумбия Время`,
"label.usermanage.unknown.license":`Недействительная лицензия, и вы не можете создавать новых пользователей, пожалуйста, свяжитесь с вашим администратором.`,
"label.operatedata.selectoperateandobject":`Выберите режим работы (Импорт или Экспорт) и объекты`,
"message.setup.field.picklist.valuerepeated":`Значения списка не могут быть повторены, пожалуйста, введите заново.`,
"label.editerror.list":`Список данных не редактировался.`,
"pagecreator_page_message_save_success":`Страница сохранена успешно`,
"label.icon.154":`Компьютер`,
"label.emailsync.setting":`Персональные настройки электронной почты`,
"label.startuploadfile.step2":`Шаг 3 Нажмите кнопку "начать загрузку", чтобы загрузить файлы.`,
"label.dashboard.notmeet.conditions":`Информация о совпадении не найдена и приборная панель не сконфигурирована.`,
"label.temp.del.conf":`Вы уверены, что хотите удалить?`,
"label.sms.authkey":`Аутентификация Пароль`,
"lable.oppt.jieduan.choosejieduan":`Выберите закрытую сцену`,
"label.tabpage.viewNamez":`Пожалуйста, введите название вида`,
"label.totalQuotation":`Итого по котировке`,
"label.tabpage.hoursagoz":`Часы`,
"label.receiveadminnews":`Получить новости от администратора`,
"label.field.is.lookup":`Приравнено ли поле к поисковому полю?`,
"label.any_changes":`Любые изменения, сделанные здесь, также обновят ваш нижний колонтитул в`,
"lable.products.to.assets":`Подтвердить перевод товара в актив?`,
"label.dashboard.compare":`Сравнение`,
"vue_label_chatter_notice1":`После удаления группы вся информация в группе будет удалена, но файлы группы не будут удалены`,
"label_tabpage_exitz":`Выход из системы`,
"label.potentialcustomerflow":`Свинцовые процессы`,
"label.longtext":`Текстовая область (длинная)`,
"october":`октябрь`,
"label.customer.email":`Email`,
"label.partnerCloud.productSet.addChildren":`Добавить подуровень`,
"label.defaultline.cannot.greater":`Количество строк по умолчанию не должно превышать 30.`,
"front-detail-module-v1-view-report":`Посмотреть отчет`,
"label.knowledge.setting.hint.sixteen":`Сохраняйте знания и продолжайте передавать их`,
"label.page.use.merged.field":`С полем слияния`,
"label.salescloud.salescloud.continuerecover":`если продолжить, то удаление будет сделано и будет обнаружено.`,
"front-project-module-v1-from-template-create":`Создать из шаблона`,
"label.exportall":`Экспорт всех записей всех объектов`,
"label.weixin.recalculate.shared.results":`Пересчитать результаты правила обмена`,
"label.components.isTemplate":`Шаблонные данные`,
"label_emailsync_status":`Статус электронной почты пользователя`,
"label.file.library.delete":`Вы уверены, что хотите удалить {librayrname}？.`,
"label.integrations.username":`Имя пользователя`,
"front-lightningset-module-v1-detail-page-report-chart":`Графики отчетов на подробной странице`,
"label_tabular":`Макет списка`,
"label.approverecords":`Утвердить`,
"vue_label_helpcenter_topic":`Молниеносная версия Использовать и Помощь`,
"label.h5.date.none":`None`,
"lable.outlook.mcto.allrecord":`Все рекорды`,
"label.readandwrite":`Чтение/Письмо`,
"label.allfold":`Свернуть все`,
"AD":`Адрес`,
"message.custom.field.donotdelete.reporttype":`Ссылка на поле дается по источнику данных отчета`,
"label.escalation.setup.newaction.title":`Эскалационное действие Редактирование`,
"label.dashboard.snapshot.settings":`Настройки снимков приборной панели`,
"label.attendance.inner":`офисный работник`,
"chatter.ns":`Новое сообщение`,
"label.validate.nowork":`Ошибка: неправильное поле, пожалуйста, повторно выберите местоположение сообщения об ошибке.`,
"label.custom.EmptyCanvas":`Прозрачный холст`,
"label.service.miniProgram.fillImageOrder":`Пожалуйста, введите порядок карусели.`,
"label.icon.16":`Сервис`,
"label.selected":`Избранный`,
"component_chatter_link_label_name":`Имя ссылки`,
"label.reportsSubscriptionPage.schedulereport.starttime":`Предпочитаемое время начала`,
"label.file.uploadNewVersion":`Загрузить новую версию`,
"chatter.group.theMembership":`Членство`,
"label.knowledge.recommended.articles":`Предлагаемые статьи`,
"label.appupload.install.parentobj":`Родительский объект`,
"label.file.recent":`Недавний`,
"vue_label_helpcenter_quote":`Предложение представляет собой предлагаемую цену на продукцию и услуги Вашей компании. В правом верхнем углу подробной информации Вы можете создать предложение из возможностей и их продукции.<br>, с помощью кнопки можно синхронизировать предложение из бизнес-возможности или синхронизировать предложение с бизнес-возможностью. Когда котировка синхронизирована с возможностью, любые изменения в строке котировки будут синхронизированы с продуктом сделки, и наоборот. Каждая бизнес-возможность может иметь несколько ассоциированных ценовых предложений, любое из которых может быть синхронизировано с бизнес-возможностью.<br>?В правом верхнем углу подробной информации Вы можете сгенерировать pdf и просмотреть предложение, а также можете напрямую распечатать, скачать или сохранить.`,
"message.error.field.default":`Значение по умолчанию должно быть положительным целым числом.`,
"label.campaignmember.main.importmember.contacts.desc":`Импорт контактов кампании из файлов.`,
"vue_label_calendar_show_only_this_calendar":`Показать только этот календарь`,
"vue_label_quot_syncfrom":`Синхронизация из бизнес-возможностей`,
"label.data.expnode.e_desc2":`2. Export по шаблону: пользователи могут выбрать шаблон для экспорта данных.`,
"label.login.verification.mfa.desc1":`Вы должны установить MFA-приложение на смарт-устройство, чтобы продолжить.общие приложения, которые поддерживают MFA на смарт-устройствах: Лук, Google Authenticator.`,
"label.jiandangfenpei.desc":`Назначить доступ текущей пользовательской страницы к профилю. Администраторы имеют доступ ко всем пользовательским страницам.`,
"label_tabpage_thisrecord":`Эта запись`,
"lable.SalesCommitmentKanBan.totalPaymentAmount":`Квитанции о роллове Сумма`,
"message.error.object.notvalidcurrency":`Недействительная валюта`,
"label.edit.discount":`Редактировать скидку`,
"label.setup.mobile.offlinecache.setenable":`Включение функции мобильной стороны в автономном режиме`,
"UG.ST.005":`Я понял, не показывай мне эту страницу снова и в следующий раз войди прямо в систему.`,
"label.assignedapprover":`Назначенный уполномоченный представитель`,
"template.chart.htlx":`Статистика по типу контракта`,
"scope":`В рамках сферы действия`,
"label.workmate.search":`Поиск коллег`,
"message.validation.isnotdigits":`Пожалуйста, введите недействительный номер`,
"label.ccpeak.use.class.time.page":`Если класс вызывается пользовательской страницей, вызовите метод invoker() в классе PageClsInvoker.`,
"setup_mainpage_label_welcome27":`Облачная платформа CloudCC предоставляет такие функции, как импорт, экспорт, пакетное удаление и пакетная передача всех данных об объектах в системе.`,
"front-epwechat-module-v1-epwechat-integrate":`Интеграция WeCom`,
"label.file.publiclink":`Общественная связь`,
"front-epwechat-module-v1-input-name":`Пожалуйста, введите название предприятия`,
"lable.Number.of.columns":`Колонки`,
"message.error.dev.service.duplicateparameter":`Сервисные параметры дублируются.`,
"label.projectManagement.percent.complete":`Процент выполнения`,
"label.chatter.nextSevenday":`Следующие 7 дней`,
"chatter.feed.myfollowers":`Мои последователи`,
"label.bacchtransfer.pleaseselecttouser":`Перевести в`,
"label_partner_workspace_member_memo":`Все пользователи с выбранным профилем и набором прав доступа могут получить доступ к облаку партнера.`,
"label.marketsea.chosen.member":`Избранные члены`,
"label.marketsea.assignment.setup":`Настройки распределения`,
"label.myaccount":`Мои счета`,
"label.schedulejob.setup.schedule.executedate":`Исполнять время`,
"label.uploadaccessory":`Загрузка приложений`,
"Homepage.News.004":`Последних новостей нет.`,
"label.marketsea.name":`Имя свинцового пула`,
"label.pending.task":`Открытые задачи`,
"label.report.details":`Подробности`,
"UG.homepage.008":`Понимать текущее состояние бизнеса (брифинги по продажам, лидерские группы, воронки продаж и т.д.), рассматривать бизнес-возможности, которые могут быть проблематичными, прогнозировать будущие показатели, своевременно принимать и назначать важные вопросы, а также принимать обоснованные решения.`,
"label.h5.similar.opportunity.clear.all":`Все чисто`,
"label.tabpage.noz":`Нет`,
"label.report.recent.all.reports":`Все доклады`,
"vue_label_lead_to_score":`Нажмите кнопку Score (Очко), чтобы набрать очки в текущем обзоре.`,
"vue_label_normal_receivable_sf":`Дебиторская задолженность`,
"label.layout.edittabdistribute":`Редактирование макета вкладки`,
"label.validate.function.funcFormat.PRIORVALUE":`ПРИОРВАЛЮ (поле)`,
"label.salescloud.field.editoptionlist":`Редактирование пиклистов`,
"APPIntegration.Dropbox.01":`Выберите файлы из Dropbox`,
"label.campaign.channel.step2":`Шаг 2: Установите значения полей по умолчанию для этого маркетингового канала.`,
"label_partner_new_function":`Описание функции`,
"vue_label_chat_no_search_results":`Нет результатов поиска`,
"vue_label_commonobjects_detail_visitstate":`Штат посещения`,
"label.sendemail.send.testemail":`Это тестовое электронное сообщение, если вы можете получить это сообщение, вы можете использовать этот почтовый ящик для отправки электронной почты.`,
"label.attendance.clear.position":`Ясные ориентиры`,
"chatter.write.n":`Комментарий к этому посту`,
"label_chatter_sendmail":`Отправить электронное сообщение`,
"label.remindertime":`Время напоминания`,
"label.app.elegantgray":`Элегантный серый`,
"label.tabpage.ownedz":`Всего`,
"label.select.approval":`Выберите утверждающее лицо`,
"UG.Lead.007":`синхронизация Google`,
"chatter.emailSetUp":`Настройка моего CCChat-напоминания`,
"label.default.censor":`Экзаменатор по умолчанию`,
"vue_label_notice_uploadavatar_success":`Аватар успешно выложен`,
"label.sms.title":`Информация о SMS-интерфейсе`,
"front-console-choose-contact":`Выберите контакт`,
"label.field.edit.des":`Более высокий балл показывает больше звездных иконок, а максимальный - 100.`,
"label.pw.big.letter":`Прописные`,
"label.select.time.dimension":`Пожалуйста, выберите измерение времени`,
"UG_Campaign_004":`импортная кампания`,
"label.dashboard.summary":`Метрика`,
"label.ems.yahoo":`Яху!`,
"label.leadscore.rule.name":`Имя правила выставления очков`,
"vue_label_calendar_object_name":`Имя объекта`,
"label.icon.69":`Машина`,
"label.reporttotal":`Итоговый показатель`,
"lable.SalesCommitmentKanBan.theActualContract":`Фактическая сумма контракта`,
"label.project.member.data":`Этот пользователь уже является участником текущего проекта!`,
"label.cloudccclass.list.viewremark":`Помощь для этого Страница`,
"label.deleteObject.isNotAdministrator":`Вы не являетесь администратором и не можете удалять объекты.`,
"lable.edit.queue.nameandemail":`Имя очереди и адрес электронной почты`,
"label.recordtype.tabname":`Типы записей`,
"label.file.is.ok":`Ничего страшного`,
"label.knowledge.language.german":`Немецкий`,
"label.layout.realityapprover":`Фактический утверждающий`,
"label.ems.with7day":`В течение 7 дней`,
"label.autoRegister.changepwd.setpwd.setpwd.button":`Установить`,
"label.weixin.edit.polls":`Голосование за изменение`,
"label.layout.mobile.default.tab":`Выберите вкладку по умолчанию в Мобильном приложении`,
"vue_label_report_deletegroupcolumn":`Удалить колонку группы`,
"label.group.archived.success":`Архив успешно архивирует`,
"label.customfields.formula.returntype":`Тип возврата формулы`,
"label.file.followers":`Писатели`,
"label.textmessage.new.templates.message1":`Имя шаблона не может быть empty！.`,
"label.selected.field.length":`Не более 10 выбранных заявок`,
"ObjectDetailed_ViewKeyInformation_Layout":`Редактирование ключевой информации`,
"label.paging.totalofpage":`Всего {0} страниц`,
"label.ccchat.message.new.error41":`Чтобы поговорить с большим количеством людей, попробуйте использовать группы`,
"message.recordtype.detail.noselectlist":`Не может быть отображен ни один из списков`,
"label.conditiontag.lookup.title":`Выберите значения пробельных списков ниже для добавления.`,
"label_partner_setup":`Настройки облака партнера`,
"front-epwechat-module-v1-android-packname":`Имя пакета Android:`,
"lable.custom.Current.CY":`Текущий CY`,
"label.newprocess2.desc":`Если скидка больше 0,3%, то она оценивается как истинная.`,
"label.operatedata.selectobjectfields":`Выберите поля экспортируемого объекта`,
"report_reportdatasource_label":`Источник данных отчёта`,
"label.chosesubject.others":`Прочая деятельность`,
"label.list.desc2":`Вы можете создать страницу на ПК для доступа со стороны ПК или мобильную страницу для доступа к мобильному устройству.`,
"vue_group_several_groups":`{totalSize} группы`,
"label.page.button.linkurl":`URL-адрес кнопки или ссылки`,
"show.week":`Показать выходные`,
"label.gotocalendar.new":`Перейти к календарю и создавать события`,
"button.reset.advancedsearch":`Очистить условия расширенного поиска`,
"label.h5.chatter.feedandcomnum":`Отправить и оставить сообщение`,
"lable.opppdt.addpdt.table.unitprice":`Продажная цена`,
"label.dataimport.validate":`Выберите проверку, которую необходимо выполнить`,
"label.lead.score":`Лидерский очко`,
"vue_label_help_product":`Брошюра о продукции и ценах`,
"label.role.select":`Выбор ролей`,
"lable.opppdt.selPdt.searchproduct":`Поиск продуктов`,
"component_event_label_newevent":`Новые события`,
"front-invoice-online-payment-setup-configure-button":`Настроить сейчас`,
"label.stdashbord.xsld.business.img2":`Общая сумма условно-патогенной стадии с вероятностью 1-99%`,
"label.event.moveup.2week":`2 недели вперёд`,
"label.partnerCloud.priceOfManual.allCustomer":`Все счета`,
"lable.account.dep":`Нажмите кнопку Новый, чтобы определить новый финансовый год.`,
"label.dataimport.insertdata.error.null.update":`Значение $schemefield_name$ в этой записи является нулевым и не может быть обновлено. Запись проигнорировала import`,
"label_component_helper_businesschange_0activity":`30 дней без активности`,
"lable.account.NextbbDays":`Следующие 60 дней`,
"label_scope_length":`Длина диапазона`,
"label.customfields.operation":`экспортировать данные`,
"serviceappointment.save.workorder":`Пожалуйста, выберите заказ на работу, связанный с пунктом строки заказа на работу.`,
"label.field.update.hide.editor":`Скрыть редактор формулы`,
"button.partner.new":`Новое облако партнёра`,
"label.stdashbord.xsld.business.oppdetails":`Поддержка Подробности`,
"message.pleasewaitingnextversion":`Эта функция будет доступна в следующем выпуске.`,
"label_tabpage_potentialcustomersz":`Свидетельства`,
"label_emailtocloudcc_step2":`Шаг 2`,
"label.weixin.username":`Имя`,
"label.quickbooks.viewlist.type":`ТИП`,
"front-kefu-moudle-v1-Select-seats":`Выберите агента`,
"label.customsetting.manage":`Управление`,
"label.tabpage.field":`Поле`,
"label.custom.page.button.icon.URL":`URL-адрес иконки кнопки`,
"font-evaluate-module-v1-evaluation-link":`Добавьте ссылку на оценку:`,
"vue_label_salesfunnel_notice3":`Количество возможностей для бизнеса с вероятностью 1% - 99%`,
"front-email-payment-describe":`Благодарим вас за поддержку нашего бизнеса. Вы можете произвести оплату онлайн по следующей ссылке, а также просмотреть, распечатать и загрузить счета в формате PDF.`,
"label.productsales.today.noevttskaddevt":`Нет открытых событий и заканчивающихся заданий, можно нажать кнопку "Добавить" в правом верхнем углу, чтобы добавить новое событие.`,
"component.setup.iframe.label.memo":`Щелкните по значку настройки и введите адрес встроенного url-адреса.`,
"front-email-payment-select-country":`Пожалуйста, введите страну`,
"label.ems.starred":`Звёздные письма`,
"component_setup_label_object":`Объекты`,
"label.query.detail.viewpartneruser":`Просмотр пользователей-партнеров`,
"this.year":`этот год`,
"serviceresource.isactive.notactive":`Эта служба redources не включена.`,
"label.marketing.message.recipientisnull":`Получатель не может быть пустым`,
"label.unfold":`Развернуть`,
"label.service.assetBOM.view.tip":`У вас нет прав на просмотр спецификации активов. Пожалуйста, свяжитесь с администратором.`,
"label.validate.function.funcExplain.ISCHANGED":`Проверьте, что значение поля отличается от предыдущего. Если нет, верните TRUE, в противном случае верните FALSE.`,
"label.validate.function.funcExplain.NOW":`Возвращает набор данных и ime, представляющий текущий момент.`,
"label.phoenix.islands.time":`Феникс. Время`,
"vue_label_checkduplicate_complete_filter_rules":`Пожалуйста, заполните условия фильтра`,
"vue_label_report_rowcount":`Количество рядов`,
"chatter.p":`человек`,
"label.umeng.activity.distributetask":`назначил тебе задание.`,
"UG_quota_05":`Бисинк с возможностями`,
"june":`июнь`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.tuesday":`вторник`,
"vue_label_commonobjects_view_chart_upto5":`До 5 групп`,
"vue_label_opportunity_contactrole_searchallcontacts":`Искать во всех контактах`,
"label.custom.field.task.notice":`Уведомление о задаче`,
"label.weixin.insert.address":`Вставить Местоположение`,
"label.attachementNew.desc":`Архивируйте вложение к документу, и вложение не может быть удалено.`,
"setup_mainpage_label_welcome18":`Настройки прав доступа корпоративного уровня CloudCC позволяют контролировать права использования отдельных пользователей при работе с данными и модулями. Настройки прав доступа на основе ролей также включают в себя пользовательские позиции, группы, роли, правила совместного использования данных, а также контроль безопасности на полевом уровне для обеспечения совместного использования данных между различными сотрудниками и отделами предприятия.`,
"front-kefu-instance-noarea":`Для этой области не был создан экземпляр, пожалуйста, выберите его заново`,
"label.please.ChooseMax":`Пожалуйста, выберите до {a} вариантов товара.`,
"label.businesschance":`Возможности`,
"label.verticalline-group":`Вертикальные колонны-группировка колонн`,
"label.ordering.platform":``,
"label.product.pricebooks.ples":`Пожалуйста, выберите "Ценовая книга`,
"vue_label_norm_addcomponent":`Новый компонент`,
"label.ServiceCloud.Installation.address":`Адрес установки`,
"vue_label_report_groupcolumn":`Групповая колонка`,
"label.ccchat.person.invite.notallsucc":`{0} адреса электронной почты были сохранены, но не отправлены. чтобы отправить приглашение, исправьте следующую ошибку и нажмите кнопку отправить.`,
"label.customfields.optionlist.tip":`Позволяет пользователям выбирать значение из списка, который вы определяете.`,
"UG.activity.07":`Создать задачу`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.last":`Последний`,
"label.permission.accessname":`Имя доступа`,
"lable.custom.year.stadate":`Индивидуальная дата начала года`,
"label.ems.inputmails":`Получить почтовый сервер (i)`,
"label.cpq.quote.transfer.order.already":`Это предложение переносится в заказ. Пожалуйста, удалите исходный заказ, а затем создайте заказ заново.`,
"label.sendletter.status":`Статус участника кампании`,
"vue_label_commonobjects_view_save_as_view":`Сохранить как вид`,
"message.mobilechooseatmostfive":`Выберите до 5 полей`,
"label.errormessage.batchedit.nopermission":`Нет записи данных, на редактирование которой у вас есть разрешение.`,
"label.dataoperate.tip":`Выберите операцию и объекты.`,
"label.enableoperate":`Доступные действия`,
"label.ems.usernamepassword.error":`Ошибка учетной записи почтового ящика или пароля.`,
"label.campaignmember.selectmember.deletemember":`Удалить членов из`,
"label.Tab":`Вкладки`,
"label.emailobject.template.message1":`Пожалуйста, выберите поле и нажмите "Вставить". Для просмотра более доступных полей нажмите на ">".`,
"label.approvalstep3.tip":`Укажите пользователя, который должен утвердить записи, вводимые на этом этапе. В качестве опции выберите, может ли делегат утверждающего лица также утверждать эти заявки.`,
"label.inusing":`Активный сайт`,
"label.edit.select.tre":`Флажок "Список`,
"label.appointmentconfirmail.wizard.title1":`Здравствуйте {0}`,
"label.partnerCloud.financeSetting.setAlipay":`Настройка Alipay`,
"lable.edit.queue.avobj":`Доступные объекты`,
"vue_label_checkduplicate_verify_all_characters":`Проверить все символы`,
"label.huntingzone":`Диапазон поиска`,
"label.request.approved":`Запрос был одобрен, не повторяйте.`,
"label.sharerule.msgerror":`Внутренняя ошибка сервера`,
"front-epwechat-module-v1-tick-unbound":`Пожалуйста, отметьте галочкой согласие и принятие вышеуказанной необязательной информации`,
"label.console.step6":`Шаг 6 Выбор способа отображения списков`,
"label.multilang.micropost.vote":`{0} билет(ы)`,
"message.error.appid.null":`Секретный ключ не может быть нулевым!`,
"lable.product.delq":`Удалить вопросы`,
"label.h5.approval.leixing":`Тип утверждения`,
"label.edit.field.select.style1":`Плитка каждый вариант`,
"label.passwordPolicy.setup.alpandnum":`Должны смешивать альфа-символы и цифровые символы`,
"label.ems.close2":`Закрыть`,
"label.report.reporttypetitle":`Источник данных`,
"label.umeng.approval.approvalsuccess":`был представлен на утверждение.`,
"label.page.showamount":`Общее количество записей на page:`,
"label.copy.asset.successfully":`Успешное копирование спецификации активов.`,
"vue_label_homepage_bigscreen_dark":`Темный`,
"vue_label_email_selected_members":`Избранные члены`,
"label.file.preview":`Предварительный просмотр`,
"label.partner.new.step3.name":`Имя`,
"label.forecast.settings.periods.ago":`предыдущий цикл`,
"label.evaluation.praise":`Хорошо`,
"label.cloudccsite.edit":`Редактирование сайта`,
"label.knowledgebase.advanced.filtering":`Расширенный фильтр`,
"label.knowledgebase.framework":`Рама`,
"vue_label_pool_ownedpool":`Главный бассейн`,
"label.exchange.sync.setting.license":`При включенной функции некоторые данные вашей организации могут быть сохранены на сервере Microsoft Exchange во внутренней установке или в облачной форме и обработаны через сервер Microsoft Exchange.`,
"front-console-conversation-btn2":`Ответ по электронной почте`,
"label.projectManagement.thelastone":`Это последняя запись.`,
"message.duplication.confirmscript.mergeoperation":`Эти записи объединяются в одну запись через выбранные значения. Примечание: действие объединения не может быть отменено. Вы уверены, что хотите объединить записи?`,
"lable.outlook.detail.nosyn":`рассинхронизированно`,
"label.iscopy":`Разрешающая копия`,
"message.matrixReportSetupStage.row":`Пожалуйста, выберите 【Укажите заголовок строки】 промежуточный итог, и вы должны выбрать один промежуточный итог, по крайней мере, в двух промежуточных итогах.`,
"label.forecast.forehistory.possibility":`Вероятность`,
"label.timetrigger.validate":`Вводимое значение должно быть положительным целым числом, и система автоматически выполнит действия процесса, когда будет достигнуто положительное целое число, т.е. время, когда будет достигнута зависимость процесса, система автоматически выполнит операцию процесса.`,
"member.name.choice.field":`Имя участника - обязательное поле!`,
"label.undone_external page":`Это необратимо, поэтому, пожалуйста, подтвердите. Эта форма не используется ни на одной странице входа в систему, но может использоваться в других местах. Например, вы могли использовать код вставки, чтобы вставить ее на внешнюю страницу.`,
"UG_Lead_012":`Импортные ключи`,
"component_chatter_label_fans":`Писатели`,
"label.systeminfo":`Информация о системе`,
"label.mr.descreption.oneGroupNote1":`Пожалуйста, выберите, по крайней мере, две части данных и нажмите [Загрузить выбранную информацию], чтобы перейти на страницу слияния данных.<br>Это то, что`,
"label.wtd.changefields.selfields":`Выберите поля для включения в форму Web-to-CloudCC:`,
"message.error.fileinfoid.null":`Файлинфойд не может быть пустым! Идентификатор файловой информации`,
"label_tabpage_cownerz":`Изменение владельца`,
"setup_layout_button_save":`Сохранить`,
"Dashboard.View.Createdbyme":``,
"label.escalation.setup.detail.order":`Заказать`,
"button.partner.start":`Начать использовать`,
"label.htyj.remark1":`Ваша текущая редакция не поддерживает просмотр объекта договора`,
"component.event.label.person":`Назначенное лицо`,
"label.appointmentconfirmail.wizard.subtitle3":`Местоположение`,
"label.emailtocloudcc.filed.username":`Адрес электронной почты`,
"label.vlidaterule.remark":`Определите правило проверки, указав условие ошибки и соответствующее сообщение об ошибке. Пользователь может исправить ошибку и повторить попытку.`,
"message.duplication.label.insertoption":`Действие по созданию`,
"front-web-module-v1-detail-comment-toast":`Пожалуйста, заполните все оценки`,
"label.import.page2.notsuitedfiledwillbenotimport":`Заметь: Система не будет импортировать нераскрытые поля`,
"label.h5.similar.opportunity.enable":`Включить аналогичные возможности`,
"label.allunfold":`Расширить все`,
"component_setup_iframe_label_inputurl":`Введите URL-адрес`,
"label.manage.all":`Управлять всеми`,
"label.mobile.side.tab.cs":`Общие функции`,
"label.datamanage.contact.information":`Контактные данные`,
"lable.outlook.edit.sel":`Выберите значение`,
"label.imgfield.type.url.tip2":`Например: http://www.cloudcc.com/images/logo.png&cimgSize=50,50`,
"setup.layout.label.areasetup":`Свойства раздела`,
"label.date":`Дата`,
"vue_label_commonobjects_detail_openfilter":`Расширить фильтр`,
"label.loginip.pagecue":`Введите диапазон действительных IP-адресов, с которых пользователи с этим профилем могут входить в систему.`,
"vue_label_email_not_valid":`Введенный вами адрес электронной почты не является действительным электронным адресом.`,
"label.page.step5.add.application":`Шаг 5 Добавить в пользовательские приложения`,
"label.dashboard.donot.delete":`Вы не можете удалить эту папку, потому что некоторые приборные панели в ней.`,
"label.visitAPPexchange":`CloudCC App Store (Новое окно)`,
"label.generate.location":`Сгенерировать данные о широте и долготе заказчика.`,
"lable.quote.syncing.syncingbutton":`Синхронизация`,
"label.pw.error.text":`Два введенных вами пароля не совпадают.`,
"label_partner_setup_Enable":`Проверить`,
"label.file.preview.unav":`Предварительный просмотр недоступен`,
"label.sms.tip":`Из интернета`,
"setup.mainpage.label.welcome21":`Облачная платформа CloudCC предоставляет пользователю функцию шаблона электронной почты, которая удобна для использования и повышения эффективности работы.`,
"label.trigger.for.example":`Например: обновите триггер функции обновления учетной записи, обновите триггер функции обновления учетной записи и триггер функции обновления учетной записи. Если в триггере отсутствует условный контроль, то система допускает до 3 таких круговых вызовов.`,
"setup.layout.button.layoutprop":`Свойства`,
"component.chatter.label.fans":`Писатели`,
"lable.PowerProcess.event.edit":`Редактирование вехи`,
"label.detailintro":`Описание`,
"vue_label_report_nosearchresults":`Нет результатов поиска`,
"error.name.repeat":`Имя не может быть повторено.`,
"label.emailEncoding":`Электронное кодирование`,
"label.partnerCloud.financeSetting.enableAccount":`Активировать счет возврата`,
"label_emailtocloudcc_clear":`Clear`,
"setup_mainpage_label_welcome12":`Пользователь может завершить определение отчета щелчком мыши, без программирования и следуя инструкциям системы. Система имеет список отчетов, сводный отчет и матричный отчет на выбор. Также доступны опции отображения для всех полей. Удалите ненужную информацию о полях. В то же время, она предоставляет различные графические дисплеи, включая полосы, складки линий, кольца, воронки и торты, так что пользователи могут видеть с первого взгляда.`,
"lable.SalesCommitmentKanBan.contractStartDate":`Дата начала договора`,
"front-starter-v1-potential-customer-tips-success":`Успешно активировать пул лидеров`,
"UG_Forcast_02":`Прогнозы представляют собой оценки ожидаемых продаж на определенный период, и модели прогнозирования могут помочь вам определить спрос на продукцию и выручку от продаж в определенный период. Менеджеры могут использовать прогнозы для постановки целей и измерения прогресса команды. Общий прогноз организации может отражать сводку всех продаж по продажам, составленную торговым представителем (независимо от стадии завершения продаж от стадии конвейера до завершенной стадии).`,
"label.escalation.setup.detail.ruleentries":`Записи в правилах`,
"lable.SalesCommitmentKanBan.allComplete":`Итого полная сумма`,
"label.appupload.install.apicanuse":`Имя api доступно`,
"label.organiza.field":`Поля организаций`,
"button.partner.workspace.manage":`Управление`,
"lable.PowerProcess.setevent":`Установление вех`,
"label.emailobject.groupemail.msg2":`Адрес электронной почты отсутствует. Это не позволит отправить электронное сообщение этому рецепту.`,
"label.h5.orderbyname":`Сортировано по имени`,
"vue_label_salesadvance_opportunities":`Номер возможности`,
"label.appointment.disable.cancel":`Отключить отмену`,
"label.trigger.folder.edit":`Страница триггера : Редактировать папку`,
"label.customfields.new.step2.opration.unique.info.v2":`Относитесь к "ABC" и "abc" как к разным значениям (с учетом регистра).`,
"label.icon.40":`Позиционирование`,
"label.eventmenuandlink":`Кнопки событий и ссылки`,
"label.service.gantt.candidate":`Кандидат`,
"label.top.userphoto":`Фото пользователя`,
"label.appointmentconfirmail.wizard.btn2":`Отменить встречу`,
"label.print":`Печать`,
"saveandreturn":`Сохранить и вернуть`,
"lable.account.CurrentandNextCY":`Текущий и следующий CY`,
"label.group.no.recent1":`Вы не просмотрели ни одной активной группы.`,
"lable.Asset.conversion":`Создайте актив в соответствии с "Переходом актива" продукта заказа при передаче активов.`,
"label.emailtocloudcc.button.sure":`Подтвердить`,
"label.Path.List":`Список путей`,
"label.please.rule.name":`Пожалуйста, введите название правил.`,
"label.knowledge.category.hint.six":`Доступная группа категорий`,
"setup_mainpage_label_welcome28":`Инструкции: Щелкните по меню в левой части этой страницы → Управление настройками → Управление данными → Импорт и экспорт данных, Пакетная передача, Пакетное удаление.`,
"vue_label_commonobjects_view_chart_editchart":`Редактировать диаграмму`,
"label.permission.detail.app.object":`Настройка объекта`,
"label.multilang.totalpage":`от`,
"label.marketsea.button.return":`Вернуться`,
"Click.to.load.more":`Нажмите, чтобы загрузить больше`,
"label.validate.globalvariable":`Глобальная переменная`,
"label.marketsea.iseditseabymanager":`Разрешите администраторам изменить свинцовый пул, к которому принадлежит.`,
"label.price.yuan":`Цена (юань)`,
"label.service.resource.uesr.tip":`Выберите пользователя для создания сервисных ресурсов, а тип ресурсов не может быть командным.`,
"vue_label_help_viewusageguide":`Посмотреть руководство пользователя версии Молнии`,
"label.autoRegister.changepwd.setpwd.too.long":`Слишком долго`,
"label.campagin.roi.fwsl":`Количество посещений`,
"label.campaign.mobile":`Мобильное приложение`,
"UG.Lead.012":`Импортные ключи`,
"link.recordtype.detail.backtoobject":`Вернуться к пользовательским объектам`,
"front-kefu-moudle-callcentrt-hasclose":`Информационный центр закрыт`,
"label.category.5":`IT-высокая технология`,
"label.import.page1.selectwayofdealdata":`Выберите режим обработки данных`,
"chatter.emailReceiveEmail":`Получить напоминание о CCChat`,
"vue_label_file_manage_lib_members":`Управлять членами файловой библиотеки`,
"label.appupload.upload.overview":`Рекапитуляция`,
"label.service.miniProgram.inputNumber":`Пожалуйста, введите номер в пределах 0-999.`,
"label.emailtemplate.finishdetailinfo":`Введите данные шаблона Email.`,
"label.weixin.fmu.before.day":`{0}за несколько дней до`,
"label.integrations.login":`Вход`,
"label.dashboard.setUpHomePage":`Домашняя страница настроена на отображение`,
"label_partner_common_webSit":`Домен`,
"front-epwechat-module-v1-unbound-user":`Непривязанные пользователи`,
"label.partnerCloud.basicSetting.offline":`Активировать автономную оплату`,
"label.start.loginip":`Стартовый IP-адрес`,
"label.projectManagement.delete.subtasks":`Вся связанная информация этой подзадачи также будет удалена, если вы удалите эту подзадачу, и данные не смогут быть восстановлены. Вы уверены, что хотите подтвердить удаление?`,
"label.message.batchapp":`Массовое одобрение`,
"message.duplication.label.ruletitle":`Дублировать правила`,
"label.all_networks":`Вся сеть`,
"label.select_columns":`Выберите столбцы, которые вы хотите видеть для представленных форм`,
"vue_label_notice_uploadavatar_exceed":`Размер загружаемого изображения аватара не может превышать 2 Мб.`,
"message.error.get.failed":`Не удалось получить информацию!`,
"label.quickbooks.viewlist.duedate":`ДАТА ГОТОВ`,
"label.ccchat.topic.search":`Тема поиска`,
"label.forecast.shre.manager":`Назначение менеджера`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.thursday":`четверг`,
"lable.product.pricebooks.copy":`Клон из существующей ценовой книги`,
"label.instrumentPanel.minLabelname":`Это значение должно быть положительным и меньше значения точки останова 1.`,
"front-market-form-createdsecond":`Автозаполнение поля на странице регистрации`,
"label.submission_detail":`Детализация представления`,
"label.customfields.checkbox.tip":`Позволяет пользователям выбирать Истинное (отмеченное) или Ложное (не отмеченное) значение.`,
"label.escalation.setup.list.description":`Вы можете автоматически определять действия, когда случаи отвечают критериям и выходят за рамки заданного времени. При эскалации дела можно выбрать автоматическое уведомление пользователя и переназначение дела новому пользователю.`,
"UG.Forcast.05":`Настройки прогноза: шаг {0}/{1}`,
"label.data.import":`Импорт данных`,
"label.upload.error.cause":`загрузка не удалась из-за`,
"label.search.change.remark":`Применяется к настройкам объектов, отображаемым в строке поиска в левой части главной страницы.`,
"serviceappointment.edit.status.limitwithstatus":`Статус назначения обслуживания не может быть изменен с {0} на {1}`,
"label.department.operation":`Операция`,
"label.textmessage.vonage.message3":`Для поиска API Key и API Secret, вы можете войти в свой аккаунт Vonage API и перейти в "Настройки" под именем аккаунта. Для поиска телефонных номеров, имеющихся у Вас в аккаунте Vonage API, Вы можете перейти в раздел "Номера" в разделе "Продукты" и нажать кнопку "Ваши номера", чтобы увидеть все телефонные номера, которые у Вас есть.`,
"label.privacystatement.dialog":`Положение о конфиденциальности (Новое окно)`,
"label.datamanage.import.leadfield":`В следующем списке выберите поля в файле импорта, в которые следует импортировать провода. Затем нажмите кнопку Далее:`,
"label.appupload.upload.install.failar":`Установить Failed`,
"label.viewall":`Посмотреть все`,
"label.sendemail.chat.addComentsfavoritesubject":`CloudCC CCChat ответ на Закладку`,
"lable.custom.dp":`На этой странице можно определить пользовательские годы.`,
"label.mobile.more.share":`Поделиться с коллегами или группами`,
"lable.name.cannot.be.empty":`Имя не может быть пустым`,
"label.autoRegister.changepwd.setpwd.password":`Ваш пароль`,
"label.multipleactivity.aevents":`Событие(и)`,
"label.many.dayline.lastday":`прошлый день`,
"lable.Please.bind.the.QuickBooks.record.first":`Пожалуйста, сначала свяжите записи в книге быстрого доступа.`,
"vue_no_related_dashboards":`Нет соответствующих приборных панелей!`,
"label.newdashboardpage.name":`Имя`,
"vue_label_commonobjects_detail_network":`Реляционная сеть`,
"label.tianyancha.reginstitute":`Регистрационный орган`,
"label.the.lower.bound.of.each.level.must.be.equal.to.the.upper.bound.of.the.upper.level.":`Нижняя граница каждого уровня должна быть равна верхней границе верхнего уровня при ценообразовании по блокам.`,
"label.chat.file.upload.info":`Загрузить файлы`,
"label.appexchange.vlidaterule":`Правила проверки`,
"label.salescloud.salesdashboard.current.business":`Текущая возможность`,
"label.app.step4.homeisfrist":`Главная страница должна быть первой вкладкой и не может быть удалена.`,
"label.weixin.micro.research.optionname":`Название выбора микропросмотра`,
"label.paging.totalofnbsp":`Всего {0}`,
"label.opportunity.perm.title":`Запрос доступа`,
"front-kefu-moudle-v1-zhyzcw-reinput":`Ошибка проверки арендатора. Пожалуйста, введите заново`,
"label.unsaved_changes":`Если вы продолжите операцию, несохраненные изменения будут потеряны.`,
"label_partner_all_description":`Описание`,
"lable.account.Next.CQ":`Следующий звонок`,
"chatter.feed.menutype.feed.me":`Мне`,
"label.sourcetranstemp":`Источник - создает один файл, содержащий весь переводимый текст.`,
"label.apply.newuser.validate":`CloudCC регистрация нового пользователя, код подтверждения:`,
"label.user.password.error":`Ошибка имени пользователя или пароля, или недействительный пользователь!`,
"label.there.is.no.quotation.line.item.in.this.quotation.line.group.at.present.":`В этой группе котировочных линий не найдено ни одной котировочной линии. Пожалуйста, нажмите "Добавить продукт", чтобы добавить.`,
"lable.PowerProcess.time.filed":`На основании поля даты и времени в {detailInterestType}`,
"label.file.default.value.is.integer":`Вводить можно только целые числа`,
"label.processsetting.please.select.field":`Пожалуйста, выберите поля.`,
"label.app.step3.introduce":`Размер файла пользовательского логотипа приложения должен быть меньше 20 КБ. Размеры изображения должны быть не более 300 пикселей в ширину и 55 пикселей в высоту для достижения наилучших результатов. Более крупные изображения будут изменены в размерах и могут выглядеть искаженными.`,
"button_partner_save":`Сохранить`,
"label.marketingmanagement":`Маркетинг`,
"label.isEnableVisualpage_new.leftlist":`Доступные пользовательские страницы`,
"label.salescloud.teamrole.optionlist.choose.correct":`Тот же пункт существует в списке, пожалуйста, измените.`,
"System_ChangeUser_Info_001":`Владелец изменился и нажмите, чтобы вернуться на предыдущую страницу.`,
"front-console-no-contact":`Нет контакта`,
"component.assistant.label.overduetask":`Возможности с просроченными заданиями`,
"label.roleofpartner":`Роль партнера`,
"label.appointmentconfirmpage.wizard.subtitle4-1":`Ты и {0}`,
"front-template-V1-Please-select-a-picture":`Пожалуйста, выберите изображение`,
"lable.SalesCommitmentKanBan.allsignedCommitmentRate":`Общая сумма подписанных обязательств`,
"label.h5.similar.opportunity.step2.conment":`Выберите от 3 до 10 полей или соответствующие списки для сравнения при поиске похожих возможностей.`,
"label.projectManagement.alert.frequency.will.not.work":`Если выбрать Нет, напоминание не будет работать.`,
"vue_label_fllscreen":`Полноэкранный просмотр`,
"label.customfields.selectcontainfieldlayout":`Выберите макеты страниц, которые должны включать это поле.`,
"label.appointment.wizard.subtitle1-4":`45 мин`,
"label.tianyancha.businessverify.unagree":`Не согласен`,
"label.unique":`Уникальный сайт`,
"setup_mainpage_label_welcome10":`Инструкции: Щелкните по меню в левой части страницы → Настройки приложения → Создать → Объект → Название объекта → Пользовательский макет.`,
"vue_label_account_subsidiary":`Дочерняя организация`,
"label.dataimport.format.error":`Ошибка формата, пожалуйста, используйте формат MM/DD/YYYY или YYYY-MM-DD.`,
"label.email.new":`Новый электронный адрес`,
"label.log.descri":`Описание работы`,
"vue_label_dashboard_componentname":`Пожалуйста, введите название компонента`,
"label.weixin.quick.reply":`Быстрый ответ`,
"label.productsales.payment.badversion":`Ваша текущая редакция не поддерживает просмотр объекта договора, поэтому вы не можете просмотреть список платежей.`,
"label.position":`Местоположение`,
"label.Annex.Conditions":`Добавьте логические фильтры для дополнительных условий （э.д.：1 И 2 Или 3 ）.`,
"label_tabpage_endz":`Конец`,
"label.setup.mobile.bottombutton.prompt":`Заметь: Для сохранения этих настроек будут изменены исходные настройки пользователя первого уровня мобильного приложения.`,
"lable.Edit.template":`Редактирование шаблона отчета об обслуживании`,
"vue_label_report_onlydisplay2000":`Отображать только 2000 данных`,
"label.salescloud.salesdashboard.sign.account.top5":`Топ 5 подписанных счетов`,
"label.weixin.ontime":`Пунктуальный`,
"font-evaluate-module-v1-disappoint":`Жаль вас разочаровывать!`,
"chatter.sel.addre":`Можно выбрать до 5 получателей!`,
"label.mobile.phone.month.summary":`Ежемесячное резюме`,
"label.partnerCloud.priceOfManual.selected":`Выбранный счет`,
"label.south.georgia.time":`Стандартное время Южной Георгии`,
"label.create.ccdocument":`Добавить приложение`,
"label.chatter.to":`На`,
"label.ems.minute":`Протокол`,
"label.mobile.phone.submit.tome":`Представлено Мне`,
"label.approvalstep1":`Шаг 1 Введите имя и описание`,
"label.h5.similar.opportunity.last.months9":`Последние 6-9 месяцев`,
"Opportunity_Detailed_Phase_Label_003":`Этап изменения`,
"lable.PowerProcess.time.input":`Пожалуйста, введите время.`,
"label.stdashbord.xsld.business.yqzsr":`Ожидаемая общая сумма`,
"label.icon.64":`Прожектор`,
"label.data.choses.i_desc":`В соответствии с вашими потребностями, импортируйте данные из одного объекта.`,
"label.integrations.mainlandchinaleads":`Материковый Китай Лидирует`,
"vue_label_notice_savemenu_success":`Меню успешно сохранено`,
"front-kefu-moudle-v1-xzhxzxkf-online":`Выберите онлайнсервис Easemob`,
"label_chatter_name":`Имя`,
"label.Viewon_Linkedin":`Взгляд из LinkedIn`,
"lable.PowerProcess.chioce.event":`Пожалуйста, выберите веху.`,
"component.chatter.file.label.maxsize":`Максимальный размер файла 20 м`,
"label.validate.function.funcExplain.SECOND":`Возвращение на второй день (с полей Дата/Время)`,
"label.data.downpage.i.title.num4":`4、Если у вас есть поле просмотра отношений и поле master-etail отношений в объекте, который вы хотите импортировать, значение для этого поля должно быть ID, в противном случае он является недействительным.`,
"label.icon.139":`Валюта`,
"label.app.step4.atleastone":`Хоум-таб не может быть удален.`,
"label.weixin.input.telephone":`Пожалуйста, введите номер мобильного телефона`,
"label.setup.mobile.bottombutton.remark":`Организация может настроить начальные параметры страницы первого уровня в соответствии с бизнес-процессом.`,
"label.file.searchs":`Поисковые файлы...`,
"vue_label_email_there_is_no_draft_yet":`Черновика пока нет.`,
"front-kefu-moudle-v1-bind-seats":`Связующий агент`,
"label.customfields.lookupmuti.tip":`Создает связь, которая связывает этот объект с другим объектом. Поле связи позволяет пользователям нажать на иконку поиска, чтобы выбрать несколько значений из всплывающего списка. Другой объект является источником значений в списке.`,
"label.integrations.password":`Пароль`,
"label.data.newtemplate.t_conditions":`Шаблонные условия`,
"message.error.repeatsubmit":`Представление повторяется или на одной и той же странице открывается несколько оконных изменений. В последнем случае, пожалуйста, подайте в только что открывшемся окне.`,
"label.umeng.approval.approvalreassign":`Запрос на утверждение #obj переназначается. #obj имя`,
"lable.edit.queue.selobj":`Ошибка: В очереди должен быть хотя бы один выделенный объект`,
"label.compact.layout.frame":`Рамка макета страницы`,
"label.sms.companyname.dsf.infor":`Этот сервис поддерживает только материковый Китай`,
"template.report.individual.case.source":`Источник дела`,
"pagecreator.button.pcpage":`конец ПК`,
"vue_label_commonobject_selectdatatime":`Выберите дату и время`,
"label.icon.181":`Файл`,
"label.loginip.setup.please":`Пожалуйста, укажите диапазон IP-адресов.`,
"vue_label_dashboard_?secondarygroup":`Пожалуйста, выберите второстепенную группу`,
"lable.outlook.mcto.pleasedes":`Введите почтовые домены, с которыми вы не хотите связываться, и разделите их на ",".`,
"DetailedInfo_Activity_EmailMessage_01":`{0} отправьте сообщение по электронной почте {1}.`,
"label.sendmail.step4":`Шаг 4 Отправленные вами сообщения обрабатываются.`,
"label.monitorsys.delete.source":`Описание`,
"label.monitorsys.log.datetime":`Скачать журнал аудита ключевых операций во временном интервале поиска (Excel.xls)`,
"component_chatter_label_myfans":`Мои последователи`,
"label.tianyancha.h5.registereddate":`Зарегистрированная дата`,
"label.multilang.feedtrack.operatecreate":`{0} была создана запись {0}`,
"label.console.step6.no":`Выберите, как отображать списки`,
"four":`Четыре`,
"message.confirmsetpwdforuser":`Сбросить пароль для новых пользователей?`,
"label.cape.verde.time":`Кабо-Верде Время`,
"label.queue.new":`Новая очередь`,
"label.cloudccsite.start":`Активный сайт Главная страница`,
"label.data.exp.way":`Метод экспорта`,
"label.lock.record.donot.delete":`Вы не можете удалить заблокированные записи.`,
"label_emailtocloudcc_filed_type":`Поставщик`,
"frame_personinfo_label_minipic":`Эскизное изображение`,
"label.checkfield.choosetab":`Выберите поля для поиска изображений`,
"component.setup.tabs.label.default":`Страница по умолчанию`,
"page.404.button.toknowmore":`Узнать больше`,
"vue_label_SMS_message_sent_cannot_be_empty":`Содержание отправленного сообщения не может быть пустым.`,
"label.lookupreplaceselectvalue":`Найти и заменить Picklist`,
"pagecreator_layout_button_new":`Новая компоновка`,
"label.mobile.more.upload":`Загрузить новую версию`,
"front-kefu-moudle-v1-Connection-failure":`Не удалось установить соединение`,
"label.version.support.unlimited":`Неограниченная поддержка`,
"message.error.notmarketseamember":`Не член ведущего пула`,
"label.taskandincident":`Задачи и события`,
"label.report.export.print.title":`Печать отчетов Представления`,
"label.file.publicview.error2":`Общественная ссылка неверна, пожалуйста, используйте новую общественную ссылку.`,
"label_chatter_cancel":`Отменить`,
"front-web-module-v1-detail-comment-satisfied":`Уровень удовлетворенности`,
"label.knowledge.delete.topic":`Ошибка при удалении предмета, использованного в этой статье знаний.`,
"label.forecast.forehistory.all":`Все`,
"label.displaybutton":`Отображаемые кнопки`,
"label.icon.148":`Робот`,
"label_tabpage_ok":`Подтвердить`,
"label.checkfield.merge.mainrecord":`мастер-запись`,
"label.notification.arketsea.restored":`{5}восстановленный {2}  {0}：{1}`,
"setup.mainpage.label.welcome31":`Инструкции: Щелкните по меню в левой части этой страницы → Управление настройками → Создание → Приложение`,
"front-kefu-moudle-v1-jtrrt-connect":`Ассоциирование пользователей CloudCC с расширениями TRRT`,
"vue_label_calendar_please_select":`Пожалуйста, выберите отображаемое поле`,
"setup.layout.label.pagename":`Имя макета страницы`,
"template.chart.schdywjhz":`Стоимость возможности кампании`,
"label.access_report":`Кто может получить доступ к этому отчету?`,
"label.assignment.layout.section.optional":`Имеется на вебсайте .`,
"label_chatter_recently":`Недавно`,
"lable.chat.advanced.setting":`Расширенная настройка`,
"label.knowledge.category.hint.eight":`Группа категорий`,
"message.error.facebookuid.null":`ID пользователя Facebook не может быть пустым!`,
"label.step5.total6":`Шаг 5 из 6`,
"label.is.cancel.delete":`Отменить удаление?`,
"setup_mainpage_label_welcome11":`Индивидуальный отчёт`,
"label.answers":`Ответы`,
"label.approvalstep1.tip":`Введите имя, описание и номер шага для вашего нового этапа утверждения.`,
"template.chart.htjeph":`Сумма контракта Рейтинг`,
"label.campaigns.onsiteregistration":`Регистрация на сайте`,
"front-epwechat-module-v1-input-agentid":`Пожалуйста, введите идентификатор агента`,
"label.emailobject.wizard.desc2":`Отслеживайте сообщения электронной почты, которые открываются и открываются.`,
"label.multilang.chatterdetial.vote":`{0} билет(ы)`,
"label.customsetting.manage.value":`Пользовательские данные`,
"front-electronic-export-listCount":`{totalView} данные в целом в текущем представлении, выберите импортированные данные`,
"label.dashboard.create.prompt":`Нельзя создавать приборные панели над табличными отчетами.`,
"label_tabpage_askz":`Что бы вы хотели спросить`,
"label.ems.sentmail":`Исходящий`,
"label.reportlist.untop":`Нефиксированный`,
"label.owner.h5.plzchose":`Пожалуйста, выберите владельца и сохраните`,
"label.callcenter.addup.10.pieces":`Добавьте 10 данных максимум один раз`,
"label.ccdocument.save":`Сохранить документ`,
"label.productcannotnull":`Продукт не может быть пустым`,
"label_tabpage_enabletomobile":`Включить ли мобильную сторону`,
"lable.account.CYAgo":`2 CY Ago`,
"lable.Select.the.returned.high.seas.pool":`Выберите возвращенный пул`,
"tuesday":`вторник`,
"label.partnerCloud.basicSetting.partnerPayment":`Партнерский фонд Activate`,
"label.validate.function.funcExplain.WEEKDAY":`Вернуть определенный день недели. 1 - воскресенье и 7 - суббота.`,
"label.query.detail.manageexuser":`Управление внешними пользователями`,
"vue_label_systemSettings_environment":`Окружающая среда`,
"component_setup_tabs_label_delete":`Удалить`,
"label.weixin.delete.ccchat":`Вы уверены, что хотите удалить это сообщение?`,
"label.lanxin.title":`Lanxin-H5Micro App`,
"label.layout.editcondition.morethanten":`В качестве критериев поиска Вы можете выделить до 10 полей.`,
"label.project.hit.fourteen":`Уведомление об обновлении вех`,
"label.createby":`Созданный`,
"label.moreoperation":`Больше работать`,
"label.lock.tip":`Заблокировать записи от редактирования`,
"label.check.input.condition.three":`Тип поля формулы и развернутая сводка не поддерживаются для вставки`,
"label.quote.dingjia":`Цены`,
"label.currentuseremail":`Текущий адрес электронной почты пользователя`,
"UG_homepage_004":`Автоматизация`,
"chatter.link":`Ссылка`,
"label.new.zealand.standard.time":`новозеландское летнее время`,
"APPIntegration.Dropbox.setting.02":`Инвалид`,
"label.version.searchandmerge":`Дублирование и объединение чеков`,
"label.allmenus.showmsg.nomenu":`Не нашел menu！`,
"front-template-V1-Enable-disable":`Активировать | Деактивировать`,
"label.marketing.setting4":`Регистрация успешно возвращает к URL по умолчанию`,
"UG.Forcast.07":`Прогноз дозволенного`,
"vue_label_systemSettings_correlation":`Связанный список Режим отображения`,
"label.cloudccsite.remark.length":`Позволяет пользователям вводить до 255 символов`,
"label.favorite":`Закладка`,
"template.report.converted.leads":`Конвертированные лиды`,
"label.campaignmember.main.description":`Используйте эту страницу для управления мемберами кампании. Вы можете добавить новых участников кампании или обновить текущий статус участников кампании.`,
"label.salescloud.teamrole.account.organization":`Члены команды могут иметь более высокий уровень доступа к этой учетной записи, чем доступ по умолчанию, установленный вашей организацией.`,
"label.permission.modifyAppPermission.canselectapp":`Доступные приложения`,
"front-epwechat-module-v1-self":`Самостоятельная установка приложений`,
"message.duplication.label.matchexactletters":`Точный`,
"label.appointmentdetail.wizard.title18":`план пятницы`,
"label.area":`Территории`,
"label.sso.saml.sp.username":`Имя пользователя`,
"lable.outlook.new":`Новая конфигурация синхронизации Exchange`,
"label.custom.field.close.conversion":`Закрыто - преобразовано`,
"lable.outlook.detail.tmaping":`Целевые поля карты`,
"label.emailobject.emaildetail.nextactivity.event":`Добавить событие`,
"vue_label_commonobjects_detail_date":`Дата окончания не может быть меньше даты начала`,
"vue_label_email_mark?as":`Отметить как`,
"label.guestgroup":`Аккаунт-группы`,
"label_emailtocloudcc_filed_server":`Сервер`,
"label.icon.186":`Консультационный сайт .`,
"label.department.user.edit":`Редактирование`,
"label.custom.page.component.button.settings":`Настройки кнопок компонентов`,
"label.partnerCloud.orderingPlatform.nextProduct":`Хотите ли вы сохранить текущую конфигурацию продукта и настроить следующий продукт?`,
"vue_label_appstore_cloud_platform":`официальная облачная платформа`,
"label.page.previous":`Предыдущий`,
"label.direct.dashboard.week.report":`Новая еженедельная рабочая записка`,
"label.ServiceCloud.prompt.warning":`Нет статистики распределения ресурсов по адресам.`,
"label.emailtocloudcc.position":`Позиция`,
"vue_label_email_please_enter_the_message_content":`Пожалуйста, введите содержание почты`,
"labal_About_to_jump":`Вскоре он будет перенаправлен.`,
"label_profile_mobile_setup_stand":`Стандартная домашняя страница`,
"label.visualpage.component.n3":`3.Параметра. Параметр записывается в собственные арги , args="name:'zhang', age:26" Обратите внимание на одинарные двойные кавычки.`,
"vue_label_report_operationmode":`Режим работы отчета`,
"label.reportsSubscription.select.attached.file":`Пожалуйста, выберите тип прикрепленного файла.`,
"label.afghanistan.time":`афганское время`,
"label.vlidaterule.formulatrue":`Если это выражение формулы является истинным, отобразить текст, определенный в области Сообщение об ошибке`,
"label.ccchat.person.invite.erroremail":`Формат адреса электронной почты неправильный.`,
"label.viewDashboard":`Перейти к списку Приборной панели`,
"label.at":`на сайте`,
"label.notification.arketsea.beforeretrieve":`Ваш {0}: {1} будет утилизирован до {2}, остаточного времени: {6}дни`,
"label.field.update.show.editor":`Показать редактор формулы`,
"label.weixin.polls.time":`Дата голосования`,
"vue_label_commonobjects_detail_activity_nostarttime":`Нет времени на старт`,
"label.direct.dashboard.me.not.approval70":`До получения разрешения Пункты, представленные мною`,
"label.data.setok.t_desc3":`Операция.`,
"label.view.edit.search.describe":`Поиск после ввода ключевых слов`,
"label.importsourcefiletip":`Перед импортом переведенного файла, разделенного на закладки, пожалуйста, убедитесь в следующем: <span><ul><li>1.Создайте отдельный файл для каждого языка, который вы хотите импортировать, содержащий только имя и атрибут translation.</li><li>2.Языковой атрибут в верхней части каждого файла является обязательным. ( Импорт на китайском языке не поддерживается ). Языковой атрибут выглядит следующим образом: thisLanguage=en_US.</li><li>3. Чтобы убедиться, что ваши файлы для импорта сохранены в кодировке UTF-8, перед импортом.</li>4.`,
"UG.Case.01":`Дело`,
"label.weixin.report.filters":`Фильтры`,
"vue_label_homepage_profilehomepageassignment":`Профиль Главная страница Назначение`,
"label_tabpage_editview":`Вид редактирования`,
"label.tabpage.allpotentialcustomers":`Все зацепки`,
"label.sendemail.send.standbyemail":`(запасной выход)`,
"errormessage.email.atleastonereceiver.z":`Вы должны выбрать или отредактировать адрес получения.`,
"workflow.action.tasks.assignortype.ownertype":`Тип владельца`,
"label.list.userinterface.new.page.setup":`Новая страница`,
"chatter.seladress":`Пожалуйста, выберите хотя бы одного получателя.`,
"Pagelayout_Setup_004":`Можно установить до 4 полей`,
"label.mobile.home.page.tenbig.opp":`Топ 10 возможностей в ближайшие 30 дней`,
"label.wtd.changefields.newpc":`Генерировать страницу ПК`,
"label.opportunity.perm.remark":`Это частные возможности, пожалуйста, свяжитесь с владельцем "owneridccname" <br>, чтобы получить доступ.`,
"label.data.exp.tempdes":`Шаблон Описание`,
"label.appointment.wizard.subtitle2-1":`С`,
"lable.currencyManage.button.manageexchangeRate":`Управление датированными обменными курсами`,
"label.file.viewinfo":`Просмотреть информацию о файле`,
"label.integrations.mailchimp.export.failed":`Экспорт данных не удался, пожалуйста, проверьте ваше сетевое подключение и попробуйте еще раз.`,
"pagecreator_page_button_edit":`Редактирование`,
"label.icon.86":`Краткий кейс`,
"label.exchange.sync.reset":`Сброс синхронизации`,
"label.customfields.lookupfilter":`Вы можете создать фильтр для ограничения записей, которые доступны пользователю в поле поиска.`,
"label.component.hotdeal.nopermission":`Для просмотра данных, связанных с возможностями вашего бизнеса, свяжитесь с вашим администратором CloudCC.`,
"label.address.province":`Государственный`,
"lable.PowerProcess.3digit.input":`Не более трех цифр.`,
"label.asset":`Активы`,
"label.passwordPolicy.setup.nopwdremember":`Пароль не помнится`,
"front-electronic-signature-setting-intro2":`Перед началом подписания договора, пожалуйста, предварительно установите шаблон на платформе DocuSign. При инициации подписания вы можете выбрать предварительно установленный шаблон договора.`,
"pagecreator.page.button.new":`Новая страница`,
"label.tabpage.step2":`На шаге 2 указываются условия фильтрации`,
"label_switch_two_column_or_responsive_layout":`Переключение на стандартный или отзывчивый макет`,
"label.batchDelete":`Массовое удаление`,
"chatter.edit.ct":`Отредактируйте свои контактные данные.`,
"UG_ST_003":`У вас нет прав на создание {0}, обратитесь к администратору, нажмите кнопку подтверждения, чтобы перейти непосредственно к интерфейсу {0}.`,
"label.timzone.tip.info2":`При использовании упрощенного формата для форматирования даты необходимо установить часовые пояса для экземпляров упрощенного формата, таких как SimpleDateFormat myDateFormat=new SimpleDateFormat("yyyy-MM-dd");myDateFormat.setTimeZone(TimeUtil.getUserTimeZone(userInfo));или получить экземпляр с помощью инструментального метода, предоставленного TimeUtil, SimpleDateFormat myDateFormat=TimeUtil.getSimpleDateFormat("yyyy-MM-dd",userInfo);`,
"label.ems.firstsynchistory":`Впервые синхронизирую почту с тех пор, как давно`,
"label.currency.invalid":`Неактивные валюты`,
"label.mask.custom":`Настроить`,
"lable.opppdt.addpdt.title":`Выбрать продукт`,
"label.appointment.wizard.subtitle3-3":`среда`,
"label.weixin.report.criteria":`сгруппированы по`,
"label.appupload.upload.install.uninstall":`Невозможно установить`,
"label.compact.layout.frame.split":`Отображение на отдельном экране`,
"label.email.attach.complete.info":`После завершения загрузки файл будет отображен в списке вложений ниже`,
"label.Receivables":`Дебиторская задолженность`,
"label.linkedin.title.setting":`Интегрированная информация LinkedIn`,
"label.companynotice":`Объявление компании`,
"label.emailobject.discard":`Бросить`,
"label.selected.searchfield":`Выбранное поле результатов поиска`,
"front-electronic-signature-explainDocusign":`DocuSign Электронная подпись Описание:`,
"chatter.link.name":`Имя ссылки`,
"label.low":`Низкий уровень`,
"label.verticalline":`Вертикальные колонны`,
"label.approval.isallowed.reject.label":`Разрешить отказ при утверждении отдельных данных?`,
"label.emailtocloudcc.button.enable":`Активный сайт`,
"label.dashboardSetup.showdw.d5":`Целочисленный блок`,
"label.usermanage.not.authority":`У вас нет достаточных на это разрешений.`,
"label.customobjects.track.introduce0":`На этой странице можно выбрать, какие поля отслеживать в списке {0} "Отслеживание полей". Всякий раз, когда пользователь изменяет любое из полей, выбранных ниже, старое значение поля и новое значение поля, а также дату, время, изменение характеристик, и пользователь, вносящий изменения, добавляются в список, связанный с "Отслеживанием полей".`,
"canlendarmonth":`Календарный месяц`,
"vue_label_dashboard_minimum":`Пожалуйста, введите минимум`,
"label.salescloud.optionlist.inputname.linealone":`Введите одно или несколько значений пикилиста ниже, при этом каждое значение будет отделено новой строкой.`,
"message.error.organuzation.information.null":`Информация об организации не существует.`,
"label.tabpage.maxfilez":`Максимальный размер файла`,
"message.validation.apiname":`Она должна начинаться с буквы, содержать только буквы, цифры и подчеркивание, только заглавные и строчные буквы, цифры и подчеркивание, а максимальная длина 50 символов, минимальная длина 2 символа.`,
"report.type.label.contractPayment":`Контракты и дебиторская задолженность`,
"label.limiting.choose.three.files":`Вы можете выбрать 3 файла, выбранные сейчас.`,
"label.reportTypeFocus":`Ориентация на источник данных отчета`,
"Report_Delete_Confirm_Title":`Пожалуйста, подтвердите`,
"front-gantt-module-reorder-milestones":`Упорядочить этапы`,
"front-starter-v1-customer-tips-success":`Активировать пул учетных записей успешно`,
"label.tabpage.isdeleteview":`Вы уверены, что удалите этот вид?`,
"label.favorite.title":`Платформа CloudCC`,
"page.layout.sysinfo":`Информация о системе`,
"label.tabpage.pleaseSelectz":`Пожалуйста, выберите`,
"label.smsnotice":`SMS-оповещения`,
"label.forecast.customforecast.foretype.Pipeline":`Трубопровод`,
"label.rejectbehaviour":`Отвергнуть Поведение`,
"label.searchlayout.view.example.new":`Пример просмотра (Новое окно)`,
"vue_label_homepage_notice2":`Вы можете вручную назначить макет домашней страницы, что облегчит сотрудникам эффективное выполнение их повседневных задач.`,
"label.import.index.chooseidorother":`3、 Вы можете выбрать ID или имя для сопоставления с записью и заполнить поле поиска. Если вам нужно получить ID соответствующей записи и другую информацию, вы можете создать отчет и установить имя записи и ID записи в качестве групповых столбцов, а затем экспортировать отчет.`,
"label.westem.european.summer.time":`западноевропейское время`,
"label.brackets":`Краткий обзор`,
"asset.serialnumber.unique":`Серийный номер актива уже существует, пожалуйста, не добавляйте его повторно.`,
"label.callcenter.access.keyID":`Идентификатор секретного ключа доступа`,
"label.calendar.month.view":`Месяц просмотра`,
"label.realdelete":`Постоянно удалять`,
"label.partnerCloud.orderingPlatform.amountPaid:":`Будет оплачено:`,
"label.reportTypName":`источник данных отчёта Название`,
"lable.newtabpage.opensearchresult":`Расширить результаты поиска`,
"front-kefu-moudle-v1-Session-duration":`Продолжительность сессии:`,
"label.import.index.ignore":`Игнорировать`,
"label.customfields.url.tip":`Позволяет пользователям вводить любой действительный адрес веб-сайта. Когда пользователи нажимают на поле, URL откроется в новом окне или текущем окне в соответствии с настройками пользователей, и по умолчанию URL откроется в новом окне.`,
"label.projectManagement.editMilestone":`Редактирование вехи`,
"front-gantt-module-v1-project-gantt-list":`Список проектов`,
"label.validate.remark":`Правила проверки помогают улучшить качество данных, не позволяя пользователям сохранять некорректные данные. Вы можете определить одно или несколько правил проверки, которые состоят из состояния ошибки и соответствующего сообщения об ошибке. Правила проверки выполняются в рекордно короткие сроки. При выполнении условия сохранения данных об ошибке, сохранение прерывается и отображается сообщение об ошибке.`,
"front-kefu-moudle-v1-sjgsbzq-reinput":`Формат телефонного номера неверен. Пожалуйста, введите заново`,
"label.channel.name":`Название канала`,
"label.weixin.cloudcc.user.message":`Информация для пользователей CloudCC`,
"label.icon.59":`Семинар`,
"label.ccpeak.function":`Метод`,
"lable.opppdt.selPdt.leastten.fields":`Пожалуйста, выберите до 5 полей`,
"label.deadline":`Крайний срок`,
"label.product.sel":`Выбор ценовой книги`,
"vue_label_helpcenter_detail2":`Все события: Показать все события, к которым у вас есть доступ, даже если вы не участвуете.<br>    Также вы можете отфильтровать записи о деятельности, которые вы хотите просмотреть, по диапазону дат и типу деятельности.<br>    4. Dynamic<br>     Все люди, которые могут просмотреть эту запись, могут оставить сообщение и сообщение в колонке "Динамическая" записи, а также вы можете просмотреть все изменения информации, последние действия и комментарии и сообщения других людей об этой записи. Эта колонка облегчает онлайн-общение и сотрудничество между Вами и Вашими коллегами, помогая улучшить командную работу и повысить эффективность.<br> Отправка<br>    Шаг 1: Нажмите на строку отправлений и введите содержание отправлений<br>    Шаг 2: Нажмите кнопку "Файл/Ссылка", чтобы добавить файл/ссылку по мере необходимости<br>      nbsp;Шаг 3: Нажмите кнопку "Отправить", чтобы закончить отправку сообщения. <br> Просмотрите post<br>    После успешной публикации вы можете увидеть микро-пост, который вы только что опубликовали ниже. Микропост состоит из следующих частей: аватар, имя и фамилия человека, содержание микропоста и методы взаимодействия (например/комментарий/редактирование/удаление сообщения). <br> Сортировка и поиск сообщений<br>    Нажмите на выпадающий список справа от "Сортировать", чтобы изменить сортировку сообщений. <br>     "Последняя активность" сортировка: сортировка по последнему времени взаимодействия микропостов;<br>      "Последнее сообщение "Упорядочить: Упорядочить по времени публикации микропостов;<br>    Просмотр различных типов микропостов<br>     Микропосты с обычным текстом: Просматривайте все содержимое непосредственно в зоне публикации микропостов;<br>    Микропосты, содержащие файлы: нажмите на кнопку загрузки файла, чтобы загрузить файл локально для просмотра;<br>     Микропосты, содержащие ссылки: нажмите на ссылку в микропосте, чтобы открыть ее;<br> Комментарии и симпатии к микропостам<br>    Комментарии<br>   Шаг 1: Нажмите на "Комментарий" под каждым микропостом <br>    Шаг 2: Введите комментарий в текстовое поле, которое откроется<br>   Шаг 3: Добавление файла/ссылки на комментарий по мере необходимости Шаг 4: Нажмите кнопку "Комментарий" под текстовым полем для завершения операции<br>    Удалить комментарий<br>     Публикатор комментария может удалить содержимое комментария. Нажмите на кнопку справа от комментария и в выпадающем списке выберите пункт "Удалить".`,
"pagecreator_layout_button_mergecell":`Объединить ячейки`,
"Lead_Scoring_Setting_Rule_Setup_Active":`Активный сайт`,
"label.query.detail.loginbypartneruser":`Вход по пользователям-партнерам`,
"label.view.selectrenderfields":`Выберите поля для отображения`,
"label.code.add":`Добавить информацию о ссылке на QR-код`,
"label.appointmentconfirmpage.wizard.title1":`ЗАПЛАНИРОВАННАЯ ВСТРЕЧА`,
"label.timzone.tip.title":`Date/time type data multiple time zone support. при работе с датами, использующими new date() или calendar, следует обрабатывать соответствующие проблемы с несколькими часовыми поясами. кроме того, класс timeutil tool предоставляет ряд инструментов, поддерживающих несколько часовых поясов.`,
"label.tag.addtags.visibility":`Видимость`,
"label.appointmentconfirmpage.wizard.title3":`Вы уверены, что отмените существующую встречу и запишитесь на новую?`,
"lable.outlook.detail.oldest":`Старейший сайт`,
"label.account.custom.quarter.timeerror":`Пользовательский квартал дата начала или пользовательский квартал дата окончания находится между историей пользовательских кварталов, пожалуйста, проверьте и сбросить`,
"label.sendsms.idea":`Уважаемый`,
"label.manageAll.pagenum2":`Это последняя страница.`,
"serviceterritory.isactive.notactive":`Данная территория обслуживания не включена.`,
"label.userinfo.newpwd.notnull":`Пожалуйста, введите новый пароль.`,
"vue_label_dashboard_nolinkagedashboard":`Приборная панель без привязки`,
"message.cannotdeleteapproval":`Вы не можете удалить эту процедуру утверждения.`,
"label.wtd.detail.m":`Мобильный`,
"label.app.step4.introduce":`Выберите вкладки для включения в это пользовательское приложение.`,
"label.ccchat.error.permission":`Нет доступа`,
"UG_opportunity_009":`Или`,
"label.Receivables.TheActualAmountOfMoney":`Фактические поступления`,
"label.callcenter.no.search":`Нет соответствующего запроса к информации`,
"label.user.introduce":`Пользователи`,
"message.datalocked.addpdt":`Эта возможность запись заблокирована, вы не можете добавить Прудук.`,
"label.sendsms.step1":`Step1: Укажите адресатов`,
"label.brief.contracts":`Контракты`,
"label.setup.mini.swap":`Установка карусели`,
"label.emailobject.wizard.desc1":`Подключите электронную почту, отправьте сюда почту и автоматически синхронизируйте с записью.`,
"label.login.verification.mfa.desc2":`Если по каким-то причинам вы не можете проверить, например, потеряли или по ошибке удалили приложения MFA на своем телефоне, возможно, вы слышали, как администратор снял привязку с МИДа.`,
"label.notification.receiveSms.message":`Вы получили текстовое сообщение от {!fromaddress}, нажмите, чтобы увидеть более подробную информацию.`,
"label.emailmerge.mergeFolder.publicfolder":`Шаблоны для объединения нефильтрованной публичной электронной почты`,
"label.password.update.false":`Не удалось изменить пароль, обратитесь к администратору!`,
"label_tabpage_systemz":`Система (системы)`,
"label.dataimport.objectid.null":`ID объекта пуст и не может быть импортирован`,
"label.currency.type":`Тип валюты`,
"component_setup_button_appurl":`Системный урл`,
"label.appointmentconfirmail.wizard.title2":`У тебя назначено {0}`,
"lable.product.please.enter":`Пожалуйста, введите`,
"label.escalation.setup.title":`Правила Эскалации Дела`,
"label.create_failure":`Не удалось создать форму`,
"label.weixin.brand.model":`Модель бренда`,
"label.layout.nameoftestobj2":`Имя тестового объекта Два Имя`,
"vue_label_filters_number":`Для каждого отчета поддерживается 10 филеров.`,
"label.file.following":`Следующий сайт`,
"vue_label_account_all_contracts":`Передайте все контракты владельцев заказчика`,
"label.service.please.select.cycle.type":`Пожалуйста, выберите тип цикла`,
"label.weixin.weipoll.optionname":`Микро Имя Выбор Голосования`,
"label.data.newtemplate.null":`Нет`,
"message.passwordPolicy.validate.complexReq1":`Ошибка:Ваш пароль должен состоять из букв и цифр.`,
"label.forecast.shre.editmanager":`Менеджер Редактирование`,
"label.emailtemplate.tip":`Ниже приведен список всех ваших шаблонов электронной почты в выбранной папке. Нажмите на новую кнопку, чтобы создать новый текстовый или HTML шаблон электронной почты. Вы можете использовать эти шаблоны при отправке отдельных сообщений электронной почты.`,
"label.tag.manage.button":`Управляющие метки`,
"label.changepw":`Изменить пароль`,
"label.sso.saml.sp.idsource.nameid":`Идентичность находится в элементе NameIdentifier в заявлении субъекта`,
"label.salescloud.teamrole.addmember":`Добавить членов группы возможностей CloudCC`,
"label.h5.similar.opportunity.last.months6":`Последние 3-6 месяцев`,
"message.save.opportunity.role.save.failed":`Не удалось сохранить контактную роль`,
"vue_label_report_formulainformation":`Информация по формуле`,
"label.area.assignuser.remark":`Назначение пользователей на территорию`,
"label.multilang.viewlist.total":`{0} Избранный`,
"label.newprocessstep4":`Шаг 4 Выберите шаблоны уведомлений по электронной почте`,
"label.permission.objectpermission.open":`Открыть`,
"label.service.gantt.close.list":`Закрыть список`,
"label.standarduserfield":`Стандартные поля пользователя`,
"vue_label_commonobjects_detail_the_administrator":`Запись заблокирована, пожалуйста, свяжитесь с администратором.`,
"label.exchange.sync.account":`Учетная запись службы обмена Учетные данные`,
"label.mr.title.button.back":`обратно, и сбросить критерии поиска`,
"label.notsetup.operation":`Ошибка состояния линии, оператор не был настроен.`,
"label.notifications_center":`Центр уведомлений`,
"label.event.moveup.5hour":`5 часов вперёд`,
"report_label_pleaseinput":`Введите то, что вы хотите найти`,
"label.batchadd.newbatchpage.errorlist":`Добавление данных не удалось`,
"label.quickbooks.invoices":`Счета`,
"chatter.feed.usingchatter":`Включите CCChat, ваши пользователи могут следить за несколькими людьми или за за записями и сообщениями.`,
"label.all.marketing.activities":`Владелец рыночной кампании`,
"label.lookup.finish":`Автоматическое завершение поиска`,
"label.weixin.unbind":`Развязать`,
"front-console-closeTime":`Время закрытия`,
"label.service.rest.time":`Оставшееся время`,
"label.mr.descreption.condition1":`Введите область действия и правила поиска дубликатов записей. Нажмите кнопку [Найти дубликаты], чтобы получить квалифицированные дубликаты записей.`,
"label.group.new":`Новая группа`,
"vue_label_SMS_sending_please_wait":`Отправляю, пожалуйста, подождите.`,
"label.Standardobj.tab":`Стандартные вкладки объектов`,
"label_chatter_pastEvents":`Прошлая деятельность`,
"label.chatter.priority":`Приоритет`,
"select.nullvalue":`-None-`,
"setup_layout_group_pagecomponent":`Компоненты страницы`,
"label.dataimport.dataerror.check":`Ошибка данных, пожалуйста, проверьте данные.`,
"label.permission.detail.app.pagesetting.tip":`Извлечь пользовательские страницы Параметры разрешения`,
"label.knowledge.language.polish":`Польский`,
"label.project.hit.two":`Напоминание об истечении срока действия подзадачи`,
"label.customerapp":`Настраиваемое приложение`,
"label.reportsSubscriptionPage.condition.value":`Значение`,
"label.tabpage.no2z":`No2`,
"lable.system.administrator":`Извините, у вас нет доступа для работы. Пожалуйста, свяжитесь с администратором.`,
"homepage.layout.buttion":`Макет страницы Назначение`,
"label.notification.event.overlapEvent":`Делегированный пользователь уже был назначен на событие {субъект} из {началу}-{конечному времени}, хотите ли вы все равно создать это событие?`,
"label.customfields":`Пользовательские поля`,
"label.data.downpage.e.title":`Шаги экспорта данных`,
"label.notification.serviceappointment.remove":`Ваш отправленный рабочий заказ {0} был отменен, пожалуйста, организуйте работу разумно.`,
"label.campagin.roi.zhuangtai":`Статус кампании`,
"label.applt.updown":`Скачать Минипрограмма QRкод`,
"label.customfields.new.step1.tip":`Укажите тип информации, которая будет содержаться в пользовательском поле.`,
"label.staticresource.upload.limit":`Загружать можно только файлы этих форматов: png, jpg, gif, js, css, zip.`,
"chatter.edit.user.p":`Изменить фото пользователя`,
"label.icon.32":`Компьютер`,
"vue_label_homepage_notice_cantset":`Главная страница профиля не настроена для этого профиля, главную страницу профиля по умолчанию изменить нельзя.`,
"front-epwechat-module-v1-agree-unbound":`Согласиться и принять вышеуказанную информацию, не имеющую обязательной силы`,
"label.version.chatter.cooperation":`CCChat`,
"label.customer.tab.step1.selectstyle":`Пожалуйста, выберите стиль табуляции.`,
"label.select.an.asset":`Пожалуйста, выберите актив.`,
"label.search.sizer.field":`Поля поискового фильтра`,
"label.emailmerge.mergeFolder.lastone":`Пожалуйста, выберите, по крайней мере, шаблон.`,
"label_tabpage_step2":`На шаге 2 указываются условия фильтрации`,
"label.version.lead.automatic.allocation":`Правила назначения свинца`,
"label.projectManagement.update.succeeded":`Успешное обновление`,
"label_tabpage_bar":`Бар`,
"label.appupload.component.type.tab":`Tab`,
"label.pigeonhole.sel.f":`Выберите папки для архивации`,
"homepage.components.status":`Статус компонента`,
"label.currency.edit.new":`Редактирование валюты: Новая валюта`,
"label.input.new.password":`Пожалуйста, введите правильный новый пароль`,
"chatter.group.membersName":`Имя MMeMber`,
"label.myinfo.modify":`Личная информация Редактирование`,
"label_tabpage_next":`Следующий шаг`,
"vue_label_homepage_card_closedopportunities":`Закрытые возможности`,
"label.permission.edit":`Редактировать свойства`,
"message.error.searchfield.objid.null":`Идентификатор объекта, требуемый полем запроса, не может быть пустым`,
"label.partnerCloud.productSet":`Настройка продукта`,
"label.emailtocloudcc.filed.emailto":`Отправить по электронной почте`,
"label.service.miniProgram.uploadingImage":`Пожалуйста, загрузите изображение карусели.`,
"label.sso.saml.idp.description1":`Подключаемые приложения`,
"label.event.moveup.10minutes":`10 минут вперёд`,
"label.quote.createby":`Подготовитель`,
"label.workflow.baseontimeoparate":`Зависящие от времени действия в рамках рабочего процесса`,
"label.searchall.r":`Повторить поиск`,
"vue_label_homepage_differentprofiles":`Назначайте различные домашние страницы разным профилям`,
"label.campaign.channel.step1":`Шаг1: Информация`,
"label.event.moveup.2hour":`2 часа вперёд`,
"font-evaluate-module-v1-cancle-reply":`Отменить автоответчик`,
"message.datalocked.delete":`Вы не можете удалить эту запись, потому что она была заблокирована. Если вы хотите удалить ее, пожалуйста, свяжитесь с администратором.`,
"label.sso.listOfKey":`Список ключей`,
"label_chatter_newtask":`Новая задача`,
"label_emailsync_form_seversetting":`Настройка`,
"label.partner.new.function":`Описание функции`,
"vue_label_notice_homepage_pleaceentername":`Пожалуйста, введите название домашней страницы`,
"message.please.choose.opportunity":`Пожалуйста, выберите бизнес-возможность`,
"label_file_use_most_user":`Пользователи с наибольшим количеством используемого пространства для хранения данных`,
"label.htyj.remark2":`поэтому вы не можете просмотреть суммы контрактов`,
"label.formula.message":`когда формула оценивается как ложная, подсказка о неудаче заявки`,
"UG_Case_04":`Назначение дела`,
"label.displaycolumn":`Показательные колонки`,
"vue_label_campaign_selected_member_status":`Обновление до статуса выбранного участника`,
"label.workflow.operate":`Рабочий процесс Действия`,
"label_chatter_mail":`Почта`,
"label.setup.mini.setting":`Настройка фона мини-программ`,
"vue_label_chat_invitetojoin":`Вы пригласили "{invite}" присоединиться к групповому чату.`,
"setup.object.field.dependency.label.linkedfieldvalue":`Зависимое поле`,
"vue_label_email_update_template":`Обновление шаблона`,
"label.email.template.private.mail":`Эксклюзивная папка шаблонов электронной почты`,
"lable.Confirm .potential.customers":`Подтвердить переработку свинца {название}`,
"vue_label_leadpool":`Свинцовый бассейн`,
"label.ems.hostorpost.error":`Ошибка конфигурации сервера или порта, пожалуйста, проверьте.`,
"label.search.saveok":`Успешно спасённый`,
"label.custom.field.cannot.maping":`Невозможно многократно наложить карту на это поле`,
"label.projectManagement.dispatched":`Отправлено`,
"time":`Время`,
"label.choose_socialnetwork":`Выберите социальную сеть для старта`,
"label.vlidaterule.checkedtrue":`Если установлен флажок "формула", нет необходимости делать двойные кавычки.`,
"label.appointmentconfirmail.wizard.btn1":`Переоформить расписание`,
"front-kefu-moudle-v1-maxchars-input":`Можно ввести до {0} символов`,
"setup.mainpage.label.welcome10":`Инструкции: Щелкните по меню в левой части страницы → Настройки приложения → Создать → Объект → Название объекта → Пользовательский макет.`,
"label.ems.company.setup.title":`Установка электронного ящика компании`,
"label.channel":`Каналы`,
"label.textmessage.groupsms":`Групповые SMS-сообщения`,
"label.asset.deleted.successfully":`Успешное удаление BOM актива.`,
"label.knowledgebase.new.workspace":`Новое рабочее пространство`,
"label.ServiceCloud.diliweizhi":`Местонахождение`,
"label.private_me":`Частный владелец (я)`,
"label.service.miniProgram.imageLink":`Ссылка на карусель`,
"label.area.assigned":`Назначенные пользователи`,
"label.weixin..xsld.name":`Имя возможности`,
"label.campaign.matchway.select.name":`Имя`,
"label.installedsoft":`Установленные пакеты`,
"label.projectManagement.spare.time":`Доступное время`,
"label.user.select.custom.text.sendemail":`Выберите пользовательский текстовый формат для отправки электронной почты напрямую`,
"label_chatter_chatter":`CCChat`,
"label.approveorrefuse":`Утвердить/отказать`,
"startdate.enddate.time.illegal":`Дата начала должна быть меньше или равна дате окончания.`,
"label.project.hit.eight":`Ежедневное напоминание о задании`,
"message.duplication.label.uncheck":`Noo-проверка`,
"label.allocation.role":`Назначить пользователей`,
"label.sendemail.lead.scoreinfo":`Уважаемый #username:\r\n система набрала все очки просмотра очков, которые вы выбрали "#viewlabel" на основании правил подсчета очков. Для этого нужно #timestr.\r\n, пожалуйста, войдите в систему и откройте просмотр, чтобы проверить результаты.\r\n attention:\r\n Если вы не можете просмотреть результат по очкам, которые вы набрали, пожалуйста, отредактируйте представление и добавьте "очко очков" в поле, чтобы увидеть результат очков.\r\n спасибо и наилучшие пожелания!\r\n #orgname\r\n.`,
"lable.oppt.jieduan.closejieduan":`Закрыть эту возможность`,
"label.ems.verify":`Проверить`,
"message.error.startdate":`Дата начала должна быть раньше, чем дата окончания.`,
"label.campaignmember.main.deletelead":`Удалить свинца, имеющиеся в наличии у членов`,
"label.partnerCloud.financeSetting.account":`После активации партнерского фонда будут добавлены объекты партнерского фонда и выписка фонда. Пользователипартнеры могут использовать счет в CloudCC для оплаты заказов.`,
"message.datalocked":`его дело закрыто. Если вам нужно отредактировать ее, пожалуйста, свяжитесь с вашим администратором.`,
"lable.opppdt.selPbk.pricebook":`Ценники`,
"label.knowledgebase.restore.article":`Восстановить статью?`,
"label.object.batchadd":`Пакетное добавление {objName}`,
"label.what_happen":`Страница после отправки формы`,
"label.roleandunderling":`Роли и Подчиненные`,
"label.knowledge.language.russian":`Русский`,
"front-electronic-signature-explain-first":`Перед привязкой электронной подписи рекомендуется зарегистрироваться и сертифицироваться на платформе Fadada.`,
"component.sendmail.label.subject":`Тема`,
"month":`Месяц`,
"label_chatter_save":`Сохранить`,
"label.view.sortview.sectiontitle":`Вид будет отображаться в выбранном порядке`,
"label.mobile.home.page.major.project":`Ключевые проекты`,
"label.weixin.input.filename":`Пожалуйста, введите имя файла`,
"label.pagelayout.remark":`Эта страница позволяет создавать различные макеты страниц для отображения`,
"label.service.miniProgram.store":`История бренда`,
"label.recordtype.edit.selected":`Выбранное значение`,
"message.selectgroupcondition":`Пожалуйста, выберите условия группировки`,
"label.y.axis.cannot.empty":`Ось Y не может быть нулевой`,
"label.textmessage.vonage.connected.count":`Засчитывается как связавшийся`,
"setup.layout.label.readonly":`Читать только для чтения`,
"front-kefu-moudle-service-agent":`Обслуживание клиентов`,
"message.login.mfaverification.page.invalid":`Страница недействительна. Пожалуйста, обновите ее.`,
"label.central.standard.time":`Центральное стандартное время`,
"label.processnoticepic":`Внимание Образ процесса утверждения`,
"vue_label_helpcenter_calendar1.2":`Правила отображения записи календаря: записи календаря будут отображаться в сетке календаря, а область сетки, в которой находится запись календаря, представляет временной диапазон записи. Записи календаря, которые охватывают более 24 часов, будут отображаться в верхней части шкалы времени в просмотрах дня, недели и доступности. Если в просмотре месяца в сетке присутствует несколько календарных записей, то для их просмотра можно нажать кнопку " Больше". Левая или правая часть записи календаря является полукругом, что означает, что нет такой записи в предыдущий или следующий день сетки. Левая или правая часть записи календаря округлена под прямым углом, что означает, что в предыдущий или следующий день сетки такой записи все еще нет. <br> Быстро найти дату в просмотре календаря: Вы можете найти диапазон дат, отображаемых в просмотре календаря слева, выбрав время на маленьком календаре справа от страницы календаря. Вы также можете нажать на иконки "<" и ">" в верхней правой части страницы календаря для быстрого переключения дат. Если время просмотра календаря не является текущим временем, Вы можете нажать на иконку "Сегодня" в верхней правой части страницы календаря, чтобы быстро вернуться к сегодняшнему дню. <br>Вид списка<br> Переключиться с вида календаря на вид списка: Щелкните по иконке "календарь" в правом верхнем углу просмотра календаря и выберите "таблицу", чтобы переключиться на просмотр списка событий. <br>пользование просмотра списка: Чтобы просмотреть определенные события или несколько событий одновременно, откройте представление "таблица". В режиме просмотра списка есть предустановленные виды списка. Нажмите на иконку "выпадающая кнопка" в левом верхнем углу просмотра списка, чтобы вывести на экран все просмотры списка, к которым у вас есть доступ. Вы также можете настроить вид списка событий в соответствии с вашими потребностями. <br> 2. Мой календарь и другие календари<br> Мой календарь<br> Мой календарь содержит мой календарь событий и календарь объектов. <br> Мой календарь событий: Отобразите в просмотре календаря все записи о событиях, в которых назначенное лицо является вашим. Мой календарь событий не может быть удален, отредактирован или изменен в цвете. Вы можете поделиться "Моим календарем событий" со своими коллегами.`,
"label.approval.end":`Конец`,
"vue_label_report_notice_cannotdelete":`В этой папке есть отчеты, которые нельзя удалить.`,
"label.sso.saml.idp.loginurl":`URL-адрес входа IDP`,
"label.emailtocloudcc.filed.port":`Порт`,
"label.directdashboard.righttitle":`Приборные панели анализа продаж`,
"label.knowledge.case.suggest.article":`Предлагаемые статьи в кейсах`,
"label.version.maxcount":`за пределом.`,
"label.weixin..xsld.yjqyrq":`Дата закрытия`,
"front-project-module-v1-unmarket-is-template":`Снять метку с шаблона`,
"label.mobile.quickcreate.default.map":`Карта`,
"chatter.click.p":`Нажмите, чтобы перейти к предварительному просмотру`,
"label.chat.topic.all.topic":`Все темы`,
"label.channel.head":`Руководитель канала`,
"lable.edit.queue.emaildes":`Введите имя очереди и адрес электронной почты, который будет использоваться при отправке уведомлений (например, когда в очередь поставлен случай). Электронный адрес может быть как для отдельного лица, так и для списка рассылки. Когда объекту назначена очередь, уведомление будут получать только члены очереди.`,
"label.tag.filter":`Тегфильтр`,
"label_chatter_filterTimeLine":`Временная линия фильтрации`,
"label.dashboard.show.value":`Показать значения`,
"vue_label_normal_solution_sf":`Решение`,
"label.customfields.location.tip":`Позволяет пользователю определить местоположение. включает в себя компоненты долготы и размеров, которые могут быть использованы для расчета расстояний.`,
"label.weixin.copyright":`Авторское право© 2008-2022 CloudCC.com,inc. Все права защищены CloudCC.com`,
"label.icon.33":`Компьютер`,
"label.mr.title.opportunityName":`Имя возможности`,
"template.report.sales.month":`Продажи этого месяца`,
"chatter.group.lookingForPeople":`Начните вводить имя`,
"label_tabpage_userz":`Пользователи`,
"label.reportsSubscriptionPage.email.formatselection":`Пожалуйста, выберите формат отчета, который вы хотите получить по электронной почте.`,
"lable.product.plist":`Прейскурантная цена`,
"label.multilang.activity.monthline":`Неделя {0}`,
"label.ccchat.whose.name.contains2":`Члены любой избирательной группы`,
"label.mobile.phone.day.report":`Ежедневные рабочие заметки`,
"label.processsetting.set.files":`Установить поля`,
"label.systemlog.s":`Успех`,
"label.tabpage.uploadsz":`Загрузить`,
"serviceterritory.member.time.conflict":`В этом временном диапазоне сервисные ресурсы стали членами другой сервисной территории.`,
"label_chatter_startDate":`Стартовые данные`,
"label.search.at.least.two":`Поисковые термины должны быть не менее 2-х символов.`,
"label.approval.ressign.project":`Элементы для назначения`,
"lable.custom.Previous.CY":`Предыдущий CY`,
"label_chatter_link":`Ссылка`,
"label.weixin.group.name":`Имя`,
"label.partnerCloud.basicSetting.domainName":`Операция необратима, и имя домена не может быть изменено после инициализации. Вы уверены, что хотите подтвердить операцию?`,
"lable.SalesCommitmentKanBan.targetContract":`Целевой контракт Сумма`,
"label.currency.new":`Новая корпоративная валюта`,
"message.passwordPolicy.validate.complexReq3":`Ошибка:Ваш пароль должен состоять из комбинации цифр, заглавных и строчных букв, а также специальных символов.`,
"label.icon.127":`Врачи`,
"label.customfields.fieldname.tip":`Имя поля является внутренней ссылкой и используется для целей интеграции, таких как API.`,
"chatter.feed.menutype.feed":`Резюме`,
"label.home.standard.dashboard.role":`У вас нет информации о ролях, поэтому вы не можете просмотреть приборную панель обязательств по продажам.`,
"label.customfields.fielddependency.button":`Нажмите кнопку, чтобы включить или исключить выбранные значения из зависимого списка`,
"label.recentprojects":`Недавние предметы`,
"label.appupload.logo.introduce":`Логотип упаковки должен быть меньше 20 КБ. Размеры изображения должны быть не более 60 пикселей в ширину и 60 пикселей в высоту для достижения наилучших результатов. Более крупные изображения будут изменены в размерах и могут выглядеть искаженными.`,
"label.integrations.northamericanleads":`североамериканские лидеры`,
"label.sms.balance":`Баланс (юань)`,
"label.ccchat.message.num":`Новости`,
"label.embed_website":`Чтобы вставить эту форму, просто скопируйте и вставьте приведенный ниже код в HTMLкод на вашем сайте.`,
"label.trigger.check.error":`Проверка синтаксиса триггера не прошла.`,
"label.bmap.baidu.maps":`Карты Байду`,
"label.nextapproverauto":`Следующий автоматический утверждающий, определяемый`,
"label.customfields.date.tip":`Позволяет пользователям вводить дату или выбирать дату из всплывающего календаря.`,
"button.partner.back":`Вернуться`,
"label.layout.editcondition.tip":`Выберите поля, которые вы хотите использовать в качестве критериев поиска. Обратите внимание, что можно выбрать до 10 полей.`,
"label.stacked.area":`Складываемая площадь`,
"font-evaluate-module-v1-case-closed":`Только когда дело закрыто`,
"label_emailsync_status_log":`Журнал подключения`,
"label.version.area.and.sales":`Команда по управлению и продажам территорий`,
"label.service.booking.sessions":`Время назначения обслуживания`,
"label.untransfile":`Непереведённый`,
"label.textmessage.sentfail":`Не отправлено`,
"label.emailtemplate.detailinfo":`Детали шаблона`,
"setup_mainpage_label_welcome13":`Инструкции: Нажмите на верхнее меню → Отчеты → Новый`,
"label.ccchat.error.nullid":`удостоверение личности не может быть пустым`,
"label.partnerCloud.partnerAccount.rebate":`Rebate Revenu`,
"label.appupload.component.type.scheme":`Поле`,
"front-kefu-moudle-phonein":`Входящий звонок`,
"label.emailmerge.list.description":`Шаблоны почтовых слияний - это документы MicroSoft Word с полями слияний, которые ссылаются на поля CloudCC.com.`,
"vue_label_commonobjects_detail_select_first":`Пожалуйста, сначала выберите соответствующие пункты`,
"label_emailsync_form_action":`Действие`,
"label.customfieldrelation":`Пользовательские поля и отношения`,
"label.ems.other.msg":`Пожалуйста, содержимое CloudCC admin(<a href='mailto:admin@cloudcc.com' style='text-decoration: подчеркивание;'>admin@cloudcc.com</a>), запустите службу синхронизации почты.`,
"label.appointment.wizard.subtitle4-3-4":`1 h`,
"label.service.miniProgram.isOpen":`Включено`,
"equal":`равняется`,
"label.partnerCloud.financeSetting.merchantInformation":`Путь доступа: Торговая платформа  Центр счетов  Информация о торговце`,
"vue_label_calendar_displayed_field_name":`Название отображаемого поля`,
"UG_opportunity_002":`Определите ваш торговый цикл, настройте стадию`,
"label.tag.addtags.button1":`Сохранить`,
"label.explain":`Инструкции`,
"label.icon.166":`Павильон`,
"label.exchange.sync.setting.use":`Включить синхронизацию обмена`,
"label.chatter.assignPerson":`Назначенное лицо`,
"lable.PowerProcess.event.condition":`Условия вех`,
"label.addattachment.step1":`Шаг 1 Выберите файл`,
"label.account.fiscal.quarter.timeerror":`Начальная дата финансового квартала или дата окончания финансового квартала находится между историческими фискальными кварталами, пожалуйста, проверьте и перезагрузите`,
"label.URL":`URL-адрес для ссылки`,
"label.icon.134":`Данные`,
"label.forecast.customforecast.foredis.sq":`Тысячи`,
"label.custom.field.number.decimal":`Неверное количество цифр.`,
"label.version.history.track.error":`Ваша версия поддерживает только выбор <=5 полей, не может выбирать больше полей.`,
"label.log.os":`Операционная система`,
"label.partner.workspace.tab.option":`Доступные вкладки`,
"label.partnerCloud.partnerAccount.accountWater":`Отчет о фонде`,
"setup_layout_label_norelatedlist":`Нет соответствующих списков`,
"label.import.page1.nextstep":`Следующий`,
"label.emailobject.view.attached":`Электронная почта с приложениями`,
"label.SalesCommitmentKanBan.allTask":`Общая сумма задачи`,
"label.eastem.daylight.time":`восточное летнее время`,
"label.create_engaging":`Создайте привлекательный пост для связи с миром.`,
"label.area.adduser":`Добавить или удалить пользователя`,
"label.timezone.importtimezone.user":`Используйте часовой пояс пользователя для входа в систему`,
"label.passwordPolicy.setup.pwdremember1":`1 запомненный пароль`,
"label.query.detail.openpartneruser":`Активировать пользователя-партнера`,
"label.senduser":`Отправить от`,
"Pagelayout_Setup_001":`Пожалуйста, выберите соответствующие списки, которые будут отображаться на наведении курсора.`,
"label.mobile.parameter.setup":`Настройки мобильных приложений`,
"message.device.not.bound.mfa":`Несвязанные устройства MFA`,
"setup.layout.label.buttonarea":`Область кнопки`,
"chatter.email.reply.like":`Комментарии по понравившейся мне вещи`,
"label.chatter.day":`День`,
"label.sendemail.chat.addComentspraisesubject":`CloudCC CCChat ответить сообщение понравилось`,
"label.field.remark2":`страница.`,
"label.ggReleaseRange.release":`Диапазон публикации`,
"lebel.alreadyback":`Напоминается .`,
"label.appupload.install.appname":`Имя приложения`,
"label.selectnewadeckertag":`Выберите метку для нового поля иерархии`,
"label.cliententrancewebsiteadmin":`Администратор клиентского портала`,
"label.checkbox.checked":`Избранный`,
"UG.Case.03":`Автоматическое обновление корпуса`,
"vue_label_dashboard_group":`Пожалуйста, выберите группу`,
"label.import.index.preparedata":`Подготовьте данные, которые вы хотите импортировать`,
"vue_label_member_notice1":`Вы можете загружать файлы в формате JPG, GIF или PNG, максимальный размер файла - 2М.`,
"message.modify.success":`Модификация прошла успешно.`,
"label.userquotas":`Квоты`,
"label.appointmentpage.wizard.subtitle3-1":`Имя`,
"label.import.index.maxdata2":`2、Перед импортом, пожалуйста, не забудьте импортировать все записи, связанные с ним в первую очередь. Например, если есть просмотр отношения между объектом, который вы в настоящее время импортируете и контакты, пожалуйста, импортируйте эти контакты сначала, а затем импортировать ваши данные. Если вам нужно получить соответствующий идентификатор записи и другую информацию, вы можете создать отчет и установить имя записи и идентификатор записи в качестве столбца группы, а затем экспортировать отчет.`,
"label.pc.sectionpart":`секция ПК`,
"template.chart.wcldqzkh":`Необработанные лиды`,
"label.save.the.block.pricing.information.of.the.current.price.manual":`Хотите ли вы сохранить информацию о ценах блока в текущей книге цен?`,
"label.partnerCloud.financeSetting.payments":`Разрешение онлайноплаты`,
"lable.account.ThisWeek":`эта неделя`,
"label.validate.function.funcFormat.RIGHT":`RIGHT(text, num_chars)`,
"label.app.select.bgcolor":`Выберите Цвет фона`,
"label.planned.work":`Планируемые вакансии`,
"label.passwordPolicy.setup.nolimit":`Нет предела`,
"label.vlidaterule.s":`Если вы отключите используемую пользователем валюту, то валюта пользователя будет установлена в Корпоративную валюту.`,
"label.paging.totalofrecords":`Всего {0} записей`,
"label.customobjects.behaviour":`Действия`,
"vue_label_ccchat_notice_deletecommentsuccess":`Комментарий удален успешно`,
"label.lock.record.dele":`Запись заблокирована, ее нельзя удалить.`,
"label.data.expnode.e.desc3":`3、Шаблон Создать: пользователь может сделать шаблон в соответствии с полями и условиями, которые будут экспортированы для удовлетворения ваших потребностей, что удобно использовать в следующий раз.`,
"label.button.step3.create.page":`Шаг 3 Генерация страницы`,
"label.sharer":`Поделиться с`,
"label.service.cycle.type":`Тип цикла`,
"lable.SalesCommitmentKanBan.allreceivingCommitmentRate":`Итого Поступления Ставка по обязательствам`,
"label.formuladate":`Формат даты: yyyy-MM-DD hh:mm:ss или MM/DD/YYYYh:mm:ss, например: 2007-12-25 12:25:30 или 12/25/2007 12:25:30.Вы также можете использовать today() или now();`,
"front-template-V1-addImg":`Добавить картинку`,
"label.basecontrol":`Базовый доступ`,
"label.forecast.settings.lable1":`Агрегация прогнозных данных`,
"message.error.file.null":`Загружаемый файл не может быть пустым`,
"label.multiply":`*Просто`,
"message.duplication.label.targetobject":`Объект`,
"label.addattachment":`Добавить приложение`,
"vue_label_dashboard_notice_editcertification":`Вы уверены, что хотите отредактировать компонент {имя}?`,
"label.notification.tip2":`Нет новых уведомлений`,
"lable.quote.syncingfrom.firstsync":`Первоначальный Sync: Возможность цитирования`,
"label.createtasktip":`Создайте задание, которое будет ассоциироваться с одним или несколькими правилами рабочего процесса, процессами утверждения или получения прав. При изменении задачи любые изменения будут применяться ко всем правилам, процессам утверждения или получения прав, связанным с ней.`,
"label.leave":`Оставить`,
"front-invoice-online-payment-setup-china":`Применить к китайским счетам`,
"label.appointment.wizard.subtitle4-1-2":`30 мин`,
"label.projectManagement.the.person.not.be.informed":`Если выбрать Нет, ответственное лицо не будет уведомлено!`,
"label.campagin.roi.name":`Название кампании`,
"label.import.page1.newcreate":`Создать`,
"label.data.downpage.i.title.num2":`2、Перед началом импорта, убедитесь, что имя поля в файле, который вы хотите импортировать совпадает с именем поля объекта в CloudCC.`,
"label.callcenter.call.in":`Звоните`,
"label.weixin.activity.phone":`Деятельность: Звонок`,
"label.forecast.customforecast.type.role":`По ролям`,
"label.moscow.standard.time":`московское стандартное время`,
"label.profile.setcustomobjectrecordtype":`Пользовательские настройки типа записи`,
"lable.edit.queue.new":`Новая очередь`,
"label.newAPPexchange":`Новое приложение...`,
"message.custom.field.donotdelete.fieldupdate":`На это поле ссылаются при обновлении поля в другом рабочем процессе или в процессе утверждения.`,
"label.chatter.state":`Статус`,
"label.subject_line":`Тема`,
"template.report.folder.active":`Анализ кампаний и действий`,
"label.icon.114":`Дом`,
"label.assignment.setup.newentries.step3":`Шаг 3 Выберите пользователя, которому будет назначен ведущий на`,
"label.salescloud.salesdashboard.sales.behavior.rankings":`Лично-обзор поведения`,
"label.weixin.optiontwo":`Выбор 2`,
"label.sso.saml.idp.config.sp":`Поставщики услуг`,
"System_TimeField_Description":`Позволяет пользователям вводить местное время. Например, "2:40 PM", "14:40" и "14:40:00" являются действительными для данного поля.`,
"label.knowledgebase.draft":`Проект`,
"label.chat.topic.no.more.suggestions":`Никаких других предложений`,
"label.quote.product":`Продукт`,
"label.cryptographictext":`Зашифрованный текст`,
"label.custom.unlock":`Разблокировать`,
"label.assignment.setup.newentries.step2":`Шаг 2 Выберите критерии для этой записи правила`,
"label.tabularreport.selectline":`Выберите столбцы, которые вы хотите включить в отчет.`,
"label.exchange.sync.state.contact.m2":`Записи синхронизированы за последние 60 минут:`,
"label.codeType":`Тип кода`,
"saturday":`суббота`,
"label.mask.type":`Типы масок`,
"label.schedulejob.setup.schedule.Monthly":`Ежемесячно`,
"label.import.page2.totalfiled{{20}}，{{4}}notsuited":`文件中共{{20}}个字段，剩余{{20}}个未映射

{{{20}}поля в файле, {{{20} нераскрытые`,
"label.projectManagement.delete.item":`Вся связанная информация этого проекта будет удалена, если вы удалите проект, и данные не смогут быть восстановлены. Вы уверены, что хотите подтвердить удаление?`,
"label.page.general.us.and.western.europe":`Общие языки США и Западной Европы`,
"label.reportsSubscription.status":`Подписался на`,
"label.discount.baifenbi":`Скидка (%)`,
"font-evaluate-module-v1-web-page-evaluation-settings":`Настройка вебоценки`,
"message.error.searchwork":`Введенные вами ключевые слова должны содержать 2 или более символов.`,
"label.weixin.option.setting":`Настройки выбора (до 10 вариантов)`,
"label.lead.score.prompt1":`При создании или редактировании одной ведущей записи оценка производится автоматически. Но при пакетном импорте или создании по интерфейсу необходимо вручную забить несколько зацепок.`,
"label.exception.must.try.throw":`Исключение должно быть выкинуто в блоке на этаже.`,
"label.activity.plan":`План`,
"label.partnerCloud.productSet.editor":`Опция редактирования`,
"label.mobile.quickcreate.default.signinnew":`Войти в систему`,
"label.summaryreport.2018.step6.new":`Шаг 6 Выберите тип графика и выделенный элемент.`,
"vue_label_homepage_owner":`Моя домашняя страница`,
"vue_label_dashboard_editfoldersuccessfully":`Редактирование папки успешно`,
"label.quickbooks.view.overdueinvoices":`Просроченные счета`,
"label.emailtocloudcc.redmessage4":`Пожалуйста, введите данные о порте`,
"label.tabpage.equalz":`Равный`,
"lable.quote.syncing.firstsync":`Первоначальный сайт Sync: Цитата из статьи "Возможности`,
"label.download.CloudCCAPP":`Скачать приложение CloudCC`,
"label.icon.6":`Валюта`,
"label.list.serial.number":`Серийный номер`,
"label.profile.setstandardobjectrecordtype":`Настройки стандартного типа записи`,
"label.customize.memory.function.sorting.error":`Время ответа на запрос слишком велико и приводит к таймауту страницы. Это может быть связано с тем, что активирована функция Память сортировки заголовков. Пожалуйста, зайдите в личные настройки и отключите эту функцию.`,
"message.view.addtoallusers":`Видимость связанных пользователей`,
"label.globaloperation.operationtype.record.phone":`Зарегистрировать звонок`,
"lable.opppdt.selPdt.searchresult":`Результаты поиска`,
"label.import":`Импорт`,
"label.service.gantt.work.based.resources":`Ресурс на основе рабочих часов`,
"label_partner_template_detailimage":`Фотография`,
"label.cpq.product.feature.option.count":`Минимальное количество вариантов продукта не может быть больше максимального количества вариантов продукта`,
"label.chatter.newtask":`Новая задача`,
"font-trade-module-v1-invoice-total-price":`Планируемая общая сумма выплат`,
"setup_mainpage_label_welcome29":`Стандартная интеграция API со сторонними продуктами`,
"label.data.exportall.all.btn":`Экспорт всех данных`,
"front-epwechat-module-v1-unbound-WeChat":`Развязать WeCom`,
"label.salescloud.salesdashboard.performance.rankings":`Контракт купли-продажи Сумма контракта Рейтинг`,
"label.import.page1.newcreateandupdate":`Обновление и запуск нового`,
"component.chatter.post.button.file":`Добавить вложения`,
"label.partnerCloud.orderingPlatform.createOrder":`Новый порядок`,
"label.lookup.multiple.data":`Несколько найденных данных, пожалуйста, выберите вручную`,
"button.partner.save":`Сохранить`,
"label.service.add.timeslot":`Добавить тайм-слот`,
"label.campaign.matchway.select.email":`Email`,
"front-sales-button-fromQB":`Обновление от QuickBooks`,
"label.icon.108":`Стрелка`,
"lable.outlook.edit.efmapping":`Редактирование отображений полей`,
"label_tabpage_refreshz":`Обновить`,
"chatter.follow.cancel":`Прекратите следовать`,
"label.totals.sum":`Всего`,
"label.noRequest":`Нет Требования`,
"vue_label_homepage_fixedcomponent":`Пожалуйста, выберите фиксированный компонент`,
"label.knowledge.delete.case":`Ошибка при удалении статьи о деле.`,
"label.weixin..xsld.yjwc":`Ожидаемый доход`,
"label.customcomponent.page.index.console.btn":`Консоль разработчика`,
"label.sendsms.batch":`Массовые SMS-сообщения`,
"vue_label_chat_onlychosechat":`Для чата могут быть выбраны только пользователи Команды`,
"label.tabpage.page":`Страница`,
"label.cyen.note":`Включить валюту. Обратите внимание, что действие включенной валюты является необратимым.`,
"label.weixin.againsend":`Повторно отправить`,
"label.processnumber":`Шаг нет.`,
"label.emailobject.to":`За:`,
"label.event.today":`Сегодня`,
"label.dashboard.dispalyPosition":`Ласкальное положение`,
"message.error.recalculate.dupoperate":`Перерасчет, пожалуйста, не оперируйте часто.`,
"vue_label_email_linkrecordsuccess":`Успешно связанная запись`,
"label.updateoutboundnews":`Обновление исходящих сообщений`,
"label_emailtocloudcc_exists2":`Этот почтовый ящик был установлен на Email to Case. Не повторяйте настройки.`,
"label.tag.addtags.button2":`Отменить`,
"label.stdashbord.xsld.business.role":`Эта роль берется из разрешительных ролей в иерархии прогнозов.`,
"label.commonnew":`Нормальный новый`,
"label.validate.remark2":`Образец использования:`,
"label.reportsSubscriptionPage.condition.checkbox":`Добавить условия к этому отчету`,
"label.globalselect":`Глобальный список опций Набор значений`,
"label.partnerCloud.partnerAccount.available":`Доступная сумма`,
"label_tabpage_nothingz":`Ничего`,
"label.version.webtolead":`We to Lead`,
"label.projectManagement.heat.map":`Тепловая карта`,
"message.error.pleasecorrectdata":`Пожалуйста, просмотрите все следующие сообщения об ошибках для исправления данных.`,
"label.hight.tip":`Когда расширенный фильтр не включен, отношение различных условий фильтрации - "and", т.е. запись, которая удовлетворяет общим характеристикам 1 и 2.`,
"label.workflow.estimatecondition3":`Созданный или каждый раз редактируемый`,
"AssetRelationship.time.limit.error":`Дата начала должна быть раньше или равна дате наступления срока.`,
"label.multilang.workflow.dayinmonth":`Каждый {1}месяц(ы)`,
"label.reportsSubscriptionPage.schedulereport.daily":`Ежедневно`,
"label.emailtocloudcc.step1.name":`Выберите функцию`,
"label.follow_up":`Последующее письмо`,
"label.price.list.price.cannot.be.empty":`Прейскурантная цена не может быть пустой.`,
"label.chatter.link":`Ссылка`,
"label.ccpeak.condition.return.record":`Возвращает записи по условиям и поддерживает общие условия "где".`,
"pagecreator.layout.message.canntdelete":`Текущая раскладка не разрешается удалять`,
"label.compact.layout.main":`Главная информационная раскладка`,
"label.testandupdate":`Проверить наличие обновлений`,
"button_partner_cancel":`Отменить`,
"label.activity":`Деятельность`,
"label.knowledge.setting.hint.fourteen":`Приготовьтесь писать!`,
"vue_label_commonobjects_view_open_from_list":`Откройте из списка, чтобы начать`,
"front-electronic-export-intro":`2000 записей могут быть экспортированы в Mailchimp за один раз`,
"label.chosen.all":`Все поля`,
"label.file.extension":`Расширение файла`,
"vue_label_systemSettings_server_miniprogram":`Минипрограмма обслуживания`,
"label.weixin.no.pending.wdgz.qin.today":`На сегодня нет графика работы.`,
"label_tabpage_issuez":`Выпуск`,
"label.staticresource.tip":`Используйте статические ресурсы для загрузки контента, на который вы хотите ссылаться на пользовательской странице, включая .zip, изображения, таблицы стилей, JavaScript и другие файлы.`,
"label.approvalstep":`Шаги утверждения`,
"label.china.standard.time":`стандартное время Китая`,
"label.appexchange.download.tiaoguo":`Игнорировать`,
"label.callcenter.link.Amazon.connect":`Amazon Connect`,
"vue.dashboard.notRequired.notConformToTheRules":`Невозможно отправить! Необходимые пункты не заполнены или не соответствуют правилам.`,
"label.appointment.wizard.title1":`Определить наличие`,
"label.chat.remove.bookmark":`Удалить закладку`,
"label.tabpage.advancedsearch":`Расширенный поиск`,
"batch.ranf.f":`Записи о массовом перемещении не удалось`,
"label.appointment.wizard.subtitle4-1-4":`1 h`,
"label.brief.account":`Счета`,
"component.chatter.link.label.url":`Соединительный урл`,
"label_emailtocloudcc_redmessage8":`Ошибка параметров, пожалуйста, свяжитесь с администратором.`,
"label.object.create.two.number.field":`На каждый объект можно создать до 2-х пользовательских полей с автоматическим номером.`,
"label.salecommit.not.roleinformation":`У тебя нет ролей и ты не можешь просмотреть приборные панели обязательств по продажам.`,
"label.defautline.cannot.less":`Количество строк по умолчанию должно быть не менее 1.`,
"label.selectedproducts":`Количество выбранных продуктов`,
"label.productsales.today.notskadd":`В правом верхнем углу можно нажать кнопку "Добавить новое задание".`,
"lable.account.year.stadate":`Дата начала финансового года`,
"label.mobile.phone.month.plan2":`Задачи этого месяца`,
"label.ccpeakfolder":`Папки класса`,
"setup_mainpage_label_welcome21":`Облачная платформа CloudCC предоставляет пользователю функцию шаблона электронной почты, которая удобна для использования и повышения эффективности работы.`,
"label.modify.layout":`Редактирование макета`,
"report.label.folder":`Папки`,
"label.tianyancha.businessverify.rewritename":`Имя аккаунта засчитывания`,
"lable.currencyAdv.dao":`на`,
"label.mobilelayout":`Мобильная планировка`,
"label.the.current.model.is.enabled.and.cannot.be.edited.":`Текущая модель активирована и не редактируется.`,
"label_partner_all_disable":`Отключить`,
"label.ownerapproverfield":`Область утверждения владельца`,
"label.emailobject.template.message4":`Некоторые из вставленных полей в сообщении нулевые, пожалуйста, отредактируйте и повторно отправьте!`,
"label.productsales.today.notsk":`Нет задач с истекшим сроком годности.`,
"label.multilang.document.upload.success":`{0} файлы были загружены успешно и {1} файлы не удались`,
"label.manageAll.sta3":`Отклонено`,
"vue_label_calendar_week_view":`Просмотр календаря-неделя`,
"setup_layout_label_nocustompage":`Нет пользовательских страниц`,
"label.weixin.wdyj.jxdcl":`Показатель личной эффективности`,
"label.donot.update":`Вы не имеете права изменять!`,
"setup.mainpage.label.welcome14":`Управление процессом настройки рабочего процесса, утверждение`,
"UG_Campaign_002":`Планирование, выполнение и мониторинг эффективности рыночной деятельности.`,
"label.layout2":`Макет два`,
"label.app.looup":`Поиск приложений`,
"label.projectManagement.selectitem":`Пожалуйста, выберите проект`,
"label.field.relating.rule":`Правила поиска полей Assoication`,
"vue_label_commonobjects_detail_selectname":`Пожалуйста, сначала выберите имя`,
"front-email-payment-Invoice-select-pay":`Выберите "Оплатить по":`,
"label.customfields.formula.numberexample":`Фаренгейт = 1.8 * Цельсий 32`,
"component_event_label_enddate":`*Конечное время*`,
"label.partnerCloud.partnerAccount.lineOfCredit":`Кредитный лимит`,
"label.chatter.newpost":`Последний пост`,
"label.report_dashboard":`Этот отчет будет сохранен в ваших отчетах. Вы также можете добавить его в приборную панель.`,
"label.assigned":`Назначено`,
"Homepage_News_002":`Компонент новостей в настоящее время недоступен.`,
"label.approval.select.relatedobj":`Чтобы выбрать соответствующий пункт, он должен выбрать тип`,
"label.service.miniProgram.isTop":`Липкий на вершине`,
"message.error.object.datatoolang":`Длина данных слишком велика, максимальная {!длина} символов.`,
"label.importsourcetip":`Импорт предназначен для приема файлов, произведенных в процессе Экспорта. Если вы не осуществляли экспорт, пожалуйста, перейдите на страницу экспорта сейчас.`,
"label.select.deadlineplease.deadline":`Пожалуйста, выберите крайний срок.`,
"vue_label_account_equityrelationship":`Отношения долевого участия`,
"label.account.Calendar.month":`Календарный месяц`,
"label.appointment.wizard.subtitle3-4":`четверг`,
"font-evaluate-module-v1-smaller-500":`Файл должен быть менее 500 КБ`,
"label.reportsSubscriptionPage.email.tome":`Послано мне`,
"label.ccchat.person.invite.existpers":`Уже отслеживаю:`,
"label.appointment.wizard.subtitle1-3":`30 мин`,
"front-kefu-moudle-connected":`Подключено`,
"label.campaignmember.main.duplicatelist.tip":`Система найдет здесь дубликаты руководств и участников кампании в соответствии с настройками.`,
"label.visualpage.such.tags.double":`Эти теги появятся вместе`,
"label.sendsms.batch.step2.introduce":`Пожалуйста, выберите шаблон SMS.`,
"Account_News_Setting_002":`Используйте настройки учетной записи ниже, чтобы указать поведение учетной записи по умолчанию для вашей организации.`,
"message.encryptchange.alert":`Вы собираетесь преобразовать {{!fieldapi}} из поля "Зашифрованный текст" (Storage Encrypted) в поле "Зашифрованный текст" (Encrypted Text) (Display Encrypted), после успешного преобразования это поле будет храниться в базе данных в виде чистого текста, который может быть отображен в виде чистого текста или зашифрованного текста в соответствии с настройками профиля. Поля с возможностью поиска.\\r Эта операция необратима, вы хотите продолжить?`,
"label.mainpageset.description":`Настройте домашнюю страницу вашего предприятия на основе ваших реальных потребностей.<br>Компоненты в конфигурации по умолчанию, не относящиеся к вашему предприятию, могут быть отключены или отключены.<br>Включено: включенные компоненты отображаются на домашней странице всех участников.<br>Отключено: отключенные компоненты не отображаются на главной странице всех участников и не отображаются в списке "Configure My Homepage" в приложении.<br>Выключено: отключенные компоненты не отображаются на главной странице не всех участников по умолчанию, и пользователи могут включить их с помощью "Configure My Homepage" в приложении.`,
"label_tabpage_linknamez":`Имя ссылки`,
"label.companyname":`CloudCC.com Ltd. Co`,
"label.currency.current":`Текущая корпоративная валюта`,
"label.campaignmember.main.duplicatelist.html.title":`Установка удаления дубликатов путем сканирования кода`,
"label.sendsms.batch.step3.plan":`План даты доставки`,
"label.profile":`Профиль`,
"label.canceluploadfile.step":`Нажмите кнопку Отмена, чтобы отменить все файлы, отображаемые в верхней области`,
"message.newreport":`Новый отчёт`,
"label.service.newBuildDialog.date.selection":`Выберите дату`,
"label.lookup":`Посмотреть`,
"label.file.editinfo":`Редактировать информацию о файле`,
"component_assistant_label_nodata":`Никаких событий сегодня, пожалуйста, проверьте позже.`,
"label.tianyancha.businessverify.msg4":`Эта функция использует сторонние сервисы, и в настоящее время она доступна пользователям бесплатно.но CloudCC не гарантирует, что третья сторона всегда будет предоставлять сервис пользователям бесплатно. если третья сторона взимает плату, CloudCC имеет право взимать плату или запрещать пользователю использовать эту функцию.`,
"label.noequal":`!=Не равны`,
"vue_label_metric_column":`Таблица должна иметь как минимум 1 столбец оценки.`,
"label_reportType_chose_and_form":`Выберите источник данных отчета и формат отчета`,
"vue_label_pool_reasondescription":`{0} описание причины`,
"label.isusing":`Активный сайт`,
"label.passwordPolicy.setup.pwdremember5":`5 запомненных паролей`,
"label.cancel":`Отменить`,
"vue_label_helpcenter_detail1.1":`активности, и динамику каждой записи, а также складывать или разворачивать соответствующую информацию в правом верхнем углу модуля. Вы также можете просматривать и управлять данными, связанными с записью, через соответствующий список.<br> 1. Просмотр и управление одним куском данных<br>Просмотр, копирование, удаление или обмен данными с другими сотрудниками осуществляется с помощью кнопок в правом верхнем углу.<br>Просмотр подробной информации о пользователе, а также возможность прямого редактирования некоторых полей на странице для изменения владельца или типа записи.<br>Просмотр и управление данными, связанными с записью, с помощью соответствующего списка. В списке, связанном с файлом, загрузите записанный файл или нажмите на имя файла для загрузки и просмотра соответствующего файла.<br> 2. Связанные списки<br>Просто подключитесь через связанный список и используйте плавающее окно для просмотра до 10 связанных записей. Щелкните, чтобы войти в вид списка, просмотреть все связанные записи и отредактировать inline.<br>Используйте макет карты для просмотра и управления связанными записями ниже.<br> 3. Действия<br> На странице с подробной информацией о записях версия Lightning не отображает два связанных списка "необработанных действий" или "истории действий". Вместо этого отображается временная шкала работ.<br>Временная шкала работ, отображающая контент<br>Временная шкала работ может отображать все работы, которые в текущей записи будут отображаться от будущего до прошлого. Просроченные задачи и предстоящие задачи и события отображаются в модуле "Просроченные и предстоящие" на временной шкале событий. Прошлые или текущие выполненные задачи, события, записанные звонки, сообщения электронной почты и текстовые сообщения будут отображаться в соответствующем месяце.<br>.`,
"registration.page.preview":`Предварительный просмотр страницы регистрации`,
"label.quickbooks.search":`Поиск`,
"label.setup.mobile.bottombutton.tab.show":`Дисплей вкладки внизу`,
"lable.want.to.delete.tem":`Вы уверены, что хотите удалить шаблон отчета об обслуживании {currentTelmplateName}?`,
"label.multilang.fielddtrack.dealkey":`Измените {0} с {1} на {2}`,
"vue_label_pool_return":`Вернуться`,
"vue_label_calendar_failed_to_share_calendar":`Не удалось поделиться календарем`,
"label.less":`<Меньше чем>`,
"label.email.form.html":`Html`,
"label.tag.nodata":`Нет записей`,
"label.setarticlecon":`Укажите критерии ввода`,
"label.searchlayout.displayrow":`Столбцы для отображения`,
"label.change.task":`Вид задачи`,
"lable.quote.editqtpdt.title":`Цитата строки Пункты Правка`,
"label.appointment.wizard.subtitle4-4":`Как далеко в будущем кто-нибудь сможет тебя забронировать?`,
"label.custom.page.button.css":`Кнопка CSS`,
"label.input.documentmessage":`Введите данные`,
"vue_label_commonobjects_detail_email_address":`Адрес получателя`,
"label.chatter.filterTimeLine":`Временная линия фильтрации`,
"label.must.select.twoorthree.records":`Вы должны выбрать две или три записи для объединения`,
"label.mobile.setup":`Настройка мобильных приложений`,
"vue_label_commonobjects_detail_key_field":`Ключевые области`,
"label.chatter.relateitem":`Связанный с`,
"label.customobjects.tip":`После создания пользовательского объекта можно создать пользовательскую вкладку, пользовательские связанные списки, отчеты и инструментальные панели для взаимодействия пользователей с данными пользовательского объекта. Вы также можете получить доступ к данным пользовательского объекта через API.`,
"label.sso.saml.idp.config":`Идентификатор поставщика`,
"label.knowledgebase.affect.article.version":`Затронет ли модификация существующий перевод? Если да, то можно пометить ценный перевод как "Просроченный" и сформировать список отложенных переводов для поставщиков переводов.`,
"message.error.record":`Соответствующая запись не найдена!`,
"message.duplication.label.fieldname":`Поле`,
"setup.layout.button.cancel":`Отменить`,
"label_radar_map_function":`Используйте радарные диаграммы с несколькими показателями для оценки роли контактов в цепочке принятия решений о продажах.`,
"label.campagin.roi.fss":`Отправленный номер`,
"label.emailobject.template.giveup":`Отменить`,
"label.apiname.exists":`Имя API уже существует.`,
"message.failtoreaddata":`Не удалось прочитать данные`,
"label.file.versionedit":`Модификатор содержания`,
"template.report.lost.business.opportunity":`Упущенные возможности`,
"label.ccchat.group.allowgd":`Разрешить группам архивировать`,
"label.fieldaccesslimit":`Доступность на местах`,
"label_target_model":`Целевая модель`,
"message.validation.isnoturl":`Недействительный URL-адрес`,
"servicecrew.member.time.conflict":`В течение этого периода времени сервисные ресурсы стали членами других сервисных команд.`,
"label.knowledgebase.delete.details":`Это приведет к удалению информации о назначении.`,
"vue_label_normal_bottom":`Нижний`,
"label.custombutton.editerror":`Редактирование не удалось`,
"label.dashboardSetup.showdw.d6":`Автоматический`,
"message.error.field.decimalPlaces":`Ошибка десятичного формата ввода.`,
"label.tabpage.busoppnamez":`Название бизнес-возможности`,
"label.insertfield.intro":`Пожалуйста, выберите поле и нажмите "Вставить". Для просмотра более доступных полей нажмите на ">".`,
"setup.layout.label.nocustompage":`Нет пользовательских страниц`,
"front-gantt-module-project-has-only":`Этот проект имеет только {n} этапов`,
"label.weixin.fmu.am":`{0}АМ`,
"label.emailsync.status.connectaccounts":`Подключенный аккаунт электронной почты`,
"label.customcomponent.check.name.same":`Это имя уже существует.`,
"label.validate.function.funcFormat.HOUR":`ЧАС(дата)`,
"label.approvepagelayout4":`Скопировать макет предыдущей страницы`,
"label.knowledge.category.hint.nine":`Активировать группу категорий`,
"label.report.sorting.column":`Сортировка по колонкам`,
"label.hours":`Часы`,
"label.email.clearAllemail":`Вы хотите очистить все синхронизированные письма в почтовом ящике?`,
"font-evaluate-module-v1-satisfaction":`Удовлетворительная оценка`,
"label.service.hide.more.info":`Скрыть Подробнее`,
"label.area.list.intro":`На этой странице можно редактировать информацию о территории.`,
"label.sendemail.chat.addPostat":`Дорогой #name:\n\n hello! #userName упомянул тебя в микропосте.`,
"label.data.newtemplate.e_seltype.desc":`Существует два типа производных данных</li><li class="titleledesc1">1.one - CSV формат(по умолчанию)</li><li class="titleledesc1">2.other - формат сжатия. Режим формата сжатия разделен на два вида</li><li class="titledesc1">2.1.one.one - автоматическая генерация пароля к сжатым файлам, автоматически сгенерированный пароль будет отправлен пользователю после успешного экспорта данных в почтовый ящик</li><li class="titledesc1">2.2.other - ручной ввод пароля к сжатым файлам, пароль для ручного ввода не будет отправлен на почтовый ящик пользователя, так что пользователям необходимо запомнить пароль, если вы не вводите, по умолчанию пароль не будет.`,
"message.passwordPolicy.validate.minlengths":`Ошибка:Ваш пароль должен быть как минимум`,
"message.save":`Ты уверен, что хочешь спасти?`,
"label.marketsea.notfollowdays1":`После получения`,
"label.app.step1":`Шаг 1 Выберите тип`,
"message.error.pageid.null":`ID социальной сети Facebook не может быть пустым!`,
"label.weixin.input.lookupfield":`Введите ключевые слова для поиска подходящего микро-голосования`,
"label.whChatAccount":`Счет WeChat`,
"label.tabpage.groupingitem":`Пункт группировки`,
"label.callboard.introduce":`Все объявления вашей компании перечислены ниже.`,
"label.financial.services.seminar":`Семинар по финансовому планированию`,
"label.data.file.i_title.num1":`1. Импортируемый файл должен быть в формате CSV. Файл должен содержать заголовок и не может быть импортирован без заголовка.`,
"label.visualpage.filename.exist":`Имя файла уже существует.`,
"front-kefu-moudle-v1-new-chats":`Новый агент`,
"label.console.step5.tab":`открытый таблетка`,
"vue_label_opportunity_contactrole_edit":`Редактировать контактные роли`,
"label.projectManagement.delete.return":`После удаления последних данных он вернется на предыдущую страницу.`,
"registration.page.designs":`Настройка внешнего вида страницы регистрации`,
"label.console.step6.heigth":`Heigth`,
"label.objectRelationshipAtLeast":`иметь одну запись, по крайней мере, имеющую отношение к`,
"label.knowledge.delete.viewstat":`Ошибка при удалении данных просмотра статьи знаний`,
"label.direct.dashboard.month.report":`Новая ежемесячная рабочая записка`,
"label_tabpage_lookatmorez":`См. подробнее`,
"label.setup.rights.management":`Управление правами доступа`,
"label.campaign.channel.clear.img":`Четкое изображение`,
"label.calendar":`Календарь`,
"label.biaoqingfaxian.username":`аккаунт`,
"label.weixin.wdyj.jxht":`Персональные - Контракты Выполнения-Продаж`,
"label.emailtocloudcc.exists1":`Этот почтовый ящик был установлен на Email to Lead. Не повторяйте настройки.`,
"label.emailtocloudcc.filed.password":`Пароль`,
"label.what_create":`Какую форму вы хотите создать?`,
"vue_label_report_onlydisplaypart":`До 50 шт. данных. Все данные отображаются после выполнения.`,
"label.up":`Up`,
"label.addattachment.edit":`Редактирование приложений`,
"label.ccchat.message.search.desc5":`Поисковые слова не могут быть менее 2-х символов`,
"label.chose.nonotice":`Пожалуйста, выберите запись, которая больше не напоминает вам.`,
"UG_activity_06":`Хотите проследить за счетами`,
"label.set_contactsmarketing":`Установить в качестве контакта кампании`,
"pagecreator.layout.button.horizontal":`Боковая разборка`,
"label.brief.opportunity2":`Ожидаемые возможности закрытия`,
"label.ems.nomsg":`Не установка`,
"label.fieldupdate.tip":`Обновление полей позволяет автоматически изменять значение поля на указанное вами. Обновление полей - это действия, связанные с правилами рабочего процесса и процессами утверждения.`,
"label.sso.saml.sp.federationid":`Идентификатор федерации`,
"label.import.page2.suited":`Mapped`,
"message.error.appexchange.integrity":`Обеспечьте целостность компонентов в пакете закачки.`,
"label.fielddatatype":`Тип данных поля`,
"message.approval.cannotsubmit.detail2":`Запись должна отвечать следующим критериям или формула дает истинную оценку, в противном случае заявка на официальное утверждение не может быть подана, просьба представить ее повторно после внесения изменений.`,
"vue_label_commonobjects_detail_cloud_as_a_user":``,
"label.summaryreport.selectlinetogroup":`Выберите столбец, на котором основана группировка отчетов`,
"label.tabpage.norecordtypez":`Неиспользуемый тип записи`,
"label.icon.141":`Валюта`,
"label.addattachment.step3.intruduce":`Если вы загружаете, это отменяет текущую загрузку.`,
"label.trigger.recursive.call.three":`Триггеры можно назвать интерактивными, количество циклов ограничено до 3-х раз, если более 3-х раз в системе появится сообщение об ошибке.`,
"maintenanceplan.workorder.type.asset.workorder":`Пожалуйста, выберите "Одно рабочее поручение для каждого актива" в качестве типа рабочего поручения.`,
"label.emailtocloudcc.select1":`Пожалуйста, выберите`,
"label.system.log":`Журнал аудита конфигурации`,
"vue_homepage_dashboard_not_support_fullscreen":`Извините, ваш просмотр не поддерживает полноэкранный режим.`,
"label.projectManagement.nodata.resource":`Пока не участвует ни в одном проекте. Добавьте информацию о проекте 'My' для членов команды, чтобы просматривать распределение времени членов команды.`,
"label.exchange.sync.state.contact":`Контакты`,
"label.field.type":`Тип поля`,
"label.selected.object":`Выбранный объект`,
"label.customfields.new.step2":`Шаг 2 Введите детали`,
"label.monitorsys.delete.style":`Типы операций`,
"label.projectcondition":`Критерии поступления`,
"potential.customers.field.default":`Настройка выводов по умолчанию`,
"message.password.nosame":`Пароли не совпадают.`,
"label.validate.function.funcExplain.MONTH":`Возвращает месяц, который является числом между 1 (январь) и 12 (декабрь).`,
"label.project.user.project.count":`Количество проектов, в которых участвовали пользователи`,
"chatter.to":`на`,
"vue_label_commonobjects_detail_activity_owntask":`собственная задача`,
"label.generate.mobile.page":`Мобильная страница завершена.`,
"label.escalation.setup.newentries.step1":`Шаг 1 Установите порядок, в котором эта запись правила будет обрабатываться`,
"label.email_footer":`Нижний колонтитул электронной почты`,
"label_partner_workspace_member_profile":`Доступные профили`,
"label.loginhis.between":`Начальная дата дата окончания расстояния не может превышать 2 месяцев`,
"label.user.verficationcode.error":`Неверный проверочный код.`,
"label.email_notifications":`Отправить уведомление по электронной почте о подаче заявки`,
"APPIntegration_Dropbox_01":`Выберите файлы из Dropbox`,
"label.projectManagement.Selectweek":`Выберите неделю`,
"wednesday":`среда`,
"message.atleastonereceiver":`Пожалуйста, выберите хотя бы одного получателя`,
"label.applt.link.text":`Мы связали вашу компанию с минипрограммой портала. Скопируйте адрес портала минипрограммы, посвященной вашей компании, поместите адрес минипрограммы в ссылку перехода к меню официального аккаунта вашей компании, после чего клиенты смогут щелкнуть по меню для использования минипрограммы. (Пользовательское меню официального аккаунта < Переход к минипрограмме < Путь к минипрограмме)`,
"label.wait.for.a.moment":`Пожалуйста, подождите некоторое время для установки языка...`,
"vue_label_chatter_only_group_members_look":`Только члены группы имеют доступ к просмотру, вы можете попробовать подать заявку на вступление в группу`,
"label.knowledgebase.last.release":`Последняя публикация`,
"component.setup.label.pagesize":`Элементы на странице`,
"label.paging.totalofpages":`Всего {0} страниц`,
"label.globaloperation.successmessage":`Послание об успехе`,
"label.logout":`Выход из системы`,
"label.partner.common.enable":`Включить облако партнера`,
"label.permission.objectpermission.goback":`Назад к списку: Наборы разрешений`,
"label.approvalstep5.required":`Требуется`,
"component_chatter_label_to":`На`,
"message.please.choose.role":`Пожалуйста, выберите роль`,
"maintenanceasset.servicecontract.contractlineitem.illegal":`Вы должны выбрать строку договора под контрактом на обслуживание, связанным с планом обслуживания.`,
"label.projectManagement.Resource.usage.view":`Просмотр использования ресурсов`,
"label.smsmainbody":`Текст сообщения`,
"label.ccchat.error.nullname":`Требуется имя`,
"label.appupload.upload.version":`Номер версии`,
"label.data.setok.t_desc2":`Назад к странице шаблона данных`,
"vue_label_pool_allocationstatus":`Статус распределения`,
"label.tianyancha.orgapprovedinstitute":`Org утверждённый институт`,
"label.quickbooks.searchlist.startdate":`Дата начала`,
"label.setapp":`Настройки приложения`,
"chatter.about":`Обо мне`,
"label.layoutname":`Имя макета страницы`,
"label.icon.160":`Земля`,
"label.tabpage.Rolesz":`Роли и подчинённые`,
"label.console.step5.introduce":`Выберите, как отображать`,
"label.customfields.totalsummary.gettogetherfield":`Поле для агрегации`,
"message.appexchange.addtopackage.profile":`В пакете может быть добавлен только один компонент профиля!`,
"vue_label_file_user_header_pic":`Аватар`,
"font-trade-module-v1-invoice-detail-price":`Подробные платежи`,
"homepage.components.three":`Шаг 3 Введите содержимое дисплея пользовательских компонентов`,
"nine":`Девять`,
"label.marketsea.button.restore":`Восстановление`,
"label.forecast.editshrepage.desc2":`Индивидуальный общий доступ может использоваться только для предоставления более широкого доступа к данным, а не для ограничения доступа.`,
"label.cloudccsite.list":`Сайты`,
"label.icon.35":`Облако`,
"vue_label_pricebook_price":`Добавить стандартную цену`,
"label.version.sum.addressfield":`адресное поле (поля)`,
"label.projectManagement.Gotomilestone":`Повернитесь к вехе`,
"label.dataimport.name.length":`Ошибка: длина имени слишком длинная.`,
"label_alculation_method":`метод какуляции`,
"label.uploadfile":`Загрузить файл`,
"label.ems.otheraccount":`Другой счёт`,
"vue_label_commonobjects_detail_group_opportunitystrategy":`Ты уверен, что присоединишься к этой команде`,
"message.error.chatter.img.nodata":`Ошибка: файл изображения не существует и не может быть захвачен.`,
"component.chatter.file.button.files":`Выберите документ`,
"label.salescloud.teamrole.optionlist.choose.null":`Требуется название роли`,
"label.yourexportsuc":`Ваш запрос на экспорт был обработан, пожалуйста, просмотрите вашу электронную почту.`,
"pagecreator_systemstyle_label_modifycolor":`Редактировать цвет`,
"label_partner_setup_title":`Настройки`,
"label.chat.topic.topic":`Тема`,
"file.error.nottype":`Ошибка: неправильный тип. типы файлов, которые могут быть загружены: txt, doc, excel, ppt, pdf, jpg, jpeg!`,
"label.all_time":`Все времена`,
"homepage_componet_approval_label":`Пункты для утверждения`,
"label.partnerCloud.financeSetting.merchantNumber":`WeChat Pay Merchant No.`,
"label.user.resetpw":`Сброс пароля`,
"label.exchange.sync1":`После настройки учетной записи службы с разрешениями на олицетворение для пользователей в Microsoft©Exchange, введите учетные данные учетной записи службы, чтобы CloudCC мог общаться с сервером Exchange.`,
"label.import.index.editfield":`Редактирование карты полей`,
"and":`И`,
"label.partnerCloud.cloudInfrastructure":`Базовая настройка Partner Cloud`,
"label.escalation.setup.newentries.createdate":`При создании дела`,
"Pagelayout.Setup.002":`Вы выбрали 3 связанных списка, и добавление дополнительных связанных списков повлияет на макет страницы.`,
"label.customfields.file.tip":`Разрешить пользователю загружать файлы от 1 до N.`,
"label.tianyancha.businessverify.accname":`Запрос на имя клиента в режиме реального времени`,
"label.Additional.Conditions":`Запись на сервисное обслуживание фильтра в соответствии с дополнительными условиями.`,
"label.emailtocloudcc.filed.type":`Поставщик`,
"vue_label_homepage_fixedcomponents":`Стандартный компонент`,
"label.visualpage.delerror":`Удалить не удалось, пожалуйста, попробуйте позже.`,
"label.tabpage.filetypez":`Тип файла`,
"label.emailobject.search.input":`Поиск`,
"label.createprocessstep2":`Шаг 2 Укажите критерии ввода`,
"label.weixin.inhead":`Обработка`,
"component.recdetail.label.title":`Подробная информация`,
"label.weixin.telephone":`Номер телефона`,
"label.web.link":`Веб-ссылка`,
"label.partnerCloud.paySuccess":`Оплачено успешно`,
"label.case.adress.link":`Портал обслуживания клиентов`,
"label.emailobject.view.connectopp":`Электронные письма, связанные с открытыми возможностями`,
"front-kefu-moudle-think-again":`Позвольте мне подумать еще раз`,
"label.Button":`Кнопка`,
"chatter.pt.most":`Максимальный размер файла 20 Мб.`,
"label.service.newBuildDialog.numberdays.horizontal":`Дни до даты уровня`,
"label.ems.relatedobj":`Связанный объект`,
"label.notification.insert.approval":`[提交人] представляет [对象] на ваше одобрение`,
"label.setting.codeSet":`Набор кодов`,
"vue_label_report_rowlevelformula":`Формула уровня рядов`,
"label.validate.function.funcFormat.TIMENOW":`TIMENOW()`,
"label.copyright":`Авторское право© 2008-2022 CloudCC Inc. Все права защищены.`,
"component.setup.button.save":`Сохранить`,
"label.emailsync.button.sure":`Подтвердить`,
"label.multilang.dupicatecheck.getdatalist":`{0}-я группа дублированных данных, имеет в сумме {1}записи:`,
"label.ccchat.person.invite.tochat":`Приглашайте людей в CCChat`,
"label_partner_all_maxNum":`Максимальные данные облака партнера:`,
"label.checkfield":`Настройки полей для поиска дубликатов`,
"label.sales.dashboard.income":`Цель в области доходов`,
"label.setup":`Настройка`,
"label.dashboardSetup.center":`Middle`,
"lable.quote.syncing.finished":`Синхронизация Completed`,
"vue_label_helpcenter_dashboard1":`Чтобы помочь вам отображать статистические данные более интуитивно, приборная панель CloudCC Sales Cloud Lightning предоставляет вам мощные возможности построения диаграмм.<br> Приборная панель CloudCC Sales Cloud Lightning версии имеет следующие характеристики<br>Возможность использования различных источников данных: вы можете выбрать исходные данные в представлении под объектом в качестве источника данных, или вы можете выбрать данные после обработки отчета в качестве источника данных<br>Целых 13 видов шаблонов диаграмм для вас на выбор: воронка поддержки продаж, указатель метра, круговая диаграмма, вторичная сгруппированная гистограмма и т.д. <br> Свободное перетаскивание для изменения размера и положения графика: приборная панель может различать важные данные и вспомогательные данные, размещая позицию и размер различных графиков, которые полностью зависят от вас<br> Приборная панель поддерживает фильтрацию встроенных данных графика с полями фильтрации, установленными по временному интервалу и пользователю<br>Кэширование данных: данные графика Dashboard могут быть кэшированы при первом создании, что сокращает время вторичной загрузки. <br>проникновение компонентов: Вы можете перейти к соответствующим деталям отчета или списку записей в соответствующем представлении объекта, нажав на компонент<br>Component linkage: В той же панели инструментов компонент может настраивать другие компоненты того же источника данных для взаимодействия с самим собой. Нажав на область данных в компоненте, можно настроить другие компоненты для повторного подсчета данных в соответствии с условиями фильтрации этой области данных<br> 1. Создать новую приборную панель<br> Вы можете, как торговый представитель или менеджер отдела продаж, отобразить данные о продажах, сделав приборные панели. Lightning версия CloudCC Sales Cloud предоставляет богатые возможности для создания приборных панелей<br>Заметка: данные Lightning версии приборной панели и старой версии приборной панели не являются взаимозаменяемыми. <br> Перейдите на вкладку "Приборная панель", нажмите "Новая приборная панель", введите имя приборной панели и выберите папку, в которую хотите сохранить эту панель. Вы можете ввести новую панель.`,
"label.layout.availabletab.trackrecord":`Отслеживание записей`,
"label.campaignmember.main.deletecontact":`Удалить контакты с членами-сотрудниками`,
"lable.outlook.mcto.emaltoc":`При отправке сообщений на CloudCC.com`,
"label.setup.mobile.offlinecache.savesuccess":`Настройки автономного кэша были успешно сохранены.`,
"label.timezone.default":`Часовой пояс по умолчанию`,
"label.noRules.have.been.enabled":`Нет включенных правил.`,
"label.ccchat.person.invite.existsend":`Некоторые из введенных вами адресов электронной почты совпадают с существующими пользователями.`,
"label.work":`Работа`,
"actualstarttime.actualendtime.time.illegal":`Фактическое время начала приема на обслуживание должно быть меньше или равно фактическому времени окончания.`,
"lable.product.stsp":`Стандартная цена установки`,
"vue_label_normal_account_sf":`аккаунт`,
"label.finishpic":`Генерируемые диаграммы`,
"label.h5.similar.opportunity.step3":`Шаг 3 Выбор полей для отображения аналогичных возможностей`,
"label.relateobjDefault":`Запись по умолчанию`,
"label.customcomponent.check.tag.endwith":`Компонент должен заканчиваться этикеткой`,
"label.related.organization":`Сопутствующая возможность`,
"label.recordtype.edit.selectvalue.orderby":`Сортировка стоимости списка опций`,
"vue_label_homepage_enter_name":`Пожалуйста, введите имя`,
"label.permission.group":`Разрешительные группы`,
"label.emailobject.send":`Отправить`,
"label.ralateuser":`Связанные пользователи`,
"label.validate.function.funcFormat.ADDMONTHS":`ДОБАВЛЕНИЕ (дата, номер)`,
"label.tablayoutedit.remark2":`Выберите поля, отображаемые на главной странице вкладки.`,
"setup_mainpage_label_welcome3":`Создание форм в облачной платформе CloudCC опирается на пользовательские базы данных (объекты), определяемые пользователем объекты - это таблицы баз данных, в которых хранятся данные, специфичные для вашей организации. Связи между таблицами могут быть легко установлены без разработки каких-либо программ.`,
"label.user.notallowed.login.scope":`Вам не разрешается входить в систему в течение установленного времени или ваш IP-адрес ограничен.`,
"label.tel.ten.case":`Вы можете ввести до 10 телефонных номеров для получения уведомлений, каждый номер разделен на ",".`,
"front-kefu-moudle-v1-user-info":`Информация о пользователе`,
"label.aboutme":`Обо мне`,
"label.setfieldediting.tip":`Когда вы определяете шаги утверждения, вы можете назначать запросы на утверждение различным пользователям. Одним из вариантов является использование пользовательского поля для автоматической маршрутизации этих запросов. Если вы хотите использовать эту опцию для любого из этапов утверждения, выберите поле в списке ниже. Кроме того, когда запись находится в процессе утверждения, она всегда будет заблокирована - только администратор сможет ее отредактировать. Тем не менее, вы можете также разрешить редактировать запись назначенному в данный момент уполномоченному лицу.`,
"label.existing_dashboard":`Добавить к существующей приборной панели`,
"label.sendemail.spotsign":`Дорогой #имя: участник кампании #клиент, которого вы пригласили на #активность прибыл и зарегистрировался, пожалуйста, обратите внимание на это.`,
"UG_solution_01":`Обеспечить решение`,
"label.tianyancha.estiblishtime":`время года`,
"label.pc.lightningpage":`Легкое приложение (бета-версия)`,
"label.saveAndSync":`Сохранить и синхронизировать`,
"label.state.end":`Заполнено`,
"label.sendemail.queue.assigninfo":`Очереди:[#queueName] назначил #objectName: #recordName`,
"label.approvalprocessname":`Наименование процесса утверждения`,
"label.view.conditions.message":`Отфильтрованный по {!условиям}`,
"label.partnerCloud.financeSetting.alipayCorporate":`Бизнессчет Alipay`,
"label.forecast.detailforecast.de":`s`,
"label.savepayset.failure.nopay":`Пожалуйста, настройте хотя бы один счет для оплаты через Интернет`,
"label.step1.total6":`Шаг 1 из 6`,
"label.appointment.wizard.subtitle4-1-3":`45 мин`,
"label.emailobject.markasread":`Отметить как прочитанное`,
"message.error.orgid.null":`orgid не может быть нулевым!`,
"label.emailtemplate.mergefield":`Значение поля слияния`,
"label.weixin.recent.list":`Недавно просмотренные списки`,
"label.emailsync.form.email":`Email`,
"label.funnel":`Воронка`,
"label.logintime.clear":`Чистое время`,
"label.chatter.followed":`Следующий сайт`,
"label.ccpeak.function.field.spack":`Поля в функции должны иметь сапсы с обеих сторон.`,
"label.setup.mobile.offlinecache.remark":`После включения этой функции, члены организации могут создавать, редактировать и удалять записи в автономном режиме с мобильных устройств`,
"label.product.function":`Категории пакетов`,
"label.icon.14":`Hammer`,
"message.report.nodata":`Данные не были возвращены.`,
"label.please.ChooseMin":`Пожалуйста, выберите не менее {а} вариантов продукции`,
"label.tabpage.releaseTourz":`Опубликовать руководство`,
"vue_label_chat_opportunity":`Команда opportunityity Team`,
"vue_label_chatter_refucecertification":`Вы уверены, что откажетесь от "{имя}", чтобы присоединиться к командному чату?`,
"label.version.unlimited":`Безлимитный`,
"label.processsetting.enable.prompt":`После включения путь к настройкам будет находиться на странице подробностей, соответствующей версии молнии. Вы также можете сначала сохранить настройки и включить их позже.`,
"label.page.display.property":`Свойства отображения`,
"label.service.appointmentList.thisOption":`Не проверено`,
"label.register.date":`Дата регистрации`,
"label.brief.contract.amount":`Сумма контракта`,
"setup.object.field.dependency.label.actionfieldnotnull":`Пожалуйста, сначала выберите контрольное поле.`,
"UG_homepage_009":`Access CRM`,
"label.icon.98":`Папка`,
"label.weixin.datacount":`Всего`,
"label.mobile.hasbind":`Этот номер мобильного телефона уже использовался. Последняя привязка будет освобождена, если вы продолжите привязку.`,
"label.emailtemplate.choosemorecontacts":`Выберите больше получателей`,
"setup_layout_button_deleteitem":`Удалить выбранные пункты`,
"vue_label_account_collection_plan":`Необработанный план сбора`,
"label_chatter_maturiyDate":`Дата истечения`,
"label.emailtocloudcc.license":`Лицензия`,
"vue_label_checkduplicate_complete_check_rules":`Пожалуйста, заполните правила проверки дубликатов`,
"chatter.up.type":`Вы можете загрузить jpg, gif или png файл.`,
"label.attendance.nocheckout":`Not Check-Out`,
"label.setup.mobile.offlinecache.remark2":`Выбранные вкладки будут включены на мобильных устройствах всех пользователей в вашей организации в качестве вкладок автономного кэша по умолчанию.каждый пользователь может отключить вкладки автономного кэша в настройках организации, или включить другие вкладки в качестве вкладок автономного кэша в зависимости от своих потребностей.`,
"template.report.count.marketing.activities":`Общая кампания`,
"label.multilingual.tip4":`Если многоязычность отключена, язык компании по умолчанию будет установлен на китайский или английский в зависимости от адреса компании, а язык всех пользователей будет установлен на язык компании по умолчанию.`,
"label.settings_area":`Область настроек`,
"label_assessment_content":`Содержание оценки`,
"label.top":`Топ`,
"UG.Account.06":`Создать аккаунт`,
"label.emailtocloudcc.step1.case2":`После настройки почта, полученная в этом почтовом ящике, будет автоматически регистрироваться в CloudCC как случайные записи. В соответствии с исходящим ящиком совпадают контакт и учетная запись, относите дело к соответствующему контакту и учетной записи, чтобы облегчить принятие и отслеживание дел.`,
"label.forecast.forehistory.best.remark":`Примечания к лучшему случаю`,
"label.project.problem.date":`Дата выпуска должна находиться в диапазоне дат вехи или проекта, к которому она относится.`,
"label.forecast.customforecast.foredis.wzs":`Полные номера`,
"message.setup.field.name.value.notexists":`Значения в списке ролей команды, которые вы ввели, не существуют, пожалуйста, войдите заново.`,
"label.salescloud.teamrole.opportunity.organization":`Члены команды могут иметь больший доступ к этой возможности, чем настройки доступа к возможности по умолчанию в вашей организации.`,
"label.sms.message.input":`Пожалуйста, введите сообщение`,
"label.document.type.not.allow":`Этот тип документа не может быть загружен!`,
"label.customfields.totalsummary.tip":`Поле только для чтения, которое отображает сумму, минимальное или максимальное значение поля в соответствующем списке или количество записей всех записей, перечисленных в соответствующем списке.`,
"label.tabpage.filesizez":`Размер файла`,
"label.import.page2.filedname":`Имя файла`,
"label.same.analyze":`Мой аналогичный анализ возможностей`,
"label.service.gantt.refreshData":`Обновление данных после обновления страницы.`,
"label.sendsms.batch.step2.sendbycontext":`Отправка по пользовательскому SMS-контенту`,
"UG_Account_05":`Структурная схема контактов`,
"label_emailtocloudcc_step1total3":`Шаг 1 из 3`,
"label.weixin.no.history":`Исторических записей нет`,
"label.datamanage.queryfield.error":`Ошибка поля запроса.`,
"label.emailmerge.mergeFolder.emailmerge":`Шаблоны для объединения писем`,
"label.workflow.estimatecondition":`Критерии оценки`,
"label.autonumberfield.wrong":`Пожалуйста, введите номер от 0-{0}`,
"label.data.setok.t.desc1":`Если вам необходимо использовать этот шаблон производных данных, пожалуйста, нажмите кнопку`,
"label.data.downpage.i.title":`Шаги импорта данных:`,
"label.data.downpage.i_list.desc2":`После импорта данных вы получите электронное письмо с напоминанием об успешном импорте.`,
"label.opportunity.jieduan":`Текущая стадия`,
"vue_label_commonobjects_view_sumby":`Суммарный метод`,
"label.knowledge.setting.hint.three":`Мы можем подготовить вас к работе. Вот что вам нужно для настройки:`,
"page.activity.history":`История деятельности`,
"label.cancelQuoteLineGroup":`Отменить группу котировочных линий`,
"label.addattachment.batch.step3":`Шаг 3 нажмите кнопку для завершения.`,
"label.chat.topic.follow":`Следите за`,
"label.import.page1.uploadcsvfiled":`Перетащите или нажмите, чтобы загрузить CSV-файл`,
"label.batchtransfer.datetype.tip":`Для полей даты введите значение в следующем формате:`,
"vue_label_systemSettings_application_util":`Консоль управления приложениями`,
"label.partner.workspace.member.selectedpermission":`Выбранный набор разрешений`,
"label.service.appointmentList.plansToEnd":`Конечный план`,
"label.industrialandcommercialverification.contactinformation":`Звоните по телефону или задавайте вопросы 400-642-2008`,
"chatter.del.p":`Удалить эту должность`,
"label.forecast.customforecast.replacefirst":`Переопределенный мной`,
"Lead.Scoring.Setting.Rule.Setup.RuleName":`Имя правила выставления очков`,
"label.weixin.appr.applicant":`Представлено`,
"component_event_label_calendar":`Просмотреть календарь`,
"step":`Шаг`,
"label.attendance.setting.position.alert":`Офисный работник должен установить местонахождение достопримечательности.`,
"label.end":`Заполнено`,
"label.mobile.change.owner.success":`сменившийся на нового владельца`,
"label.chinese":`китайский язык`,
"label.textmessage.vonage.account":`Информация об аккаунте`,
"front-console-no-related-contact":`Пожалуйста, сначала свяжитесь с контактом`,
"label.dashboardSetup.seltype":`Тип дополнительного компонента`,
"chatter.follow.user":`Следуйте за этим пользователем`,
"label.textmessage.sentsuccess":`Отправлено успешно`,
"label.australian.gentral.standard.time":`Австралийское центральное летнее время （South Australia）`,
"label.validate.function.funcFormat.AND":`И (логика1,логика2,...)`,
"lable.SalesCommitmentKanBan.contract":`Подписанный`,
"label.processsetting.basic.settings":`Базовая настройка`,
"label.escalation.setup.newentries.ifcondtions":`Запустите это правило, если`,
"label.lookup.nofound.data":`Значение не существует или не соответствует фильтру.`,
"vue_label_commonobjects_view_chart_chartname":`Название диаграммы`,
"label.dashboard.show.percent":`Показать %`,
"label.sso.saml.sp.userid":`идентификатор пользователя`,
"label_tabpage_minutesagoz":`минут`,
"vue_label_chatter_comment_content":`Пожалуйста, введите содержание комментариев`,
"label.campaign.channel.step6.mobilepc":`Создать страницу Мобильный и ПК`,
"vue_label_homepage_editprofilepage":`Имя редактора`,
"label.tabpage.crecordtypez":`Изменить тип записи`,
"label.social.posts.type.null":`Тип поста не может быть пустым`,
"label.projectManagement.groupbyuser":`Группировка по пользователям`,
"vue_label_email_new_template":`Сохранить как новый шаблон`,
"label.ems.close":`Отменить`,
"label.ccdocument.noauthority.folder":`У вас нет разрешения на работу с этой папкой.`,
"message.filterconditionerror":`<strong>Ошибка: </strong> Ваш фильтр неправильно указал условия фильтрации:`,
"label.User.Interface":`Пользовательский интерфейс`,
"label_tabpage_greaterz":`Больше чем`,
"vue_label_CCChat_unfollow":`Unfollow`,
"label.selectandcontinue":`Выберите и продолжайте`,
"vue_label_commonobjects_detail_influence":`Влияние`,
"label.total.have.priority":`предшествующий`,
"label.manageAll.sta4":`Вспомнить`,
"label.setup.mobile.offlinecache.setup":`Настройки кэш-памяти офлайн для мобильных устройств`,
"vue_label_chatter_cancel_adding":`Отменить`,
"vue_label_lead_select_existing":`Выберите существующий`,
"front-epwechat-module-v1-contacts-sync":`Синхронизация контактов WeCom`,
"label.appupload.component.type.recordtype":`Типы записей`,
"label.layout.hint":`Эта страница недоступна для предварительного просмотра. Пожалуйста, сохраните и просмотрите на переднем плане страницы.`,
"label.change":`Изменить`,
"setup_layout_label_detailpage":`Подробная информация Страница`,
"label.imgfield.use.tip":`img(docid,width,height), эта функция используется для вывода изображений, "docid" - идентификатор документа, "width" - ширина изображения (Целочисленный тип может быть нулем), "height" - высота изображения (Целочисленный тип может быть нулем).`,
"pagecreator.systemstyle.button.edit":`Стиль редактирования`,
"label.delete_externalpage":`' ', которую вы хотите удалить, не может быть отозвана, пожалуйста, подтвердите еще раз. Форма не используется ни на одной странице входа в систему, но может использоваться в других местах. Например, вы могли использовать код вставки, чтобы вставить ее на внешнюю страницу.`,
"font-evaluate-module-v1-open-case":`Возобновить дело:`,
"label_not_adjust":`Без настройки`,
"vue_label_title_ordernow":`Подписаться сейчас`,
"label.notification.serviceappointment.allocation":`Вам был отправлен новый рабочий заказ {0}, пожалуйста, проверьте его.`,
"label.objectRelationshipDescription2":`. Вы можете определить, какие связанные записи из других объектов возвращаются в результатах отчета, выбрав связь с другим объектом.`,
"vue_label_calendar_notice_createfail":`Не удалось создать календарь`,
"label.ems.step1":`Шаг 1`,
"label.ems.password":`Пароль`,
"label.icon.143":`Свиная банка`,
"label.select.year":`Выберите год`,
"label.termsforusage.dialog":`Условия использования (Новое окно)`,
"label.tag.addtags.create":`Создать`,
"label.emailobject.groupemail.msg4":`не будет отправлять из-за недействительного адреса электронной почты.`,
"label.version.sum.autonumberfield":`автоматическое числовое поле (поля)`,
"label.projectManagement.unallocated.time":`Неназначенное время`,
"PageLayout.Search.MultiSearch.002":`Включить настраиваемое окно поиска (Поиск по одному полю)`,
"label.icon.150":`VR`,
"label.SMS.edit":`Редактирование SMS-уведомлений`,
"Opportunity.Detailed.Phase.Label.003":`Этап изменения`,
"vue_label_helpcenter_all":`1. Общий поиск<br> Общий поиск - это инструмент, который поможет вам быстро найти то, что вам нужно. <br>?Введите ключевые слова в поле ввода поиска в навигационной панели в верхней части страницы. В процессе ввода система в режиме реального времени порекомендует вам соответствующий контент; <br>?Нажмите кнопку "Поиск" или непосредственно нажмите клавишу Enter, чтобы открыть страницу результатов поиска; <br>?На странице результатов вы можете отфильтровать объект слева, чтобы просмотреть список результатов поиска под этим объектом. В списке результатов для вас рекомендуется до 10 записей. Вы можете нажать кнопку "Посмотреть подробнее", чтобы попасть на страницу списка этого объекта для просмотра дополнительных результатов поиска; <br>Заметка: По умолчанию система ищет "предложение", "заказчик", "свинец", "бизнес-возможность", "маркетинговая деятельность", "контракт", "продукт", "запрос на услугу", "задача" и "событие". <br> 2. Быстро создать<br> Нажмите кнопку " " в навигационной панели, и в выпадающем окне Вы можете выбрать объект, который хотите создать. <br> 3. Мой центр<br> Нажмите на аватар в правой части навигационной панели, чтобы открыть окно Мой центр. Предоставляются следующие функции: <br>?Быстро войдите на страницу личных настроек, пакетного импорта и входа в корзину; <br>?Если вы находитесь в пробном периоде, нажмите кнопку "Заказать сейчас", чтобы быстро войти на страницу заказа CC Cloud; <br>?Нажмите на версию, чтобы быстро переключиться; <br>?Выходите из системы. <br> 4. Меню<br> В строке меню рекомендуются некоторые объекты меню. Вы можете нажать на меню для быстрого входа на страницу. Вы также можете просмотреть все меню и установить часто используемые меню для отображения в панели меню. <br>?Все меню: Щелкните на "Больше", а в нижней части выпадающего меню щелкните на "Все меню"; <br>?Настройте мое меню: Нажмите на кнопку в правой части меню, чтобы открыть пользовательское окно меню и установить общие меню, которые необходимо отобразить в строке меню во всех меню. <br> 5. Центр запуска приложений<br> Щелкните по иконке в правой части панели меню, чтобы быстро перейти к системному администратору для настройки других сервисов приложений для вас. <br>Заметка: Приложение представляет собой набор функциональных модулей (таких как руководство, бизнес-возможности, управление контрактами и т.д.), которые могут быть использованы для удовлетворения конкретных потребностей бизнеса.`,
"label.summaryreport.2018.step5.new":`Шаг 5 Выбор критериев отчета`,
"label.weixin.id":`Номер`,
"chatter.pu.mess":`пост(ы)`,
"label.weixin.lookup.record":`Поиск рекордов`,
"label.ServiceCloud.statistics.by.address":`Статистика по адресам`,
"label.jixiaoswitchoff":`Collapse`,
"label.savealipay.failure":`Не удалось сохранить информацию о продавце Alipay`,
"template.chart.khdqfb":`Счета Региональное распределение`,
"front-email-payment-immediate-payment":`Оплатить сейчас`,
"label.dashboard.unit5":`Отряд: 100 миллионов`,
"label.tabpage.greaterz":`Больше чем`,
"vue_label_calendar_stop_sharing_calendar":`Прекратить календарь обмена`,
"label.projectManagement.allhours":`Все (часы)`,
"label.currency":`Валюта`,
"label_vue_create_edit_obj_create_event_dialog_title":`Напоминание о повторяющихся расписаниях`,
"front-template-V1-templateSetting":`Настройка шаблона`,
"label.dashboard.away.condition":`Состояние коллапса`,
"label.replacelayout":`Заменить макет страницы`,
"label.permission.detail.system.setting.tip":`Выполните операцию, примененную к приложениям. Например: изменить права доступа ко всем данным`,
"label.customfield.delete.prompt":`Пользовательская полевая этикетка`,
"label.add":`Добавить`,
"label.deputationalsoapprove":`Удаленный утверждающий орган также может утвердить этот запрос`,
"label.leave_nosave":`После выхода текущие данные не будут сохранены.`,
"label.tianyancha.title":`TianYanCha`,
"vue_label_pool_restore":`Восстановление`,
"chatter.feed.menutype.feed.markcom":`Отправление закладок`,
"label.query.data.error":`Ошибка при запросе связанных списков`,
"label.pc.ui.2018.unpin":`Отправить`,
"label.partner.template.memo":`Название`,
"label.weixin.cannot.gain.userinformation":`Невозможно получить информацию о пользователе.`,
"label.stdashbord.xsld.department":`Департамент`,
"label.service.ganttBaiduMap.scheduled.starttime":`Планируемое время начала`,
"label.documentforms":`Документы`,
"label.operator.insert":`Вставить оператора`,
"label.processsetting.select.five.fields":`Можно выбрать до 5 полей.`,
"label.weixin.password":`Пароль`,
"vue_label_chatter_share_followers":`Поделиться со своими последователями`,
"label.brief.baifang":`Посетители`,
"label.emailobject.track.unopen":`Неоткрытый`,
"label.sendmail.immediately":`Отправить сейчас же`,
"label.partnerCloud.payTheAmount":`Сумма платежа`,
"label.integrations.mailchimp.connect":`Подключите CloudCC к вашему аккаунту`,
"label.datamove.record.sucessfully":`запись(и) успешно передана(ы).`,
"lable.outlook.edit.allocation":`Назначить пользователей и профили`,
"label.chosesubject.talk":`Расписание разговора А`,
"label.escalation.setup.entrydetail.escalation.time":`Эскалатировать`,
"label.projectManagement.must.be.less.than.24.hours":`Менее 24 часов`,
"setup_mainpage_label_welcome15":`Правила рабочего процесса CloudCC Cloud Platform автоматизируют процесс поддержки ваших продаж, маркетинга и многого другого. В зависимости от предопределенного набора правил, записи могут быть автоматически назначены пользователям или преобразованы из одного пользователя в другого. Основным преимуществом управления рабочими процессами является повышение эффективности работы за счет устранения многих ненужных операций при обновлении записей, а также повышение уровня обработки данных и оптимизация процессов контроля за счет стандартизации методов работы и снижения эксплуатационных расходов. Она поддерживает неограниченное бесконечное одобрение для любого объекта, а также может вызывать напоминания по электронной почте, SMS, задачи, обновления полей и другие функции.`,
"label.mobile.phone.week.plan2":`эта неделя`,
"label.add.newAsset":`Новый актив`,
"vue_label_salesadvance_losts":`Номер убытка`,
"vue_label_report_editcolumn":`Колонка редактирования`,
"vue_label_homepage_assignedtasks":`Назначенные задачи`,
"label.posting_from":`Опубликовано`,
"year":`Год`,
"label.autoRegister.changepwd.setpwd.tip.letter":`Как минимум одна буква`,
"label.version.nonsupport.feature.staticresource":`Эта функция временно не поддерживается. Пожалуйста, подождите обновления перед использованием.`,
"label.toleadmyclientandlinkman":`Импорт моих счетов и контактов`,
"label.appupload.install.processcrash":`Урегулировать конфликты`,
"label.profile.setstandardtab":`Настройки стандартной вкладки`,
"template.chart.khhyfx":`Анализ индустрии счетов`,
"label.reportTypcrtC":`Связанный объект (с), пожалуйста, нажмите, чтобы выбрать связанный объект`,
"vue_label_report_mayormaynothave":`Родительский объект может иметь или не иметь записи, связанные с этим объектом.`,
"label.service.gantt.plan.recommendation":`Рекомендуемый график`,
"label.version.sum.lookupfield":`поля поиска взаимоотношений`,
"label.builder":`Создатель страницы`,
"label.sharerule.remark":`Укажите, как делиться этой записью. Вы можете предоставить доступ к записям и связанным с ними данным пользователю, роли, роли и подчиненным, пользователям на территории, пользователям на территории и суб-территории.  Индивидуальный общий доступ может использоваться только для предоставления более широкого доступа к данным, а не для ограничения доступа.`,
"vue_label_email_benn_added":`Почтовый ящик добавлен`,
"label.version.allow.sum":`достигла верхнего предела. При необходимости, пожалуйста, обновите версию CloudCC.`,
"label.icon.130":`Валюта`,
"label.custom.new":`Новый сайт`,
"label.see_allfields":`Посмотреть все поля`,
"front-marketing-module-v1-share-poster":`Поделиться плакатом`,
"label.service.one":`Ваш фильтр ссылается на неопределенные условия фильтрации:`,
"lable.outlook.edit.alprec":`Всегда предпочитаемый CloudCC.com`,
"Account_News_Setting_001":`Настройки аккаунта`,
"label.mr.caption.opportunity.result":`Поиск дубликатов и слияние: Результаты для запроса дубликатов возможностей`,
"label.forbidden":`Отключить`,
"label.query.detail.openpartner":`Разрешено в качестве пользователя-партнера`,
"label.session_date":`Дата сессии`,
"label.forecast.customforecast.submit.deyuce":`Прогноз`,
"label.emailtocloudcc.filed.server":`Сервер`,
"label.emailtocloudcc.tip2":`После удаления вы не сможете использовать Email в CloudCC, вы уверены, что хотите удалить?`,
"pagecreator_layout_message_delete_fail":`Удаление макета не удалось`,
"front-lightning-module-v1-dashborad-export-PDF":`Экспорт PDF`,
"lable.quote.syncing.syncingto":`Пункты котировок были синхронизированы с альтернативными продуктами.`,
"message.error.view.lastview.update":`Невозможно удалить последний публичный просмотр списка</br>Вы не можете изменить видимость последнего публичного просмотра списка с "Видимый для всех пользователей" на "Видимый только для меня"<br><br>.`,
"label.weixin.select.one":`Выберите хотя бы одного`,
"label.projectManagement.Pleaseenterprojectname":`Пожалуйста, введите название проекта...`,
"label.data.downpage.e_list.desc1":`На этой странице отображаются успешно экспортированные файлы. Пожалуйста, загрузите экспортированные файлы вовремя, добавив ссылку на загрузку в вашем электронном письме.`,
"label_tabpage_notexceed25":`Выбранная запись не должна превышать 25`,
"label.campaign.channel.step5.remark":`Вы закончили настройку страницы регистрации.`,
"label.setup.mobile.bottombutton.profile.prompt":`Советы:настраиваемое нижнее меню профиля переопределяет унифицированные настройки нижнего меню компании`,
"label.stdashbord.xsld.business.knx":`Вероятность`,
"label.setemailtip":`Создать оповещение по электронной почте для связи с одним или несколькими правилами рабочего процесса или процессами утверждения. При изменении оповещения по электронной почте, любые изменения будут применяться ко всем правилам или утверждениям, связанным с ним.`,
"report.button.go":`Перейти к`,
"lable.the.united.arab.emirates":`Записи были получены.`,
"label.writer. name.file":`Пожалуйста, заполните имя файла цитаты`,
"label.validate.function.funcExplain.ADDMONTHS":`Добавьте числовые месяцы к дате, используя последнюю дату месяца, если дата является последним днем месяца, или добавление числовых месяцев имеет меньшее количество дней.`,
"vue_label_chatter_enter_shared_content":`Пожалуйста, введите общий контент`,
"message.lookup.condition":`Критерии поиска должны вводить более одного символа`,
"vue_label_commonobjects_detail_customers":`Клиенты, которые навсегда отключат внешних пользователей, запретят всех внешних пользователей, связанных с клиентом, и удалят их из всех сообществ, групп, команд, наборов разрешений и правил совместного использования, связанных с ними. В то же время, роли и группы, связанные с учетной записью, будут навсегда удалены и не появятся в корзине. Вы уверены?`,
"label.emailobject.view.all":`Все письма`,
"vue_label_file_size_limit_new":`Загрузка не удалась. Вложение превышает {размер}M.`,
"front-gantt-module-please-reorder-milestones":`Пожалуйста, введите действительный номер для повторного заказа вех`,
"label.escalation.setup.entrydetail.escalation.assingTemplate":`Email`,
"label.namespaceprefix":`Префикс пространства имён`,
"label.ems.delete.success":`Удалить успешно`,
"label.partnerCloud.financeSetting.setWechatPay":`Настройка WeChat Pay`,
"front-epwechat-module-v1-input-token":`Пожалуйста, введите маркер`,
"setup_object_field_dependency_button_setdependency":`Настройки зависимости от поля`,
"chatter.group.request01":`Запрос(ы)`,
"message.error.field.number.length":`Длина введенного формата.`,
"label.tabpage.lessz":`Менее чем`,
"vue_label_notice_uploadavatar_format":`Загруженное изображение аватара может быть только в формате JPG/PNG/GIF.`,
"label.project.hit.thirteen":`Ежедневное напоминание о вехах`,
"frame_personinfo_label_usethisimage":`Мы будем использовать вариации этого эскиза вокруг приложения.`,
"label.startuploadfile.step":`В противном случае не удастся загрузить файлы будут отображаться в верхней области, необходимо удалить, а затем выбрать новый файл.`,
"component_assistant_label_overduetask":`Возможности с просроченными заданиями`,
"label.partnerCloud.financeSetting.information":`Как настроить информацию о подписке Alipay?`,
"label.appupload.install.package.component":`Пакетные компоненты`,
"label.emailobject.emaildetail.nextactivity.task":`Добавить задачу`,
"vue_label_chatter_edit_post":`Редактировать сообщение`,
"label.appupload.upload.logo":`иконка`,
"label.role.selecteduser":`Избранные пользователи`,
"label.letter.assign":`Укажите содержание приглашения`,
"label.forecast.shrepage.title":`Прогноз Совместное использование Подробности`,
"lable.Generate.service.appointment":`Записи на обслуживание, созданные по элементам заказа на выполнение работ`,
"label.productsales.nodata":`Нет Данные`,
"vue_label_email_Please_select_at_least_one_email":`Пожалуйста, выберите хотя бы один адрес электронной почты`,
"label.data.downpage.i_title.num4":`4. If в объекте, который вы хотите импортировать, есть поле для отношений поиска и поле для отношений master-detail, значение для этого поля должно быть ID, в противном случае оно недействительно.`,
"label.new.exchagecurrency":`Новые курсы валют`,
"label.layout.listtip":`В таблице ниже показано назначение макета страницы для различных профилей.`,
"label.icon.2":`Бумажник`,
"label.chat.topic.delete.prompt3":`Вы уверены, что удалите эту тему?`,
"UG_Lead_008":`код сканирования визитки`,
"label.multilang.databatchadd.fail":`{0} данные не добавляются {0} :`,
"front-kefu-moudle-v1-chzx-confirm":`Вы уверены, что хотите удалить агента?`,
"label.import.page1.matchlabel":`Способ соответствия {{$store.state.labelName}}`,
"label.dashboardSetup.showdw.d3":`миллион`,
"label.version.ifnecessary":`При необходимости, пожалуйста, обновите вашу версию CloudCC.`,
"label.confirm.delete.default.tab":`Вы уверены, что хотите удалить вкладки регистрации по умолчанию?`,
"label.emailtemplate.mergefields.tip":`Когда пользователи редактируют содержимое электронной почты, они могут добавлять объединенные поля для замены текста в содержимом электронной почты. При отправке сообщений электронной почты система заменяет их текстом. Например, {!Contact.name} в сообщении электронной почты станет именем контакта.`,
"vue_label_chatter_decline_members_join":`Отказать членам группы в присоединении`,
"label.role.no":`Роли нет`,
"label.service.gantt.resources":`ресурсы`,
"label.knowledge.language.simplified":`Упрощенный китайский`,
"label.eidt.queue.length.cannot.than":`Длина имени не может превышать 50 шайберов.`,
"label.mobile.quickcreate.default.tasks":`Задачи`,
"label.discount.yuan":`Скидка (юань)`,
"message.error.delete.pending":`Запись ожидает одобрения, вы не можете ее удалить.<br>Нажмите <a href='javascript:history.back();'>здесь</a> для возврата.`,
"chatter.show.mostnews":`Показать больше`,
"label.optionlist":`Пиклист`,
"template.chart.cpdj":`Ценообразование продукции`,
"label.user.usernamepassword.error":`Пожалуйста, проверьте свое имя пользователя и пароль.`,
"label.file.sharetype.check":`Зритель`,
"label.completed.generated.page":`Страница ПК завершена`,
"label.martrixcross":`Матричный крест`,
"label_tabpage_entercusnamez":`Пожалуйста, введите имя клиента`,
"lable.account.NextwDays":`Следующие 30 дней`,
"label.list.userinterface.dashboard.hint":`Новые графики приборной панели, быстро отображаемые на мобильных телефонах, планшетах и т.д..`,
"message.fieldtrack.operatecreate":`Создан`,
"label.service.gantt.available.plan":`Временные шкалы, которые могут быть запланированы:`,
"label.activity.setting":`Настройки деятельности`,
"label.tag.manage.record":`Количество записей`,
"label.customcomponent.page.edit.title":`Редактирование пользовательских компонентов`,
"label.import.index.creationrecord":`Создать запись`,
"label.tabpage.printz":`Печать`,
"label.appointment.wizard.subtitle4-1-5":`1.5 h`,
"label.partnerCloud.orderingPlatform.discountUnit":`Скидочная единица:`,
"label.weixin.micro.message.profile.associated":`Официальный аккаунт WeChat, связанный с профилем компании`,
"label.cpq.opportunity.pricebook.change":`Эта возможность была привязана к первичной котировке, и ценовая книга не может быть изменена`,
"vue_label_opportunity_business_opportunity":`Результаты закрытых и выигранных клиентом бизнес-возможностей содержат записи с одним или несколькими полями, совпадающими с текущими бизнес-возможностями.`,
"message.standardreport":`Стандартные отчёты`,
"vue_label_account_outstanding_business":`Передать все необработанные бизнес-возможности других людей`,
"vue_label_commonobjects_detail_field":`Выберите поле фильтра`,
"pagecreator_page_button_delete":`Удалить`,
"label.leadconvers.permisson":`Нет {!оператора} разрешения на {!объективное имя}, пожалуйста, свяжитесь с администратором!`,
"vue_label_systemSettings_customcode":`Пользовательский код`,
"button.partner.cancel":`Отменить`,
"label.whChatBindingState":`Статус привязки WeChat`,
"label.appointmentconfirmail.wizard.subtitle6":`Телефон`,
"label.recycle.dis.tip2":`Нажмите кнопку Опустошить корзину или Опустошить все, чтобы опорожнить корзину пользователей или организации . Это займет некоторое время, когда опустошение будет завершено, вы получите уведомление по электронной почте.`,
"batch.transfer.succ":`данные успешного массообмена`,
"label.chat.add.bookmark":`Закладка`,
"label.mr.object.contact":`Контакты`,
"component_setup_label_parentobject":`Высший объект`,
"label.reportsSubscriptionPage.schedulereport.weekly.tuesday":`вторник`,
"vue_label_report_list":`Выберите поле для отображения в заголовке списка`,
"label.checkbox.false":`Нет`,
"label.chatter.followers":`Будьте внимательны`,
"label.mr.loadReDate":`Загрузить выбранный`,
"label.versiontype.Essential":`Essential`,
"front-project-module-v1-input-actual_working_hours":`Пожалуйста, введите количество человекочасов`,
"label.visualpage.staticresource.p2":`2. Обратите внимание, что поддерживаются статические типы файлов ресурсов png, jpg, gif, js and css`,
"label.query.clone.detail.choose":`Пожалуйста, выберите пункты для клонирования`,
"component.assistant.label.30daysnoact":`30 дней без какой-либо кампании`,
"label.tianyancha.businessverify.relation":`картографировал`,
"vue_label_email_havent_received_the_email_yet":`Почта сейчас не получена`,
"label.isEnableVisualpage_new.title":`Включите индивидуальный доступ к странице`,
"lable.SalesCommitmentKanBan.allContractAmount":`Общая сумма контракта Сумма контракта`,
"label.searchall":`Искать все`,
"label.h5.similar.opportunity.select.all":`Выбрать все`,
"label.area.tree.intro":`Вы можете посмотреть иерархию территорий здесь.`,
"label.select.up.three.fields":`Внимание: Можно выбрать максимум три поля.`,
"label.leadscore.doing":`Подсчет очков начался, пожалуйста, не повторяйте подсчет очков.`,
"message.choosereportobj":`Пожалуйста, выберите объекты отчёта`,
"button_partner_start":`Начать использовать`,
"label.quote.print":`Печатная цитата`,
"label.workflowoperateselect":`Шаг 3 Укажите действия в рамках рабочего процесса`,
"label.greate":`> Больше, чем`,
"lable.setting.qrcodeOrbarcode.rule":`Настройки правил генерации QR-кода/штрих-кода`,
"label.partnerCloud.orderingPlatform.discounts":`Расписание скидок`,
"label.ems.save2draft":`Сохранить как черновик`,
"vue_label_homepage_editname":`Редактирование названия домашней страницы`,
"label.ccdocument.save.error":`Сохранить не удалось, и код ошибки`,
"label.samoa.standard.time":`стандартное время Самоа`,
"label.tianyancha.businessverify.msg7":`3. объём услуг`,
"vue_label_commonobjects_view_up_to_data":`Операция поддерживает до 200 данных`,
"label.manage":`Управляйте`,
"label.tooltip":`отчет источник данных был использован, вы не можете редактировать отношения объекта!`,
"vue_label_calendar_edit_calendar":`Редактировать календарь`,
"label.attendance.keywords":`Пожалуйста, введите ключевые слова`,
"label.otherinfo":`Прочая информация`,
"System_TAB_SeeViewAmount":`Смотреть итоговые показатели`,
"label.recordtype.remark":`Описание`,
"label.object.cannot.delete":`Объект не может быть удален, так как он связан со следующими отношениями с другими объектами`,
"label.setup.mobile.bottombutton.saveprompt":`Пожалуйста, выберите 4 страницы первого уровня`,
"label.department.lastpage":`Это последняя страница`,
"label.emailtemplate.mergefield.use":`Скопируйте и вставьте значения полей слияния в электронную почту`,
"vue_label_salesfunnel_notice8":`Доля успешных переходов с этого этапа на следующий.`,
"lable.opppdt.addpdt.table.product":`Продукция`,
"vue_label_helpcenter_report2.2":`Шаг 2: Выберите способ суммирования столбцов: Всего, Средний, Макс, Мин. <br>? Отсортируйте данные в отчете в порядке возрастания или убывания<br> Щелкните по символу ↑ или ↓ рядом с любым полем в заголовке предварительного отчета. Данные в отчете будут отсортированы в порядке возрастания и убывания в соответствии с данным полем. <br>? <br>Показать или скрыть строки подробностей<br> После группировки вы можете показать или скрыть строки подробностей, предварительно посмотрев переключатель "Строка подробностей" в правом верхнем углу отчета. По умолчанию переключатель "Подробный ряд" выключен. <br>? Включить или выключить автоматический просмотр обновления<br>В верхней правой части отчета "Автоматический просмотр обновления" позволяет включить или выключить автоматический просмотр обновления. При включении, влияние каждого шага, который вы делаете на данные, автоматически отображается в отчете о предварительном просмотре. ? Для фильтрации записей отчета нажмите на фильтры<br>Фильтры разделены на стандартные фильтры и фильтры полей. <br>Стадартные фильтры включают в себя фильтр Роль, фильтр Показать меня и фильтр Дата. <br>А. Фильтр "Роль" разделяет данные по текущим и непосредственным подчинённым ролям, и вы можете переключаться между ролями, щелкая по имени роли. <br> B. Фильтр "Показать мне" делит данные на "Показать мне" и "Показать всем", при этом "Показать мне" показывает данные, где владелец является текущим пользователем, а "Показать всем" показывает все данные, где текущий пользователь имеет права просмотра. <br> C. Фильтр "Диапазон дат" разделяет данные по дате на интервалы времени, такие как "Создать дату", "Конечная дата". <br> Фильтр "Поле" включает в себя как фильтр "Поле", так и фильтр "Дополнительно". <br>`,
"label.validate.function.funcFormat.YEAR":`Год (дата)`,
"label.service.gantt.timeScale":`Выбор шкалы времени в Гантте`,
"label.data.dataexptemplate.desc1":`1. Data экспортные файлы имеют два формата: CSV формат и сжатый формат. По умолчанию CSV формат.`,
"template.chart.btjbkhqk":`Различные уровни клиентов`,
"label.role.assign.select":`Удалить пользователя из списка <b>Выбранные пользователи</b> и назначить пользователя на выбранную роль выше.`,
"label.event.lookupmulti.assigner":`Назначено`,
"label.appexchange.fieldupdata":`Обновления полей рабочего процесса`,
"label.lookup.page.notexists":`Страница не выходит.`,
"label.appupload.install.error.choice3":`Объединить конфликтующие компоненты в один компонент`,
"vue_label_commonobjects_detail_team":`Управление коллективом`,
"label.approvereqiest":`Запрос на утверждение`,
"message.error.id.replace":`Календарная информация, соответствующая {0}, не найдена.`,
"font-evaluate-module-v1-general":`Тип оценки  Нейтральная`,
"vue_label_report_whatweek":`Какой день`,
"vue_label_chatter_img_upload":`Вы можете загружать файлы в формате JPG, GIF или PNG, максимальный размер файла - 2М.`,
"label.checkbox":`Флажок`,
"label.visualpage.component.n5":`5.пример. Звонок:`,
"chatter.updat":`Обновление`,
"label.ems.emailaccount":`аккаунт электронной почты`,
"label.autoRegister.changepwd.setpwd.tip1":`Установить пароль к учетной записи CloudCC`,
"label.import.step1.matchway":`Способ соответствия { labelNameshow }`,
"label.manageAll.sel.one4":`Пункты I Отклонено`,
"label.tabpage.lookatmorez":`Подробнее`,
"label_tabpage_addadvancedoptions":`Добавить дополнительные опции`,
"message.validation.accept":`Недействительный формат`,
"label.handlingnooperate":`Данные обрабатываются, пожалуйста, не делайте больше ничего, иначе обработка будет неудачной.`,
"label.mobile.buttom.homepage":`Домашняя страница`,
"lable.account.LastaDays":`Последние 7 дней`,
"label.user.notexists":`Пользователь не существует.`,
"front-electronic-signature-isclose":`Неактивный`,
"label.optional.groups":`Дополнительные группы строк цитат`,
"pagecreator.layout.label.layoutname":`Макетное имя`,
"label.error404":`Страницы, которую вы пытаетесь просмотреть, здесь нет, пожалуйста, попробуйте еще раз позже.`,
"label.eventtrigger":`Ивент-триггеры`,
"label.projectManagement.next.page":`Следующая страница`,
"vue_label_SMS_chosen":`Избранный`,
"label.part.cannot.empty":`Поле не может быть нулевым`,
"label.call.center.jilu":`История звонков`,
"front-kefu-moudle-v1-tenant-reinput":`Пожалуйста, введите идентификатор арендатора`,
"label.projectManagement.you.want.to.delete.this.data":`Вы уверены, что хотите удалить эту запись?`,
"label.projectManagement.nocharge":`Бесплатно`,
"System_TAB_SeeViewPageAmount":`Просмотр страниц`,
"label.password.query.error":`Ошибка пользовательского запроса.`,
"message.chooseatleastone":`Выберите хотя бы одно значение.`,
"label.sortasc":`Вознесение`,
"label.stdashbord.xsld.business.jinezhb":`Сумма Доля`,
"label.attendance.add":`Добавить Посещаемость`,
"vue_label_account_invoices":`Передайте все счета клиента владельцу`,
"label_delete _model":`Удаление модели также удалит связанные с ней целевые данные и является необратимым. Вы хотите подтвердить удаление?`,
"label.folder.sort。discreption":`Папки будут выведены в выбранном порядке.`,
"label.partnerCloud.financeSetting.merchantPlatform":`Путь доступа: Торговая платформа  Центр счетов  Безопасность API  Секрет APIＫey`,
"label.equal":`=Равноправный`,
"lable.PowerProcess.Workorder":`Порядок работы`,
"front-docusign-setting-error-tips":`Пожалуйста, выберите пользовательское поле`,
"template.report.lead.status":`Статус лидов`,
"label.create.remark":`Добавить Примечание`,
"font-evaluate-module-v1-one-points":`Отрицательный знак: 1 балл`,
"label.validate.function.funcExplain.DATETIMEVALUE":`Возврат значения года, месяца, дня и времени по Гринвичу (поле "Дата/время").`,
"label.report.select.group.mode":`Выбор режима группировки`,
"label.h5.editmydetails":`Отредактируйте мои данные`,
"front-epwechat-module-v1-authorize":`Авторизованный домен обратного вызова`,
"label.tabpage.kanban":`Настройка Viewboard`,
"label.emailobject.emaildetail.button.addtocontact":`Добавить в Контакты`,
"lable.opppdt.selPbk.description":`Выберите ценовую книгу для этой возможности. Вы можете добавить продукт только из одного ценника, а изменение выбранного ценника удалит все существующие продукты из возможности.`,
"component.event.button.save":`Сохранить`,
"vue_label_homepage_homepage_assigned_success":`Домашняя страница назначена успешно`,
"message.duplication.label.blankmatch":`Матч пустые поля`,
"label.icon.24":`Аптечка первой помощи`,
"label.mobile.same":`Новый номер телефона совпадает со старым номером телефона`,
"label.file.library.managemembers.addmember":`Добавить членов`,
"chatter.sp":`Показать сообщения`,
"label.user.notlogin.range":`Вне диапазона времени входа в систему.`,
"label.step3.total7":`Шаг 3 из 7`,
"label.user.fullname":`Полное имя`,
"label.button.menubar":`Строка меню`,
"#label.importfilestep3":`Шаг 3 Выберите и загрузите файл(ы) #`,
"label.appointment.wizard.subtitle6":`Описание`,
"message.lostnextapprover":`Если вы хотите подать запрос на официальное утверждение, заполните, пожалуйста, поле "Соответствующий пользователь", чтобы определить следующее официальное утверждение. То есть поле "Соответствующий пользователь" не может быть пустым. По всем остальным вопросам Вы можете обратиться к администратору.`,
"label.sso.saml.sp.logoutUrl":`URL-адрес единственного поставщика идентификационных данных для выхода из системы`,
"label.weixin.isgoon":`Информация о вашем членстве уже существует. Если вы продолжите, то WeChat ID, который ранее связывал этот номер мобильного телефона, не сможет использовать официальную учетную запись AidMax WeChat. Вы уверены, что хотите продолжить?`,
"vue_label_notice_homepage1":`Пожалуйста, введите правильное заданное значение в пределах 12 цифр.`,
"label.umeng.activity.event.will":`будет`,
"label.insertURL":`Вставить URL`,
"label.partnerCloud.orderingPlatform.administrator":`Нет доступного справочника цен. Пожалуйста, свяжитесь с администратором.`,
"vue_label_systemSettings_emailtemplate":`Электронная почта Tamplate`,
"template.dashboard.market.analysis":`Анализ кампании`,
"message.deleteapproval.tip":`Удалять можно только ту процедуру утверждения, которая не связана с данными или записями.`,
"pagecreator_page_message_delete":`Вы удаляете текущую выбранную страницу?`,
"component.telerecord.label.message":`Комментарий`,
"front-email-payment-Invoice-preview-opening":`Обратитесь к системному администратору для активации функции онлайноплаты и настройки соответствующих параметров метода оплаты.`,
"noless":`больший или равный`,
"label_emailtocloudcc_button_back":`Отменить`,
"lable.Please.select.a.template":`Пожалуйста, выберите существующий шаблон.`,
"front-lightning-module-v1-details-page-chart-relevant":` Когда связанные объекты выбранного отчета содержат текущий объект, вы можете в дальнейшем фильтровать данные отчета в соответствии с текущей записью; Настроить, разрешить ли пользователям вручную обновлять данные кеша.`,
"label.object.page.head":`Заголовок страницы`,
"label.notification.time1":`Через несколько секунд`,
"label.weixin.optionnine":`Выбор 9`,
"label.approval.content.tolang":`Содержание, которое вы ввели, слишком длинное, пожалуйста, введите заново.`,
"label.leadconvers":`Преобразование свинца`,
"label.compact.layout.frame.tabseq":`Отображение порядка отображения страниц вкладок:`,
"label.permission":`Наборы разрешений`,
"vue_label_notice_new_success":`Создан успешно`,
"label.money":`Валюта`,
"label.ccchat.person.invite.unsuppem":`Адрес электронной почты, который вы ввели, не поддерживает {0}.`,
"message.profile.del":`Этот профиль является профилем администратора и не может быть удален!`,
"vue_label_report_savelocation":`Сохранить местоположение`,
"label.knowledgebase.select.lighting.target":`Пожалуйста, выберите цель молнии`,
"label.visualpage.labelname":`Имя метки страницы`,
"label.notification.ccchat2":`【点赞用户名】лица твоего поста.`,
"label.htyj.wanchenglv":`Процент`,
"label.weixin.report.generatedchart":`Генерируемая диаграмма`,
"label.customer.tab.please.label":`Пожалуйста, наклейка табуляции`,
"label.template.lookup":`Шаблон просмотра`,
"label.attendance.setting.wucha":`Отклонение в пределах 200 метров`,
"vue_label_opportunity_product_addproduct":`Добавить продукт`,
"label.data.setok.t.desc3":`Операция.`,
"label.emailobject.template.public":`Общественный`,
"label.setsubmit":`Настройки подачи заявок`,
"chatter.feed.menutype.feed.companycom":`Вся компания`,
"label.Generate.Document":`Сгенерировать документ`,
"label.knowledge.setting.hint.six":`Организуйте статьи по классификации данных.`,
"label.dashboard.show.total":`Показать общую сумму`,
"attachment.select.warning.001":`Вложение заархивировано, кнопка "Архив" недоступна, пожалуйста, выберите вложение заново.`,
"message.schedulejob.error.delete":`При удалении базы заданий произошла ошибка.`,
"setup.layout.group.pagecomponent":`Компоненты страницы`,
"label_partner_new_step3_meno":`Не знаешь, что записать? Не волнуйся, ты можешь поменять его позже в любое время.`,
"label.partnerCloud.orderingPlatform.mutex":`Mutex`,
"label.subtotalrely":`Промежуточные итоги`,
"label.file.library.selectFile2Lib":`Добавить Файлы`,
"label.lock.record":`Есть( записи заблокированы`,
"label.multilang.addcustomreporttypestage2.description":`Этот источник данных будет генерировать отчет по {0}. Выбрав объект, связанный с ним,
можно определить, какие связанные записи в других объектах будут возвращены в результаты источника данных.`,
"message.duplication.errorinscript.greaterthan10":`Для объединения можно выбрать до 10 записей.`,
"label.encd":`Дисплей зашифрован`,
"UG.Account.03":`Проактивно проверять и объединять дублированные счета`,
"label.salescloud.teamrole.main2":`Основной`,
"label.email.to":`Получатель`,
"label.members.sign.notify":`Уведомить руководителя`,
"template.report.individual.case.priority":`Приоритет дела`,
"vue_label_report_selectfolder":`Выберите папку`,
"label_partner_all":`Облако всех партнеров`,
"lable.custom.year":`Нестандартные годы`,
"label.ispigeonhole":`Архив`,
"label.campaignmember.selectmember.steptotal":`Шаг 2 из 2`,
"label.userphoto.save":`Сохранить`,
"label.knowledgebase.published.version.online":`Опубликованные версии остаются в сети до тех пор, пока вы не опубликуете этот черновик.`,
"template.report.customer.level.statistics":`Статистика уровня счета`,
"label.mobile.phone.day.plan":`Завтра`,
"label.icon.95":`Обучение`,
"label.recordphone":`Зарегистрировать звонок`,
"lable.currencyManage.unEnabledadvcurrency.discripation":`Отключение расширенного валютного менеджмента прекратит использование всех датированных курсов обмена для Вашей организации. Переводы валютных полей по возможностям, продуктам возможностей и отчетам, связанным с этими объектами, больше не будут привязываться к диапазону дат - при всех конвертациях валют будет использоваться статический курс.`,
"label.service.gantt.is.candidate":`кандидат`,
"label.ruleofchecktask":`Правила проверки выполнения задачи`,
"label.whole.page.show":`Полная страница Диспалия`,
"label.validate.function.funcFormat.ISNULL":`ISNULL(выражение)`,
"label.ccdocument.template.set":`Функция набора шаблонов`,
"label.icon.103":`Расписание`,
"lable.no.products.to.assets":`Ни один продукт не может быть переведен в актив.`,
"label.fristname":`Имя`,
"label.appointmentconfirmail.wizard.subtitle5":`Организатор`,
"label.partner.workspace.myspace":`Мое рабочее место`,
"label.tabpage.optionsz":`Варианты`,
"component_chatter_link_button_save":`Опубликовать`,
"label.validate.function.funcFormat.NOW":`СЕЙЧАС()`,
"label.discountPlanEditor":`Редактор планов скидок`,
"label.weixin.fmu.pm":`{0}ПМ`,
"front-gantt-module-milestone-sorting":`Сортировка вех`,
"label.partnerCloud.maximumNumber":`Максимальное количество партнерских сайтов:`,
"label.mobile.place.record.interval.setup":`Интервал совместного использования местоположения`,
"label.visiblelinenumber":`Видимые строки`,
"front-kefu-moudle-nopower-calluser":`Нет разрешения, пожалуйста, свяжитесь с администратором`,
"label.field":`Поля`,
"label.projectManagement.groupbydate":`Группировка по дате`,
"label_vue_create_edit_obj_create_event_dialog_desc_deal_field":`запланировано`,
"label.operation.monitoring.history":`История монитора работы`,
"label.data.dataexpalltype.all_desc1":`1. You может снимать для автоматической генерации и вручную вводить пароль экспортированного сжатого файла. Автоматически сгенерированный пароль будет отправлен в почтовый ящик пользователей при успешном экспорте данных. Введенный вручную пароль не будет отправлен на почтовый ящик, поэтому пользователям необходимо запомнить пароль, который они ввели. Если пароль не введен, по умолчанию пароль отсутствует.`,
"front-web-module-v1-detail-comment-proposal":`С нетерпением ждем ваших ценных предложений`,
"label_partner_workspace_member_selectedpermission":`Выбранный набор разрешений`,
"vue_label_helpcenter_view1":`В версии для освещения вы можете интуитивно понятно и гибко просматривать и управлять данными, к которым у вас есть доступ. С помощью представления вы можете реализовать основные функции, такие как представление классификации данных, отображение данных несколькими способами, добавление, изменение и удаление данных, а также удобно просматривать отчеты и диаграммы для дальнейшего анализа данных.<br> 1. Управление видом<br>.<br>В выпадающем меню в левом верхнем углу вида выберите вид, который вы хотите просмотреть, и выберите вид по умолчанию с помощью фиксированных настроек. <br>Используйте меню управления видом списка для создания, редактирования, удаления или сортировки видов. В то же время, используйте функцию фильтрации в правом верхнем углу для быстрого редактирования и создания новых видов. <br> 2. Просмотр данных через несколько видов<br> Вы можете просматривать данные различными способами. В правом верхнем углу можно переключать список, Kanban и разделенный экран для просмотра данных. <br>В представлении списка некоторые типы полей могут напрямую изменять одни или несколько данных. Дважды щелкните по ячейке, которую необходимо отредактировать, или нажмите кнопку редактирования, вы можете напрямую редактировать данные во всплывающем окне. Для редактирования нескольких фрагментов данных, просто выберите сначала несколько фрагментов данных, а затем выберите \"Применить к выбранным данным\" во всплывающем окне редактирования. <br>В окне просмотра списка можно непосредственно редактировать колонку, отображаемую в левом верхнем углу, нажать на заголовок таблицы для сортировки или выбрать колонку, которая будет заблокирована через выпадающее плавающее окно. <br>После установки вида Kanban можно просматривать данные в группах, а также просматривать суммарное значение каждой группы. В настройках вида Kanban Вы можете редактировать основу группировки, сводную основу и метод сводки вида Kanban, а также можете выбрать до четырех полей для отображения. Вы можете быстро изменить группировку данных путем перетаскивания. <br>В режиме разделенного экрана Вы можете быстро переключиться к просмотру подробной информации по каждому из данных. <br> 3. Быстрый анализ данных о продажах<br> В правом верхнем углу представления можно открыть график в представлении для выполнения простого визуального анализа данных в представлении. В то же время вы можете просмотреть панель инструментов и список отчетов, относящихся к данным представления для дальнейшего анализа. <Нажмите на кнопку с изображением диаграммы в правом верхнем углу, вы можете просматривать, создавать, редактировать простые диаграммы, созданные с данными представления, или просматривать панели инструментов, связанные с текущим представлением. <br>Шаг 1: Нажмите на кнопку с изображением диаграммы в правом верхнем углу, чтобы развернуть диаграмму на странице. Вы можете просматривать и управлять существующими диаграммами в соответствии с правами доступа, а также просматривать список дашбордов, связанных с данными просмотра. <br> Шаг 2: Нажмите кнопку Настройки, вы можете создавать, редактировать и удалять диаграммы в соответствии с правами доступа. Вы можете создать четыре стиля графиков, вертикальную столбчатую диаграмму, горизонтальную столбчатую диаграмму, круговую диаграмму и воронкообразную диаграмму. <br>Нажмите на кнопку отчета для просмотра отчетов, относящихся к текущему виду. <br> 4. Управление данными в представлении<br>.В представлении, в соответствии с вашими полномочиями, вы можете добавлять, редактировать, удалять и изменять владельца данных с помощью кнопок в правом верхнем углу представления или рядом с каждым кусочком данных. <br>Используйте теги для помощи в управлении данными. Используйте кнопку справа для расширения списка управления тегами, и вы можете отфильтровать данные в представлении на основе тегов. После нажатия кнопки Manage tags (Управление тегами) вы также можете поддерживать и управлять своей библиотекой тегов. После выбора данных используйт`,
"component.task.label.priority":`Приоритет`,
"label.datamanage.field.error":`Ошибка поля запроса объекта.`,
"label.console.step3":`Шаг 3. Выберите источник изображения для консоли`,
"label.ems.emailsyncsetup":`Настройка синхронизации электронной почты`,
"label_tabpage_placeenterz":`Пожалуйста, введите`,
"label.getontocolumn":`Перейти на Column:`,
"label.file.down.e":`Текущий тип файла не разрешен для загрузки`,
"vue_label_notificationcenter_unreadonly":`Только непрочитанное`,
"label.login.access.change":`Изменить`,
"label.globaloperation.operationtype.send_e-mail":`Отправить электронное сообщение`,
"label.dashboard.refresh.hint":`Нажмите Обновить, чтобы загрузить последние данные в приборную панель. Это займет некоторое время, чтобы запустить источник данных, вы уверены, что хотите обновить?`,
"front-kefu-moudle-open-free":`Включить (пробная версия)`,
"label.lanxin.setting.appsecret":`AppSecret`,
"label.payment.manage.order":`Управление подпиской`,
"label.chatter.maturiyDate":`Дата истечения`,
"message.mobilechooseatmostthree":`На вкладке Мобильное приложение можно выбрать до трех полей.`,
"label.customfields.formula.tip":`Поле, доступное только для чтения, которое выводит свое значение из выражения формулы, которое вы определяете. Поле формулы обновляется при изменении любого из исходных полей.`,
"lable.PowerProcess.start.time":`Пожалуйста, выберите время начала.`,
"label.mr.title.button.group2":`набор(ы) дубликатов записей, итого`,
"label.atlantic.standard.time":`стандартное время Атлантики`,
"label.account.LengthofTime":`Продолжительность`,
"label.ccchat.message.search.desc2":`сообщения`,
"label.pigeonhole.desc":`Архивное вложение действует только для неархивированных вложений.<br/>После архивирования вложения, оно не будет удалено.`,
"label.partnerCloud.orderingPlatform.sure":`Переключатель {alias} опустошит корзину. Вы уверены, что хотите подтвердить операцию?`,
"label.default.value.is.positive.integer":`Значение по умолчанию должно быть положительным целым числом`,
"label.partnerCloud.selectOne":`Выберите хотя бы одно меню`,
"label.dashboard.more.condition":`Дополнительные условия`,
"component.event.label.enddate":`*Конечное время*`,
"label.forecast.settings.type":`Тип прогноза`,
"com.cloudcc.login.error.message.licensenotstart":`Лицензия не начинается`,
"lable.list.queue":`Очереди`,
"label.mobile.app.isdisablum":`Отключить выбор фотографий из мобильного альбома при регистрации на рейс`,
"label.service.gantt.filter":`При фильтрации по навыкам на диаграмме Ганта будут отображаться только ресурсы с выбранным навыком.`,
"label.potentialcustomeronline":`Веб-встреча`,
"label.campaignmember.main.deletecontactdesc":`Массовое удаление всех контактов из этой кампании`,
"label.list.desc1":`Используя Web to CloudCC, вы можете захватывать контактную и профильную информацию от пользователей и автоматически генерировать новые ссылки на CloudCC.com.`,
"label.generatepage.title.desc3":`Имя должно быть уникальным, и имя должно начинаться с буквы. Оно должно содержать только заглавные и строчные буквы, цифры и подчеркивание. Оно не должно быть длиннее 30 символов.`,
"label.emailtocloudcc.step2total3":`Шаг 2 из 3`,
"label.movablemenu":`Кнопки деятельности`,
"label.partnerCloud.partnerAccount.topUp":`Вверх`,
"label.data.standobject":`Стандартные объекты`,
"label.frequency":`Частота`,
"label.schedulejob.setup.schedule.end":`Конец`,
"label.chat.topic.following":`Следующий сайт`,
"label.martrixreport.2018.step2":`Шаг 2 Обобщить информацию по:`,
"label.event.moveup.11hour":`11 часов вперёд`,
"label.forecast.customforecast.directorcommit":`Прямые субординаты`,
"vue_label_homepage_card_view":`Просмотр карты`,
"vue_labenl_applauncher_notice_closecertification":`После выключения данные будут потеряны. Уверены ли вы, что сможете это сделать?`,
"component_setup_button_weburl":`Внешний урнал`,
"label_emailtocloudcc_button_addemailaddress":`Добавить почтовый ящик предприятия`,
"vue_label_campaign_added_campaign_members":`Успешное добавление участников кампании`,
"label_tabpage_rtemptyz":`Тип записи не может быть пустым`,
"label.martrixreport.2018.step5":`Шаг 5 Выбор типа графика и выделенного элемента`,
"label.moverecord":`Запись трансфера`,
"pagecreator_layout_label_layoutdesc":`Описание схемы размещения`,
"label.knowledge.setting.data.nine":`Да, я хочу удалить эту группу категорий и категории в этой группе.`,
"label.icon.90":`Люди`,
"label.weixin.micro.research.name":`Микро Имя опроса`,
"label.ccchat.micropost.allowedit":`Разрешить пользователям редактировать сообщения и комментарии`,
"vue_label_homepage_fixed_components":`Стандартный компонент`,
"label.version.document":`Библиотека документов`,
"label_assessment":`Оценка (Возможности - Количество)`,
"label.appupload.component.type.lookuplayout":`Макет поиска`,
"label_chatter_loadmore":`Загружать больше`,
"component_setup_tabs_label_memo":`Установить имя тега вкладки`,
"label.icon.167":`Компас`,
"vue_label_chatter_enter_content_sharing":`Пожалуйста, войдите в группу обмена контентом и совместного использования`,
"vue_label_notice_modify_success":`успешно модифицированный`,
"label.sharerules":`Правила обмена`,
"label.field.api.exists":`Это имя API поля уже существует.`,
"label.icon.83":`Краска`,
"label.file":`Файл`,
"vue_label_report_foldernameisrequired":`Требуется имя папки`,
"label.emailobject.wizard.btn2":`Подключено, перейдите на электронную почту`,
"label.data.downpage.i_title.num3":`3. Before импорт, убедитесь, что импортированы все соответствующие записи. Например: если необходимо найти связь между объектами, которые вы в данный момент импортируете, и контактами, то сначала необходимо импортировать контакты, а затем импортировать свои данные.`,
"label.email.original.content":`Справочное содержание`,
"vue_label_campaign_add_to_campaign":`Добавить в кампанию`,
"label.dashboard.new":`Новая панель приборов`,
"label.console.detail":`Детали консоли`,
"label.view.desc":`Поле даты может быть равно "вчера", "сегодня", "завтра", "в прошлом месяце", "в этом месяце", "в следующем месяце", "на прошлой неделе", "на этой неделе", "на следующей неделе" или "ГГГГГ-ММ-ДД, ММ/ДДД/ГГГГ".`,
"label.emailobject.template.insert.continue":`Продолжить работу по адресу .`,
"label.notification.appointment.overlapEvent":`Выбранное время запланировано, пожалуйста, выберите другое время.`,
"label.console.step6.top":`Исправлена ошибка с вершиной и списки всегда видны.`,
"label.data.file.the_trigger":`Исполнить триггер`,
"message.report.error.operation":`Действие не удалось, пожалуйста, сбросьте отчет`,
"vue_label_helpcenter_detail3":`<br>    Люблю и не люблю<br>    Вам может понравиться комментарий к микро-посту или просто микро-посту. После того, как вам понравилось, вы можете просмотреть количество "лайков" к сообщению, а также можете не походить на него. <br>? Правка и удаление сообщений<br>    Издатель сообщения может редактировать или удалять его. <br>    Шаг 1: Нажмите кнопку справа от сообщения и в выпадающем списке выберите пункт Правка или Удалить<br>    Шаг 2: Откройте окно Edit/OK для удаления всплывающего<br>    Шаг 3: Нажмите кнопку Сохранить/ОК для завершения операции<br>5. История утверждения<br>? Отправить для одобрения<br>иnbsp;   Кнопка "Отправить для одобрения" появляется, когда создается новая запись, запрос на одобрение отзывается, или в конечном итоге в одобрении отказано. <br>    Шаг 1: Нажмите кнопку "Отправить на утверждение". Система определяет, соответствуют ли запись и податель заявки условиям проекта и исходного подателя, установленным процессом утверждения, и если все эти условия выполнены, то подача заявки считается успешной. <br>    Если следующий шаг в конфигурации процесса утверждения требует выбора утверждающего лица вручную, то после "Представления на утверждение" выполняется шаг 2.<br>   Шаг 2: Выберите следующего утверждающего лица и завершите операцию по представлению заявки. <br>? История утверждения<br>    A. Перед подачей:<br>    Нажмите на "Просмотр процесса утверждения", система определит, соответствуют ли запись и оператор, подающий заявку, пунктам, установленным в процессе утверждения, а затем, если все эти условия выполнены, будет отображен процесс утверждения. <br>    B. После представления:<br>    В истории утверждений можно не только просмотреть шаги истории утверждений и текущий статус утверждения записи, но и просмотреть следующий процесс утверждения. <br>? Отзовите запросы на утверждение<br>иnbsp;   Если этот процесс утверждения настроен на отзовите запросы на утверждение, то они могут быть отозваны в любое время после их отправки. <br>    Шаг 1: Нажмите кнопку "Отозвать запрос на обратное утверждение" на странице подробностей записи <br>   Шаг 2: Откройте страницу "Отозвать запрос на обратное утверждение" и нажмите кнопку "Отозвать запрос на утверждение", чтобы завершить операцию.`,
"Opportunity_Detailed_Phase_Label_004":`День(ы)`,
"PageLayout_Search_MultiSearch_001":`Выберите до 3 полей.`,
"vue_label_systemSettings_set_business":`Настройте расположение и поля объектов в соответствии с требованиями вашего бизнеса.`,
"label.compact.layout.frame.select":`Пожалуйста, выберите рамку макета страницы`,
"label.tabpage.rolez":`Роль`,
"label.weixin.appr.currentauditor":`Назначено`,
"label.knowledgebase.verification.status":`Статус верификации`,
"UG_Case_05":`Создать дело`,
"label.service.marking.completed":`Отметить как завершенное`,
"label.notification.ccchat1":`【发出@的用户名】 упомянул вас.`,
"label.knowledgebase.no.action.available":`Нет доступных действий`,
"label.tabpage.newlybuildz":`Новый сайт`,
"label.appupload.install.error.choice2":`Переименовать локальные компоненты, которые конфликтуют с пакетом.`,
"label_tabpage_as":`Как`,
"Opportunity.Detailed.Phase.Label.Popup.001":`Дата начала текущего этапа`,
"vue_label_homepage_singlepage":`Добавьте до 10 компонентов на одну страницу`,
"font-evaluate-module-v1-fair-and-bad":`Когда тип оценки Нейтральный и Негативный`,
"label.partnerCloud.orderingPlatform.orderInformation":`Подтверждение заказа`,
"label.custom.lead.conversion.notice":`Преобразовать свинцовое напоминание`,
"label.re.upload":`Перезагрузить`,
"label.knowledgebase.top.window":`Верхнее окно`,
"label.h5.allmarkedasread":`Все помечены как прочитанные`,
"vue_label_SMS_open_record_from_start_activation":`Откройте запись из списка для активации.`,
"label.customer.tab.step2":`Шаг 2 Добавить в профили`,
"label.campaign.channel.input.owner.select2":`Лицо, выступающее в роли солиситора этого канала сбыта.`,
"component.task.button.save":`Сохранить`,
"front-kefu-moudle-v1-phone-type":`Тип телефона`,
"label.wedge-shapearrows":`Клиновидная хвостовая стрела`,
"vue_label_homepage_todaysevent":`Сегодняшние события`,
"label.data.exp.way.sel":`Выберите режим экспорта`,
"label.setting.intergrationlist.status1":`В настоящее время эта интеграция не установлена.`,
"button_partner_workspace_disable":`Отмена активации`,
"label.customfields.reference":`На них можно ссылаться при помощи других полей, таких как формулы, пикилисты, поля поиска и так далее.`,
"label.publicgroups.new":`Новая группа Pubilc`,
"label.data.setok.e_desc3":`загрузите экспортированные данные.`,
"vue_label_commonobjects_view_chart_countmode":`режим графа`,
"label.service.appointmentList.earliest.allowedStart":`Самая ранняя дата начала`,
"label.data.choses.e.desc":`В соответствии с вашими потребностями, вы можете экспортировать все данные или экспортировать данные из объекта.`,
"label.multilang.common.fieldlist.fieldremark":`Применить к полям, отображаемым на странице {0}.`,
"label.umeng.activity.event":`мероприятие`,
"label.project.hit.ten":`Напоминание об обновлении выпуска`,
"label.c_d_least":`Каждая запись в букве "С" должна иметь как минимум одну соответствующую запись в букве "D".`,
"label.emailobject.wizard.btn1":`Подключить вашу электронную почту`,
"lable.product.pricebooks.info":`Подробная информация о ценовой книге`,
"component_telerecord_label_message":`Комментарий`,
"lable.total.of.estimates":`Всего 0 оценок`,
"label.stdashbord.xsld.business.oppcounts":`Количество Поддержки`,
"vue_label_commonobject_duplicatewith":`Дублируйте в {1}в {0}`,
"label.setpicandreport":`Настройки диаграммы`,
"label.category.2":`Общие сведения`,
"label.emailtocloudcc.reauthorization":`Повторная авторизация`,
"label.chatter.vote":`Опрос`,
"label_emailtocloudcc_edit":`Редактирование`,
"label.pleaseinput":`Вход`,
"vue_label_homepage_user_particular_application":`Домашняя страница, когда пользователь использует определенное приложение, назначения отменяют стандартную домашнюю страницу.`,
"label.allianceID":`Aliance ID`,
"label.h5.homepage.cannot.applied.mobile.terminal":`Домашняя страница профиля не настроена для этого профиля. Она недоступна для мобильного приложения`,
"label.appointmentpage.wizard.notif2":`Имя необходимо!`,
"label_emailsync_status_email":`Действие Выполнено Электронная почта`,
"label.icon.179":`Люди`,
"UG_Contract_03":`Заключить договор`,
"label.cy.new":`Новая валюта`,
"label.version.setup.controllist":`Контрольный список установки`,
"label.vlidaterule":`Правила проверки`,
"label.customer.tab.name":`Имя вкладки`,
"label.recentview.seloption1":`Недавно просмотренный`,
"vue_label_report_notice_nameisrequired":`Название отчета обязательно`,
"label.createapproveprocessstep":`<li>1. прочитать справочные темы</li><li>2. создать шаблоны электронной почты</li><li>3. создать шаблоны SMS</li><li>4. создать процесс утверждения с помощью мастера Jump Start или Standard Wizard</li><li>5. добавить список "История утверждения" ко всем макетам страниц</li><li>6. активировать процесс развертывания для ваших пользователей</li>.`,
"label.gotocalendar":`Перейти к Календарю`,
"label.import.page1.pleaseselectobj":`Пожалуйста, сначала выберите объект`,
"label_tabpage_messagez":`Пожалуйста, введите комментарий`,
"vue_label_homepage_profilepage":`Главная страница профиля`,
"label.tabpage.choose":`Выберите`,
"label.campaignmember.setup.lead.field":`Поля свинца`,
"label.setalipay.null":`Необходимая информация для настройки Alipay пуста.`,
"label.custom.Current.and.NextCQ":`Текущий и следующий CQ`,
"label.knowledgebase.needto.publish.articles":`Resotre архивированной статьи создаст черновую версию. Вы хотите опубликовать статью?`,
"pagecreator.layout.message.save.success":`Макет сохранен успешно`,
"homepage.componet.approval.label":`Пункты для утверждения`,
"label.last_submission":`Время последнего представления`,
"lable.outlook.detail.prefo":`Обмен всегда выигрывает`,
"label.projectManagement.new.subtask":`Новая подзадача`,
"label.service.appointmentList.checkThe":`Проверено`,
"message.error.searchlayoutselectdefields":`Не может быть удалено и должно быть первым полем в макете поиска.`,
"label.ems.normal":`Нормальный`,
"vue_label_notice_pleaseselectobject":`Пожалуйста, выберите объект`,
"component.sendmail.button.send":`Отправить`,
"label.relevant.records":`Связанные записи`,
"label.weixin.login.CloudCC":`Вход в систему`,
"label.tag.addtags.private":`Частный`,
"label.appointment.disable.remark":`Извините, функция в настоящее время отключена. Если вы хотите перенести или отменить встречу, пожалуйста, свяжитесь с ответственным лицом по адресу {邮箱地址}.`,
"label.campaignmember.main.addMember1":`Добавить членов`,
"message.error.objectnofound":`Объект неизвестен`,
"label.employeenum":`Количество сотрудников`,
"label.search.applyfilter":`Применить фильтр`,
"label.version.history.track.nonsupport":`Только бесконечная версия поддерживает функцию истории отслеживания полей.`,
"label.ccpeak.direction.for.use.time":`Инструкция для запланированных классов [версия 2.0].`,
"label.ems.settings":`Настройки`,
"label_tabpage_arecordtypez":`Доступный тип записи`,
"vue_label_pool_assign1":`{1}{2}`,
"label.customcomponent.direction.for.use":`Инструкция для пользовательских компонентов [ версия 2.0 ]`,
"label.appupload.appname":`Имя пакета`,
"label.cpq.order.status.no.active":`Только заказы с активным статусом могут генерировать контракты`,
"label.dashboard.maxlength":`Вы можете ввести до 255 символов`,
"label.customize.memory.function.sorting.title2":`Память о сортировке заголовков`,
"label.report.chose.obj":`пожалуйста, выберите взаимосвязь объектов и сообщите источник данных`,
"label.partner.step3":`Шаг 3 Основная информация`,
"message.report.type.error.fail":`Недействительный источник данных отчета.`,
"pagecreator.page.message.publish.fail":`Не удалось опубликовать страницу`,
"label.minimun":`Минимум`,
"label.state":`Статус`,
"label.customcomponent.referencetype":`Тип ссылки`,
"label.nameandemailtemplate":`Введите название вашего процесса в поле ниже и затем выберите шаблон электронной почты для уведомления уполномоченного лица (необязательно).`,
"label.customobjects.track.introduce":`На этой странице вы можете выбрать поля, которые вы хотите отслеживать на`,
"label.campaign.matchway.label":`Метод сопоставления`,
"label.redistribution":`Переадресовать`,
"label.groupmanage":`Управление организацией`,
"label.icon.157":`Камера`,
"label.quickbooks.viewlist.total":`ИТОГО:`,
"label.file.copy.file.fail":`Не удалось скопировать, пожалуйста, вручную скопируйте`,
"label.outline.selectfield":`Резюме выбранных полей:`,
"label.datetime.maxsize":`Цикл запроса не может быть дольше трех месяцев.`,
"label.dashboard.CustomDashboardMyHomePage":`Настройка панели управления моей домашней страницы`,
"label.data.customobject":`Пользовательские объекты`,
"vue_label_SMS_noselected":`Запись не выбрана`,
"label_tabpage_value":`Значение`,
"label.quote.qianming":`Подпись`,
"label.view.source":`Просмотр исходного кода`,
"label_popup_infoz":`Симптома`,
"label.emailtocloudcc.redmessage8":`Ошибка параметров, пожалуйста, свяжитесь с администратором.`,
"label.tianyancha.Search.business":`Поиск информации о регистрации бизнеса`,
"vue_label_systemSettings_server":`Сервис`,
"vue_label_homepage_dashboard_components":`Компонент приборной панели`,
"label.search.listview":`Просмотр списка`,
"label.service.gantt.distribution.success":`Назначение успешно`,
"label.icon.4":`Бумажник`,
"label.partnerCloud.orderingPlatform.calculate":`Рассчитать цену`,
"label.forecast.edittotal.ycyx":`Приоритет прогноза`,
"vue_label_commonobjects_detail_to_precise_search":`Точный поиск`,
"label.order.number":`Заказать`,
"setup.mainpage.label.welcome7":`Инструкции: Щелкните по меню в левой части страницы → Настройки приложения → Создать → Объект → Название объекта → Пользовательское поле.`,
"label.weixin.user.binding":`Обязательная для исполнения Пользователем`,
"label.custom.canvas.size":`Размер холста`,
"label.projectManagement.recent.projects":`Последний проект`,
"vue_label_helpcenter_lead":`Отслеживайте и управляйте вашими зацепками через Cloud CC. Используйте настроенные правила для подсчета и назначения ссылок и конвертации их в клиентов, контакты и соответствующие бизнес-возможности в нужное время.<br>Score<br> В правом верхнем углу представления используйте кнопку пакетного подсчета ссылок для подсчета ссылок в представлении.<br>Распространение<br> При создании или редактировании ссылки выберите Назначить в нижней части страницы, чтобы назначить ссылку соответствующему персоналу на обработку в соответствии с существующими правилами.<br>Conversion<br> В нужное время вы можете конвертировать ссылки в клиентов и контакты, нажав на кнопку преобразования в правом верхнем углу страницы подробностей. В то же время, вы можете создать соответствующие бизнес-возможности и задачи, чтобы облегчить дальнейшее отслеживание транзакций.`,
"label.enabledprocess":`Активные процессы утверждения`,
"label.emailobject.noemail":`Пока нет почты, иди и отправь!`,
"label.validate.remark3":`Определите, требуется ли какое-либо поле, исходя из значения другого поля.`,
"vue_label_salesadvance_retention":`Сохранение`,
"label.product.managep":`Управление ценовыми книгами`,
"font-evaluate-module-v1-not-report":`Не открывать повторно`,
"label.emailmerge.mergepage.step1":`1.Выберите записи для слияния:`,
"front-epwechat-module-v1-epwechat-describe":`CloudCC обеспечивает интеграцию с WeCom, объединяя мощные функции WeCom с легкой версией H5 системы CloudCC,<br /> помогая вам удобно управлять отношениями с клиентами, управлять трафиком частных доменов и повышать доходы предприятия.`,
"label.partner.template.detailimage":`Фотография`,
"label.recycle.clearall":`Пустая корзина вашей организации`,
"chatter.error.nottype":`Ошибка:Неверный тип файла. Пожалуйста, используйте файлы JPG, GIF или PNG.`,
"pagecreator.button.cancel":`Отменить`,
"front-market-form-quired-ziduan":`Обязательные поля на странице регистрации`,
"vue_label_report_columnname":`Имя столбца`,
"message.notdelete.type":`Удалить данный тип записи нельзя, так как в следующих профилях этот тип записи используется в качестве значения по умолчанию.`,
"label.ccpeak.folder.all.time":`Все запланированные папки классов`,
"label.quickbooks.searchlist.total3":`Есть {0} несвязанные оценки на общую сумму {1}`,
"label.forecast.detailforecast.quantity":`Количественный прогноз`,
"label.knowledge.language.british":`Британия`,
"label.vlidaterule.example.messagelocation":`Это сообщение об ошибке может появиться либо в верхней части страницы, либо под определенным полем на странице.`,
"front-kefu-moudle-chf-success":`Успешно разделить`,
"vue_label_jihui_yi":`Возможность 1`,
"label.import.step1.null":`Опции отсутствуют`,
"label.console.step5.tab.subtab":`В качестве подзаголовка`,
"batch.edit.permission":`Нет разрешений на редактирование`,
"label.weixin.fmu.before.min":`{0} за минуту до времени`,
"chatter.up.file":`Загрузка файла занимает некоторое время, в зависимости от размера загруженного файла, пожалуйста, подождите.`,
"setup.layout.group.field":`Поля`,
"label.chat.unlike":`Любимый`,
"vue_label_dashboard_updatefrequency":`Обновить частоту`,
"label.trigger.folder.new":`Страницы триггеров: Новая папка`,
"label.process.des.app":`Нажмите на правую ссылку для просмотра подробной информации о текущей записи.`,
"vue_label_pool_assignselect":`Выберите, чтобы назначить членов`,
"label.lookup.user":`Поиск коллег`,
"label.mobilescreentablayoutedit.remark2":`Выберите поля фильтра, отображаемые на главной странице вкладки в Мобильном приложении.`,
"label.data.exp.objtemp":`Вы создадите шаблон для экспорта данных этого объекта следующим образом кретира`,
"label.weixin.moreselect.error":`Только 10 записей можно выбрать`,
"label.icon.25":`Бандаж`,
"lable.sample.text":`Образец текста`,
"label.most.setup.obj":`Можно установить до 10 объектов.`,
"label.weixin.coming":`Приходит`,
"label.editdescription":`Примечание Редактирование`,
"label.multipleactivity.multiple":`Многопользовательские`,
"label.sso.saml.idp.entityid":`Идентификатор организации`,
"label.SMS.pho.filed":`Телефонное поле`,
"message.serviceabsence.violation":`Нарушение периода назначения: противоречит записи об отсутствии.`,
"label.forecast.settings.type.clist":`Использовать семейства продуктов`,
"label.state.noend":`Неполный`,
"label.sourcetemp":`Источник`,
"vue_label_chatter_name_link":`Пожалуйста, введите имя и ссылку`,
"label.emailobject.attach":`Прикрепить`,
"label.everyother":`друг друга`,
"label.title":`CloudCC.com`,
"vue_label_chat_haventactivate":`Вы еще не активировали аккаунт чата. Хотите активировать сейчас?`,
"pagecreator_layout_button_delete":`Удалить макет`,
"label.transfer.temporarily":`Звоните на .`,
"label.service.dispatchingUnits.search.services":`Назначение поисковой службы`,
"customer.message.fail.chat":`Не удалось получить записи сообщений, обратитесь за помощью к администратору`,
"label.apiname.toolong":`Имя API слишком длинное.`,
"label.empty.filter":`Очистить фильтры`,
"label_tabpage_personalCenterz":`персональный центр`,
"label.minutes":`Минута`,
"label.multipleactivity.atasks":`Задача(и)`,
"label_tabpage_deleteview":`Удалить вид`,
"pagecreator_layout_message_save_success":`Макет сохранен успешно`,
"label.reportlineorder":`Порядок столбцов отчета`,
"label.total.forecast.have.priority":`любой прогноз является предварительным, но те, которые принимают другие подзаголовки, являются предварительными`,
"label.custom.quarter.subtitle":`Таможенный квартал`,
"label.icon.79":`Печать`,
"label.hiddenoperate":`Действия по скрытию`,
"label.project.hit.six":`Уведомление о назначении задания`,
"label.visualpageaction.errordesc":`Вы не имеете права отменить запрошенную операцию. Пожалуйста, свяжитесь с владельцем записи или вашим администратором.`,
"label.chat.unmute":`Отменить "не сомневаться"`,
"label.zhaiyao":`Аннотация`,
"vue_label_commonobjects_detail_bcc":`Bcc`,
"label.customcomponent.page.index.table.version":`версия API`,
"UG.quota.06":`Создать цитату`,
"label.icon.152":`Робот`,
"label.partnerCloud.partnerAccount.account":`Имя пользователя`,
"label.file.sharewith":`Поделиться`,
"label.data.dataexptemplate.desc2":`Формат сжатия разделен на два типа: один - для автоматической генерации пароля к сжатому файлу, другой - для ручного ввода пароля к сжатому файлу.`,
"vue_label_dashboard_newfoldersuccessfully":`Создать новую папку успешно`,
"label.campaignmember.main.importmember":`Участники массовой кампании по импорту`,
"label.htyj.completed":`Заполнено`,
"label.reportTypeLabel":`Тип отчета Метка`,
"label.customer.tab.label":`Этикетка`,
"label.dashboard.component":`Компоненты`,
"label.safetystatement.dialog":`Выписка о безопасности (Новое окно)`,
"label.forecast.settings.data":`Прогнозная дата`,
"label.knowledgebase.modifiedby":`Изменено`,
"label.batchadd.remark":`Добавить несколько записей`,
"button.partner.delete":`Удалить`,
"Pagelayout_Setup_005":`Имя должно быть поставлено на первое место.`,
"label.forecast.edit.wcpxl":`Нет Семейства продуктов`,
"lable.PowerProcess.seq.input":`Пожалуйста, введите заказ.`,
"pagecreator.layout.message.delete.fail":`Удаление макета не удалось`,
"label.emailobject.edit":`EDIT`,
"label.weixin.million":`десять тысяч юаней`,
"setup.mainpage.button.manageobject":`Управление объектами`,
"label.weixin.participants.perfect.information":`От участников требуется улучшить информацию`,
"vue_label_campaign_campaign_members":`Добавить участников кампании`,
"label.ccchat.person.invite.emplaceholder":`Введите адреса электронной почты и разделите их точкой с запятой`,
"label.mobile.phone.new":`Новый сайт`,
"font-evaluate-module-v1-small-program-evaluation-settings":`Настройка оценки минипрограммы`,
"UG.opportunity.005":`Многократный процесс продажи`,
"vue_label_report_polymerization":`Совокупность`,
"label.multilang.lookfiltercondition.fieldtypenotmate":`Условие строки {0} неверно, тип поля не совпадает!`,
"label.knowledgebase.delete.draft":`Удалить черновик?`,
"label.mr.descreption.condition3":`Точное совпадение правил: проверьте этот пункт и найдите дубликаты записей по одним и тем же символам поля. Если клетка отмечена, то поиск дубликатов по первым нескольким символам будет входить в игру.`,
"Lead.Auto.Scoring.Setting":`Установка лидирующих оценок`,
"label.marketing.channel.default":`Маркетинговый канал (Включен по умолчанию)`,
"front-project-module-v1-select-projecttemplate":`Выберите шаблон проекта`,
"front-email-payment-select-area":`Пожалуйста, укажите район`,
"lable.PowerProcess.message":`Информация о процессе получения прав`,
"label.weixin.free.get.captcha":`Получить код верификации бесплатно`,
"label.projectManagement.please.select.task.or.question":`Пожалуйста, выберите задачу/проблему`,
"label.pacific.daylight.time":`Тихоокеанское летнее время`,
"label.sendsms.batch.step1.introduce":`Выберите один из следующих видов просмотра (который содержит адресатов данного SMS)`,
"label.same.analyze.account.name":`Имя аккаунта`,
"Homepage.Contract.FieldMissed.DoesntSupport":`На объекте договора нет полей "qdrq" и "htje", поэтому данные не могут быть показаны.`,
"label.partnerCloud.orderingPlatform.noProduct":`Конфигурирование опции продукта в рамках данного продукта не требуется.`,
"label.totalsummary":`Прокатный итог`,
"label.partner.workspace.tab":`Tab`,
"label.entitlement.process.name.unique":`Это имя уже существует. Пожалуйста, введите его еще раз.`,
"report.label.norole":`У вас нет разрешения на это, пожалуйста, свяжитесь с вашим администратором.`,
"label.password.old.error":`Старый пароль неверен, пожалуйста, введите заново.`,
"lable.account.quarter.stadate":`День начала финансового квартала`,
"label.salescloud.contactrole.choose.correct":`Дублируйте выбранные контакты, пожалуйста, исправьте.`,
"label.schedulejob.setup.schedule.day":`День`,
"label.communalusergroup":`Общественные группы`,
"label.Display.Fields":`Поля, отображаемые в списке назначений на обслуживание`,
"label.marketsea":`Бассейн`,
"label_partner_setup_address":`Облачный адрес партнера`,
"label.industrialandcommercialverification.label.url":`URL-АДРЕС`,
"lable.data.exp.newtemp":`Экспорт данных и создание шаблонов`,
"label.pc.ui.2018":`Вертикальное`,
"label.version.free":`Бесплатная версия`,
"label.dataimport.contact.length":`Ошибка: длина имени контакта слишком велика.`,
"label.cy.vlidate":`Действие включенной валюты является необратимым. Вы уверены, что хотите включить управление валютой?`,
"label.recycle.all":`Все корзины`,
"label.message.changeaccount.isnot":`Контакт включен партнером, не может изменить учетную запись`,
"label.searchlayout.exactsearch":` Совет: Установите флажок за поисковым полем, чтобы выполнить точный поиск в этом поле.`,
"label.file.size.limit":`Примечание: Максимальный размер файла составляет 10М.`,
"label.mobileapp.modelsetting1":`Настройки модуля "Мобильный стандарт`,
"template.report.overall.sales.opportunities":`Общий период продаж (по типам возможностей)`,
"label.password.update.success":`Пароль был успешно изменен.`,
"label.import.page3.gobackhome":`Назад домой`,
"label.phone":`Телефон`,
"label.detail.vlidaterule":`Просмотреть Правила проверки`,
"label.weixin.input.usernames":`Пожалуйста, введите ваше имя пользователя`,
"label.icon.85":`Трансформатор`,
"vue_label_systemSettings_partner":`Партнер`,
"label.processsetting.new.process":`Новый процесс`,
"Lead_Scoring_Setting_Rule_Setup_01":`Ведущий список правил подсчета очков`,
"setup.layout.component.area":`Территория`,
"label.createnewpwdinformuser":`Сгенерируйте новый пароль и немедленно сообщите об этом пользователю.`,
"label.pwinfo":`Пароль Подробности`,
"label.imgfield.type.url":`Справочное изображение`,
"label.attendance.sxccheckincy":`Регистрация участников кампании`,
"lable.PowerProcess.condition.input":`Пожалуйста, выберите состояние.`,
"label.partnerCloud.partnerAccount.topUpFailure":`Пополнение фиалами`,
"label.document.size.too.long":`Превышен размер документа`,
"label.link":`Ссылка на доступ`,
"label.partnerproduct.sort.repeat":`Берется название семейства продуктов.`,
"label.data.setok.e_desc2":`Список данных экспорта Страница`,
"front-project-module-v1-plase-input-project-name":`Пожалуйста, введите название проекта`,
"label.export":`Экспорт`,
"label.icon.45":`Котел`,
"label.autoRegister.changepwd.title":`Установите ваш логин-пароль`,
"label_clear_adjust":`Четкая регулировка`,
"front-kefu-moudle-return-visit":`Обзор`,
"label.ems.compose":`Составить`,
"Pagelayout_Setup_002":`Вы выбрали 3 связанных списка, и добавление дополнительных связанных списков повлияет на макет страницы.`,
"label.service.gantt.skill.screening":`Использовать фильтр навыков`,
"label.partnerCloud.basicSetting.enable":`Облако партнера будет деактивировано. Действия по входу и редактированию в вашей организации будут автоматически отключены системой.`,
"label.workbanch.setup.description":`Вы можете настроить фоллинговые виды, чтобы показать их в "Моем рабочем банке".`,
"label.category.1":`Все`,
"label.foldername":`Имя папки`,
"label.forecast.settings.shuliang":`Количество`,
"label.emailmerge.newtemplate.word":`Пожалуйста, загрузите документы Microsoft Word.`,
"message.error.type":`тип не может быть пустым, вам нужно пройти общественный тип или персонал частных!`,
"label.manualallocation":`Назначить вручную`,
"label.addattachment.step2":`Шаг 3 Нажмите Загрузить файл, чтобы загрузить файл`,
"label.company":`Компания`,
"label_emailsync_status_export":`Экспорт в формате Excel_csv`,
"label.eventreminder":`Напоминание о событии`,
"label.emailtemplate.lookup":`Просмотр шаблонов электронной почты`,
"label.customsetting.touse.getCustomSetting":`Запрос типа "иерархия" настраиваемых параметров, возврат соответствующего apiName и разрешений (ID - ID профиля или ID пользователя), Map map = cs.getCustomSetting(String apiName, String id);`,
"label.projectManagement.Resourceuse":`Использование ресурсов`,
"label.appointment.wizard.subtitle4":`Настройки буфера и времени`,
"label.donot.close.your.browser":`Во время этого процесса, пожалуйста, не нажимайте на другую ссылку и не закрывайте веб-браузер.`,
"label.multilang.customforcast.target":`Цель {0} :`,
"setup_layout_label_newarea":`Новая область`,
"component.timeline.button.more":`Больше шагов`,
"label.appointmentdetail.wizard.title3":`Продолжительность`,
"label.help.new.features.pc":`Руководство по эксплуатации новых функций`,
"label.mr.record":`Запись`,
"label.trigger.wgd":`Нефилированные триггеры`,
"label.icon.72":`Инструменты`,
"setup.layout.label.detailpage":`Подробная информация Страница`,
"frame.personinfo.label.usethisimage":`Мы будем использовать вариации этого эскиза вокруг приложения.`,
"label.multilingual.confirm.open":`Вы уверены, что включили? Мультиязычность можно использовать после включения.`,
"label.recordcreater":`Созданный`,
"label.afterfinish":`По окончании нажмите кнопку Сохранить`,
"label.companyinformation":`Информация о компании`,
"step1":`Шаг 1`,
"label.sales.page.dashboard.add":`Добавить в панели управления Homepage`,
"label.processsetting.process.enabled.failed":`Не удалось удалить процесс!`,
"label.document.history.date":`Дата`,
"label.linkedin.title":`LinkedIn-H5MiniApp`,
"label.foldervisitlimit1":`Все пользователи могут получить доступ к этой папке`,
"april":`апрель`,
"label_emailsync_form_disconnect":`Отменить отзыв Концерт`,
"label.appointment.wizard.subtitle4-2-6":`2 дня`,
"vue_label_notice_follow_success":`Следующий сайт`,
"label.startuploadfile.success":`При нажатии кнопки "Start Upload", если индикатор выполнения достигнет 100%, файл будет успешно загружен и исчезнет в верхней области.`,
"message.accesstoken.acquisition.failed":`Не удалось получить маркер доступа!`,
"label.quickbooks.fieldlabel.fistname":`Имя`,
"label.appointment.wizard.subtitle1-5":`1 h`,
"2018UI.Homepage.DataNoAccess.Info":`У вас нет разрешения на просмотр этой записи, пожалуйста, нажмите, чтобы вернуться к предыдущему шагу.`,
"label.batchaddattachments":`Массовое Добавление Добавление`,
"label.ems.next":`Следующий`,
"label.quote.zhekou":`Скидка`,
"lable.product.notdel":`Потому что это все еще находится в руководстве с другой записью в прайс-книге. Соответствующие записи следующие.`,
"label.ems.action":`Действие`,
"message.error.chart.type":`Типы диаграмм не могут быть пустыми.`,
"label.conditiontag.lookup.value":`Значение`,
"label.chatter.allactivity":`Все действия`,
"label.summaryreport":`Сводные отчёты`,
"label.textmessage.vonage.action":`Действие`,
"label.ccpeak.must.result":`Должны быть использованы как следует псевдонимы, чтобы получить от результата`,
"label.data.newtemplate.savetemp.desc":`Пожалуйста, внимательно введите название и описание шаблона, чтобы облегчить использование.`,
"label.projectManagement.search.for.users":`Поиск пользователя`,
"component.milestones.label.title":`Вехи`,
"vue_label_applauncher_description_accountpool":`Используйте Account Pool (Пул счетов) для удобного управления последующим статусом в организации и мотивации персонала к завершению операции.`,
"label.import.index.startimport":`Начало импорта`,
"page.field.masterinput2":`Мастер-детальный ввод`,
"label.mobile.change.owner.permission":`Новый владелец должен иметь права "Чтения" на этот тип записи.`,
"label_partner_common_enable":`Включить облако партнера`,
"label.log.browser":`Браузер`,
"label.app.step4":`Шаг 4 Выберите вкладки`,
"lable.quote.syncing.opportunity":`Возможности`,
"label.forecast.customforecast.foredis.jqz":`Точное значение`,
"label.forecast.forecastroleuserpage.title":`Назначение менеджера по прогнозированию`,
"label.starting.quarter":`Стартовый квартал`,
"label-combination-record":`Запись {index}`,
"label.here":`здесь`,
"label.weixin.underfind.error":`Неизвестная ошибка`,
"label.cloudccclass.list.tip.time":`Разрешить разработчикам разработать на платформе CloudCC.com плановые классы, которые могут быть использованы для плановых программ.`,
"label.data.setok.t_desc1":`Если вам необходимо использовать этот шаблон производных данных, пожалуйста, нажмите кнопку`,
"label.service.gantt.break.rules":`Нарушение правил`,
"label.weixin.no.pending.ywjh.qin":`Нет возможностей на следующие 30 дней`,
"label.view.atleastone":`Список не может быть пустым.`,
"label.attendance.sxccheckin":`Посещаемость кампании`,
"label.custom.split":`Сплит`,
"front-kefu-moudle-v1-yesorno-delete-templete":`Вы уверены, что хотите удалить этот шаблон?`,
"label_chatter_theme":`Темы`,
"label.partner.new.step1":`Шаг 1 Выберите понравившийся шаблон`,
"vue_label_commonobjects_view_settings":`Настройки представления Канбан`,
"UG_Contract_02":`Договор представляет собой письменное соглашение между сторонами. Многие компании используют контракты для определения условий ведения бизнеса с другими компаниями. Используйте CloudCC для создания и документирования существующих контрактов с вашими учетными записями и бизнес-возможностями. Отслеживайте договор через процесс утверждения. Используйте напоминания рабочего процесса, чтобы напомнить вам о переносе контракта.`,
"label.setup.mobilesetup.isenableh5newandedit":`Включите новое и отредактируйте H5 в своем мобильном приложении.`,
"label.attendance.edit":`Посещаемость Редактирование`,
"label.service.miniProgram.fillImageLink":`Пожалуйста, заполните ссылку карусели.`,
"label.b.c.without":`Записи типа B могут иметь или не иметь соответствующие записи типа "C".`,
"label.sso.key":`Код авторизации`,
"label.star_click":`Нажмите, чтобы очистить`,
"vue_label_SMS_name_or_phone_number_lookup":`поиск имени записи`,
"label.case.copre.text":`Вы также можете загрузить QRкод вебпортала, посвященный вашей компании, и разместить его на своем сайте или устройстве, после чего клиенты смогут сканировать QRкод для использования вебверсии портала для клиентов.`,
"label.salescloud.forbidden.confirm":`Ты уверен, что хочешь отключить команды возможностей?`,
"vue_label_chat_conformactivation":`Подтвердить активацию`,
"label.emailtocloudcc.redmessage9":`Ошибка базы данных, пожалуйста, свяжитесь с администратором.`,
"label.sahreto":`Поделиться с`,
"label.recordtype.sort":`Типы записей отображаются в порядке их сохранения.`,
"label.allreport":`Все доклады`,
"front-gantt-module-drag-and-drop-subtask":`Перетащите (поместите его в задачу), чтобы сделать его подзадачей!`,
"label.permission.objlist.nopermission":`Нет доступа`,
"label_file_num":`Количество`,
"chatter.mostword":`Ваш комментарий содержит более 500 слов, пожалуйста, удалите и введите заново.`,
"label.h5.chatter.comment":`Комментарий к телу`,
"vue_label_calendar_notice_havecreated":`Вы создали календарь`,
"label.tabpage.loadz":`Загрузка страницы, пожалуйста, подождите...`,
"chatter.w.p":`Рабочий Телефон`,
"label.chat.topic.name.desc":`Вы можете изменить только регистр и интервал между названиями тем.`,
"label_partner_template_name":`Название шаблона`,
"label.mobile.phone.required.examines.people":`Требуется пересмотренный бай-фай.`,
"message.error.view.notexists":`Вид не существует.</br> Или вид мог быть изменен кем-то другим, нажмите <a href='javascript:history.back();'> здесь </a> назад.`,
"label.custom_time":`Пользовательское время`,
"label_partner_workspace_member_all":`Все`,
"lable.custom.year.name":`Название года по выбору`,
"label.account.previous.M":`последний месяц`,
"vue_label_commonobjects_detail_locking":`Замок`,
"label.brief.lead":`Свидетельства`,
"label.linkedin.setting.appsecret":`Пароль секретного ключа`,
"label.query.detail.closepartner":`Партнеры-инвалиды`,
"label.isEnableVisualpage_new.rightlist":`Активные пользовательские страницы`,
"front-epwechat-module-v1-unbound-item3":` данные авторизованной информации`,
"label.exchange.sync.setting.info":`После настройки учетной записи службы с разрешениями на олицетворение для пользователей в Microsoft©Exchange, введите учетные данные учетной записи службы, чтобы CloudCC мог общаться с сервером Exchange. Если учетные данные служебной учетной записи были сохранены, но пользователь все еще не может синхронизировать записи, убедитесь, что вы настроили Exchange Sync.`,
"label.emailobject.groupemail.fail.title":`Электронная почта группы CloudCC отправила неудачный адрес электронной почты`,
"label.the.upper.bound.of.each.level.of.edit.discount.must.be.greater.than.the.lower.bound.":`Верхняя граница для редактирования каждого уровня скидки должна быть больше нижней границы.`,
"label.visualpage.list.vpname":`Настраиваемое имя страницы`,
"label.mask.length.error.message":`Зашифрованное текстовое поле не может содержать более 255 символов.`,
"label.h5.approval.actorname":`Представлено`,
"label.knowledgebase.view.translation":`Посмотреть перевод`,
"label.ems.edit":`Редактирование`,
"vue_label_commonobjects_view_reset_width":`Ширина колонки сброса`,
"label.version.feature.controllist":`Ограничительный список функций`,
"label.setuppagelayout":`Макеты страниц`,
"vue_label_commonobjects_view_new_view":`Новый взгляд`,
"label_tabpage_queuez":`Очередь`,
"label.direct.dashboard.wait.me.approval":`Пункты для утверждения`,
"message.report.error.noRelatedField":`Никаких связанных с докладом полей нет. Они могли быть удалены, пожалуйста, свяжитесь с вашим администратором.`,
"label.ccchat.person.invite.notme":`Вы не можете отправлять приглашения на свой собственный адрес электронной почты.`,
"label.weixin.jieduan.finish":`Отметьте текущий этап как завершенный`,
"vue_label_commonobjects_detail_?enter_subject":`Пожалуйста, введите тему`,
"label_starting_month":`Начальный месяц`,
"label.address_linetwo":`Адресная строка 2`,
"message.error.select.contiguous.item":`Выбор соответствующих пунктов с`,
"vue_label_pricebook_enterbookname":`Пожалуйста, введите название прайс-листа`,
"label.cycleworkflowoperate":`Периодический рабочий процесс Действия`,
"label.ems.withoneday":`Сегодня`,
"component.todaytask.label.notask":`Сегодня нет задачи по истечению срока годности, выпей кофе.`,
"label.tianyancha.id":`Идентификатор компании`,
"label.user.illegal.login":`Незаконный логин`,
"label.withgathercondition":`По Обобщенным Критериям`,
"label.foldervisitlimit":`Разрешения доступа`,
"label.ccchat.search.conversation":`Искать в этом разговоре`,
"lable.annual.project.report":`Отчет по проектному счету в этом году`,
"template.chart.qzkhzhfx":`Анализ конверсии лидов`,
"label.my":`My`,
"label.sendsms.batch.chosetemplate":`Массовые SMS: Выберите шаблон или отредактируйте содержание`,
"label.callcenter.enterprise.number":`Предприятие №.`,
"label_last_modified_by_time":`Последний модификатор и время`,
"message.fieldtrack.operaterecord":`Изменено <b>операционное поле</b> из<b>операции</b> в<b>операционное поле</b>.`,
"label.mobile.more.openin":`Откройте...`,
"label.multilingual.tip2":`Вы можете включить или отключить многоязычность.`,
"label.datamanage.lead.novalue":`Примечание: Поле "Имя контакта" является нулевым, записи контактов не будут импортированы.`,
"label.custom.revoke":`Отменить`,
"label_chatter_leaveword":`Комментарий`,
"vue_label_ccchat_group_deletedgroup":`Группа удалена`,
"label.tabpage.operationz":`Поле, операция не может быть пустой`,
"label.user.organization.permit.overdue":`Лицензия на вашу организацию прошла проверку, пожалуйста, свяжитесь с администратором!`,
"label.log.datetimeoruser.value":`Пожалуйста, введите время запроса и имя пользователя.`,
"lable.product.stsp.noavailable":`Стандартная цена отсутствует`,
"label.appservice.cannot.delete.app":`Вы не можете удалить это пользовательское приложение, потому что некоторые профили используют это пользовательское приложение в качестве приложения по умолчанию.`,
"component.event.label.newevent":`Новое событие`,
"label.view.sortview.exportview":`Вид на экспорт`,
"label.uploadfilemaxsize":`Максимально допустимое значение загрузки файла`,
"label.event.weekview":`Вид на неделю`,
"label.conversion_rate":`Коэффициент конверсии`,
"label.partnerCloud.partnerAccount.useWechat":`Используйте сканирование WeChat для оплаты.`,
"UG_Forcast_05":`Настройки прогноза: шаг {0}/{1}`,
"label.service.gantt.jobresour":`Показать только рабочие резервы`,
"vue_label_campaign_fromopprotunities":`От возможностей для бизнеса...`,
"label.app.skyblue":`Небесно-голубой`,
"label.chinacloudcc":`Облачные вычисления Китай`,
"label.connectOtherFinalNumber":`Ограничение объектов<br/>Вы можете связать до четырех объектов с источником данных пользовательского отчета.`,
"label.redistributionrequest":`Переадресовать запросы на утверждение`,
"label.knowledge.category.button.one":`Добавить подкатегорию`,
"label.campagin.pcandmo":`ПК и мобильный телефон`,
"label.project.milestone.date":`Дата вехи должна находиться в диапазоне дат проекта, к которому она относится.`,
"assetbom.transfer.notpermission":`У вас нет полномочий для миграции BOM активов. Пожалуйста, свяжитесь с администратором.`,
"label.marketing.setting1":`Маркетинговые каналы`,
"label.select.file":`Выберите Файл`,
"message.error.object.contactadministrators":`В системе произошел сбой, обратитесь за помощью к системному администратору.`,
"label.custom.quarter.title":`Таможенный квартал`,
"label.knowledge.case.settings":`Установление случаев`,
"front-service-cloud-transfer-title":`Передача актива Владелец спецификации`,
"label.group.search.searchthisfeed":`Поиск по этому каналу`,
"label.report.action.addtodashboard5":`Добавить в новую панель приборов`,
"label.mobile.side.tab.remark2":`При установке ползунка, вы можете поставить наиболее часто используемые элементы в переднее положение. журнал вызовов, пункт меню может быть только userd для android версии CloudCC на мобильной стороне.`,
"contain":`Включить`,
"label.select.template":`Выберите шаблон`,
"label.addattachment.step3.weixin":`Шаг 3 Нажмите кнопку "Завершить" и вернитесь на предыдущую страницу.`,
"lable.Order.successfully":`Успешно перевести заказ в актив.`,
"label.user.title":`Название`,
"label.weixin.check.agreement":`Пожалуйста, проверьте соответствующее соглашение`,
"label.SMS.pfi":`Номер телефона Поле`,
"label.weixin.micro.research":`Микро-исследование`,
"label.projectManagement.assigned.work":`Назначенная работа`,
"label.document.login.error":`Вход не удался, пожалуйста, попробуйте еще раз.`,
"label.mobile.phone.examines.people":`Пересмотрено`,
"label.safetyset":`Параметры безопасности`,
"label_function_tip":`В настоящее время эта функция не поддерживается для пользователей материкового Китая. Мы ценим ваше понимание!`,
"label.app.sort":`Сортировать приложения`,
"component.sendmail.label.cc":`Cc`,
"label.titlename":`Название`,
"label.event.moveup.3day":`3 дня вперёд`,
"label.condition":`Условия`,
"label.description.message":`Максимум 500 символов.`,
"label.ems.detailedsettings":`Подробные настройки`,
"label.repeat.condition.field.prompt":`Пожалуйста, введите номер в поле "В соответствии с длиной символов" Filed！.`,
"label.validate.function.funcExplain.OR":`Убедитесь, что все параметры верны, и верните TRUE или FALSE. Возвращает FALSE только в том случае, если все параметры ложны.`,
"label.salecommit.allow.prediction.query":`Вы не можете просматривать панели фиксации продаж, потому что не отметили опцию "Разрешить прогнозы" в разделе "Настройка - моя личная информация - персональные настройки".`,
"front-kefu-moudle-soft-phone":`Софтфон`,
"label.view":`Посмотреть`,
"front-gantt-module-quick-create-task":`Быстрое создание задачи`,
"label.all_forms":`Все формы`,
"front-lightning-module-v1-dashborad-statistical-dimension":`Статистическое измерение`,
"label.forecast.settings.data.chanpin":`Дата продукта`,
"label.appointment.wizard.subtitle4-2-7":`3 дня`,
"front-web-module-v1-detail-comment-please":`Пожалуйста, введите отзыв`,
"label_chatter_nextSevenday":`Следующие 7 дней`,
"homepage.components.desctiption":`Эта страница позволяет создавать и редактировать компоненты, которые могут отображаться на одном или нескольких макетах главной страницы.`,
"label.customcomponent.page.index.table.namespace":`Префикс пространства имён`,
"label_emailtocloudcc_exists":`Электронная почта уже существует.`,
"label_tabpage_save":`Сохранить`,
"label.mergeRechecking":`Дублирование и объединение чеков`,
"vue_label_helpcenter_view2":`В режиме разделения экрана можно быстро перейти к просмотру подробной информации по каждому из данных. <br> 3. Быстрый анализ данных о продажах<br> В правом верхнем углу представления можно открыть график в представлении для выполнения простого визуального анализа данных в представлении. В то же время вы можете просмотреть панель инструментов и список отчетов, относящихся к данным представления для дальнейшего анализа. <Нажмите на кнопку с изображением диаграммы в правом верхнем углу, вы можете просматривать, создавать, редактировать простые диаграммы, созданные с данными представления, или просматривать панели инструментов, связанные с текущим представлением. <br>Шаг 1: Нажмите на кнопку с изображением диаграммы в правом верхнем углу, чтобы развернуть диаграмму на странице. Вы можете просматривать и управлять существующими диаграммами в соответствии с правами доступа, а также просматривать список дашбордов, связанных с данными просмотра. <br> Шаг 2: Нажмите кнопку Настройки, вы можете создавать, редактировать и удалять диаграммы в соответствии с правами доступа. Вы можете создать четыре стиля графиков, вертикальную столбчатую диаграмму, горизонтальную столбчатую диаграмму, круговую диаграмму и воронкообразную диаграмму. <br>Нажмите на кнопку отчета для просмотра отчетов, относящихся к текущему виду. <br> 4. Управление данными в представлении<br>.В представлении, в соответствии с вашими полномочиями, вы можете добавлять, редактировать, удалять и изменять владельца данных с помощью кнопок в правом верхнем углу представления или рядом с каждым кусочком данных. <br>?Используйте теги для помощи в управлении данными. Используйте кнопку справа для расширения списка управления тегами, и вы можете отфильтровать данные в представлении на основе тегов. После нажатия кнопки Manage tags (Управление тегами) вы также можете поддерживать и управлять своей библиотекой тегов. После выбора данных используйте кнопку Добавить тег в правом верхнем углу, чтобы добавлять теги к данным партиями.`,
"label.app.ismobile":`Отображается на мобильном приложении`,
"chatter.group.changeTheGroupPicture":`Изменить Фото группы`,
"label.mr.descreption.reDataList2":`записи о повторных`,
"vue_label_chatter_agree_join":`Согласиться присоединиться`,
"label.planned.nextrun":`Запуск в следующий запланированный`,
"Homepage.News.003":`Невозможно отображать новости без данных аккаунта, пожалуйста, создайте новый аккаунт, и соответствующие новости будут показаны.`,
"label.summaryreport.selectpictype":`Выберите тип графика и другие графические опции`,
"label.app":`Заявления`,
"label.trigger.name":`Имя триггера`,
"vue_label_email_private_template":`Частный шаблон`,
"label.appointmentpage.wizard.subtitle1":`Выберите дату и время Часовой пояс пригласителя {0}.`,
"label.partnerCloud.orderingPlatform.payment":`Оплата заказа`,
"label.stdashbord.xsld.title":`Воронка продаж`,
"vue_label_pool_poolname":`Название пула аккаунтов`,
"label.ServiceCloud.fuwuyuyue.distributionMap":`Карта распределения назначений на обслуживание`,
"front-lightning-module-v1-dashborad-target-value":`Целевая стоимость`,
"label.reportsSubscriptionPage.email.keywords":`Поиск после ввода ключевого слова`,
"label.appointmentconfirmail.wizard.subtitle1":`Название мероприятия`,
"label.limited_scanning":`Входной билет предназначен только для регистрации на месте.`,
"label.weixin.nomore":`Больше нет`,
"february":`февраль`,
"label.view.filterbyowner":`Фильтр от владельца:`,
"label.contentType":`Продление срока действия документов`,
"label.customobjdel.master.hsiang":`Поле Master-Detail Relationship создается в этом объекте, поэтому его нельзя удалить.`,
"lable.Removal.succeeded":`Удалено успешно.`,
"label.weixin.end.incorrect":`Недействительная дата окончания`,
"label.email.cc.recipients":`получатели КК`,
"label.taskevent.list":`Список мероприятий`,
"label.formula":`Формула`,
"label.h5.new.errorheader":`Просмотрите ошибки на этой странице.`,
"label.emailobject.template.private":`Частный`,
"label.visualpage.component.n4":`4. Переменная. Вы можете использовать переменные напрямую, и будьте осторожны, чтобы не иметь одинарных кавычек.`,
"label.newemailnotice.step1":`Шаг 1 Выберите объект`,
"label.chatter.file":`Файл`,
"vue_label_checkduplicate_rules":`Установить правила проверки дубликатов`,
"label.appointment.wizard.subtitle1-6":`1.5 h`,
"label.customReportType":`Источник данных пользовательского отчета`,
"vue_label_email_with_accessories":`Электронные письма с вложениями`,
"label_efine_assessment_cycle":`Установленный срок аттестации`,
"label_emailtocloudcc_button_sure":`Подтвердить`,
"label.forecast.userenablepage.isusing":`Включенные пользователи`,
"lable.goal.description":`Описание цели`,
"message.error.serviceresource.relatedrecordid":`Каждый пользователь может быть добавлен только как один сервисный ресурс типа {0}`,
"label.weixin.addbus.information":`Добавить информацию о транспортном средстве`,
"label.emailtocloudcc.button.view":`Посмотреть`,
"label.detail.workflow":`Просмотр рабочих процессов`,
"label.standardfilter":`Стандартные фильтры`,
"label.mobile.phone.results":`Производительность`,
"chatter.feed.unavailabled":`Unenable`,
"label.view.sortview":`Сортировать вид`,
"label.availabilityobject.wizard.title":`Наличие`,
"Main_Menu_Mobiledownload":`ВКЛЮЧИТЬ ИСПОЛЬЗОВАНИЕ`,
"chatter.sticker":`Отслеженный`,
"label.workflow.intruduce":`Настройка процесса организации путем создания правил документооборота. Каждое правило процесса состоит из:`,
"label.customfields.richtext.tip":`Позволяет пользователям вводить отформатированный текст, добавлять изображения и ссылки. до 32 768 символов в отдельных строках.`,
"label.new.cy.select":`Выберите новую валюту из доступного списка.`,
"template.chart.schdzqzkhzhqk":`Конверсия лидов в кампаниях`,
"label.forecast.customforecast.cpxl":`Семейство продуктов`,
"front-electronic-signature-open-service":`Включить электронную подпись`,
"label.datamanage.import.field":`Импортные поля`,
"chatter.email.sendMessageToMe":`Отправляет мне сообщение`,
"message.cannotusebefore":`Пожалуйста, обратите внимание, что вы не сможете использовать эту процедуру утверждения, пока она не будет активирована.`,
"label.textmessage.vonage.api.secret":`секретный API`,
"label_chatter_newEvent":`Новое событие`,
"label.ji.year":`{а} год`,
"label.sendmail.step2":`Шаг 2 Выберите шаблон электронной почты`,
"label.console.step5.record":`открытые отчёты`,
"label.customfields.totalsummary.gettogetherfield.isnull":`Пожалуйста, выберите поле для объединения`,
"vue_label_commonobjects_detail_current_recorder":`Новый владелец также станет владельцем записей, связанных с этим проектом, и эти записи принадлежат текущему диктофону.`,
"label.SMS":`SMS-оповещения`,
"label.reconfigure.bundle":`Переконфигурируйте пакет`,
"front-kefu-select-region":`Пожалуйста, выберите регион, в котором находится экземпляр`,
"chatter.feed.deletefeeds":`Вы уверены, что хотите удалить это сообщение и его комментарии?`,
"label.customsetting.manage.introduce.h":`Если пользовательская настройка представляет собой иерархию, вы можете добавить данные для уровня пользователя, профиля или организации. Например, вы можете захотеть, чтобы различные значения отображались в зависимости от того, работает ли приложение под определенным пользователем, под определенным профилем или просто под общим пользователем.`,
"label.product.name":`Название продукта`,
"vue_label_commonobjects_view_saveas":`Сохранить как`,
"label.group.my.archived":`Мои архивированные группы`,
"vue_label_pool_coflictmethods":`Конфликт с текущим режимом продаж`,
"label.appupload.upload":`Загрузить`,
"lable.SalesCommitmentKanBan.signedTaskRate":`Скорость выполнения подписанной задачи`,
"label.dashboardStandard":`Стандартные приборные панели`,
"label.niboer.time":`Непальское время`,
"label.emailtocloudcc.filed.email":`Email`,
"market.name.social.post":`Социальные посты`,
"evaluation.detail.notfound":`Деталь комментария не найдена`,
"label.layoutoftestobj":`Макеты тестовых объектов`,
"label.example":`Примеры`,
"label.campaign.channel.step6.remark6":`посетите, пожалуйста, здесь`,
"chatter.emailLike":`Любит`,
"label.knowledge.category.button.two":`Редактировать категорию`,
"label.alluser":`Все пользователи`,
"addadvancedconditions":`Добавить дополнительные условия`,
"message.selectgsummarycondition":`пожалуйста, выберите сводные критерии`,
"message.duplication.label.sectionremar2":`Note: All соответствующие записи, включая любые примечания, приложения и мероприятия, будут связаны с новой объединенной записью.`,
"vue_label_helpcenter_product&pricebook":`Товары - это Ваш основной каталог всех товаров и услуг, которые Вы продаете, а также их стандартные цены. Прайс-лист позволяет вам создать индивидуальную коллекцию товаров и соответствующие прайс-листы для конкретных пользователей.`,
"message.duplication.label.isprofile":`По разрешению`,
"component_setup_label_milestonesfield":`вехатое поле`,
"setup_layout_label_required":`Требуется`,
"component_chatter_label_title":`Последняя запись`,
"label.assignment.setup.detail.order":`Порядок сортировки`,
"vue_label_pool_unassigned":`Неприписанный`,
"UG_Lead_007":`синхронизация Google`,
"label.knowledge.record":`Никаких релевантных данных не существует!`,
"label_tabpage_filetypez":`Тип файла`,
"label.ccpeak.if.error.message":`Если возвращается ошибка: используйте`,
"label.intialsubmitter":`Первоначальные заявители`,
"label.wei.icon":`иконка`,
"label.mask.show.last.4":`Маска последние четыре символа`,
"lable.PowerProcess.time.trigger":`Время срабатывания (мин)`,
"july":`июль`,
"label.usestandardwizard":`Использовать стандартный мастер настройки`,
"label.two.quarter":`Второй квартал`,
"label.size":`Размер`,
"label.integrations.mailchimp.massage4":`В настоящее время Mailchimp не установлен. Пожалуйста, установите Mailchimp в разделе "Интеграции".`,
"label_emailtocloudcc_step2total3":`Шаг 2 из 3`,
"vue_label_chat_customer_group_strategy":`Команда клиентов`,
"label.searchvalue":`Поиск значений`,
"label.sendemail.birthday.title":`Напоминание о дне рождения`,
"label.projectManagement.planned.days":`Дни планирования (день)`,
"label.service.gantt.workhours":`На основе трудочаса`,
"label.notification.approval5":`Удалено утверждение:【提交人】и запрашивается утверждение 【对象】.`,
"label.service.miniProgram.bindAddressDesc":`CloudCC Официальный портал мини-программы обслуживания клиентов:`,
"chatter.error.wt":`Ошибка:Неверный тип файла.`,
"vue_label_calendar_my_calendar":`Мой календарь`,
"label.customername":`Имя аккаунта`,
"label.salescloud.salesdashboard.huikuan.rankings":`Рейтинг платежей по группам`,
"message.query.opportunity.contactrole.error":`Запрос бизнес-возможности контакт контактная роль по умолчанию не удалось, пожалуйста, свяжитесь с администратором!`,
"noequal":`не равнозначный`,
"label.document.searchcustominfo":`Введите ключевые слова для поиска подходящих документов.`,
"label.account.PreviousFQ":`Предыдущий FQ`,
"label.file.f":`Файлы`,
"label.dashboard":`Приборные панели`,
"label.report.folder":`Папки`,
"batch.edit.permission.list":`Нет разрешения на редактирование списка данных`,
"label.file.orderbyowner":`Сортировано по владельцу`,
"label.exchange.sync.account.password":`Пароль учетной записи:`,
"pagecreator.button.publish":`Опубликовать`,
"label.modify":`Редактирование`,
"label.exchange.sync4":`Государства`,
"label.remark.information":`Описание Информация`,
"label.service.without.major.event":`Нет важного события, которое должно быть отображено`,
"label.knowledgebase.release.status":`Статус публикации`,
"label.tabpage.ok":`Подтвердить`,
"label_screening_assessment_content":`Содержание оценки фильтра`,
"label_partner":`Облако партнера`,
"label.user.detail":`Просмотр пользователей`,
"front-kefu-moudle-or-this":`или вот так?`,
"label.unselect.object":`Дополнительный объект`,
"label.quote.contactfax":`Факс`,
"label.weixin.appmanage.alert":`Нажмите {0}, чтобы удалить приложение из раздела "Мои приложения", нажмите {1}, чтобы добавить приложение в раздел "Мои приложения".`,
"vue_label_dashboard_thisfolder":`Добавить общедоступную панель инструментов в эту папку`,
"label.delete":`Удалить`,
"label.appexchange.installedpage.message1":`Вы можете просматривать и загружать приложения непосредственно в CloudCC App Store и устанавливать их в среду CloudCC.com.`,
"label.mobile.phone.required.summary":`Требуется резюме`,
"label.batchadd.newbatchpage.addtr":`Максимум 30 записей могут быть добавлены.`,
"label.partnerCloud.partnerAccount.lockLine":`Заблокированная сумма`,
"label.emailsync.status.connectstatus":`Статус подключения`,
"label.campaignmember.main.importmember.lead":`Импортные участники - Руководители`,
"message.username.isnull":`Вы должны ввести значение для имени пользователя.`,
"label.forecast.tree.enableuser":`Включить пользователей`,
"label.multilang.view.viewmessage":`Этот вид был применен к мобильному устройству. Можно выбрать максимум 10 полей, теперь есть {0}:`,
"friday":`пятница`,
"label.sendemail.activity.neweventtitle":`Уведомление о новом событии`,
"label.page.addtabto.user":`Добавить вкладку к существующим персональным настройкам`,
"front-kefu-moudle-v1-connect-phone":`Номер телефона сотрудника`,
"label.wei.pollis":`Голосуйте за`,
"lable.opppdt.editPdt.title":`Возможность редактирования Продукты`,
"label.permission.objectpermission.recordfenpei":`Присвоение типа записи`,
"pagecreator.layout.message.delete.success":`Макет удален успешно`,
"label.dataimport.isdupecatcher":`Исполнять фильтры`,
"label.deletelayout.tip":`Для того чтобы удалить макет страницы, необходимо выбрать другой макет для его замены.`,
"label.projectManagement.No.matching.data":`Нет подходящих данных.`,
"pagecreator_page_message_delete_success":`Страница удалена успешно`,
"label_tabpage_equalz":`Равный`,
"label.ems.emailsetup":`настройка электронной почты`,
"label.decimaldigits":`десятичные знаки`,
"component.chatter.button.delete":`Удалить`,
"label.isallowreport":`Разрешить отчёты`,
"label.view.appliedMobile.message":`Проверьте этот пункт, Шаг 3. Выберите поля для отображения и можете выбрать до 6 полей.`,
"label.must.positive.integer":`Число должно быть целым числом.`,
"label.preview.print.template":`Предварительный просмотр шаблона для печати`,
"label.schedulejob.setup.schedule.start":`Начать`,
"UG.Case.04":`Назначение дела`,
"vue_label_pool_move1":`{1}{2}`,
"label.list.userinterface.enableHoverDetails":`Включить Hover Подробности`,
"vue_label_email_alltemplates":`Все шаблоны`,
"label_report_chose_obj":`пожалуйста, выберите взаимосвязь объектов и сообщите источник данных`,
"label.partnerCloud.productSet.del":`Удалить элемент`,
"label.quote.shrdz":`Адрес получателя`,
"page.approval.history":`История утверждения`,
"lable.outlook.detail.prefc":`Всегда предпочитаемый CloudCC.com`,
"label.translation.unable.display.view":`Невозможно просмотреть`,
"label.encrypt.change":`Конвертировать зашифрованный тип`,
"button.partner.workspace.login.logo.upload":`Загрузить изображение`,
"label.batchadd.mustinput2":`требуется, эта запись не может быть сохранена, если требуемая информация пуста.`,
"label.dataimport.update.error.check":`Произошла ошибка при обновлении данных. Пожалуйста, внимательно изучите эти данные.`,
"label.staticresource.name.already.exists":`Уникальное название статического ресурса уже существует!`,
"label.appupload.upload.install.success":`Успешно установлено`,
"label.conditiontag.lookup.true":`TRUE`,
"label.quickbooks.viewlist.customer":`КЛИЕНТ`,
"label.field.edit.change2":`Самый высокий балл - не менее 1`,
"label.fianalrejectoperate":`Действия по окончательному отказу`,
"label.ccpeak.wgd":`Нефилированные классы`,
"label.reportsSubscriptionPage.condition.emailreport":`Резюме   доклад`,
"label.detailinf":`Подробности`,
"label.eastem.standard.time":`восточное стандартное время`,
"chatter.group.manager":`Менеджер`,
"label.manage_columns":`Управление заголовком`,
"label.daylight.time":`Летнее время`,
"label.weixin.mycar.information":`Мои машины`,
"label.ccpeak.help":`Помощь для классов`,
"lable.outlook.detail.match":`Соответствующие критерии`,
"label.version.nonsupport.approval":`Процессы утверждения временно не поддерживаются.`,
"label.custom-tailor":`Настроить`,
"label.showoperate":`Показать действия`,
"label.view_edit":`Просмотр и редактирование`,
"label.lead.score.prompt2":`Выберите диапазон оценки, нажмите кнопку [Lead Scoring], и система оценит выбранные лиды в соответствии с активным правилом Lead Scoring Rule.`,
"label.datamanage.savetemplate.error":`Шаблон спасения не удалось.`,
"label.source":`Источник`,
"label.multilang.customfieldsetup.reference":`На это поле ссылается {0}`,
"chatter.poll.option7":`Выбор 7`,
"label.login.access.day":`день(ы)`,
"label.icon.66":`Оборудование`,
"label.tabpage.kanbansetup":`Настройка Viewboard`,
"label_emailtocloudcc_step1_lead2":`После настройки почта, полученная в этом почтовом ящике, будет автоматически регистрироваться в CloudCC как ведущая запись. Убедитесь, что ни одна сделка не будет пропущена.`,
"label.partnerCloud.partnerAccount.numericValue":`Сумма пополнения должна быть числовым значением.`,
"label.permission.detail.app.object.tip":`Настройки доступа к объектам, полям и вкладкам`,
"label.emailobject.template.subject":`Тема`,
"template.report.month.customer":`Счета этого месяца`,
"label.weixin.formerly":`В прошлом`,
"label.contract":`Контракты`,
"label.help":`Помощь`,
"vue_label_homepage_setdefault":`Установить в качестве домашней страницы по умолчанию`,
"label.icon.52":`Выработка электроэнергии`,
"label.customfields.file.count":`Количество файлов`,
"UG_Account_07":`импортный счёт`,
"label.addattachment.ntko":`Редактирование онлайн`,
"label.service.ganttBaiduMap.assign.service":`Назначение услуги этому лицу`,
"vue_label_file_my_file":`Мое досье`,
"label.custom.page.hide":`Спрятать`,
"label.addexistoperate":`Добавить существующую операцию`,
"label.already.startdate":`Начальное время`,
"label.partnerCloud.financeSetting.alipay":`Вам необходимо открыть бизнессчет Alipay. Только бизнессчет поддерживается в качестве счета получения. Комиссия за транзакцию будет взиматься Alipay с получателя платежа.`,
"label.dashboard.summary.editPageFooter":`Редактировать ногу`,
"label.category.8":`Товары народного потребления`,
"label.forecast.customforecast.foretype.best":`Лучший случай`,
"message.validation.isnull":`Пожалуйста, введите значение`,
"label.savewxpay.failure":`Не удалось сохранить информацию о продавце платежей WeChat`,
"label.file.stop.sharing.desc1":`Хватит делиться с`,
"label.opportunity.setting.showstage。read.info":`Этапы возможности не могут быть изменены вручную после установки галочки`,
"UG_Campaign_003":`Создать кампанию`,
"label.edit.field.select.showoptions":`Показать все варианты`,
"message.inputplatformpwd":`Введите пароль администратора`,
"vue_label_systemSettings_mobel_set":`Настройка мобильного приложения`,
"label.projectManagement.thefirstone":`Это первая запись`,
"label.data.newtemplate":`Создать шаблон экспорта данных`,
"label.monitorsys.delete.log":`Журнал аудита ключевых операций`,
"label.template":`Шаблоны`,
"Lead.Auto.Scoring.Setting.001":`Автоматическая оценка при редактировании или сохранении (За исключением очков, которые импортируются в пакетном режиме или создаются по интерфейсу).`,
"label.operatesuccess":`Операция прошла успешно.`,
"label.send":`Отправить`,
"chatter.yp":`Скрытый корм`,
"label.overall_responses":`Общий ответ`,
"vue_label_systemSettings_server_report":`Отчет об обслуживании`,
"label.icon.113":`Дом`,
"label.partnerCloud.basicSetting.domainSet":`Настройка доменного имени`,
"label.login.access.text":`Чтобы помочь с поддержкой, вы можете предоставить администратору доступ для входа в систему и посещения ваших данных.`,
"vue_label_report_addrowlevelformula":`Добавить формулу уровня рядов`,
"message.duplication.label.mergeTitle":`Соедините мои`,
"label.event.add":`Добавить Событие`,
"vue_label_homepage_bigscreen_light":`Light`,
"setup.chatter.enabled":`Недоступно, пожалуйста, свяжитесь с администратором, чтобы включить CCChat.`,
"label.inputreceiver":`Вы можете ввести до пяти (5) адресов электронной почты для уведомления. Каждый адрес электронной почты разделен на ";".`,
"label.custom.page.custom.page":`Пользовательские страницы`,
"label.data.exp.csv":`формат CSV`,
"label.searchlayout.view.example":`Пример просмотра`,
"label_tabpage_fullscreenz":`Полный экран`,
"label.tabpage.last":`Последний шаг`,
"lable.outlook.mcto.accepemail":`Мои доступные адреса электронной почты`,
"front-electronic-signature-isopen":`Активный`,
"vue_label_commonobjects_detail_earlier":`Смотреть Ранее`,
"label.name.cannot.greater.str":`Имя может содержать до 255 символов.`,
"label.weixin.activity.email":`Деятельность: Электронная почта`,
"label.tabpage.unequalz":`неравноправный к`,
"label_calendar_year":`Календарный год`,
"label.appupload.upload.installor":`Установлено`,
"label.jixiaoswitchon":`Развернуть`,
"label.user.congratulations.send.finish":`Поздравляю, массовая переписка завершена.`,
"label.customsetting.touse.getListCustomSetting2":`Запросить данные пользовательских настроек типа "list", вернуть единичные данные, соответствующие имени API. Карта карты = cs.getListCustomSetting(String apiName, String Name);`,
"label.recordtype.masterrecordtype.selectedTip":`Основной тип записи не может быть назначен профилю, которому уже назначен тип записи.`,
"label.tippage.li3":`Так что все компоненты приборной панели, основанные на отчете о сбое, были удалены.`,
"label.weixin.no.name":`Тема не обсуждается`,
"label.tabpage.viewz":`Печать текущего вида`,
"label.create_contacts":`Создать список контактов`,
"vue_label_homepage_operationitem":`Пожалуйста, выберите кнопку`,
"label.pc.ui.2018.switch.version":`Перейти на версию`,
"label.salescloud.teamrole.main":`Главный контакт`,
"label.reportsSubscription.format.report":`Форматированный отчет (формат Excel .xlsx)`,
"label.forecast.customforecast.total":`Сумма`,
"label.quickbooks.fieldlabel.lastname":`фамилия`,
"label.appointment.wizard.title2":`Информация о встрече`,
"label.project.template.one":`Создание проекта из шаблона проекта требует 2~3 минуты. Спасибо за ваше терпеливое ожидание.`,
"label.timetrigger.workflow":`Когда рабочий процесс активен.`,
"label.projectManagement.creator":`Создатель`,
"label.customfields.formula.selectreturnfieldtype":`Пожалуйста, выберите тип возврата формулы`,
"label.list.userinterface.dashboard.enable":`Включить новые компоненты приборной панели`,
"label.email.delete.html.format":`Все форматы html будут удалены. Вы уверены?`,
"label.appupload.install.modifyapi":`Измените конфликтующее имя api:`,
"label.chat.add.topics":`Добавить тему`,
"label.savepartner.fail":`Не удалось сохранить настройки для Partner Cloud`,
"label.pc.query.new":`Просмотреть ваши последние`,
"message.duplication.label.editfiltertitle":`Поиск дубликата фильтров Редактирование`,
"label.task":`Задачи`,
"label.emailobject.emaildetail.title.toaddress":`За:`,
"label.setup.mobile.bottombutton.select":`Выберите 4 страницы первого уровня, которые вы хотите показать в мобильном приложении.`,
"label.loginip.pagecue.invalido":`Недействительный интернет-адрес`,
"label_tabpage_listshow":`Список показывает`,
"component.newrecords.label.10records":`10 пластинок`,
"label_chatter_file":`Файл`,
"pagecreator.systemstyle.label.detailcolor":`Подробный цвет текста`,
"label.forecast.userenablepage.title":`Прогнозы Пользователи`,
"front-project-module-v1-actual_working_hours":`Отчетный человекочас`,
"vue_label_systemSettings_Security":`Сдерживание безопасности`,
"label.processsetting.two.select.key.fields":`Шаг 2: Выберите ключевые поля для каждого этапа процесса и обеспечьте руководство`,
"label.page.display1":`Записи на страницу`,
"label.appointmentpage.wizard.subtitle1.2":`Часовой пояс пригласителя {0}`,
"label.ggReleaseRange.searchTeam":`Поиск в публичной группе`,
"chatter.group.searchGroup":`Введите имя группы...`,
"label_card_type":`Макет карты`,
"label.appupload.managed.tip":`Быть под контролем означает, что вы можете редактировать только определенные атрибуты.`,
"label.changemyshow":`Изменить мой дисплей`,
"label.custom.CustomQuarter":`Таможенный квартал`,
"label.tobedelete":`Для удаления`,
"label.newPage.unuse":`Твоя страница потеряна.`,
"label.product.pricebooks":`Ценники`,
"label.mobile.layout":`Макеты страниц мобильных устройств`,
"label.multilang.file.items":`{0}проекты:`,
"label.app.step4.tabused":`Избранные вкладки`,
"label_ccchat_create_account":`Создать учетную запись`,
"message.startusingprocess":`После активации этой процедуры утверждения вы не можете добавлять или удалять шаги утверждения. Также некоторые атрибуты шагов утверждения не будут редактироваться. Вы уверены, что хотите продолжить?`,
"vue_label_email_please_add_a_theme":`Пожалуйста, добавьте тему перед сохранением в качестве шаблона`,
"label.please.create.a.target.record.first.":`Пожалуйста, сначала создайте запись индикатора`,
"label.processsetting.set.objandfile":`Шаг 1: Выберите объекты и поля, для которых вы хотите задать процесс`,
"label.newreport.group.data":`group（s）`,
"label.notcreatenew":`Не создавайте новых возможностей при конверсии.`,
"lable.custom.CurrentandPreviousCY":`Текущий и предыдущий CY`,
"front-epwechat-module-v1-input-androidschema":`Пожалуйста, введите схему Android`,
"label.projectManagement.unfinished.quantity":`Незавершенное количество`,
"label.visualpage.idandname":`Page ID и Page Name is:`,
"label.approvingprojects":`Пункты для утверждения`,
"label.partnerCloud.financeSetting.weChat":`Необходимо открыть сервис WeChat и заключить соглашение о коллекторских услугах с Tencent. Комиссия за транзакцию будет взиматься Tencent с получателя платежа.`,
"label.quickbooks.viewlist.view":`Посмотреть`,
"label.knowledge.category.hint.ten":`Неактивированная группа категорий`,
"report_type_label_productPricebooks":`Продукция и ценники`,
"label.fenbeitong.description":`Проверьте и включите форму заявки на поездку FenBeiTong, чтобы помочь сотрудникам в заявке на деловую поездку и возмещении расходов на поездку.
расходы`,
"label.ccchat.upload.change":`Что изменилось? (необязательно)`,
"label.emailsync.status.log":`Журнал подключения`,
"label.addnew":`Добавить Новое`,
"UG_contact_05":`Создать контакт`,
"label.appupload.componet.queryerror":`При поиске omponent произошла ошибка. Пожалуйста, свяжитесь с вашим администратором.`,
"label.salescloud.setting":`Настройка продажи в команде`,
"label.recurrencetimetriggeroperate":`Действия с периодическим триггером времени`,
"label.event.moveup.4day":`4 дня вперёд`,
"No.Hisitory.Activity":`Никакой исторической деятельности`,
"label.validate.function.funcFormat.MINUTE":`МИНУТА(дата)`,
"label.recentview.seloption3":`Недавно модифицированный`,
"label.login.access.nopermission":`--Нет доступа...`,
"label.taskmenuandlink":`Кнопки задач и ссылки`,
"label.forecast.customforecast.foredis.sbw":`Миллионы`,
"lable.PowerProcess.created.event":`создать веху`,
"label.stdashbord.xsld.funnelchat":`Таблица воронки продаж`,
"label.step1.total7":`Шаг 1 из 7`,
"label.sendsms.batch.chosepersion":`Массовые SMS: Выберите получателей`,
"Lead.Scoring.Setting.Rule.Setup.Value":`Оценка`,
"label.ccdocument.isdel.folder":`Вы уверены, что хотите удалить эту папку?`,
"label.discard_change":`Да, отбросьте изменения`,
"label.knowledgebase.assign":`Назначить`,
"PersonalInfo_LoginHistory_001":`Браузер подтверждает ссылку на регистрацию в вашем почтовом ящике.`,
"label.globalselect.deletedvlaue":`Глобальный набор значений удален`,
"label.ems.lookup2":`Поиск`,
"label.dataimport.system.unable.determine":`система не может определить потерю`,
"label.weixin.invitation.consultant":`Приглашенный консультант`,
"label.salescloud.salesdashboard.phone.rankings":`Рейтинг набора`,
"label.knowledgebase.plan.release":`План публикации`,
"label.integrations.first.half":`Текущий вид в целом`,
"label.icon.123":`Аптечка первой помощи`,
"label.leadscore.isactivity":`Активный сайт`,
"front-epwechat-module-v1-corpid":`WeCom ID (Corpld)`,
"label.createnewcustomer":`Новый аккаунт`,
"front-lightning-module-v1-details-page-chart-tittle":`На странице детализации можно вставить модули диаграмм и графиков, причем можно вставить до 10 диаграмм отчетов. Например, вы можете добавить модуль диаграммы отчета для записи с типом записи Агент в объекте Счета, добавить в модуль диаграммы суммы продаж по заказу агента и квартальный отчет о продажах агента, а также отфильтровать по имени счета для просмотра соответствующих данных непосредственно на странице детализации счета агента.`,
"label.customobjects.fieldsrelation":`Пользовательские поля и отношения`,
"label.dashboardSetup.left":`Налево`,
"label.mobile.app.sectionpart":`Раздел мобильных приложений`,
"setup.mainpage.label.welcome25":`Инструкции: Щелкните по меню в левой части этой страницы → Управление настройками → Контроль безопасности → Общие настройки.`,
"label.custombutton.edit.error":`Ошибка: Название уже используется или использовалось ранее, пожалуйста, выберите другое имя.`,
"label.icon.48":`отработанный вентилятор`,
"label.tabularreport.step2":`Шаг 2 Выберите столбец отчета`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.two":`Два`,
"UG_quota_01":`Управление котировками счетов`,
"label.customcomponent.btn.usewhere":`Где это используется?`,
"label.quickbooks.searchresault.email":`Email`,
"label.emailobject.appointment.urltext2":`зарезервировать время здесь`,
"label.tianyancha.field.relation.error":`Пожалуйста, сначала установите связь между полем Тяньянча и полем заказчика.`,
"APPIntegration_Social_facebookerror":`Вы должны ввести действительный URL-адрес для facebook.com.`,
"label.notification.arketsea.transfer":`{5}передано из {2} в {3}`,
"lable.SalesCommitmentKanBan.allreceivingTaskRate":`Общее количество поступлений Ставка выполнения задачи`,
"UG.Account.04":`Фильтрация учётных записей пассивных запросов`,
"this.week":`эта неделя`,
"label.email.track.attachment.num.control1":`Количество загруженных файлов превышает 10 и не может быть загружено`,
"label.exchange.sync.state.event":`События`,
"vue_label_systemSettings_websitesetting":`Вебнастройка`,
"vue_label_file_replace_reason":`Причина замены`,
"label.version.feature":`Особенности`,
"E":`Email`,
"label.escalation.setup.entrydetail.escalation.notifyTemplate":`Шаблон`,
"label.chosesubject.meet":`Устроить встречу`,
"UG.ST.003":`У вас нет прав на создание {0}, обратитесь к администратору, нажмите кнопку подтверждения, чтобы перейти непосредственно к интерфейсу {0}.`,
"label.authorization.failure":`Авторизация не прошла. Пожалуйста, пройдите повторную авторизацию!`,
"label.newprocessstep3":`Шаг 3 Укажите свойства редактирования поля утверждения и записи`,
"lable.outlook.mcto.mostrecord":`Рекорд с наибольшим количеством действий`,
"vue_label_normal_select":`Выберите`,
"label.partner.workspace.login.buttontext":`Текст кнопки`,
"template.chart.ydschdtj":`Статистика ежемесячных кампаний`,
"label.ServiceCloud.zichanmingcheng":`Название актива`,
"label.productsales.oppor.nooverdue":`Хорошая работа, никаких просроченных возможностей.`,
"label.appointment.wizard.subtitle3-5":`пятница`,
"label.payment.the.current.version":`Текущая подписка`,
"label.reportlist.top":`Исправлено наверху`,
"label.emailobject.emaildetail.prompt":`Симптома`,
"label.weixin.endst":`Время окончания не может быть до начала.`,
"report_label_knowcreatehighlevelreport":`Как создать расширенный отчет?`,
"label.quickbooks.view.openestimates":`Открытые оценки`,
"label.url.cannot.empty":`URL не может быть нулевым!`,
"label.emailnoticetemplate":`Шаблоны уведомления по электронной почте`,
"calendar.tips.task":`Сегодня нет задачи`,
"label_partner_all_operate":`Операция`,
"message.duplication.label.cancelbutton":`Отменить`,
"vue_label_SMS_addcontact":`Добавить контакт`,
"label.martrixreport.setsumfield2":`Выберите поле, которое использовалось в качестве сводного столбца в матричном отчете.`,
"approval_request_email_body":`Следующие пункты запрашивают approval: \n, нажмите на ссылку ниже на approve: \n.`,
"label.emailobject.emaildetail.field.record":`Запись`,
"label.tab.page":`Страница`,
"label_tabpage_prepagez":`Отображение на каждой странице`,
"label.iran.daylight.time":`стандартное время Ирана`,
"label.event.nextweek":`следующая неделя`,
"fliter.lastmonth":`последний месяц`,
"label.group.no.recent.search":`Совпадений между недавно просмотренными группами нет.`,
"label.h5.act.confirm":`Подтвердить`,
"label_tabpage_mypotentialcustomers":`Мои зацепки`,
"label.tabpage.queuez":`Очередь`,
"label.batch.edit.description":`Выберите поля, которые вы хотите редактировать, выберите по крайней мере одно поле и до 5.`,
"label.batchadd.newbatchpage.deltr":`Держитесь хотя бы на линии.`,
"label.industrialandcommercialverification.instructions2":`Используемая вами версия бесплатна, а максимальное количество запросов - 10 000 раз в день. Если Вам необходимо расширить количество запросов, рекомендуется приобрести услугу. После покупки услуги Вы получите токен от продавца, настроив его на этой странице. Продавец продолжит предоставлять Вам соответствующую платную услугу.`,
"label.rejectrequestbehaviour":`Выполните все отклонения <strong> и </strong> все окончательные отклонения для этого шага. (Final Rejection)`,
"label.batchCopy":`Пакетное клонирование`,
"label.service.two":`Некоторые фильтры определены, но на них нет ссылок в разделе Дополнительные фильтры.`,
"label.data.import.setup.detail.remark":`Если вы отметите следующие опции, то это будет выполняться в данных импорта.`,
"vue_label_file_delete_lib":`Удалить файловую библиотеку`,
"label.integerdigit":`Количество цифр слева от десятичной запятой`,
"label.profile.standardobjcontrol":`Стандартные разрешения на объект`,
"label.reportrecords":`Записи`,
"label.noplan":`У вас нет запланированных мероприятий на следующие 7 дней.`,
"label.visualpage.ytype":`Приборные панели`,
"label.branch":`;`,
"label.knowledgebase.new.article":`Новая статья`,
"label.Addressbook":`Контакты`,
"label.delete.reward.groups":`Удалить группу котировочных линий`,
"label.appexchange.uninstallpage.message1":`Постоянно удалять все компоненты в этом пакете （listed below）.`,
"chatter.group.everyone":`Все пользователи`,
"label.cooperation":`Сотрудничество`,
"label.uploadfail":`Загрузка Ошибка`,
"to":`на`,
"button_partner_delete":`Удалить`,
"attachment_select_warning_001":`Вложение заархивировано, кнопка "Архив" недоступна, пожалуйста, выберите вложение заново.`,
"label.step4.total4":`Шаг 4 из 4`,
"label.login.access.avalid":`Истекает сегодня`,
"label.defaultview2":`Заминированный список`,
"vue_label_commonobjects_detail_style":`Стиль покупки`,
"label.selectfield":`Выбрать поля`,
"label.report.select.column.collect":`Выберите столбец для подведения итогов`,
"lable.currencyAdv.newdaterate.existeddate":`Эта дата уже используется для HKD. Пожалуйста, укажите другую дату начала.`,
"pagecreator_systemstyle_button_new":`новый стиль`,
"label.ccchat.person.invite":`Приглашаем коллегу`,
"label.sendemail.recycle.clear":`Очищенная переработка`,
"label.usermanage.view.notexist":`Вид не существует`,
"setup_chatter_enabled":`Недоступно, пожалуйста, свяжитесь с администратором, чтобы включить CCChat.`,
"UG.Contract.01":`Управлять контрактом`,
"label.martrixreport.2018.step4":`Шаг 4 Выберите критерии отчета`,
"message.errorinscript":`Проблемы со сценарием исполнения.`,
"label.knowledgebase.modification.date":`Измененная дата`,
"label.projectManagement.the.maximum.number.of.fees.is.10":`Для стоимости можно ввести до 10 цифр`,
"label.list.isActiveNewApproval":`Включить новую страницу утверждения`,
"label.mobile.main.page.icon.setup":`Настройки иконки мобильного приложения`,
"label.select.customer":`Выберите счет`,
"label.sharerule":`Настройки совместного использования`,
"label.fiscal.FY":`финансовый год`,
"label.appupload.component.type.customfield":`Настраиваемое поле`,
"label.emailobject.emailsend.sendindividually":`Отправить индивидуально`,
"label.new_formname":`Имя новой формы`,
"label.appointment.wizard.notif1":`Время окончания не должно быть раньше времени начала.`,
"front-console-conversation-evaluate-desc":`Ответ на оценку от {evaluateInfoName}`,
"homepage.components.lasttime":`Последняя измененная дата`,
"vue_label_commonobjects_view_chart_deletechart":`Удалить диаграмму`,
"label.multilang.document.upload.fail":`{0} файлы были загружены успешно и {1} файлы не удались`,
"UG_contact_03":`Отслеживать контакты в одном месте, сигналы продаж`,
"label.marketsea.istoseafromother":`Разрешить передачу из других свинцовых бассейнов`,
"label.datamanage":`Управление данными`,
"label.globaloperation.operationtype.create.data":`Создать запись`,
"label.customer.tab.step2.see":`Табличка Видимость`,
"label.wtd.changefields.desc":`После того, как пользователи отправят форму, они будут перенаправлены на указанный URL-адрес возврата на вашем сайте, например, на страницу "спасибо".`,
"label.ems.eamilinfo":`электронная информация`,
"label.recordtypeselect.new":`Новый тип записи`,
"vue_label_report_output":`Тип формулы выхода`,
"label.emailnotice":`Оповещение по электронной почте`,
"label.icon.196":`Туалетная бумага`,
"label.emailsync.status.disabel":`Неактивный сайт`,
"label.tabpage.isdeleterecord":`Если удалить выбранную запись`,
"message.selectoneoftypes":`Пожалуйста, выберите один из следующих типов`,
"label.import.index.createid":`Создать идентификатор`,
"vue_label_systemSettings_social2":`Настройка аккаунта в социальных сетях`,
"label.ccpeak.sel.time":`Запланированные классы в этой папке`,
"label.data.downpage.i_list.desc1":`Во время импорта данные, которые не были успешно импортированы из-за неправильного форматирования, или из-за неудачного правила триггера или проверки, генерируют CSV-файл для отображения на текущей странице. Успешно импортированные данные не будут отображаться на текущей странице.`,
"label_adjust_forecast":`Скорректировать прогноз`,
"vue_label_normal_lead_sf":`Ведущий`,
"vue_label_report_notice1":`Отчет содержит несохраненные изменения. Если вы закроете отчет, эти изменения будут потеряны. Нажмите кнопку "Сохранить и закрыть", чтобы сохранить изменения.`,
"label.notfiledpublicreport":`Неопубликованные публичные отчёты`,
"one":`Один`,
"UG.Lead.008":`код сканирования визитки`,
"label.archived":`Архивный`,
"label.standardabstractfield":`Стандартные суммарные поля`,
"vue_label_notice_add_fail":`Добавить не удалось`,
"label.sendemail.registIMUser.addresserror":`адрес электронной почты получателя неверен`,
"label.ccdocument.toolbar.switch":`Переключатель панели инструментов`,
"first":`Первый`,
"label.icon.147":`Мышь`,
"vue_label_jihui_er":`Возможность 2`,
"label.ccchat.micropost.isedit":`Модификация сообщений и комментариев`,
"label.department.next":`Следующая страница`,
"front-kefu-moudle-confirm-disable-phone-user":`Вы уверены, что отключили дозвон для пользователя {0}?`,
"label.reportsSubscription.time.meets.subscription.frequency":`Дата начала и окончания не соответствует частоте подписки!`,
"lable.account.NextpDays":`Следующие 120 дней`,
"UG_opportunity_007":`Контактная роль`,
"label.encrypt":`Зашифрованный`,
"label.knowledge.category.hint.three":`Удаление или замена существующей категории, при этом удаляются все катетоги, связанные со статьей.`,
"label.customcomponent.usewhere.info":`Ниже приведены все ссылки на этот компонент. Нажмите на ярлык ссылки для просмотра определения.`,
"vue_label_import_addandupdate":`Добавить и обновить`,
"label.email.all.members":`Отправить всем членам группы по электронной почте`,
"component_task_button_save":`Сохранить`,
"label.file.deleted.unavailable.desc":`Файл удаляется, выходит или недоступен сейчас.`,
"label.emailsync.status.viewlog":`Журнал просмотра`,
"label.marketsea.othersetup":`Другие настройки`,
"label.data.exp.newtemppage":`Шаблон Создать страницу`,
"vue_label_lead_score_successsful":`Успешно очкованная оценка`,
"label.sendemail.activity.newtask":`Дорогой #belongtoidccname, hello:\r\n Ваш коллега #createbyidccname назначил Вам новое задание в #created, которое выглядит следующим образом:\r\n subject:#subject\r\n due date:#expireDate\ r\n related item: #relatedstr\r\n контент: #remark\r\nfor подробнее, пожалуйста, посетите эту ссылку:\r\n #path\r\n #orgNameCRM system`,
"component.event.label.soon":`Немедленно`,
"label.forecast.shrepage.getlist":`Вернуться к Прогнозной Иерархии`,
"UG.solution.02":`Решение - это внутреннее решение проблемы, с которой сталкивается учреждение.`,
"label.weixin.data.approval":`Запись находится на утверждении`,
"label.build.pagelist":`Список страниц создателей`,
"label.customsetting.type.hiberarchy":`Иерархия`,
"label.forecast.ccfh":`Лучший случай`,
"label.Current.Window":`Отображение в существующем окне`,
"label.appointmentdetail.wizard.title20":`план воскресенья`,
"label.emailaddress":`Почтовый адрес`,
"label.qetting_notifications":`Не получаете наши электронные письма? Убедитесь, что вы добавили адреса электронной почты CloudCC в свой список разрешений и включили уведомления об экспорте.`,
"Homepage.News.001":`Новости`,
"label.runreport":`Отчёт о пробеге`,
"label.customer.tab.step3":`Шаг 3 Добавить в пользовательские приложения`,
"label.dashboard.snapshot.refresh":`Обновить`,
"label.approvepagelayout3":`Утвердить макет страницы`,
"vue_label_SMS_send_messages":`Отправка сообщений`,
"label.executestate.old":`Выполнено`,
"label.approvalstep3":`Шаг 3 Выберите Назначенное утверждение`,
"label.step3.total6":`Шаг 3 из 6`,
"front-kefu-moudle-v1-delete-templete":`Удалить шаблон`,
"label.data.downpage.e.title.num3":`3、Пользователи могут создавать экспортные шаблоны в соответствии с их потребностями и выбрать пункт "Экспорт по шаблону", который может сделать экспортную операцию более удобной.`,
"label.attendance.outer":`Мобильный работник`,
"setup_layout_button_selectall":`Выбрать все`,
"chatter.photo.img":`Максимальный размер файла - 2 Мб.`,
"front-dynamiclayout-module-v1-required":`Поле {required} устанавливается как требуемое.`,
"label.mytask":`Мои задачи`,
"label.edit.customerinfo":`Редактирование профиля компании`,
"label.processsetting.process.explain":`Настройка и использование процесса позволяют пользователям сосредоточиться на самых важных пунктах и в нужный момент показывают им ключевые слова и подсказки, помогающие завершить процесс.`,
"label.emailobject.subject":`Тема`,
"label.mobileapp.scansetting.message":`Выберите, сохранять ли отсканированные карточки в формате изображения в соответствующий список "Примечания и вложения" в соответствии со сценарием фактического использования. <br>Включено: отсканированная карта автоматически сохраняется в вложении во время сохранения записи. <br>Открыто: сохранить только запись.`,
"front-epwechat-module-v1-android-autograph":`Подписание приложений для Android`,
"label_component_helper_potentialcustom":`Свидетельства, назначенные вам сегодня`,
"label.projectManagement.nodata.week.work":`Давайте добавим задачи, чтобы лучше организовать работу на этой неделе.`,
"label_tabpage_rolez":`Роль`,
"label.importsourcestep4":`Шаг 3 Импорт ваших файлов`,
"label.icon.50":`Компас`,
"lable.service.prompt":`Невозможно создать новое поле, количество полей достигло предела.`,
"label.campaign.channel.input.page":`Укажите веб-страницу, обычно устанавливая домашнюю страницу кампании в качестве страницы благодарности.`,
"UG.homepage.001":`Выигрывайте больше сделок за меньшее время`,
"label.step4.total6":`Шаг 4 из 6`,
"label.partner.required":`Ошибка: домен не может быть пустым`,
"label.tag.manage.title":`Манаж...`,
"label.data.downpage.i_title.num1":`Система поддерживает только распространенный формат CSV.`,
"label.custom.quarter.end":`Индивидуальная дата окончания квартала`,
"label.layout.distribute":`Макет страницы Назначение`,
"label.version.allsms":`Mas SMS`,
"label.tolead":`Импорт`,
"label.texttemplate.usemergefields":`Используйте встроенные поля в шаблоне SMS.`,
"label.emailobject.sure":`Конечно`,
"lable_setup_mobilesetup_isenbaleh5newandedit":`Если включить h5 в мобильной стороне и отредактировать`,
"label.tabpage.messagez":`Пожалуйста, введите комментарий`,
"label.mobile.phone.write.day.report":`Новые ежедневные рабочие заметки`,
"label.data.setok.e.desc2":`Список данных экспорта Страница`,
"label.emailsync.message":`Симптома`,
"label.sales.page.mubiao":`Достичь цели`,
"label.ccdocument.list":`Просмотреть последний документ`,
"label.tabpage.userGuidez":`руководство пользователя`,
"label.report.fields":`Доступные поля для отчетов`,
"vue_label_checkduplicate_at_same_time":`Удовлетворяйте все одновременно`,
"label.sms.phone":`Сервисный Телефон`,
"UG_ST_004":`У вас нет управления данными - "разрешение на импорт данных", пожалуйста, свяжитесь с администратором, нажмите кнопку подтверждения и перейдите непосредственно к интерфейсу {0}.`,
"label.mobile.nobindmobile":`Этот мобильный номер сейчас не существует. Пожалуйста, привяжите номер мобильного телефона из информации о пользователе`,
"label.partnerCloud.basicSetting.intro":`CloudCC поддерживает создание нескольких сайтов для партнеров разных типов и отдельную настройку страницы входа, меню и прав доступа. Например, розничные продавцы могут создавать различные сайты для местных агентов и рекламных партнеров.`,
"label.trigger.targetobject":`Целевые объекты`,
"label.ems.emailsyncperiod":`Период синхронизации электронной почты`,
"lable.Transformation.mode":`Режим трансформации`,
"label.emailobject.new.template":`Добавить новый шаблон`,
"label.System.Setting":`Системные настройки`,
"label.emailtocloudcc.button.addemailaddress":`Добавить почтовый ящик предприятия`,
"lable.a.total.of.invoices":`Всего 0 счетов-фактур`,
"label.multilang.customforcast.forecasthistory":`История прогноза {0} :`,
"label.role":`Роли`,
"advancedconditions":`Расширенные условия фильтрации`,
"label.tabpage.beginz":`Начать`,
"label.campagin.roi.khzhsl":`Количество конвертированных счетов`,
"chatter.poll.option5":`Выбор 5`,
"label.weixin.horse.club.registered":`Регистрация пользователей Aid-Max`,
"frame_personinfo_label_resizeimage":`Чтобы настроить изображение эскиза, перетащите и измените размер пунктирных линий на изображении профиля выше.`,
"label.file.share.select.warning":`Он был настроен для обмена!`,
"label.event.this.week":`эта неделя`,
"label.data.import.object.label":`Этикетки объектов`,
"label.visualpage.folder":`Нефилированные папки страниц`,
"vue_label_report_saveandclose":`Сохранить и закрыть`,
"label.newdashboardpage.saveto":`Сохранить до`,
"label.partnerCloud.financeSetting.developerIDTwo":`Идентификатор разработчика`,
"lable.PowerProcess.created.ago.please":`Прежде чем создавать процесс, пожалуйста`,
"label.chatter.myfollowers":`Мои последователи`,
"label.campaignmember.main.duplicatelist.title":`Кампания "Мемберы": Сканирование кода для поиска дубликатов настроек`,
"label.group.no.recent2":`Поиск групп для присоединения`,
"label.icon.110":`Книга`,
"label.merge.my.account":`Объединить мои счета`,
"setup.layout.button.quicksave":`Быстрая экономия`,
"pagecreator.page.message.canntdelete":`Текущая страница не может быть удалена`,
"label.report.printable.view":`Просмотр для печати`,
"ccchat_fieldtrack_fieldchange":`Изменение с {0} на {1}`,
"label.email.bcc":`Bcc`,
"label.sso.saml.sp.idpcert":`Сертификат поставщика идентификационных данных`,
"label.step2.total2":`Шаг 2 из 2`,
"lable.product.pricebooks.isn":`Книги Активных цен`,
"labal.emailtemplate.namemassage":`Уникальное имя почтового шаблона уже существует, пожалуйста, отредактируйте его заново.`,
"only.one.field":`Можно выбрать только одно поле.`,
"label.weixin.appr.audittime":`Дата утверждения`,
"pagecreator.page.button.delete":`Удалить`,
"front-kefu-moudle-v1-Session-start-time":`Сеанс начинается в:`,
"label_chatter_state":`Статус`,
"vue_label_systemSettings_lightningcustom":`Пользовательский пользовательский интерфейс в Lightning`,
"label.searchs":`Поиск`,
"label.mobile.phone.not.read":`Неотредактированный`,
"label_chatter_allweather":`Всепогодный`,
"label.enter.number":`Пожалуйста, введите целое число между 0-6.`,
"front-epwechat-module-v1-addressbook-desc":`Если эта функция включена, контакты и отделы в WeCom будут синхронизированы с пользователями и ролями CloudCC`,
"label.emailfield":`Поля электронной почты`,
"pagecreator_button_next":`Следующий шаг`,
"label.more.select.merge.records":`Для объединения можно выбрать только до 3-х данных.`,
"lable.edit.queue.selobjct":`Избранные объекты`,
"label.reportsSubscription.editsubscribe":`Редактировать подписку`,
"label.selectfieldtoautotransmit":`Выберите поле, используемое для автоматической маршрутизации утверждения.`,
"label.ccpeak.need.topass":`Нужно перейти в`,
"label.checkfield.merge":`Слияние`,
"front-lighting-module-v1-detail-file-downlaodInfo":`Запись заблокирована и недоступна для загрузки файлов. Пожалуйста, свяжитесь с администратором для разблокировки.`,
"vue.please.enter.a.chart.name":`Пожалуйста, введите название графика.`,
"label.data.dataexptemplate.desc3":`Режим экспорта The действителен только для экспортированных данных и не является валидным для шаблона экспорта. Формат файла для шаблона экспорта - CSV.`,
"label.setup.mobile.homepageshortcuts.setting":`Настройки функции быстрого доступа к домашней странице`,
"label.ems.connect.success":`Электронная почта тест удалось`,
"label.applet.text":`Для заявки на ремонт, поданной через минипрограмму, в системе может быть создана запись о случае. Пожалуйста, выберите пользователя в качестве создателя записи дела. Выбранный пользователь должен иметь разрешение на создание объекта дела. После смены владельца необходимо снова войти в минипрограмму и отправить форму отчета для вступления в силу.`,
"label.knowledgebase.parent.window":`Родительское окно`,
"label_file_size":`Использованное пространство`,
"label.allocation.department":`Назначить пользователей`,
"label.browser":`Браузер`,
"label.reportsSubscriptionPage.schedulereport.weekly.wednesday":`среда`,
"label.integrations.description1":`Экспорт данных в текущем виде`,
"label.project360":`Проект 360`,
"label.choose_formtype":`Выберите тип формы`,
"label_emailsync_status_connectstatus":`Статус подключения`,
"label.bmap.beijing.city":`Пекин`,
"label.mask.encryption.scheme":`Зашифрованный формат`,
"label.imgfield.type":`Тип изображения`,
"label.person.target.responsible":`Выберите куратора цели.`,
"label.appexchange.installedpage.installdate":`Дата установки`,
"label.partnerCloud.orderingPlatform.partnerUsers":`Эта функция доступна только для пользователейпартнеров.`,
"label.profile.customfieldsafety":`Настраиваемая безопасность на полевом уровне`,
"label.no.target.models.available.":`Нет доступных моделей индикаторов. Пожалуйста, создайте модель индикатора или свяжитесь с администратором.`,
"label.process.execute.tip":`Ваш запрос был обработан, массовое одобрение или массовый отказ займет некоторое время, и система сообщит вам по почте о завершении обработки.`,
"label.app.step2.introduce":`Введите следующие поля для определения пользовательского приложения`,
"label.loginip.cue":`Диапазон IP-адресов не указан, и пользователи с любого IP-адреса могут входить в систему.`,
"label.step1.select.tablayout":`Шаг 1 Выбор макета вкладки`,
"mainpage.setup.chosecomponent.leastone":`Вы должны выбрать один компонент, по крайней мере, на главной странице.`,
"label.custom.quarter.name":`Название пользовательского квартала`,
"chatter.ptup.link":`Разместить ссылку`,
"label.compact.layout.frame.error2":`Подробная информация и соответствующий список должны быть на левом экране`,
"vue_label_salesfunnel_notice7":`Общее количество бизнес-возможностей с вероятностью 100% Общее количество бизнес-возможностей с вероятностью 0% или 100%`,
"label.multilang.datamanage.dataimport.lostmsg":`Длина заголовка &nbsp;{0}&nbsp; но длина данных &nbsp;{1}&nbsp; система не может определить, какие &nbsp;{2}&nbsp; поля являются избыточными.`,
"label.owner.notnull":`Владелец не может быть пустым`,
"label.logintime.pagecue.invalidt":`Время начала не может быть больше времени окончания.`,
"vue_label_file_checked_num_limit":`Количество выбранных файлов превышает лимит`,
"front-email-payment-repayments":`Заплати еще раз`,
"template.report.today.prospects":`Ведущие сегодня`,
"label.weixin.appr.status":`Статус`,
"label.knowledge.language.japanese":`Японский`,
"label.event.reminder.lead.time":`Напоминание`,
"lable.custom.dep":`Нажмите кнопку Новый, чтобы определить новый пользовательский год.`,
"Dashboard_View_Createdbyme":`Приборные панели Созданные Мной`,
"label.file.upload.fail":`Не удалось загрузить файл`,
"label.manager":`Менеджер`,
"label.stdashbord.xsld.business.jine":`Сумма`,
"label.tag.manage.tag":`тег`,
"chatter.nlk":`В отличие от`,
"label.file.search.people":`Поиск людей`,
"message.error.domain.format":`Доменные имена могут состоять только из английского языка и массивов`,
"label.firstisdefault":`Использовать первое значение в качестве значения по умолчанию`,
"label.discount":`Скидка`,
"label.mobile.phone.have.read":`Пересмотренный сайт`,
"label.field_selected":`Это поле было выбрано`,
"label.payment.renew.now":`Обновить сейчас`,
"label.multilang.lookfiltercondition.notsetup":`Состояние строки {0} неверное, оператор не задан!`,
"label.projectManagement.Selectionday":`Выберите день`,
"label.user.organization.permit.licensenotstart":`Лицензия вашей организации не была активирована, пожалуйста, повторите попытку после того, как лицензия будет активирована.`,
"label.download.save.attachment":`Загрузить и сохранить во вложении`,
"lable.outlook.mcto.must":`Должен быть в формате электронной почты.`,
"vue_label_notice_unfollow_success":`Успешно разворачиваться`,
"label.taskinfo":`Шаг 2 Настройка задачи`,
"label.other.SMS":`Другие телефонные номера`,
"label_partner_workspace_login_logo":`Логотип заголовка`,
"label.weixin.data.lock":`Запись заблокирована.`,
"label.Yaxis":`Y-Axis`,
"lable.edit.queue.selobjdes":`Выберите объекты, которые вы хотите назначить этой очереди. Отдельные записи для этих объектов могут затем принадлежать этой очереди.`,
"label.campagin.roi.dcfezb":`Посещаемость`,
"label.marketseamemset.maximum":`Максимальное количество`,
"label.owner":`Владелец`,
"label.reportsubscribe.error.noview":`Пожалуйста, заполните, какой пользователь вы хотите запустить этот отчет, как в разделе "Запуск как".`,
"label.icon.133":`Папка`,
"vue_label_file_share_files":`общие документы`,
"label.searchlayoutfilterfields.remark":`Выберите столбцы поля фильтра, которые будут отображаться при поиске на боковой панели домашней страницы и при поиске на закладке "Главная страница".`,
"vue_label_help_contract":`План по контракту и сбору платежей`,
"component.chatter.button.message":`Комментарий`,
"label.marketsea.recyclereminddays2":`Напоминание о дне (должно быть меньше, чем количество дней без последующих действий после получения)`,
"label.webtocloudcc.input.information":`Информация обязательна.`,
"vue_label_chatter_exit_group":`Оставьте группу`,
"vue_label_lead_notcreatetask":`Не создавать задачу`,
"front-lightning-module-v1-dashborad-date-dimension":`Дата Размерность`,
"setup.layout.label.fieldlist":`Доступные поля`,
"label.leadscore.charname":`Имя поля`,
"label.forecast.customforecast.mybest":`Мой лучший случай`,
"setup_mainpage_label_welcome24":`Облачная платформа CloudCC обеспечивает настройки безопасности доступа ко всем объектным данным в системе. Совместное использование данных и права доступа могут контролироваться путем установки различных правил и условий.`,
"label.queue":`Очереди`,
"label.icon.159":`Чип`,
"label.path":`Путь к ссылке`,
"label.app.message.failtoget":`Не удалось получить список приложений`,
"label.returntoprocess":`Назад к списку: Процессы утверждения`,
"vue_label_commonobjects_detail_more_data":`Больше нет данных`,
"label.number":`Номер`,
"label.product.find":`Найти Цены Книги`,
"label.legend":`Легенда`,
"label.partner.workspace.member.profile":`Доступные профили`,
"label.service.gantt.sum.appointments":`Завершенные сервисные назначения/Все сервисные назначения`,
"label.partnerCloud.financeSetting.paymentAllowed":`Разрешение пополнения баланса онлайн`,
"label.integrations.upgrate":`Обновление`,
"label.timzone.tip.info3":`При использовании класса календаря для обработки дат, необходимо установить часовой пояс для экземпляра календаря, и можно выбрать один из следующих двух методов для получения объектов календаря: Calendar cal=Calendar.getInstance(TimeUtil.getUserTimeZone(userInfo))和Calendar cal=TimeUtil.getCalendar(userInfo)`,
"label.ems.addaccount2":`Добавить почтовый аккаунт`,
"label.partneruser":`Пользователь-партнёр`,
"label.validate.globalvariable.user.roleId":`Идентификатор роли`,
"pagecreator.layout.button.mergecell":`Объединить ячейки`,
"label.evacuantvalue":`Исключить значения`,
"label.setup.mini.msg":`История бренда/определение сообщения`,
"label.icon.178":`Люди`,
"vue_label_pricebook_notice_cantbedeleted":`Запись в прайс-листе не может быть удалена, так как в прайс-листе уже есть записи. Вы можете пометить прайс-листы как неактивные.`,
"vue_label_appstore_application_recommendation":`Популярные рекомендации по применению`,
"label.version.createlimit":`Ваше текущее издание CloudCC {0}, и вы можете создать {1}. {2}. Теперь количество {2} превысило максимальное значение вашего тарифного плана, пожалуйста, обновите вашу версию CloudCC.`,
"message.duplication.label.sectionremar1":`Выберите значения, которые вы хотите сохранить в объединенной записи. Выделенные строки указывают на поля, содержащие конфликтующие данные. Выбранная Главная запись сохранит значения полей только для чтения и скрытые.`,
"label.icon.1":`Облако`,
"label.salescloud.salesdashboard.sales.performance":`Итоги договора купли-продажи`,
"System_AddressFieldType_Post":`Почтовый индекс`,
"setup_object_field_dependency_label_mustone":`Вы должны выбрать хотя бы одно значение зависимого поля.`,
"label.appointmentdetail.wizard.title6":`Местоположение`,
"label.layout.testobj2":`Тестовый объект 2`,
"label.searchlayout.dupcacher.field":`Нажмите на ссылку "Поиск дубликатов" и "Объединить", чтобы просмотреть дубликаты полей.`,
"label.attendance.persons.title":`Подходящие пользователи`,
"template.report.product.sales":`Реализация продукции`,
"label.editCustomReportType":`Редактирование источника данных пользовательского отчета`,
"label.multilang.ui.setup.profile.alltime":`Всегда {0}`,
"label.service.dispatchingUnits.noservice.booking":`Без записи на обслуживание`,
"label.validate.remark4":`Убедитесь, что номер находится в пределах определенного диапазона, например, скидка менее 30%.`,
"front-kefu-moudle-v1-Waiting-time":`Время ожидания:`,
"label.weipagelayout.remark":`Используется в мобильном приложении или на странице WeChat.`,
"vue_label_wang_er":`Майкл`,
"label.pw.text":`Пожалуйста, введите пароль для {user}, и убедитесь, что он содержит как минимум`,
"message.error.user.data.null":`Информация о пользователе не может быть пустой!`,
"chatter.like.p":`Как этот пост`,
"label.page.double.column.style.cloudcc":`Стиль из 2 колонок предоставляет полезные функции CloudCC.com, такие как Поиск и Недавние предметы, на той же странице, что и ваше встроенное содержимое.`,
"label.h5.iscloseaccount":`Ты уверен, что хочешь выйти из системы?`,
"label.dataimport.insertdata.id.error":`Ошибка формата, пожалуйста, используйте комбинацию букв и цифр.`,
"label_tabpage_sum":`Всего`,
"front-epwechat-module-v1-addressbook-sync":`Синхронизация книги контактов`,
"label.setup.mobile.offlinecache.mostsave":`Платформа может установить по умолчанию включенную мобильную сторону оффлайн вкладки до 10`,
"label.weixin.quickcreate":`Быстрое создание`,
"label.forecast.edittotal.de.mubiao":`Quota`,
"label.icon.144":`Гарантия`,
"label.icon.155":`Изображение`,
"label.In.the.search":`Поиск`,
"message.validation.isnotdateISO":`Недействительная дата (ISO)`,
"label.service.appointmentList.send.successfully":`Успешная отправка`,
"label.dynamicpage.error.exist":`Динамические данные о макетах страниц не существуют`,
"vue_label_SMS_otherpeople":`и {0}другие`,
"label.cloudccsite.url":`URL-адрес сайта`,
"label.tabpage.contactsz":`Контакты`,
"vue_label_commonobject_notice_clickthename":`Если вам нужно загрузить загруженный файл, пожалуйста, нажмите на имя файла`,
"vue_label_file_new_lib":`Новая библиотека файлов`,
"label.chatter.card":`Карта`,
"chatter.feed.menutype.user.allusercom":`Все Коллеги`,
"label.exchange.sync2":`Настройки`,
"template.report.year.income":`Доходы текущего года`,
"label.partner.template.detail":`Описание функций`,
"label.setup.service.template":`Шаблон отчета об оказании услуг`,
"label.dataimport.insertdata.id.length":`Ошибка формата, пожалуйста, проверьте эту запись и измените ее. Обратите внимание, что длина менее 20 символов.`,
"label.partnerCloud.financeSetting.collaborator":`Идентификатор кооператора`,
"label.processskipwizard":`Мастер прыжкового запуска процесса утверждения`,
"label.weixin.inputbusnumber":`Пожалуйста, введите номер автомобиля`,
"label.dashboardSetup.d1":`Точка перелома 1`,
"template.report.conversions.number.industry":`Количество конверсий лидов (по отраслям)`,
"vue_label_chat_group_chat":`групповой чат`,
"label.file.publicview.error":`Файл удален или не существует или не может быть предварительно просмотрен.`,
"label.customfields.location.locationHelpText":`Пожалуйста, укажите название места, например, "штаб-квартира". Пожалуйста, опишите и укажите специфику, и имейте в виду, что запись может иметь несколько местоположений, например, "офис продаж на западном побережье" и "офис продаж на восточном побережье".`,
"message.duplication.label.blankmatchtip":`Установите пустое поле, по умолчанию False.`,
"message.appexchange.addtopackage":`Выберите один или несколько компонентов для добавления в данный пакет!`,
"label.ems.return2query":`Вернуться на страницу запросов добавленных учетных записей электронной почты`,
"label_model_name":`Название модели`,
"label.apiname.retainapi":`Имя - зарезервированное имя системы, пожалуйста, используйте другое имя API поля.`,
"lable.Cancel.the.search":`Отменить поиск`,
"label.custom.viewport":`Точка зрения`,
"label.weixin.polls.type":`Введите .`,
"label.opportunity.setting.showstage.label":`Автопромоушн`,
"label_component_helper_businesschange_expiredtask":`Возможности для бизнеса с истекшими сроками выполнения задач`,
"label.operator":`Оператор`,
"label.ccpeak.use.class.time.listmap":`Доступ путем передачи в коллекцию List<Map>.`,
"component_timeline_label_past":`Прошлая деятельность`,
"label.mobile.phone.submit":`Представлено Мной`,
"message.recordtype.new.subtip":`Введите имя и описание для нового типа записи. Новый тип записи будет включать все значения пикировки из существующего типа записи, выбранного ниже. После сохранения нового типа записи можно будет настроить значения пропикировки.`,
"UG_product_05":`импортная продукция`,
"label.validate.globalvariable.user.id":`идентификатор пользователя`,
"label.umeng.activity.distribute":`вам поручается`,
"label.weixin.avote":`Голосовать`,
"label.weixin.already.sign":`Уже зарегистрировался.`,
"label.emailmerge.mergepage.generator":`Создать`,
"label.batchtransfer.transferto":`Перевод в`,
"label.tianyancha.industry":`Отрасль`,
"label.addattachment.name":`Имя файла`,
"label.customfields.formula.date.tip":`Для вычисления даты, например, добавить дни к другим датам или вычесть дни из других дат.`,
"label.partnerCloud.orderingPlatform.noPayment":`Не платить`,
"label.emailobject.failedtosend":`Не отправлено`,
"label.knowledge.setting.data.three":`Можно выбрать максимум {count} данных групп категорий.`,
"label.weixin.input.maxlength.langtext":`Пожалуйста, введите здесь, до 32000 символов`,
"vue_label_calendar_delete_calendar":`Удалить календарь`,
"vue_label_commonobjects_detail_filter":`Свернуть фильтр`,
"setup.layout.group.custompage":`Настроить страницу`,
"component_sendmail_label_subject":`Тема`,
"label_tabpage_maxfilez":`Максимальный размер файла`,
"label.logintime.pagecue":`Выберите дату и время, когда пользователи с этим профилем могут войти в систему. Обратите внимание, что точное время указанного часового пояса используется для всех времен. Даже если пользователь находится в разных часовых поясах, эти точные времена используются для времени входа в систему.`,
"label.salescloud.salesdashboard.datetime":`Дата закрытия`,
"label.format":`Формат`,
"label.newfoundland.daylight.time":`Ньюфаундленд Летнее время`,
"front-kefu-moudle-v1-messagetemplate.finishdetailinfo":`Скопируйте и вставьте значение поля слияния в содержимое SMSсообщения`,
"message.chooseatleastoneforshare":`Пожалуйста, выберите по крайней мере одного пользователя, чтобы поделиться`,
"label.multilang.datamanage.importobjfield":`Колонка {0}`,
"label.denglu":`Вход`,
"label.popup.infoz":`Симптома`,
"label.schedulejob.setup.schedule.onday":`Каждый месяц`,
"label.appointmentdetail.wizard.title16":`план на среду`,
"label.userphoto.dragtoadjust":`Перетащите, чтобы настроить эскиз`,
"label.product.series":`Семейство продуктов`,
"message.view.kanban.not.set.group.summary.field":`Приборная панель представлений не задает поле сводки по группам`,
"page.un.activities":`Незавершенная деятельность`,
"label.exchange.sync3":`Конфигурации`,
"label.login.activityExpired":`Период активности пользователя истек, обратитесь к системному администратору.`,
"component_chatter_file_button_files":`Выберите документ`,
"message.onlydelete.type":`Удалять можно только неактивные типы записей. Таким образом, вы можете сначала отключить типы записей, если хотите их удалить.`,
"message.recordtype.selectlayouttouse":`Макет страницы для использования`,
"label.knowledgebase.unable.restore.draft":`Вы не можете восстановить удаленные черновики.`,
"label.shangqing.name":`Бизнес-информация`,
"label.weixin.target.payment":`Целевая оплата`,
"label.chatter.sendEmailToGroupMember.check":`Посмотреть сообщения`,
"front-kefu-moudle-v1-input-single-login-area":`Введите имя домена единой регистрации`,
"vue_label_zhang_yi":`Алиса`,
"label.icon.190":`Фен`,
"label.quickbooks.fieldlabel.company":`Компания`,
"vue_label_email_are_you_sure_to_delete":`Вы уверены, что удалите почту?`,
"Pagelayout.Setup.005":`Имя должно быть поставлено на первое место.`,
"label.object.name.two":`Имя объекта 2`,
"label.tabpage.completez":`Отметьте выбранное состояние для завершения`,
"label.setup.mobile.bottombutton.saveerror":`Не удалось сохранить настройки страницы первого уровня`,
"label.report.action.addtodashboard8":`Выберите Папку Приборной панели`,
"label.data.downpage.i_list.desc3":`Пользователи могут просмотреть причину неудачи при импорте в последнем столбце файла после загрузки.`,
"label.layout":`Макет`,
"label.marketsea.button.assign":`Назначить`,
"UG.solution.03":`Создать решение`,
"label.ccchat.person.invited":`Пригласить коллег`,
"label.ccchat.person.invite.address":`Получатель`,
"label.displaytype1":`Подробная информация Ссылка на страницу`,
"label.tianyancha.h5.ziranrengudong":`акционер-физическое лицо`,
"lable.SalesCommitmentKanBan.targetReceipts":`Целевые поступления`,
"message.error.getitems.type":`getItems:type не может быть пустым.`,
"label.addattachment.list":`Были загружены следующие файлы`,
"label.datamanage.export.false":`При экспорте произошла ошибка.`,
"pagecreator.systemstyle.label.buttonfontcolor":`Текст кнопки`,
"label.emailtocloudcc.redmessage1":`Недействительный адрес электронной почты`,
"label.weixin.polls.closed":`Голосование закрыто, крайний срок`,
"label.icon.165":`Шляпа`,
"vue_label_report_detailsonly":`Только детали`,
"component.salesperformance.label.100finish":`Завершено`,
"november":`ноябрь`,
"label.data.file.generatejwd":`Генерирование службы широты и долготы по адресу`,
"label.salescloud.opportunity.access":`Возможности Доступ`,
"label.isremider.remider":`Напоминание`,
"vue_label_total":`Всего`,
"label.email.prompt.using.lightning.link":`Установите ссылку на электронную почту в системных уведомлениях в соответствии со ссылками Lightning.`,
"label.knowledgebase.cancel.attached.articles":`Отмена прикрепленной статьи`,
"label.version.custom.xslc":`Настраиваемый процесс продажи`,
"component_setup_button_save":`Сохранить`,
"label.ems.cc":`Cc`,
"label.edit.user":`Пользователи Редактирование`,
"label.emailtocloudcc.select2":`Пожалуйста, выберите тип`,
"label.industrialandcommercialverification.fieldnumber":`No. of Mapped Fields:4`,
"label.ccchat.havenot.joined.group":`Вы не находитесь ни в одной из активных групп`,
"pagecreator_page_label_pagename":`Название страницы`,
"setup.layout.button.save":`Сохранить`,
"label.campaignmember.main.updatestatus":`Статус участников кампании массового обновления`,
"label.tab.web.edit":`Редактирование Web Tab`,
"label.ring_chart":`Диаграмма пончиков`,
"label.usermanage.resetpwd.error":`Сброс пароля не удался, и пользователь не существует.`,
"label.Xaxisscope":`Ось X`,
"label.app.new":`Новое пользовательское приложение`,
"message.modifythereport":`Приборная панель использует этот отчет. Изменения могут сделать недействительным инструментальную панель, на которую ссылается этот отчет.`,
"label.component.helper.businesschange.0activity":`30 дней без активности`,
"label.weixin.fmu.noon":`{0}ПМ`,
"label.enter.rule.name":`Введите название правил`,
"lable.Confirm.recovery.potential.customers":`Подтвердите восстановление ведущего {имя}.`,
"lable.PowerProcess.type.created":`Какой тип процесса получения прав вы хотите создать?`,
"front-lightning-module-v1-dashbord-rectangle-size":`Размер ортогона`,
"label.projectManagement.new.service.appointment":`Новый сервисный прием`,
"label.multilang.totalpage2":`Всего`,
"pagecreator.systemstyle.label.styledesc":`Описание стиля`,
"chatter.up":`Загрузка`,
"2018UI_Homepage_DataDeleted_Info":`Данные, которые вы хотите просмотреть, были удалены, пожалуйста, нажмите, чтобы вернуться к предыдущему шагу.`,
"label.knowledge.draft.recordid":`Идентификатор проекта не может быть нулевым!`,
"vue_label_pool_recyclecertification":`{0}{1}{2}{3}？`,
"label.setting.intergrationlist.viewall":`Просмотреть все интеграции`,
"vue_label_file_num_limit_tip":`Количество файлов превышает установленное количество. Если вам необходимо заменить файлы, пожалуйста, сначала удалите загруженные файлы.`,
"vue_label_commonobjects_view_refreshat":`Освежился в {таймИнтервале} назад.`,
"laebe.data.exp.save.success":`Если вам необходимо использовать этот шаблон для экспорта данных, пожалуйста, вернитесь к "Экспорту по шаблону" для работы.`,
"label.mr.caption.contact":`Поиск дубликатов и слияние: Кодировки для запроса дубликатов Контактов`,
"label.webtocloudcc.submit.error":`Непредставление`,
"label.multilang.datadelete.delmessage":`Заблокированные записи ({0}) удалять запрещено:`,
"label.quickbooks.searchlist.total2":`Есть {0} несвязанные платежи на общую сумму {1}`,
"label.createnew":`Создать Новое...`,
"component.milestones.label.choicestate":`Подтвердить этот статус`,
"lable.outlook.edit.exist":`Имя этого поля уже существует. Введите уникальное имя поля.`,
"vue_label_dashboard_eachother":`Можно связать только представления из одного и того же отчета или одного и того же объекта`,
"label.new.role":`Новая роль`,
"message.error.operationType":`При обращении в сервисную службу операция не определена.`,
"label.fenbeitong.name":`FenBeiTong`,
"label.choose.person":`Пожалуйста, выберите получателей для отправки`,
"label.attendance.thanks":`Спасибо за ваш participation!`,
"label.invoice.message.statusupdatefailed":`Обновление статуса счета-фактуры прошло неудачно, повторите попытку позже.`,
"template.chart.yzhqzkhlyfx":`Анализ источников конвертированных лидов`,
"chatter.feed.menutype.user.alluser":`Все Коллеги`,
"UG_Forcast_04":`Начальное испытание`,
"label.appupload.upload.tips.profile":`Замечание: компонент "profile" был добавлен в данный пакет и не может быть добавлен повторно (разрешено добавлять до одного компонента профиля на пакет).`,
"lable.PowerProcess.leave.the.process":`{describeName} Выход из процесса`,
"template.report.sales.cycle.opportunities":`Продолжительность цикла продаж (по типам возможностей)`,
"vue_label_calendar_please_fill_in_the_calendar":`Пожалуйста, заполните название календаря`,
"label.salescloud.unit.wanyuan":`отряд (китайский юань)`,
"label.fileAPI":`Уникальное имя документа`,
"label.weixin.link":`Связанный с`,
"label.service.seconds":`сек`,
"label.encd.visible":`Зашифрованное поле видимо`,
"label.tianyancha.regstatus":`Рабочее состояние`,
"label.event.moveup.18hour":`18 часов вперёд`,
"label.upper.bound":`Верхняя граница`,
"label.please.insertURL":`Пожалуйста, введите URL-адрес для вставки.`,
"label.approval.notallowed.reject":`Отказ не допускается`,
"label.permission.fieldpermission":`Полевые настройки разрешения`,
"label.customcomponent.page.index.title":`Пользовательские компоненты`,
"label.quickbooks.viewlist.number":`НЕТ.`,
"lable.list.queue.sendemail":`Отправить сообщение электронной почты участникам`,
"label.productsales.today.noevtadd":`Открытых событий нет, в правом верхнем углу можно нажать кнопку "Добавить" для добавления нового события.`,
"label.report.line.daixuan":`Колонка "Отложенный отчет`,
"label.reportsSubscription.select.start.endtime":`Пожалуйста, выберите время начала и время окончания!`,
"template.chart.schdyscb":`Бюджетная стоимость кампаний`,
"label.sendemail.chat.addPostatsubject":`Меня упоминали в микропосте CloudCC CCChat.`,
"label.RelatedList":`Связанные с ними списки`,
"label.knowledgebase.delete.translation.associated.with.draft":`Существующий проект перевода будет связан с последней опубликованной версией статьи на основном языке. Если опубликованной версии не существует, все переводы будут удалены.`,
"vue_label_chatter_submitted_review":`Вы подали заявку на вступление, пожалуйста, подождите, пока администратор рассмотрит`,
"label.layout.list2":`Список 2`,
"label.manage.area":`Управлять территориями`,
"label.manageapproveprocess":`Управление процессами утверждения Для`,
"workflow.action.tasks.assignortype.created":`Созданный`,
"label.custombutton.nonsupport.operation":`Текущая версия не поддерживает работу стандартных кнопок и ссылок.`,
"label.ip":`IP-адрес`,
"label.chat.topic.desc.error.info":`Описание темы не может превышать 1000 символов. Попробуйте использовать более короткое описание темы.`,
"label_tabpage_cue":`Информационное напоминание`,
"label.integrations.mailchimp1":`Благодаря интеграции CloudCC с Mailchimp ваши пользователи смогут импортировать выбранные лиды и контакты из вашей учетной записи CloudCC в Mailchimp.`,
"label.email.track.required":`Необходимая информация`,
"label.set.case":`Пожалуйста, сначала установите владельца дела.`,
"label.weixin.newspaper.coverage.number":`Номер листа риска`,
"vue_label_approve_submitreason":`Основание для представления`,
"message.oppdt.noenabledpricebook":`Книги Активных цен нет`,
"label.partner.workspace.setup":`Настройки`,
"label.version.nonsupport.feature":`Эта функция временно не поддерживается. При необходимости обновите версию CloudCC.`,
"com.cloudcc.login.error.message.licenseexpired":`Лицензия истекла`,
"label.emailsync.form.signin":`Вход`,
"label.campaign.channel.input.to.chooselanguage":`Пожалуйста, выберите язык`,
"label.tabpage.gotit":`Понял`,
"front-console-no-contact-tip":`Нет данных. Пожалуйста, свяжитесь с соответствующим лицом и посмотрите.`,
"label.approval.apiname":`Уникальное имя, используемое API и управляемыми пакетами, должно начинаться с буквы, а также использовать только буквенно-цифровые символы и символы подчеркивания. Имена не могут заканчиваться подчеркиванием или иметь два последовательных знака подчеркивания.`,
"label_emailtocloudcc_filed_ssl":`Безопасное соединение`,
"component_sendmail_label_fromuser":`Отправитель`,
"front-kefu-moudle-v1-new-online-chats":`Новый онлайнагент`,
"label.searchlayout.merge.duplicated.results":`Возможность поиска дубликатов и слияния`,
"label.weixin.input.maxlength.remark":`Пожалуйста, введите здесь, до 500 символов`,
"component.telerecord.label.related":`Связанные предметы`,
"label.note":`Примечания`,
"message.duplication.label.nletters":`Персонажи`,
"label.productsales.payment.phb":`Список платежей`,
"label.forecast.editshrepage.desc":`Прогноз:Укажите обмен этой записью. Вы можете предоставить эту запись и связанные с ней данные пользователю, пользователям определенной роли или пользователям определенной роли, а также всем пользователям ролей ниже этой роли.`,
"vue.dashboard.setPenetrationSuccessful":`Успешная настройка проникновения!`,
"label.tabpage.noOperationz":`Это содержимое является фиксированным и не может быть использовано!`,
"label.email.jump":`Перенаправление на сторонний веб-сайт...`,
"label.appointmentpage.wizard.btn1":`Подтвердить бронирование`,
"label.umeng.approval.pass":`#approver утвердил ваш запрос на одобрение #obj.`,
"label.project.hit.twelve":`Напоминание об истечении срока действия вехи`,
"two":`Два`,
"label.approvedinfo":`Информация об одобрении`,
"label.import.step1.choosecsv":`Пожалуйста, выберите файл csv`,
"vue.please.select.the.expansion.method":`Пожалуйста, выберите способ расширения.`,
"UG.homepage.005":`Информация о продажах`,
"Account.News.Setting.003":`Общие настройки`,
"label.quickbooks.button.actions":`Действия`,
"lable.list.queue.email":`E-mail в очередь`,
"label.name.lastname":`Фамилия`,
"message.confirm":`Ты уверен?`,
"Opportunity.Detailed.Phase.Label.Popup.002":`Дата закрытия текущего этапа`,
"label.knowledge.setting.title":`Параметры знаний`,
"label.helptocreateprocess":`Чтобы создать новый процесс утверждения, нажмите "Создать новый процесс утверждения", затем выберите "Использовать мастер запуска", чтобы настроить процесс утверждения в несколько коротких шагов. Или выберите "Использовать стандартный мастер", чтобы настроить все параметры утверждения.`,
"label.batcheditor.remark":`Можно редактировать несколько записей.`,
"label.page":`Страница`,
"label.newfolder":`Создать новую папку`,
"label.version.interceptor.api":`API интерфейса`,
"label.sms.toaddress":`получил SMS`,
"front-kefu-moudle-noopen-callcenter":`Организация не активировала функцию центра обработки вызовов, обратитесь к администратору`,
"label.data.exp.zip":`Формат сжатия`,
"lable.account.LastcDays":`Последние 60 дней`,
"label.import.index.starttime":`Статусное время`,
"label.dashboardall":`Все приборные панели`,
"label.create_socialpost":`Новая почта`,
"label.searchlayoutedit.remark":`Выберите поля и кнопки, отображаемые при щелчке по боковой панели поиска на главной странице или при щелчке по закладке поиска.`,
"message.servicecrew.violation":`Нарушение распределения ресурсов: ресурсы службы - это члены команды в этот период.`,
"label.email.attrach.file":`Приложение`,
"report.label.folderandreport":`Отчеты и папки`,
"label.list.userinterface.sales.setup":`Настройка домашней страницы отдела продаж`,
"label.martrixreport.2018.step1":`Шаг 1 Создание группировки`,
"label.campaignmember.selectmember.memberstatus":`Статус участника кампании`,
"label.textmessage.vonage.api.key":`клавиша API`,
"label.tabpage.next":`Следующий шаг`,
"UG_Lead_006":`Посетитель сайта`,
"label.salescloud.salesdashboard.visit.rankings":`Рейтинг посещений`,
"label.myevent":`Мои события`,
"label.activity.history":`История`,
"label_tabpage_kanban":`Настройка Viewboard`,
"label.weixin.allapp":`Все приложения`,
"label.query.clone.detail.choose.choosed":`Выбранные строки Пункты`,
"message.error.view.errvalid":`Ошибка: В уникальном поле имени вида могут содержаться только символы подчеркивания и буквенно-цифровые символы. Оно должно быть уникальным, начинаться с буквы, исключать пробелы, не может заканчиваться подчеркиванием и не может содержать два последовательных знака подчеркивания.`,
"label.customfields.searchrelation.dependobject.tip":`Выберите другой объект, связанный с этим объектом`,
"label.appointment.wizard.subtitle4-4-3":`3 недели`,
"label.setup.mobile.offlinecache.saveerror":`Настройка мобильного автономного кэша не сохраняется.`,
"label.planned.started":`Запущен`,
"label.page.step4.of.step5":`Шаг 4 из 5`,
"label.tabpage.value":`Значение`,
"label.reportlist.allfolder":`Все папки`,
"label.callcenter.sure.disable.center":`Вы уверены, что нужно отключить текущий центр обработки вызовов?`,
"vue_label_commonobjects_detail_activity_tocalendar":`Перейти в Календарь`,
"label.setup.mobile.bottombutton.recovery.default":`Восстановить по умолчанию`,
"label.appointmentdetail.wizard.title15":`план вторника`,
"label.icon.15":`Порядок ремонта`,
"component_sendmail_label_touser":`На`,
"template.report.all.owner":`Владелец лидов`,
"front-Partner-email-tips":`Пожалуйста, введите электронную почту для имени пользователя`,
"vue_label_systemSettings_mobelhomepagesetting":`Настройка домашней страницы мобильного приложения`,
"label.service.newBuildDialog.aswellas":`и`,
"label.name":`Имя`,
"label.tag.search.taglist":`Список тегов`,
"label.partnerCloud.priceOfManual.theOnly":`Рекомендуется установить единственную книгу цен для каждого пользователяпартнера. Или они должны выбрать одну из нескольких ценовых книг при оформлении заказа. Стандартная книга цен применяется, если не была задана конкретная книга цен.`,
"label.knowledge.field.update":`{1} меняется с {2} на {3}`,
"label.emailobject.save":`Сохранить`,
"label.top.changeVersion":`горизонтальное`,
"label.recordtype.edit.unselected":`Существующие значения`,
"label.knowledgebase.additional.articles":`Прикрепить статью`,
"label.lead.score.confirm":`Пожалуйста, выберите диапазон scoring, click[Lead Scoring] button, and система заработает выбранную сумму в соответствии с активным правилом о начислении баллов.<br><br>Это может занять несколько минут. You получит подтверждение по электронной почте после завершения.<br><br><br>.`,
"label.projectManagement.pleaseselectadate":`Пожалуйста, выберите дату`,
"label.appointment.wizard.subtitle5":`Название встречи`,
"label_setup_failed":`Установка не удалась`,
"label.chatter.collect":`Закладка`,
"label.appointment.cancelappointment":`Отменить`,
"front-console-response":`Время отклика`,
"message.delete":`Вы уверены, что хотите удалить?`,
"label.dataimport.type.selected":`Выберите тип импорта`,
"label.new.target":`Новый индикатор`,
"vue_label_report_autoupdatepreview":`Предварительный просмотр автообновления`,
"label.knowledgebase.guidance":`Руководство`,
"label.chatter.mail":`Почта`,
"label.login.verification.scan.code.acquisition":`Сканируй код, чтобы получить:`,
"label.customsetting.changefieldtype":`Изменить тип поля`,
"label.data.dataexpalltype.all_desc2":`2. It занимает некоторое время для экспорта всех данных. После завершения экспорта вы получите по электронной почте напоминание об успешном экспорте данных.`,
"label.opportunity.contactisnull":`Никакой информации о клиентах, не может отображаться.`,
"pagecreator_layout_button_upload":`Макет загрузки`,
"label.dashboard.noRecord":`Нет Записей`,
"label.SMS.template":`Имя шаблона SMS`,
"label.c.d.without":`Записи в формате C могут иметь или не иметь соответствующие записи в формате "D".`,
"UG.Case.05":`Создать дело`,
"front-epwechat-module-v1-edit-selfapp":`Редактирование приложения, созданного Sefl`,
"label.role.createrole.tip":`Вы можете построить существующую иерархию ролей, показанную на этой странице. Чтобы вставить новую роль, нажмите <b> Добавить роль</b>.`,
"label.grouping":`Группировка по`,
"vue_label_email_upload_new_file":`Загрузить новый файл`,
"label.notification.event3":`Событие 【事件名】 начинается с 【开始时间】.`,
"labe_benchmark_objects":`Объект ссылки`,
"component.chatter.button.collect":`Закладка`,
"front-QBtoCC-sinchronies":`Синхронизация...`,
"message.submitpage.sms":`Поздравляю. SMS-сообщение отправлено успешно.`,
"label.imgfield.width":`Ширина`,
"label.send_email":`Отправляйте уведомления о подаче по электронной почте по адресу`,
"label.queue.list":`Список очереди`,
"label.tabpage.fieldoptions":`Поле типа записи, поле списка опций и поле списка опций (множественный выбор). рекомендуется вводить не более 10 ключевых слов, разделенных запятыми, для достижения "или связи", например: "Нью-Йорк, Торонто, Токио".`,
"component.chatter.post.button.save":`Опубликовать`,
"chatter.group.groupDescriptionInformation":`Описание группы`,
"label_setup_mobilesetup_isenableh5newandedit":`Включите новое и отредактируйте H5 в своем мобильном приложении.`,
"lable.Confirm.recallpotential.customers":`Подтвердите переработку {num} выводов.`,
"label.knowledge.setting.hint.seven":`Выберите имя из перечисленных ниже и предоставьте письменный доступ, чтобы внести свой вклад.`,
"label.emailtocloudcc.redmessage2":`Пожалуйста, введите правильный пароль учетной записи`,
"message.validation.equalTo":`Введите те же значения.`,
"vue_label_help_golbal":`Общая навигация`,
"vue_label_chatter_delete_group_title":`Группа удаления`,
"label.user.login.success":`Вход в систему Успех`,
"label.chatham.standard.time":`Стандартное время Чатема`,
"label.vlidaterule.example.percent":`Процент скидки не должен превышать 30%`,
"label.group.field":`Укажите поле группировки`,
"label.trigger.operation.sharetab":`Действия триггера Общая форма:`,
"label.mobile.phone.write.month.report":`Ежемесячные рабочие заметки`,
"label.statusofconvers":`Преобразованный статус`,
"label.version.emailtemplate.track":`Шаблон электронной почты`,
"label.customobjects.onlytrackforupdate":`Только отслеживание изменений`,
"label_tabpage_enterviewname":`Шаг 1, пожалуйста, введите название вида`,
"label.processsetting.three.enable":`Шаг 3: Активировать`,
"label.service.show.more.info":`Показать больше информации`,
"front-epwechat-module-v1-input-iosschema":`Пожалуйста, введите схему iOS`,
"label.dataimport.datatype.error":`Ошибка типа данных, пожалуйста, внимательно проверьте, совпадают ли данные и заголовок один за другим.`,
"label.staticresource":`Статический ресурс`,
"label.weixin.customize":`Настроить`,
"label.product.edit.sel":`Редактировать Выбрано`,
"label.appointmentpage.wizard.notif5":`Недействительный формат телефона`,
"label.marketsea.basicsetup":`Основные настройки`,
"label.workflow.supplyintruduce":`1.Критерии, вызывающие выполнение правила рабочего процесса.<br/> 2.Немедленные действия, которые выполняются, когда запись соответствует критерию. Например, CloudCC может автоматически отправить письмо, уведомляющее команду аккаунта о создании новой возможности.<br/>3. Зависимые от времени действия, которые ставятся в очередь, когда запись соответствует критериям, и выполняются в соответствии с триггерами времени.`,
"label_report_line_tuozhuai":`Пожалуйста, перетащите мышью или дважды щелкните мышью, чтобы выбрать столбец отчета и настроить их порядок.`,
"label.add.new.rule":`Добавить новые правила генерации`,
"label.marketing.setting2":`Настройка`,
"vue_label_chatter_delete_some_group":`Вы уверены, что хотите удалить группу "{groupInfoList}".`,
"label.appupload.uploading.wait":`Пожалуйста, подождите`,
"label.linecondition.error":`Ошибка состояния строки, несоответствие типа поля!`,
"chatter.group.request":`Запрос`,
"label.recordtype.tabname.remark":`Используйте эту страницу для создания и поддержки типов записей для вашей организации. Вы можете отобразить различные макеты страниц и значения пикилистов в зависимости от типов записей. Чтобы использовать типы записей, добавьте поле Тип записи к макету страницы.`,
"setup_mainpage_label_welcome4":`Инструкции: Щелкните по меню в левой части страницы → Настройки приложения → Создать → Объект.`,
"vue_label_salesadvance":`Заблаговременная стадия продаж`,
"vue_label_campaign_of_existing_campaign_members":`Пожалуйста, установите статус существующих членов кампании`,
"label.report.object.detail.no.permission":`Тип отчета изменен или перемещен. Обратитесь за помощью к администратору.`,
"label.weixin.untreated":`Открыть`,
"label.service.miniProgram.bindSetOwnerDesc":`В системе может быть создана запись о случае для заявки на ремонт, поданной в минипрограмме.  Пожалуйста, выберите пользователя в качестве создателя записи о случае. Этот пользователь должен иметь полномочия на создание записей в объекте дела. После изменения создателя снова войдите в минипрограмму и отправьте заявку на отчет, чтобы она вступила в силу.`,
"label.autoassigntoapprover":`Автоматически назначаются утверждающим(и) лицом(ами).`,
"label.marketseamemset.containself":`Содержит самодельные записи`,
"vue_label_report_drill":`Drill`,
"label.order.products.to.assets":`Преобразование заказанного товара в актив`,
"label.recordtype.list":`Существующий тип записи`,
"lable.outlook.detail.conflict":`Поведение в условиях конфликта`,
"pagecreator.page.label.layoutpreview":`Просмотр макета`,
"front-kefu-moudle-v1-zxltyhxzc-buyuser":`Чат с агентами поддерживается Easemob. Пожалуйста, сначала приобретите аккаунт Easemob.`,
"label.convers":`Конвертировать`,
"serviceappointment.worktype.isnot.father.worktype":`Для этого служебного назначения должен быть выбран тип работы, связанный с его родительской записью.`,
"lable.tianyancha.h5.relatedcom":`Релявантные компании`,
"label.reportsSubscriptionPage.schedulereport":`Отчет о расписании`,
"label.workbanch.setup.showinworkbanch":`Показ на моем рабочем месте`,
"label_emailsync_connectaccount":`Подключить электронную почту`,
"label.usermanage.license.not.qualified":`Система обнаружила, что это лицензия, не соответствующая требованиям, пожалуйста, свяжитесь с поставщиком, чтобы получить лицензию снова!`,
"component_setup_label_displayfield":`Поле отображения`,
"setup_layout_label_buttonarea":`Область кнопки`,
"label.weixin.input.content":`Пожалуйста, введите содержание`,
"label.operatedata.importsuc":`Успешный импорт, вы можете проверить результат импорта, перейдя на вкладку объекта.`,
"label_tabpage_yes1z":`Да1`,
"front-electronic-signature-describe":`Доступ к электронной подписи, подписывайте контракт в любом месте и в любое время. Подписывайте одним щелчком мыши, безопасно и эффективно!`,
"label.event.this.month":`Этот месяц`,
"label.document.replaces":`Заменить`,
"label.email.cc":`Cc`,
"chatter.feed.sticker":`Отслеживание подачи корма`,
"vue_label_commonobjects_view_chart_notice_pleaseaddchart":`Пожалуйста, добавьте график`,
"label.cpq.main.quote.transfer.order":`Только основная котировка может генерировать ордера.`,
"label.partnerCloud.partnerAccount.topUpSuccess":`Успешно пополнить счет`,
"label.appexchange.uninstallpage.uninstall":`Удалить`,
"label.campagin.roi.channel":`Каналы`,
"label.multilang.versioncontrol.checkversion":`Ваша текущая версия CloudCC - {0}, которая позволяет создать {1} {2}которые достигли предела!{2} При необходимости, пожалуйста, обновите версию CloudCC!`,
"label.emailobject.my.template":`Только мои шаблоны`,
"label.edittimetrigger":`Редактирование триггера времени`,
"label.setup.mobile.homepageshortcuts.saveerror":`Настройки функции быстрого доступа к домашней странице мобильного телефона не сохраняются.`,
"label.address.street":`Улица`,
"label.workflow.estimatecondition2":`созданный`,
"label.wei.expiresdate":`Дата истечения`,
"label.quickbooks.viewlist.date":`ДАТА`,
"label.page.select.field.type":`Выберите тип поля`,
"label.tabpage.mypotentialcustomers":`Мои зацепки`,
"label.file.library.editlib":`Редактировать Весы Подробности`,
"label.weixin.message.operateexception":`Симптома`,
"label.visualpage.staticresource.p1":`1.Call method.refference выбранные статические ресурсы путем обращения к кнопкам статических ресурсов.`,
"label.icon.175":`Авиабилеты`,
"chatter.edit.r":`Напишите комментарий...`,
"label.examinationandapproval.flow":`Процессы утверждения`,
"label.mr.descreption.reDataList5":`наборы данных.`,
"label.edit.field.select.showstyle":`Стиль дисплея`,
"label.reportsSubscriptionPage.condition.and":`И`,
"label.please.associations":`Пожалуйста, выберите ассоциированный объект.`,
"label.service.dispatchingUnits.displays.service.appointments":`Показать назначения на обслуживание, которые не связаны с регионом`,
"label.addcurrent":`Добавить существующий`,
"label.search.change":`Настроить объекты с возможностью поиска`,
"message.schedulejob.error.modify":`На основе настроенного расписания данное задание никогда не будет запущено. Проверьте данные и отправьте их повторно.`,
"label.chatter.sendEmailToGroupMember.subject.L":`{0} опубликованных ссылок для всех в {1}`,
"label.weixin.micro.oldid":`Оригинальный идентификатор официального аккаунта WeChat`,
"label.employees.only.invitation.code":`Система сгенерирует уникальный код приглашения для сотрудника, который может быть использован для оформления приглашений и может быть засчитан как индивидуальная производительность. Обратите внимание, что владельцем лида будет текущий владелец маркетинговой кампании или пригласитель маркетингового канала. Вы можете перераспределить лиды с помощью правил распределения лидов. Для правил распределения`,
"lable.PowerProcess.event.msg":`Вы можете добавить зависящие от времени действия рабочего процесса, которые происходят на каждом этапе (вехе) процесса получения прав. Например, вы можете настроить действия для отправки электронного письма владельцу дела за час до истечения срока действия контрольной точки или для автоматического обновления определенных полей дела при завершении первого ответа на контрольную точку.`,
"label.file.share.email.content2":`Предотвращение: #sharerole`,
"label.querydetailservice.datalayout.notexist":`Соответствующего макета записи не существует.`,
"label.group.items":`Пункт группы`,
"label.istouse":`Имеется на вебсайте .`,
"front-electronic-signature-explain":`Электронная подпись Фадада Описание:`,
"label.partner.template.thumbnail":`Эскиз`,
"registration.page.selected.fields":`Обязательные поля страницы регистрации`,
"label.reportTypeCategoryLabel":`Источник данных`,
"vue_label_email_You_have_not_activated_the_mailbox":`Вы не активировали почтовый ящик`,
"lable.SalesCommitmentKanBan.taskCompletionRate":`Скорость выполнения задачи`,
"label.forecast.detailforecast.program":`Пункты прогноза`,
"label.page.display":`Показать`,
"label.passwordPolicy.setup.minute":`протокол`,
"label.emailtocloudcc.step1total3":`Шаг 1 из 3`,
"label.file.title":`Название`,
"label.callcenter.private.key":`Секретный ключ закрытого доступа`,
"com.cloudcc.login.error.message.loginerror":`Ваш идентификатор или пароль неверны`,
"UG_Lead_004":`веб-форма`,
"label_tabpage_recordsz":`Запись`,
"label.shangqing.discovery":`Открытие бизнес-информации`,
"vue_label_notice_change_success":`Успешно изменился`,
"label.ems.other":`Другое`,
"loading":`Загрузка...`,
"label.committedtoapprove":`Представленные заявки на утверждение`,
"label.category.4":`Финансовый`,
"template.report.folder.customer.situation":`Анализ состояния счетов`,
"label.quickbooks.searchresault.phone":`Телефон`,
"label.ccpeak.ccobj.save":`Чтобы сохранить CCObject в базе данных, метод вызова имеет вид`,
"label.knowledge.delete.linked":`Ошибка при удалении связанной статьи`,
"label.forecast.settings.future2":`Будущие 2 цикла`,
"message.error.displaytype.detail":`Тип дисплея не может быть пустым, День: день, Месяц: месяц, Неделя: неделя, Наличие: наличие!`,
"front-template-V1-search-template-name":`Введите имя объекта и найдите`,
"label.sendsms.batch.step3.introduce":`Хранение активности каждого SMS`,
"UG.Forcast.08":`Предыдущий шаг`,
"label.inputnameandintro":`Введите имя и описание`,
"label.redistributioned":`Переадресованный`,
"label.service.dispatchingUnits.left.right.total":`{left}-{right} записей , {totalCount} записей всего.`,
"label.projectManagement.Pleaseentertheactualworkinghours":`Пожалуйста, введите фактическое рабочее время`,
"label.exporttemplate":`Экспорт шаблона`,
"label.data.downpage":`Страница загрузки данных`,
"message.please.choose.contact":`Пожалуйста, выберите контакт`,
"message.error.dataformat.error":`Ошибка формата данных`,
"label.customsetting.changefieldtype.losevalue":`Изменение выбранного типа данных приведет к потере всех имеющихся в поле данных.`,
"label.sendemail.chat.chattype":`Вид основного поста:`,
"label.ccdocument.upload.error":`Ошибка при загрузке документа.`,
"label.quickbooks.view.all":`Все`,
"label.data.downpage.e_title":`Шаги экспорта данных`,
"lable.data.lock":`Данные заблокированы, если вам нужно отредактировать, пожалуйста, сначала разблокируйте их.`,
"label.locked":`Запертый`,
"label.customfields.beforedeletedata":`Чтобы сохранить запись данных для дальнейшего использования, выполните экспорт данных перед удалением пользовательских полей, нажав кнопку Настройка | Управление данными | Экспорт данных.`,
"label.productsales.oppor.noapproach":`Нет возможностей с ожидаемой датой контракта менее 30 дней.`,
"label.input.notmore.than.number":`Пожалуйста, введите число меньше или равно {0}.`,
"label.list.userinterface.isenable":`Включить редактирование онлайн`,
"label.listofshare":`Информационный список акций`,
"label.emailsync.status.role":`Роль`,
"label.staticresource.useful.realtion":`Где используется этот статический ресурс`,
"label.sharerule.tip":`На этой странице отображаются общие настройки вашей организации. Эти настройки определяют уровень доступа ваших пользователей к данным других пользователей.`,
"label.qrcodelogin.message.expired":`QR-код истёк`,
"label.marketing.setting3":`Настройка маркетинговых каналов`,
"vue_label_statistical_field":`статистическая область`,
"message.view.addtomyhomepage":`Добавить в мой домашний рабочий стол.`,
"label.customfields.percent.tip":`Позволяет пользователям вводить процентное число, например, "10", и автоматически добавляет к числу знак процента.`,
"component_newrecords_label_10records":`10 пластинок`,
"Lead_Scoring_Warning_001":`При создании или редактировании одной ведущей записи оценка производится автоматически. Но при пакетном импорте или создании по интерфейсу необходимо вручную забить несколько зацепок.`,
"label.project.planing":`Диспетчерский человекочас VS отчетный человекочас в этом году`,
"label.data.exp.pwdverif":`Пароли разрешены только для букв и цифр.`,
"coderules.notEnable":`Пожалуйста, свяжитесь с администратором для активации правил генерации QR-кода и штрих-кода.`,
"label.weixin.wdyj.jxhk":`Персональные-продажи-платежи`,
"label.data.expnode.e_desc3":`3. Template Создать: пользователь может сделать шаблон в соответствии с полями и условиями, которые будут экспортированы для удовлетворения ваших потребностей, что удобно использовать в следующий раз.`,
"chatter.group.join":`Присоединяйся`,
"vue_label_systemSettings_monitoring":`Монитор`,
"front-kefu-moudle-v1-yesorno-delete-folder":`Вы уверены, что нужно удалить эту папку?`,
"label.exchange.sync.state.info":`Проверьте состояние системы, чтобы убедиться, что записи синхронизированы между Exchange и CloudCC.`,
"lable.outlook.mcto.emaildes":`Введите все адреса электронной почты потенциальных клиентов и контактов, которые вы использовали для отправки электронной почты, и разделите их запятыми. Только электронная почта, отправленная с адреса электронной почты, указанного ниже, может быть добавлена в Историю Деятельности, если соответствующие записи.`,
"label.ems.save":`Сохранить`,
"vue_label_dashboard_maximumvalue":`Пожалуйста, введите максимальное значение`,
"label.passwordPolicy.setup.norestriction":`Нет ограничений`,
"label.multilang.customforcast.total":`Накопление {0} :`,
"label_partner_all_memo":`В списке отображаются все облака партнеров в вашей организации. Для входа в систему нажмите url.`,
"Account.News.Setting.002":`Используйте настройки учетной записи ниже, чтобы указать поведение учетной записи по умолчанию для вашей организации.`,
"label.essential":`обязательный сайт`,
"label.nonotice":`Больше никаких напоминаний`,
"vue_label_calendar_calendar_deleted_successfully":`Календарь успешно удален`,
"message.huanxinagent.disable":`Неактивный агент`,
"label.goto":`Перейти к`,
"label.chat.topic.add.favorite":`Добавить в закладки`,
"label.trigger.targetobj":`Целевой объект`,
"label.form_fields":`Поля формы`,
"this.month":`Этот месяц`,
"vue_label_homepage_select_view":`Выберите Вид`,
"label.weixin.input.subject":`Пожалуйста, заполните формуляр`,
"label.ems.emailType":`Тип почтового ящика`,
"vue_label_file_safe_type_file":`Пожалуйста, подтвердите, что файл не содержит конфиденциальной информации. Пожалуйста, рассмотрите возможность обмена файлами с определенными пользователями или записями`,
"label.version.case.automatic.upgrade":`Правила эскалации и распределения дел`,
"label.input.invalid.credit.card.number":`Пожалуйста, введите номер действующей кредитной карты`,
"component_timeline_label_future":`Следующий шаг`,
"label.emailtemplate.cannotsupporthtml":`HTML-тип в настоящее время не поддерживается`,
"label.appupload.install.error.info2":`{1} "{0}" конфликтует с существующими компонентами.`,
"label.custom.field.maping":`в эту область.`,
"encd":`Зашифрованный текст (Отображение зашифрованного текста)`,
"label.service.newBuildDialog.filter.logic":`Логика фильтрации`,
"label.customerinfo":`Профиль компании`,
"vue_label_applauncher_notice_activepoolsuccess":`Успешно активирован свинцовый пул`,
"label.partner.workspace.member.choicepermission":`Выберите набор разрешений`,
"front-gantt-module-this-task-of-other-tasks":`Эта задача существует как подзадача и не может быть подзадачей другой задачи!`,
"label_chatter_publish":`Опубликовать`,
"label.forecast.settings.mrfw":`Начиная с`,
"label.Named.Filter":`Назовите фильтр`,
"label.department.email":`электронный адрес`,
"label.updatingfield":`Поле для обновления`,
"label_partner_template_detail":`Описание функции`,
"front-epwechat-module-v1-unbound-item":` обязательность для всех предприятий`,
"vue_label_file_lib_name":`Имя библиотеки файлов`,
"label.notification.arketsea.distribution":`{5} назначенный {2}{0}: {1} вам`,
"vue_label_norm_removecomponent":`удалять деталь`,
"component.event.label.begindate":`*Время начала`,
"chatter.note":`полученные комментарии`,
"label.forecast.settings.type.all":`Прогноз замены`,
"label.compact.layout.frame.full":`Отображение в полноэкранном режиме`,
"label.approvalstep3intro":`Используя приведенные ниже опции, укажите пользователя, которому должен быть присвоен запрос на утверждение.`,
"label.notification.approval6":`【被委派人名称】 утвердил запрос 【提交人】 об утверждении 【对象】【对象名称】 для Вас.`,
"setup.object.field.dependency.label.actionfieldvalue":`Поле управления`,
"label.multilang.page2":`Страница`,
"vue_label_email_submitted":`Представлено на .`,
"label.Standard.button":`Стандартные кнопки`,
"vue_label_report_emailchoose":`вариант электронной почты`,
"page.field.masterinput.list":`Мастер-список входных данных`,
"label.martrixdown":`Матрица вниз`,
"vue_label_helpcenter_opportunity":`В правом верхнем углу просмотра нажмите на значок воронки продаж, чтобы перейти к просмотру воронки продаж.<br>.<br>С помощью интуитивно понятной индикатор прогресса, отслеживайте прогресс каждой бизнес-возможности, и нажмите на кнопку, чтобы отметить завершение текущего этапа, или отрегулировать текущий этап. Если вы сталкиваетесь с препятствиями в продвижении бизнес-возможностей, вы также можете расширить шкалу прогресса для просмотра информации и некоторых теплых советов, которым следует уделить больше внимания на текущем этапе.<br>Через соответствующий список группы бизнес-возможностей, данные о бизнес-возможностях могут быть переданы другим людям, которые не имеют доступа к их просмотру, с тем, чтобы облегчить совместную работу.<br>В списке ролей, связанных с контактами в рамках бизнес-возможности, быстро добавьте роль в возможности контакта в соответствующем клиенте, а затем просмотрите вышестоящие и нижестоящие отношения соответствующего контакта через сеть отношений, и используйте радарную диаграмму для оценки текущего контакта Ценность возможностей, отслеживайте, находите ключевых людей и проверяйте контакты. Роль, статус посещения, степень отношения, стиль покупки и время посещения<br>Через связанный список продуктов бизнес-возможности, вы можете добавить продукты в том же прайс-листе для бизнес-возможности, а также редактировать цену и количество продуктов.`,
"label.sso.ssoKeyMan":`Единая система управления ключами для входа в систему`,
"label.forecast.edit.desc":`Установить квоту пользователя на следующий период`,
"label.weixin.newspaper.coverage.time":`Дата риска`,
"label.pleaseselectpro":`Пожалуйста, выберите продукты`,
"label.bottonandlink":`Кнопки и ссылки`,
"label.donot.know.error":`Произошла неизвестная ошибка, обратитесь к администратору.`,
"label.account_noordab":`В вашей учетной записи есть 0 пользовательских отчетов и 2 приборные панели.`,
"label.partnerCloud.orderingPlatform.toPay":`Оплата через партнерский фонд`,
"label.many.dayline.nextday":`Следующий день`,
"lable.showmorerecords":`Показать больше`,
"front-lightning-module-v1-details-page-chart-record-type":`Пожалуйста, выберите тип записи`,
"label.ccpeak.query.record":`поиск записей`,
"pagecreator.systemstyle.message.save.fail":`Стиль спасения не удалось`,
"label.weixin.share.file":`Общий файл`,
"errormessage.email.relatedorreceivermusthaveone.z":`Необходимо выбрать хотя бы одного получателя или смежную тему.`,
"chatter.save.f":`Сохранить не удалось`,
"button.partner.create":`Новый сайт`,
"label.marketseamemset.lead.title2":`Пожалуйста, установите верхний предел на количество зацепок, которые затрагивают всех участников. Этот лимит не имеет ничего общего с бассейном открытого моря.`,
"label.service.major.event.new":`Новая веха`,
"label.version.custom.site":`Custom Site`,
"label.permission.visualpagepermission":`Назначенные пользовательские страницы`,
"lable.product.zongjia":`Общая цена`,
"label.viewchart":`Просмотр графиков`,
"label.alaska.daylight.time":`Аляска Летнее время`,
"front-kefu-moudle-v1-rgdyhcwzx-reply":`Позволяет большему количеству пользователей стать агентами и обслуживать посетителей, повышая качество обслуживания клиентов.`,
"component_assistant_label_todaylead":`Зацепки, назначенные вам сегодня.`,
"label.sendemail.chat.addComentsfavorite":`Дорогой #name:\n\n ; Здравствуйте! #userName ответили на ваше сообщение в закладке.`,
"label.smstemplate.tip":`Ниже перечислены все шаблоны SMS в выбранной папке. Нажмите кнопку "Создать", чтобы создать новый текст или шаблон HTML SMS. Вы можете использовать эти шаблоны SMS при отправке сообщений. Нажмите на ссылку роли для просмотра более подробной информации".`,
"label.documentname":`Наименование документа`,
"label.icon.162":`Пейзаж`,
"label.salescloud.wanyuan":`Юань`,
"label.view.desc1":`Поле типа записи, поле пикилиста и поле пикилиста (мульти-выбор), рекомендуется вводить до 10 ключевых слов, разделенных запятыми. Например, "Нью-Йорк, Торонто, Токио".`,
"label.searchlayout.lookup.newfield":`Lookup Dialogs, которые появляются при нажатии на новую кнопку на полях Lookup.`,
"label.emailobject.bcc":`Бакс:`,
"label.manageAll.pagenum1":`Это первая страница.`,
"vue_label_appstore_crm_used_companies":`CRM, используемый компаниями, акции которых котируются на бирже`,
"label.document.replace":`Заменить`,
"label.assignment.setup.newrule.title":`Новое правило назначения дел`,
"component.chatter.label.mygroup":`Моя группа`,
"lable.currencyAdv.exchangedate":`Диапазон дат`,
"label.quickbooks.button.viewinqb":`Просмотр в Быстрых Книгах`,
"UG.homepage.004":`Автоматизация`,
"label.currencyName":`Наименование валюты`,
"Homepage_News_001":`Новости`,
"front-lightning-module-v1-details-page-chart-refresh-button":`Показать кнопку обновления`,
"label.list.projectSetting.isenable":`Включить таймер проекта (Включить: Вехи, задача, подзадача, задача)`,
"setup.layout.message.relatedlistbutton":`Выберите стандартные кнопки для отображения на`,
"vue_label_homepage_homepageassignment":`Приложение Главная страница Назначение`,
"label.pending":`Дожидается`,
"component.timeline.label.today":`Сегодня`,
"front-kefu-moudle-free-hasexpire":`Срок действия вашей бесплатной пробной версии истек`,
"homepage.layout.customlayout":`Пользовательский макет страницы`,
"label.service.miniProgram.content":`Пожалуйста, заполните содержание.`,
"label.defaultline.must.int":`Количество строк по умолчанию может быть только положительными целыми числами.`,
"label.mirror_issues":`Если форма не отражает то, что вы видите на своей стороне, ознакомьтесь с нашей статьей о том, как устранить распространенные проблемы с дисплеем.`,
"label.edit.select.two":`Список одноразовых коробок`,
"label.emailmerge.mergeFolder.tip":`Шаблоны слияния занимают некоторое время, во время слияния, пожалуйста, не переходите по другим ссылкам, закройте веб-браузер или обновите страницу.`,
"label.ServiceCloud.zichan.distributionMap":`Карта распределения активов`,
"label.selectfile":`Выберите Файлы`,
"vue_label_account_equitymanage":`Управлять отношениями с акционерами`,
"label.email.clearAll":`Очистить все`,
"label.selecting.parent.assets":`Выберите родительский актив`,
"component.setup.tabs.label.delete":`Удалить`,
"label.visualpage.top.must.is":`Должна быть первая строка заголовка овсянки:`,
"label.SalesCommitmentDashboard":`Приборные панели Комитетов по продажам`,
"chatter.group.changeTheRole":`Изменить роль`,
"label.dataimport.insertdata.error":`При вставке новых данных произошла ошибка. Пожалуйста, внимательно проверьте эти данные.`,
"label.partner":`Облако партнера`,
"label.process.async.execute.tip":`Ваш запрос находится на стадии обработки. Одобрение занимает определенное время, и результат будет показан на странице подробностей. Пожалуйста, подождите.`,
"label.service.newBuildDialog.additional.conditions":`Дополнительные условия`,
"label.name_copy":`Вы собираетесь клонировать эту существующую форму. Пожалуйста, введите имя для копии.`,
"label.integrations.install":`Установить`,
"label.edit.ccpeakfolder.time":`Занятия по расписанию: Папка Редактирование`,
"label.knowledgebase.filing.time":`Архивное время`,
"vue_label_chatter_success_exit_group":`Успешный выход из группы`,
"font.market.module.v1.save.name":`Пожалуйста, заполните название собрания`,
"label.a.b.without":`Запись может иметь или не иметь соответствующие записи типа "В".`,
"label.chat.topic.desc":`Описание`,
"label.field.editoptionlist.introduce":`Введите имя значения пикилиста.`,
"label.versiontype.Enterprise":`Предприятие`,
"message.selectrulecondition":`Пожалуйста, укажите критерии правила`,
"label.custombutton.unknown.operation":`Недействительные действия`,
"label.pricecannotnull":`Требуется цена`,
"component_salesperformance_label_target":`Цель`,
"pagecreator.page.message.delete.success":`Страница удалена успешно`,
"label.help.new.features":`Новые возможности CloudCC`,
"label.weixin.vehicle.owner.information":`Детали владельца автомобиля`,
"label.exchange.sync.state.user.info":`Проверьте статус синхронизации пользователя, чтобы убедиться, что записи синхронизированы между Exchange и CloudCC. Если у пользователя возникли проблемы с синхронизацией между Exchange и CloudCC, вы можете сбросить процесс синхронизации. Сброс информации, которую CloudCC для Exchange использует только и не удаляет данные с вашего сервера Microsoft Exchange или CloudCC.`,
"label.batcheditor":`массовое редактирование`,
"report.label.knowcreatehighlevelreport":`Как создать расширенный отчет?`,
"label.dataimport.title.length":`Длина заголовка`,
"label_model_description":`Описание модели`,
"label.tabpage.ctbtsftcz":`Щелкните на обратной стороне для поиска содержимого`,
"label.channel.activity.member.owner":`Владелец участника кампании`,
"label.ems.serverinfo":`Информация о сервере`,
"tjinvilid":`Незаконные условия`,
"label.nameofreport":`Название отчета`,
"label.ifapproverreject":`Что произойдет, если утверждающая сторона отклонит этот запрос?`,
"label.wtd.changefields.title.desc2":`Если вам нужна запись в мобильном приложении "Web to CloudCC", чтобы связать ссылку, вам необходимо создать поле текущего объекта для поиска ссылки, а название API поля - " lead_wtd".`,
"label_emailsync_form_connecttime":`Связанное с этим время`,
"label.visualpage":`Пользовательская страница`,
"label.customlink":`Пользовательские ссылки`,
"label.lead.score.doing.remark":`Ваш запрос был обработан, и его выполнение займет определенное время. и система проинформирует вас по электронной почте о его завершении.`,
"label.h5.act.details":`Детали деятельности`,
"label.profile.setrecordtype":`Настройки типа записи`,
"label.processsetting.process.enabled.successfully":`Включите процесс успешно!`,
"label.campaign.url.overtime":`Ссылка истекла.`,
"label.structureChart.notFiled":`Не заполнено`,
"label.h5.chatter.something":`Скажи что-нибудь.`,
"label.pm":`PM`,
"template.chart.rwlx":`Тип задачи`,
"label.icon.42":`Облако`,
"label.project.hit.one":`Уведомление о назначении подзадач`,
"label.martrixreport.2018.step3":`Шаг 3 Выбор заголовков столбцов`,
"label.wtd.changefields.newmo":`Создать мобильную страницу`,
"label.downloadTheTemplate":`Скачать шаблон`,
"label_chatter_assignPerson":`Назначенное лицо`,
"label_emailtocloudcc_license":`Лицензия`,
"label.willdeletedlayout":`Макеты страниц, которые вы хотите удалить.`,
"label.projectManagement.delete.question":`При удалении этого выпуска вся связанная с ним информация также будет удалена, и данные не смогут быть восстановлены. Вы уверены, что подтверждаете удаление?`,
"lable_setup_mobilesetup_isEnableValidationRulesForScan":`Включить правила проверки при использовании Сканирования`,
"label.salescloud.opportunity.addandedit.contactrole.note":`Примечание: Двойной щелчок по пустым контактам, может добавить пустую запись.`,
"label.step6.total6":`Шаг 6 из 6`,
"label.knowledge.setting.hint.one":`Knowledge позволяет клиентам и обслуживающему персоналу в полной мере использовать статьи Knowledge.`,
"label.usefieldautoassign":`Автоматическое назначение утверждающего лица с использованием стандартного или пользовательского поля иерархии:`,
"label.partnerCloud.orderingPlatform.orderAmount":`Сумма заказа:`,
"chatter.fieldtrack.operateupdate":`заменённый`,
"chatter.del.com":`Удалить этот комментарий`,
"report.reportdatasource.label":`Источник данных отчёта`,
"label.text":`Текст`,
"label.marketsea.select.member":`Факультативные члены`,
"label.typeofreceivers":`Тип получателя`,
"label.knowledgebase.affect.existing.translations":`Да, мои изменения повлияют на существующий перевод. Пометить как "Просроченный"`,
"label.marketing.invitationmail":`Добро пожаловать в нашу деятельность, ваша ссылка на приглашение:`,
"label.version.quotation.management":`Управление котировками`,
"label.dataimport.insertdata.error.unique":`$fieldName$ нарушает ограничения уникальности при вставке новых данных.`,
"label.emailmerge.list.newtemplate":`Новый шаблон`,
"label.salescloud.salescloud.allteam":`Команда всех возможностей на основе всех команд`,
"vue_label_commonobjects_detail_record_changes":`Изменения в записи полей`,
"label.file.delete.info":`Удалить файлы`,
"vue_label_calendar_name":`Название календаря`,
"label.version.support":`Поддержка`,
"label.event":`События`,
"label.searchlayout.lookup.searchdialog":`Диалоги поиска, которые появляются при нажатии на иконку поиска в полях поиска.`,
"label.data.downpage.e_list.desc2":`После завершения процесса вы получите электронное письмо с напоминанием об успешном экспорте данных.`,
"label.partnerCloud.productSet.delIsTrue":`Вы хотите удалить этот продукт?`,
"label.tianyancha.businessverify.msg2":`Это соглашение является соглашением между вами (далее пользователь) и CloudCC относительно использования функции проверки бизнес-данных. это соглашение описывает права и обязанности использования функции проверки бизнес-данных и связанных с ней сервисов между CloudCC и пользователем. это соглашение может быть обновлено CloudCC в любое время. обновленные условия соглашения после публикации, они заменят первоначальные условия соглашения без предварительного уведомления.`,
"label.customobjects.cancleselectallfield":`Отменить все выбранные поля`,
"image.up.maxsize":`Загруженный файл слишком большой, пожалуйста, не превышайте 2M.`,
"label.icon.8":`Файл`,
"label.donot.delete":`У вас нет разрешения на удаление`,
"label.version.profile.and.layoutpage":`Профили и макеты страниц`,
"chatter.coll.s":`Удалить эту закладку`,
"label.icon.163":`Земля`,
"label_chatter_myfollowers":`Мои последователи`,
"label.multilang.customforecast.refuse":`Отклонить любой прогностический приоритет {0}, но принять прогностический приоритет от других подчиненных.`,
"label.tabpage.findz":`Поиск`,
"label.smstemplate.detailinfo":`Подробная информация о шаблоне SMS`,
"label.knowledge.setting.hint.nineteen":`Давайте начнем`,
"label.mr.tip":`Пожалуйста, заполните правила в строке {0}.`,
"label.icon.132":`Гарантия`,
"label.customobjects.track.introduce2":`Список, связанный с историей. Всякий раз, когда пользователь изменяет любое из полей, выбранных ниже, в список, связанный с Историей, добавляются старое и новое значения полей, а также дата, время, характер изменения и пользователь, вносящий изменение.`,
"label_emailtocloudcc_redmessage5":`Неизвестный стаус, пожалуйста, свяжитесь с администратором.`,
"label.must.select.field":`Ошибка состояния линии, необходимо выбрать поле.`,
"label.tag.manage.modifiedby":`Последний изменен`,
"label.translation.start1":`Выберите язык (если вы переводчик).`,
"label.ccchat.topic.searchs":`Тема поиска`,
"label.mask.custom.example":`{AAAA}{****}{AAAAA} представляет собой зашифрованное отображение с пятого по восьмой символ.`,
"setup_object_field_dependency_label_addtolist":`Добавить выбранные значения`,
"label.view.total.record":`Всего выбрано 0 записей.`,
"label.service.without.right":`Нет соответствующего права`,
"template.chart.wxqzkhyy":`Причины недействительных лидов`,
"vue_label_dashboard_pleaseenterabreakpoint1value":`Пожалуйста, введите значение точки останова 1`,
"message.pleaseinputmouthdistance":`Пожалуйста, введите действительный месячный интервал.`,
"label.forgetPsd.tip":`Забудьте пароль, свяжитесь с администратором.`,
"label.projectManagement.planned":`Запланировано`,
"lable.Product.conversion.asset.operation":`Перевод продукта в актив`,
"label.search_forms":`Поиск форм`,
"label.sendemail.chat.addPostmainPagesubject":`Сообщение домашней страницы CloudCC CCChat`,
"label_tabpage_viewNamez":`Пожалуйста, введите название вида`,
"label_chatter_addresser":`Отправитель`,
"Opportunity_Detailed_Phase_Change_Text_001":`Стадия "Возможность изменения`,
"label.what":`Страница`,
"vue_label_systemSettings_set_android":`Настройка меню и функций для Android и IOS, чтобы сделать его подходящим для бизнеспользователей.`,
"label.sell":`Продажа`,
"template.report.folder.case":`Анализ кейсов`,
"label.customfields.profilefieldsafety":`Безопасность профиля на полевом уровне`,
"label.industrialandcommercialverification.label.token":`Токен`,
"label.finished":`Заполнено`,
"label.sendmail.step3.introduce1":`В настоящее время у вас есть`,
"vue_label_calendar_other_calendars":`Другой календарь`,
"label.donot.know.validate.field":`Недействительные поля проверки`,
"label.exportdetail":`Детали экспорта`,
"label.step.filter":`Укажите условия фильтрации`,
"label.campaignmember.main.hasMember":`Существующие члены`,
"label.updown.suess":`Скачать успешно`,
"label.ems.browse":`Посмотреть`,
"front-email-payment-Invoice-login-account-describe":`Нажмите "Продолжить", чтобы завершить оплату счета путем сканирования QRкода Alipay или входа в систему Alipay.`,
"label.copyCustomReportType":`Клон Пользовательский источник данных отчета`,
"label.visualpage.write.class":`Редактируйте код класса на странице с тем же синтаксисом, что и Java.`,
"label.setsharerule.tip":`<br>Используйте правила общего доступа, чтобы сделать автоматические исключения из общеорганизационных параметров общего доступа для определенных наборов пользователей.<br>Примечание: "Роли и подчиненные" включают всех пользователей в роли, а также роли ниже этой роли.`,
"label.report.action.addtodashboard9":`Приборная панель Страница Списка`,
"label.cloudccsite.remark":`Описание сайта`,
"label_tabpage_noz":`Нет`,
"chatter.up.limit":`Загруженный файл слишком большой, пожалуйста, не превышайте`,
"label.leadmarketsea.grouplist.title":`Настройки ведущих групп пула`,
"label.pc.user.help":`руководство пользователя`,
"label.partnerCloud.orderingPlatform.relyOn":`Зависимость`,
"label.appointmentpage.wizard.subtitle2":`Выберите время`,
"label.deleteoneormore":`Удалить один или несколько`,
"january":`январь`,
"label.delete.profile":`Удалить профиль`,
"label.appointment.wizard.subtitle1-7":`2 h`,
"label.icon.188":`Косметика`,
"vue_label_file_already_in_lib":`Уже существует в этой файловой библиотеке`,
"label.icon.151":`VR`,
"label.withvalue":`По значению`,
"label.tianyancha.businseeverify.opererror":`Не удалось открыть бизнес-данные. попробуйте еще раз или свяжитесь с Вашим системным администратором!`,
"label.tabpage.individual":`Индивидуальный выбор`,
"label.layout.editdistribute":`Редактировать Назначение`,
"label.smstemplate.lookup":`Просмотр шаблона SMS`,
"pagecreator.systemstyle.button.delete":`Стиль удаления`,
"label.customer.tab.step2.same.option1":`По умолчанию`,
"label.knowledgebase.no.results.knowledge":`Нет результатов в Знании`,
"label.data.exp.newtemporexp":`Выберите метод экспорта данных или создайте новый шаблон.`,
"vue_label_chatter_refuse_join":`Отказ от участия`,
"Homepage.News.002":`Компонент новостей в настоящее время недоступен.`,
"label.log.requesttype":`Метод запроса`,
"vue_label_dashboard_generatefromreport":`Генерировать из отчета`,
"label.knowledge.create.version":`Создать версию`,
"label.emailtocloudcc.description2":`Подключить вашу электронную почту`,
"label.partnerCloud.partnerAccount.recharge":`Сумма пополнения должна составлять от 0,1 до {верхнего лимита}.`,
"label.customobjects":`Пользовательские объекты`,
"label.schedulableprg.endtime":`Дата окончания должна быть позже текущей даты системы.`,
"message.error.viewreport.confirmdelete":`Существуют графики, использующие текущее представление/отчет в качестве источника данных. Вы хотите также удалить диаграмму?`,
"label.marketing.social.seting":`Настройка социальных сетей`,
"chatter.follow.stop":`Прекратите следовать за этим пользователем`,
"label.notification.arketsea.return":`{5} вернулся {0}: {1}к {2}`,
"label.conditionsofnextapprover":`В выбранном вами запросе на официальное утверждение есть один или несколько последующих указанных официальных утверждений. Для указания следующего официального утверждения воспользуйтесь, пожалуйста, следующим поисковым окном.`,
"label.partner.all.state":`Статус`,
"mobel_web_closed":`Закрытый`,
"label.icon.65":`Оборудование`,
"label.stdashbord.xsld.business.jinehj":`Общая сумма`,
"label.selectobject":`Выберите объект`,
"label.account.CurrentFQ":`текущий FQ`,
"label.workflow.estimaterule":`Оцените правило, когда есть запись:`,
"label.list.userinterface.shownewrecordssetup":`Недавние настройки записи`,
"label.tianyancha.businessverify.msg3":`1. заряд`,
"label.weixin..xsld.jieduan":`Этап`,
"label.first.quarter":`Первый квартал`,
"Opportunity.Detailed.Phase.Label.002":`{0}день(ы) в текущей стадии`,
"label_tabpage_page":`Страница`,
"label_emailsync_status_time":`Время`,
"label.pleaseselectaapprover":`Пожалуйста, выберите утверждающее лицо`,
"label.emailtocloudcc.redmessage5":`Неизвестный стаус, пожалуйста, свяжитесь с администратором.`,
"label.four.quarter":`Четвертый квартал`,
"label_chatter_relateList":`Соответствующий перечень`,
"label.customfields.new.step2.opration.exid.info":`Установите в данном поле уникальный идентификатор записи для внешней системы.`,
"label.projectManagement.nodata.overdue.tasks":`Отлично! Нет просроченной задачи`,
"label.sendemail.activity.task.statuscompleted":`Уважаемый #createbyidccname Здравствуйте! \r\n Задача, которую вы поставили перед #belongtoidccname на #createdate, заключается в следующем: \r\n Тема: #subject\r\n Duetime: #expireDate\r\n Related Items: #relatedstr\r\n Содержание: #remark\r\n Пожалуйста, посетите ссылку для более подробной информации: \r\n #путь\r\n Пожалуйста, обратите внимание: #belongtoidccname отмечен как завершенный. \r\n #orgNameCRM System`,
"label.sso.saml.idp.config.issuer":`Эмитент`,
"label.cannot.delete":`пункты) не разрешается удалять`,
"label.pigeonhole.sel_f":`Выберите папки для архивации`,
"label.customfields.text.tip":`Позволяет вводить любые комбинации букв и цифр.`,
"message.error.user.service.common":`Операция прошла неудачно, пожалуйста, свяжитесь с администратором для получения помощи.`,
"label.datamanage.account.information":`Информация об аккаунте`,
"vue_label_homepage_deleteprofilepage":`Удалить главную страницу профиля`,
"label.sendmail.step3.introduce3":`получатель(и), выбранный(ые) для получения данного SMS.`,
"label.pc.ui.2018.recentitem":`Недавние предметы`,
"label.report.loading":`Ожидание загрузки`,
"vue_label_globalsearch_adjustment":`Метод настройки`,
"label_report_line_yixuan":`Выбранная колонка отчёта`,
"label.h5.similar.opportunity.only.view":`Только на дисплее`,
"label.marketactivitymember":`Участники кампании`,
"label.recycle.execute.tip":`Ваш запрос был обработан, и потребуется некоторое время, чтобы очистить корзину. По завершении процесса вы будете уведомлены emial.`,
"label.permission.detail.system.setting":`Настройки системных разрешений`,
"label.RecordType":`Типы записей`,
"label.custom.error.between":`Пользовательский год дата начала или пользовательский год дата окончания находится между историей пользовательских лет, пожалуйста, проверьте и сбросьте`,
"vue_label_dashboard_selectview":`Выберите Вид`,
"label.tianyancha.businessverify.cancel":`Отключить проверку бизнес-данных`,
"label.partnerCloud.financeSetting.MD5":`Секретный ключ MD5`,
"label.multilang.messagedetail.new.error":`Мы не можем найти пользователя Чата с любым именем с {0}:`,
"label.callcenter.pleaseenter.private.key":`Пожалуйста, введите секретный ключ доступа`,
"label.umeng.activity.youdistribute":`Вы назначили`,
"label.weixin.nickname":`Прозвище`,
"label.customerinfo.mailusername":`Имя пользователя электронной почты`,
"label.partnerCloud.orderingPlatform.discountPlan":`Название графика скидок:`,
"lable.account.year":`финансовый год`,
"T":`Время`,
"System.Email.Template.Title":`Добро пожаловать на платформу CloudCC CRM`,
"label.login.type":`Типы входа`,
"label.notification.evaluation":`{0} оставлен комментарий {2} для случая {1}`,
"label.turntolist":`Перейти к спискам`,
"label.sort":`Сортировать`,
"vue_label_commonobject_notice_clickcross":`Если вам необходимо заменить загруженный файл, нажмите кнопку [X] и загрузите его снова`,
"label.Select.maximumecords.operate":`Для обработки можно выбрать до 200 записей.`,
"label.submission_rate":`Ставка представления`,
"label.datadelete.record.sucessfully":`запись(и) successfully!`,
"label.version.standard.dashboard":`Стандартные приборные панели`,
"label.task.postunsolve":`Просроченные задания`,
"label.Receivables.name":`Дебиторское имя`,
"label_tabpage_noOperationz":`Это содержимое является фиксированным и не может быть использовано!`,
"label.attendance.onrecord":`Выберите хотя бы одну запись`,
"label.partner.error2":`Ошибка: Доменное имя может содержать только цифры или буквы.`,
"label.account.map":`Карта аккаунта`,
"label.dashboardSetup.reference.legend":`Ссылка на диаграмму`,
"label.Yaxisscope":`Ось Y`,
"label.hierarchy.tree.tip":`Выберите запись в поле поиска каждой вкладки для создания иерархии. Иерархия выглядит следующим образом:`,
"label.permission.objlist.columnsize":`Общее число полей`,
"label.setup.mobile.bottombutton.savesuccess":`Сохранены настройки страницы первого уровня`,
"label.mobile.side.tab.selected":`Уже выбранный`,
"label.partner.donotdel.cause":`Потому что это связано со следующим облаком партнера`,
"label.ccchat.message.new.error4":`Напоминание:`,
"vue_label_systemSettings_setorganization":`Настройте приложения для вашей организации, настройте различные меню для различных функциональных подразделений.`,
"label.umeng.approval.approvalmes4obj1":`Пожалуйста, своевременно рассмотрите утверждение`,
"UG_opportunity_010":`Создать сделку`,
"label.tag.addtags.public":`Общественный`,
"System.TAB.SeeViewPageAmount":`Просмотр страниц`,
"label.filterconditions":`Фильтр`,
"front-personalEmailBox-module-v12-clear-not-associated":`Отмена подключения очистит все неассоциированные письма, вы уверены, что хотите отменить подключение?`,
"label.assign":`Назначить`,
"label.layout.clone.tip":`Вы можете выбрать существующий макет для клонирования`,
"label.choose.relatedlist":`Выберите соответствующий список, который вы хотите перевести`,
"label_chatter_recordcall":`Записанный звонок`,
"label.product.proofOne":`В поле {0} выберите до {1} вариантов товара.`,
"label.layout.availablefield.relatedlist":`Доступные поля / соответствующие списки`,
"label.campaignmember.main.updateleadstatus":`Обновить статус-Свидетельства о наличии`,
"label.custom.buttonandlink":`Пользовательские кнопки`,
"label.view.manage":`Управление просмотром`,
"label.search.exp":`Выберите объекты, для которых вы хотите включить следующие функции, и нажмите кнопку Сохранить:`,
"vue_label_appstore_apply_to":`Применить к`,
"label.dashboard.message.refreshfail":`Обновление приборной панели не удалось`,
"UG_Case_02":`Случаи позволяют реагировать на проблемы с учетной записью и решать их. Случаи - это мощная запись в Cloud CC, которая не только отслеживает проблемы учетной записи, но и отображает полное представление об учетной записи.`,
"label.project.hit.three":`Ежедневное напоминание о подзадачах`,
"label.tianyancha.businessverify.tip":`Функция проверки бизнес-данных включена для того, чтобы помочь пользователям ввести правильную регистрационную информацию о клиентах при вводе данных о корпоративных клиентах.`,
"label_emailsync_status_disconnect":`Отменить отзыв Концерт`,
"label.rule.disabled.successfully":`Успешное отключение правил`,
"label.custombutton.queryerror":`Запрос провалился, пожалуйста, повторите.`,
"label.customfields.deletecannotresume":`Соответствующие данные будут окончательно удалены и не могут быть восстановлены.`,
"label.account.current.M":`Этот месяц`,
"label.under.approve.data":`записи проверяются(`,
"vue_label_title_remainingdays":`Оставшиеся дни`,
"label.partnerCloud.orderingPlatform.refundable":`Доступная скидка`,
"label.lookup.iscover":`Разрешить синхронизацию при редактировании`,
"label.recordtype.detail.selectlist":`Доступные для редактирования пиклисты`,
"label.sso.isActiveYes":`Да`,
"label.service.appointmentList.canceltheSuccess":`Успешно отменено`,
"label.escalation.setup.newentries.createfirst":`Когда регистр создается и отключается после того, как регистр впервые изменен`,
"label.new.ccpeakfolder":`Класс: Новая папка`,
"lable.currencyAdv.exchagecurrency.after":`и за`,
"label.majoranddetailrelation":`Мастер-детальные отношения`,
"label.appointment.wizard.subtitle4-2-1":`1 h`,
"label.projectManagement.working.hours":`Рабочее время`,
"label.forecast.customforecast.button.forehistory":`История прогнозов`,
"label.mymasterplate":`Мои шаблоны`,
"component.setup.tabs.label.memo":`Установить имя тега вкладки`,
"label.customfields.longtextarea.tip":`Позволяет пользователям вводить до 32 000 символов в отдельных строках. Вы можете создать до 10 текстовых (длинных) полей на каждый объект.`,
"label.service.miniProgram.fillJumpLink":`Пожалуйста, заполните ссылку для перехода.`,
"label.british.summer.time":`среднее время по Гринвичу`,
"label.nogreate":`<=Меньше чем или равно`,
"label.assignment.setup.detail.sameuser":`Тот же пользователь`,
"mesage.error.profile.delate.user":`Невозможно удалить профиль, так как пользователь назначен на текущий профиль.`,
"label.tabpage.cownerz":`Изменение владельца`,
"label.multilang.dupicatecheck.processedcount":`Дублированные данные,{0} группы обработаны,{1} группы данных не обработаны {1}.`,
"vue_label_report_notice_leavecertification":`Вы обязательно покинете эту страницу - введенные вами данные могут быть не сохранены`,
"label.master.required":`Имеют необходимые поля отсутствующие записи о детях`,
"label.chatter.follow":`Следите за`,
"label.dataimport.insertdata.error.repeat":`Запись дублирует данные в исходной базе данных, и импорт записи был проигнорирован.`,
"label.sms.cgid":`Галерейный номер`,
"label.knowledge.article.rator":``,
"label.datamanage.object.field":`Поля объекта`,
"label.forecast.editshrepage.quanxian":`Совместное использование Пеймиссионного уровня доступа`,
"label.weixin.interactive.log":`Журнал взаимодействия`,
"label.batchedit.remark":`Редактирование нескольких записей`,
"label.user.permissions.message":`Нет разрешений на установку информации о пользователе.`,
"label.mobile.phone.month":`месяц`,
"chatter.sel.u":`Выберите пользователей, которых вы хотите @ упомянуть, или введите Имя пользователя, которого вы хотите @`,
"label.service.gantt.assigned.work":`Назначенная работа`,
"UG_ST_001":`Симптома`,
"label.edit.select.one":`Выпадающий список`,
"label.forecast.shrepage.desc0":`На этой странице перечислены пользователи, роли и зоны, имеющие общий доступ к {0}.`,
"label.multilingual.confirm.close":`Вы уверены, что нужно отключить? После отключения мультиязычность не может быть использована, и язык пользователя будет изменен на язык по умолчанию.`,
"label.setting.intergrationlist.integration":`Интеграция`,
"label.leadscore.rule.list":`Список правил начисления очков лидерам`,
"component_telerecord_button_save":`Сохранить`,
"label.weixin.save.log":`Сохранить журнал`,
"label.validate.function.funcExplain.DAY":`Возвращаясь в день месяца, необходимо ввести число от 1 до 31.`,
"label.appointmentdetail.wizard.title1":`Имя`,
"label.multilang.feedtrack.dealkey":`Измените {0} с {1} на {2}`,
"label.optional.features":`Дополнительные функции`,
"vue_label_email_no_email":`Нет электронной почты`,
"label.sendemail.chat.messagecontent":`Содержание сообщения:`,
"label.tabpage.lessequalz":`Меньше или равно`,
"setup.layout.label.setupfield":`Свойства месторождения`,
"label.approved.receiveApprovalEmail.option1":`Если я являюсь утверждающим или уполномоченным лицом.`,
"label.chatter.relateList":`Соответствующий перечень`,
"component.sendmail.label.fromuser":`Отправитель`,
"label.projectManagement.problem.status":`Состояние вопроса`,
"label.weixin.fmu.before.hour":`{0} час(ы) вперёд`,
"chatter.feed.menutype.feed.mark":`Зарегистрирован на сайте`,
"label.addQuoteLineGroup":`Добавить группу котировочных линий`,
"label.report.action.addtodashboard6":`Добавить`,
"label.url":`URL-АДРЕС`,
"lable.account.CurrentandPreviousCQ":`Текущий и предыдущий CQ`,
"label.tabpage.emptyz":`Пустой`,
"less":`не особо`,
"label.h5.selectmostphotos":`Можно выбрать максимум девять фотографий`,
"UG.activity.04":`Почтовый ящик Outlook/Gmail, записывайте почту`,
"template.chart.qbhtje":`Все Сумма контракта`,
"label.tabpage.endz":`Конец`,
"label.partner.workspace.member":`Член`,
"label.filter.error.filedvaluetoolong":`Ошибка: Значение поля превышает максимальный предел.`,
"label.months":`месяц`,
"button.partner.workspace.disable":`Отмена активации`,
"label.visualpage.checkpinyin.grammar":`Пожалуйста, проверьте орфографию и грамматику.`,
"label.dashboardSetup.geshihua":`Форматирование`,
"label.belongto":`Принадлежать`,
"label.upload.cannot.empty":`Вы должны выбрать файл для загрузки.`,
"label.number.MaxCheck":`Максимальное значение {0} равно {1}. Пожалуйста, измените количество и сохраните изменения.`,
"pagecreator.page.message.save.fail":`Сохранить страницу не удалось`,
"label.edit.SMS":`Редактирование SMS-уведомлений`,
"UG_Lead_002":`Существует множество способов определить "зацепки" для вашего продукта или услуги.`,
"label.quickcreate.active.quickcreate":`Включить быстрое создание`,
"label.recordtypeselect.tip":`Чтобы пропустить этот шаг в будущем, установите типы записей по умолчанию.`,
"label.form_content":`Форма`,
"workflow.action.tasks.assignortype.related":`Связанный пользователь`,
"vue_label_allsearch_set_more_items":`Вы можете задать больше элементов поиска в выпадающем списке в левой части поля поиска, чтобы продолжить поиск.`,
"label.tianyancha.businessverify.title":`Проверка бизнеса`,
"label.errormessage.batchedit.norecord":`Нет данных.`,
"label.permission.appname":`Имя приложения`,
"label.report.action.addtodashboard7":`Отменить`,
"label.generated.transfer.product":`Генерируйте активы в соответствии с методом конвертации активов.`,
"vue_label_commonobjects_detail_you":`Вы`,
"label.user.captcha":`Проверьте свою личность`,
"label.notification.event4":`Событие 【事件名】, назначенное Вами на 【被分配人】, начинается с 【开始时间】.`,
"label.version.setup":`Настройка`,
"setup.object.layout.message.selectedlayoutandrecordtype":`Пожалуйста, выберите макет и тип записи`,
"label.role.add":`Добавить роль`,
"label.versiontype.Unlimited":`Безлимитный`,
"label.partnerCloud.financeSetting.developerID":`Пожалуйста, введите идентификатор разработчика.`,
"front-invoice-online-payment-setup-global":`Применить к глобальным счетам`,
"vue_label_commonobjects_view_basis":`Основа классификации`,
"label.decimaldigits.tip":`Количество цифр справа от десятичной запятой`,
"vue_label_commonobjects_detail_selected":`Отметить как текущую стадию`,
"label.data.export.page":`Перейти на страницу экспорта`,
"message.error.serviceresource.servicecrewid":`Каждый сервисный экипаж может быть добавлен только как одна запись сервисного ресурса типа экипажа.`,
"label.loginttime.alltime":`Все время`,
"label.requiredinfo":`Необходимая информация`,
"label.forecast.edit.di":`БЮ`,
"vue_label_calendar_failed_to_remove_calendar":`Не удалось удалить календарь`,
"pagecreator_systemstyle_button_delete":`Стиль удаления`,
"label.import.page3.continueimport":`Продолжать импорт`,
"label.page.width":`Полная ширина страницы`,
"label.campaignmember.selectmember.addmember":`Добавить членов из`,
"label.finalreject":`Окончательный отказ`,
"label.isend":`Готово`,
"front-console-conversation":`Диалог`,
"label.mr.theLastGroupOfThisPage":`Это последний набор данных на этой странице. Нажмите [Back to Duplicate Data List] (Создать список дубликатов данных), чтобы просмотреть дополнительные дубликаты данных.`,
"label.data.dataexpalltype.all_desc":`Экспорт данных всех объектов, к которым имеет доступ текущий пользователь для чтения.`,
"label_emailtocloudcc_redmessage7":`Ошибка конфигурации, пожалуйста, свяжитесь с администратором.`,
"label.forecast.shrepage.classdes.all":`Полный доступ - Пользователи могут просматривать и переопределять прогнозируемые данные, а также расширять доступ для других пользователей путем совместного использования.`,
"market.contacts":`Контакт с рынком`,
"label.weixin.polls.voter":`Список проголосовавших`,
"template.report.industry.distribution.customers":`Отраслевое распределение счетов`,
"front-electronic-signature-setup":`Контракт Infor Автозаполнение и настройка резервного заполнения`,
"vue_label_chatter_removecertification":`Вы уверены, что хотите удалить члена "{имя}"?`,
"label.appointment.wizard.subtitle1-2":`15 минут`,
"label.sso.saml.idp.config.custattr":`Пользовательский атрибут`,
"label_tabpage_totalTeamz":`Всего групп`,
"lable.outlook.detail.assigned":`Назначенные пользователи и профили`,
"label.department.user.delete":`Удалить`,
"label.customcomponent.check.label.same":`Эта этикетка уже существует.`,
"label.partner.error1":`Ошибка: длина домена слишком велика`,
"label.escalation.setup.entrydetail.escalation.notify":`Оповестить`,
"component_todaytask_label_choicestate":`Выберите статус`,
"label.customfields.fielddependency.new.step1":`<b>Step1: </b> Выберите управляющее и зависимое поля. Нажмите кнопку Продолжить после завершения.`,
"chatter.group.anyoneCanSeeTheUpdateAndJoin":`Каждый может посмотреть и подать заявку на вступление в эту группу.`,
"label.custom.pixel":`пиксель`,
"label.quicksave":`Быстрая экономия`,
"label.approved.persion":`Удаленный уполномоченный представитель`,
"lable.info.queue.member":`Члены очереди`,
"label.addattachment.step2.weixin":`Шаг 2 Нажмите Загрузить, чтобы загрузить файлы`,
"label.forecast.customforecast.title":`Прогнозы`,
"mainpage_setup_chosecomponent_leastone":`Вы должны выбрать один компонент, по крайней мере, на главной странице.`,
"label.appointmentconfirmpage.wizard.title2":`Приглашение на календарь было отправлено на вашу электронную почту.`,
"label.useallselectedapprover":`Требуется, чтобы все избранные одобрены.`,
"label.ccpeak.current.line.return":`Возвращается из текущей строки и больше не выполняется вниз.`,
"label_new_target_model":`Новая целевая модель`,
"label.saving":`Спасение...`,
"label.mobile.phone.write":`Написать`,
"label.applt.updown.text":`Вы также можете загрузить QRкод портала минипрограммы, посвященной вашей компании, и разместить QRкод внутри вебстраницы или публичной статьи, а клиенты могут сканировать QRкод, чтобы воспользоваться минипрограммой.`,
"label.partner.common.manageSetup":`Настройки администрирования облака партнера`,
"label.quickbooks.new":`Новый клиент`,
"message.error.color":`цвет не может быть пустым!`,
"label.project.template.two":`Для каждого типа записи в объекте может быть только один набор конфигураций!`,
"label.approval.input.des1":`Утверждать или отклонять уровень за уровнем, а максимальный уровень иерархии:`,
"label.x.axis.cannot.empty":`Ось Х не может быть нулевой`,
"label.solomon.isiands.time":`Соломон Ис. Время`,
"label.login.access.duedate":`Продолжительность доступа`,
"label.service.dispatch.booking.order":`Назначение услуги`,
"label_shareme_forecast":`Общий прогноз со мной`,
"label.custom.page.cuspage.height":`Высота (пикселей)`,
"label.quote.line.group.":`Вы уверены, что хотите удалить группу строк кавычек {groupName}? Строки кавычек в этой группе также будут удалены после выполнения операции.`,
"label.data.downpage.i_title.num6":`Рекомендуется импортировать тестовый файл, содержащий 5 записей, перед импортом данных, чтобы убедиться, что данные, которые вы хотите импортировать, корректны.`,
"label.\u2019s":`s`,
"label.version.contact.management":`Управление контрактами`,
"label.document.history.user":`Пользователи`,
"vue_labenl_commonobjects_opportunity_product_edit_notice1":`Пожалуйста, введите правильное количество, до двух знаков после запятой.`,
"label.weixin.target.contract.jine":`Целевая сумма контракта`,
"lable.common":`￥0 всего`,
"front-kefu-moudle-sendemail-success":`Письмо было отправлено, и сотрудники отдела продаж свяжутся с вами как можно скорее`,
"label.service.no.operation.time":`Текущая запись не имеет связанного с ней времени работы!`,
"label.info":`Информация`,
"label.ccchat.zw":`NOON`,
"label.assignment.setup.newentries.title":`Ввод правил Редактирование`,
"label.weixin.report.timeline":`Дата Поле`,
"UG.quota.04":`Печатное предложение`,
"label.social.user.exception":`Ненормальная пользовательская информация социального характера.`,
"label.import.index.failed":`Не удалось`,
"label.common.settings":`Общие настройки`,
"label.nullvalue":`Нулевая стоимость`,
"PageLayout_Search_MultiSearch_002":`Включить настраиваемое окно поиска (Поиск по одному полю)`,
"message.myselfreport":`Мои личные пользовательские отчеты`,
"label.productsales.today.noevttskaddtsk":`Нет открытых событий и истекающих заданий, можно нажать кнопку "Добавить новое задание" в правом верхнем углу.`,
"lable.oppdt.noconditionrecrods":`Нет записей для отображения`,
"label.campaignmember.selectmember.deletelead":`Кампания: удалить участников из зацепок`,
"label.marketingactivity":`Кампании`,
"vue_label_pool_self-built":`Самостоятельно созданный`,
"message.textareamaxlength":`Длина не должна превышать 4000 символов.`,
"label.valadate.must.value":`Должен ввести значение`,
"label.tabpage.groupsVisiblez":`Выбранные группы пользователей`,
"component.button.cancel":`Отменить`,
"label.emailobject.list.inbox":`Входящая`,
"label.app.step1.error.labelexist":`ERROR: Эта Этикетка уже существует или использовалась ранее.`,
"front-calendar-V1-Unable-to-display":`Запись не может быть отображена в календаре, так как поле окончания одной или нескольких записей находится раньше поля начала.`,
"label.forecast.settings.prompt1":`Вы должны выбрать один Прогнозный Измерение по крайней мере: Доход или Количество.`,
"front-kefu-moudle-callout-missphone":`Вызов пропущенных вызовов`,
"label.tabpage.editz":`Редактирование`,
"vue_label_chatter_label_new_team":`Новая группа`,
"label.version.formulafield":`Формульное поле`,
"label.partner.step1":`Шаг 1 Выбор шаблона`,
"label.weixin.perfect.url":`Введите URL-адрес`,
"label.appointmentconfirmail.wizard.subtitle4":`Описание`,
"label.step7.total7":`Шаг 7 из 7`,
"setup.object.layout.label.selectedprofile":`Выбранные профили`,
"label.payments.paytip5":`Пожалуйста, введите правильное количество пользователей!`,
"label.visualpage.open.type":`открыта индивидуальная страница в стиле`,
"lable.Sort.field.tips":`Настройте порядок записей в связанном списке, выбрав поля для сортировки. Вы можете упорядочить на основе любых числовых полей или полей даты объектов.`,
"label.nosharerules":`Правила совместного использования не определены.`,
"label.service.miniProgram.bindSetOwner":`Владелец установленных дел`,
"report_label_highlevelreport":`Расширенные отчеты позволяют создавать связи между максимум 4 объектами.`,
"S":`Текст`,
"label.lastmodifyby":`Последние изменения`,
"label.customerinfo.mailaddress":`Адрес электронной почты`,
"vue_label_pool_converted":`Конвертированный`,
"UG.ST.004":`У вас нет управления данными - "разрешение на импорт данных", пожалуйста, свяжитесь с администратором, нажмите кнопку подтверждения и перейдите непосредственно к интерфейсу {0}.`,
"label.view.application.mobile.terminal.filed":`Этот вид был применен в мобильном приложении. Доступно не более 10 полей; выбираются.`,
"chatter.feed.limitentity500":`Вы можете проследить за 500 коллегами и записями.`,
"label.starttime":`Начать`,
"chatter.emailToMe":`Напомни мне, когда кто-нибудь:`,
"label.custom.Current.and.PreviousCQ":`Текущий и предыдущий CQ`,
"label.my.logout":`Me`,
"label.quickbooks.searchlist.enddate":`Дата окончания`,
"label.ccservice.validate.length":`Превышается длина соответствующего значения {2} поля {1} под API объекта {0}. Пожалуйста, сбросьте его!`,
"label.integrations.installed":`Установленный`,
"label.integrations.mailchimplist":`Список рассылки Mailchimp`,
"label.checkfield.matchothers":`Матч с другими записями`,
"label.umeng.activity.event.distributewillbegin":`Событие #мероприятие, которое вы назначили #названию, начинается в #время.`,
"pool.notice.gotolightning":`Пожалуйста, перейдите в Меню Молнии, если вы хотите использовать эту функцию.`,
"label.batchtransfer.pleaseselecttransferreddata":`Выберите данные, которые вы хотите передать`,
"label.mr.title.mailingAddress":`Почтовый адрес`,
"vue_label_approve_no_response":`Нет ответа`,
"component.event.label.title":`Предстоящие события`,
"label.mobile.setup.confirm":`Вы изменяете местоположение значка вкладки по умолчанию в мобильном приложении. После успешного изменения все предыдущие настройки иконки вкладки мобильного телефона будут удалены, необходимо сбросить иконку вкладки, используемую в мобильном приложении. Если вы не выберете, система будет выбирать случайным образом в вашем каталоге настроек.`,
"label.tianyancha.approvaltime":`Дата утверждения`,
"label.download_merge_file":`Скачать объединенный файл`,
"label_display_quota":`Показать квоты`,
"label.publishreadonly":`Только для публичного чтения`,
"label.campagin.roi.query.roi":`Окупаемость инвестиций в кампанию`,
"label.dashboardSetup.lookup":`Найти приборные панели`,
"vue_label_notificationcenter_nomessages":`Нет непрочитанных сообщений`,
"label.create.object":`Создать объект`,
"label.social.campaign.null":`Информация о камчадале не может быть пустой`,
"label.console.step6.left":`Исправлена ошибка слева, и списки всегда были видны.`,
"label.line":`Колонка`,
"label.bottonandlink.introduce":`Вот список кнопок и ссылок. Добавляйте кнопки или ссылки, пожалуйста, редактируйте layout.<br/>Кнопки и ссылки могут быть добавлены на страницу деталей, соответствующий список и просмотр списка.<br/>.`,
"label.layout.list1":`Список 1`,
"label.mr.title.customerName":`Имя аккаунта`,
"label.user.text":`Текст`,
"label.nolastestrecord":`Нет последнего рекорда`,
"label.emailobject.appointment.urltext1":`Посмотрите мое расписание и`,
"label.chat.topic.my.favorites":`Зарегистрирован на сайте`,
"label.select.dashboar.cd0":`Поле группировки не может быть пустым`,
"label.data.downpage.e_title.num2":`2. If вы выбираете экспорт данных одного объекта, вам нужно выбрать способ экспорта данных: пользовательский экспорт, экспорт по шаблону и экспорт по шаблону.`,
"message.error.user.service.login.unconn":`Сеть занята, повторите попытку или свяжитесь с администратором.`,
"label.escalation.setup.newentries.title":`Ввод правил Редактирование`,
"label.import.step1.above2000":`При выполнении триггера за один раз можно импортировать не более 2000 записей. Пожалуйста, разбейте на несколько файлов и импортируйте их партиями.`,
"label.ccchat.person.allowinvite":`Позвольте коллегам пригласить`,
"label.input.number.between":`Пожалуйста, введите номер между {0} и {1}`,
"label.forecast.shrepage.wpfmanager":`Удаленный менеджер прогнозов`,
"label_server_is_time_out":`На сервере тайм-аут. Пожалуйста, повторите попытку позже.`,
"label.indochina.standard.time":`стандартное время Индии`,
"label.cpq.quote.sync.opportunity.failure":`Только первичное предложение может быть синхронизировано с возможностью. Пожалуйста, установите флажок в поле первичного предложения, а затем начните синхронизацию.`,
"label.emailobject.send100emails":`Извините, вы можете отправлять только 100 писем в день, пожалуйста, перевыберите!`,
"label.dashboard.snapshot.end":`от`,
"label.jiandangfenpei.rightlist":`Назначенные профили`,
"label.input.string.length.between":`Введите строку, длина которой находится между {0} и {1}.`,
"label.multilang.lookfiltercondition.select":`Условие строки {0} неверно. Вы должны выбрать поле!`,
"label.datamanage.lead.namenull":`Примечание: Если поле основного имени является нулевым, запись не будет импортирована.`,
"label.forecast.detailforecast.button.saveandfresh":`Сохранить`,
"label.venezuela.time":`венесуэльское время`,
"label.same.analyze.miaoshu1":`Если вам нужно больше правил, пожалуйста, используйте "`,
"label.twomb":`Разрешается загружать только jpg/png файл с максимальным размером 2MB.`,
"label.event.moveup.7hour":`7 часов вперёд`,
"label.weixin.forgot.password":`Забыл свой пароль?`,
"label.import.page1.diledsizelimited":`2. Максимально допустимый размер файла 100M`,
"label.file.foldername":`Имя папки`,
"label.multilingual.open":`Управление несколькими маршрутами включено.`,
"label.dashboard.snapshot.refresh.failed":`Обновление снимка приборной панели не удалось.`,
"label.marketsea.memberfieldselectone":`Просмотр полей и члены могут просматривать поля Пожалуйста, выберите по крайней мере одно поле`,
"label.trigger.createdate":`Дата создания`,
"label.ccpeak.operation.sharetab":`Действуйте в форме совместного использования:`,
"label.partner.message.admin.access":`Вход в систему возможен только администраторам`,
"label.emailsync.status.email":`Действие Выполнено Электронная почта`,
"chatter.error":`Ошибка:Пожалуйста, выберите файл для загрузки!`,
"label.role.viewinlist":`Показать в виде списка`,
"label.tag.addtags.title":`тег`,
"setup.mainpage.label.welcome6":`Пользователи могут создавать различные типы полей во всех объектах CloudCC системы без каких-либо знаний программирования или разработки кода. Типы полей включают в себя: отношения поиска, поле одиночного выбора, выбор из двух элементов, формула, автоматическая нумерация. , URL, телефон, факс, электронная почта, чекбокс, дата, время, номер, текст, текстовая область, список опций (одиночный/множественный выбор), валюта и т.д.`,
"label.delete.rule.successfully":`Успешное удаление правил`,
"label.field.duplicate.error.msg6":`Дублированное значение поля. Значение выходит в записи:`,
"label.stdashbord.xsld.business.jhzsl":`Общие возможности (Количество)`,
"label.compact.layout":`Ключевая информационная раскладка`,
"label.checkfield.merge.introduce":`Выберите значение, которое вы хотите сохранить в объединенной записи.`,
"earlieststarttime.duedate.time.illegal":`Фактическое время начала приема на обслуживание должно быть меньше или равно фактическому времени окончания.`,
"label.dataimport.validate.prompt":`Правило валидации Быстрое`,
"message.setuptip":`Вы можете удалить созданные вами пакеты.`,
"template.report.customer.collection.statistics":`Статистика платежей по счетам`,
"vue_label_homepage_dashboardcomponents":`Редактировать компоненты приборной панели`,
"setup.mainpage.label.welcome30":`Платформа CloudCC - это настоящая платформа облачных вычислений. Открытые атрибуты платформы, стандартные методы интеграции и гибкая настройка применимы ко всем предприятиям, интегрируя программное обеспечение сторонних производителей, осуществляя унификацию данных управления предприятием в режиме реального времени, и максимизируя всесторонние и глубокие управленческие потребности наших клиентов. Платформа CloudCC может быть интегрирована с любым корпоративным приложением или системой, в том числе со сторонним программным обеспечением, таким как SAP, Kingdee и UF. Стандартный метод веб-сервиса под гибкой архитектурой SOA не имеет никаких разрушительных, технических зависимостей или привязки к поставщику.`,
"label.SMS.new.det":`Создать SMS-уведомление для ассоциирования одного или нескольких правил рабочего процесса, процессов утверждения. В случае изменения SMS-уведомления, любые изменения применяются ко всем правилам и связанным с ними утверждениям.`,
"lable.product.page.previous":`Назад к предыдущему`,
"label.recordtype.labelname":`Метка типа записи`,
"message.error.system.service.failure":`Не удалось выполнить службу, пожалуйста, свяжитесь с администратором.`,
"label.visualpagefolder":`Папки страницы`,
"label.username":`Имя пользователя`,
"label.data.downpage.i.title.num5":`5、Пожалуйста, проверьте точность данных.`,
"label.permission.manage":`Управление заданиями`,
"label_emailsync_status_user":`Пользователи`,
"label.weixin.voting.least.two":`Существует как минимум два варианта голосования.`,
"label.tabpage.thisrecord":`Эта запись`,
"label.icon.119":`Blackboard`,
"label.partner.common.webSit":`Домен`,
"label.email.form.html2":`[переключиться на текстовое]`,
"label.appupload.upload.noversion":`Нет загруженных версий`,
"label.appointmentpage.wizard.subtitle1_2":`Часовой пояс пригласителя {0}`,
"MR":`Lookup Relationship (Мульти-выбор)`,
"label.partnerCloud.orderingPlatform.availableBalance":`Доступный остаток`,
"label.schedulejob.setup.schedule.st3":`3-е`,
"label.reportsSubscriptionPage.email.general":`Общие сведения`,
"label.setsharerule.step4":`Шаг 4 Выбор уровня доступа для пользователей`,
"front-epwechat-module-v1-info-desc":`Пожалуйста, получите информацию из внутреннего интерфейса WeCom и заполните здесь`,
"message.duplication.label.isactive":`Активный сайт`,
"pagecreator_systemstyle_label_linkcolor":`Цвет ссылки`,
"label.import.page1.alertfiledsize":`Загруженные файлы не должны превышать 100 МБ!`,
"tomorrow":`Завтра`,
"label.publicdashboard":`Неопубликованные публичные приборные панели`,
"label.knowledgebase.same.taborworkspace":`Та же вкладка или рабочая область`,
"homepage.layout":`Главная страница Макеты`,
"label.emailobject.trackemailopening":`Открытие электронной почты на треке`,
"label.unlock.tip":`Разблокировать записи для редактирования`,
"lable.account.NextzDays":`Следующие 90 дней`,
"vue_label_report_throw":`Бросить`,
"label.icon.102":`Расписание`,
"label.payments.paytip2":`Вы обновились до платной версии, нажмите кнопку Подтвердить, чтобы закрыть окно и обновить вашу CRM-систему.`,
"label.customfields.email.tip":`Позволяет пользователям вводить адрес электронной почты, который проверяется на правильность формата. Если это поле указано для контакта или свинца, пользователи могут выбрать адрес при нажатии кнопки "Отправить электронное письмо". Обратите внимание, что пользовательские адреса электронной почты не могут использоваться для массовых рассылок.`,
"label.test_visitors":`Протестируйте, как ваша форма должна выглядеть при просмотре посетителями.`,
"label.workflow.immediatelyoperate":`Немедленные действия в рамках рабочего процесса`,
"label.approvalstep4.tip":`Страница утверждения - это страница, на которой утверждающее лицо фактически одобряет или отклоняет запрос. Для выбора полей, отображаемых на этой странице, используйте следующие опции.`,
"label.ccchat.person.invite.failsend":`Следующее приглашение не было отправлено. Пожалуйста, свяжитесь с администратором.`,
"label.import.index.obj":`Объект`,
"label.multilang.leadscore.countnum":`{0}раз:`,
"label.report.error.typefind":`Тип отчета по группировке информации не найден`,
"label.validate.function.funcFormat.SUBSTITUTE":`SUBSTITUTE(text, old_text, new_text)`,
"label_tabpage_unpacketz":`Нет данных по группировке!`,
"lable.Create.new.template":`Шаблон отчета о новой услуге`,
"label.knowledgebase.display.error":`Показать {а} Ошибки`,
"label.emailobject.template.message2":`Поле, вставленное в текущее письмо, не совпадает с соответствующей записью, что может привести к нулевым значениям.`,
"label.productsales.today.taskcomplete":`Настройка завершена`,
"label.emailobject.selectone":`Пожалуйста, выберите хотя бы одну запись в качестве получателя электронного письма.`,
"button_partner_workspace_saveas_memo":`Сохранить текущее облако партнера как "шаблон".`,
"vue_label_help_detail":`Детали записи`,
"label.tabpage.minutesagoz":`Протокол`,
"label_tabpage_characterz":`Начальный персонаж`,
"message.error.accesstoken.null":`Токен не может быть пустым!`,
"label.textMessageObject.send100":`Извините, вы можете отправлять только 100 смс-сообщений в день, пожалуйста, перевыберите!`,
"vue_label_commonobjects_detail_record_call":`Зарегистрировать звонок`,
"label.campaignmember.main.addlead":`ДобавитьСталкивающиесяСталкивающиесяСталкивающиесяСталкивающиесяСталкивающиесяСталки`,
"setup_mainpage_label_welcome30":`Платформа CloudCC - это настоящая платформа облачных вычислений. Открытые атрибуты платформы, стандартные методы интеграции и гибкая настройка применимы ко всем предприятиям, интегрируя программное обеспечение сторонних производителей, осуществляя унификацию данных управления предприятием в режиме реального времени, и максимизируя всесторонние и глубокие управленческие потребности наших клиентов. Платформа CloudCC может быть интегрирована с любым корпоративным приложением или системой, в том числе со сторонним программным обеспечением, таким как SAP, Kingdee и UF. Стандартный метод веб-сервиса под гибкой архитектурой SOA не имеет никаких разрушительных, технических зависимостей или привязки к поставщику.`,
"label.file.library.deleteprompt":`Удалить {0} из Библиотеки Активов?`,
"label.wtd.changefields.title":`Настройка Web to CloudCC`,
"label.sendmail.step1":`Шаг 1 Укажите получателей для включения`,
"label.cpq.newquote.createorder.checkbox.selected":`Флажок Создать заказ не может быть установлен при создании новой котировки.`,
"label.emailtocloudcc.name":`Имя`,
"message.error.object.nullbinding":`переплёт пуст`,
"B":`Флажок`,
"label.pc.endtime":`Срок действия вашей лицензии истекает менее чем через 30 дней. пожалуйста, продлите ее вовремя, чтобы обеспечить ее дальнейшее использование.`,
"label.visualpage.section.start":`Используйте метку в начале`,
"label.partnerCloud.basicSetting.available":`Доменное имя доступно.`,
"label.data.exportall.all_desc":`Экспортирует все данные для всех объектов, на просмотр которых у текущего пользователя есть разрешение.`,
"label.editor.layout":`Редактировать макет поиска`,
"label.send.chatter":`Отправить болтовню`,
"label.h5.chatter.reply":`Быстрый ответ`,
"component_chatter_post_button_file":`Добавить вложения`,
"label.emailobject.emaildetail.button.reply":`Ответить на`,
"label.eidt.queue.title.desc":`Имя должно быть уникальным, и имя должно начинаться с буквы. Оно должно содержать только заглавные и строчные буквы, цифры и подчеркивание. Оно не должно быть длиннее 40 символов.`,
"label.campaign.channel.input.url":`5.установить информацию, которую пользователи увидят после регистрации, которая может быть страницей благодарности, листовкой или ticket:`,
"label.compact.layout.assign.tip":`В этой таблице показаны назначения ключевых информационных макетов для различных типов записей.`,
"vue_label_fall":`Спуститься`,
"label.trigger.save.failed":`Сохранить не удалось, данные не могут быть нулевыми`,
"label.appupload.upload.tips.report":`ПРИМЕЧАНИЕ: Отчеты и старые отчеты в папках "Мои пользовательские отчеты" и "Незаполненные публичные отчеты" не могут быть добавлены в пакеты и не будут отображаться в этой папке".`,
"label.tianyancha.businessverify.rewriteall":`Засыпка всех данных`,
"label.campaign.channel.step6.remark4":`Обратите внимание, что ведущий владелец может быть владельцем текущей кампании или лицом, приглашающим к участию в текущей маркетинговой кампании.`,
"front-kefu-moudle-called-num":`Набранный номер`,
"label.approvalstep4":`Шаг 4 Выберите поля для отображения на макетах страниц утверждения.`,
"label.login.verification.please.scan":`Пожалуйста, отсканируйте код, используя приложение MFA на вашем смартфоне.`,
"label.invoice.message.statusupdated":`Обновлен статус счета-фактуры`,
"label.pc.ui.2018.subject":`Тема`,
"label.area.notexist.userinfo":`Группа пользователей не существует.`,
"label.newuser":`Новый пользователь`,
"label.chat.micropost.share":`Поделиться почтой`,
"label.locatedupcurrentvalue":`Значение выше текущего`,
"vue_label_systemSettings_course":`Настройка пути молнии`,
"chatter.group.public":`Общественный`,
"label.reportsSubscription.entrance":`Подписаться на`,
"front-kefu-moudle-v1-online-at":`Онлайнагент`,
"label.rejectbehaviourselect":`Выполните <strong> только</strong> отказ от этого шага и отправьте запрос на утверждение обратно на самый последний утверждающий. (Back На предыдущий Step)`,
"vue_label_commonobjects_view_currentviewset":`Чтобы отменить настройку текущего вида по умолчанию, можно установить другой вид в качестве вида по умолчанию.`,
"lable.currencyAdv.and":`и`,
"label.appexchange.installedpage.publish":`Опубликовано`,
"label.tab.profile.ismobile":`Применить к мобильному приложению`,
"label.data.setok.t.desc2":`Назад к странице шаблона данных`,
"label.email_required":`Электронная почта обязательна.`,
"label.tabpage.fullscreenz":`Полный экран`,
"chatter.sticker.set":`Отслеживание подачи корма`,
"label.mobile.phone.year":`год`,
"label.projectManagement.next.page.before":`Предыдущая страница`,
"pagecreator_button_pcpage":`конец ПК`,
"label.dashboard.xsld.percent":`Процент`,
"label.ccpeak.service.checkerror":`Сбой проверки синтаксиса.`,
"label.icon.26":`Папка`,
"label_partner_common_webSit_memo":`Доменное имя по умолчанию:`,
"label.unselectfile":`Файлы не выбраны`,
"label.take.notice":`Уведомление`,
"message.error.filename.null":`fileName не может быть пустым!`,
"vue_label_SMS_nophone":`Телефонный номер не указан`,
"label.area.assignuser":`Назначить пользователей`,
"label.icon.176":`Симптома`,
"label.icon.21":`Валюта`,
"message.error.system.service.deletedeny":`Дада связан и не может быть удален.`,
"label.compact.layout.main.tip":`Выберите макет ключевой информации, который будет использоваться, когда эта запись появится в CloudCC в качестве элемента списка.`,
"label.emailtocloudcc.delete":`Удалить`,
"label.dashboardSetup.showdw.d2":`10 миллионов`,
"front-kefu-moudle-hqyyjlsb-admin":`Не удалось получить запись голоса, обратитесь за помощью к администратору`,
"label.partnerCloud.basicSetting.userCounts":`Общая роль партнера`,
"front-kefu-moudle-calling-num":`Номер вызова`,
"label.alldocument":`Все документы`,
"coderules.nullvalue1":`Не удалось сгенерировать. Пожалуйста, введите значение для 【{0}】, используемое в правилах генерации.`,
"lable.automatically.shared":`Автоматически совместно используемый`,
"label.batchadd.newbatchpage.save.emptyselect":`Пожалуйста, проверьте, не выбраны ли необходимые опции.`,
"vue_label_homepage_card_30dayswithout":`Отсутствие контактов с возможностями в течение 30 дней`,
"label.multilang.dupicatecheck.onegroupnote":`Выберите, по крайней мере, две данные, нажмите кнопку [Загрузить выбранную информацию], чтобы войти на страницу комбинации данных. В настоящее время в {0}-группе данных предприятия, имеется в общей сложности {1}записи ..:`,
"UG.activity.03":`Зарезервировать расписание`,
"label.pc.oldpage":`Старая страница`,
"label.exchange.sync.state.task.m2":`Записи синхронизированы за последние 60 минут:`,
"label.setmovable":`Настройки деятельности`,
"label.sendemail.send.loginfail":`Не удалось войти в почтовый ящик, пожалуйста, сбросьте информацию по электронной почте.`,
"label.copy.quote.lines":`Клонировать строку цитаты`,
"label.copying.reward.to.groups":`Копирование в группы строк цитат`,
"label.ems.connect.error":`Сбой соединения с сервером, пожалуйста, проверьте.`,
"lable.account.Tomorrow":`Завтра`,
"label.manageAll.sta2":`Утверждено`,
"label.create_form":`Новая форма`,
"label.ems.saveDetail.error.msg":`Сохранить fail.please проверить учетную запись почтового ящика и пароль`,
"label.service.gantt.distribution.recommendation":`Назначить предложенное`,
"label.email.track.attachment.size.control2":`Размер загруженного файла превышает 10 м и не может быть загружен`,
"lable.product.pricebooks.add":`Добавить в ценник`,
"label.login.time":`Время входа`,
"label.tabpage.yes1z":`Да1`,
"label.SalesCommitmentKanBan":`Приборные панели Комитетов по продажам`,
"label_partner_workspace_myspace":`Мое рабочее место`,
"chatter.like":`похожий(ые)`,
"lable.PowerProcess.number.input":`Пожалуйста, введите целое число.`,
"chatter.coll":`Закладка`,
"label.campaign.channel.img.remark":`Remark: Размер изображения не должен превышать 2M.`,
"label.field.duplicate.error.msg7":`Дублированные данные`,
"vue_label_pool_discard":`Бросить`,
"label.service.gantt.total.planned.duration":`Сумма запланированной продолжительности служебных назначений`,
"label.weixin.click.loadmore":`Нажмите, чтобы загрузить больше`,
"label.help.new.features.yd":`Руководство по эксплуатации нового мобильного интерфейса`,
"label":`Ярлык`,
"label.quickbooks.viewlist.total1":`Есть {0} счета на общую сумму {1}`,
"front-kefu-moudle-v1-input-publicKey":`Пожалуйста, введите общий ключ`,
"label.approval.allowed.reject":`Отказ разрешен`,
"label.visualpage.folder.notdel":`Вы не можете удалить эту папку, потому что некоторые файлы в ней.`,
"label.projectManagement.charging":`Зарядка`,
"label.ccservice.validate":`Некорректен формат соответствующего значения {2} поля {1} под объектным API {0}. Пожалуйста, введите правильное число!`,
"message.unbind.mfadevice.no.permission":`Вы не имеете права отключать устройства MFA. Обратитесь к своему администратору.`,
"label.partner.new.step3.meno":`Не знаешь, что записать? Не волнуйся, ты можешь поменять его позже в любое время.`,
"label.import.page3.importsucceedtip":`Начать импорт успешно. После импорта, на ваш соответствующий почтовый ящик будет отправлено письмо`,
"label.customsetting.visible.protect":`Защищенный`,
"label.publishreadandwrite":`Публичное чтение/запись`,
"vue_label_file_add_most_once":`Добавлять максимум один раз`,
"label.salescloud.teamrole.optionlist.group":`Назначение ролей для членов команды по работе с возможностями и членов команды по работе с клиентами.`,
"label.appointment.wizard.subtitle7":`Местоположение`,
"label.task.dateminus":`Минус`,
"label.data.exp.zippwd":`Введите пароль к сжатому файлу вручную`,
"UG_Forcast_09":`Следующий шаг`,
"message.duplication.label.allselectlink":`[Выбрать все]`,
"label.file.ccchat.selectfromcloudcc":`Выберите файл из CloudCC`,
"label.ems.addaccount3":`Добавить аккаунт`,
"front-epwechat-module-v1-schedule-sync":`Расписания синхронизации`,
"label.h5.manage":`Управление приложениями`,
"setup.layout.label.nobutton":`Нет доступных кнопок`,
"label_component_hotdeal":`Горячие предложения`,
"template.dashboard.contract.analysis":`Анализ договоров и дебиторской задолженности`,
"vue_label_dashboard_editcomponent":`Компонент редактирования`,
"label.quotationInformation":`Информация о цитатах`,
"label.data.file.validation_rules":`Исполнять правила проверки`,
"label.ccpeak.construction.shareobj":`Для того чтобы построить разделяемую форму объекта, необходимо передать в API имя и разделяемую метку.`,
"label.wei.pollinformation":`Микро детали голосования`,
"label.quickbooks.viewlist.total3":`Есть {0} платежей на общую сумму {1}`,
"label.paging.totalofpagesnoid":`Всего {0} страниц`,
"label.unlock":`Разблокировать`,
"front-invoice-online-payment-information":`Информация о счетефактуре`,
"label.permission.systempermission":`Назначенные системные разрешения`,
"message.error.object":`При вызове услуги обнаруживается, что объект не определен.`,
"font-trade-module-v1-invoice-intro":`Введите номер или название счетафактуры`,
"label.userinfo.pwdexpired":`Текущий пароль истек. В целях безопасности вы должны изменить пароль прямо сейчас.`,
"label.userphoto.photo":`Фото`,
"label.tabularreport.filterrecord":`Выберите критерии tge для определения, какие записи показывать`,
"label.partnerCloud.orderingPlatform.rechargeIt":`Баланс вашего счета недостаточен, пожалуйста, пополните его.`,
"label.icon.120":`Компьютер`,
"label.projectManagement.select.new.type":`Выберите тип создания`,
"vue_label_commonobjects_detail_customer_details":`Загрузка данных клиента`,
"label.ems.status":`Статус`,
"label.validate.function.description":`Любая функция, соответствующая синтаксису java, может быть использована в правиле валидации, и выражение должно возвращать булево значение.<br>Вы также можете использовать определенную функцию, предоставляемую CloudCC.
Например, isNew(),isChanged(FieldAPIName__c),priorValue(FieldAPIName__c),priorValue() возвращает объект, его необходимо преобразовать в соответствующий тип поля.`,
"label.escalation.setup.newaction.step2":`Шаг 2 Выберите пользователя для автоматической переадресации случаев`,
"label.forecast.customforecast.searchforecast":`Найти прогноз`,
"label.the.upper.bound.of.each.level.of.block.pricing.must.be.greater.than.the.lower.bound.":`Верхняя граница каждого уровня должна быть больше нижней границы при ценообразовании по блокам.`,
"vue_label_commonobjects_view_notice_deletefailreason":`Удалять данные с помощью идентификатора записи {0}, причина: {1};`,
"page.field.masterinput.remark":`Включенный главный почтовый вход используется для создания соответствующих записей списка на закладке.`,
"lable.SalesCommitmentKanBan.contractName":`Название контракта`,
"front-gantt-module-add-milestone":`Добавить веху`,
"label.callcenter.save.error":`Пожалуйста, не сохраняйте снова`,
"label.workflow.selectobj":`Шаг 1 Выберите объект`,
"label.validate.function.category.all":`-- Все функциональные категории...`,
"label.multilang.uploadifupage.select":`Вы полностью выбрали файлы:`,
"label.weixin.dragsort":`Перетащите иконки в "Мои приложения", чтобы отсортировать их.`,
"N":`Номер`,
"label.knowledge.article.translation.completed":`Перевод статьи завершен`,
"label.weixin.myapp":`Мои приложения`,
"label.icon.138":`Валюта`,
"vue_label_chat_create_discussion_now":`Создать дискуссию сейчас`,
"label.knowledge.recover.article":`Восстановить статью`,
"label.ccpeak.use.class.time.map":`Доступ, пройдя в коллекцию карт`,
"front-email-payment-error-tips":`Ошибка интерфейса`,
"label.service.gantt.ziyuan":`Только для`,
"label.upload.error":`Не удалось`,
"label.staticresource.upload.error":`Ошибка загрузки статических ресурсов!`,
"com.cloudcc.login.error.message.loginfail":`Операция не удалась, пожалуйста, свяжитесь с администратором`,
"pagecreator_button_back":`Последний шаг`,
"label_tabpage_skip":`Перейти к`,
"label.pw.old":`Пожалуйста, введите старый пароль`,
"pagecreator.layout.label.modifylayout":`редактор макета`,
"vue_label_chatter_share_group":`Поделиться с группой`,
"label.app.edit":`Редактирование приложений`,
"label.user.Email.repeat":`Дубликат электронной почты. Этот пользователь не поддерживается для связывания с агентом`,
"label.field.quilt":`Это поле`,
"label.projectManagement.Groupuser":`Группировка по пользователям`,
"label.deleteall":`Удалить все`,
"label.appexchange.download.tiaoguo.mes":`Игнорируйте установку следующих конфликтующих компонентов:`,
"label.sendemail.recycle.operatehello":`#username hello:\r\n`,
"label.emailmerge.mergeFolder.max20templates":`Вы можете выбрать до 20 шаблонов!`,
"label.campaignmember.main.deleteleaddesc":`Массовое снятие всех зацепок с этой кампании`,
"Opportunity_Detailed_Phase_Label_Popup_003":`Дни на текущем этапе`,
"vue_label_file_no_title":`Нет названия`,
"label.data.dataexpalltype.all.desc":`Экспорт данных всех объектов, к которым имеет доступ текущий пользователь для чтения.`,
"label.dashboard.unit2":`Единица измерения: миллион`,
"label.list.userinterface.isrelatedlist":`Включить ссылки на связанные списки наведения`,
"label.role.tree":`Ролевая иерархия Вашей организации`,
"label.campagin.roi.zcsl":`Регистрация`,
"message.error.forecast.setupchange":`Данные, к которым вы пытались получить доступ, могут быть найдены. Они могут быть удалены другими пользователями или изменены.`,
"label.sendemail.changeowner.dataname":`Название документа: #датановый файл`,
"label.salescloud.opportunity.contactrole.optionlist":`Контактные роли для контактов Значения пиклиста`,
"setup_mainpage_label_welcome1":`Нужно соответствующее разрешение`,
"UG_activity_02":`Назначение задач`,
"label.tabpage.erraddressz":`Неправильный формат адреса электронной почты, пожалуйста, введите адрес электронной почты правильно`,
"label.weixin.nicheng":`Никнейм WeChat`,
"label.forecast.settings.mrsz":`Прогнозное измерение`,
"label.campaign.channel.download.size3":`Маленький size: 300*300 пикселей`,
"label.icon.73":`Станок`,
"label.ServiceCloud.suoxuchanpin":`Необходимые продукты`,
"label.escalation.setup.newrule.description":`Введите имя правила и активируйте его. Активация этого правила деактивирует правило эскалации текущего случая. Чтобы отключить автоматическое повышение рейтинга, отключите все правила повышения рейтинга.`,
"label.data.import.setup.whichfield.cloudccid":`CloudCC ID`,
"label.validate.function.funcExplain.PRIORVALUE":`Возвращает тип объекта, соответствующий тип поля должен быть преобразован.`,
"Lead.Scoring.Warning.001":`При создании или редактировании одной ведущей записи оценка производится автоматически. Но при пакетном импорте или создании по интерфейсу необходимо вручную забить несколько зацепок.`,
"label.tianyancha.businessverify.msg9":`Право толкования настоящего соглашения принадлежит пекинской научно-технической компании "Шэньчжоу Юньдун" (shenzhou yundong science and technology co., ltd.).`,
"label.compact.layout.tip":`Раскладка ключевой информации используется для отображения ключевого поля детали записи на странице деталей.`,
"label.visualpage.btype":`Доклады`,
"label.textmessage.vonage.settings":`Настройки`,
"label.field.not.exites":`несуществовать`,
"label.payment.switch.version":`Переход к новому изданию`,
"label.ems.hour":`Час`,
"label.weixin.cannot.edit":`Тип файла не может быть отредактирован`,
"chatter.pt.limit":`Максимальный размер файла`,
"label.quote.detailinfo.add":`Добавить строки котировок`,
"component.setup.label.displayfield":`Поле отображения`,
"vue_label_report_reportfolder":`папка отчётов`,
"label.gbkencoding":`китайский (ГБК)`,
"front-kefu-moudle-v1-Transfer-to":`Перевести на {TransferName}`,
"label.file.stop.sharing.desc2":`Совместный доступ`,
"label.textmessage.messageCannoutuse":`Невозможно, пожалуйста, свяжитесь с Администратором, чтобы включить Текстовые сообщения.`,
"component_newrecords_label_type":`Тип хранения`,
"label.validate.function.funcFormat.ISNEW":`ISNEW()`,
"lable.product.pricebooks.new":`Новая книга цен`,
"vue_label_newfile":`Новый файл`,
"label.reportTypcrtB":`Связанный объект (b), пожалуйста, нажмите, чтобы выбрать связанный объект`,
"label.knowledgebase.type":`Категория`,
"label.report.select.format":`Выберите формат отчета`,
"component.todaytask.label.title":`Сегодня`,
"message.undelete":`Вы уверены, что хотите отменить удаление?`,
"label.ccdocument.trace.retention":`Функция удержания трассировки`,
"label.publicgroup.tip":`Публичная группа - это набор пользователей. В нее могут входить отдельные пользователи, другие группы, пользователи в определенной роли или территории, или пользователи в роли или территории плюс все пользователи, находящиеся ниже этой роли или территории в иерархии.`,
"label.forecast.settings.lable2":`Настройка отображения прогноза по умолчанию`,
"label.projectManagement.positive.integer":`Пожалуйста, введите целое положительное число в пределах 0-24.`,
"label.projectManagement.one.work.list":`Пожалуйста, заполните хотя бы один список работ!`,
"label.or":`||Or`,
"label.projectManagement.no.person.in.charge":`Нет руководителя`,
"vue_label_commonobjects_detail_an_email":`электронная почта`,
"front-electronic-signature-field-mapping":`Добавить отображение полей`,
"label.marketsea.name.error":`Имя свинцового пула не может быть пустым`,
"component.setup.button.appurl":`Системный урл`,
"label.mr.title.button.group1":`Сайт`,
"chatter.contact":`Контактная информация`,
"vue_label_pool_hasfixed":`фиксированные каналы сотрудничества`,
"lable.list.queue.des":`Очереди позволяют группам пользователей более эффективно управлять общей рабочей нагрузкой. Очередь - это место, куда записи могут быть маршрутизированы в ожидании обработки членом группы. Записи остаются в очереди до тех пор, пока пользователь не примет их для обработки, или пока они не будут переданы в другую очередь. Вы можете указать набор объектов, поддерживаемых каждой очередью, а также набор пользователей, которым разрешено извлекать записи из очереди.`,
"label.reportsSubscriptionPage.condition":`Условия`,
"label.transwork":`Верстак для переводов`,
"label.batch.batchopration.resel":`Пожалуйста, повторно выберите данные, которые вы хотите перенести, и нажмите "ОК", чтобы перейти к странице просмотра списка.`,
"label.cloudccsite.new":`Новый сайт`,
"label.button.select.page.required.field":`Выберите необходимые поля для включения на Вашей странице:`,
"label.pagelayout":`Макеты страниц`,
"label.weixin.trace.record":`Отслеживание записей`,
"label.emailtocloudcc.clear":`Clear`,
"label.checkfield.find":`Найти дубликаты`,
"message.view.count.title0":`Обзор текущей страницы`,
"label.reportsSubscriptionPage.schedulereport.frequency":`Частота`,
"setup.mainpage.label.welcome5":`Настраиваемое поле`,
"label.implementation.details":`Выполнить детали`,
"label.attendance.history":`История посещений`,
"label.is.pigeonhole":`Архив`,
"lable.account.CurrentandPreviousFYt":`Текущая и предыдущие 2 года`,
"label.forecast.customforecast.tab.opportunity":`Возможности`,
"label.version.business.track":`Отслеживание возможностей`,
"label.profilelayoutedit.selectrecordtype.tip":`Выберите тип записи для данного профиля пользователей. Необходимо добавить поле типа записи в макет страницы, связанный с этим профилем, чтобы он отображался на страницах деталей и на страницах редактирования.`,
"label.campagin.roi.zclzb":`Стоимость регистрации`,
"label.validate.function.funcFormat.WEEKDAY":`Еженедельное число`,
"label.view.sort.message":`Сортировано по {!сорту}`,
"page.field.masterinput.sort":`Ведущие денежные входы отображаются в том порядке, в котором они были сохранены.`,
"label.selected.field":`Выбранные поля поиска`,
"label.product.proofTwo":`В {0} выберите, пожалуйста, не менее {1} вариантов товара.`,
"vue_label_report_filtercondition":`Состояние фильтра`,
"label.forecast.shrepage.desc1":`На этой странице перечислены пользователи, роли и территории, которые имеют общий доступ к`,
"label.file.copy.link":`Ссылка на копирование`,
"vue_label_chat_movedto":`переехал в НьюФилд.`,
"label.layout.new.built":`новая секция`,
"label_tabpage_crecordtypez":`Изменить тип записи`,
"label.report.searchcustominfo":`Введите ключевые слова для поиска подходящих пользовательских отчетов`,
"chatter.feed.menutype.user":`Коллеги`,
"label.recordtypeselect":`Выберите Тип записи`,
"label.partner.new.step3":`Шаг 3 Введите имя и урл`,
"label.newCustomReportType":`Новый источник данных пользовательских отчетов`,
"label.service.gantt.day.timescale":`Шкала времени на дневной просмотр:`,
"label.displaytype3":`Кнопка списка`,
"label.weixin.discharge.rate":`объём отработанных газов`,
"label.weixin.menu.message":`Меню`,
"label.mask.show.all.characters":`Маска отображает все символы`,
"label.quickbooks.fieldlabel.billingaddress":`Адрес для выставления счёта`,
"Dashboard.View.All":`Все приборные панели`,
"setup_mainpage_label_welcome22":`Инструкции: Щелкните по меню в левой части этой страницы → Управление настройками → Шаблон рассылки → Шаблон электронной почты.`,
"chatter.group.groupInformation":`Информация о группе`,
"front-epwechat-module-v1-input-secret":`Пожалуйста, введите Секрет`,
"lable.Set.value.prompt":`Или отфильтруйте записи, отображаемые в связанном списке. Выберите поля флажка или пиклиста и значения, которые вы хотите отфильтровать. Если вы вводите значения вручную, пожалуйста, разделяйте их запятыми.`,
"label.appupload.upload.from":`По адресу`,
"label.weixin.postunsolve":`Просрочка`,
"label.cooperation.all":`Все Сотрудничество`,
"lable.PowerProcess.close.time":`На основании времени закрытия {detailInterestType}`,
"lable.opppdt.selPdt.leastone.fields":`Пожалуйста, выберите хотя бы одно из полей.`,
"label.emailtocloudcc.help":`Пожалуйста, введите правильный электронный пароль или код авторизации. Если вашему почтовому серверу необходимо включить службу IMAP/SMTP для входа в систему с помощью учетной записи стороннего производителя, сначала необходимо войти в настройки учетной записи электронной почты, чтобы включить службу, и скопировать код авторизации для авторизации в это поле ввода пароля.`,
"label.attendance.offwork.time":`Конец дня`,
"front-gantt-module-v1-project-gantt":`Диаграмма Ганта проекта`,
"label.chuangming.description":`Настройте информацию Чуангринга для удовлетворения потребностей вашей организации в услугах по отправке и получению SMS-сообщений.`,
"label.custom.lead.notice.account.name":`Есть зацепка, которая, была конвертирована, указать, что вы являетесь владельцем счета, контакт и возможность. Имя аккаунта:`,
"label.emailobject.failedtosend1":`Отправка провалилась: Аутентификация по электронной почте недействительна, пожалуйста, reconnect！`,
"vue_label_ccchat_notice_updaterecordsuccess":`Эта запись была обновлена`,
"label.dayinmonth":`Месяцы`,
"label.sendemail.chat.follow":`Дорогой #name:\n\n hello! #userName следует за тобой.`,
"label.emailsync.form.emialpassword":`Пароль`,
"component_task_label_subject":`Тема`,
"label.projectManagement.please.enter.a.positive.integer":`Пожалуйста, введите целое положительное число.`,
"lable.account.NexteDays":`Следующие 7 дней`,
"label.appupload.upload.managed":`Можно создать максимум один управляемый пакет!`,
"label.data.dataexpalltype.all.desc1":`1、Вы можете снимать для автоматической генерации и вручную ввести пароль экспортированного файла сжатия. Автоматически сгенерированный пароль будет отправлен на почтовый ящик пользователей, когда данные экспортируются успешно. Введенный вручную пароль не будет отправлен на почтовый ящик, поэтому пользователи должны помнить пароль, который они ввели. Если пароль не введен, по умолчанию пароль отсутствует.`,
"label.step1.total3":`Шаг 1 из 3`,
"label.escalation.setup.detail.section":`Правило Подробнее`,
"front-gantt-module-drag-task-sorting":`Перетаскивание задач для упорядочивания`,
"label.isEnableVisualpage.new.title":`Включите индивидуальный доступ к странице`,
"label_tabpage_yesz":`Да`,
"label.emailobject.emaildetail.button.replyall":`Ответить всем`,
"label.knowledge.setting.data.one":`Это не может добавить больше подкатегорий.`,
"label.manageAll.sel.one3":`Пункты I Утверждено`,
"UG_contact_01":`Как извлечь максимум пользы из ваших контактов?`,
"font-trade-module-v1-invoice-name":`Название счетафактуры`,
"label.central.daylight.time":`Центральное летнее время`,
"label.chatter.pastThirtyday":`За последние 30 дней`,
"vue_label_commonobjects_detail_activity_ownevent":`Доступное мероприятие`,
"label.user.modify":`Редактирование пользователем`,
"label.uploadTemplate":`Загрузить шаблон`,
"setup_mainpage_label_welcome14":`Управление процессом настройки рабочего процесса, утверждение`,
"label.workmate":`Коллеги`,
"label.displaycolumns":`Дисплейные столбцы`,
"label.emailnoticeintro":`Электронные оповещения - это письма, которые правила документооборота отправляют при срабатывании.`,
"label.knowledge.category.button.five":`Удалить категорию`,
"template.report.business.opportunities.type":`Возможности по типам`,
"vue_labenl_applauncher_moreapp":`Дополнительные приложения`,
"label.captcha.expired":`Срок действия проверочного кода истек, пожалуйста, проверьте его еще раз.`,
"template.chart.bnqzkhslmb":`Целевое количество лидов за год`,
"chatter.up.user.pic":`Загрузить фотографию пользователя`,
"label.timezone.importtimezone.gmt":`Используйте gmt таймзон`,
"label.step.type":`Выберите тип пользователя, который вы хотите найти`,
"Dashboard.View.RecentlyView":`Недавно просмотренный`,
"label.reportinthisfolder":`Отчеты в этой папке`,
"label.product.vies":`Виды продуктов`,
"pagecreator_systemstyle_message_delete_fail":`Удаление стиля не удалось`,
"label.multipleactivity.singleUser":`Одинокий пользователь`,
"vue_label_email_enter_subject":`Введите тему`,
"label_tabpage_alltabs":`Все вкладки`,
"label.publicgroup.groupname":`Название группы`,
"template.report.sales.performance":`Производительность продавцов`,
"label.newWindow":`Новое окно`,
"label.forecast.editopp.forecastedit":`Редактирование прогноза`,
"label.data.import.setup.whichfield":`Какое поле вы хотите использовать для сопоставления?`,
"label.noadd_dashboard":`Не добавляйте в приборную панель`,
"label.subtotal":`Промежуточный итог`,
"front-email-payment-weichat":`Пожалуйста, используйте WeChat "Scan"`,
"label.attendance.position.alert":`Пожалуйста, сначала выберите маску`,
"chatter.follow.me":`Следуйте за мной`,
"label.mobile.more.details":`Редактирование файла Детали`,
"Dashboard_SelectBoardToDisplay":`Пожалуйста, выберите приборные панели, которые вы хотите отобразить на странице вкладки "Ракетка".`,
"front-gantt-module-v1-search-project":`Поиск по вашему проекту...`,
"label.paging.totalofpagereport":`Всего {0} страниц({1}).`,
"label.from.phone":`С сайта`,
"lable.Signatory":`Сигнтори:`,
"label.campagin.roi.query.roi2":`Каналы маркетинга ROI`,
"label.tabpage.selectcontentz":`Пожалуйста, выберите содержание`,
"label.multilang.lookfiltercondition.valuetypenotmate":`Условие строки {0} неверно, тип значения не совпадает!`,
"label.interfaceconstraint.disabled":`Интерфейс отключен, пожалуйста, свяжитесь с системным администратором.`,
"third":`Третий`,
"label.quickbooks.viewlist.status":`СТАТУС`,
"label.emailtocloudcc.select3":`Пожалуйста, выберите владельца записи`,
"label.projectManagement.week.work":`Моя работа на этой неделе`,
"vue_label_pool_nodemand":`Нет спроса`,
"label.version.two.developapi":`API вторичной разработки`,
"label.icon.82":`Принтер`,
"label.batchadd.newbatchpage.suclist":`успешно добавленные данные`,
"label.checkfield.chooseatlast":`Пожалуйста, выберите как минимум два`,
"label.quotation.deleteTip":`Пожалуйста, выберите строки цитат, которые необходимо удалить`,
"label.generatepage.title.desc2":`Нажмите Сохранить, чтобы сгенерировать Web-страницу и ссылку Web URL, по которой можно получить доступ.`,
"label.licence.total":`Всего лицензии`,
"Y":`Поисковые отношения`,
"label.wuzibiekesitan.time":`Время Узбекистана`,
"label.component.hotdeal.nodata":`Нет данных, связанных с бизнес-возможностями.`,
"label.data.exp.save":`Сохранить шаблон`,
"label.appupload.upload.tips.dashboard":`ПРИМЕЧАНИЕ: Дашборды "Мои пользовательские приборные панели" и "Незаполненные публичные приборные панели" не могут быть добавлены в пакеты и не будут показаны в этом списке. Соответствующие старые отчеты не могут быть загружены".`,
"lable.PowerProcess.new.PowerProcess":`Процесс получения новых прав`,
"label.loginhis.search.download":`Учитывая, что истории входов в систему много, при поиске скачиваний можно скачать только историю за 2 месяца.`,
"label.tabpage.deleteview":`Удалить вид`,
"label.chatter.recently":`Недавно`,
"label.industrialandcommercialverification.title":`Промышленная и торговая проверка`,
"message.nextapproverlost":`Следующее указанное утверждение является недействительным.`,
"front-kefu-moudle-v1-mfsysy-time":`Оставшиеся дни бесплатной поездки`,
"label.role.assign.tip":`Выберите пользователя в списке Available Users (Доступные пользователи) и добавьте его в список Selected Users (Выбранные пользователи), чтобы назначить его на эту роль.`,
"label.addattachment.step2.intruduce":`Повторите шаги 1 и 2 для добавления нескольких файлов.`,
"vue_label_pool_returnreasondiscription":`Описание причины возвращения`,
"label.weixin.report.range":`Диапазон`,
"label.wei.weiresearchtab":`Микро Выбор Голосования`,
"vue_label_report_setdrill":`Установить дрель`,
"page_404_button_back":`Возврат к предыдущему шагу`,
"label.customfields.autonumber.tip":`Сгенерированный системой порядковый номер, использующий заданный вами формат отображения. Номер автоматически увеличивается для каждой новой записи.`,
"label.ccpeak.return.allrecords":`Вернуть все рекорды`,
"label.ccchat.notmember.active.group2":`Вы не под именем`,
"label.uniquename":`Уникальное имя`,
"label.emailtocloudcc.filed.ssl":`Безопасное соединение`,
"chatter.emailFollowMe":`Следуйте за мной`,
"label.allrightsreserved.allrightsreserved.customerServiceHotline":`Авторское право. Все права защищены. Горячая линия обслуживания клиентов`,
"label.projectManagement.actualworkinghours":`Фактическое рабочее время`,
"label.quickbooks.fieldlabel.taxresale":`Перепродажа налогов`,
"label.icon.12":`Сервис`,
"label.data.exp.dataexptemp":`Шаблоны экспорта данных`,
"component_setup_tabs_label_add":`Добавлен`,
"label.appointmentdetail.wizard.title10":`Дата начала`,
"label.multilingual.close":`Управление несколькими языками не включено.`,
"message.error.username.notexist":`Неверное имя пользователя, пожалуйста, введите заново.`,
"label.batchadd.newbatchpage.des2":`Если типом поля является Auto Number (Автономный номер), то номер автоматически увеличивается для каждой новой записи без ручного ввода.`,
"vue_label_SMS_search":`Поиск проводов или контактов`,
"label.appupload.successWithUrl":`Теперь ваш пакет доступен для установки по установочному URL ниже.`,
"UG_Forcast_06":`Пожалуйста, выберите пользователей, которым разрешено прогнозировать`,
"vue_label_dashboard_secondarygroup":`Пожалуйста, выберите второстепенную группу`,
"label.weixin..xsld.total":`Общая сумма в воронке продаж`,
"label.setup.mobile.bottombutton.recovery.default.fail":`Не удалось восстановить по умолчанию`,
"label.addrecurrencetimetrigger":`Добавить периодический триггер времени`,
"label.emailsync.connectaccount":`Подключить электронную почту`,
"label_fiscal_years":`Финансовый год`,
"label.icon.164":`Тренер`,
"label.batchadd.mustinput":`Поле с`,
"message.newtabpage.nokeywords":`Ваш поисковый запрос должен содержать 1 или более символов. Или вы можете добавить расширенные критерии поиска.`,
"label.login.verification.mfa.desc3":`Если ваша учетная запись была совместно использована несколькими людьми, другие люди, не связанные с МИД, не смогут войти в систему после того, как вы успешно связали МИД. Решение заключается в том, чтобы кто-то другой установил приложение MFA и отсканировал QR-код для этой страницы, или сохранил изображение QR-кода для последующего сканирования другими людьми. Однако с точки зрения безопасности мы рекомендуем вам отменить несколько общих аккаунтов.`,
"label.partnerCloud.basicSetting.initialize":`Вы не можете изменить имя домена после инициализации.`,
"label.address.county":`Округ`,
"label.validate.function.funcFormat.TODAY":`TODAY()`,
"label.sso.addAKey":`Добавить клавиши`,
"label.myusergroup":`Мои группы пользователей`,
"label.import.index.time-consuming":`Время`,
"label_tabpage_systems":`Существуют * системы`,
"batch.sendemail.s":`Почта отправлена успешно.`,
"label.appointment.wizard.subtitle4-1-1":`15 минут`,
"label.projectManagement.delete.milestone":`Вся связанная информация этой вехи также будет удалена, если вы удалите эту веху, и данные не смогут быть восстановлены. Вы уверены, что хотите подтвердить удаление?`,
"label.umeng.chatter.praise":`понравился твой пост.`,
"font-evaluate-module-v1-evdetails":`Оценка деталей:`,
"label.group.filter.resources.and":`Выберите метод фильтрации ресурса, И отношение.`,
"label_emailtocloudcc_description":`Подключите учетную запись электронной почты предприятия, например, sales@company.com, info@company.com, support@company.com. Автоматически регистрировать полученные письма в CloudCC в качестве зацепок и записей по делам, чтобы обеспечить своевременное отслеживание писем клиентов.`,
"label.chat.topic.delete.prompt2":`Обратите внимание, что одноименные темы в других сообществах не удаляются.`,
"message.error.group.authorization":`У вас нет доступа к настройке этой группы.`,
"label.attendance.wz":`Местоположение`,
"vue_label_activity_notice_logacal_success":`Вы записали звонок`,
"label.emailtocloudcc.step1.case1":`Электронная почта на имя дела`,
"label.h5.chatter.praisenum":`Получил похвалу`,
"label_time_statistics_basis":`Основа статистики времени`,
"label.onlyadmincanedit":`Администраторы <strong>ONLY</strong> могут редактировать записи во время процесса утверждения.`,
"label.fieldtoolongmassage":`Поле`,
"label.sales.team.shared":`Коммерческие возможности Совместное использование групп`,
"label_emailsync_status_department":`Департамент`,
"label.mobile.quickcreate.default.sellingfunnel":`Воронка продаж`,
"label.tabpage.closez":`Закрыть`,
"homepage.components.two":`Шаг 2 - выбор места отображения пользовательских компонентов.`,
"label.everyday":`Ежедневно`,
"lable.Product.to.asset.BOM":`Продукт в спецификацию активов`,
"label.appointment.wizard.subtitle4-3":`Приглашаемый может выбрать начало в каждом`,
"label.customobjects.standardfieldslist":`Стандартный список полей`,
"label.customfields.suretodelete":`Да, я хочу удалить пользовательское поле.`,
"component.chatter.label.to":`На`,
"label.emailsync.form.seversetting":`Настройка`,
"label.service.gantt.enabled.resources":`Активированный ресурс`,
"label.tianyancha.h5.weibo":`Микроблог`,
"template.chart.dddje":`Сумма потерянных заказов`,
"label.pc.trigger.apiname":`Имя API уже существует, пожалуйста, попробуйте еще раз.`,
"label.icon.34":`Настраиваться`,
"label.schedulejob.setup.schedule.prgname":`Название приложения`,
"label.weixin.free.registration":`Зарегистрироваться бесплатно`,
"label.placeholder":`Быстрый поиск`,
"label.emailobject.manage.template":`Управление шаблонами`,
"label.knowledge.article.existsdata":`Существуют и другие неквалифицированные данные.`,
"label.campaign.channel.lookup.ticket":`Проверьте билет`,
"label.searchlayout.relation.searchfield":`Поля поискового фильтра для соответствующих списков.`,
"label.recordid.cannot.empty":`Идентификатор записи не может быть нулевым`,
"label_partner_workspace_member_choice":`Выберите профиль`,
"vue_label_campaign_amount":`Сумма дохода`,
"label.niue.time":`Ниуэвское время`,
"front-homepageobject-module-v1-workload-ranking":`Ранжирование рабочей нагрузки`,
"message.error.datainvalid":`Ошибка: недействительные данные.`,
"vue_label_helpcenter_salesfunnel":`Используйте новую версию воронки продаж для анализа последующих бизнес-возможностей и предоставления ссылок на данные для вашего процесса продаж.<br> В верхнем левом углу записи будут отфильтровываться в соответствии с такими условиями, как роль или владелец, а все видимые бизнес-возможности при соответствующих условиях будут просматриваться и анализироваться. Для просмотра всех записей на этом этапе нажмите на этап диаграммы воронки продаж.`,
"vue_label_transferownernotice":`Владелец записи, связанной с этим пунктом, также будет изменен.`,
"label.monitorsys.operator":`в соответствии с`,
"label.please.codeNorm":`Пожалуйста, выберите стандарт кода.`,
"label.campaign.channel.step6.remark2":`Разрешить сотрудникам обращаться с просьбами`,
"market.potential.customers":`Лидер рынка`,
"label.customfields.phone.tip":`Позволяет пользователям вводить любой телефонный номер. Автоматически форматирует его как телефонный номер.`,
"label.currency.edit":`Редактирование валюты: Изменение корпоративной валюты`,
"label.emailobject.emaildetail.button.markasunread":`Отметить как непрочитанный`,
"label_partner_template_memo":`Название`,
"label.chat.message.search.all":`Выполнять поиск по всей информации`,
"label_tabpage_hoursagoz":`часы`,
"label.customcomponent.developer.help":`Помощь разработчика пользовательских компонентов`,
"setup_mainpage_label_welcome":`Добро пожаловать на платформу CloudCC PaaS, основные функции платформы следующие:`,
"label.h5.similar.opportunity.list":`Результаты включают в себя закрытые возможности, которые имеют одно или несколько полей, совпадающих с вашей возможностью. Размещение закладок добавляет их в список Похожие Возможности на странице с подробной информацией о Вашей сделке.`,
"vue_label_record_count":`Количество записей`,
"label.icon.29":`Демонстрация`,
"pagecreator.page.label.pagelayout":`Макет страницы`,
"label.ggReleaseRange.searchRole":`Поиск роли`,
"label.campagin.member.field.setup":`Настройки поля участника кампании`,
"augest":`август`,
"label.salescloud.massloss.content":`Команды по отключению возможностей необратимо удалят существующие команды из всех возможностей и удалят команды пользователей по умолчанию.`,
"label.customfields.new.step2.opration.unique.info":`Дублирующие значения не допускаются.`,
"vue_label_email_optional_members":`Факультативные члены`,
"label.emailobject.attachment.download":`Скачать`,
"label.recordamount":`Количество записей`,
"front-kefu-moudle-call-recorder":`Запись разговоров`,
"label.more.info":`Подробности`,
"vue_label_commonobjects_view_secondsbefore":`секунды`,
"label.emailsync.status.action":`Действие`,
"label.customfields.totalsummary.collectedfields":`Обобщенный объект`,
"label.knowledge.setting.hint.two":`Внимание: Вы не можете отключить Знание после его включения.`,
"label.login.access.yujidao":`Эксп.`,
"label.assignment.setup.detail.description":`Добавьте записи правил, которые определяют критерии, используемые для автоматического назначения приводов пользователям.`,
"message.error.marketsea.null":`Свинцового Бассейна не существует`,
"lable.account.Current.CY":`Текущий CY`,
"vue_label_salesadvance_lost":`Потеря`,
"label.file.ownedbyme":`Владеющий мной`,
"label.component.helper.nodata":`Ничего не требует твоего внимания сейчас. Пожалуйста, проверь позже.`,
"label.weixin.appr.pending.auditor":`Представлено`,
"UG_opportunity_004":`Мультисервисный тип`,
"label.leadscore.setup":`Настройки подсчета очков по свинцам`,
"label.addtimetrigger":`Добавить триггер времени`,
"label.mr.title.match":`Если точное совпадение`,
"label.projectManagement.Newmilestone":`Новая веха`,
"label.preview":`Предварительный просмотр`,
"label.tabpage.issuez":`Выпуск`,
"label.img.max.size":`Загруженное изображение слишком большое, и максимальный размер загруженного изображения 500K, пожалуйста, загрузите его еще раз.`,
"label.mainpageset":`Настройка компонентов домашней страницы`,
"label.user.login.false.lock":`Количество попыток входа превышено. Учетная запись заблокирована`,
"UG_solution_02":`Решение - это внутреннее решение проблемы, с которой сталкивается учреждение.`,
"vue_label_approve_put_away":`Collapse`,
"label.profile.existing":`Существующий профиль`,
"label.ems.logininfo":`Информация для входа`,
"label.weixin.location.service":`Объекты, поддерживающие услуги по определению местоположения`,
"label.multilang.datamoveaction.totaldata":`Всего есть {1} записи, удовлетворяющие условию, максимум 100 записей можно передать на одном сайте time！：.`,
"label.ccdocument.cannot.update.set":`Этот документ не принадлежит к типу Word, Excel или PPT файла, не загруженного в шаблон красной папки.`,
"vue_label_fliter_addfliter":`Добавить Флитер`,
"label.custom.page.or.trigger":`(Пользовательские страницы или триггеры)`,
"label.tag.filter1":`Отфильтровать записи, которые содержат все выбранные теги.`,
"UG.homepage.006":`360-градусный обзор деятельности вашей учетной записи с помощью опросов, живых чатов, электронной почты, заказов на работу, сообщений в социальных сетях, и даже торговой деятельности (например, руководство, сервисная поддержка и деятельность).`,
"SCORE":`Оценка`,
"label.file.library.managemembers2":`Управление членами библиотеки`,
"label.email.template.public.SMS":`Папка шаблонов SMSсообщений`,
"label.leadscore.donot":`Не удается забить лидирующие позиции`,
"label.gaode.map":`Amap`,
"pagecreator_button_preview":`Предварительный просмотр`,
"UG_contact_04":`Или`,
"label.ccchat.person.invite.eminfo":`{0} пригласил вас присоединиться {1} к CCChat. С помощью ccchat вы можете общаться с коллегами, создавать команды для своих проектов и обмениваться файлами.`,
"setup_object_field_dependency_label_actionfieldvalue":`Поле управления`,
"lable.Product.options":`Варианты продукции`,
"front-electronic-signature-add-autofill-field":`Добавить поле автозаполнения`,
"label.customfields.totalsummary.selectcollectedfields":`Выберите объект для обобщения`,
"label.projectManagement.the.maximum.contract.amount.is.10.digits":`Для суммы контракта можно ввести до 10 цифр.`,
"label.forecast.shrepage.pagetitle":`Пользователи, роли и территории Совместное использование`,
"label.login.access.mark":`Для оказания помощи в вопросах поддержки вы можете предоставить администратору или персоналу службы поддержки возможность войти в систему по своему усмотрению и получить доступ к своим данным.`,
"lable.outlook.edit.zdyout":`Настраиваемое сопоставление полей обмена`,
"label.approveoperate":`Действия по утверждению`,
"label.tabpage.linknamez":`Имя ссылки`,
"label.report.error.deletehavedashboard":`Этот отчет имеет новую приборную панель и не может быть удален.`,
"label.summaryreport.2018.step1":`Шаг 1 Создание группировки`,
"label.campaignmember.main.leadtomember.title":`Конфигурация картирования полей`,
"label.select.dashboar.type":`Пожалуйста, выберите тип приборной панели`,
"message.setup.field.picklist.valueexists":`Значение этого списка уже существует.`,
"label.loading":`Загрузка...`,
"label.payments.paytip1":`Ваша текущая подписанная редакция не является бесплатной, пожалуйста, нажмите кнопку Подтвердить для обновления или повторного входа в систему.`,
"label.view.appliedMobile":`Применить к мобильному приложению`,
"label.multilang.forcast.financialyear":`{0} финансовый год: {0}`,
"front-web-module-v1-detail-comment-opinion":`Обратная связь`,
"UG_Forcast_10":`Полный`,
"label.optionlistset":`Параметры пиклиста`,
"label.visualpage_list.vpname":`Настраиваемое имя страницы`,
"vue_label_calendar_failed_to_delete_calendar":`Не удалось удалить календарь`,
"label.json.string.null":`Пустой`,
"message.serviceappo.time.violation2":`Нарушение доступного времени назначения услуги: Назначенное время окончания приема раньше, чем срок выполнения служебного задания`,
"label.productsales.today.noevttsk":`Нет открытых мероприятий и задач, срок действия которых истекает.`,
"label_tabpage_emptyz":`Пустой`,
"front-kefu-moudle-no-create":`Не создано`,
"label.wedge.shaped.tail.arrow.cannot.empty":`Стрелка хвоста клина не может быть нулевой`,
"label.continue.shopping":`Продолжить покупки`,
"label.turntomain":`Перейти к мастер-контенту`,
"component.assistant.label.nodata":`Никаких событий сегодня, пожалуйста, проверьте позже.`,
"label.payments.paytip4":`Пожалуйста, введите номер users！.`,
"label.appupload.upload.versionName":`Имя версии`,
"label.chatter.endData":`Дата окончания`,
"front-kefu-moudle-buytr-tip":`Мы надеемся, что у вас будет отличный опыт работы с коллцентром CloudCC, и что вы сможете приобрести официальный аккаунт коллцентра, и мы будем предоставлять лучшее обслуживание.`,
"label.repw":`Повторите пароль`,
"label.tabularreport.intro":`Табличный отчет - один из самых простых и быстрых способов перечислять данные.`,
"label.selectoperatetype":`Выберите Тип действия`,
"setup.layout.label.required":`Требуется`,
"label.default.designee":`По умолчанию Отправлено Перон`,
"label.ccdocument.cannotdel.folder":`Вы не можете удалить эту папку, потому что некоторые файлы в этой папке.`,
"label.escalation.setup.newentries.inputentries":`Введите запись правила`,
"label.emailobject.addnewtemplate":`Добавить новый шаблон`,
"label_chatter_content":`Содержание`,
"label.htyj.mubiao":`Цель`,
"label.reportsSubscriptionPage.schedulereport.weekly.friday":`пятница`,
"label_tabpage_fieldoptions":`Поле типа записи, поле списка опций и поле списка опций (множественный выбор). рекомендуется вводить не более 10 ключевых слов, разделенных запятыми, для достижения "или связи", например: "Нью-Йорк, Торонто, Токио".`,
"label.mobiletablayoutedit.remark2":`Выберите поля, отображаемые на главной странице вкладки в Мобильном приложении.`,
"label.sendemail.chat.addComentsat":`Дорогой #name:\n\n #userName упоминает вас в комментарии.`,
"Z":`Формула`,
"label.multilang.batchdeleteaction.movesuccess":`Всего удалено {0} записей successfully！：`,
"label.textmessage.vonage.message2":`Настраивая аккаунты Vonage API, пользователи позволяют CloudCC получить доступ к аккаунту Nexmo API для отправки и получения текстовых сообщений.`,
"label.file.use.document":`Использование места для хранения`,
"UG.Lead.011":`Создать подсказку`,
"label.view.name":`Название вида`,
"label.data.downtemplate":`Скачать шаблон`,
"vue_label_appstore_get_now":`Получить его сейчас`,
"label.controlfield":`Поле управления`,
"label.dataimport.type.insert":`Вставить`,
"label.customfields.multiselect.tip":`Позволяет пользователям выбирать несколько значений из списка, который вы определяете.`,
"label.weixin.approval.qxzjl":`Пожалуйста, выберите запись`,
"component.salesperformance.label.70finish":`Завершено - необработано (>70%)`,
"Lead_Auto_Scoring_Setting":`Установка лидирующих оценок`,
"pagecreator_layout_message_canntdelete":`Текущая раскладка не разрешается удалять`,
"vue_label_report_exprotpage":`Страница экспорта: Страница {страница}`,
"label.campaign.channel.step4":`Step4: Select обязательные поля для отображения на странице регистрации канала сбыта.`,
"label.app.launcher":`Запуск приложений`,
"vue_label_campaign_selectedmember":`Выбранные члены кампании`,
"label.mobile.quickcreate.default.approvals":`Утверждения`,
"label.view.step4":`Шаг 4 Ограничение видимости`,
"label.exchange.sync.state.user":`Статус синхронизации пользователя`,
"label.forecast.customforecast.tab.forecast":`Прогнозы`,
"label.theUserLoginForTheFirstTime":`Первый логин пользователя.`,
"label.workflowoperate.tip":`Укажите действия рабочего процесса, которые будут инициироваться при выполнении критериев правила.`,
"font-evaluate-module-v1-ten-points":`Положительная оценка: 10 баллов`,
"label.knowledge.delete":`Ошибка при удалении знаний`,
"front-console-see-contacts":`Выявленные {число} контактов`,
"label.h5.similar.opportunity.add.to.favorites":`Добавить в закладки`,
"front-epwechat-module-v1-install-app":`Установить в WeCom`,
"setup_layout_message_relatedlistbutton":`Выберите стандартные кнопки для отображения в соответствующем списке.`,
"label.salescloud.massloss.title":`Может привести к большой потере данных.`,
"front-console-conversation-btn1":`Кольцо назад`,
"label.custom.canvasScale":`Масштаб холста`,
"label.lead.score.doing":`В процессе подсчета очков`,
"message.approval.step.validation.invalid.number":`Недействительное число`,
"chatter.lk":`Например,`,
"label.dashboardSetup.showmaxval":`Максимально отображаемый`,
"label.keywords":`Ключевые слова`,
"vue_label_helpcenter_SMS":`Включите функцию SMS<br> Если код страны в CRM-системе, которую вы приобрели, - США, то функция SMS доступна в системе вашей организации. Администратор организации может ввести номер телефона, приобретенного Вашей организацией в системе vonage в шлюзе vonage в приложении фоновой интеграции, а затем воспользоваться функцией SMS в меню облачного приложения sales cloud.<br>SMS box<br> SMS box разделена на две части. Слева находится запись проводов или контактов с SMS. После нажатия на запись справа отображаются данные об отправке и получении. Вы можете просмотреть записи о себе и своих подчиненных.<br>Отправить групповое сообщение<br> В меню SMS Вы можете отправить групповые текстовые сообщения, список потенциальных клиентов или контактов, а также кнопку для отправки SMS-сообщений на участников кампании. Отправлять текстовые сообщения потенциальным клиентам или контактам можно только в CRM. После редактирования текстового сообщения, выберите "Отправить", и будет сгенерирована групповая запись, независимо от количества получателей, или вы можете выбрать "Отправить отдельно", чтобы отправить текстовые сообщения отдельно Поддержка отдельных SMS-сообщений, показывая объединенные поля, вставленные в шаблон SMS.`,
"label.emailobject.createnewavailability":`Создать новую доступность`,
"front-kefu-moudle-buytr-send-email":`Вы еще не ассоциированы с системным почтовым ящиком. Пожалуйста, отправьте письмо по адресу support@cloudcc.com и напишите ваше намерение, название компании и контактную информацию, сотрудники отдела продаж свяжутся с вами как можно скорее.`,
"front-kefu-moudle-v1-Put-away-the-chat":`Свернуть детали чата`,
"label.marketseamemset.lead.maxuser":`Максимальное ведущее число участников`,
"label.forecast.forecastroleuserpage.shre.manager":`Только администраторы могут поделиться этим прогнозом`,
"label.file.noselect":`Файл не выбран`,
"label.notification.task3":`【被分配人】 изменить статус задания, назначенного тебе 【新状态】`,
"label.dependfield":`Зависимое поле`,
"lable.SalesCommitmentKanBan.receipts":`Поступления`,
"label_partner_workspace_member_search":`Поиск`,
"label.share.originally.posted":`Первоначальный плакат`,
"label.autonumber":`Автоматическое число`,
"label.view.sortview.name":`Название вида`,
"label.h5.add.activity":`Добавить активность`,
"label.textmessage.vonage.phone.number":`Номер телефона`,
"label.partnerCloud.financeSetting.enterApiKey":`Пожалуйста, введите секретный ключ API`,
"label.industrialandcommercialverification.enablestatus":`Статус активации`,
"label.reportTypeFocusD1":`Укажите, на какие типы записей (строк) будут ориентированы отчеты, создаваемые источником данных этого отчета.`,
"vue_label_report_four-levelseriesobjecttree":`Четырехуровневое дерево объектов серии`,
"label.mobile.default.catalogue":`Каталог по умолчанию`,
"label.partnerCloud.partnerAccount.again":`Пополнить`,
"label.summaryreport.step2.new":`Шаг 2 Выбор метода группировки сводных данных`,
"label.tabpage.cancel":`Отменить`,
"label.multilang.datamovelist.datamove":`Перенести несколько {0} от одного пользователя к другому:`,
"label.conferloginandvisitlimit":`Предоставленный доступ к Входу в систему`,
"vue_label_help_viewhelpcenter":`Посмотреть Справочный центр CloudCC`,
"label.leadscore.norule":`Никаких правил забивания очков, пожалуйста, создайте правило забивания очков или активируйте правило выхода из игры.`,
"label.tabpage.exitz":`Выход`,
"label.DeploymentStatus":`Статус развертывания`,
"label.layout.saving":`Спасательный план...`,
"label.emailobject.emaildetail.field.object":`Объект`,
"label.customfields.searchrelation.fieldtag.tip":`Введите метки для использования в режиме отображения, в режиме просмотра макета страницы, в режиме просмотра отчета и в режиме просмотра списка.`,
"message.huanxin.bindtenant.notfound":`Свободный агент`,
"label.referpersonalias":`Представлено`,
"label.icon.31":`Компьютер`,
"label.appupload.upload.install.thispackage":`Данный пакет`,
"label.appointment.wizard.subtitle1-1":`Пользовательский`,
"pagecreator_page_message_save_fail":`Сохранить страницу не удалось`,
"label.lastset":`Наконец-то, по словам`,
"label.version.support.limited":`Support Limited`,
"vue_label_homepage_kanban":`Kanban`,
"label.layout.editsearchdistribute":`Редактировать макет поиска`,
"template.dashboard.customer.analysis":`Анализ счетов`,
"label.continue_editing":`Продолжить редактирование`,
"label.version.sum.customtab":`пользовательские вкладки`,
"label.validate.function.funcExplain.TIMEVALUE":`Возвращает значение местного времени без даты`,
"label.import.page1.selectobjfromdata":`Выберите объекты для импорта данных`,
"label.partnerCloud.basicSetting.success":`Инициализация прошла успешно`,
"label.customfields.fielddependency.cannotcreat":`Выбранное вами поле прямо или косвенно зависит от самого себя, поэтому вы не можете создать плотность.`,
"label.umeng.activity.youhaveatask":`У тебя новое задание.`,
"label.file.folder.create":`Новая папка`,
"vue_label_campaign_member_status":`статус участника`,
"lable.opppdt.addpdt.table.date":`Дата`,
"label_partner_workspace_login_buttontext":`Текст кнопки`,
"label_other_mistakes":`Другие ошибки`,
"label.must.be.configured":`Должен быть настроен`,
"label.customize.memory.function.sorting.enable":`Активизация памяти о сортировке заголовков`,
"setup.layout.label.areaname":`Наименование секции`,
"label_chatter_pastThirtyday":`За последние 30 дней`,
"setup_mainpage_label_welcome25":`Инструкции: Щелкните по меню в левой части этой страницы → Управление настройками → Контроль безопасности → Общие настройки.`,
"label.ccchat.person.invite.succsend":`Приглашение присоединиться к CCChat отправляется по адресу`,
"label.select.time.range":`Пожалуйста, выберите временной диапазон`,
"label.partnerCloud.orderingPlatform.djustQuantity":`Добавьте товары в корзину, где вы можете отрегулировать количество и просмотреть цену.`,
"label.manageAll.sta1":`Дожидается`,
"label.cy.select":`Выберите новую валюту из доступного списка.`,
"chatter.lam":`Комментарий`,
"label.partner.setup.title":`Настройки`,
"component.setup.label.displaybutton":`Кнопка дисплея`,
"component.salesperformance.label.target":`Цель`,
"label.campagin.channel":`Пожалуйста, введите значение канала`,
"label.validate.function.funcFormat.ISCHANGED":`ИСКЛЮЧЕННЫЙ (местный)`,
"UG.homepage.009":`Access CRM`,
"label.file.item":`Проект`,
"label.file.library.addmembprompt":`Следующие уже являются членами.`,
"label.bmap.releasePosition":`Местоположение`,
"setup_object_layout_label_selectedprofile":`Выбранные профили`,
"label_emailsync_message":`Симптома`,
"label.view_submissions":`Просмотреть представленные материалы`,
"lable.tianyancha.repeated":`Повторный выбор`,
"label.import.index.introduce":`Импорт ваших данных в систему в три простых шага`,
"label.time.operation.new":`Новая запланированная работа`,
"label.projectManagement.Pleaseentersettlementtype":`Пожалуйста, введите тип поселения`,
"label.icon.169":`Экскурсионный автомобиль`,
"vue_label_commonobjects_detail_related_listview":`Список`,
"label.view.step1":`Шаг 1 Введите имя вида`,
"label.summaryreport.intro":`В сводных отчетах показаны как промежуточные данные, так и другая сводная информация.`,
"vue_label_file_input_correct_name":`Пожалуйста, введите правильное название`,
"System_Email_Template_Title":`Добро пожаловать на платформу CloudCC CRM`,
"label.tianyancha.province":`провинциальная аббревиатура`,
"label.deleteall.sure":`Ты уверен, что хочешь все удалить?`,
"label.passwordPolicy.setup.uppercasealpandnum":`Должны смешивать цифры и заглавные и строчные буквы`,
"front-lightning-module-v1-details-page-chart-select":`Выберите объект и отображение`,
"setup_mainpage_label_welcome8":`Настройка перетаскиваемого интерфейса`,
"lable.outlook.edit.lastupc":`Последний обновлённый контакт`,
"label.weixin.registered":`Зарегистрироваться`,
"vue_label_file_history_version":`Пересмотр`,
"vue_label_campaign_earned":`Сумма, подлежащая сбору`,
"label.staticresource.useful.realtion.tip":`Ниже приведен список всех ссылок со страниц CloudCC.com на этот статический ресурс.`,
"vue_label_file_libraray":`Библиотеки`,
"label.department.phone":`Номер мобильного телефона`,
"label.emailtemplate.edit":`Редактировать Шаблон электронной почты`,
"label.processsetting.key.information.tips":`Ключевая информация и советы`,
"label.summaryreport.step7":`Шаг 7 Выберите тип графика и выделенный элемент.`,
"label.chat.topic.remove.favorite":`Удалить из закладок`,
"label.campagin.roi.ksrq":`Дата начала`,
"label.data.downpage.e_title.e_btn":`Перейдите на страницу экспорта и начните экспорт`,
"label.approvaldatamove.dname":`Текущий утверждающий`,
"lable.Partial.attributes":`Частичный атрибут`,
"template.report.enabled.products":`Активированные продукты`,
"lable.outlook.detail.cto":`CloudCC.com to Exchange`,
"label.sendemail.activity.newtasktitle":`Уведомление о новой задаче`,
"label.validate.function.funcFormat.DAY":`ДЕНЬ(дата)`,
"label.log.datetime.value":`Пожалуйста, введите время запроса`,
"label.import.index.updaterecord":`Обновить запись`,
"label.registration.page.invitation":`Приглашение на страницу регистрации`,
"pagecreator_systemstyle_label_detailcolor":`Подробный цвет текста`,
"label.tabname.cannot.empty":`Имя вкладки не может быть нулевым`,
"label.data.newtemplate.savetemp":`Вы можете сохранить данные в виде шаблона и использовать поля и критерии для экспорта данных в качестве шаблонов экспорта данных. Пожалуйста, внимательно введите название и описание шаблона, чтобы облегчить использование.`,
"label.ems.body":`Тело`,
"enc":`Зашифрованный текст (Хранение зашифрованного текста)`,
"label.profile.mobile.setup.commonSaler":`Общие продажи`,
"label.continueselectproduct":`Продолжить выбор продуктов`,
"label.event.new":`Новое событие`,
"label.renametabandtaglib":`Переименовать Tab и Label`,
"label.qrcodelogin.message.exception":`Исключение для сервера, пожалуйста, свяжитесь с вашим администратором.`,
"label.service.gantt.locationToGantt":`Диаграмма Ганта`,
"label.mr.theLastGroup":`Это последняя группа. Нажмите "Назад для просмотра списка дубликатов записей" для просмотра дубликатов записей.`,
"label.report.export.format.content":`Экспорт текущего заголовка отчета, групп и деталей. Максимальное количество деталей может быть экспортировано следующим образом`,
"label.version.accountandcontact":`Аккаунты и Контакты`,
"label.partnerCloud.financeSetting.enterMd5Key":`Пожалуйста, введите секретный ключ MDS.`,
"label.login.access.quater":`Неделя`,
"vue_label_commonobjects_view_searchthisview":`Искать в этом списке`,
"label.import.step1.allobj":`Все объекты`,
"front-efficient-project-management":`Project Cloud обеспечивает управление полным жизненным циклом проекта от начала, планирования, выполнения, контроля до закрытия, оптимизируя процесс управления проектами в соответствии с потребностями вашего бизнеса и помогая вам эффективно управлять проектами.`,
"label.includedvalue":`Включить значения`,
"label.service.newBuildDialog.past.days":`прошедшие дни`,
"vue_label_report_sortup":`Сортировать по возрастанию`,
"label.appointment.wizard.subtitle3-2":`вторник`,
"label.dashboard.trend":`Тенденция`,
"label.schedulejob.setup.schedule.st2":`2-ой`,
"label.view.sortview.number":`Количество записей`,
"lable.Please.enable.order":`Заказ не активирован, пожалуйста, активируйте его.`,
"label.datamanage.immediately.import":`Импорт`,
"label.delete.condition":`Clear`,
"label.dashboard.chooseDispalyOnTheHomePage":`Выберите главную страницу для отображения`,
"asset.accountid.contactid.required":`Каждый актив должен быть связан с учетной записью или контактом.`,
"label.mask.character":`Характер маски`,
"lable.account.Previous.FY":`Предыдущий БЮ`,
"chatter.attachment":`Добавлять файлы`,
"label.view_only":`Только просмотр`,
"label.tianyancha.name":`Название компании`,
"label.service.gantt.avg.traveltime":`Среднее время поездки по служебным назначениям`,
"vue_label_pool_move":`Переместить`,
"label.import.index.beforeexport":`2、Перед импортом, пожалуйста, убедитесь, что импортированы все связанные записи. Например, если вы импортируете записи контактов и хотите заполнить поле счета, которое является полем поиска, вам нужно сначала создать запись счета, которую вы заполняете, затем импортировать запись контакта и заполнить поле счета именем или ID соответствующего клиента.`,
"label.view.delete":`Удалить`,
"template.detail.info.link":`Ссылка на детали`,
"label.sendemail.send.setfail":`Настройка информации по электронной почте не удалась, пожалуйста, заполните правильную информацию по электронной почте.`,
"label_emailtocloudcc_redmessage11":`аутентификация SMTP выполнена. Пожалуйста, проверьте правильность адреса электронной почты и пароля.`,
"label.campaigns.memberalert":`Пожалуйста, выберите члена, по крайней мере`,
"label.schedulejob.setup.schedule.frequency":`Частота`,
"component.newrecords.label.all":`Посмотреть все`,
"label.mr.caption.opportunity":`Поиск дубликатов и слияние: Кодификации для запроса дубликатов Возможностей`,
"chatter.group.onlyMembers":`Только члены могут видеть эту группу. И только владелец группы имеет право добавлять членов группы.`,
"label.recordtype.edit.selectvalue.show":`Значения пиктограмм отображаются в том порядке, в котором они были сохранены.`,
"message.textmaxlength":`Длина не должна превышать 255 символов`,
"label.reportsSubscriptionPage.visibility":`Работает как`,
"label.umeng.chatter.addcoments":`В вашем сообщении в облаке есть 1 новый ответ`,
"chatter.up.f":`Загрузка Ошибка, неизвестная ошибка.`,
"label.icon.146":`Клавиатура`,
"lable.custom.CY.Ago":`2 CY Ago`,
"label.tabpage.step3":`Шаг 3 Выбор полей для отображения`,
"label.checkfield.introduce":`Установите поля объекта, которые можно использовать для проверки дубликатов, и найдите дубликаты в списке записей по заданным вами полям.`,
"label.tag.addtags":`Добавить метки`,
"label.service.newBuildDialog.characterlimit":`Имя превышает ограничение в 25 символов.`,
"font-evaluate-module-v1-evquestions":`Оценочный вопрос`,
"label.knowledge.only.update.draft":`Только обновление проекта`,
"label.partnerCloud.basicSetting.defaultCounts":`Номер роли по умолчанию для добавления партнерской учетной записи`,
"label.chat.topic.delete":`Удалить`,
"label.workflow.contentcondition":`удовлетворённые критерии`,
"vue_label_commonobjects_view_sortby":`Сортировать по полям.`,
"label.passwordPolicy.setup.pwdremember24":`Вспомнить (0) пароль`,
"front-kefu-moudle-free-account":`Судебный счет`,
"label.marketsea.isautorecycle":`Включить автоматическую переработку`,
"label.addattachment.view":`Просмотр файлов`,
"vue_label_helpcenter_contact":`В подробной информации, нажмите кнопку дерево диаграммы рядом с контактом, вы можете просмотреть диаграмму иерархии контактов, понять, лидер-пользователь отношения связанных контактов, а также просмотреть некоторую информацию о полях каждого контакта.`,
"label.taskevent":`Деятельность`,
"label.industrialandcommercialverification.message":`Закончились сегодняшние бесплатные запросы.`,
"label.object.already.delete":`Объект удален`,
"label.project.hit.four":`Уведомление об обновлении подзадачи`,
"label.taskpagelayout":`Макеты страниц задач`,
"label.version.sum.locationfield":`Геолокационные поля`,
"front-sales-button-toQB":`Синхронизация с QuickBooks`,
"label.app.oceanblue":`Синий океан`,
"label.operating":`Операционный...`,
"label.customfields.formula.dateexample":`Дата напоминания = Дата закрытия - 7`,
"label.happen_delete":`Что произойдет, если я удалю форму?`,
"label.service.appointmentList.plansToStart":`Стартовый план`,
"label.persmets.operate.licence":`Разрешение`,
"label.mobile.quickcreate.default.activities":`Календарь`,
"label.australian.eastem.standard.time":`Австралийское восточное летнее время （New South Wales）`,
"label.emailobject.remove":`УДАЛИТЬ`,
"label.weixin.vote":`Голосовать`,
"label.reportsSubscriptionPage.condition.aggregate":`Совокупность`,
"front-kefu-moudle-has-unbind":`Вы были связаны`,
"chatter.group.newGroup":`Новая группа`,
"label.tabpage.systems":`Есть * системы`,
"label.textmessage.vonage.connect":`Подключиться к Вонажу`,
"label.campaign.channel.input.ticket":`Отправить входной билет`,
"label.ccpeak.query.sharetab":`Формы поиска Совместный доступ`,
"label.reporttype":`Источник данных отчёта`,
"message.duplication.label.isprofiletip":`В случае проверки, данные, которые может видеть текущий пользователь, проверяются при поиске дубликатов. В противном случае проверьте все данные.`,
"label.tianyancha.businessverify.xieyi":`Лицензионное соглашение с пользователем CloudCC`,
"font-evaluate-module-v1-select-person":`Пожалуйста, выберите сотрудников службы поддержки клиентов`,
"vue_label_chatter_all_groups":`Все группы`,
"label.recordtype.profile.setdefault":`Сделать по умолчанию`,
"label.mr.descreption.nocondition":`Никаких дубликатов данных, удовлетворяющих условиям.`,
"label.tabpage.askz":`Что бы вы хотели спросить`,
"label.marketsea.selectMember":`Выберите члена`,
"template.report.stage.possibility.analysis":`Анализ возможностей этапа`,
"label.data.selectderivedobject":`Выберите объект для экспорта`,
"label.customfields.formula.explain":`Описание: в настоящее время поддерживает числовые, процентные и другие поля четырех принципов, а также переносит значения поля поиска. Например: число вычисляется: единица*единица измерения и nbsp;&nbsp;&nbsp;&nbsp;&nbsp;поле поиска несет значение:contact__r.address`,
"vue_label_notice_change_fail":`Изменения не удались`,
"label.customobjects.trackoldandnewvalues":`Отслеживать старые и новые ценности`,
"label.h5.leftprompt":`У вас есть отредактированный контент, который не был отправлен, вы уверены, что уйдёте?`,
"label.select.field":`Доступные поля`,
"label.customobjects.layoutedit":`Макет страницы Назначение`,
"label.false":`FALSE`,
"UG_Forcast_07":`Прогноз дозволенного`,
"vue_label_chatter_team_member":`участник группы`,
"label.tabpage.retypez":`При изменении типа записи значения существующего списка опций автоматически не меняются. мы рекомендуем обновить в том же месте значения существующего списка опций записи.`,
"front-epwechat-module-v1-single-desc":`Единый вход на других концах CloudCC через WeCom; быстрое переключение между всеми концами.`,
"label.closeandconverted":`Закрытый конвертированный`,
"label.service.confirmed":`Подтверждено`,
"label.partner.workspace.member.cloudcc":`Профиль CloudCC`,
"label.star.click":`Нажмите, чтобы очистить`,
"label.icon.135":`Валюта`,
"button_partner_workspace_login_logo_upload":`Загрузить изображение`,
"message.error.sql.constraint.recordnotsingle":`Успешно установлена внешняя идентификационная карта. Причина: это поле в исходных данных имеет дубликаты данных.`,
"label.ccchat.person.invite.errorpwd":`Используйте не менее 8 символов и включайте комбинацию цифр и символов.`,
"label_tabpage_isdeleterecord":`Если удалить выбранную запись`,
"label.weixin.prompt.message":`Быстрое сообщение`,
"vue_label_chatter_view_original_post":`Просмотреть оригинал сообщения`,
"label.multilingual.tip3":`Включение многоязычности позволяет каждому пользователю в организации настраивать включенные вами языки.`,
"label.dataimport.error.datetime":`Ошибка: Неправильный формат данных и времени`,
"label_tabpage_addcondition":`Добавить условие`,
"label.query.detail.manageexcludeuser":`Управление внешним пользователем`,
"label.tianyancha.creditcode":`Единый социальный кредитный код`,
"label.cy.enter":`Введите курс конвертации из вашей корпоративной валюты в эту новую валюту.`,
"label.textmessage.vonage.message1":`Интегрировавшись с Vonage, пользователи могут отправлять и получать текстовые сообщения на платформе CloudCC через Vonage. Однако, прежде чем отправлять текстовые сообщения, необходимо зарегистрировать аккаунты Vonage и приобрести телефонные номера.`,
"front-marketing-module-v1-share-invitation":`Поделиться Приглашение для сотрудников`,
"label.file.items":`элемент(ы)`,
"label.otherwise":`В противном случае`,
"label.permission.detail.system":`Система`,
"message.success.task.emailsend":`Успешное сохранение и отправка сообщения электронной почты`,
"label.the.reward.group":`Quote Line Group`,
"setup.layout.label.relatedlistsetup":`Параметры смежного списка`,
"label.empty":`Clear`,
"label.weixin.cloudcc.user.binding":`CloudCC Пользовательский привязка`,
"label.file.what.change":`Что изменилось?`,
"label.search":`Поиск`,
"label.mobile":`Мобильный`,
"template.report.month.potential.customer":`Лидеры этого месяца`,
"lable.setup.mobilesetup.isEnableValidationRulesForScan":`Включить правила проверки при использовании Сканирования`,
"lable.outlook.list.des":`Конфигурация Exchange Sync определяет параметры CloudCC для Exchange для применения к определенной группе пользователей.`,
"label.appupload.install.error.info":`{0}"{1}" было использовано {2}, пожалуйста, переименуйте существующую {0}.`,
"label.tabpage.addoptionsz":`Добавить опции`,
"label.arabian.standard.time":`стандартное время Аравии`,
"label.thefirst":`1-я колонна`,
"label_partner_workspace_login_footertext":`Текст нижнего колонтитула`,
"lable.Disabled.successfully":`Деактивация прошла успешно.`,
"label.confirm.del":`Записей об утверждении, вы уверены, что хотите удалить?`,
"vue_label_normal_reregister":`Войти снова`,
"label_file_img":`Изображение`,
"label.salescloud.salesdashboard.sales.behavior":`Продажная деятельность`,
"label.startdate":`Дата начала`,
"label.field.duplicate.error.msg5":`Пожалуйста, проверьте все ошибки ниже, повторите попытку после модификации.`,
"setup.main2018.label.managesetup":`Администрирование Настройки`,
"label.forecast.editshrepage.title":`Новый Совместный Участник`,
"UG.solution.01":`Обеспечить решение`,
"label.knowledgebase.data.recovery.successfully":`Успешное восстановление данных {a}`,
"label.pc.ui.2018.myccchat":`Моя CCChat`,
"label.attachement":`Примечания`,
"message.mobilechooseatmostten":`Выберите до 10 полей`,
"label.campagin.roi.bhzeywjh":`Общие возможности`,
"label.autoresponserule":`Правила автоотзыва`,
"label.attendance.yuyue":`Вам не назначено, зарегистрируйтесь на сайте now`,
"label.insert":`Вставить`,
"label.service.ganttBaiduMap.shutDown":`Вы хотите закрыться?`,
"label.icon.194":`TV`,
"message.serviceterritory.violation":`Нарушение зоны: зона ресурсов не совпадает с зоной обслуживания назначения.`,
"label.appointment.disable.function":`Отключить функцию`,
"lable.currencyManage.manageexchangeRate.dis":`Чтобы управлять датированными курсами обмена для вашей организации, нажмите Управление датированными курсами обмена. Датированные обменные курсы используются в возможностях, продуктах возможностей и отчетах, связанных с этими двумя объектами.`,
"vue_label_file_upload_tip_newmsg":`Менее {размер} Рекомендуется загружать файл размером менее MB, иначе могут возникнуть проблемы с медленной загрузкой.`,
"label.event.next.week":`следующая неделя`,
"label.datamanage.import.contactfield":`В следующей таблице выберите поля в импортируемом файле, которые должны быть импортированы в каждый контакт. Затем нажмите кнопку Далее:`,
"label.projectManagement.time.allocated":`Назначенное время`,
"label_tabpage_isdeleteview":`Вы уверены, что удалите этот вид?`,
"label.pc.ui.2018.search":`ИЩИ...`,
"label.role.createrolelevel":`Создание ролевой иерархии`,
"label.tabpage.editview":`Вид редактирования`,
"label_partner_common_manageSetup":`Настройки администрирования облака партнера`,
"label.service.gantt.noservice.resource":`На выбранной территории обслуживания не было обнаружено доступных сервисных ресурсов.`,
"message.numbertoolarge":`Слишком большое количество`,
"label.sendsms.success":`Текст успешно отправлен`,
"UG.opportunity.009":`Или`,
"label.ccpeak.construction.dataobj":`чтобы построить объект данных, API имя объекта должно быть передано в формате`,
"front-lighting-module-v1-detail-file-uploadInfo":`Запись заблокирована и недоступна для загрузки файлов. Пожалуйста, свяжитесь с администратором для разблокировки.`,
"label.import.page2.newnotmatchfiled":`Всего в файле {{ csvfiledlength }} полей. {{this.csvfiledlength - this.selectlength}} без отображения.`,
"label.ems.inputmailss":`Получить почтовый сервер`,
"label.knowledgebase.data.published.successfully":`Успешная публикация {а} данных`,
"label_emailtocloudcc_position":`Позиция`,
"label.data.exp.customexp":`Экспорт на заказ`,
"component_chatter_post_button_user":`Добавлять людей`,
"label.new.visualpagefolder":`Пользовательская страница : Новая папка`,
"label.forecast.shrepage.classdes":`Описание уровней доступа`,
"label.task.overdue.unfinished":`Просроченные необработанные задачи`,
"label.ccchat.micropost.isedit.setting.info":`Автор сообщения или комментария, владелец записи, модератор CCChat и модератор этого сообщества имеют право изменять этот текст.`,
"label.recordname":`Имя записи`,
"label.posted_your":`и размещены в вашем`,
"label.globaloperation.operationtype.custom.page":`Пользовательская страница`,
"label_tabpage_busoppnamez":`Название бизнес-возможности`,
"front-epwechat-module-v1-schedule-desc":`Синхронизация расписаний WeCom и мероприятий CloudCC`,
"label.escalation.setup.newentries.lastmodifydate":`На основании времени последней модификации`,
"setup_layout_label_nofield":`Нет доступных полей`,
"label.sendemail.registIMUser.logininfo":`Облачный партнерский портал, на который вы можете войти, представлен ниже:<br>.`,
"label.weixin..xsld.kehu":`Счета`,
"label.display_thank":`Показать страницу благодарности`,
"label.group.no.my.group":`Нет никаких совпадений с моей группой.`,
"label.partnerCloud.newBuildSite.enterDomain":`Пожалуйста, введите имя домена`,
"label.step1.total2":`Шаг 1 из 2`,
"label.ccpeak.delete.record":`Удалить записи:`,
"label.customer.tab.step1.introduce":`Выберите пользовательский объект для этой новой пользовательской вкладки. Заполните другие данные.`,
"label_tabpage_newInterfacez":`Новый интерфейс`,
"setup.mainpage.label.manageuser":`Управление пользователями`,
"label.partnerCloud.partnerAccount.completed":`Оплата завершена?`,
"label.projectManagement.kanban":`Канбан задач`,
"label.operate":`Действие`,
"label.service.dispatchingUnits.selected.time.range":`Отображение назначений на обслуживание в выбранном диапазоне времени.`,
"component_setup_label_pagesize":`Номера, отображаемые на каждой странице`,
"font-evaluate-module-v1-email-evaluation-settings":`Настройка оценки электронной почты`,
"label.service.dispatchingUnits.skills":`Навыки`,
"label.editrecurrencetimetrigger":`Редактирование периодических триггеров времени`,
"vue_label_file_edit_lib":`Редактировать библиотеку файлов`,
"label.campaignmember.selectmember.deleteconc":`Кампания: удалить участников из контактов`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.monday":`Понедельник`,
"front-detail-module-v1-by":`по`,
"label.mobile.home.page.date.signed":`Дата закрытия`,
"label.apply.send.success":`Пошли успех.`,
"label.app.choseimg":`Выберите логотип`,
"label.customsetting.visible":`Видимость`,
"label.sendemail.activity.task.distributetaskcompleted":`Задача, которую вы назначили на #belongtoidccname, выполнена.`,
"label.dashboard.snapshot.refreshing":`Освежающий`,
"label.document.name.already.exists":`Это уникальное имя документа уже существует.`,
"label.ccchat.person.invite.needlastname":`Введите свою фамилию`,
"pagecreator_page_button_copy":`Скопировать`,
"label.appointmentpage.wizard.subtitle1-2":`Предыдущая неделя`,
"label.validate.function.funcFormat.MILLISECOND":`МИЛЛИЗЕКОНД(дата)`,
"label.profile.allowtocreateview":`Создать вид`,
"message.error.recordid":`Идентификатор записи не может быть пустым`,
"lable.SalesCommitmentKanBan.returnToTheSuperiorRole":`Возвращаемся к главенствующей роли`,
"label.translation.start3":`При необходимости выберите объект. Например, в задании процесса есть объект (Учетная запись, Контакт и т.д.) для фильтрации по переводимым терминам.`,
"label.ccpeak.send.email":`Отправьте электронное письмо, чтобы уведомить:`,
"vue_label_commonobjects_detail_activity_noexpirationdate":`Нет срока годности`,
"label.permission.objectpermission.objpermission":`Настройки разрешений объектов`,
"label.version.custom.report":`Стандартные отчеты (Custom Page)`,
"label.title.qrcodeOrbarcode":`Генерировать штрих-код/QR-код`,
"label.emailtocloudcc.step2.name":`Настройка права собственности на электронную почту`,
"label.reportsSubscription.edited.successfully":`Редактирование подписки на отчет успешно!`,
"label_tabpage_kanbansetup":`Настройка Viewboard`,
"label.tianyancha.regcapital":`Зарегистрированный капитал`,
"front-epwechat-module-v1-web-single":`Единая регистрация в Интернете:`,
"label.visualpage.display.top":`заголовок дисплея, заголовок не отображаемый в ложном срабатывании`,
"label.customfields.fielddependency.selectcell":`Выберите хотя бы одну ячейку из списка ниже`,
"label.paging.addmember.totalofpages":`Всего {0} пункт(ы)`,
"label.email.saveing":`Данные сохраняются...`,
"label.userinfo.doublepwd.notnull":`Вы должны повторить свой пароль.`,
"label.appointment.wizard.subtitle4-4-2":`2 недели`,
"label.chatter.BCC":`Bcc (слепая копия любезности)`,
"label.emailtocloudcc.description":`Подключите учетную запись электронной почты предприятия, например, sales@company.com, info@company.com, support@company.com. Автоматически регистрировать полученные письма в CloudCC в качестве зацепок и записей по делам, чтобы обеспечить своевременное отслеживание писем клиентов.`,
"label.sendemail.send.atlastone":`Вы должны выбрать хотя бы одного получателя.`,
"label.mobile.phone.subordinate":`Включить подчинённых`,
"label.data.choses.e_desc":`В соответствии с вашими потребностями, вы можете экспортировать все данные или экспортировать данные из объекта.`,
"chatter.new":`Новости`,
"vue_label_help_back":`Назад`,
"label.skipwizardintro":`Мастер прыжкового запуска создаст для Вас одноступенчатый процесс одобрения всего за несколько минут.`,
"label.weixin.fmu.before.week":`{0} неделя(ы) вперёд`,
"label.sendemail.chat.praiseFeedsubject":`CloudCC CCChat понравился твой пост.`,
"lable.currencyAdv.andafterdate":`и за`,
"label.sometoprocess":`Если в этот процесс утверждения должны включаться только определенные виды записей, введите этот критерий ниже. Например, этот процесс утверждения должны использовать только отчеты о расходах, поступающие от сотрудников штаб-квартиры.`,
"label.campaignmember.main.updateleaddesc":`Обновление статуса всех проводок сразу`,
"label_partner_common_roleSetup":`Облачная роль партнера и настройки пользователя`,
"label.console.step5.no":`Выберите способ отображения записей`,
"label.salescloud.teamrole.optionlist.account":`Добавить члена команды по работе с клиентами в`,
"Report.Delete.Confirm.Title":`Пожалуйста, подтвердите`,
"label.onclick":`Нажмите на`,
"label.weixin.input.identifying.code":`Пожалуйста, введите проверочный код`,
"label.knowledge.translate":`Перевести можно только статью знаний основного издания в статусе "Черновик" или "Опубликовано".`,
"label.log.ip":`IP-АДРЕС`,
"front-electronic-export-goResult":`Регистрация в Mailchimp`,
"label.escalation.setup.newaction.otheremail.otheremail":`Дополнительные электронные письма`,
"label.icon.104":`Расписание`,
"label.partnerCloud.exceedTwo":`Загружаемая фотография профиля не может превышать 2 МБ!`,
"label_tabpage_thevalurofz":`Стоимость`,
"front-lightning-module-v1-details-page-chart-maximum":`Можно ввести до 50 символов.`,
"label.data.downpage.i.title.num6":`Рекомендуется импортировать тестовый файл, содержащий 5 записей, перед импортом данных, чтобы убедиться, что данные, которые вы хотите импортировать, корректны.`,
"label.ccpeak.update.record":`Изменить записи`,
"label.dataimportandexport":`Импорт и экспорт данных`,
"label.tabpage.notexceed25":`Выбранная запись не должна превышать 25`,
"label.starting":`В процессе выполнения`,
"label.knowledge.language.spanish":`Испанский`,
"label_emailtocloudcc_set":`Установить информацию о почтовом ящике`,
"message.oneormoreneedsreport":`Пожалуйста, удалите для отчета блок контрольной панели приборов, а затем попробуйте еще раз.`,
"label.attendance.xccheckin":`Регистрация`,
"label.emailmerge.editfolder.title":`Папки шаблонов для объединения почты`,
"template.report.year.customer":`Лидеры этого года`,
"label.partner.common.webSit.memo":`Доменное имя по умолчанию для партнерского "облака" вашей организации:`,
"label.partnerCloud.financeSetting.onlinePayment":`Онлайн оплата`,
"Pagelayout.Setup.001":`Пожалуйста, выберите соответствующие списки, которые будут отображаться на наведении курсора.`,
"front-kefu-moudle-time-length":`Продолжительность`,
"label.deleteObject":`Объект удаляется.`,
"label.setup.mobile.homepageshortcuts.select":`Выберите 4 быстрых фукции для отображения в верхней области __ главной страницы.`,
"setup.mainpage.label.welcome26":`Управление данными - пакетная обработка`,
"label.ServiceCloud.yuyuebainhao":`Назначение на обслуживание №.`,
"label.emailobject.emaildetail.button.addtolead":`Добавить в Свинца`,
"label.event.single.view":`Вид одного пользователя`,
"lable.product.pricebooks.ustand":`Выберите стандартную цену`,
"label.emailtocloudcc.department":`Департамент`,
"component_assistant_label_30daysnoact":`30 дней без какой-либо кампании`,
"label.weixin.no.pending.qzkh.qin":`Простите, никаких зацепок.`,
"label.vlidaterule.formula":`Формула состояния ошибки`,
"label.tianyancha.h5.contact":`Контактные данные`,
"label.button":`Кнопки`,
"message.checkemail":`<strong>Error:</strong> есть ошибка в введенном сообщении электронной почты, пожалуйста, проверьте.`,
"lable.account.previous.CY":`Предыдущий CY`,
"label.icon.13":`Сервис`,
"chatter.coll.c":`Удалить закладку`,
"label.knowledge.category.hint.four":`Распределение категорий данных`,
"label.tianyancha.phonenumber":`Номер телефона`,
"label.tablayoutedit.remark":`Выберите поля и пользовательские страницы, отображаемые на главной странице вкладки.`,
"label.shareusers":`Поделиться с пользователями`,
"label.endtime":`Конец`,
"label.length":`Длина`,
"label.umeng.activity.event.begin":`начинаться после`,
"label.tabpage.alltabs":`Все вкладки`,
"label.exact.query":`Расширенный поиск`,
"label.weixin.skip":`Перейти к`,
"label.ems.cancel":`Отменить`,
"label.trigger":`Триггеры`,
"label.exchange.sync.setting":`Настройка синхронизации Exchange`,
"label.product.pricebooks.name":`Название ценника`,
"label.relation.list.total":`Избранный`,
"label.step2.total7":`Шаг 2 из 7`,
"label.martrixreport.2018.step6.new":`Шаг 6 Выберите тип графика и выделенный элемент.`,
"label.standard.buttonandlink.override":`Ширина захвата`,
"front-console-conversation-btn4":`Выделение в качестве нового дела`,
"vue_label_dashboard_range":`диапазон`,
"label.app.sort.show":`Приложение отображается в сохраненном порядке.`,
"label.salescloud.teamrole.choose.correct":`Дублировать пользователей выбранных, пожалуйста, исправьте`,
"label.schedule_post":`Опубликовать сообщение`,
"front-kefu-moudle-server-request-num":`Список запросов на обслуживание №.`,
"label.h5.logout":`Выход из системы`,
"label.weixin.horse.club.member.message":`Информация для членов Aid-Max`,
"label.field.addoptionlist.introduce":`Введите одно или несколько значений пикилиста ниже, при этом каждое значение будет отделено новой строкой.`,
"setup_layout_label_setupfield":`Свойства месторождения`,
"label.chatter.nextStep":`Следующий шаг`,
"label.quickbooks.searchlist.total1":`Есть {0} несвязанные счета на общую сумму {1}`,
"label.tianyancha.h5.regcapital":`Зарегистрированный капитал`,
"label.icon.184":`Консультационный сайт .`,
"label.dashboard.message.refreshtoomush":`Приборная панель слишком часто обновляется, пожалуйста, освежитесь позже.`,
"label.umeng.approval.reject":`#approver отклонил ваш запрос на одобрение #obj.`,
"label.h5.chatter.newmessage":`Введите новое сообщение`,
"message.error.relationid":`родственник не может быть пуст!`,
"label.setup.mobile.offlinecache.selectdefault":`Выберите вкладки по умолчанию в автономном кэше`,
"label.setup.mobile.homepageshortcuts.saveprompt":`Пожалуйста, выберите 4 быстрые функции.`,
"label.projectManagement.Selectmonth":`Выберите месяц`,
"label.version.ultimate":`Окончательное издание`,
"label.validate.remark5":`Поля обязательной даты расположены в правильном порядке, например: время начала должно быть меньше времени окончания.`,
"label.version.nowis":`Ваша текущая версия CloudCC`,
"front-kefu-moudle-CRM-set":`Настройка CRM`,
"label.mr.title.customerAddress":`Адрес счёта`,
"label_emailtocloudcc_step1_name":`Выберите функцию`,
"label.time.operation.edit":`Изменить запланированные задания`,
"label_tabpage_operationz":`Поле, операция не может быть пустой`,
"label.translation.start4":`Дважды щелкните в столбце перевода, чтобы ввести новые значения.`,
"vue_label_systemSettings_request":`Запрос на пакетную передачу`,
"label.maintenance.notice":`Уведомление о техническом обслуживании`,
"label.customfields.txet.textlength.tip":`Пожалуйста, введите максимальную длину текстового поля ниже И максимальная длина составляет 255 символов.`,
"label.ccdocument.select.template.open":`Пожалуйста, выберите шаблон для открытия.`,
"vue_label_display_date_field":`Показать поля даты`,
"label_partner_workspace_tab":`Tab`,
"lable.account.LasthDays":`Последние 120 дней`,
"chatter.using.sticker":`Включить отслеживание подачи корма`,
"message.save.dataerror":`Ошибка: сохраните ошибку, вызванную большой длиной данных или другими проблемами. Пожалуйста, измените данные для повторного сохранения.`,
"vue_label_commonobjects_view_chart_newchart":`Новый график`,
"label.chat.micropost.a.group":`Группа`,
"lable.currencyManage.advcurrencyunEnabled":`Расширенное управление валютой не включено`,
"label.appexchange.workflow":`Правила документооборота`,
"vue_label_calendar_show_details_and_add_events":`Показывать детали и добавлять события`,
"label.salescloud.optionlist.inputname":`Пожалуйста, введите название значения фильтра`,
"label.dashboard.folder":`Папки`,
"label.knowledgebase.permanently.remove.articles":`Удаление архивной статьи приведет к тому, что другие релевантные версии также будут удалены навсегда.`,
"label.emailtocloudcc.titel":`Электронная почта в CloudCC`,
"label.visualpage.sel":`Пользовательские страницы в этой папке`,
"label.planned.all.work":`Все запланированные вакансии`,
"label.weixin.agree.agreement":`Согласиться с соответствующим соглашением`,
"label.forecast.customforecast.qsn":`стартовый год`,
"label.appupload.managed":`Контролируемый`,
"template.report.folder.sale.index":`Анализ показателей продаж`,
"UG_opportunity_011":`импортная сделка`,
"label.validate.function.funcFormat.SECOND":`ВТОРОЙ (дата)`,
"UG_homepage_005":`Информация о продажах`,
"label.clicktoreturn":`Нажмите здесь, чтобы вернуться`,
"label.collectionofview":`s Наборы представлений`,
"com.cloudcc.login.error.message.nonuser":`Твоего имени не существует.`,
"vue_label_systemSettings_emailsetting":`Настройка электронной почты`,
"vue_label_email_mark_as":`Марк Ас`,
"label.tabpage.customernamez":`Имя клиента`,
"label.appupload.install.apicannotsame":`Новое имя api не может быть тем же самым, что и первоначальное значение.`,
"label.task.all.undealt":`Все просроченные необработанные задачи`,
"front-lightning-module-v1-dashborad-statistical-indicators":`Статистический индекс`,
"UG.quota.02":`Стадия "Возможность изменения`,
"label.approve":`Утвердить`,
"vue_label_calendar_remove_calendar":`Удалить календарь`,
"label.mr.title.contactName":`Имя контакта`,
"label.projectManagement.resource":`Управление ресурсами`,
"label.rejectbehaviour1":`Позвольте одобрить ручной выбор обратного номера шага.  (вернуться к предыдущему шагу N)`,
"label.publicgroup.relationship":`Членство в группах`,
"Lead.Scoring.DetailedPage.Popup.Title":`Свинцовое понимание`,
"label.owner.edit":`Собственническое редактирование`,
"label.campaign.channel.ticket.mark":`ПРИМЕЧАНИЕ: Сохраните QRкод в фотоальбоме с помощью скриншота мобильного телефона или сохраните его на мобильный телефон и войдите в кампанию с QRкодом.`,
"label.opportunity.setting.showstage.info":`Показывать ли сцену возможности в приложении CloudCC.`,
"label.emailobject.wizard.desc3":`Экономьте время, используя шаблоны электронной почты`,
"label.cpq.quote.no.product.add":`В предложении не добавлены продукты. Пожалуйста, добавьте товар перед формированием заказа.`,
"label.customer.tab":`Пользовательские вкладки`,
"Opportunity_Detailed_Phase_Label_Popup_002":`Дата закрытия текущего этапа`,
"component_telerecord_label_name":`Имена`,
"label_component_helper_nodata":`Ничего не требует твоего внимания сейчас. Пожалуйста, проверь позже.`,
"label.dashboardSetup.d2":`Точка останова 2`,
"setup.mainpage.label.welcome4":`Инструкции: Щелкните по меню в левой части страницы → Настройки приложения → Создать → Объект.`,
"label.step4.total5":`Шаг 4 из 5`,
"label.payment.the.remaining.days":`Срок действия вашей лицензии истекает через {0} дней.`,
"label.encoding":`Кодирование`,
"label.setting.intergrationlist.status2":`В настоящее время эта интеграция установлена.`,
"label.new":`Новый сайт`,
"label.search.searchsetup":`Настройки поиска`,
"label_tabpage_printz":`Печать`,
"report.type.label.customService":`Поддержка клиентов`,
"label.notification.addEmailObject.message":`Вы получили электронное письмо с {!fromaddress}, нажмите, чтобы увидеть более подробную информацию.`,
"label.icon.68":`Машина`,
"UG.Lead.003":`Социальный сайт`,
"label_mobile_default_field_service_home":`Домашняя страница Service Cloud`,
"label.select.one.group":`Пожалуйста, выберите хотя бы одну группу котировочных линий.`,
"front-kefu-moudle-trkey-nopower":`Пара ключей Tianrun не имеет назначенных разрешений`,
"label.chatter.cancel":`Отменить`,
"label.weixin.report.optiondisplay":`Показать`,
"front-kefu-moudle-v1-System-version":`Версия системы:`,
"lable.product.pricebooks.editall":`Редактировать все`,
"label.group.no.recent3":`или`,
"label.knowledge.article.delete":`Ошибка при удалении статьи знаний.`,
"label.relateobj":`Связанный с`,
"workflow.action.tasks.assignortype.type":`Введите .`,
"label.layout.selectedfields":`Избранные поля`,
"label.role.assign.operate":`Назначьте других пользователей на эту роль:<ul><li>Нажмите на выпадающий список, чтобы просмотреть всех доступных пользователей.</li><li>Выбрать пользователя в левом списке "Доступные пользователи" и добавить его в список "Избранные пользователи".</li></ul>.`,
"label.field.insert":`Вставить поле`,
"label.icon.11":`Люди`,
"label.group.no.recent4":`создать группу.`,
"front-epwechat-module-v1-input-corpid":`Пожалуйста, введите Corpld`,
"setup_object_field_dependency_label_actionfieldnotnull":`Пожалуйста, сначала выберите контрольное поле.`,
"setup.mainpage.label.welcome19":`Инструкции:  Щелкните по меню в левой части этой страницы → Управление настройками → Управление пользователями → Пользователи, роли, профили.`,
"label.escalation.setup.list.rulename":`Имя правила`,
"label.ems.addaccount":`Добавить аккаунт сейчас`,
"label.reportsSubscription.details.only":`Только подробная информация (формат Excel .xlsx)`,
"vue_label_commonobjects_view_groupby":`Группировка по`,
"label.email.form.text":`Только для текста`,
"label.weixin.loginname":`Имя пользователя`,
"label.forecast.settings.sr":`Доход`,
"label.chatter.sendEmailToGroupMember.subject.F":`{0} опубликованных постов для всех в {1}`,
"label.ccchat.enter.subject":`Пожалуйста, укажите тему для голосования`,
"label.customer.tab.introduce":`Вкладки пользовательских объектов выглядят и ведут себя как стандартные вкладки, предоставляемые в CloudCC.`,
"message.login.mfaverification.wrong":`Ошибка кода безопасности.`,
"component.newrecords.label.name":`Имя`,
"label.salescloud.opportunity.addandedit.contactrole":`Добавление и редактирование контактных ролей`,
"label_emailtocloudcc_button_next":`Следующий`,
"label.console.step5":`Шаг 5 Выбор способа отображения записей`,
"setup.main2018.label.norole":`У вас нет административных разрешений`,
"template.chart.ywjhqd":`Стадия бизнесвозможностей`,
"label.instrumentPanel.breakpointOneLabelname":`Это значение должно быть больше, чем минимальное значение.`,
"label.qrcode":`QR-код`,
"label_tabpage_no2z":`No2`,
"label.log.search.date.range":`Цикл запроса не может быть больше {c} месяцев.`,
"label.console.step7":`Шаг 7 Назначить профиль`,
"label.australian.central.standard.time":`Австралийское центральное стандартное время （Northern Territory）`,
"label_tabpage_deleteviewfailed":`Просмотр удалить не удалось`,
"vue_label_commonobjects_view_searchview":`Поиск в этом представлении`,
"message.error.object.notexists":`Объекта не существует.`,
"label.tablecell":`Ячейки`,
"vue_label_notice_edit_success":`Редактирование прошло успешно`,
"label.customer.language":`Язык по умолчанию`,
"label.csrf":`Активировать защиту безопасности csrf`,
"label.forecast.customforecast.submit.zhi":`на`,
"label.sso.saml.idp.config.desc2":`Нажмите Включить поставщика идентификационных данных, чтобы включить вашу организацию CloudCC.com в качестве поставщика идентификационных данных.`,
"label.export_data":`Экспортные данные`,
"component.todaytask.label.all":`Посмотреть все`,
"label.h5.chatter.record":`Следовая запись`,
"front-vew-email-verification":`Просмотрите электронную почту и подтвердите учетную запись. Вы сможете войти в систему только после подтверждения электронной почты.`,
"laber.marketsea.del.error":`Ведущий пул занят и не может быть удален`,
"vue_label_notice_homepage_entername":`Пожалуйста, введите изменённое имя`,
"UG.Forcast.01":`Прогноз`,
"front-email-payment-tips":`Сумма счета не заполнена. Пожалуйста, инициируйте онлайноплату после заполнения суммы счета.`,
"setup.mainpage.label.welcome2":`Пользовательская база данных (объект)`,
"APPIntegration.Social.facebookerror":`Вы должны ввести действительный URL-адрес для facebook.com.`,
"label.profile.mobile.setup.stand":`Стандартная Главная страница`,
"label.custom.CY":`Нестандартный год`,
"label.knowledgebase.publishing.conditions":`Пулиш {a} данные не удалось, они отключены критерии публикации!`,
"label.tianyancha.description":`Включите TianYanCha для проверки промышленных и коммерческих данных. Этот сервис поддерживает деловые данные, зарегистрированные в материковом Китае.`,
"label.appexchange.uninstallpage.title":`Удалить пакет will:`,
"label.currencyRate":`Скорость конверсии`,
"setup_layout_label_areashow":`Вкл. заголовок раздела дисплея`,
"label.setup.case.setting":`Мини-программа для кейса`,
"vue_label_commonobjects_view_fixed_at_most":`Максимум три колонки могут быть зафиксированы.`,
"template.report.month.income":`Доходы текущего месяца`,
"label.sms.companyname":`Наименование организации`,
"label.sendemail.registIMUser.waitmessage":`К сожалению, у вас нет партнерского облачного портала, на который вы можете войти. пожалуйста, подождите, наш администратор сообщит вам об этом позже. вы можете посетить указанный адрес, чтобы войти на страницу входа. используйте имя пользователя и пароль, указанные выше, чтобы войти в систему.`,
"label.custom.field.task.object":`Назначенное вам задание. Задача смиренная:`,
"message.pleaseselectdayinweek":`Пожалуйста, выберите день недели.`,
"label.chat.topic.favorites":`Закладка`,
"UG.Campaign.004":`импортная кампания`,
"label.approval.preview":`Просмотр процесса`,
"label.knowledgebase.assign.articles.to.people.or.queues":`Выберите язык перевода и назначьте статью соответствующему лицу или очереди. Экспорт переводов обычно назначается в очередь, а внутренние переведенные статьи  соответствующему лицу.`,
"pagecreator_systemstyle_message_save_success":`Стиль сохранен успешно`,
"label.outline":`Описание`,
"label.read.only.field":`Поля только для чтения`,
"front-gantt-module-v1-early-warning":`Раннее предупреждение`,
"label.file.ccchat.selectfrompc":`Выберите файл с компьютера`,
"vue_label_systemSettings_social":`Социальные медиа`,
"label_report_year_last_year":`Год за годом`,
"lable.PowerProcess.Meet.the.conditions":`Должны быть соблюдены следующие критерии:`,
"label.changemydisplay.list.title":`Показать`,
"UG_Forcast_03":`Начать планирование и реализацию бизнес-стратегий. <br> Желаю Вам счастливого прогноза!`,
"label.sendemail.chat.sendmessage":`Дорогой #name:\n\n hello! #userName отправил тебе сообщение.`,
"label.huanxinconfig.secretid.lost":`секретный идентификатор не может быть пустым`,
"label.icon.49":`Выработка электроэнергии`,
"chatter.feed.button.publish":`Поделиться`,
"label.power":`^Мощность`,
"label.partnerCloud.financeSetting.informationThree":`3. После входа на страницу управления секретными ключами нажмите mapi Gateway Product Key и получите ID партнера и секретный ключ MDS.`,
"label.emailtocloudcc.step1.lead2":`После настройки почта, полученная в этом почтовом ящике, будет автоматически регистрироваться в CloudCC как ведущая запись. Убедитесь, что ни одна сделка не будет пропущена.`,
"label.knowledgebase.delete.draft.succeeded":`Успешное удаление черновика`,
"label.dashboardSetup.title":`Редактор компонентов`,
"label.trigger.operation.email.template.map":`Возврат к информации шаблона, Тема письма: m.get("subject"); Содержание письма: m.get("context"); Является ли тип письма текстовым: m.get("istext")`,
"label.dependencesearchfilter":`Сопутствующие поисковые фильтры`,
"label.selected.search.length":`Не более 10 выбранных полей поиска`,
"label.profile.commonusercontrol":`Общие разрешения пользователя`,
"lable.Microsoft.YaHei":`Microsoft YaHei`,
"label.appupload.component.type.app":`Приложение`,
"label.customsetting.manage.position":`Местоположение`,
"vue_label_systemSettings_bindweb":`Связующая паутина`,
"label.loginservice.license.notexist":`Лицензии не существует.`,
"label.icon.43":`Колокола`,
"UG_homepage_003":`360-градусный вид`,
"label.file_format":`Формат файла`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.sunday":`воскресенье`,
"vue_label_chatter_post_has_delete":`Сообщение удалено`,
"report_label_searchresult":`Результаты поиска`,
"label.tabpage.justsz":`Просто`,
"Lead_Scoring_Setting_LevelSetting":`Свинцовые настройки популярности`,
"setup.object.field.dependency.label.selectedfieldvalue":`Доступные значения полей`,
"label.search.morelistview":`Дополнительный просмотр списка`,
"vue_label_homepage_won":`Закрытый`,
"label.notification.last30days":`Последние 30 дней`,
"vue_label_helpcenter_pool":`Используйте ведущий пул и пул учетных записей для управления данными о продажах.<br>Настройте пул учетных записей<br>Создайте пул учетных записей в фоновом режиме, настройте администраторов и участников пула учетных записей, а также настройте правила просроченной автоматической переработки, что удобно для управления ситуацией с отслеживанием возможностей в вашей команде и поощрения членов команды к активному отслеживанию.<br>Ручное управление данными<br> Администратор пула учетных записей может выполнять такие операции, как распространение, переработка, удаление и передача записей в пуле учетных записей, а также управлять записями в пуле учетных записей единым способом;<br> Участники пула учетных записей могут получать нераспределенные записи или просматривать записи, за которые они несут ответственность.`,
"label.emailsync.status.export":`Экспорт в формате Excel_csv`,
"label.service.miniProgram.slideshowTitle":`Карусель`,
"label.service.miniProgram.slideshowName":`Название карусели`,
"label.fieldupdate.selectobj":`Определите объект, связанный с обновлением поля, затем нажмите Далее. Обновление полей может быть связано только с правилами рабочего процесса и процессами утверждения того же типа.`,
"label.ccpeak.take.notice.sharetab":`Примечание: поля в выражении общей формы не требуют добавления "__c".`,
"label.log.startdate.after.endate":`Время начала должно быть не позднее времени окончания.`,
"label.rememberme":`Помни меня`,
"label.partner.all.maxNum":`Самые большие данные по партерным облакам:`,
"component.setup.iframe.label.inputurl":`Введите URL-адрес`,
"label.h5.systemmessage":`Системное сообщение`,
"label.delete.date":`Удалить дату`,
"front-email-payment-select-month-tips":`Пожалуйста, выберите ММ`,
"front-kefu-moudle-bind-userinfo":`Связать информацию о пользователе`,
"label.appointment.wizard.notif2":`您需要在创建日程预约前先设定好一个预约的时长`,
"label.custom.field.maping.number":`Количество ведущих цифр не может быть больше, чем количество отображенных цифр поля.`,
"label.event.dayview":`Дневной вид`,
"label.replace":`Заменить`,
"label.knowledgebase.search.knowledge.articles":`Поиск статьи Знания`,
"component_event_label_soon":`Немедленно`,
"label.imgfield.upload":`Загрузить изображение`,
"message.printable.view":`Просмотр для печати`,
"vue_label_notice_uploadavatar_notice1":`Размер загружаемого изображения аватара не может превышать 2 Мб.`,
"label.visualpage.developer.help":`Индивидуальная помощь разработчика страницы`,
"label.validate.function.funcFormat.IF":`IF(logical_test, value_if_true, value_if_false)`,
"label.sso.saml.sp.description1":`Настройки одиночной регистрации`,
"vue_label_calendar_step_1":`Шаг 1: Назовите календарь`,
"component.telerecord.button.save":`Сохранить`,
"setup_mainpage_button_manageobject":`Управление объектами`,
"label.marketingactivityinfluence":`Влияние кампании`,
"label.quote.bjjsxx":`Информация о принятии цитат`,
"label.appupload.upload.install.retry":`Переустановить`,
"label.layout.assignrules":`Правила назначения`,
"UG.Lead.006":`Посетитель сайта`,
"label.workmate.searchs":`Поиск коллег`,
"label.visualpage_list.no":`Нет разрешений на доступ к пользовательским страницам`,
"label.service.miniProgram.slideshowintroduce":`Название карусели используется только для идентификации нескольких объявлений и не отображается в объявлении.`,
"label.multilang.messagedetail.search.desc":`Мы не можем найти сообщение с {0}:`,
"label.mobile.phone.read.note":`Пожалуйста, введите примечания здесь`,
"label.passwordPolicy.setup.isUsingGotp":`Включить вторичную проверку входа`,
"message.datetypeerror":`<strong>Error: </strong> Недействительная дата.`,
"label.searchlayout.listview.button":`Кнопки, отображаемые в окне просмотра списка.`,
"label.sectionpart":`Раздел`,
"label.partnerCloud.basicSetting.userSetting":`Настройка ролей и пользователей`,
"System_Data_Import_Warning_MaxCount":`Ваша организация может импортировать только {0} фрагменты данных за один раз, что сейчас выходит за рамки, пожалуйста, настройте и повторите импорт.`,
"label.datamove.qualified.record":`квалифицированный(ые) рекорд(ы), каждый раз может передать 100 рекордов в максимум`,
"component_task_label_priority":`Приоритет`,
"vue_label_report_me":`Me`,
"label.college.duplicate.option":`Опции не могут быть повторены!`,
"label.pw.letter":`Письма`,
"label.file.sharedwithme":`Разделили со мной`,
"label.translation":`Перевести`,
"lable.currencyAdv.exchagecurrency.before":`и до`,
"label.file.share":`Поделиться`,
"label.page.next":`Следующий`,
"label.autoRegister.changepwd.setpwd.notmatch":`Два пароля несовместимы`,
"label.tabpage.include":``,
"front-email-payment-thanks":`Спасибо`,
"vue_label_help_helponthispage":`Помощь на этой странице`,
"label.approvepagelayout":`Макет страницы утверждения`,
"vue_lightning_help_zero_distance_communication":`Онлайн поддержка поможет вам сэкономить время, обратившись к специалистам службы CloudCC с нулевым расстоянием.`,
"vue_label_normal_case_sf":`Дело`,
"label.report.line.tuozhuai":`Пожалуйста, перетащите мышью или дважды щелкните мышью, чтобы выбрать столбец отчета и настроить их порядок.`,
"template.dashboard.management":`Управление операциями`,
"label.customcomponent.params.info.n1":`Значение "args" в теге "компонент" в формате "json", например: args="name:'zhang',age:26", В блоке кода cc , use: Строка myName = name; int myAge = age;`,
"lable.SalesCommitmentKanBan.signedCommitmentRate":`Ставка подписанного обязательства`,
"label.add.status":`Добавить статус`,
"label.loss.customers":`Закрыто / Потеря счета`,
"vue_label_chatter_involving_me":`Вовлеченные`,
"label.update.input":`Пожалуйста, исправьте ввод`,
"label.import.step1.commonobj":`Общие объекты`,
"label.appupload.upload.tips.document":`Примечание: документы в "моих личных папках" и "красных папках шаблонов" не могут быть добавлены в пакет, а также не могут быть отображены в этом списке.`,
"label.appupload.install.complete":`Полный`,
"label.console.edit":`Редактирование консоли`,
"setup.object.field.dependency.label.removefromlist":`Удалить выбранные значения`,
"label.textmessage.groupsms.no.phone":`Телефона нет`,
"label.account.Current.and.NextFQ":`Текущий и следующий КВ`,
"label.sso.saml.sp.idtype.userid":`Анкета содержит идентификатор пользователя из объекта User`,
"label.data.import.setup.operate.update":`Обновлять существующие записи, не вставлять новые записи`,
"front-kefu-moudle-v1-jcaws-call-serve":`Callцентр интегрирован с AWS (Amazon Web Service) для предоставления более комплексных SaaSуслуг`,
"label.version.bacheditordel":`Массовое редактирование/удаление/передача`,
"lable.even.higher":`Выше`,
"label.datetime.error":`Формат даты неправильный`,
"vue_label_commonobjects_detail_customer_hierarchy":`Иерархия счетов`,
"label.startuploadfile":`Начальная загрузка`,
"label.appointment.wizard.subtitle3-1":`Понедельник`,
"label.weixin.relevance":`Связанная с этим возможность`,
"label.datamanage.field.mapping.information":`Настройка Картирование полей`,
"label.brief.lastweek":`прошлая неделя`,
"label.nextstep":`Следующий шаг`,
"label.listtoshow":`Ниже отображается список активных и неактивных процессов утверждения для {0}.`,
"label.partner.ishave":`Ошибка: домен уже существует`,
"label.service.miniProgram.name":`Пожалуйста, заполните имя.`,
"label.view.filterbyaddition":`Фильтр по дополнительным полям (необязательно):`,
"label.projectManagement.nodata.task":`Нет записей о задачах. Давайте добавим информацию о задачах!`,
"label.chooseemailtemplate":`Выберите Шаблон электронной почты`,
"label.page.step4.add.profile":`Шаг 4 Добавить в профили`,
"label.ems.mailtype":`Тип почты`,
"label.weixin.no.pending.projects.vg":`Хорошая работа, не ожидающих одобрения пунктов`,
"label.tabpage.saveviewfailed":`Просмотр сохранить не удалось`,
"label.chat.file.upload.cancel":`Отменить загрузку`,
"com.cloudcc.login.error.message.notenabled":`Ваш идентификатор не включен.`,
"label.data.import.setup.operate.insertandupdate":`Обновить существующие записи и вставить новые записи`,
"label_target_type":`Тип цели`,
"label.notification.event2":`【被分配人】 просмотрел назначенное вами событие`,
"chatter.feed.menutype.feed.news":`За чем я следую`,
"label.import.page1.suitedwayofcustomer":`Стиль подгонки под клиента`,
"label.import.page2.CloudCCfiled":`поле CloudCC`,
"label.custom.quarter.start":`Пользовательская дата начала квартала`,
"label.page.including.tab":`В том числе таблички`,
"label.mobile.phone.day.plan2":`Сегодня`,
"template.report.lead.conversion.statistics":`Статистика конверсии лидов`,
"label.show.type":`Тип дисплея`,
"label.weixin.no.pending.wdgz.qin.week":`На этой неделе не запланирована работа.`,
"2018UI.Homepage.DataDeleted.Info":`Данные, которые вы хотите просмотреть, были удалены, пожалуйста, нажмите, чтобы вернуться к предыдущему шагу.`,
"label.vlidaterule.message":`сообщение об ошибке`,
"label.approval.remark":`Заключение об одобрении`,
"label.field.duplicate1":`Уникальный сайт`,
"label.batchtransfer":`Массовое перемещение`,
"label.quickbooks.view.allinvoices":`Все счета`,
"vue_label_commonobjects_detail_lead_selectedstatus":`Отметить как текущее состояние`,
"label_home_page_source":`Пожалуйста, выберите источник данных.`,
"front-kefu-moudle-v1-opencall-please":`Пожалуйста, включите центр обработки вызовов, а затем настройте`,
"setup_layout_label_asc":`Восходящий`,
"label.use_tikect":`Использовать входной билет?`,
"label.tag.setup":`Настройки тегов`,
"label.existinglayout":`Существующий макет страницы`,
"label.productsales.today.noevt":`Нет никаких открытых мероприятий.`,
"message.error.view.date.validerr":`Пожалуйста, введите действительный формат даты (ГГГГГ-ММ-ДД, ММ/ДДД/ГГГГ) или специальные символы даты`,
"label.mr.descreption.oneGroupReData3":`приходится иметь дело с`,
"label.tianyancha.businessverify.msg1":`С коммерческой функцией проверки данных включена, пользователи должны внимательно прочитать и полностью понять условия настоящего "пользовательского лицензионного соглашения" (далее "соглашение"), в том числе освобождение от ответственности пекинского shenzhou yundong клиент ООО. (далее "Облако") и ограничения прав пользователей. пожалуйста, внимательно прочитайте его и решите принять или не принимать настоящее соглашение.`,
"label.custom.CQ":`Таможенный квартал`,
"label.version.custom.dashboard":`Стандартные приборные панели (Custom Page)`,
"vue_label_commonobjects_detail_dragtoupload":`Перетащите ваш файл сюда или <em>выберите файл для загрузки</em>.`,
"label.tabpage.addadvancedoptions":`Добавить дополнительные опции`,
"front-kefu-moudle-v1-Launch-page":`Посадочная страница:`,
"label.emailobject.tabname":`Email`,
"label.weixin.addmore":`Добавить еще`,
"message.error.view.operator.validerr":`Недействительный оператор`,
"label.another_page":`Перенаправление на другую страницу`,
"label.reportTypeFocusD2":`Пример: При составлении отчета "Контакты с возможностями с партнерами" выберите "Контакты" в качестве первичного объекта.`,
"label.icon.47":`Барометр`,
"label.task.today":`Сегодня`,
"label.service.gantt.weekend.highlight":`Выделите выходные`,
"label.customcomponent.referencetagname":`Имя вкладки`,
"label.senderemail":`Адрес электронной почты отправителя`,
"label.defaultvalue":`Значение по умолчанию`,
"label_tabpage_Sdfez":`дней`,
"pagecreator.page.label.pagename":`Название страницы`,
"vue_label_report_pagenumber":`Номер страницы в диапазоне`,
"label.emailsync.connectaccount.description":`Добавьте сюда свой личный почтовый ящик, и CloudCC будет автоматически сопоставлять ссылки и контакты в системе в соответствии с их электронными адресами, синхронизировать содержимое электронной почты с записями для облегчения отслеживания и связи.`,
"label.schedulableprg.chooseweek":`Пожалуйста, выберите дату каждой недели`,
"lable.edit.queue.membercanuse":`Доступные члены`,
"lable.Quick.find":`Быстрый взгляд`,
"label.daynuminmonth":`День(ы) месяца(ов)`,
"message.error.state":`государство не может быть пустым!`,
"label.introduction.the.form":`Описание`,
"label.batchtransfer.pleaseselectcomefromuser":`Перевод от`,
"front-dashboard-module-implemented":`Реализованный`,
"label.custombutton.newerror":`Новое созданное не удалось`,
"label.version.allow.size":`сверх лимита. При необходимости, пожалуйста, обновите версию CloudCC.`,
"label.weixin.account.loginpage":`Учетная запись Безопасный логин Страница`,
"message.pleaseselectfieldtype":`Пожалуйста, выберите тип поля`,
"component.setup.label.parentobject":`Высший объект`,
"System.TAB.SeeViewAmount":`Смотреть итоговые показатели`,
"label.event.lastmonth":`последний месяц`,
"label.taskrecordtype":`Типы записи заданий`,
"label.layout.selectedpages":`Избранные страницы`,
"label.appointmentdetail.wizard.title19":`план на субботу`,
"label_chatter_endData":`Дата окончания`,
"label.appupload":`Пакеты`,
"label.knowledgebase.article.link":`Связанная статья`,
"label.licence.enddate":`Дата истечения`,
"chatter.fieldtrack.record":`запись`,
"label.reportsSubscriptionPage.schedulereport.weekly":`Еженедельный сайт`,
"label.forecast.editshrepage.title2":`Совместное редактирование`,
"label.attendance.onwork.time":`Начало дня`,
"label.appointment.wizard.subtitle1-8":`3 h`,
"pagecreator.layout.button.upload":`Макет загрузки`,
"label.input.notless.than.number":`Пожалуйста, введите число больше или равно {0}.`,
"setup.mainpage.label.welcome13":`Инструкции: Нажмите на верхнее меню → Отчеты → Новый`,
"label.forecast.settings.data.opp":`Возможность Дата закрытия`,
"vue_label_display_checkbox_field":`Показать поля флажка`,
"label.summaryreport.2018.step5":`Шаг 5 Выбор типа графика и выделенного элемента`,
"front-lightning-module-v1-dashborad-one-statistic":`Выберите, пожалуйста, хотя бы одно статистическое значение и тип статистики`,
"label.home.standard.dashboard.forcase":`Вы не имеете права прогнозировать и не можете просматривать панель инструментов обязательств по продажам.`,
"page.field.track":`История отслеживания полей`,
"label.dataimport.format.datetime.error":`Ошибка формата, пожалуйста, используйте yyyy/MM/dd HH:mm:ss или yyyy-MM-dd HH:mm:ss.`,
"lable.opppdt.selPbk.title":`Выберите ценник`,
"pagecreator_systemstyle_label_stylename":`Имя стиля`,
"label.projectManagement.nodata.project":`Нет связанных данных. Почему бы не создать проекты, связанные со мной?`,
"label.start_below":`Начните делиться своей формой с контактами. Ваша форма была надежно опубликована и готова к использованию по указанному ниже вебадресу.`,
"label.campaignmember.main.delete":`Участники кампании по массовому удалению`,
"label.modifyall":`Изменить все`,
"label.homepage":`Главная страница`,
"vue_label_pool_adoptedbyme":`Я собрал`,
"label.email.clearItem":`Очищаются только те письма, в которых нет связанных элементов.`,
"label.callcenter.login.Amazon.connect":`Войдите в Amazon Connect`,
"label.import.page1.selectimportfiled":`Выберите файл для импорта`,
"message.error.id":`ID не может быть пустым!`,
"label.ggReleaseRange.searchUsers":`Поиск партнера пользователя`,
"label.changemypwd":`Изменить пароль`,
"label.ccpeak.reference.parameters":`Параметры, которые могут быть непосредственно ссылками:`,
"chatter.share.success.tip":`Успех! Вы поделились этим постом с`,
"label.message.checkfailed":`Проверка синтаксиса не прошла, имя класса существует.`,
"label.shangqing.introduction":`Интегрируйте и анализируйте последние горячие новости или клиентов, чтобы помочь продавцу понять клиентов более полно`,
"label.allemailnotice":`Все уведомления по электронной почте`,
"vue_label_report_copy":`Копировать отчет`,
"label.exchange.sync.state.setting":`Настройки конфигурации`,
"label.merge.result.error1":`Следующая запись заблокирована, и операция "слияния" не допускается.`,
"label.process.des":`Нажмите на левую ссылку для просмотра подробной информации о текущей записи.`,
"label.textmessage.vonage.create.lead.setting":`Создавать новые зацепки при получении текста с номеров, отсутствующих в системе.`,
"label.views":`Просмотры`,
"label.notification.tip1":`Нет Уведомления`,
"label.forecast.detailforecast.returnforecast":`Назад к прогнозам`,
"label.knowledgebase.target.framework.name":`Имя целевой рамки`,
"label.brief.close.opportunities":`Закрытый выигрыш`,
"label.appointment.wizard.subtitle4-2":`Самое короткое время, чтобы заметить вас`,
"vue_label_systemSettings_set_record":`Установите режим диспача связанного списка, пытаясь переключиться между режимом карточки и режимом списка.`,
"pagecreator_page_message_publish_fail":`Не удалось опубликовать страницу`,
"vue_label_homepage_name":`Главная Имя страницы`,
"label.weixin.no.pending.wdgz.qin.month":`У тебя нет расписания на этой неделе.`,
"label.campagin.register.page":`Кампания Регистрация участников Страница`,
"label.campaign.channel.edit":`Campaigns: Маркетинговый канал Редакция`,
"label.folder":`Папка`,
"label.umeng.chatter.follow":`Я следил за тобой.`,
"label.sso.theKeyToEdit":`Ключевое редактирование`,
"label.deletelayout":`Удалить макеты страниц`,
"label.same.analyze.miaoshu":`Связь между вышеуказанными условиями is: "Имя возможности" или "Имя учетной записи" или ("Контактный мобильный" и "Контактная электронная почта");`,
"label.ccpeak.sel":`Классы в этой папке`,
"label.tabpage.addtoworkbench":`Добавить на домашнюю страницу верстак`,
"label.forecast.shrepage.classdes.r":`Только для чтения - Пользователь может считывать данные прогнозов.`,
"homepage.custompagename":`Имя пользовательской домашней страницы`,
"label.sendemail.batchapprovalinfo":``,
"front-email-payment-Invoice-alipay-describe":`Безопасная и надежная оплата`,
"setup.object.field.dependency.label.configured":`Макеты страниц, назначенные профилю`,
"label.potentialcustomers":`Свидетельства`,
"label.timetrigger.button":`Кнопка "Добавить время срабатывания" недоступна в следующих случаях:`,
"label.category.10":`Адвокат`,
"label.selectall":`Выбрать все`,
"message.field.id.not.null":`Идентификатор поля не может быть пустым.`,
"CloudCCCRM.ST.Info.TypeIn.001":`Пожалуйста, введите`,
"label.author":`Автор`,
"label.import.step1.csvonly":`1. Поддерживается только файл формата csv, и за один раз можно импортировать до {рекордный лимит} записей. При необходимости выполнения триггера можно импортировать до 2 000 записей. Записи, превышающие установленный лимит, будут автоматически проигнорированы системой. Если вы хотите импортировать больше данных, пожалуйста, сначала разделите их на несколько файлов и импортируйте их в разное время. .`,
"label.assignment.setup.newrule.name":`Имя правила`,
"label.campaignmember.selectmember.chosestatusdesc":`Пожалуйста, выберите кампанию, в которую вы хотите добавить участников, и отредактируйте Статус участника кампании. Создайте новую кампанию, вы должны выйти из этого процесса.`,
"label_tabpage_operation":`Операция`,
"label_tabpage_datatyoez":`Тип данных`,
"UG_product_04":`Создать продукт`,
"label_emailtocloudcc_step1_case2":`После настройки почта, полученная в этом почтовом ящике, будет автоматически регистрироваться в CloudCC как случайные записи. В соответствии с исходящим ящиком совпадают контакт и учетная запись, относите дело к соответствующему контакту и учетной записи, чтобы облегчить принятие и отслеживание дел.`,
"workflow.action.tasks.assignortype.role":`Роль`,
"vue_label_notice_refreshi_success":`Успешно освежиться`,
"label.notification.arketsea.abandon":`{5}выброшенный {2} {0}：{1}`,
"label.icon.36":`Компьютер`,
"chatter.group.cancelToJoin":`Отменить, чтобы присоединиться`,
"label.publicgroups.edit":`Редактировать общественную группу`,
"message.duplication.label.letternum":`Совпадающие биты персонажей`,
"label.brief.lost.opportunities":`Потерянный`,
"setup.layout.label.nofield":`Нет доступных полей`,
"label.dataimport.isSharingRule":`Использовать правила совместного пользования`,
"vue_label_opportunity_contactrole_synctocontacts":`Синхронизация информации с контактами`,
"attachment_button_massdownload":`Массовая загрузка`,
"label.weixin.agreement.remark":`Данная услуга WeChat является вспомогательным инструментом консалтинговой услуги для клиентов Aid-Max, она не является окончательной основой для страховых компаний для урегулирования претензий, и претензии клиентов должны быть урегулированы в соответствии с законодательными требованиями страховых компаний.`,
"label.partnerCloud.basicSetting.introTwo":`Редактирование части уникального URL. CloudCC.com предоставляет первую часть URL, а последующая часть содержит только цифру или букву. Рекомендуется использовать название вашей компании или его вариант, например, "mycpmpanypotal".`,
"pagecreator_layout_funcpath":`/ строитель / библиотека макетов`,
"label.ccdocument.online.edit":`Документ Онлайн-редактирование`,
"label.partner.setup.Enable":`Проверить`,
"label.log.state":`Статус действия`,
"label.lower.bound":`Нижняя граница`,
"label.timezone.isenable":`Включите несколько часовых поясов, затем позвольте пользователю установить часовой пояс и отобразить дату/время по часовому поясу пользователя.`,
"label.martrixreport.setrowtitle":`Укажите заголовки столбцов`,
"label.bottom":`Нижний`,
"label.multilang.ccchat.groupnotcontainsname":`Вы не являетесь членом ни одной компании, которая имеет {0} в своем имени`,
"label.step1.of.step5":`Шаг 1 из 5`,
"message.report.error.FieldListIsAmbiguous":`В отчете есть ссылка на поданную формулу, которая вызывает исключение, пожалуйста, удалите поданное:&nbsp;`,
"label.monitorsys.operator.ip":`IP-АДРЕС`,
"ccchat.fieldtrack.fieldchange":`Изменение с {0} на {1}`,
"label.report.export.print.content":`Экспорт текущих заголовков отчетов, групп и первых 2000 записей`,
"message.thanksusing":`Спасибо за использование CloudCC.com`,
"label.reportexport.allobject":`Экспорт всех объектов`,
"label.projectManagement.working.hours.per.day":`Ежедневное рабочее время`,
"label.partnerCloud.financeSetting.enterCollaborator":`Пожалуйста, введите идентификатор кооператора`,
"label.defineReportRecords":`Определить набор записей отчетов`,
"greate":`нечто большее, чем`,
"label.sure_discard":`Вы уверены, что откажетесь от изменений?`,
"label.escalation.setup.newaction.notifyowner":`Уведомить владельца дела`,
"label.icon.28":`Доктор Шляпа`,
"lable.PowerProcess.see.page":`Посмотреть вехи`,
"message.error.object.relogin":`Вход не удался, пожалуйста, попробуйте войти еще раз.`,
"label.chatter.activity":`Деятельность`,
"label.query.clone.detail.choose.canChoose":`Доступные позиции`,
"chatter.using.object":`Включите отслеживание объектов, чтобы пользователи могли следить за записями этого типа объектов. Выберите поля для отслеживания, чтобы пользователи могли видеть обновления ленты, когда эти поля изменяются в записях, за которыми они следят.`,
"UG.opportunity.001":`Как вы отслеживаете свои продажи?`,
"label.ServiceCloud.fuwuziyuan.distributionMap":`Карта распределения сервисных ресурсов`,
"vue_label_email_current_email":`Вставка этого шаблона перезапишет текущее письмо.`,
"label.h5.approval.page.layout":`Вы можете установить макет страницы утверждения: <br>Настройка>Создать>Рабочий процесс и утверждение>Процессы утверждения<br>выберите процесс утверждения, щелкните имя утверждения<br>щелкните Редактировать>Установить макет страницы утверждения`,
"component.hots.label.title":`Горячие предложения`,
"mail.foldername.notOnly":`Этот файл уже существует`,
"label.customer.tab.step1":`Шаг 1 Введите данные`,
"label.delete.persion":`Удалено`,
"chatter.changed0":`Изменить {0} с {1} на {2}`,
"homepage.components.type":`Тип компонента`,
"label.norfolk.isiands.time":`Норфолк Тайм`,
"label.product.pricebooks.view":`Просмотр ценников`,
"label.forecast.customforecast.director":`Прямые Подчиненные`,
"label.emailtocloudcc.step3total3":`Шаг 3 из 3`,
"label.cloudccsite.end":`Неактивная страница сайта Главная страница`,
"label.login.verification.mfa.device":`Проверка виртуального устройства MFA`,
"chatter.follow":`Следите за`,
"label.month's":`месяц`,
"label.sendmail.step1.introduce":`Выберите вид ниже, который содержит адресатов, которые будут включены в это сообщение.`,
"label.shangqing.title":`Настройка бизнес-информации`,
"label.rejectrecords":`Отклонённые записи`,
"label.selectupdatevalue":`Изменение стоимости от`,
"vue_label_pricebook_disabled":`Прейскурант отключен`,
"component.chatter.label.title":`Последняя запись`,
"label.partner.all.workspace":`Рабочее пространство`,
"label.querydetailservice.delete.message":`Данные удалены или не существуют.`,
"label.objectRelationshipWithout":`с соответствующей документацией или без неё`,
"nocontain":`не содержит`,
"label.partnerCloud.financeSetting.accountSettings":`Настройка партнерского фонда`,
"label.file.sharetype.owner":`Владелец`,
"label.open.multilingual":`Включить мультиязычность`,
"label.searchresult.field":`Поля результатов поиска`,
"label.tabpage.selectdate":`Выберите дату`,
"label.h5.logouting":`Выход из системы`,
"label.quickbooks.fieldlabel.payment":`Оплата`,
"label.chatter.leaveword":`Комментарий`,
"label.customfields.majoranddetailrelation.tip":`Создайте специальную связь родитель-ребенок между этим объектом (дочерним или details）and другим объектом (родительским или ведущим), где: <br> ● поля отношений для всех записей деталей должны быть заполнены. <br>● После сохранения значения реляционного поля оно не может быть изменено. </li><br> ● принадлежность и общий доступ к записи деталей определяется основной записью. </li><br>● когда пользователь удаляет основную запись, все детали удаляются. </li><br><br> ● вы можете создавать сводные кумулятивные поля основной записи для суммирования подробных записей. </li><br>Поле связи позволяет пользователю нажать на иконку "Найти" для выбора значения из выпадающего списка. Основным объектом является источник значения в списке. "`,
"label.batchapproveorrefuse":`Массовое одобрение/отклонение`,
"label.copy.success":`Успешное копирование`,
"vue_label_show_record_count":`Показать счетчик записей`,
"label.ems.delete.false":`Не удалось удалить`,
"label.new.Product.Goals":`Цель нового продукта`,
"label_chatter_BCC":`Bcc (слепая копия любезности)`,
"label.knowledgebase.data.archived.successfully":`{a} архив данных успешно`,
"label.chuangming.title":`СМС Чуан Мин`,
"label.notification.arketsea.recovery":`Твой {0}:{1}был переработан до {2}на {5}`,
"label.partnerCloud.orderingPlatform.paymentAmount":`Сумма платежа:`,
"label.martrixreport.2018.step5.new":`Шаг 5 Выбор критериев отчета`,
"label.testing":`Проверяю...`,
"chatter.poll.option4":`Выбор 4`,
"lable.outlook.detail.otc":`Обмен на CloudCC.com`,
"label.startuploadfile.batch.step2":`Шаг 2 Нажмите кнопку "начать загрузку", загрузить файлы`,
"lable.outlook.edit.outdes":`Введите пользовательские поля, которые вы уже создали в Exchange. Прежде чем сопоставить это пользовательское поле Exchange с полем CloudCC.com, CloudCC.com проверит существование поля Exchange при первой синхронизации.`,
"hour":`Час`,
"label.appointmentpage.wizard.notif4":`Недействительный формат электронной почты`,
"label.import.index.state":`Статус`,
"label.integrations.mailchimp.massage6":`Выбранные данные, показанные на текущей странице, смогут быть экспортированы в ваш список Mailchimp.`,
"label.file.share.email.subject":`#sharedBy поделился с вами файлом на #orgname.`,
"label.assignment.setup.newentries.noassignment":`Не переуступать владельца`,
"label.dashboard.unit1":`Отряд: 10,000`,
"label.forecast.customforecast.foretype.commit":`Обязательство`,
"label.type":`Введите .`,
"label.partner.workspace.login.logo":`Логотип заголовка`,
"pagecreator_systemstyle_button_edit":`Стиль редактирования`,
"label.displaytype2":`Кнопка Подробнее`,
"email.one":`Уважаемый пользователь: <br/>Добро пожаловать в CloudCC. Вы запросили сброс пароля в {!operatetime}, пожалуйста, войдите с кодом проверки ниже в течение 15 минут.<br/>Случайный код проверки: <b>{!authcode}</b><br/> Нажмите на ссылку ниже, чтобы сбросить пароль: <b>{!URL}/authcodecheck.jsp?username={!username}&lang={!lang}</b><br/><br/> <b>Важно: </b><br/>Если вы не запрашивали этого, или вы считаете, что это сообщение не должно доходить до вас, пожалуйста, немедленно свяжитесь с вашим администратором!`,
"label.partnerCloud.orderingPlatform.unavailable":`Нет доступных продуктов`,
"vue_label_email_save_the_signature_successfully":`Сохранить подпись успешно`,
"label.reportsSubscriptionPage.email.detailed":`Подробный сайт`,
"chatter.group.query":`Запрос`,
"label.translation.unsupported.format":`Не поддерживается формат, поддержка импорта только на нескольких языках Формат собственности`,
"message.operateexception":`Быстро (Пожалуйста, свяжитесь с Вашим администратором).`,
"label.sendemail.chat.praiseFeedcomment":`Дорогой #name:\n\n hello! #userName понравился ваш комментарий (#href).`,
"label.recycle.clearmy":`Опорожните корзину`,
"label_tabpage_choose":`Выберите`,
"#label.importstep2tip":`Если вы хотите загрузить более одного файла, вы можете сжать все файлы вместе и импортировать их.`,
"label.batchedit":`Mas Edit`,
"label.integrations.mailchimp.export":`Экспорт в Mailchimp`,
"label.cloudccsite.name":`Имя сайта`,
"serviceterritory.serviceappointment.iscontain.contain":`Вы не можете удалить территорию обслуживания, поскольку она связана с записью на обслуживание. Вы можете отключить эту территорию обслуживания.`,
"label.sum":`Сумма`,
"setup.mainpage.label.welcome29":`Стандартная интеграция API со сторонними продуктами`,
"label.tabpage.nothingz":`Ничего`,
"label.weixin.actual.contract.jine":`Фактическая сумма контракта`,
"label.tabpage.emailaddressz":`От адреса`,
"label.dashboard.unit4":`Отряд: 10 миллионов`,
"label.dashboard.data.labels":`Метки данных`,
"label.import.page2.oneonone":`Одно поле CloudCC может соответствовать полям только одного файла.`,
"homepage.components.name":`Наименование компонентов`,
"template.report.task.theme":`Задача Предмет`,
"component.setup.label.setupsaveok":`Настройки компонентов успешно сохранены`,
"front-epwechat-module-v1-add-selfapp":`Добавить приложение, созданное Sefl`,
"label.to.save.the.current.page.information.button.":`Если вы хотите сохранить информацию текущей страницы, пожалуйста, нажмите кнопку "Быстрое сохранение".`,
"vue_label_file_not_support_preview":`Файл не поддерживает предварительный просмотр, пожалуйста, скачайте и просмотрите`,
"label.object.reached.limit":`Количество создаваемых объектов достигает верхнего предела.`,
"label.partnerCloud.basicSetting.online":`Активировать онлайноплату`,
"label.app.step1.error.nameexist":`Это имя группы уже существует или использовалось ранее. Пожалуйста, выберите другое имя.`,
"label.workflowandapprove":`Рабочий процесс и согласования`,
"label.recordtypeselect.change.tip":`При изменении типа записи существующие значения пикилиста автоматически не меняются. Рекомендуется обновлять существующие значения пропикированных списков записей в одном и том же месте.`,
"label.summaryreport.step6":`Шаг 6 Выберите критерии отчета`,
"Pagelayout.Setup.004":`Можно установить до 4 полей`,
"label.file.attached":`Прилагается`,
"front-invoice-online-payment-setup-configure":`Нажмите "Configure Now", Configure {name} Payment Interface.`,
"label.approvaldatamove.submitdate":`Дата отправления`,
"label.emailobject.time.from":`От:`,
"label.dataimport.insertdata.error.fieldrepeat.insert":`Поле $schemefield_name$ в записи уже существует в БД и больше не вставляется. Импорт записи игнорируется.`,
"assetbom.copy.notpermission":`У вас нет полномочий для клонирования BOM актива. Пожалуйста, свяжитесь с администратором.`,
"lable.outlook.mcto.autoallocation":`Автоматически назначайте их соответствующим записям CloudCC.com.`,
"label.dataimport.but.datalength":`но длина данных`,
"label.setuserstocommit":`Используя приведенные ниже опции, укажите, каким пользователям разрешается подавать первоначальный запрос на утверждение.`,
"component_telerecord_label_related":`Связанные предметы`,
"front-lighting-module-v1-detail-file-lockInfo":`Запись заблокирована и недоступна для добавления файлов. Пожалуйста, свяжитесь с администратором для разблокировки.`,
"pagecreator_layout_button_edit":`Редактировать макет`,
"label.app.step3.tabcanuse":`Доступные вкладки`,
"label.ems.delete.sure":`Вы уверены, что удалите эту информацию об учетной записи электронной почты?`,
"label.email.show":`Показать`,
"label.checkbox.unchecked":`Невыбранный`,
"message.error.operation":`Сбой в работе, пожалуйста, свяжитесь с администратором.`,
"label.template.set.folder.only.upload.type.file":`Папки, отмеченные красным цветом в шаблоне, могут быть использованы только для загрузки файлов типа Word, Excel и PPT.`,
"label.knowledgebase.select.publish.status":`Пожалуйста, выберите статус публикации`,
"label.recordtype.tabname.edit":`Введите новое имя для выбранного типа записи и нажмите "Сохранить".`,
"label.tabpage.exportview":`Вид на экспорт`,
"label.dataimport.insert.sharetab":`Не удалось вставить форму обмена`,
"vue_label_dashboard_penetrateto":`Проникать в`,
"label.weixin.group.member":`Персонал`,
"vue_label_systemSettings_customadd":`Пользовательское расширение`,
"UG_Account_03":`Проактивно проверять и объединять дублированные счета`,
"label.singapore.standard.time":`стандартное время Сингапура`,
"label.weixin.captcha":`Код проверки`,
"Account_News_Setting_004":`Включить новости`,
"label_emailtocloudcc_select1":`Пожалуйста, выберите`,
"label_ring_ratio":`Месяц за месяцем`,
"label.industrialandcommercialverification.button.save":`Сохранить`,
"label.approvalstep5.tip":`Страница утверждения - это страница, на которой утверждающее лицо фактически одобряет или отклоняет запрос. Используйте следующие опции для выбора свойств редактирования полей для отображения на этой странице.`,
"label.import.page1.maxrecord{{30000}}":`1. Вы можете импортировать записи {{30000}} один раз.`,
"setup_object_layout_label_profileoptions":`Доступные профили`,
"label.emailtemplate.type":`Тип шаблона`,
"label.searchlayout.tab.field":`Поля, отображаемые на главной странице вкладки.`,
"chatter.news":`Сообщения`,
"label.pw.small.letter":`Нижний регистр`,
"label.notification.group3":`Ваше заявление о вступлении в общественную группу было отклонено`,
"label.ccchat.day.before.yesterday":`Позавчера`,
"component.chatter.post.label.title":`Опубликовать`,
"label.tianyancha.type":`Тип юридического представителя`,
"label.detail.searchlayout":`Просмотр макета поиска`,
"vue_label_pool_deleteconfirm":`Вы уверены, что хотите удалить выбранную (1) запись (записи)?`,
"label.import.index.maxmb{{100}}，maxitem{{30000}}":`1. Поддерживаются только файлы формата csv, максимальная поддержка {{100}}mb, и максимум {{30000}} записей можно импортировать один раз; пожалуйста, разделите их на несколько файлов и импортируйте их поэтапно, если ограничение превышено,`,
"label.h5.similar.opportunity.lookup":`Найти аналогичные возможности`,
"template.report.customer.list.opportunity":`Список аккаунтов с большими возможностями`,
"component_setup_iframe_label_memo":`Щелкните по значку настройки и введите адрес встроенного url-адреса.`,
"label.version.allemail":`Массовая электронная почта`,
"lable.product.editp":`Редактирование цен`,
"label.weixin.plate.number":`Номер пластины`,
"font-evaluate-module-v1-disabled-successfully":`Успешно отключен вариант оценки "Нейтральный"`,
"label.multilingual.tip1":`Используйте эту страницу для определения языка вашей организации.`,
"label.japan.standard.time":`японское стандартное время`,
"lable.product.notdel.use":`Удалять попытки, так как это все еще связано со следующими записями. В этом случае рекомендуется отключить.`,
"label.appointment.wizard.subtitle4-2-4":`4 h`,
"label.queue.edit":`Редактирование`,
"label.partnerCloud.financeSetting.informationTwo":`2. В Merchant Center нажмите Управление аккаунтом  Управление торговцем  PIDIKEY продукта  Управление секретными ключами.`,
"label.partnerCloud.partnerOrdering.permission":`Разрешение на заказ партнера`,
"vue_label_commonobjects_detail_company_hierarchy":`Иерархия компании`,
"label.forecast.settings.sl":`Количество`,
"label.partner.workspace.tab.memo":`Выберите вкладки для этого облака партнеров. Можно выбрать стандартные или пользовательские вкладки.`,
"label.mr.mainRecord":`мастер-запись`,
"setup_mainpage_label_welcome20":`Шаблон электронной почты, SMS`,
"front-email-payment-select-date-tips":`Пожалуйста, выберите YY`,
"label.dependencelisttag":`Ярлык соответствующего списка`,
"label.umeng.activity.eventof":`случай`,
"label.sales.dashboard.collection":`Поступления Цель`,
"report_label_folder":`Папки`,
"label.assignment.setup.newentries.step1":`Шаг 1 Установите порядок, в котором эта запись правила будет обрабатываться`,
"label.quote.shrname":`Имя получателя`,
"label.newreport.group.sum":`Количество группировок`,
"label.number.MinCheck":`Минимальное значение {a} равно {0}. Пожалуйста, измените количество и сохраните изменения.`,
"label.chatter.save":`Сохранить`,
"vue_label_email_all_email_templates":`Все шаблоны электронной почты`,
"message.summaryconditionnototal":`Условия Сводных условий не могут использовать Roll-Up fields!`,
"label.callboard":`Объявления`,
"label.step2.total5":`Шаг 2 из 5`,
"vue_label_homepage_custom_homepage_page":`Пользовательская Главная страница`,
"label.data.newtemplate.e_seltype":`Выберите метод экспорта данных`,
"label.data.dataexpalltype.all.desc2":`2、Нужно некоторое время, чтобы экспортировать все данные. Когда экспорт будет завершен, вы получите по электронной почте напоминание, что экспорт данных был успешным.`,
"lable.account.CalenderYear":`Календарный год`,
"message.error.data":`Переданные данные не могут быть пустыми, пожалуйста, проверьте переданные параметры.`,
"label.from_user":`От пользователя`,
"label.parentdepartment":`Высший отдел`,
"template.dashboard.product.analysis":`Анализ продукции`,
"label.tabpage.unpacketz":`Нет данных по группировке!`,
"label.icon.107":`Сообщение`,
"label.monitorsys.operator.username":`Пользователи`,
"label.serchreport":`Отчеты о поиске`,
"label.payment.upgrade":`Обновление`,
"setup_layout_button_ok":`Подтвердить`,
"label.please.select.channel":`Пожалуйста, выберите куратора канала.`,
"template.chart.txdrw":`Напоминание о задаче`,
"chatter.group.accept":`Принять`,
"pagecreator_systemstyle_message_canntdelete":`Текущий стиль не разрешается удалять`,
"label_tabpage_ctbtsftcz":`Щелкните на обратной стороне для поиска содержимого`,
"label.datamanage.select.accountfield":`(Выберите поля, соответствующие импортируемой учетной записи).`,
"label.schedulejob.setup.list.title":`Запланированные вакансии`,
"label.visualpage_list.title":`Активный пользовательский доступ к странице`,
"label.mr.selectTwoData":`Пожалуйста, выберите, по крайней мере, две записи для объединения.`,
"label.customer.tab.step2.different":`Применить различные видимости вкладки для каждого профиля`,
"label.mobile.side.tab.can":`Имеется на вебсайте .`,
"label.log.url":`URI`,
"label.weixin.cloudccnumber.isgoon":`Учетная запись CloudCC была привязана, если продолжить, WeChat, которая ранее была привязана к этой учетной записи CloudCC, не сможет использовать микро CloudCC систему. Хотите продолжить?`,
"label.applet.to.case":`Портал обслуживания клиентов минипрограммы`,
"lable.outlook.detail.cmaping":`Карта Контактные поля`,
"label.theUserActiveTime":`Активный период пользователя`,
"label.event.moveup.9hour":`9 часов вперёд`,
"vue_label_pool_other":`другой сайт`,
"label.fieldname":`Имя поля`,
"vue_label_notice_add_success":`Добавлено успешно`,
"label.conditiontag.lookup.insertbutton":`Вставить выбранный`,
"label.identifying":`Идентификация`,
"label.tabpage.uploadingz":`Загрузка`,
"label.view.introduce":`Редактирование Вид`,
"vue_label_dashboard_sortingmethod":`Пожалуйста, выберите способ сортировки`,
"label.quote.number.introduce":`Введите количество и скидки и нажмите Сохранить.`,
"front-kefu-moudle-which-missphone-case":`Создание дел, по которым были пропущены звонки`,
"label.sendemail.chat.response":`Ответ на CCChat:`,
"label.productsales.refreshTime":`Последнее обновление`,
"lable.SalesCommitmentKanBan.phase":`Этап`,
"label.version.sum.object":`объект(ы)`,
"label.defineReportStep2":`Шаг 2`,
"message.duplication.label.returnDuplications":`Список фильтров резервного копирования`,
"label.lookover":`Посмотреть`,
"label.quickbooks.button.copy2":`Скопируйте Detials CloudCC в QuickBooks`,
"label.checkbox.true":`Да`,
"label.profilename":`Название профиля`,
"label.finalapproveoperate":`Действия по окончательному утверждению`,
"label.SMS.detailed":`SMS-оповещения отправляются по правилам документооборота при их срабатывании.`,
"label.lasttimemodifier":`Последние изменения`,
"label.sso.summary":`Резюме`,
"label.customfields.encd.tip":`Позволяет пользователям вводить любые комбинации букв и цифр и хранить их в открытом текстовом виде, которые можно шифровать и искать.`,
"vue_label_report_formulacolumn":`Столбец формулы уровня рядов`,
"vue_label_systemSettings_transfer":`Записи пакетной передачи`,
"lable.product.ecm":`линия, пожалуйста, введите правильное количество.`,
"label.partner.setup":`Настройки облака партнера`,
"label.same.analyze.miaoshu2":`функция`,
"label.mobile.phone.day.summary":`Ежедневная сводка`,
"label.ccchat.person.error.illdomain":`Ошибка: неправильно заполненный формат домена`,
"label.knowledgebase.edit.as.draft":`Редактировать как черновик`,
"message.duplication.label.newfilterule":`Новое правило дублирования и совпадения`,
"vue_label_salesfunnel_notice1":`Резюме возможностей`,
"label.partnerCloud.partnerAccount.order":`Номер заказа :`,
"label.account.Current.and.PreviousFQ":`Текущий и предыдущий КВ`,
"label.customfields.formula.dateandtimeexample":`Next = NOW() 1`,
"label.area.unassign":`Назначенные пользователи`,
"label.at.my":`Содержание, о котором я упомянул (@)`,
"vue_label_calendar_notice_stopsharingfail":`Не смог остановить обмен`,
"label.data.file.validation.rules":`Исполнять правила проверки`,
"label.escalation.setup.entrydetail.escalation.hour":`Часы`,
"vue_label_ccchat_notice_pleaseentercontent":`Пожалуйста, введите содержание и параметры`,
"label.forecast.edit.error1":`Ошибка: Неактивная валюта`,
"label_emailtocloudcc_exists1":`Этот почтовый ящик был установлен на Email to Lead. Не повторяйте настройки.`,
"label.trigger.send.email":`Уведомления по электронной почте через триггеры`,
"label.setmysafetysignagain":`Сброс моего маркера безопасности`,
"label.callcenter.pleaseenter.access.keyID":`Пожалуйста, введите идентификатор секретного ключа`,
"chatter.poll.option10":`Выбор 10`,
"vue_label_systemSettings_mobelbottonsetting2":`Настройка унифицированного нижнего меню`,
"label.quickbooks.searchs":`Поиск`,
"label.section":`Сегмент`,
"label.customfields.fielddependency.new.tip":`Создайте зависимую связь, которая вызывает динамическую фильтрацию значений в пикилисте или в многоселекторном пикилисте на основе значения, выбранного пользователем в другом поле.<ul ><li>Поле, которое управляет фильтрацией, называется "управляющим полем". Стандартные и пользовательские флажки и списки пикилистов, содержащие как минимум одно и менее 300 значений, могут быть управляющими полями. </li><li>Поле, значения которого фильтруются, называется "зависимым полем". Настраиваемые пикилисты и многоселекционные пикилисты могут быть зависимыми полями.</li></ul>.`,
"label.customobjects.track.introduce3":`Обратите внимание: отслеживается только часть диафильмированных полей, и при отслеживании полей будет показано "Edited".`,
"front-kefu-moudle-all-hidden-phone":`Скрыть номер телефона глобально`,
"vue_label_calendar_share_calendar_with_others":`Поделиться календарем с другими`,
"label.case.copre":`Скачать QRкод вебпортала`,
"label.conditiontag.lookup.pagetitle":`Выберите Picklist Values`,
"UG.opportunity.004":`Мультисервисный тип`,
"label.event.moveup.1day":`1 день вперёд`,
"label.industrialandcommercialverification.enablestatus1":`Включить проверку промышленных и коммерческих данных`,
"label.ccpeak.newrecord.getorpost":`Новая запись: есть два способа построить CCObject, используя CCObject.`,
"frame.personinfo.label.resizeimage":`Чтобы настроить изображение эскиза, перетащите и измените размер пунктирных линий на изображении профиля выше.`,
"label.optional.searchresultfield":`Доступные поля результатов поиска`,
"UG.Contract.02":`Договор представляет собой письменное соглашение между сторонами. Многие компании используют контракты для определения условий ведения бизнеса с другими компаниями. Используйте CloudCC для создания и документирования существующих контрактов с вашими учетными записями и бизнес-возможностями. Отслеживайте договор через процесс утверждения. Используйте напоминания рабочего процесса, чтобы напомнить вам о переносе контракта.`,
"label.group.activity":`Активные группы`,
"label.tabpage.characterz":`Начальный персонаж`,
"label.globalsearch.tip":`Пожалуйста, введите содержание поиска`,
"label.campaign.channel.download.size2":`Средний size: 500*500 пикселей`,
"label.step3.total4":`Шаг 3 из 4`,
"label.partnerCloud.payForFailure":`Платеж не прошел`,
"label.ggReleaseRange.editSuccess":`Редактировать успешно`,
"label.summaryinforelyon":`Обобщенные данные по`,
"label.productsales.htyj":`Выполнение контракта`,
"label.newpagelayout":`Новая компоновка страницы`,
"front-gantt-module-input-task-name":`Пожалуйста, введите название задачи！`,
"label.c_d_without":`Записи типа "С" могут иметь или не иметь соответствующие записи типа "D".`,
"label.licence":`Лицензии`,
"setup.layout.button.selectall":`Выбрать все`,
"label.app.step1.error.appnameexist":`Это имя приложения уже существует.`,
"label.cpq.quote.item.no.record":`Только продукты заказа с записями могут быть переданы в контракты.`,
"label.knowledgebase.noaffect.existing.translations":`Нет, мои изменения не повлияют на существующий перевод.`,
"label.schedulejob.setup.schedule.editjob":`Редактирование работы по расписанию`,
"lable.PowerProcess.Tips":`Процесс получения прав - это настраиваемая временная шкала, содержащая все шаги (этапы), которые могут помочь службе поддержки клиентов и другим сотрудникам выполнить все шаги для разрешения поддерживаемого дела или записи рабочего заказа. После того как настройка завершена, ее можно применить к правомочию.`,
"label.campaignmember.selectmember.step2":`Шаг 2 Выберите членов, которых вы хотите добавить`,
"vue_label_calendar_stopsharing":`Ты уверен, что перестанешь делиться календарем`,
"vue_label_notice_savemenu_fail":`Меню сохранить не удалось`,
"message.error.getitems.id":`getItems: id не может быть пустым.`,
"label.return.currencylist":`Назад к списку: Управление валютой`,
"label.wtd.detail.p":`ПК`,
"label.knowledgebase.publish.now":`Опубликовать сейчас`,
"label.appupload.install.explain":`Инструкции по установке`,
"label.visualpage.folder.all":`Все папки страниц`,
"message.passwordPolicy.validate.complexReq2":`Ошибка:Ваш пароль должен состоять из заглавных и строчных букв и цифр.`,
"label.umeng.chatter.at":`упоминал тебя.`,
"label.mobile.phone.month.report":`Ежемесячные рабочие заметки`,
"label.describableEditeSelectedFields":`Выберите поля, которые по умолчанию отображаются в столбцах отчета при создании нового пользовательского отчета.`,
"component.event.label.subject":`Тема`,
"label.knowledgebase.edit.draft":`Редактировать черновик?`,
"label.customer.tab.step1.selectoneobject":`Выберите существующий пользовательский объект`,
"label_partner_step2":`Шаг 2 подтвердить шаблон`,
"label_starting_annual":`Начальный год`,
"X":`Текстовая область`,
"label.customer.tab.style":`Стиль табуляции`,
"vue_label_commonobjects_detail_book":`Стандартный справочник цен`,
"chatter.email.referredToMe":`Упоминает меня в посте`,
"label.enable.both.barcode.qrcode":`Активация штрих-кода и QR-кода`,
"front-market-form-quired-choose":`Обязательные поля`,
"noinclude":`исключает`,
"label.sms.template.select":`Пожалуйста, выберите шаблон SMS`,
"label.weixin.optionten":`Выбор 10`,
"message.duplication.label.matchlastletters":`Последние N персонажей`,
"label.webtocloudcc.submit.success":`Успешное представление`,
"label.sales.dashboard.number":`Номер`,
"label.custom.field":`Карта это пользовательское поле`,
"label.dataimport.of.field":`поле (поля)`,
"label.view.new":`Создать новый вид`,
"UG_activity_03":`Зарезервировать расписание`,
"label.customfields.image.tip":`Позволяет пользователям загружать изображения.`,
"label.startexport":`Начать экспорт`,
"vue_label_commonobjects_view_chart_verticalbar":`Вертикальный гистограмма`,
"label.ccchat.person.invite.allexist":`Все, кого вы приглашаете, уже используют CCChat.`,
"label.fielddependence":`Полевые зависимости`,
"label.scan.tip":`Пожалуйста, используйте IE7, IE8, Chrome или Firefox браузер, и рекомендуется использовать разрешение более чем 1024×768.`,
"label.wei.weiactor":`Голосовалиовали за`,
"label.service.miniProgram.quantity":`Можно создать до 20 записей карусели~.`,
"vue_label_homepage_new_homepage_page":`Новая домашняя страница`,
"label.apply.telphone.validate.error":`Неверный номер проверки.`,
"component.assistant.button.newevent":`Новое событие`,
"System_TimeField_Format_Warning":`недействительное время`,
"chatter.feed.publishfeed":`Сообщение`,
"label.setting.intergrationlist":`Список интеграции`,
"label.object.prefix":`Префикс объекта`,
"label.tippage.confirmed":`Да, я хочу удалить пользовательский источник данных отчета и все зависимые отчеты.`,
"label_emailsync_form_signin":`Вход`,
"label.delete.cancel":`Разблокировать`,
"label.dashboard.myHomePage.des":`Выберите приборную панель для работы в каждом приложении.`,
"lable.account.FY.Ago":`2 года назад`,
"label.umeng.approval.reassign":`#approver переназначил ваш запрос на одобрение #obj.`,
"label.data.exp.zippwd2":`Автоматически генерировать пароль к сжатому файлу`,
"label.tabpage.contentz":`Пожалуйста, введите содержание`,
"label.callcenter.batch.add.number":`Добавить номера в Batch`,
"label.tabpage.deleteviewsuccess":`Посмотреть удалить успех`,
"setup_layout_group_field":`Поля`,
"label.appupload.component.addobj.scheme.label.suoshu":`Объект`,
"front-project-module-v1-market-is-template":`Пометить как шаблон`,
"label.service.gantt.one.esource.types":`и один из следующих типов ресурсов`,
"label.emailtocloudcc.search":`Поиск`,
"label.mobile.home.page.myyj":`Мое выступление`,
"vue_label_normal_invoice_sf":`Счет-фактура`,
"label.permission.detail.app.fenpei.tip":`Укажите, какие приложения отображаются в меню приложений.`,
"label.login.access.month":`Месяц`,
"label_tabpage_retypez":`При изменении типа записи значения существующего списка опций автоматически не меняются. мы рекомендуем обновить в том же месте значения существующего списка опций записи.`,
"label.ems.private.company.message":`Версии для частного облака не поддерживают онлайн-редактирование почтового ящика компании.`,
"label.dataimport.length.check":`Длина более 18 бит, пожалуйста, внимательно ознакомьтесь с записью и модифицируйте ее.`,
"label.batchtransfer.type1":`Переводить открытые возможности, не принадлежащие владельцу текущего счета`,
"vue_label_calendar_are_you_sure_to_remove":`Вы уверены, что удалите этот календарь`,
"label.icon.117":`Школьный портфель`,
"vue_label_systemSettings_downloadapp":`Скачать мобильное приложение`,
"label.approval.project":`Пункты для утверждения`,
"template.organization":`Организационный уровень`,
"label.weixin.return.research":`Назад к странице с подробной информацией о микроопросе`,
"label.ccchat.person.invite.addsay":`Добавить дополнительное сообщение...`,
"UG.Case.02":`Случаи позволяют реагировать на проблемы с учетной записью и решать их. Случаи - это мощная запись в Cloud CC, которая не только отслеживает проблемы учетной записи, но и отображает полное представление об учетной записи.`,
"label_emailtocloudcc_step1":`Шаг 1`,
"workflow.action.tasks.assignortype.owner":`Владелец`,
"label.data.import.page":`Перейти на страницу импорта`,
"label.cache":`Кэш`,
"label.custom.page.cuspage.width":`Ширина (пикселей)`,
"label.customcomponent.referencetag":`Справочная этикетка`,
"label.tabpage.search":`Поиск`,
"label.knowledge.searcharticle.casefields":`Поля дел для поиска предлагаемых статей`,
"setup_layout_message_relatedlistfield":`Выберите поля для отображения в соответствующем списке. Можно также повторно упорядочить выбранные поля.`,
"label.relationobject.type":`Тип связанного объекта`,
"UG_Account_02":`Некоторые компании предоставляют услуги другим компаниям, некоторые напрямую сотрудничают с конечными пользователями, а другие обслуживают НПО.`,
"UG_homepage_006":`360-градусный обзор деятельности вашей учетной записи с помощью опросов, живых чатов, электронной почты, заказов на работу, сообщений в социальных сетях, и даже торговой деятельности (например, руководство, сервисная поддержка и деятельность).`,
"chatter.poll.option1":`Выбор 1`,
"label.ccdocument.fieldforld":`Имя папки документов принадлежит`,
"label.wei.result":`Результат`,
"label.recentview.new":`Последний сайт`,
"label.martrixreport.setsumfield":`Выберите поле для использования в качестве сводной строки в матричном отчете.`,
"label.reportsSubscriptionPage.schedulereport.weekly.monday":`Понедельник`,
"label.marketsea.button.recycle":`Рециклировать`,
"label.standard.buttonandlink.info2":`Выберите пользовательскую страницу CloudCC.com вместо URL-адреса CloudCC.com для этой стандартной кнопки или ссылки.`,
"label.reportsSubscription.select.two.months":`Пожалуйста, выберите диапазон дат в течение двух месяцев для этой частоты!`,
"label.standard.buttonandlink.page":`CloudCC Classic`,
"vue_label_commonobjects_view_chart_horizontalbar":`Горизонтальная гистограмма`,
"label.Remove":`Удалить`,
"label.mobile.phone.receivable":`Платежи`,
"label.appupload.uploaddetail.goback":`Назад к упаковке`,
"label.select.role":`Пожалуйста, выберите роль`,
"label.file.sharetype":`Тип акции`,
"label.app.chosetab":`Выбрать вкладки`,
"label.case.other.phone":`Другой номер телефона`,
"chatter.edit.cancel":`Ваши изменения были отменены.`,
"label.html":`HTML`,
"message.auth2cn.acquisition.failed":`Не удалось получить auth2cn!`,
"message.error.system.service.permissiondeny":`К сожалению, вам не разрешается обслуживать эту услугу, пожалуйста, свяжитесь с вашим администратором.`,
"label.chatter.mygroups":`Мои группы`,
"label.umeng.approval.approvalpass":`Утверждается запрос на утверждение #obj. #obj имя`,
"label.chatter.owner":`Владелец`,
"vue_label_commonobjects_view_kanban_view":`вид на Канбан`,
"message.please.choose.group.role":`Пожалуйста, выберите групповую роль`,
"label.icon.136":`Валюта`,
"label_tabpage_selectdate":`Выберите дату`,
"chatter.emailInformation":`Общая информация`,
"front-lightning-module-v1-dashborad-bubble-size":`Размер пузырька`,
"label.stdashbord.xsld.business.wan":`мириады`,
"label.datamanage.field.notexist":`Поле, соответствующее объекту, не существует.`,
"UG.Forcast.04":`Начальное испытание`,
"UG.contact.02":`Взаимодействие с контактами по нескольким каналам, звонки, электронная почта, социальные сети`,
"vue_label_pool_selecttransferinto":`Выберите ведущий пул для перевода в`,
"label.quote.xingming":`Имя`,
"label.customerinfo.userlicencenum":`Лицензии пользователей`,
"label.group.no.my.archived":`Соответствующих архивных групп не найдено.`,
"label.weixin.add.activity.tel":`Добавить вызов активности`,
"label.partner.setup.address":`Облачный адрес партнера`,
"label.data.file.i_title.num3":`3. система предварительно считывает файл данных с сервера, затем запускает внутренний массовый импортер, о результатах которого пользователи будут уведомлены по почте, и вам не придется ждать на этой странице.`,
"label_sum_up":`РЕЗЮМЕ`,
"label.searchall.title":`Глобальный поиск`,
"label.bind.chooseone":`Выберите владельца`,
"label.campaign.channel.input.owner.select1":`Владелец текущей кампании`,
"front-kefu-moudle-v1-Expand-chat":`Развернуть подробности чата`,
"label.component.hotdeal":`Горячие предложения`,
"component_event_label_title":`Предстоящие события`,
"No.planed.activity":`Нет планируемой деятельности`,
"label.searchlayout.result.field":`Столбцы результатов поиска для поиска и тегов.`,
"label.leadscore.value":`Значение`,
"vue.dashboard.linkage.is.set.successfully":`Связка установлена успешно!`,
"PersonalInfo.LoginHistory.001":`Браузер подтверждает ссылку на регистрацию в вашем почтовом ящике.`,
"front-gantt-module-v1-problem-number":`Проблемные номера`,
"label.page.step5.of.step5":`Шаг 5 из 5`,
"label.sendemail.chat.sendmessagesubject":`Сообщение CloudCC CCChat`,
"label.Linkedin_accounts":`Аккаунт в LinkedIn`,
"label.qrcode.useful.life":`Дата истечения срока действия QR-кода`,
"deleterow":`Удалить Ряд`,
"label.forecast.settings.future1":`Будущий 1 цикл`,
"message.error.group.operation":`Ошибка групповой подачи заявок`,
"label_tabpage_loadz":`Загрузка страницы, пожалуйста, подождите...`,
"label.brackets.left":`(Открытая скобка)`,
"label.source.code":`Просмотр исходного кода`,
"setup_layout_label_areasetup":`Свойства раздела`,
"component.assistant.label.todaylead":`Зацепки, назначенные вам сегодня.`,
"label.qrcode_signin":`QRкод ограничен приложениями, которые требуют сканирования кода на месте и входа в систему`,
"label.calendarshare":`Календарный обмен`,
"IMG":`Изображение`,
"label.use.rule.when.both":`Применяйте это правило при одновременном включении штрих-кода и QR-кода.`,
"label.ccpeak.addshare.record":`Новые записи в общей форме:Недавно добавленные записи`,
"label.enable.email.tracking":`Включить отслеживание электронной почты`,
"label.top.plsinput":`Ищите в этом списке...`,
"vue_label_helpcenter_case":`Дела - это вопросы клиентов, обратная связь или проблемы. Агенты поддержки могут просмотреть дела, чтобы понять, как обеспечить лучшее обслуживание. Торговые представители могут использовать кейсы, чтобы понять, какое влияние они оказывают на процесс продаж. Отвечая на отдельные кейсы, вы можете удовлетворить своих клиентов и улучшить имидж вашего бренда.`,
"label.useonly":`Частный`,
"label.displaytype":`Тип дисплея`,
"label.most.user.group":`Пользователи могут присоединиться к 100 группам пользователей, а вы уже присоединились к 100-й группе пользователей.`,
"label.umeng.activity.yourevent":`Ваше мероприятие`,
"label.forecast.shrepage.classdes.w":`Чтение/запись - Пользователь может просматривать и переопределять данные прогноза.`,
"label.defaultaccess":`Доступ по умолчанию`,
"label.partner.new.step2":`Шаг 2 подтвердить шаблон`,
"component_setup_iframe_label_title":`Настроить страницу`,
"label.sso.saml.sp.idenitytype":`SAML-идентификатор`,
"label.dashboard.this.folder":`Приборные панели в этой папке`,
"label.data.newtemplate.e.seltype.desc":`Существует два вида производных данных</li><li класса`,
"label.forecast.customforecast.submit.tip1":`Отправьте свой прогноз:`,
"label.version.workflow.and.approval":`Автоматизация рабочего процесса и процесса утверждения`,
"label.tianyancha.tip":`Введенный текст неверен, пожалуйста, введите заново!`,
"label.report_details":`Детали отчета`,
"template.report.folder.contract.product":`Анализ контрактов и продукции`,
"label.all":`Все`,
"label.version.area.long.rich":`{0} поля с богатым текстом или длинными текстовыми областями`,
"label.enc":`Зашифрованное хранилище`,
"vue_label_pricebook_enterproductname":`укажите, пожалуйста, название продукта`,
"label.edit.quote.line":`Редактировать строку цитаты`,
"label.edit":`Редактирование`,
"M":`детальные отношения`,
"front-kefu-phonenumber-exists":`Место № {a} уже существует`,
"label.standardplatformuser":`Стандартная платформа Пользователи`,
"label.custom.page.configuration":`Редактирование пользовательского компонента консоли`,
"url.error.contact.null":`Адрес микросервиса пуст.`,
"label.sethelp":`Параметры справки`,
"setup.mainpage.label.welcome23":`Параметры безопасности`,
"label.sales.page.dashboard.fenxi":`Приборные панели анализа продаж`,
"label.limit":`Доступ`,
"maintenanceasset.asset.contractlineitem.illegal":`Вы должны выбрать актив в строке договора, прежде чем связать строку договора с активом обслуживания.`,
"UG.contact.04":`Или`,
"Opportunity.Detailed.Phase.Label.004":`День(ы)`,
"label.emailobject.receive":`На`,
"label.brief.new":`Недавно новый`,
"label.marketsea.button.adopt":`собирать`,
"label.select.up.to.three.fields":`Можно выбрать максимум три поля.`,
"vue_label_allsearch_noresults":`Мы искали по вашим индивидуальным настройкам поиска, результат поиска не найден с помощью {userInput}.`,
"Report_CantDelete_Info":`{0} отчёт является источником данных для приборной панели {1} и не может быть удалён!`,
"label.chile.summer.time":`Чилийское летнее время`,
"label.partnerCloud.menu.selectedMenu":`Выбранное меню (отмеченные меню будут синхронизированы с приложением)`,
"vue_label_report_onlysummary":`Только резюме`,
"front-template-V1-Applicable-object":`Пожалуйста, выберите подходящий объект.`,
"label.invoice.message.sendfailed":`Счет не прислали, попробуйте позже.`,
"front-kefu-moudle-v1-use-free":`ПОПРОБУЙТЕ БЕСПЛАТНО`,
"label.rule.updated.successfully":`Успешное обновление правил`,
"label.owner.lastone":`Maitain одно условие не менее`,
"label.appointment.wizard.subtitle1":`Продолжительность встречи`,
"template.report.opportunities.closed.month":`Закрытые возможности этого месяца`,
"label.tabpage.choosecontent":`Выберите содержание значения`,
"template.chart.jbnddxl":`Продажи заказов за последние полгода`,
"label.fieldsecurity.detail":`Подробная информация о безопасности на местах`,
"label.knowledgebase.data.deleted.successfully":`{a} данные удалены успешно`,
"label.sso.saml.idp.config.nameidfmt":`Формат ID имени`,
"label.emailobject.prompt":`Симптома`,
"label.marketsea.isgetbyself":`Позволить членам самостоятельно собирать`,
"label.winxin.cancelprompt":`Вы уверены, что выйдете? Ваша текущая операция не сохранена.`,
"label.appexchange.installedpage.message2":`Приложения и компоненты устанавливаются в пакетах. Любые пользовательские приложения, вкладки и пользовательские объекты изначально помечены как "В разработке" и не устанавливаются для вас, пользователей, что позволяет вам протестировать и настроить их перед установкой. Вы можете развернуть компоненты по отдельности, используя другие возможности в настройке или в группе, нажав "Развернуть".`,
"vue_label_import_importtype":`Тип импорта`,
"label.data.importef.des":`Файлы, которые не удалось импортировать, будут сохранены на сервере в течение 48 часов и автоматически удалены через 48 часов.`,
"chatter.email.reply":`Комментарии к моим сообщениям`,
"label.stdashbord.xsld.business.sdl":`Потерянная ставка`,
"labal.emailtemplate.namemessage":`Уникальное имя шаблона электронной почты существует, пожалуйста, введите его повторно.`,
"vue_label_email_Please_select_file":`Пожалуйста, выберите файл`,
"label.event.modify":`Редактирование событий`,
"label.projectManagement.isnmber":`Пожалуйста, введите число до одного знака после запятой.`,
"lable.outlook.detail.emailst":`Настройки электронной почты`,
"label.partnerCloud.priceOfManual.isUsed":`Этот параметр определяет, могут ли партнеры использовать этот справочник цен для заказа.`,
"setup_mainpage_label_welcome26":`Управление данными - пакетная обработка`,
"label.file.version":`Версия`,
"pagecreator_systemstyle_label_bordercolor":`Цвет границы`,
"label.approval.isallowed.reject.prompt":`Хотите ли вы разрешить отказ при утверждении отдельных данных? (Массовое утверждение всегда может быть отклонено).`,
"label.myinfo":`Личная информация`,
"front-template-V1-fontSize":`Размер шрифта`,
"lable.outlook.edit.alpreo":`Всегда предпочтительный обмен`,
"front-email-payment-card-number":`Номер карты`,
"label.cpq.quote.pricebook.no.change":`После определения справочника цен для предложения его нельзя изменить. Для использования нового справочника цен создайте 1 новую запись о предложении.`,
"vue_label_file_size_limit_tip":`Размер файла превышает лимит`,
"lable.PowerProcess.worktime":`Время работы процесса получения прав`,
"label.monthly.month.report":`Ежемесячный отчет по г/г и м/м`,
"front-kefu-moudle-v1-sydq-buyuser":`Ваш след должен быть пройден. Пожалуйста, приобретите Easemob для продолжения использования`,
"label_tabpage_Rolesz":`Роли и подчинённые`,
"chatter.f.n":`Следуйте этой записи`,
"UG.Forcast.02":`Прогнозы представляют собой оценки ожидаемых продаж на определенный период, и модели прогнозирования могут помочь вам определить спрос на продукцию и выручку от продаж в определенный период. Менеджеры могут использовать прогнозы для постановки целей и измерения прогресса команды. Общий прогноз организации может отражать сводку всех продаж по продажам, составленную торговым представителем (независимо от стадии завершения продаж от стадии конвейера до завершенной стадии).`,
"label.productsales.contract.phb":`Перечень контрактов`,
"label.umeng.insert.approval.submit":`#заявитель представляет #obj на ваше одобрение`,
"message.duplication.label.matchfirstletters":`Первые N Персонажи`,
"label.partnerCloud.partnerAccount.toPay":`Перейти к оплате`,
"label.model.un":`Номер модели: UN6786`,
"label.save.c1":`Название "Web To CloudCC" должно быть уникальным.`,
"week":`Неделя`,
"Pagelayout.Setup.003":`Должно быть выбрано поле "Имя`,
"label.query.detail.openpartnermessage":`Как только клиент включен в качестве партнера, он появляется в отфильтрованных отчетах и просмотрах списка на поле ispartner. Кроме того, пользователи-партнеры могут создавать из контактов, связанных с этим клиентом. вы уверены?`,
"label.validate.function.funcFormat.DATEVALUE":`ДАТЕВАЛЬНОСТЬ (дата)`,
"label.apply.send.false":`Отправить неудачу`,
"label.recordtype.edit.selectvalue":`Значения в пиклисте`,
"label.chosesubject":`Выберите тему ниже`,
"label.validate.function.funcExplain.YEAR":`Годом возврата является число между 1900 и 9999 годами.`,
"component.chatter.button.more":`Подробнее`,
"label.top.class.smallest":`Минимальный уровень иерархии - 1.`,
"label.startingvalue":`Начальный номер`,
"label.multi.layout.remark":`Макет, который применяется к переднему мастер-детальному входу и массовому добавлению.`,
"label.role.availableuser":`Доступные пользователи`,
"label.weixin.iebrowser":`В настоящее время вы используете браузерную версию IE6, которая была выпущена компанией Microsoft в 2001 году. Поскольку версия браузера слишком низкая для того, чтобы CloudCC разрабатывался с использованием новой технологии, не гарантируется, что все функции будут использоваться должным образом. Пожалуйста, загрузите и обновите браузер вовремя.`,
"Homepage_News_004":`Последних новостей нет.`,
"vue_label_normal_task_sf":`Задача`,
"label.version.nonsupport.trigger":`Триггеры пока не поддерживаются.`,
"pagecreator_page_label_pagelayout":`Макет страницы`,
"label_tabpage_step3":`Шаг 3 Выбор полей для отображения`,
"label.canOnlyUploadCSVFormatFile":`Загружать только файлы в формате CSV`,
"label.b.c.least":`Каждая запись в букве "В" должна иметь как минимум одну связанную запись в букве "С".`,
"label.list.userinterface.sales.enable":`Просмотр данных на главной странице продаж Просмотр данных на главной странице Разрешение доступа`,
"label.umeng.approval.approvalreject":`Запрос на утверждение #obj отклоняется. #obj имя`,
"vue_labenl_normal_notice_share_fail":`Делиться не удалось`,
"label_emailtocloudcc_tip":`Симптома`,
"label.h5.touchselect":`Нажмите, чтобы выбрать`,
"label.tabularreport":`Табличный отчёт`,
"label.app.defaulttab":`Вкладки по умолчанию`,
"label.validate.function.category.Datetime":`Дата и время`,
"vue_label_pricebook_editdetail":`Редактирование прайс-листа`,
"vue_label_commonobjects_view_no_selected_record":`Запись не выбрана`,
"chatter.changed":`Изменен`,
"label.asset.bom.based":`Генерировать спецификацию активов в соответствии с продуктовой структурой заказа`,
"label.appointmentdetail.wizard.title8":`Начать в каждом`,
"label.area.query.user.error":`Пользовательские данные, соответствующие территории запроса, не удались, а идентификатор территории был пуст.`,
"page.field.masterinput":`Настройки главного входа детализированной информации`,
"chatter.selads":`Выбрать получателей`,
"label.data.exp.please.savebutton":`Пожалуйста, отметьте "Сохранить как шаблон".`,
"label.members.activity":`Активный участник`,
"label.weixin.click.searchs":`Нажмите, чтобы найти запись`,
"label.input.least.two":`Пожалуйста, введите не менее двух символов`,
"label.marketing.seting":`Настройки облака маркетинга`,
"label.approveprocess.tip":`Утверждения - это сложные бизнес-процессы, требующие сбора информации и планирования перед внедрением. Перед началом работы рекомендуется следовать инструкциям, приведенным ниже.`,
"front-email-payment-Invoice-login-account":`Вход в аккаунт`,
"label.selectmulti.mes":`Слишком много выбранных получателей.`,
"label.workflow.gotolist":`Назад к списку: Рабочий процесс`,
"label.profile.fieldsafety":`Безопасность на местах`,
"front-project-module-v1-no-selectemplat":`Нет доступного шаблона`,
"label.sendemail.queue.assigntitle":`Электронное письмо с уведомлением об очередности назначения объекта`,
"label.approval.mobile.comments.placeholder":`Пожалуйста, введите комментарий здесь, до 1000 слов.`,
"vue_label_report_given":`конкретный`,
"vue_label_dashboard_groups":`Пожалуйста, выберите группу`,
"label.service.gantt.popoverTip":`Расстояние/время в пути`,
"label.mr.title.characters":`По длине символов`,
"label.passwordPolicy.setup.day":`дни`,
"label_tabpage_personvisible":`Доступен для соответствующего персонала`,
"ct":`Мультивалютный`,
"label.chatter.newEvent":`Новое событие`,
"vue_label_systemSettings_id":`Идентификация входа в систему`,
"label.page.preview.web.tab":`Предварительный просмотр Web Tab`,
"label_emailsync_button_sure":`Подтвердить`,
"front-template-V1-Modification-time":`Время модификации`,
"vue_label_homepage_edit_fixed_components":`Редактировать фиксированные компоненты`,
"label.apply":`Применить`,
"Main.Menu.Mobiledownload":`ВКЛЮЧИТЬ ИСПОЛЬЗОВАНИЕ`,
"vue_label_salesfunnel_notice6":`Общее количество возможностей с вероятностью 100%`,
"label.chosesubject.sendemail":`Отправить электронное сообщение`,
"label.changemydisplay.chagetab.des":`Выберите вкладки, которые будут отображаться в каждом из ваших приложений.`,
"label.attendance.setting.checkUser":`уже существует в другом присутствии.`,
"label.list.projectSetting.setup":`Настройки управления проектами`,
"label.app.introduce2":`Вы можете настроить существующие приложения в соответствии с тем, как вы работаете, или создавать новые приложения, группируя стандартные и пользовательские вкладки.`,
"label_emailsync_form_emialpassword":`Пароль`,
"label.Lightning.Setting":`Настройка молнии`,
"label.print.preview":`Просмотр для печати`,
"label_vue_create_edit_obj_create_event_dialog_desc_alert":`Вы все еще хотите создать мероприятие в эти сроки?`,
"label.mobile.phone.report.type":`Тип доклада`,
"lable.account.CalenderWeek":`Календарная неделя`,
"label_emailtocloudcc_step3total3":`Шаг 3 из 3`,
"label_tabpage_emailaddressz":`Адрес электронной почты отправителя`,
"label.data.is_woking":`Операционный сайт`,
"label.knowledge.cancelattach.case":`Отмена Прикрепить к делу`,
"label.sendemail.chat.chatcontent":`Содержание основного поста:`,
"label.timezone.set":`Настройки территории`,
"label_tabpage_uploadingz":`Загрузка`,
"front-epwechat-module-v1-home-url":`URL домашней страницы:`,
"label.reportsSubscription.select.subscription.frequency":`Пожалуйста, выберите частоту подписки!`,
"label.validate.function":`функция`,
"label.partnerCloud.orderingPlatform.quantity":`Количество`,
"label.compact.layout.chatter":`CCChat`,
"label.sso.saml.sp.description2":`Настройка единой регистрации для аутентификации пользователей в CloudCC из внешних сред.`,
"label.ccchat.message.new.error1":`Мы не можем найти пользователя чата с {0} на его имя.`,
"label.file.share.email.content3":`Для получения более подробной информации, пожалуйста, войдите в систему CloudCC CRM.`,
"label.file.cancel.sharing":`Отменить обмен`,
"label.changemydisplay.showalltabs.add":`Добавить вкладки на дисплей по умолчанию`,
"label_chatter_incident":`Событие`,
"label.file.folder.delete3":`Вы уверены, что хотите удалить {имя папки}？.`,
"label_tabpage_delsuccessz":`Удалить успех`,
"label.view_contact":`Посмотреть контакты`,
"label.deactivate":`Деактивировать`,
"label.Horizontal.Date":`Назначение обслуживания фильтров в соответствии с датой понижения уровня грунтовых вод.`,
"label.forecast.tree.title":`Иерархия прогнозов`,
"vue_label_dashboard_dategruop":`Пожалуйста, выберите основу группировки дат`,
"label.version.nonsupport.custompage":`Пользовательские страницы временно не поддерживаются.`,
"label.tabpage.personvisible":`Доступен для соответствующего персонала`,
"message.error.unknown":`Неизвестная ошибка`,
"label.down":`На сайте`,
"label.multilang.customforcast.financialyear":`{0} финансовый год: {0}`,
"label.dataimport.type.error":`Ошибка типа, пожалуйста, проверьте запись и измените.`,
"label.batchadd.newbatchpage.save.num":`Неправильный цифровой формат`,
"front-Dev-V12.2.8-calendar-endField":`Конечное поле`,
"label.tabpage.rtemptyz":`Тип записи не может быть пустым`,
"vue_label_dashboard_maximum":`Пожалуйста, введите максимум`,
"label.expiredate":`Срок исполнения`,
"label_emailtocloudcc_button_view":`Посмотреть`,
"label.event.future":`Будущие события`,
"label.mobile.app.layout":`Макет мобильного приложения`,
"label.emailobject.contacts":`  контакт(ы)`,
"label.approvalstep2.tip":`Укажите, должна ли запись отвечать определенным критериям, прежде чем вступать в данную стадию официального утверждения.`,
"label.usefollowtoset":`Используя приведенные ниже опции, укажите пользователя, которому должен быть присвоен запрос на утверждение.`,
"label.dashboard.summary.editPageHeader":`Редактировать заголовок`,
"label_partner_workspace_tab_memo":`Выберите вкладки для этого облака партнеров. Можно выбрать стандартные или пользовательские вкладки.`,
"front-lightning-module-v1-details-page-chart-title-supports":` Title поддерживает вставку имени записи с форматом {recordname}, например "Opportunity Amount of {recordname}". Если текущее имя записи  CloudCC, то оно будет отображено как "Opportunity Amount of CloudCC".`,
"label.enable.generate.location.service":`Позволяет генерировать сервисы данных о широте и долготе заказчика на основе адреса заказчика.`,
"label.loginsystem":`Вход`,
"label.email.template.edit.template":`Редактирование шаблона`,
"vue_label_commonobjects_detail_share":`Доля прибыли`,
"label.icon.142":`Дом`,
"label.maintype":`Мастер`,
"label.step2.total4":`Шаг 2 из 4`,
"label.select.intended.tablayout":`Выберите макет страницы вкладки, которую вы хотите создать.`,
"label.custom.unit":`Единица`,
"label.mr.title.phone":`Телефон`,
"label.compact.layout.frame.showtype":`Способ отображения:`,
"label.associations":`Ассоциированный объект`,
"label.potentialcustomers.name":`Имя свинца`,
"label.edit.profile":`Редактировать профиль`,
"label.tabpage.allvisible":`Все пользователи видны`,
"label.login.verification.confirmation.enabled":`Твердо включите`,
"vue_label_norm_recordselected":`{selectNum} выбранная(ые) запись(ы)`,
"label.partner.workspace.member.selectedprofile":`Выбранный профиль`,
"label.divide":`/разделять`,
"label.version.case.control":`ведение дел`,
"label.attendance.nocheckin":`Не зарегистрирован`,
"vue_label_helpcenter_report2.1":`2.Удалить группировку рядов: <br> A. После нахождения поля "группировка строк", которое вы хотите удалить в списке "группа строк" слева, нажмите на поле "×". <br> B. Или найдите поле "группировка строк", которое хотите удалить, в заголовке отчета о предварительном просмотре справа, нажмите на "выпадающую кнопку", и нажмите на "удалить групповую строку".<br> Удалить группировку столбцов: <br> A. После нахождения поля "Группировка столбцов", которое Вы хотите удалить в списке "Групповые столбцы" слева, нажмите на поле "×". <br> 1. B. Или найдите поле "Группировка строк", которое Вы хотите удалить, в заголовке таблицы отчета предварительного просмотра справа, нажмите на выпадающую кнопку и нажмите кнопку "Удалить строку группы". <br> Для удаления группировки столбцов:<br> A. Найдите поле Группировка столбцов, которое вы хотите удалить, в списке Групповых столбцов слева и нажмите на поле "x". <br> B. Или найдите поле Column Grouping, которое вы хотите удалить, в заголовке таблицы отчета о предварительном просмотре справа, нажмите выпадающую кнопку и щелкните Delete Group Column. <br>? Настройка гранулярности даты для группировки записей<br> Шаг 1: После группировки по полям даты можно также настроить гранулярность даты. Сначала выберите поле даты, по которой вы хотите сгруппировать отчет. Затем нажмите кнопку Обновить рядом с этим полем в заголовке предварительного просмотра отчета и нажмите кнопку Сгруппировать по дате. <br> Шаг 2: Выберите, как вы хотите сгруппировать: День, месяц, год, Бухгалтерский квартал, Бухгалтерский год, пользовательский квартал, пользовательский год. <br>? Шаг 1: После нахождения колонки, которую вы хотите резюмировать в заголовке отчета предварительного просмотра, нажмите кнопку "выпадающий" и нажмите кнопку "Сводка". <br>`,
"label.payment.renew":`Просмотреть`,
"vue_label_file_wrong_type":`'Произошла ошибка в типе загружаемого файла, формат файла, который вы сейчас загружаете,  {тип}!`,
"UG_opportunity_005":`Многократный процесс продажи`,
"label.knowledge.language.korean":`Корейский`,
"label.customobjects.inputrecordtagandformat":`Введите имя записи Метка и формат`,
"label.h5.chatter.commentednum":`Получить ответ`,
"label.quickbooks.button.unlink":`Ссылка на`,
"label.step5.total5":`Шаг 5 из 5`,
"label.projectManagement.Selweek":`Выберите неделю`,
"label.optional.searchfield":`Доступные поля с возможностью поиска`,
"label.mobile.quickcreate.default.signin":`Зарегистрироваться`,
"label.visualpage.unable.parse":`Невозможно разрешить маркер.`,
"mesage.error.role.delete":`Нельзя удалить роль, которой назначена дочерняя роль.`,
"label.role.user":`Пользователи в роли`,
"button_partner_workspace_saveas":`Сохранить как`,
"label.file.no.public.link.created":`Общественная ссылка не создана`,
"label.login.access.shenyu":`Остающийся`,
"label.ccchat.group.section":`Группа`,
"label.weixin.object.notnull":`Тема не может быть пустой`,
"label.accmarketsea.add.title":`Новый пул аккаунта`,
"label.sales.funnel.layout":`Продажа макета воронки`,
"pagecreator.page.button.edit":`Редактирование`,
"label_tabpage_entercontent":`Пожалуйста, введите содержание`,
"component_event_label_begindate":`*Время начала`,
"label.file.versionhref":`Перейти на новую версию страницы`,
"label_chatter_send":`Отправить`,
"setup_layout_label_buttonlist":`Кнопки выбора`,
"label.custom.Current.and.NexttCQ":`Текущий и следующий 3 CQ`,
"pagecreator_page_label_pagedesc":`Описание страницы`,
"label.appupload.upload.uploader":`Загружено`,
"label.console.step5.tab.primary":`В качестве основной вкладки`,
"vue_label_globalsearch_expandlist":`Расширить список`,
"label.forecast.edit.userqu":`Цель`,
"label.step1.total5":`Шаг 1 из 5`,
"label.multilang.dupicatecheck.onegroupredata":`Ход проверки дубликата и комбинации: всего {0} групп {0} :`,
"vue_label_systemSettings_repeat":`Управление дубликатами`,
"label.mobile.side.tab.error1":`Пожалуйста, выберите вкладки "Коммунальные фракции" и "Приложения", которые необходимо отобразить.`,
"label.knowledgebase.reduction":`Восстановить`,
"label.standard.buttonandlink.override.usedefault":`Нет Переопределения (использовать по умолчанию)`,
"dateandtime":`Дата/время`,
"label.group.activate.info":`Активировать группу`,
"label.triggertotask":`Триггеры задачи`,
"label.emailobject.save.template":`Сохранить черновик в качестве шаблона`,
"label.audit.objInfo":`Процесс утверждения Подробная информация`,
"label.callcenter.successfully.logged.account":`Успешно вошел в систему!`,
"label_new_customer_target":`Цель нового счета`,
"label.campaign.channel.step5":`Шаг 5: Просмотрите страницу регистрации канала сбыта и исходный код.`,
"label.log.type":`Типы операций`,
"front-template-V1-noTemplate":`Для переключенного объекта не найдено доступных шаблонов.`,
"label_report_line_daixuan":`Колонка "Отложенный отчет`,
"label.tianyancha.businessverify.relation.tip":`Напишите поля, возвращенные tianyanyancha в поля заказчика`,
"label.default.value":`Используйте это значение в качестве значения по умолчанию для пикилиста ведущего.`,
"label.weixin.campaign.attendance":`Посещаемость кампании`,
"message.duplication.label.check":`Проверить`,
"label.salescloud.salescloud.yes2forbidden":`Да, я хочу отключить Team Selling.`,
"lable.currencyAdv.exchagecurrency.rate":`Обменные курсы для:`,
"lable.Hide.title":`Скрыть названия`,
"label.finishedreport":`Генерируемые отчёты`,
"vue_label_account_business":`Передача закрытых бизнес-возможностей владельцам клиентов`,
"vue_label_pool_assigned":`Назначен`,
"label.report.export.error":`Экспортная операция столкнулась с исключением. Пожалуйста, попробуйте еще раз.`,
"label.layout.availablefield":`Доступные поля`,
"label.licence.remainder":`Остающиеся лицензии`,
"label.approval.idea.required":`Необходимо получить положительное заключение.`,
"front-kefu-moudle-needhand-createcase":`Перед созданием дела требуется ручное подтверждение`,
"label.dashboard.snapshot.Data.change":`Источник данных изменен, пожалуйста переконфигурируйте`,
"label.partner.workspace.login.footertext":`Текст нижнего колонтитула`,
"vue_label_chatter_upload_link_type":`Выбранная публикация типа ссылка для загрузки`,
"front-dialog-module-v1-error-detail":`Детали ошибки`,
"label.emailobject.sendgroupemail":`Отправить сообщение электронной почты группы`,
"lable.newtabpage.allviews":`Все виды`,
"label.khdd":`Местоположение аккаунта`,
"vue_label_dashboard_sortfield":`Сортировочное поле`,
"label.form.sample":`Пример формы`,
"component_setup_button_cancel":`Отменить`,
"vue_label_salesfunnel_notice5":`Количество бизнес-возможностей с вероятностью 1% - 99% * вероятность`,
"pagecreator_systemstyle_label_modifystyle":`Редактор стилей`,
"UG_homepage_001":`Выигрывайте больше сделок за меньшее время`,
"label.campaign.pc":`ПК`,
"label.visualpage.lightning":`Молниеносная версия`,
"label.knowledge.category.hint.two":`Используйте эту страницу для выбора группы для Lightning после создания группы категорий.`,
"label.south.africa.standard.time":`Южно-Африканское стандартное время`,
"label.service.gantt.reservation.number":`Номер заказа`,
"label.weixin.report.period":`Период`,
"label.leadtomap.exp":`Используйте вкладки для сопоставления каждого из полей руководства Вашей организации с одним из полей Вашей учетной записи, контакта или возможности. Эти сопоставления используются, когда вы конвертируете ссылки в учетные записи, контакты или возможности.`,
"label.currency.d":`Вы можете поменять корпоративную валюту на другую поддерживаемую валюту Вашей организации. Все курсы обмена валют, уже определенные на CloudCC.com, будут изменены соответствующим образом, чтобы отразить это изменение.`,
"label.forecast.detailforecast.oppyclb":`Категории прогноза возможностей`,
"label.reportsSubscriptionPage.email.selected":`Избранные члены`,
"vue_label_homepage_componentname":`Пожалуйста, введите название компонента`,
"lable.account.Previous.FYt":`Предыдущие 2 года`,
"label.appupload.success":`Загрузка завершена`,
"label.customer.newtab":`Новая пользовательская вкладка страницы`,
"label.value.notnull":`Вы должны ввести значение.`,
"label.case.miniprogram.layout":`Макет страницы отчета апплета - это макет страницы, используемый для запроса на обслуживание, который был отправлен с конца апплета, и этот макет страницы можно только редактировать и нельзя удалить.`,
"label.partnerCloud.partnerAccount.twoDecimal":`Пожалуйста, введите в правильном формате.  Можно оставить два десятичных знака.`,
"UG.Lead.004":`веб-форма`,
"label.umeng.activity.event.eventwillbeginnew":`Уведомление о событии: #событие начинается в #начале.`,
"label.projectManagement.subtasks":`Sub-taks`,
"vue_label_checkduplicate_repeat_conditions":`Решить повторяющиеся условия`,
"label.subject":`Тема`,
"label_search_otherusers_forecast":`Поиск прогнозов других пользователей`,
"label_tabpage_namemandatory":`Требуется название вида`,
"label.timezone.importtimezone":`Настройка часового пояса для импорта данных`,
"label.mobile.buttom.team.init":`Инициализация пользователя команды`,
"label.checkfield.choosefield":`Выберите поля, чтобы найти дубликаты`,
"label.b_c_least":`Каждая запись в букве "В" должна иметь как минимум одну связанную запись в букве "С".`,
"label.knowledge.setting.hint.five":`Выберите автора знаний`,
"label.h5.similar.opportunity.step2":`Шаг 2 Укажите критерии соответствия`,
"label.page.style.imbedded.cloudcc":`Стиль полной страницы дает вам максмиумы экрана недвижимости для контента, который вы встраиваете в окно CloudCC.com.`,
"label.sendemail.marketactivity.invitecode":`Инквизиционный код кампании #campaignname`,
"label.block.pricing":`Ценообразование по блокам`,
"message.error.field.number.zero":`Ошибка формата длины, не может быть 0.`,
"pagecreator.systemstyle.message.save.success":`Стиль сохранен успешно`,
"pagecreator_systemstyle_label_styledesc":`Описание стиля`,
"APPIntegration_Dropbox_setting_01":`Включить`,
"label_emailtocloudcc_redmessage2":`Пожалуйста, введите правильный пароль учетной записи`,
"label.user.special.operations":`Используется только в работе, не может использоваться временно, обратитесь к администратору!`,
"pagecreator_page_label_layoutpreview":`Просмотр макета`,
"APPIntegration_Dropbox_setting_03":`Включите Dropbox, чтобы позволить вам выбирать файлы из Dropbox и добавлять их как вложения.`,
"label.sure_leave":`Вы уверены, что уедете?`,
"label.applt.copylink":`Скопировать ссылку на минипрограмму`,
"label_tabpage_allpotentialcustomers":`Все зацепки`,
"label.rulestrikedate":`Время срабатывания правила`,
"label_tabpage_justsz":`Просто`,
"label.customize.memory.function.sorting.title":`Настроить функцию сортировки моей памяти`,
"message.duplication.label.mergebutton":`Слияние`,
"chatter.group.cancelRequest":`Отменить запрос`,
"label.campaign.channel.step6.remark":`Если вы подтвердили регистрацию, нажмите кнопку "Создать" для создания страницы регистрации.`,
"label.appupload.upload.install.abort":`Отменить установку`,
"label.emailobject.proposetimes":`Предлагаемые сроки`,
"label.probability.cannot.empty":`Вы должны ввести номер в вашей возможности.`,
"vue_label_homepage_editkanban":`Эдит Канбан`,
"lable.Related.template":`Соответствующие шаблоны`,
"label.cloudccclass.list.cls.time":`Запланированные занятия`,
"component.task.label.enddate":`Дата истечения`,
"label.sendmail.step3":`Шаг 3 Обзор и подтверждение`,
"label.projectManagement.Gridview":`Вид сетки`,
"label.emailobject.time":`Время`,
"label.applt.address":`Портал обслуживания клиентов минипрограммы`,
"label.searchfield":`Поля поиска`,
"vue_label_calendar_please_enter_the_name":`Пожалуйста, введите имя`,
"label.list.userinterface.default.page.setup":`Страница по умолчанию системы`,
"label.detail.2018":`Подробности`,
"label.webtocloudcc.success":`Ваша информация была успешно предоставлена. Большое спасибо за ваше участие, мы будем служить вам от всего сердца.`,
"component_telerecord_label_title":`Записывающий телефон`,
"label.setting.sureDelete.rules":`Вы уверены, что хотите удалить это правило?`,
"vue_label_email_current_theme":`При вставке этого шаблона будет закрыта текущая тема электронного письма.`,
"lable.Order.product":`Заказать товар`,
"UG_product_02":`Продукты относятся к продуктам или услугам, которые продаются или покупаются.`,
"label.appexchange.task":`Задачи рабочего процесса`,
"label.selectprocesscondition":`Укажите условия для шага`,
"label.mobile.quickcreate.default.scan":`Сканировать`,
"label.tabpage.prepagez":`Отображение на каждой странице`,
"label.query.error":`Ошибка в запросе.`,
"label.tabularreport.2018.step1":`Шаг 1 Выберите столбцы отчета`,
"pagecreator.systemstyle.label.modifystyle":`Редактор стилей`,
"label.app.step3":`Шаг 3 Выберите источник изображения для пользовательского логотипа приложения`,
"label_tabpage_rowsz":`Удалить строки`,
"label.validate.function.funcExplain.SUBSTITUTE":`Подставляет новый_текст для старого_текста в текстовую строку. Используйте SUBSTITUTE, когда вы хотите заменить определенный текст в текстовой строке.`,
"vue_label_checkduplicate_select_data_to_merge":`Выберите данные для слияния`,
"vue_label_commonobjects_view_chart_displaymode":`Режим отображения`,
"label.industrialandcommercialverification.servicesetiings":`Сервисные настройки`,
"label.refresh":`Обновить`,
"label.taskfield":`Целевые поля`,
"label.notification.approval4":`【提交人】 просит утвердить 【对象】`,
"label.group.isusing":`Активный`,
"label.language.settings":`Настройка языка`,
"front-kefu-moudle-please-login":`Пожалуйста, сначала войдите в систему`,
"label.page.double.line.cloudcc":`2 колонки с боковой панелью CloudCC.com`,
"folder.error.delete":`1. Текущая папка содержит отчеты и не может быть удалена! 2. Текущая папка содержит скрытые отчеты и не может быть удалена! Скрытый отчет - это отчет, созданный на основе логически удаленного объекта (настройки-создание-удаление объектов под объектом), так как объект на самом деле не удален, поэтому отчет скрыт`,
"eight":`Восемь`,
"label.marketseamemset.user":`участник`,
"label.recordnum":`Номер записи`,
"page.404.button.back":`Назад к предыдущему шагу`,
"label.mobile.phone.month.plan":`Планы на следующий месяц`,
"label.marketseamemset.account.title2":`Пожалуйста, установите верхний предел на количество клиентов, которые влияют на всех членов. Лимит не связан с лидирующим пулом`,
"vue_label_chatter_current_avatar":`Текущий аватар`,
"label.mobile.side.tab.remark3":`Удерживая нажатой кнопку сдвига, нажмите или перетащите, чтобы выбрать серию соседних элементов. удерживайте кнопку ctrl и нажмите, чтобы выбрать несколько несмежных элементов.`,
"component.sendmail.label.touser":`Получатель`,
"label.homeitems.noobject":`Нет Субъектов`,
"template.report.overall.sales":`Общий период продаж (по источникам лидов)`,
"label.partner.donotdel":`не может удалить`,
"label.service.miniProgram.bindCopyDesc":`После привязки к официальному aacount или мини-программе вашей компании вы можете использовать этот адрес в качестве собственного портала обслуживания клиентов, копируя и переходя на этот адрес одним касанием.`,
"UG_Contract_01":`Управлять контрактом`,
"UG_quota_06":`Создать ценовое предложение`,
"vue_label_report_deletereport":`Удалить отчёт`,
"front-epwechat-module-v1-input-appname":`Пожалуйста, введите название приложения`,
"label_tabpage_deleteviewsuccess":`Посмотреть удалить успех`,
"component_chatter_label_mygroup":`Моя группа`,
"label.campagin.roi.leixing":`Тип кампании`,
"label.dashboard.myHomepageDashboard":`Мои Домашние приборные панели`,
"UG_solution_04":`импортное решение`,
"label.knowledge.setting.hint.four":`Активировать знания`,
"label.campaign.channel.add.field":`Нажмите кнопку, чтобы добавить поля`,
"label.eastem.european.time":`восточноевропейское время`,
"label.partner.workspace.member.partner":`Профиль партнера CloudCC`,
"label.campaignmember.main.backtocampaign":`Назад к кампаниям`,
"label.reportsSubscriptionPage.schedulereport.monthly.time.absolute":`Абсолютный`,
"label.task.unsolve":`Все Открытые Задачи`,
"label.multilang.chatterservice.vote":`{0} билет(ы)`,
"label.console":`Консоль`,
"label.emailsync.message1":`Если вы отмените соединение, вы не сможете синхронизировать содержимое почтового ящика с выводами и контактами, вы уверены, что хотите отменить?`,
"pagecreator.systemstyle.label.stylename":`Имя стиля`,
"setup_mainpage_label_welcome16":`Инструкции: Щелкните по меню в левой части страницы → Настройки приложения → Создать → Схема работы, Процесс утверждения, Задачи, Уведомление по электронной почте, Обновление полей и многое другое.`,
"message.duplication.label.editfilterule":`Поиск дублирующих правил фильтрации`,
"Account.News.Setting.004":`Включить новости`,
"label_tabpage_saveviewsuccess":`Просмотр успешно сохранен`,
"label.forecast.forehistory.replacecommit":`Обязательная отмена`,
"pagecreator_button_cancel":`Отменить`,
"label.knowledge.article.nomatch":`Невозможно архивировать эту статью для связанного с ней черновика. Пожалуйста, удалите черновик и повторите попытку.`,
"vue_label_combined_field":`Нет полей для суммирования.`,
"label.batchadd.save.prompt":`запись(и)`,
"label.tabpage.summaryway":`Резюме`,
"label.check.input.condition.two":`SQL не поддерживается`,
"mail.apiCode.notOnly":`Единственное имя уже существует`,
"UG.quota.01":`Управление котировками счетов`,
"label.approved.receiveApprovalEmail.option3":`Только если я буду делегированным уполномоченным лицом.`,
"label.stdashbord.xsld.business.img5":`Итого Сумма вероятности 0%`,
"vue_label_chat_movedfromto":`Переехал из старого поля в новое.`,
"label.customfields.new.step2.opration":`Общие параметры`,
"label.dashboardSetup.isurl":`Добавить ссылки`,
"label.forecast.settings.mrfwqj":`Цикл прогнозирования`,
"label.campaign.channel.field":`Поля`,
"label.weixin.optionthree":`Выбор 3`,
"label.safetystatement":`Заявление о безопасности`,
"label.useskipwizard":`Использовать мастер запуска прыжков`,
"label.projectManagement.completion":`Статус завершения`,
"label.customfields.fielddependency.new.step2":`<b>Стап 2: </b> На следующей странице отредактируйте правила фильтрации, которые контролируют значения, появляющиеся в зависимом поле для каждого значения в контрольном поле.`,
"setup.mainpage.label.welcome8":`Настройка перетаскиваемого интерфейса`,
"label.emailobject.list.outbox":`Исходящий`,
"label.app.default.login.tab":`Вход по умолчанию`,
"label.follow_emails":`Последующая электронная почта  это отличный способ быстро и легко связаться с посетителями после отправки ими форм.`,
"vue_label_homepage_application_page":`Главная страница приложения`,
"label.confirm.template":`Подтвердить`,
"lable.product.not":`Невозможно полностью удалить`,
"label.multilang.feedtrack.dispalyinfo":`Вы можете выбрать максимальное количество полей {0}:`,
"label.weixin.plz.inputsrhkey":`Пожалуйста, введите ключевое слово для поиска`,
"label.projectManagement.service.appointment":`Назначение услуги`,
"label.list.userinterface.watermark.enable":`Включение водяных знаков на главной странице, просмотрах, подробных страницах, отчетах и приборных панелях на ПК и мобильном приложении.`,
"label.confirmDelete":`Вы уверены, что хотите удалить эти данные?`,
"label.sso.description":`Пользователи могут получить доступ к системе CloudCC.com без входа в систему в соответствии с именем пользователя и кодом авторизации.<br>При нажатии на URL ниже вы получите доступ к системе CloudCC.com: _COPY7@dev.com&authCode=dcc5c192facd7c08e124fbe93d8950b9 .<br>Пользуйтесь ссылками выше, 'http://localhost:8080' замените, пожалуйста, доступ вашей организации на ссылку. 'admin@dev.com' замените, пожалуйста, ваше имя пользователя organization.<br>'dcc5c192facd7c08e124fbe93d8950b9' замените, пожалуйста, ваш код авторизации организации.`,
"errormessage_email_atleastonereceiver_z":`Вы должны выбрать или отредактировать адрес получения.`,
"C":`Прокатный итог`,
"label.service.major.event.edit":`Редактирование вехи`,
"label.icon.9":`Сервис`,
"label.visualpage.notvalidate.check":`Недействительные пользовательские страницы, пожалуйста, обратитесь к Справочному тексту, чтобы проверить страницу.`,
"label.audit.todo.from":`с`,
"label.directboss":`Эта роль отчитывается перед`,
"label.manageAll.selpage":`Страница`,
"label.console.step6.all":`Полный экран, неисправленные и списки отображаются только при выборе вкладки навигации.`,
"vue_label_pool_expiredate":`Дата истечения`,
"lable.no.matching.record":`Нет соответствующей записи`,
"label.standard.redirecterror":`Перейти на пользовательскую страницу через стандартные кнопки не удалось.`,
"label.Platform.Setting":`Настройки платформы`,
"lable.outlook.edit.havenewc":`Контакты с недавно созданными мероприятиями`,
"label.partnerCloud.partnerAccount.choosePayment":`Пожалуйста, выберите способ оплаты`,
"label.weixin.optionsix":`Выбор 6`,
"lable.SalesCommitmentKanBan.allCommitments":`Трубопровод`,
"page_404_button_toknowmore":`Узнать больше`,
"label.customfields.number.tip":`Позволяет пользователям вводить любой номер. Ведущие нули удаляются.`,
"label.import.index.processimport":`Импорт`,
"label.quote.phone":`Телефон`,
"label.insert.approval":`Вставить утверждение`,
"label.tabpage.printview":`Вид на печать`,
"lable.product.price":`Цена`,
"front-kefu-moudle-call-detail":`Подробности по телефону`,
"label.umeng.approval.apply":`применяться`,
"label.background.the.form":`Фон формы`,
"chatter.f":`Писатели`,
"label.quickbooks.searchresault.company":`Компания`,
"vue_label_systemSettings_platformutils":`Инструмент платформы`,
"front-quotation-v1-nofilles-tocreate":`Пожалуйста, нажмите кнопку Generate Quote и отправьте после генерации.`,
"label.category.6":`Медицинское лечение`,
"label.attendance.choose.positon":`Выберите Достопримечательности`,
"label.batchadd.newbatchpage.save.pho":`Недействительный формат телефона`,
"UG.Account.01":`Кто ваш аккаунт?`,
"label.marketseamemset.addspecialuser":`Добавить специальных членов`,
"label.query.detail.forbidpartneruser":`Пользователь Forbid-партнера`,
"label.stdashbord.xsld.business.ydzhl":`Скорость выигрыша`,
"vue_label_SMS_mymessagebox":`Мой ящик для сообщений`,
"label.knowledgebase.data.publishing.failed":`Опубликовать данные {a} не удалось. Пожалуйста, выберите для публикации статью со статусом, равным Черновик.`,
"label.wholestate":`Общее состояние`,
"label.selectedline":`Выбранные колонки`,
"label.validate.function.funcExplain.LEFT":`Возвращает заданное количество символов из начала текстовой строки`,
"label.emailmerge.edittemplate.detail":`Детали шаблона почтового объединения`,
"vue_label_checkduplicate_checkduplicate":`Дубликат проверки`,
"label.knowledgebase.assign.articles":`Статьи по ассигнованиям`,
"label.tabpage.recordsz":`Запись`,
"label.field.img.validate.error":`Имя переменной после $User неправильно написано или ссылка на $User нелегальная, пожалуйста, проверьте орфографию.`,
"workorderlineitem.worktype.isnot.father.worktype":`Должен быть выбран тип работы, связанный с родительской записью этого элемента рабочего заказа.`,
"label.ccchat.group.name.noexist":`Имя группы, которую вы ввели, не существует, пожалуйста, введите его заново.`,
"label.weixin.sign.type":`Ошибка при входе (выходе) в систему.`,
"label.nowvaluereplace":`Заменить на Существующие`,
"report_label_report":`Доклады`,
"label.knowledge.setting.plus":`Плюс настройки знаний`,
"label.event.moveup.2day":`2 дня вперёд`,
"label.translation.start":`Чтобы начать работу в Translation Workbench:`,
"lable.PowerProcess.created.time":`На основе времени создания {detailInterestType}`,
"label.ems.step2":`Шаг 2`,
"label.tabpage.groupingemptyz":`Пункты группировки не могут быть пустыми`,
"pagecreator.layout.button.new":`Новая компоновка`,
"label.tabpage.listshow":`Список показывает`,
"label.partnerCloud.productSet.optionName":`Название варианта`,
"label.service.without.cycle":`Без цикла`,
"label.chatter.sendEmailToGroupMember.subject.V":`{0} опубликовал голоса за всех в {1}`,
"label_target_model_dimension":`Размер целевой модели`,
"component.task.label.subject":`Тема`,
"label.custom.field.login.query.information":`Пожалуйста, войдите в систему и просмотрите детали.`,
"label.validate.function.funcExplain.NOT":`Изменить FALSE на TRUE или изменить TRUE на FALSE`,
"pagecreator_layout_button_horizontal":`Боковая разборка`,
"lable.Returned.to.successful":`Успешное возвращение`,
"label.campaign.channel.ticket.title":`Входной билет`,
"label.ruleName.supportMaximum.50Characters":`Для названия правил поддерживается максимум 50 символов.`,
"label.email.track.attachment.size.control1":`Общий размер приставки превышает 20 м, не может быть загружен`,
"template.report.folder.opportunities":`Анализ возможностей`,
"label.knowledge.setting.data.eight":`Вы собираетесь удалить группу категорий {flzmc} и ее категории. Эта категория будет недоступна для присвоения записям. У вас есть 15 дней, чтобы отменить удаление группы категорий. По истечении 15 дней она будет удалена навсегда и не сможет быть восстановлена. Вы уверены, что хотите удалить эту группу категорий и ее категории?`,
"mail.id.notNull":`ID не может быть пустым при удалении шаблона`,
"vue_label_normal_product_sf":`Продукт`,
"vue_label_report_superiortothisrelationship":`Отношения между вышестоящим объектом и этим объектом`,
"label.leadscore.operation":`Оператор`,
"label.customfields.formula.percentexample":`Скидка = (Сумма - Скидка_Скидка__в) / Сумма`,
"component.setup.iframe.label.inputurlmemo":`Пожалуйста, введите URL-адрес импортируемой страницы`,
"label.icon.177":`Логотип`,
"label.tabpage.myz":`My`,
"label.leadmarketsea.add.title":`Создать свинцовый бассейн`,
"label.partnerCloud.partnerAccount.thePage":`Страница {skippageNum}`,
"label.visualpage.some.size":`Емкость кода: максимальная поддержка 300KB символов, приблизительно 300 000 байт.`,
"label.setwxpay.null":`Необходимая информация для настройки оплаты WeChat пуста.`,
"label.icon.74":`Станок`,
"font-evaluate-module-v1-evbad":`Тип оценки  Негативная`,
"System.TimeField.Format.Warning":`недействительное время`,
"label.captcha":`Код случайной верификации`,
"label.payment.assessment":`Ознакомьтесь с другими изданиями`,
"message.error.not.taskevent":`Объект нестандартного события`,
"font-evaluate-module-v1-evaluation":`Оценка`,
"vue_label_commonobject_view_updatedago":`Обновлено {таймИнтервал} назад.`,
"label.sendemail.birthday.newevent":`Дорогой {!ownerName}：\r\n {!objectLable} {!recordName} день рождения будет через 3 дня. aware！\r\n {!orgName}`,
"label.laststep":`Предыдущий шаг`,
"message.duplication.label.matchoption":`Соответствующий вариант`,
"label.setupmultplerecordtype":`Типы множественных записей`,
"vue_label_account_unprocessed_oppprtunities":`Неиспользованные возможности`,
"KeyInformationLayout.DefaultLayout.Name":`По умолчанию системы`,
"label.partner.all":`Все партерное облако`,
"label.datamanage.export.error":`Экспорт не состоялся`,
"label.standard.buttonandlink":`Стандартная кнопка или ссылка`,
"label.reportsSubscriptionPage.email":`Отчёт по электронной почте`,
"message.nogrammarfaultinformula":`Никаких синтаксических ошибок.`,
"front-kefu-moudle-nofind-instance":`Экземпляр не найден`,
"label.is.delete.data":`Записи, которые вы хотите удалить, содержат запрос на утверждение, вы уверены, что хотите удалить?`,
"label.partner.error":`Ошибка: ошибка формата домена`,
"label.notification.time2":`{0} минут назад`,
"label.ccchat.person.invite.needfirstname":`Введите ваше имя`,
"label.mr.title.URL":`URL-АДРЕС`,
"chatter.norecord":`Никаких записей.`,
"label.readwrite":`Чтение/Письмо`,
"label.partnerCloud.orderingPlatform.orderPayment":`Оплата заказа`,
"label.accesslimittype":`Уровень доступа`,
"label.preciew_tab":`Ссылка для предварительного просмотра в новой вкладке`,
"label.attachment":`Приложение`,
"label_tabpage_helpNavigationz":`Помощь и навигация`,
"label.dataimport.select":`Проверьте эту информацию, выполните импорт данных`,
"chatter.en.info":`Введите информацию, чтобы люди могли узнать о вас больше.`,
"label.ccservice.validate.date":`Формат соответствующего значения {2} поля {1} под API объекта {0} некорректен. Пожалуйста, введите правильный формат даты или времени!`,
"label.social.posts.send":`Не удалось отправить сообщение`,
"label.emailobject.time.to":`За:`,
"label.defineReportStep1":`Шаг 1`,
"savefail":`Сохранить не удалось`,
"label.mr.descreption.title":`Объединить дубликаты данных`,
"label.share.info.by":`По адресу`,
"label.list":`Список`,
"label.event.select":`Избранный`,
"message.accountmap.cannotfind":`Адрес аккаунта не удалось найти, пожалуйста, обновите адрес аккаунта.`,
"label.choosefield":`Утверждение Поля стр.`,
"label.forecast.settings.title":`Прогнозы Настройки`,
"label.setup.log.datetime":`Скачать журнал поведения в пределах диапазона времени поиска (Excel.xls)`,
"button_partner_new":`Новое облако партнёра`,
"label.umeng.approval.dlsp.reject":`#approvalname отклонил запрос #actorname''s approval request of #objAPIName # recordname for you.`,
"label.tabpage.totalTeamz":`Всего групп`,
"label.lead.score.prompt3":`Это может занять несколько минут. You получит подтверждение по электронной почте после завершения.`,
"label.schedulejob.setup.schedule.name":`Имя работы`,
"vue_label_report_advanced":`Когда расширенный фильтр включен, вручную запишите условие фильтрации в поле расширенного фильтра ниже, формат показан на рисунке.`,
"label.emailsync.form.connecttime":`Связанное с этим время`,
"front-gantt-module-v1-project-status":`Статус проекта`,
"label.field.for.example":`Например`,
"label.marketsea.manager.notnull":`Администратор не может быть пустым.`,
"label.click.here":`&lt&lt Нажмите здесь, чтобы вернуться`,
"UG.solution.04":`импортное решение`,
"label.validate.function.funcExplain.IF":`Верно условие или нет, и если условие TRUE возвращает одно значение, а условие FALSE, то возвращается другое значение.`,
"label.profile.settab":`Настройки вкладки`,
"front-email-payment-weichat-tips":`Сканирование QRкода для оплаты`,
"label.task.next.week":`следующая неделя`,
"label.operatedata.selectobjectfields.tip":`Выберите поля, которые вы хотите экспортировать, и вы должны выбрать, по крайней мере, в поле для экспорта.<font color="red">Attention:Text Area(Rich) can be export.</font>.`,
"label.recalculate.alert":`Пожалуйста, выберите правило совместного использования, которое вы хотите пересчитать.`,
"label.marketsea.noopportunitydays":`Дни без создания возможностей для бизнеса (должно быть больше, чем количество дней без последующих действий после получения)`,
"label.chat.likeperson":` Лицо (лица)`,
"label.selectedFields":`Доступные поля`,
"label.App":`Приложения`,
"label.file.type":`Тип файла`,
"permissionService.error1":`Недостаточная лицензия на применение.`,
"front-detail-module-v1-chart-display":`Отображение диаграммы`,
"label.audit.status":`Состояние утверждения`,
"UG.activity.05":`Записывающий телефон`,
"label.connectOtherObject":`( Нажмите, чтобы связать другой объект )`,
"lable.currencyManage.unEnabledadvcurrency":`Отключить расширенное управление валютой`,
"label.ccpeak.getthree.function":`Есть три функции, и`,
"label.weixin.new.weitoupiao":`Пожалуйста, создайте новое микро голосование, пользователи могут участвовать в голосовании и получать доступ к результатам голосования в микро мероприятиях на WeChat.`,
"label.tag.manage.prompt":`Тег уже exsits！`,
"label.goon":`Продолжить работу по адресу .`,
"label.addworkflowoperate":`Добавить рабочий процесс Действие`,
"label.weixin.click.search":`Нажмите, чтобы найти запись`,
"vue_label_report_deletecolumn":`Столбец "Удалить`,
"label.ordercondition":`Сортировать по`,
"message.error.group.notallow":`Группа не разрешает архивирование`,
"label.unread":`Непрочитанные письма`,
"vue_label_report_notice_namerequired":`Требуется название колонки`,
"label.tabpage.entercontent":`Пожалуйста, введите содержание`,
"label.schedulejob.setup.schedule.startdate":`Дата начала`,
"component_assistant_button_newtask":`Новая задача`,
"vue_label_report_notice_filter1":`При включении расширенного фильтра(ов) необходимо вручную заполнить его(их), как показано на рисунке.`,
"value":`Значения`,
"label.icon.70":`Сервис`,
"label.knowledgebase.delete.draft.t":`Удалить черновик`,
"label.setup.mini.bind":`Связывание мини-программ`,
"component_timeline_button_more":`Больше шагов`,
"label_emailtocloudcc_redmessage4":`Пожалуйста, введите данные о порте`,
"label.field.input.number":`Пожалуйста, введите действительные номера`,
"front-invoice-online-payment-setup-title":`Начать онлайноплату`,
"front-kefu-moudle-called-user":`Призванный человек`,
"label.currency.disable":`Неактивные валюты`,
"label.user.alias":`Псевдоним`,
"UG_quota_04":`Печатное предложение`,
"label.chatter.delete":`Удалить`,
"label.addtocurrentcustomer":`Прикрепленные к существующим счетам`,
"message.error.recordid.null":`Запись не может быть пустой!`,
"label.merge.records":`Слияние рекордов`,
"report_label_norole":`У вас нет разрешения на это, пожалуйста, свяжитесь с вашим администратором.`,
"label.pqrs":`.`,
"label.email.attach.button":`Нажмите кнопку "прикрепить"`,
"label.tabpage.selrecordtypez":`Выберите тип записи`,
"label.ServiceCloud.purchase.date":`Дата покупки`,
"label.customreporttype.delete.prompt":`Пожалуйста, удалите следующий отчет перед прерыванием операции удаления`,
"label.brief.total.page":`Всего {общее} страница(ы)`,
"label.reportsSubscription.unsubscribe":`Отписаться от рассылки`,
"label.ccpeak.take.notice.exp.order":`Примечания: должно быть добавлено "__c" после имени API полей в exp и условий заказа.`,
"report_type_label_quote":`Цитаты`,
"label.file.norecord":`Нет элементов для отображения`,
"vue_label_checkduplicate_all_processed":`Все данные обработаны`,
"label.next":`Следующий`,
"label.icon.10":`Папка`,
"label.lanxin.title.setting":`Интегрированная информация`,
"label.h5.chatter.business":`Связанные возможности`,
"lable.are.you.sure.to.delete.this.view":`Хотите ли вы удалить это представление?`,
"vue_group_no_operation_permission":`Нет разрешения на эксплуатацию!`,
"label.knowledge.archive.article":`Архивная статья`,
"vue_label_lead_":`Нет активных правил скоринга, обращайтесь к системному администратору.`,
"label.fiscal.error.between":`Дата начала или окончания финансового года находится между историческими финансовыми годами, пожалуйста, проверьте и сбросьте их.`,
"label.stdashbord.xsld.business.qdzje":`Итого Сумма (Закрытые возможности)`,
"label.calendar.day.view":`Дневной вид`,
"label.emailtocloudcc.tip":`Симптома`,
"label.schedulejob.setup.schedule.st1":`1-ый`,
"label_tabpage_addtoworkbench":`Добавить на домашнюю страницу верстак`,
"label.umeng.approval.waitapproval":`разрешение на ожидание`,
"label.justcheckingwebsite":`Проверять только веб-сайт`,
"homepage.components":`Главная страница Компоненты`,
"label.audit.remark":`Примечания к утверждению`,
"label.searchs.labelname":`Поиск {fieldlabelName}`,
"label.remarkofreport":`Примечание к докладу`,
"label.weixin.isno":`ли`,
"label.currencyCode":`Код валюты`,
"label.service.resources":`Ресурсы`,
"label.clone_form":`Форма клона`,
"label.weixin.view.information":`Посмотреть Подробнее`,
"UG_activity_05":`Записывающий телефон`,
"chatter.feed.menutype.user.recentuser":`Люди, которые недавно смотрели`,
"label.marketsea.notfollowdays2":`Дни без последующих действий`,
"label.tabpage.namemandatory":`Требуется название вида`,
"message.demo.nosupport":`Эта функция будет развернута в следующем релизе.`,
"label.mail.merge.template":`Объединение шаблонов электронной почты......`,
"label.sendemail.marketactivity.sign":`Уведомление о знаке кампании`,
"setup_layout_group_relatedlist":`Связанные с ними списки`,
"label.pc.ui.2018.all.tabs":`Все меню`,
"label.field.lost.right.bracket":`Закрытый кронштейн потерян`,
"label.datamanage.contact.novalue":`Примечание: Поле имени контакта является нулевым, записи контактов не будут импортированы.`,
"label.version.unlimited.edition":`Неограниченное издание`,
"vue_label_dashboard_selectsortfield":`Пожалуйста, выберите поле сортировки`,
"label.partnerCloud.productSet.instructions":`Вы можете установить иерархию для семейства продуктов. Отфильтруйте иерархию для просмотра при добавлении продуктов в соответствии с функциями. Можно установить максимум 10 уровней.`,
"front-kefu-moudle-v1-canuse-obj":`Видимый для`,
"thursday":`четверг`,
"label.nextapprover":`Следующий подходящий`,
"setup_mainpage_label_manageuser":`Управление пользователями`,
"label.saveandcontinue":`Сохранить`,
"label.top.userCenter":`персональный центр`,
"component.chatter.file.button.save":`Опубликовать`,
"label_emailsync_setting":`Персональные настройки электронной почты`,
"label.usableshareuser":`Available Shared To`,
"label.customfields.optionlist.fieldvaluelist.letterrank":`Отображать значения в алфавитном порядке, а не в введенном порядке.`,
"label.list.button":`Назначение профиля`,
"chatter.up.m":`Ошибка:Загруженные файлы слишком большие.Максимальный размер файла 20 Мб.`,
"label.knowledgebase.filters":`{а} фильтры`,
"label.sso.saml.sp.idtype.username":`Уведомление содержит имя пользователя CloudCC`,
"vue_label_file_size_limit":`Размер файла не превышает {размер}Мб.`,
"label.appupload.install.error.choice4":`Пропустить конфликтующие компоненты, не устанавливать конфликтующие компоненты`,
"label.currencyDecimalDigits":`десятичные знаки`,
"label.weixin.customer.details":`Детали счета`,
"component.timeline.label.7daysahead":`7 дней до`,
"label.sendsms.batch.step1":`Шаг 1 Укажите получателей для включения`,
"label.brief.opportunity1":`Возможности`,
"label.datamanage.click.importbutton":`Нажмите <b>Импорт</b> и данные будут импортированы в систему CloudCC.`,
"label_filter_benchmark_objects":`Объект отсчета фильтров`,
"label.area.record.notexist":`Запись не существует.`,
"label.event.overdue.unfinished":`Просроченные события`,
"label.file.publicview.errortype":`Тип файла не поддерживает предварительный просмотр`,
"label.setup.mobile.bottombutton.profile.setting":`Настройка нижнего меню профиля`,
"label.campaignmember.main.addleaddesc":`Добавьте все существующие проводки к этой кампании`,
"vue_label_approve_actual_operator":`Фактический оператор`,
"label.version.essential":`существенное издание`,
"lable.SalesCommitmentKanBan.commitments":`Трубопровод`,
"label.chatter.pastEvents":`Прошлая деятельность`,
"vue_label_calendar_choose_calendar_type":`Выберите тип календаря`,
"label.service.dispatchingUnits.batch.send":`Пакетное назначение`,
"chatter.poll.option8":`Выбор 8`,
"label_tabpage_summaryway":`Метод суммирования`,
"front-kefu-moudle-trindex-copy-num":`Пожалуйста, скопируйте номер предприятия на главной странице системы Tianrun`,
"lable.quote.syncing.syncfinish":`Sync Completed`,
"label.home.task.finish":`Выполненная задача`,
"label.toleadfield":`Свинцовые поля карты`,
"label.everyone":`Все`,
"label.multilang.databatchadd.success":`{0} данные добавлены успешно：`,
"label.quote.createdate":`Создать дату`,
"email.template.nopermission":`Только администраторы могут редактировать шаблоны в этой папке`,
"label.report.action.addtodashboard2":`Добавить Приборную панель`,
"label.campaign.name":`Название кампании`,
"label.check.input.condition":`Ошибка синтаксиса, пожалуйста, проверьте критерии фильтрации, которые вы ввели.`,
"front-epwechat-module-v1-upload-file":`Загрузите кредитный документ:`,
"label.batchadd.newbatchpage.button.add":`Добавить строку`,
"label.partnerCloud.footer":`Нижний колонтитул`,
"lable.Enter.template.name":`Пожалуйста, введите название тамплина.`,
"label_tabpage_last":`Последний шаг`,
"label.setup.mobile.bottombutton.setting":`Настройки страницы первого уровня мобильного приложения`,
"label_emailtocloudcc_filed_emailto":`Отправить по электронной почте`,
"label.data.downpage.e_title.num3":`3. Users может создавать экспортные шаблоны в соответствии со своими потребностями и выбрать пункт "Экспорт по шаблону", что может сделать экспортную операцию более удобной.`,
"startwith":`начинаться с`,
"vue_label_normal_cancel":`Отменить`,
"label.reportTypcrtD":`Связанный объект (d), пожалуйста, нажмите, чтобы выбрать связанный объект`,
"label.globalselect.disabledvalue":`Недействительная стоимость`,
"vue_label_commonobjects_view_notice_deletecertification":`Вы уверены, что хотите удалить выбранную(ые) запись(ы) { selectNum }?`,
"front-epwechat-module-v1-bound-role":`Связанные роли`,
"label.partnerCloud.financeSetting.gaofilter":`Условия фильтрации (например, 1 и 2 или 3)`,
"label.quote.sprname":`Имя для выставления счёта`,
"lable.asset.successfully":`Успешно перевести продукт в актив.`,
"label.projectManagement.service.appointment.work.noedit":`Невозможно отредактировать трудовой стаж при приеме на работу`,
"lable.tianyancha.h5.inputandsearch":`Введите ключевые слова для поиска по релевантным компаниям`,
"label.customcomponent.check.tag.firstrow":`Первая строка должна быть`,
"label.knowledgebase.published.translations":`Опубликованные переводы также будут архивироваться, а перевод в статусе "Черновик" будет удален.`,
"vue_label_wang_yi":`Том`,
"label.step3.total3":`Шаг 3 из 3`,
"label.stdashbord.xsld.business.img6":`Суммарное количество случайных стадий с вероятностью 100%/(Суммарное количество случайных стадий с вероятностью 100% Суммарное количество случайных стадий с вероятностью 0%)`,
"component_button_cancel":`Отменить`,
"label.delete.false.not.exists":`Удалить не удалось, потому что данных не существует.`,
"label.appupload.install.error.choice1":`Пожалуйста, не устанавливайте`,
"label.Days.After.Horizontal.Date":`дата уровня после`,
"setup_layout_button_additem":`Добавить выбранные пункты`,
"UG.contact.05":`Создать контакт`,
"label.form.title":`Название формы`,
"label.horizontalbar-group":`Горизонтальная группировка гребных линий`,
"component_sendmail_label_title":`Отправить электронное сообщение`,
"label.passwordPolicy.setup.neverexpires":`Никогда не истекает`,
"label.sso.saml.idp.config.desc1":`Включите CloudCC.com в качестве поставщика идентификационных данных, чтобы вы могли использовать единую регистрацию с другими веб-сайтами.`,
"label.chat.topic.desc.null":`Узнать кое-какую информацию по этой теме? В раскрывающемся меню в правом верхнем углу выберите пункт "Редактировать информацию".`,
"label.movablecustomerfield":`Древние пользовательские поля`,
"label.trigger.folder":`Нефильтрованные триггерные папки`,
"label.selectuploadfile":`Пожалуйста, выберите файл для загрузки.`,
"front-email-payment-card-tips":`Пожалуйста, введите номер карты`,
"label.tabpage.addcondition":`Добавить условие`,
"label.number.MinAndMaxCheck":`Минимальное значение {0} равно {1}, максимальное  {2}. Пожалуйста, измените количество и сохраните изменения.`,
"vue_label_dashboard_dashboard":`Успешно переименованная приборная панель`,
"label.objectDeleteList":`Удалить список объектов`,
"lable.service.gantt.and":`И`,
"label.emailtocloudcc.step2":`Шаг 2`,
"label.chatter.postup":`Post Up`,
"label.personalsetting":`Персональные настройки`,
"message.please.choose.permission":`Пожалуйста, выберите доступ`,
"label.mobile.move":`Мобильное приложение`,
"label.Choose":`Выбор`,
"label_chatter_vote":`Опрос`,
"label.weixin.user.select.one":`Выберите пользователя`,
"pagecreator.page.label.modifypage":`Редактор страниц`,
"label.select.partOrField":`Выберите разделы или поля для управления`,
"vue_label_helpcenter_chat":`1. Мгновенный обмен сообщениями<br> Команда может заменить корпоративный WeChat и т.д., позволяя отправлять текстовые сообщения, файлы и т.д. коллегам компании во время работы в CRM-системе. Когда каждому отделу организации необходимо создать отдельную дискуссионную группу, руководитель отдела может инициировать групповой чат в команде и добавить сотрудников отдела в групповой чат.<br> 2. Создать групповой чат для клиентов и записей о бизнес-возможностях<br> Откройте страницу с деталями записи о клиенте или бизнес-возможности и нажмите кнопку "Команда" в правом верхнем углу, чтобы создать групповой чат о данной записи в команде. Если групповой чат не создан владельцем записи, то владелец записи также будет автоматически подключен к групповому чату. Другие могут войти в групповой чат, нажав на кнопку "Команда" в правом верхнем углу страницы деталей записи или после добавления владельцем группы.<br> 3. Отслеживать записи в групповом чате<br> Создать групповой чат для клиентов и записей бизнес-возможностей в соответствии с методом в 4.2, и вы можете отслеживать динамику записей в групповом чате, отправляя карточки. Если у пользователя есть доступ к просмотру записей на карте, то при нажатии на карту он может сразу перейти на страницу с подробной информацией о соответствующем объекте.<br>Отслеживать изменения поля записи в групповом чате<br> Когда запись настроена со списком "Отслеживание полей" и настроены поля, которые необходимо отслеживать, при изменении отслеживаемого поля ассистент групповой стратегии в групповом чате отправит карточку с информацией об изменении поля в группу .<br> Следите за всеми изменениями в групповых чатах<br> При изменении владельца записи, ассистент групповой стратегии в групповом чате отправит карточку с информацией об изменении владельца в группу.<br>Отслеживать деятельность в групповом чате<br> После создания группового чата записи, если создается новое задание или событие об этой записи, ассистент групповой стратегии в групповом чате отправит карточку с основной информацией о задании или событии в группу.<br> Отследить и записать новую запись связанного списка в групповом чате<br> После создания группового чата, при добавлении записи связанного списка, ассистент группы в групповом чате отправит карточку с основной информацией о только что добавленной записи в группу. Например: при добавлении нового контакта в контактный список записей клиентов, в групповом чате клиентов будет получена карточка "Новый контакт", а основная информация о новой записи будет видна на карточке.`,
"label.tianyancha.business":`Регистрационная информация для бизнеса`,
"chatter.group.groupMembersToFind":`Поиск членов группы`,
"label.pc.ui.2018.pin.top":`Пин к вершине`,
"label.forecast.forehistory.submitor":`Представлено`,
"vue_label_email_send_emails_separately":`Успешно отправлять электронные письма`,
"vue_label_homepage_select_display_field":`Выбрать поле`,
"label.partnerCloud.partnerAccount.accountBalance":`Баланс`,
"label.sendemail.template":`Выберите Шаблон электронной почты`,
"label.service.violated":`Нарушено`,
"label.manageAll.title":`Центр утверждения`,
"label.forecast.settings.qy":`Включить совместное использование прогнозов`,
"label.detailofshare":`Совместное использование правил Подробности`,
"label.multilang.passwordpolicy.chechlength":`Ошибка: Пароль должен быть не менее {0} символов:`,
"label.visualpage.filesave.error":`Сохраненный файл не удался, пожалуйста, попробуйте еще раз.`,
"vue_label_campaign_please_select_member_status":`Пожалуйста, выберите статус члена`,
"homepage.components.sort":`Заказать компоненты`,
"label.brief.thismonth":`Этот месяц`,
"label_emailsync_connectaccount_description":`Добавьте сюда свой личный почтовый ящик, и CloudCC будет автоматически сопоставлять провода и контакты в системе в соответствии с их электронными адресами, синхронизировать содержимое электронной почты с записями для облегчения отслеживания и связи.`,
"label.sms.csid":`Номер подписи`,
"label.ccdocument.remark":`Описание документа`,
"label.forecast.customforecast.disdw":`Устройство отображения`,
"label_tabpage_field":`Поле`,
"label.logintime.all":`Весь день`,
"UG_Account_06":`Создать аккаунт`,
"label.login":`Вход`,
"label.dupicate.data.error":`Найдите дубликаты записей и ошибку слияния, пожалуйста, проверьте.`,
"label.monitorsys.recent.logs":`По умолчанию отображаются последние 200 журналов.`,
"message.chooseatleastonefield":`Выберите хотя бы одно поле`,
"lable.PowerProcess.name1":`Название процесса получения прав`,
"label.processdetail":`Определение процесса Детали`,
"label.upload.file.size.limit":`Загружаемые файлы не должны превышать 2 МБ!`,
"label.forecast.userenablepage.desc":`Пользователи, включенные для Прогнозов, появляются в списке Разрешенные пользователи. Чтобы включить доступных пользователей, добавьте их в список Разрешенных пользователей. Чтобы отключить пользователей, удалите их.`,
"label.visualpage.type.detailembed":`Инструкция по использованию пользовательской страницы (стиль страницы - "detailEmbed").`,
"label.textmessage.vonage.configurations":`Конфигурации`,
"label.report.select.chart.and.item":`Выберите график и выделенный элемент`,
"label.data.downpage.i.title.num1":`1、Система поддерживает только общий формат CSV.`,
"label.mobileapp.scansetting":`Настройки сканирования мобильных приложений`,
"chatter.emailFollow":`Следите за`,
"label.weixin.businformation":`Детали автомобиля`,
"label.import.index.recentrecord":`Недавний рекорд импорта`,
"label.case.update":`Обновление`,
"label.isEnableVisualpage.new.desc":`Выберите доступную пользовательскую страницу из раздела Доступные пользовательские страницы и добавьте ее в раздел Выбранные пользовательские страницы, нажмите кнопку Сохранить. После этого пользователи с этим профилем получат доступ к активным пользовательским страницам.`,
"label.emailobject.wizard.title":`Подключить вашу электронную почту`,
"vue_label_ccchat_notice_deletepostsuccess":`Успешно удаленное сообщение`,
"label.deleteQuoteLine":`Удалить строку цитаты`,
"label.integrations.export.failed.Mailchimp":`Экспорт не удался, пожалуйста, проверьте подключение к сети и повторите попытку позже`,
"label.increase":` Плюс`,
"label.setup.mobile.homepageshortcuts.setunable":`Модуль не отображается на главной странице`,
"label.ccchat.person.invite.toolong":`Нельзя вводить текст, превышающий 255 символов`,
"label.knowledge.setting.help":`Помощь по самообслуживанию клиентов`,
"label.is_pigeonhole":`Архив`,
"message.atleastonecommitter":`По крайней мере, один представленный кем`,
"label.emailobject.wizard.desc4":`Вставить время предложения, чтобы облегчить назначение для нескольких человек`,
"APPIntegration_Dropbox_setting_02":`Инвалид`,
"template.report.open.opportunities":`Незакрытые возможности`,
"label.goonwork":`Продолжать работу`,
"label.isiands.time":`время Исианд`,
"label.enable.rules.enableOnlyOneqrcodeOrbarcode":`Включенные правила (каждый объект поддерживает только один QR-код или штрих-код)`,
"label.summaryreport.2018.step2":`Шаг 2 Обобщить информацию по:`,
"pagecreator.systemstyle.message.delete.success":`Стиль удален успешно`,
"label.standarduser":`Стандартные пользователи`,
"label.reportsSubscription.succeeded":`Отчет о подписке успешно отправлен!`,
"lable.Select.a.template":`Выберите существующий шаблон в качестве основы для нового шаблона.`,
"label.file.library.addfile2libsuccess":`{0}файл(ы) загружен!`,
"label.searchfield.instruction":`Поле поиска - это поле, которое используется для глобального поиска или поиска одного объекта. Если по умолчанию оно не выбрано, поиск по выбранному полю результатов поиска - это выбранные поля результатов поиска.`,
"U":`URL-АДРЕС`,
"label.Time.slot.overlap":`Один или несколько временных интервалов имеют перекрывающиеся временные диапазоны. Пожалуйста, обновите временной интервал, который не перекрывается.`,
"vue_label_chat_opportunity_details":`Подробности о возможностях`,
"label.knowledge.category.hint.seven":`Выбранная группа категорий`,
"label.chatter.list":`Список`,
"front-email-payment-Invoice-preview":`Предварительный просмотр счетафактуры`,
"label_emailsync_message1":`Если вы отмените соединение, вы не сможете синхронизировать содержимое почтового ящика с выводами и контактами, вы уверены, что хотите отменить?`,
"label.summaryreport.step5":`Шаг 5 Укажите порядок столбцов в отчете`,
"component_newrecords_label_name":`Имя`,
"label.appointment.wizard.subtitle4-4-5":`2 месяца`,
"component_salesperformance_label_title":`Показатели продаж`,
"label.ccchat.person.invite.says":`Скажи:`,
"label.fax":`Факс`,
"label.knowledge.modify.article":`Изменить статью`,
"label.componenteditor.Limit.number.components":`На одной странице можно добавить до 15 компонентов.`,
"label.multilang.forecast.shrepage.desc":`На этой странице будут перечислены пользователи, роли и регионы, имеющие общий доступ к {0}.`,
"label.chat.micropost.write.comment":`Пишите комментарии`,
"Lead.Scoring.Setting.Rule.Setup.Active":`Активный сайт`,
"label.ccpeakfolder.time":`Запланированные папки классов`,
"label.partnerCloud.financeSetting.filter":`Условия фильтрации:`,
"label.knowledge.delete.topicassignment":`Ошибка при удалении назначения предмета`,
"label.file.orderbyname":`Сортировать по названию`,
"vue_label_chat_activelater":`Активен позже`,
"chatter.reply":`комментарий`,
"label.setup.profile.accordtext":`Согласно тексту`,
"label.encd.plaintext":`Показать четкий текст`,
"label.h5.approval.cannotreassignmark":`Проекты, утвержденные путем делегирования, не могут быть переуступлены, пожалуйста, переуступите проекты, утвержденные путем делегирования.`,
"label.version.area.lookup":`{0} текстовая область или поля поиска (мульти-выбор)`,
"approval.request.email.body":`Следующие пункты запрашивают одобрение：\n, нажмите на ссылку ниже, чтобы утвердить：\n.`,
"label.user.mass.emails.select":`Массовая электронная почта: Выберите шаблон`,
"lable.quote.syncing.title":`Синхронизация цитат и возможностей`,
"vue_label_dashboard_dashboardaccess":`Доступ к приборной панели`,
"label_emailtocloudcc_filed_owner":`Владелец`,
"label.brief.page":`Страница`,
"label.isEnableVisualpage_new.desc":`Выберите доступную пользовательскую страницу из раздела Доступные пользовательские страницы и добавьте ее в раздел Выбранные пользовательские страницы, нажмите кнопку Сохранить. После этого пользователи с этим профилем получат доступ к активным пользовательским страницам.`,
"label.service.shift.view":`Рабочие смены Посмотреть`,
"label.emailsync.addnewaccount":`Добавить новый аккаунт`,
"label.forecast.settings.prompt":`Отключение совместного доступа к прогнозам удалит все доступы, предоставляемые вручную.`,
"front-electronic-signature-explain-second":`При скреплении электронной подписи, пожалуйста, подготовьте фотографию предпринимательской лицензии предприятия и единый социальный кредитный код.`,
"label.emailtocloudcc.redmessage3":`Пожалуйста, введите адрес сервера`,
"message.confirmgiveupedit":`Если вы покинете эту страницу, вы потеряете все несохраненные изменения. Вы хотите продолжить?`,
"label.gantt.plan.success":`Успешное планирование`,
"label.monitorsys.type.error":`Пожалуйста, выберите тип поиска.`,
"label.industrialandcommercialverification.button.setup":`Установить`,
"today":`Сегодня`,
"label.attendance.setting.position":`Установить Достопримечательности`,
"chatter.mynews":`Мои сообщения`,
"label.recycle.dis.tip1":`Система будет держать та данных в корзину для переработки в течение 15 дней, и записи будут постоянно удаляться через 15 дней после того, как записи введены в корзину.`,
"label.icon.81":`Холодильник`,
"label.customer.tab.page.prompt":`Пожалуйста, настройте хотя бы одну страницу!`,
"label.globalselect.use":`Использовать глобальный список опций Установить значение`,
"template.report.customer.sales.order":`Порядок продаж счетов с разными уровнями`,
"vue_label_dashboard_lastruntime":`Последнее время работы`,
"label.edit.ccpeakfolder":`Классы: Редактирование папок`,
"vue_label_lead_be_converted":`Был преобразован и не может быть преобразован`,
"label.tabpage.filenamez":`Имя файла`,
"label.please.click.add.products.":`Пожалуйста, нажмите "Добавить товар", чтобы добавить товар в справочник цен.`,
"label.followup_emails":`После того, как посетитель отправил форму, отправьте ему электронное письмо  это простой способ быстро установить с ним связь.`,
"label.indochina.time":`индокитайское время`,
"message.error.task.email":`аномалия почтовой задачи`,
"label.dynamic.copy":`Синхронное копирование правил компоновки`,
"label.log.d":`Скачать журнал аудита в интервале времени поиска (файл Excel.csv)>>.`,
"pagecreator_layout_label_layoutname":`Макетное имя`,
"template.chart.htsktj":`Статистика по взысканию задолженности по контрактам`,
"label.appointment.wizard.subtitle4-2-5":`1 день`,
"label.view_form":`Просмотр формы`,
"label.tablet":`Планшет`,
"label.campaignmember.main.addcontact":`Добавить членов - Существующие контакты`,
"message.get.userinfo.error":`Не удалось получить информацию о пользователе`,
"label.department.username":`Имя пользователя`,
"label.ems.verifysuccess":`Электронная почта аккаунт успешно подтвержден!`,
"label.batchedit.copyValue":`Применить к этой колонке`,
"label.trigger.triggerVersion":`Версия`,
"label.mr.descreption.oneGroupReData5":`группы не обработанных данных.`,
"label.appointmentconfirmpage.wizard.subtitle5":`Описание`,
"label.weixin.inbetween":`Мульти-выбор`,
"label.salescloud.contactrole.relatelist.customnize":`Вы не можете настроить этот список`,
"label.data.exp.please.nameanddes":`Пожалуйста, введите название и описание шаблона.`,
"label_partner_workspace_login":`Страница входа`,
"label.notification.approval7":`【被委派人名称】 отклонил запрос на утверждение 【提交人】 【对象】 【对象名称】 для тебя.`,
"message.send.posts.image.error":`Загрузка изображения не удалась!`,
"message.fieldtrack.operateupdate":`Изменен`,
"label.sharerule.grantuselevelconstructureaccess":`Предоставить доступ с помощью иерархии`,
"label.translation.setup":`Многоязычная настройка`,
"PageLayout.Search.MultiSearch.003":`Выберите хотя бы одно поле.`,
"label.ccchat.person.emaildomain":`Электронная почта компании`,
"pagecreator.systemstyle.label.bordercolor":`Цвет границы`,
"label.submit":`Отправить .`,
"UG.Lead.001":`Как внедрить подсказки?`,
"label.icon.172":`Карта`,
"label_chatter_owner":`Владелец`,
"vue_label_systemSettings_Currency":`Валютный менеджмент`,
"page.layout.binfo":`Важная информация`,
"label.version.date":`поля даты`,
"label.data.is.woking":`Операционный сайт`,
"label.customfields.searchrelation.dependobjectDefault.tip":`В качестве значения по умолчанию для данного поля можно выбрать запись в соответствующем пункте.`,
"label.partnerCloud.orderingPlatform.configuration":`Продукция конфугурации`,
"lable.currencyManage.Enabledadvcurrency":`Включить расширенное управление валютой`,
"label.event.moveup.3hour":`3 часа вперёд`,
"label.reportexport.object":`Объекты экспорта`,
"front-dialog-module-v1-requestid":`Идентификатор запроса`,
"label.pw.symol":`Символы`,
"label_group_field":`Укажите поле группировки`,
"label.recallapprove":`Повторный запрос на утверждение`,
"vue_label_pool_deal_done":`Закрытая сделка`,
"label.shangqing.description":`Это описание ситуации в бизнесе`,
"label.view.allcansee":`Видимый для <b>пользователей мяча</b>.`,
"chatter.poll.addOption":`Добавить еще`,
"label.icon.112":`Еда`,
"label.ignorecase":`Трактовать "ABC" и "abc" как дублирующие значения (нечувствительные к регистру).`,
"label.email.track.edit":`Редактировать электронную почту`,
"label_tabpage_erraddressz":`Неправильный формат адреса электронной почты, пожалуйста, введите адрес электронной почты правильно`,
"label_tabpage_viewz":`Печать текущего вида`,
"component.timeline.label.future":`Следующий шаг`,
"label.b_c_without":`Записи типа "В" могут иметь или не иметь соответствующие записи типа "С".`,
"label.version.autonumberfield":`Автоматическое число Поле`,
"label.appointmentdetail.wizard.title5":`URL-адрес приглашения`,
"label.weixin.addoption":`Добавить опцию`,
"label.b.c":`От Б до С. Отношения`,
"chatter.group.complete":`Полный`,
"label.must.numeric.value":`Стоимость должна быть числовой.`,
"lable.edit.queue.memberdes":`Чтобы добавить членов в эту очередь, выберите тип члена, затем выберите роль или пользователя из "Доступные члены" и переместите их в "Избранные члены". Если модель совместного использования для всех объектов в очереди является Public Read/Write/Transfer, Вам не нужно назначать пользователей в очередь, так как все пользователи уже имеют доступ к записям для этих объектов.`,
"label.staticresource.chose.limit":`Файлы в этом формате временно не поддерживаются. Пожалуйста, с нетерпением ожидайте улучшения этой функции.`,
"vue_label_commonobjects_view_kanban_unset":`Пожалуйста, выберите основу группировки в настройках просмотра Kanban`,
"label.appexchange.download.merge.mes":`В результате слияния устанавливаются следующие конфликтующие компоненты:`,
"label.sharerule.baseofowner":`На основании владельца записи`,
"label.email.template.manage.SMS":`Управление шаблоном SMS`,
"label.imgfield.example.tip":`Зеленый значок означает "одобрено", а красный - "отклонено".`,
"template.report.potential.customer.industry":`Свинцовая промышленность`,
"component_hots_label_title":`Горячие предложения`,
"label_file_use_document":`Использование места для хранения`,
"label.input.path":`Введите путь к файлу`,
"label.partnerCloud.financialSetup":`Финансовые настройки партнера`,
"label_tabpage_myz":`My`,
"vue_label_pool_discard1":`{1}{2}`,
"label_emailtocloudcc_tip2":`После удаления вы не сможете использовать Email в CloudCC, вы уверены, что хотите удалить?`,
"label.customfields.fielddependency.sure":`Контрольное поле не включает в себя значение зависимого поля. Вы хотите продолжить?`,
"label.project.task.date":`Дата задачи должна находиться в диапазоне дат вехи, к которой она относится.`,
"Report.CantDelete.Info":`{0} отчёт является источником данных для приборной панели {1} и не может быть удалён!`,
"label.assignment.setup.title":`Правила назначения`,
"image.pt.most.maxsize":`Максимальный размер файла - 2 Мб.`,
"label.appupload.introduce":`Пакет содержит такие компоненты, как приложения, объекты, вкладки, триггеры или страницы. эти пакеты могут быть размещены в CloudCC App Store для общего доступа. в списке ниже отображаются все пакеты, созданные вашей организацией. Чтобы создать новый пакет, нажмите кнопку Новый.`,
"label.import.page2.confirm":`Подтвердить`,
"label.console.step2.introduce":`Заполните поля ниже, чтобы определить консоль.`,
"label.extendsfather":`Контролируется родителем`,
"front-homepageobject-module-v1-year":`В этом году`,
"front-grasp-sales-opportunities":`CRM помогает вам точно определять возможности продаж, приобретать больше лидов, быстро предоставлять предложения и заключать больше сделок, обеспечивая при этом многоканальный маркетинг и постоянно повышая рентабельность инвестиций компании.`,
"label.tab.oldpage":`Страница старой версии`,
"label.service.miniProgram.intro":`Введение`,
"label.data.import.setup.operate.insert":`Не обновляйте существующие записи, просто вставьте новые.`,
"label.ccpeak.direction.for.use":`Описание использования платформы CloudCC [версия 2.0].`,
"label.sendemail.chat.addComentsmyFeedsubject":`Ответ микропоста CloudCC CCChat`,
"label.campaignmember.main.importmember.contacts":`Импорт Участников - Контакты`,
"setup.mainpage.label.welcome20":`Шаблон электронной почты, SMS`,
"label.newbatcheditor.remark":`Для разных записей существуют разные типы записей. По умолчанию, раскладка рядов, если тип записи первой записи используется в качестве раскладки пафов для массового редактирования.`,
"label.step4.total7":`Шаг 4 из 7`,
"label.campagin.roi.tzhbl":`Окупаемость инвестиций`,
"label.emailmerge.mergepage.step3":`Зарегистрировать деятельность`,
"label.marketsea.isrecyclecreatebyself":`Хотите ли вы переработать самоустанавливающийся аккаунт`,
"message.mobilechooseatmost.five":`На мобильных устройствах в меню можно выбрать максимум 5 полей.`,
"label.icon.171":`Гостевой дом`,
"label.saveandnext":`Сохранить и продолжить`,
"label.import.page1.selectcodingtype":`Выберите тип кодирования`,
"label.searchlayout.displaybutton":`Отображаемые кнопки`,
"label.approvalstep5":`Шаг 5 Выбор свойств редактирования полей для отображения на макете страницы утверждения`,
"label.passwordPolicy.setup.enforcePswHis":`Ввести историю паролей`,
"vue_label_commonobjects_detail_contact_hierarchy":`Иерархия контактов`,
"front-kefu-moudle-v1-trythjzx-intelligent":`TRRT(tinet) Интеллектуальный центр обслуживания вызовов`,
"label.select.statistical.indicators":`Пожалуйста, выберите статистический индекс`,
"label.callcenter.Tianrun.RONGTONG":`TRRT (tinet)`,
"label.file.library":`Библиотеки`,
"lable.completion.rate.color.setting":`Цветовая настройка скорости завершения`,
"label.name.firstname":`Имя`,
"setup_layout_label_readonly":`Читать только`,
"label.chatter.recordcall":`зарегистрированный вызов`,
"label.service.appointmentList.service.empty":`Служебное назначение пусто.`,
"component_milestones_label_choicestate":`Подтвердить этот статус`,
"label.approved.receiveApprovalEmail.option2":`Только если я одобряю`,
"label.marketseamemset.account.title":`Настройки ведущих участников пула`,
"label.changemydisplay.list.custom":`Настройте мои вкладки`,
"label.emailtemplate.selecttype":`Выберите тип шаблона электронной почты, который вы хотите создать.`,
"component_timeline_label_title":`Сроки`,
"chatter.group.addRemoveMembers":`Добавить/Удалить членов`,
"label.console.step6.width":`Ширина`,
"pagecreator.systemstyle.message.delete.fail":`Удаление стиля не удалось`,
"label.partnerCloud.orderingPlatform.productPrice":`{productQuantity}products，{totalCount} pieces, original price：{currency} {originalPrice}，discount：{currency} {Reduction}`,
"label.h5.share":`Поделиться`,
"label.schedulejob.setup.list.tip":`Настройка запланированных заданий, которые будут выполняться автоматически с интервалом в неделю или месяц.`,
"message.intheapproving":`Отчет требует одобрения и не может быть представлен повторно.`,
"vue_label_commonobjects_detail_real_time":`После присоединения команда будет отображаться в списке Вашей команды, а динамика команды будет выкладываться Вам в режиме реального времени.`,
"label.autoRegister.changepwd.setpwd.too.weak":`Слишком короткий`,
"label.salescloud.forbiddenteamsales":`Команда Forbid Sales Team`,
"component.chatter.link.label.title":`Ссылка`,
"label.layout.editsearchdistribute.page":`Выберите пользовательские страницы, которые должны быть включены в закладку домашней страницы`,
"label.dashboard.show.value.percent":`Показывать значения или показывать %, пожалуйста, выберите по крайней мере один из них`,
"label.everymonth":`в месяц`,
"label.campaign.channel.download.size1":`Большой size: 1000*1000 пикселей`,
"permissionService.error2":`Не удалось добавить разрешения лицензии приложения.`,
"button.partner.workspace.manage.memo":`Управляйте облаком партнера и настройте свойства облака партнера.`,
"label.forecast.forehistory.commit.remark":`Примечания к представлению`,
"six":`Шесть`,
"label.datamanage.donot.export.object":`Объекты, экспорт данных которых запрещен.`,
"label.schedulejob.setup.schedule.execute":`Выполнить`,
"lable.account.CurrentandPreviousCY":`Текущий и предыдущий CY`,
"label.temp.SMS":`SMS шаблоны`,
"label_partner_all_state":`Статус`,
"label.editdocument":`Редактировать свойства`,
"front-epwechat-module-v1-ios-single":`Единый вход в систему iOS`,
"lable.redo":`Redo`,
"vue_label_SMS_alltemplates":`Все шаблоны`,
"label.allfolderreport":`Все папки отчетов`,
"label.layout.alltab":`All Tabs`,
"lable.account.Yesterday":`Вчера`,
"label.formula.to.evaluate":`Оценка формулы`,
"component_setup_label_setupsaveok":`Настройки компонентов успешно сохранены`,
"pagecreator_page_message_canntdelete":`Текущая страница не может быть удалена`,
"label.tab.message.failtotp":`Не удалось возглавить Tab`,
"label.h5.chatter.location":`Вставить место`,
"vue_label_commonobjects_view_chart_gotodashboard":`Перейти к панели управления`,
"label.data.exp.conf":`Вы уверены, что хотите экспортировать данные?`,
"label.currency.e":`Тип валюты Редактирование`,
"message.matrixReportSetupStage.column":`Пожалуйста, выберите 【Укажите 【Заголовки столбцов】 промежуточный итог, и вы должны выбрать один промежуточный итог, по крайней мере, в двух промежуточных итогах.`,
"font-evaluate-module-v1-have-comment":`Оставил оценку`,
"chatter.feed.dao":`На`,
"label.import.index.notice":`Примечание:`,
"label.weixin.information":`Подробности`,
"label.multilingual.tip5":`Статус мультиязычности не верен. Пожалуйста, обновите и попробуйте снова!`,
"label.appointment.wizard.subtitle3-7":`воскресенье`,
"label.emailobject.groupemail.fail.content":`Дорогой{0},\r\nThe следующий адрес электронной почты, который не был отправлен.{1}\r\n CloudCC`,
"vue_label_notice_uploadavatar_fail":`Не удалось загрузить аватар`,
"chatter.group.myGroup":`Мои группы`,
"label.ccpeak.object.fieldapi.name":`это поле API имени объекта`,
"lable.activeCurrency":`Активные валюты`,
"label.file.save.to.send":`Сохранить и отправить`,
"label.emailmerge.list.editfolder":`Папка Редактирование`,
"label.Path.Setting":`Настройка пути`,
"label.validate.function.funcFormat.DATE":`Дата (год, месяц, день)`,
"message.objapiexists":`Этот объектный API уже существует.`,
"label.sendmail.batch.confirm":`Массовая электронная почта: Подтвердить`,
"message.approval.cannotsubmit.detail":`Эта запись не соответствует условиям или первоначальному представлению для какоголибо действительного процесса утверждения. Обратитесь за помощью к своему администратору.`,
"setup.layout.button.deleteitem":`Удалить выбранные пункты`,
"label.end.loginipIP":`Конечный IP-адрес`,
"component_event_label_subject":`Тема`,
"message.500":`Произошла внутренняя ошибка сервера`,
"label.wei.polltype":`Типы`,
"vue_label_norm_duplicate":`Дублировать`,
"label.addcycletrigger":`Добавить периодический триггер`,
"DetailedInfo.Activity.EmailMessage.01":`{0} отправьте сообщение по электронной почте {1}.`,
"No.Activity":`Бездеятельность`,
"label.chat.topic.add.topic":`Нажмите, чтобы добавить тему`,
"label.schedulejob.setup.schedule.morning":`AM`,
"chatter.save.al":`Ваши изменения были сохранены.`,
"label.setsharerule.step3":`Шаг 3 Выберите пользователей, с которыми хотите поделиться`,
"label.tabpage.Sdfez":`Дни назад`,
"label_submit_forecast":`Представить прогноз`,
"label.version.sum.formulafield":`поля формул`,
"lable.weixin.you.invitation":`Ваш приглашённый`,
"label.stacked.horizontalbar":`Сложные горизонтальные линии`,
"label.file.anyone.can.link":`Любой, у кого есть ссылка, может просмотреть и скачать файл.`,
"label.campaignmember.main.importmember.lead.desc":`Импорт зацепок из файлов.`,
"UG_activity_01":`Как вы отслеживаете свои записи для взаимодействия с вашими учетными записями/группами?`,
"label.reason":`Причина`,
"label.version.free.createmax":`Позволяет создать 2000 записей, верхний предел достигнут.`,
"label.brief.thisweek":`эта неделя`,
"label.deleteobjinapprove":`Пожалуйста, введите комментарий, прежде чем вы сможете удалить этот объект из процесса утверждения.`,
"calendar.tips.event":`день(ы) без событий`,
"label.customerinfo.mailinfo":`Электронный адрес всей организации`,
"lable.electronic.signature":`Электронная подпись`,
"label_emailsync_addnewaccount":`Добавить новый аккаунт`,
"label.layout.exampleoftesgobj":`Пример тестового объекта`,
"label.happen_submit":`Что должно произойти после того, как посетитель отправит эту форму`,
"label.forecast.customforecast.button.submit":`Отправить .`,
"label_right_click_notice":`Внимание: Почтовый ящик CloudCC не может быть привязанным почтовым аккаунтом пользователя системы, иначе это приведет к недействительным письмам для генерации лидов или кейсов.`,
"font-trade-module-v1-invoice-no-price":`Подлежит возмещению`,
"lable.opppdt.selPdt.morecondtions":`Больше   фильтры`,
"label_invalid_token":`Неверный токен`,
"label_chatter_postup":`Разместить`,
"label.escalation.setup.newaction.step1":`Шаг 1 Укажите временные критерии для данного правила`,
"label.sendmail.step3.dealoption2":`Хранить деятельность для каждого сообщения`,
"front-kefu-moudle-v1-yesornoBatch-delete-templete":`Вы уверены, что хотите пакетно удалять шаблоны?`,
"vue_label_appstore_enter_website":`Зайдите на официальный сайт`,
"label.when":`Время публикации`,
"label.linellae":`Линии`,
"label_chatter_detailinfo":`Подробная информация`,
"lable.SalesCommitmentKanBan.receivingTaskRate":`Поступления Ставка выполнения задачи`,
"vue_label_homepage_dashboard_deleted":`Приборная панель была удалена`,
"pagecreator.layout.button.vertical":`Продольная разборка`,
"label.redistribution1":`Выберите до 5 пунктов`,
"pagecreator_page_label_modifypage":`Редактор страниц`,
"label.Service.Cloud.Setting":`Настройка облака обслуживания`,
"setup_layout_label_pagename":`Имя макета страницы`,
"label.ems.send":`Отправить`,
"vue_label_commonobjects_view_kanban_notice1":`Вид Канбана показывает только первые 200 записей.`,
"lable.outlook.detail.maping":`Полевые отображения`,
"vue_label_pool_abandonorrestore":`{1}{2}`,
"label.mobile.side.tab":`Мобильная боковая настройка ползунка`,
"label.trigger.operation.email.template.param":`Передача параметров: язык, идентификатор шаблона электронной почты и идентификатор записи`,
"front-objectTemplate-V1-Select-a-template":`Выберите существующий шаблон в качестве основы для нового шаблона.`,
"label.email.template.delete.template":`Вы уверены, что хотите удалить этот шаблон?`,
"label.reportsSubscription.cancel":`Отменить`,
"lable.quote.syncingfrom.firstsync.description":`Продукты возможностей заменят позиции котировок`,
"label.weixin.no.pending.xsld.qin":`Простите, данных по воронкам продаж нет.`,
"template.dashboard.sales.indicators":`Показатели продаж`,
"label.field.new":`Предоставление пользователям операций по оценке и подсчету очков.`,
"label.generatepage.title.desc1":`Сгенерировать мобильную или компьютерную версию HTML кода на основе выбранных полей, пользователи могут изменять код по мере необходимости.`,
"template.report.source.potential.customers":`Источник лидов`,
"label.mr.title.queryData":`Найти дубликаты`,
"button_partner_workspace_enable":`Включить облако партнера`,
"V":`Автоматическое число`,
"label.icon.19":`Папка`,
"vue_label_report_summaryformula":`Сводная формула`,
"label.appointment.wizard.subtitle2":`Диапазон доступных дат`,
"label.stdashbord.xsld.business.bjdzhl":`Степень конверсии ступеней`,
"label.forecast.forehistory.deopportunity":`Возможности`,
"chatter.email.referredToMeLeaveMessage":`Упоминает меня в комментарии`,
"label.dategrouprelyon":`Критерии группировки даты`,
"label.sendmail.batch.finish":`Массовая электронная почта: Заполнено`,
"label.weixin.allexpired":`Все просроченные`,
"label.dashboardSetup.showdw.d4":`10 тысяч`,
"message.duplication.label.masterRecord":`мастер-запись`,
"vue_label_calendar_availability":`Наличие`,
"vue_label_chat_approval_message":`Сообщение об одобрении`,
"vue_label_zhang_er":`Дженни`,
"label.select.options":`Пожалуйста, выберите варианты`,
"label.israel.daylight.time":`стандартное время Израиля`,
"front-sales-search-QB":`Всего 0 данных, нужно ли создавать новую учетную запись в QuickBooks`,
"vue_label_account_change_customer":`Изменить владельца клиента`,
"label.integrations.mailchimp2":`Посмотреть дополнительную информацию об CloudCC и Mailchimp`,
"lable.product.pricebooks.onisu":`Неактивные цены Книги`,
"front-electronic-signature-backfill-field":`Засыпка поля`,
"label.document.myself.folder":`Мои личные папки`,
"label.event.moveup.10hour":`10 часов вперёд`,
"report.label.report":`Доклады`,
"label.validate.function.funcFormat.CONTAINS":`CONTAINS(text, compare_text)`,
"label.usermanage.query.false":`Запрос не удался, пользователя не существует.`,
"front-epwechat-module-v1-input-EncodingAESKey":`Пожалуйста, введите EncodingAESKey`,
"label.event.multi.view":`Многопользовательский просмотр`,
"label.h5.similar.opportunity.setup":`Похожие возможности Настройки`,
"label.setting.intergrationlist.button.install":`Установить`,
"label.event.monthview":`Месяц просмотра`,
"label.version.weixin":`Версия WeChat`,
"label_emailtocloudcc_redmessage6":`IMAP/SMTP аутентификация не прошла, пожалуйста, проверьте правильность адреса электронной почты и пароля.`,
"UG.homepage.003":`360-градусный вид`,
"vue_label_calendar_shared_calendar":`Календарь акций`,
"label.select.hope.merge.num1.record":`Пожалуйста, выберите записи, которые вы хотите объединить в одну запись. Выберите максимум 3 записи одновременно.`,
"label.createnewprocess":`Создать новый процесс утверждения`,
"font-trade-module-v1-invoice-status":`Статус оплаты`,
"label.customerinfo.introduce":`Информация о компании`,
"label.objectname":`Имя объекта`,
"label.chosen.field":`Избранные поля`,
"label_target_name":`Имя модели цели:`,
"label.appointment.wizard.subtitle4-4-4":`1 месяц`,
"label.emailobject.groupemail.msg1":`Адрес электронной почты отсутствует`,
"label_component_hotdeal_nopermission":`Для просмотра данных, связанных с возможностями вашего бизнеса, свяжитесь с вашим администратором CloudCC.`,
"label.appointmentdetail.wizard.title13":`Описание`,
"front-web-module-v1-detail-comment-title":`Пожалуйста, прокомментируйте эту услугу`,
"label.visualpage.component.n1":`1. Метод вызова.  `,
"lable.outlook.mcto.erecord":`первые созданные записи`,
"label.weixin.del.log":`Журнал удаления`,
"setup_mainpage_label_welcome23":`Параметры безопасности`,
"label.selectreportline":`Пожалуйста, выберите столбцы отчета`,
"label.chatter.following":`Следуя`,
"seven":`Семь`,
"message.error":`Error:`,
"label.mobile.phone.reporter":`Представлено`,
"label.valadate.telphone.false":`Телефонный номер введите ошибку, пожалуйста, введите повторно`,
"label.linkedin.setting":`Интеграция LinkedIn H5 MiniApp`,
"label.mobile.side.tab.success":`Сохраните настройки ползунка на мобильной стороне успешно.`,
"label.notification.approval3":`Запрос на утверждение 【对象】 переназначен на 【重新审批人】`,
"label.channel.invites.employees":`Приглашение сотрудников этого канала`,
"label.assignment.setup.detail.assigner":`Назначить на`,
"label.campaignmember.main.updatecontactdesc":`Обновлять статус всех контактов одновременно`,
"label.permission.detail.app.fenpei":`Назначить приложения`,
"label.copydown":`Скопировать вниз`,
"label_emailsync_status_action":`Действие`,
"lable.Please.switch":`Для использования этой функции переключитесь в горизонтальное или вертикальное меню.`,
"label_adjust_remark":`Замечания по регулировке`,
"label.weixin.newspaper.coverage.list":`Листы рисков`,
"label.datamanage.contact.field":`Контактные поля`,
"label.partner.workspace.login.headerfooter":`Верхний и нижний колонтитулы`,
"lable.account.quarter.ovdate":`День окончания финансового квартала`,
"pagecreator.systemstyle.label.textcolor":`Цвет текста`,
"label.industrialandcommercialverification.fieldmappingsettings":`Настройки картирования полей`,
"component_chatter_button_message":`Комментарий`,
"label.partnerCloud.enterAddress":`Пожалуйста, введите адрес`,
"label.email.template.recently.used":`Недавно использованные`,
"component.event.label.calendar":`Просмотр Календаря`,
"label.setup.mobile.offlinecache.setting":`Настройки кэш-памяти офлайн для мобильных устройств`,
"label.custom.PreviousCQ":`Предыдущий CQ`,
"lable.total.of.payments":`0 оплата всего`,
"label.ccpeak.use.class.time.trigger":`Если триггер вызывает класс, то можно напрямую использовать методы в CCService.`,
"label_tabpage_addresswrongz":`Формат адреса почтового ящика неправильный, пожалуйста, правильно введите адрес почтового ящика!`,
"vue_label_homepage_select_components":`Выбор компонентов`,
"front-kefu-moudle-v1-secretID-reinput":`Пожалуйста, введите секретный идентификатор`,
"label.ccdocument.select.template.red":`Пожалуйста, выберите набор шаблонов.`,
"vue_label_email_public_template":`Общественный шаблон`,
"label.eowechat.openid":`WeCom ID`,
"label.user.ip.notlogin.range":`Этот IP-адрес не находится в диапазоне IP-адресов.`,
"chatter.email.reply.collection":`Комментарии к пункту, на который я сделал закладку`,
"label.integrations":`Интеграции`,
"label.permission.modifyAppPermission.selectedapp":`Выбранные приложения`,
"label.privacystatement":`Положение о конфиденциальности`,
"label.specificvalue":`Определённое значение`,
"label.appointmentconfirmpage.wizard.subtitle2":`Дата и время`,
"label.message.ispartner.delete":`Так как контакт уже связан с пользователем-партнером, клиент не может быть удален.`,
"report_button_go":`Перейти к`,
"label.h5.similar.opportunity":`Аналогичная возможность`,
"UG_Lead_005":`Почтовый ящик`,
"label.num.length.not.overstep":`длина значения не может превышать 18 бит`,
"label.profile.mobile.setup.CEOandDirector":`генеральный директор и директор по продажам`,
"label.addfield":`Добавить поле`,
"template.dashboard.institutional.overview":`Обзор агентства`,
"label_tabpage_datefield":`При равенстве поля даты он может использовать "вчера", "сегодня", "завтра", "в прошлом месяце", "в этом месяце", "в следующем месяце", "на прошлой неделе", "на этой неделе", "на следующей неделе" или "ГГГГГ-ММ-ДД, ММ/ДДД/ГГГГ" формат.`,
"label.category.7":`Туризм`,
"UG_contact_02":`Взаимодействие с контактами по нескольким каналам, звонки, электронная почта, социальные сети`,
"chatter.feed.menutype.feed.mecom":`Новый пост для меня`,
"vue_label_systemSettings_calltemplate":`Шаблон письма`,
"approval_process_errore":`Во время сохранения произошла ошибка, пожалуйста, свяжитесь с администратором.`,
"label.tabpage.choosefilez":`Выберите файл`,
"label.changemydisplay.chagetab.cusapp":`Пользовательские приложения`,
"clearadvancedoption":`Логика чистого фильтра`,
"front-epwechat-module-v1-binding-user":`Связанные пользователи`,
"label.customfields.fielddependency.null":`Зависимости не определены.`,
"label.enterprise":`Корпоративная версия`,
"font-evaluate-module-v1-five-points":`Нейтральный знак: 5 баллов`,
"lable.Synchronize.from.QuickBook":`Синхронизация с QuickBook`,
"front-gantt-module-v1-task-number":`Сумма задания`,
"label.currency.edit.newexchagecurrency":`Датированные обменные курсы`,
"label.partnerCloud.partnerSite":`Сайт партнера`,
"label_tabpage_unequalz":`неравноправный к`,
"label.version.solutions":`Решения`,
"label.setting.intergrationlist.button.installed":`Установленный`,
"label.h5.chatter.share":`Предоставлять общий доступ к файлам`,
"front-epwechat-module-v1-unbound-item4":` привязка внешних счетов`,
"label.textmessage.vonage.accessibility.setting":`Доступность Настройка`,
"font-evaluate-module-v1-evaluation-set":`Параметры оценки`,
"message.servicecrew.time.violation2":`Вне рабочего времени`,
"label.processinfo":`Информация о процессе утверждения`,
"label.knowledgebase.last.modified":`Последняя модификация`,
"label.to.phone":`На`,
"label.baseoffirsttimereply":`Утвердить или отклонить на основе <сильной> первой </сильной> реакции`,
"label.projectManagement.startingEndingTime":`Время`,
"label.licence.enable":`Активный сайт`,
"label.partnerCloud.basicSetting.cshua":`Инициализация партнерского облака`,
"APPIntegration.Dropbox.setting.03":`Включите Dropbox, чтобы можно было выбирать файлы из Dropbox и добавлять их как вложения.`,
"label.account.contact":`Контактный АИ`,
"label.many.dayline.tab":`Отметить`,
"label.weixin.input.username":`Пожалуйста, введите ваше имя`,
"label.logintime.pagecue.invalido":`Время окончания должно быть целым днём.`,
"label.icon.30":`Книга`,
"label_tabpage_advancedscreening":`Расширенный фильтр`,
"lable.currencyManage.unEnabledadvcurrency.agree":`Да, я хочу отключить Advanced Currency Management.`,
"label.tab.web.new":`Новая веб-вкладка`,
"label.bmap.tiananmen":`Тяньаньмэнь`,
"label.disabled":`Инвалид`,
"error.currencyAdv.deleteprecodedate":`Невозможно удалить дату обменного курса валюты.`,
"message.error.view.checkbox.validerr":`Ошибка: пожалуйста используйте правду или ложь`,
"UG_ST_006":`Введите напрямую`,
"label.dongshifang.title":`SMS-сообщение о DongShiFang`,
"label.data.dataexpalltype.all.desc3":`3、Экспорт успешных данных будет генерировать сжатый файл, который пользователи могут загрузить со страницы списка экспортных успешных в соответствии с информацией по почте.`,
"vue_label_pool_returnreason":`Причина возврата`,
"label.list.userinterface.des":`Измените пользовательский интерфейс со следующими настройками:`,
"label.notification.approval2":`Запрос на утверждение 【对象】 отклонен 【审批人】`,
"label.service.dispatchingUnits.the.level":`Уровень`,
"front-email-payment-Invoice-preview-tips":`В настоящее время все шаблоны счетовфактур отключены. Пожалуйста, обратитесь к администратору, чтобы включить шаблон перед созданием счетовфактур.`,
"label.dashboard.isAvailableFieldOfComponentGroupInTheReport":`Ошибка:одно или несколько полей, выбранных в компоненте, больше не доступны в отчете. <br>используйте редактор компонентов приборной панели для выбора одного из доступных полей.`,
"label.import.step2.chooseidorother":`2、Вы можете выбрать ID или имя для сопоставления с записью и заполнить поле поиска. Если вам нужно получить ID соответствующей записи и другую информацию, вы можете создать отчет и установить имя записи и ID записи в качестве групповых столбцов, а затем экспортировать отчет.`,
"label.customobjects.introduce":`Пользовательские объекты - это таблицы баз данных, которые позволяют хранить данные, специфичные для вашей организации, в CloudCC. Вы можете использовать пользовательские объекты для расширения функциональности CloudCC или для создания новых функциональных возможностей приложения.`,
"label.visualpage.oldsystem":`Старая версия`,
"label.icon.94":`Книга`,
"label.setup.log.desctiption":`Вы можете загрузить трассировку поведения вашей организации (Excel.xls).`,
"label.dynamicpage.layout":`Правила размещения`,
"lable.list.queue.objct":`Поддерживаемые объекты`,
"label.customfields.placeholder.tip":`Образец текста будет отображаться в поле ввода и исчезнет после получения фокуса`,
"label.ems.activationtime":`Время активации`,
"label.detailinfo":`Подробности`,
"label.icon.17":`Сообщить`,
"label_emailtocloudcc_button_complete":`Закончить`,
"label.visualpage.component.n2":`2. Обратите внимание, что "теги компонентов" не могут быть вложены в "<cc>tags".`,
"label.object.name.one":`Имя объекта 1`,
"label.summaryreport.step2":`Шаг 2 Выберите обобщенные данные`,
"thisisanew":`New!`,
"label.query.detail.editpartneruser":`Редактировать пользователя-партнера`,
"label.tabpage.newview":`Создать новый вид`,
"label.partnerCloud.productSet.addNew":`Новый вариант`,
"label.appupload.upload.new.remark":`Это новый компонент`,
"label.case.ptext":`Мы привязали вашу компанию к вебверсии портала. Скопируйте адрес вебверсии портала обслуживания клиентов, предназначенного для вашей компании, и добавьте портал на свой официальный сайт.`,
"lable.PowerProcess.name":`Процесс получения прав`,
"label_tabpage_choosefilez":`Выберите файл`,
"homepage.components.place":`Положение компонентов:`,
"lable.Synchronization.failure":`Не удалось синхронизировать`,
"label.dashboard.snapshot.get.data":`Получить ваши данные`,
"label.input.invalid.format":`Пожалуйста, введите действующий формат`,
"label.quickbooks.view.openinvoices":`Открытые счета-фактуры`,
"label.weixin.seating":`Места для сидения`,
"label.searchlayout.remark":`Схемы поиска позволяют выбирать стандартные и пользовательские поля, которые отображаются в следующих поисковых функциях:`,
"label.escalation.setup.entrydetail.escalation.assiner":`Назначить на`,
"vue_label_calendar_availability_view":`Календарь-Вид наличия`,
"label.country":`Страна`,
"label.campagin.roi.zl":`Обзор`,
"lable.currencyManage.advcurrencyEnabled":`Включено расширенное управление валютой`,
"label.projectManagement.project.task":`Проектная задача`,
"label.appointmentpage.wizard.subtitle3-2":`Email`,
"label.input.invalid.date":`Пожалуйста, введите действительные даты`,
"vue_label_chatter_my_followers":`Мои последователи`,
"label.setupdevelop":`Разработать .`,
"label.sendemail.send.checksend":`Проверьте, отправлено ли письмо успешно`,
"label.eventfield":`Поля событий`,
"label.ccpeak.ccobject.put":`используйте put для назначения CCobject, например:`,
"label.campaignmember.main.addMemberDesc":`Вы можете осуществлять поиск существующих ссылок и контактов, добавлять их в эту кампанию или управлять существующими участниками кампании.`,
"label.knowledge.setting.hint.eleven":`Введите категорию данных`,
"label.knowledge.category.button.four":`Добавить категорию братьев и сестер`,
"label.icon.27":`Узнать`,
"vue_label_chatter_certification":`Ты уверен, что хочешь... "Имя"?`,
"label.data.downpage.i.title.btn":`Перейдите на страницу импорта и начните импорт`,
"label.campaign.channel.step6.pc":`Генерировать страницу ПК`,
"label.mr.caption.rule":`Правила:вы должны выбрать одно или несколько правил для поиска дубликатов`,
"label.service.gantt.resourcestype":`Тип ресурса`,
"label.searchfitconditions":`Найдите те, которые соответствуют следующим критериям:`,
"label.partner.template.name":`Название шаблона`,
"setup.mainpage.label.welcome15":`Правила рабочего процесса CloudCC Cloud Platform автоматизируют процесс поддержки ваших продаж, маркетинга и многого другого. В зависимости от предопределенного набора правил, записи могут быть автоматически назначены пользователям или преобразованы из одного пользователя в другого. Основным преимуществом управления рабочими процессами является повышение эффективности работы за счет устранения многих ненужных операций при обновлении записей, а также повышение уровня обработки данных и оптимизация процессов контроля за счет стандартизации методов работы и снижения эксплуатационных расходов. Она поддерживает неограниченное бесконечное одобрение для любого объекта, а также может вызывать напоминания по электронной почте, SMS, задачи, обновления полей и другие функции.`,
"vue_label_commonobjects_view_chart":`Диаграмма`,
"label.salescloud.teamrole.choose":`Пожалуйста, выберите роль команды`,
"lable.outlook.mcto.emailrel":`Ассоциации электронной почты`,
"front-invoice-online-payment-setup-describe":`Быстрый доступ, доступ одним кликом. Простой, безопасный и быстрый сервис онлайнплатежей.`,
"label.korean.standard.time":`корейское стандартное время`,
"label.lord.howe.standard.time":`Лорд Хоу Дневное время`,
"setup_layout_group_button":`Кнопки`,
"label.editdefaultshare":`Редактирование по умолчанию общего доступа для всей организации`,
"label_fiscal_year":`финансовый год`,
"label.appointmentdetail.wizard.title2":`Владелец`,
"label.email":`Email`,
"label.city":`Город`,
"label.knowledgebase.data.recovery.failed":`Восстановление данных {a} не удалось`,
"setup_mainpage_label_welcome6":`Пользователи могут создавать различные типы полей во всех объектах CloudCC системы без каких-либо знаний программирования или разработки кода. Типы полей включают в себя: отношения поиска, поле одиночного выбора, выбор из двух элементов, формула, автоматическая нумерация. , URL, телефон, факс, электронная почта, чекбокс, дата, время, номер, текст, текстовая область, список опций (одиночный/множественный выбор), валюта и т.д.`,
"label_emailtocloudcc_button_enable":`Активный сайт`,
"label.account.custom":`Таможенный налоговый квартал`,
"label.custompublish_time":`Время публикации клиента`,
"label.dashboardSetup.selwz":`Отображаемое положение`,
"component_todaytask_label_all":`Смотреть все`,
"label.service.resource.group.tip":`Сервисные ресурсы, относящиеся к типам экипажей, должны использовать тип экипажа.`,
"label.tianyancha.legalpersonname":`Имя юридического лица`,
"component.setup.label.titlefield":`поле заголовка`,
"label.email.template.public.mail":`Папка шаблонов публичной электронной почты`,
"front-template-V1-DeleteTempalte":`Вы уверены, что хотите удалить "{currentTelmplateName}"?`,
"pagecreator.layout.label.layoutdesc":`Описание схемы размещения`,
"vue_label_file_singel_upload":`Загрузить можно только один файл. Если вам нужно заменить файл, пожалуйста, сначала удалите загруженный файл.`,
"label.view.hierarchy":`Иерархии просмотра`,
"label.file.owner.settings":`Собственные настройки`,
"label.sales.dashboard.name":`Имя`,
"label.offfer.filer.name":`Имя файла цитаты`,
"label.quickbooks.view.recentlypaid":`Недавно оплаченный`,
"label.step1.select.merge.records":`Шаг 1 Выбор записей для объединения`,
"message.recordtype.assignprofile.tip":`Установите флажок Включить для профиля, чтобы новый тип записи стал доступен для профиля. Пользователи, назначенные на данный профиль, смогут создавать записи данного типа или назначать данный тип записи существующим записям. Чтобы сделать новый тип записи доступным для профиля по умолчанию, установите флажок Make Default (Сделать по умолчанию).`,
"label.appointmentdetail.wizard.title9":`Время в пути`,
"label.group":`Группы`,
"label.deltorecycle":`Удалить в корзину`,
"label.import.index.numlimit":`1. Поддерживаются только файлы формата csv, и за один раз можно импортировать до 30 000 записей (<span style="color: red"> до 2000 записей можно импортировать, если нужно выполнить триггер</span>). Записи, превышающие лимит, будут автоматически проигнорированы системой. Если вы хотите импортировать больше данных, сначала разделите их на несколько файлов и импортируйте их в разное время. .`,
"label.file.delete.desc":`Удаление файла также удалит его из любых дополнительных записей или сообщений.`,
"UG_activity_04":`Почтовый ящик Outlook/Gmail, записывайте почту`,
"label.event.all.undealt":`Все необработанные события`,
"label.appupload.upload.install.error":`Это приложение не может быть установлено. пожалуйста, закончите установку или модифицируйте систему api и переустановите ее!`,
"template.chart.yqydcpsl":`Количество активированных продуктов`,
"label.import.index.advancepreparation":`Предварительные приготовления`,
"label.eowechat.epdeptnamee":`Название отдела WeCom`,
"front-kefu-moudle-please-input-servernum":`Пожалуйста, введите список заявок на обслуживание №.`,
"label.lookup.autocmp.nodata":`Данные о совпадении отсутствуют`,
"vue_label_pool_assign":`Назначить`,
"label.knowledge.timing.publish":`Публикация по времени не удалась`,
"label.selected.groups":`Выбранные группы котировочных линий`,
"front-epwechat-module-v1-removesele-desc":`После удаления все настройки этого приложения будут удалены. Вы уверены, что хотите удалить?`,
"label.batchtransfer.type2":`Передача закрытых верхних частот`,
"label.richtext":`Текстовая область (богатая)`,
"label.icon.174":`Самолет`,
"vue.please.select.grouping.basis":`Пожалуйста, выберите параметры группы.`,
"label.matrixreport":`Матричный отчёт`,
"label.jiandangfenpei.leftlist":`Неприписанные профили`,
"label_chatter_card":`Карта`,
"label.file.enter.title":`Пожалуйста, введите название`,
"label.the.record.is.locked.and.cannot.be.selected.":`Эта запись заблокирована и не может быть выбрана.`,
"label.partner.success":`Доступен домен Success!`,
"label.selectreporttype":`Выберите источник данных отчета`,
"report.type.label.productPricebooks":`Продукция и ценники`,
"label.texttemplate.mergefields.tip":`Добавляйте встроенные поля при редактировании содержимого SMS. При отправке SMS встроенные поля могут быть заменены соответствующим текстом. Например, {!Contact.name} может быть заменено именем контакта при отправке SMS.`,
"label.publicgroup.detail.showallusers":`Просмотреть все пользователи`,
"label.brief.follow":`Последующие действия`,
"label.forecast.settings.qijian.p":`Квартальный прогноз`,
"label.sms.url":`URL-АДРЕС`,
"setup_layout_group_custompage":`Настроить страницу`,
"label.validate.function.funcFormat.BEGINS":`BEGINS(text, compare_text)`,
"label.umeng.chatter.sendmessage":`отправлено сообщение`,
"label.pc.layout":`макет ПК`,
"label.currency.v":`Введите десятичные знаки (количество цифр справа от запятой), разрешенные при отображении данных в этой новой валюте. Это должно быть целое число со значением от 0 до 6.`,
"label.projectManagement.kanbantask":`Задача Канбан`,
"component_recdetail_label_title":`Подробная информация`,
"label.isremider":`Напоминание`,
"front-epwechat-module-v1-input-home-url":`Пожалуйста, введите URL домашней страницы`,
"label.usefullife":`Истекающий период`,
"label.visualpage.ptype":`Общий сайт`,
"label.quote.name":`Цитатное имя`,
"vue_label_report_addtocomponent":`Вы уверены, что хотите добавить {имя} в библиотеку компонентов?`,
"label.dashboardSetup.showdw.d1":`100 миллионов`,
"label.validate.function.funcFormat.OR":`ИЛИ(logic1,logic2,...)`,
"label.component.helper.potentialcustom":`Свидетельства, назначенные вам сегодня`,
"label.autoRegister.changepwd.setpwd.tip.number":`Как минимум один номер`,
"label.data.setok.e.desc3":`загрузите экспортированные данные.`,
"label.data.downpage.e.title.num4":`4、Экспортные файлы имеют два формата: CSV формат и формат сжатия. Формат сжатия разделен на два типа: один для автоматической генерации сжатого пароля файла, другой для ручного ввода сжатого пароля файла.`,
"lable.quote.editqtpdt.description":`Выберите ценовую книгу для этого предложения. Вы можете добавить продукт только из одного ценника, и изменение выбранного ценника удалит все существующие продукты из ценника.`,
"front-kefu-moudle-edit-userinfo":`Редактирование информации о пользователе`,
"label.please.ChooseMinAndMax":`Пожалуйста, выберите не менее {0} вариантов товара, можно выбрать до {1}.`,
"label.knowledgebase.archive.an.article":`Архивировать статью?`,
"label.multilang.customforcast.submit":`Вы представляете прогноз от {0}фискального года{1} до {2}фискального года{3}?`,
"label.import.index.filename":`Имя файла`,
"front-console-no-reco-contact":`Контакт не может быть идентифицирован`,
"label.quantity.greater.than0":`Количество должно быть больше 0.`,
"label.codeNorm":`Стандарт кода`,
"label.average":`Средний`,
"label.multilang.page1":`Страница`,
"label.data.exp.save.ok":`Сохранить шаблон успешно`,
"message.error.delete.record":`Запись, которая должна была быть удалена, не была найдена!`,
"label.newvaluereplaceoldvalue":`В глобальном масштабе заменить существующее значение в списке на новое. Убедитесь, что Вы сначала создали новое значение в поле пикилиста.`,
"label.tabpage.saveviewsuccess":`Просмотр успешно сохранен`,
"label.partnerCloud.productSet.parentOptions":`Родительский вариант`,
"label.emailtemplate.availablemergefields":`Доступные поля слияния`,
"label.data.import.setup":`Настройки импорта данных`,
"label.escalation.setup.entrydetail.escalation.action":`Эскалационные действия`,
"System.TimeField.Description":`Позволяет пользователям вводить местное время. Например, "2:40 PM", "14:40" и "14:40:00" являются действительными для данного поля.`,
"front-additional-products":`Купить другие продукты`,
"label.appointment.wizard.subtitle4-4-1":`1 неделя`,
"label.chatter.colleagues.list":`Список коллег`,
"label.log.invalid.data":`Недействительная дата`,
"label.file.preview.unconvert":`Информация о предварительном просмотре не генерируется, пожалуйста, нажмите кнопку "Просмотр деталей".`,
"label.customer.detailed":`Выберите страницу для этой новой вкладки. Введите другие данные.`,
"label.sendsms.content":`Содержание следующее:`,
"label.exported_to":`Экспортированный файл будет отправлен по электронной почте на`,
"label.attendance.checkin":`Регистрация`,
"Dashboard.NoAccessRightToSee.Warning":`У вас нет разрешения на просмотр дашбоад {0}, которые установлены как defualt open, пожалуйста, сбросьте.`,
"message.choosedelete":`Пожалуйста, выберите данные, которые вы хотите удалить`,
"label_tabpage_choosecontent":`Выберите содержание значения`,
"label.no_responses":`Нет ответов`,
"report_type_label_customService":`Поддержка клиентов`,
"label.report.select.condition":`Условия`,
"label.umeng.activity.distributeevent":`назначил тебе событие.`,
"label.knowledge.language.portuguese":`Португальский язык`,
"label.knowledgebase.published":`Опубликовано`,
"UG_opportunity_001":`Как вы отслеживаете свои продажи?`,
"label.mr.caption.scope":`Сфера действия: запрос всех данных, если не выбран`,
"message.login.mfaverification.to.pclogin":`Ваша организация включила проверку вторичного входа, первый вход требует привязки к мобильному устройству, пожалуйста, используйте сторону ПК для привязки входа`,
"vue_label_dashboard_pleaseenterthecolorrange":`Пожалуйста, введите цветовую гамму`,
"label.emailsync.status.time":`Время`,
"chatter.putup":`Предоставить общий доступ к файлу`,
"vue_label_report_drillcondition":`условие бурения`,
"label.emailobject.list.myemail":`Моя электронная почта`,
"label_tabpage_andz":`И`,
"label.share_link":`Поделиться ссылкой`,
"label.emailtocloudcc.exists2":`Этот почтовый ящик был установлен на Email to Case. Не повторяйте настройки.`,
"label.icon.89":`Консультационный сайт .`,
"front-kefu-moudle-v1-qdygbzx-chat":`Вы уверены, что отключили онлайнчаты?`,
"label.approval.selectone":`Пожалуйста, выберите хотя бы одно действие.`,
"chatter.group.groupName":`Название группы`,
"label_chatter_relateitem":`Связанный с`,
"label.file.folder.delete1":`Удалить папку?`,
"Pagelayout_Setup_003":`Должно быть выбрано поле "Имя`,
"setup_mainpage_label_welcome2":`Пользовательская база данных (объект)`,
"pagecreator.systemstyle.label.linkcolor":`Цвет ссылки`,
"label.task.this.week":`эта неделя`,
"message.custom.field.donotdelete.report":`Ссылка на поле приведена в докладе`,
"pagecreator.layout.button.delete":`Удалить макет`,
"label.reportsSubscriptionPage.condition.operator":`Оператор`,
"label.location.display.type.degrees":`Степени, минуты, секунды`,
"label.appupload.upload.url":`URL-адрес установки`,
"label.logical.relation":`Логическая связь`,
"label.knowledge.publish.article":`Опубликовать статью`,
"vue_label_commonobjects_detail_activity_commingtask":`Доступная предстоящая задача`,
"vue_label_pool_reason":`причина`,
"front-gantt-module-subtasks-cannot-subtasks":`Подзадачи не могут появляться под подзадачами!`,
"label_tabpage_filesizez":`Размер файла`,
"label.customfields.formula.returntype.monry.tip":`Рассчитайте сумму в долларах или других валютах и автоматически отформатируйте поле как сумму в валюте.`,
"label.tabpage.allapplications":`Все приложения`,
"message.duplication.label.matchcontainletters":`Содержать`,
"maintenanceplan.workorder.type.asset.workorderlineitem":`Пожалуйста, выберите "Один элемент строки наряда-допуска для каждого актива" в качестве типа наряда-допуска.`,
"label.preview_post":`Предварительная запись`,
"chatter.p.data":`Дата сообщения`,
"label.isnot.right.number":`Недействительное число`,
"label.contentsource":`Источник контента`,
"message.groupandsummaryconditionsame":`Условия, используемые для группировки, не могут быть такими же, как и резюме conditions`,
"label.weixin.wdyj.nodata.qin":`Извините, {0} нет данных.`,
"chatter.vote":`Голосовать`,
"label_partner_workspace_tab_option":`Доступные вкладки`,
"chatter.changeVote":`Изменить голос`,
"label.data.file.i_title.num2":`2. Рекомендуется экспортировать данные при импорте, чтобы экспортный документ использовался в качестве шаблона для сопоставления импортируемых данных с последующим импортом. (Если импортируемые данные содержат запятую, замените ее на символ @).`,
"label.relation.list.error":`Ошибка`,
"label.validate.function.funcExplain.MILLISECOND":`Возвращение миллисекунды дня (с полей Дата/Время)`,
"label.emailobject.emaildetail.button.relateto":`Связанный с`,
"label.dashboard.dataSource":`Показать источник данных`,
"label.marketseamemset.lead.title":`Настройки ведущих участников пула`,
"label.appupload.addobj":`Добавить в пакет`,
"lable.outlook.mcto.domain":`Добавьте мой домен (gmail.com) в список исключенных доменов.`,
"label.input.right.url":`Пожалуйста, введите действующий URL-адрес`,
"label.newprocessstep5.tip":`Страница утверждения - это страница, на которой утверждающее лицо фактически одобрит или отклонит запрос. Используя приведенные ниже опции, выберите поля для отображения на этой странице.`,
"label.schedulejob.setup.schedule.st4":`4-е`,
"label.emailsync.status.user":`Пользователи`,
"front-kefu-moudle-v1-jymm-reinput":`Пожалуйста, введите 12значный пароль, сочетающий два или более заглавных, строчных, цифровых и знаков.`,
"Lead_Scoring_Setting_Rule_Setup_RuleName":`Имя правила выставления очков`,
"label.mr.title.fieldName":`Имя поля`,
"label.data.deriall":`Экспортировать все`,
"label.tianyancha.businessverify.step2":`Включить проверку бизнес данных шаг 2`,
"label.submissions":`Представления`,
"vue_label_calendar_removed_successfully":`Календарь удален успешно`,
"label.eventrecordtype":`Типы записи событий`,
"lable.outlook.detail.syndire":`Направление синхронизации`,
"label.mobile.bind.fail":`Не удалось установить связь, повторите попытку позже`,
"label.notification.task2":`【被分配人】 просмотрел задание, которое вы назначили`,
"label.partnerCloud.orderingPlatform.paymentMethod":`Оплачивать по:`,
"label.escalation.setup.newaction.step3":`Шаг 3 Выберите пользователя для уведомления`,
"label.summaryreport.selectsum":`Выберите обобщенные данные и обобщенный тип`,
"label.components.setup":`Настройки компонентов`,
"label.taskevent.introduce":`Список Ваших действий`,
"label.assignment.setup.detail.conditon":`Критерии`,
"front-lightning-module-v1-details-page-chart-select-statements":`Выберите отчет`,
"lable.Song.typeface":`SimSun`,
"label.formulassesstrue":`формула истинна`,
"label_partner_common_setup":`Общая настройка`,
"label_chatter_dateRange":`Диапазон дат`,
"label.partner.workspace.tab.mobile.using":`Отображение на мобильном приложении`,
"message.servicecrew.time.violation1":`Нарушение времени выполнения задания: есть член команды.`,
"report_label_projectcount":`элементы, сортировать по названию отчёта`,
"label.file.uploadfile":`Загрузить файлы`,
"vue_label_commonobjects_detail_correct_email_address":`Пожалуйста, введите правильный адрес электронной почты`,
"lable.account.CurrentandNextCQr":`Текущий и следующий 3 CQ`,
"setup.layout.label.order":`Сортировать по`,
"label.service.major.event.independent":`Независимый`,
"label.icon.38":`Позиционирование`,
"label.knowledge.draft.record":`Запись, которую вы пытаетесь удалить, не найдена.`,
"label_quota_percentage":`Показать выполнение Процент квот`,
"label.escalation.setup.entrydetail.escalation.minute":`Протокол`,
"label.knowledgebase.edit.article.category":`Редактировать категорию статьи`,
"Homepage_News_003":`Невозможно отображать новости без данных аккаунта, пожалуйста, создайте новый аккаунт, и соответствующие новости будут показаны.`,
"label.mr.descreption.oneGroupNote3":`Записи.`,
"label.customsetting.touse.getListCustomSetting":`Запросить данные пользовательских настроек типа "list", вернуть все данные, соответствующие Имени API. Карта карты = cs.getListCustomSetting(String apiName);`,
"message.error.view.cannotbenull":`Ошибка: вы должны ввести значение`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.friday":`пятница`,
"message.error.view.badprevilege.qin":`К сожалению, у вас нет доступа к {1}, поэтому никаких данных не показано</br>.`,
"label.dashboard.distribution":`Распространение`,
"label.field.value.save":`Для сохранения записи всегда требуется значение в этом поле.`,
"label_custom_year":`Индивидуальный год`,
"label.code.error":`Код содержит команды или функции, которые не разрешены следующим образом:`,
"label.appexchange.uninstallpage.message2":`Постоянно удаляйте все пользовательские настройки для этих компонентов.`,
"label.global.search.obj":`Объект глобального поиска`,
"label.emailobject.from":`С`,
"lable.opppdt.selPdt.byconditions":`По полям`,
"chatter.p.note":`Примечания к этой должности`,
"label.hiddenformulaedit":`Скрытый редактор формул`,
"label.editQuotation":`Редактировать котировку`,
"label.notification.arketsea.collection":`{5}сборник{2}{0}{0}:{1}`,
"label.timzone.tip.info1":`Когда речь идет о сохранении данных типа java. util.dat （insert и update）in база данных, например, Когда речь идет о сохранении (вставке и обновлении) базы данных типа java.util.Date, например, TpSysTask task=new TpSysTask () ；task.setBeginTime (новая дата () ）；......dbman.insert (задача) или dbman.update (задача); необходимо изменить новую дату (), чтобы вызвать TimeUtil.getNowDate (userInfo), поэтому соответствующее утверждение в примере выше следует заменить на task.setBeginTime (TimeUtil.getNowDate (userInfo);).`,
"label_tabpage_transformationsz":`Конвертировать`,
"front-kefu-moudle-IP-phone":`IPтелефон`,
"label.emailobject.list.draft":`Чертежи`,
"label.tianyancha.businessverify.readandconfirm":`Я прочитал соглашение и согласен с ним`,
"label.win.customers":`Закрытые счета`,
"vue_label_commonobjects_view_switch_display":`Ваши записи сгруппированы по типу записи, для переключения отображения можно нажать на название соответствующего типа записи.`,
"pagecreator_systemstyle_label_textcolor":`Цвет текста`,
"label.autosearch.keywords":`Полный автоматический поиск ключевых слов`,
"label.knowledge.setting.data.six":`Вы собираетесь удалить категорию {lbmc}, вы уверены, что хотите продолжить?`,
"front-console-sort-field":`Дело №.`,
"label.bangladesh.time":`Бангладешское время`,
"label.dashboardSetup.number":`Числовые значения`,
"lable.account.LastbDays":`Последние 30 дней`,
"label.layout.searchdialog":`Диалоги поиска`,
"label.newprocessstep4.tip":`Выберите шаблон электронной почты, который будет использоваться для уведомления утверждающих органов о том, что им был назначен запрос на официальное утверждение. Обратите внимание, что этот шаблон будет использоваться на всех этапах этого процесса.`,
"label.nousing":`Неактивный сайт`,
"vue_label_report_detailline":`Линия деталей`,
"label.emailobject.template.message3":`Достигнуто максимальное количество почтовых шаблонов!`,
"label.c.d":`От "C" до "D"`,
"message.report.error.fail":`Загрузка не удалась, пожалуйста, попробуйте еще раз.`,
"label.edit.ccdocument.content":`изменил аттракцион.`,
"label.textmessage.exceeded":`Количество Ваших текстовых шаблонов превысило лимит!`,
"label.saveas":`Сохранить как`,
"label.visualpage.an.inline.style":`Встроенный пользовательский тип страницы для детализации страницы и главной страницы вкладки`,
"label.pagelayout.remark2":`данные. После создания макета страницы нажмите кнопку Page Layout Assignment (Назначение макета страницы), чтобы контролировать, какие страницы пользователи видят по умолчанию.`,
"label.notification.approval1":`Запрос на утверждение 【对象】, утвержденный 【审批人】`,
"label.h5.chatter.image":`Загрузка формата изображения некорректна`,
"vue_label_dashboard_displayunit":`Пожалуйста, выберите устройство отображения`,
"label.knowledge.default.language":`Язык знаний по умолчанию`,
"label.chatter.publish":`Опубликовать`,
"label.companyprofile.serveraddress":`Эта синхронизация синхронизирует только текущий сервер.`,
"label.chatter.groups":`Группа`,
"label_set_successfully":`Удачно настроен!`,
"label.quote.zongjia":`Общая цена`,
"label.project.notice.endingdatelater":`Дата окончания должна быть позже даты начала или равна ей.`,
"label.customfields.fielddependency.info":`На этой странице можно определить зависимости между полями (например, зависимые пикилисты).`,
"vue_label_lead_successful_conversion":`Успешное преобразование`,
"label.icon.93":`Книга`,
"shift.serviceresource.illegal":`Сервисный ресурс не относится к члену территории обслуживания или дата сдвига не входит в диапазон членства.`,
"label.integrations.action.addnewlead":`Добавить Новые Свидетельства`,
"label_display_all_zeros":`Показать все строки с нулевыми значениями`,
"canlendaryear":`Календарный год`,
"label_tabpage_selrecordtypez":`Выберите тип записи`,
"vue_label_commonobjects_view_chart_funnel":`Диаграмма воронки`,
"label.layout3":`Макет 3`,
"label.logintime.cue":`Время входа не указано.`,
"label.service.miniProgram.lastDate":`Дата последнего изменения`,
"label.emailobject.view.fromcrm":`Письма от контактов/лидов`,
"pagecreator.button.mobilepage":`Мобильная сторона`,
"lable.oppt.jieduan.signcur":`Отмечен как текущая стадия`,
"label.fullaccess":`Полный доступ`,
"homepage.layout.pagename":`Имя макета страницы`,
"label.appointment.wizard.subtitle4-2-3":`3 h`,
"label.knowledgebase.please.check.record":`Пожалуйста, выберите хотя бы одну запись.`,
"label.view.sortview.closepage":`Закрыть окно`,
"label_forecast_type":`Вид прогноза`,
"all.day":`Весь день`,
"label.view.sortview.printpage":`Печать этой страницы`,
"message.integration.configure":`Встроенная конфигурация пуста!`,
"label.forecast.customforecast.foretype.close":`Закрытый`,
"label_chatter_like":`Например,`,
"template.report.folder.customer.potential":`Анализ лидов`,
"label.umeng.approval.dlsp.approve":`#approvalname утвердил #actorname''s approval request of #objAPIName # recordname for you.`,
"vue_label_normal_movedown":`Опуститься`,
"chatter.group.groupAccessPermissions":`Доступ для групп`,
"label.visualpage.tip":`Вы можете создать свою собственную страницу здесь`,
"message.validation.isnotdate":`Недействительная дата`,
"label.icon.173":`Парусник`,
"label.icon.124":`Впрыск`,
"label.import.page2.csvfiled":`поле CSV`,
"setup_layout_component_area":`Территория`,
"label.visualpage.workability.standard":`Доступные стандартные классы на странице`,
"label_emailtocloudcc_redmessage9":`Ошибка базы данных, пожалуйста, свяжитесь с администратором.`,
"label_tabpage_contactsz":`Контакты`,
"label.multilang.workflow.everydayinmonth":`{1}дни каждые {0}месяцы*`,
"APPIntegration.Social.linkedinerror":`Вы должны ввести действующий URL-адрес для сайта linkedin.com.`,
"button_partner_workspace_manage_memo":`Управляйте облаком партнера и настройте свойства облака партнера.`,
"template.chart.bnsrmb":`Целевой показатель выручки на год`,
"chatter.follow.now":`Следующий сайт`,
"label.entitlement.process.condition.repeat":`Повторение установленных этапов`,
"label.relationobject.isdl":`Делегат`,
"label.lasttimemodifieralias":`Последний модификатор псевдоним`,
"vue_label_commonobjects_detail_task_name":`Редактировать имя задачи`,
"vue_label_homepage_quarterlyperformance":`Ежеквартальная производительность`,
"pagecreator.layout.message.delete":`Вы удаляете текущую выбранную раскладку?`,
"component_sendmail_label_cc":`Cc`,
"vue_label_email_enable_signature":`Включить подпись`,
"label.partnerCloud.financeSetting.create":`Создание фонда для соответствующих пользователей автоматически при активации новых партеров.`,
"label.data.file.i.title.num1":`1. Импортируемый файл должен быть в формате CSV. Файл должен содержать заголовок и не может быть импортирован без заголовка.`,
"label_efine_assessment":`Цикл оценки`,
"message.duplication.label.sectionTitle":`Выберите значение, которое вы хотите сохранить`,
"front-electronic-export-buttonExport":`Продолжить экспорт`,
"message.submitpage.email":`Поздравляю, электронная почта отправлена успешно.`,
"after":`После`,
"label.version.nonsupport":`Unsupport`,
"label.icon.105":`Расписание`,
"label.quickcreate.titledesc":`Включите быстрое создание (Quick Create), чтобы пользователи могли создавать записи из диалогового окна поиска.`,
"label.quote.number":`Введите количество`,
"label.view.sortview.setdefault.prompt":`Закрепите этот список просмотра`,
"label.refertime":`Дата отправления`,
"frame.personinfo.label.minipic":`Эскизное изображение`,
"label.mobile.home.page.newopp":`Недавно созданные Свинцы`,
"label.address":`Адрес`,
"front-pay":`Оплатить`,
"label.chat.serviceAppointment":`Уведомление о предоставлении услуг`,
"label.umeng.activity.eventviewed":`Просмотр события, которое вы назначили #name.`,
"label.validate.function.funcExplain.DATE":`Создать дату через год, месяц и день`,
"label.commiterselectapprover":`Пусть податель заявки выберет утверждающее лицо вручную.`,
"label.appointmentconfirmpage.wizard.subtitle3":`Местоположение`,
"vue_label_display_text_field":`Показать текстовые поля`,
"label.salescloud.teamrole":`Роль команды`,
"maintenanceplan.workorder.generate.limit":`Наряд на выполнение работ должен находиться в диапазоне графика технического обслуживания.`,
"label.campaignmember.selectmember.description":`выберите вид, затем добавьте участников в Кампанию, и Статус Менмебера Кампании будет следующим`,
"label.ismodify":`Разрешить редактирование`,
"label.height":`Высокий`,
"label.tabpage.thevalurofz":`Стоимость`,
"label.create_successful":`Успешное создание формы`,
"front-invoice-online-payment-setup-configure-dialog":`Настройка интерфейса оплаты`,
"label.customerinfo.smsEid":`EID шлюза SMS`,
"label.visualpage.list.no":`Нет разрешений на доступ к пользовательским страницам`,
"look.trigger.in":`Посмотреть Инструкции`,
"label.setting.disable":`Деактивировать`,
"chatter.group.name":`Группы`,
"label.solutionadministrator":`Менеджер по решениям`,
"label.vlidaterule.top":`Верхняя часть страницы`,
"pagecreator.layout.message.save.fail":`Макет сохранить не удалось`,
"label.partnerCloud.orderingPlatform.noZero":`Количество не может быть равно 0.`,
"label.customfields.suretodeleteprompt":`Подтвердить подсказки об удалении настраиваемых полей`,
"button_partner_viewdetail":`Посмотреть`,
"label.icon.122":`Дом`,
"label.customer.tab.step2.introduce":`Выберите профили пользователей, для которых будет доступна новая пользовательская вкладка. Вы также можете просматривать или изменять видимость закладок из детали и редактировать страницы каждого профиля.`,
"label.task.delegated":`Удалено`,
"vue_label_salesadvance_averageamount":`Каждая клиентская операция`,
"vue_label_chat_invitedtojoin":`{invite} пригласил тебя присоединиться к групповому чату.`,
"label.data.downpage.e_title.num1":`1. Select объекты, которые вы хотите экспортировать, или выбрать экспорт всех.`,
"label_display_options":`Параметры отображения`,
"vue_label_chatter_more_comments":`Больше комментариев`,
"label.ggReleaseRange.publish":`Опубликовать список`,
"label.valuetype.notmate":`Ошибка состояния линии, тип значения не совпадает.`,
"label.chatter.chatter":`CCChat`,
"label.exchange.sync.state.contact.m1":`Last Synced activity:`,
"label.dataimport.duplication.filter":`Поиск дубликатов штампов фильтров`,
"label.appdownload.uninstall":`Удалить`,
"message.error.task.add":`аномалия новой задачи`,
"UG.Account.07":`импортный счёт`,
"label_tabpage_lastone":`Выберите хотя бы одну операцию`,
"front-console-holdTime":`Время задержки`,
"label.emailobject.schedule":`Посмотри мое расписание и забронируй время здесь.`,
"label.lookup.locked.data":`Эта запись заблокирована, не является выборной`,
"label.assignment.setup.newentries.ifcondtions":`Запустите это правило, если`,
"label.magadan.time":`время Пьетро Павлова`,
"message.error.serviceterritorymember":`Пожалуйста, определите выбранный ресурс обслуживания как член территории обслуживания в пределах временного диапазона плана назначения обслуживания.`,
"label_chatter_delete":`Удалить`,
"label.partner.workspace.member.permission":`Набор доступных разрешений`,
"label.notification.task5":`Ваша задача просрочена.`,
"mary":`май`,
"label.homepagemodule":`Главная страница Компоненты`,
"label.compact.layout.frame.error1":`Правый экран не может не иметь содержимого`,
"chatter.error.refresherror":`Обновление провалилось, пожалуйста, попробуйте еще раз.`,
"label.login.rememberPsd":`Помни меня`,
"Lead.Scoring.Setting.Rule.Setup.01":`Ведущий список правил подсчета очков`,
"label.reportsSubscriptionPage.schedulereport.weekly.sunday":`воскресенье`,
"label.visible":`Видимый`,
"label.console.new":`Новая консоль`,
"label.mr.descreption.reDataList4":`миллисекунды. На страницу.`,
"vue_label_notice_uploadavatar_notice2":`Загруженное изображение аватара может быть только в формате JPG/PNG/GIF.`,
"label.operation.error":`Операция провалилась, пожалуйста, попробуйте еще раз.`,
"label.sendsms.context":`SMS-контент`,
"label.least.show.line":`(вывести на экран не менее 4 строк)`,
"label.tabpage.newWizardz":`Новый мастер добавления функций`,
"label.tippage.li2":`Удалить все отчеты, основанные на пользовательском источнике данных отчетов.`,
"label.customfields.new.step2.opration.unique":`Уникальный сайт`,
"label.listofshare.remark":`Просмотреть записи могут следующие пользователи`,
"label.address_information":`Адресная информация`,
"label.projectManagement.overdue.tasks":`Просроченная задача`,
"lable.account.PreviousCQ":`Предыдущий CQ`,
"label.service.miniProgram.advertising":`Название объявления используется только для идентификации нескольких объявлений и не отображается в объявлении.`,
"label.integrations.mailchimp.exportlead":`Выбранный экспорт ведет в Mailchimp`,
"label.payments.paytip3":`Пожалуйста, выберите адрес для выставления счёта`,
"label.mobile.phone.screen":`Фильтр`,
"label.h5.tome":`Обо мне`,
"label.mobile.side.tab.remark1":`Добавьте вкладку CloudCC и объект в меню навигации ползунка на мобильной стороне.`,
"vue_label_calendar_choose_a_custom_color":`Выберите пользовательский цвет этого календаря`,
"label.lastname":`Фамилия`,
"vue_label_dashboard_selectreport":`Пожалуйста, выберите отчёт`,
"label.lanxin.setting.appid":`AppID`,
"vue_label_report_information":`Экспорт отчета в том виде, как он отображается в Cloud CC, включая информацию о заголовке отчета, группе и фильтре.`,
"label_chatter_default":`По умолчанию`,
"label.globalSearch.info":`Поиск всех выбранных объектов`,
"label.integrations.mailchimp.massage2":`Экспорт выбранных ссылок в Mailchimp, и Вы сможете просмотреть их в списке Mailchimp позже.`,
"label.tabpage.addresswrongz":`Формат адреса почтового ящика неправильный, пожалуйста, правильно введите адрес почтового ящика!`,
"label.mobile.phone.customer.call":`Визит-клиент`,
"vue_label_email_linkrecordfail":`Запись несвязанная`,
"lable.account.LastfDays":`Последние 90 дней`,
"label.cpq.order.status.delete":`Этот заказ активен и не может быть удален`,
"label.ccchat.notmember.active.group":`Вы не являетесь членом`,
"label.savepayset.failure":`Не удалось сохранить счет онлайн-платежа`,
"label.version.createlimitbyobject":`Ваше текущее издание CloudCC {0}, и вы можете создать {1}. {2}для каждого объекта. Теперь количество {2} превысило максимальное значение вашего плана подписки, пожалуйста, обновите вашу версию CloudCC.`,
"approval.process.errore":`Во время сохранения произошла ошибка, пожалуйста, свяжитесь с администратором.`,
"label.stdashbord.xsld.business.reportanalysis":`Анализ графиков`,
"label.login.verification.please.enter":`Пожалуйста, введите код безопасности, который вы получите из приложения МИД.`,
"label.tabpage.cue":`Информационное напоминание`,
"vue_label_salesadvance_converserate":`Коэффициент конвертации`,
"label.marketsea.recyclereminddays1":`Перед автоматической переработкой`,
"label.import.page1.update":`Обновление`,
"label.document.folder":`Папки для документов`,
"label.h5.similar.opportunity.feature":`Эта функция позволяет пользователю искать возможности, которые имеют общие поля с возможностью. После включения данной функции в записи о сделке появляется список Похожие Возможности.`,
"label.myanmar.time":`Мьянма Время`,
"monday":`Понедельник`,
"vue_label_account_shareholder":`Акционер`,
"button.partner.search":`Задать вопрос`,
"label.partnerCloud.partnerAccount.topUpAmount":`Сумма пополнения`,
"label.tabpage.refreshz":`Обновить`,
"lable.PowerProcess.complete":`Завершение этапа мин`,
"front-kefu-moudle- normal-phone":`Общий телефон`,
"label.user.unauthorized.organization":`Несанкционированная организация, пожалуйста, свяжитесь с администратором.`,
"label.area.canot.save.nulldata":`Невозможно сохранить нулевые данные`,
"label.version.role.management":`Ролевое управление`,
"label.recordtype.batchaddattachments.batch.remark":`Шаг 1 Выберите файл, шаг 2 Нажмите кнопку "начать загрузку", загрузить файлы, шаг 3 Нажмите кнопку, чтобы закончить.`,
"label_tabpage_contentz":`Пожалуйста, введите содержание`,
"label.partner.workspace.member.all":`Все`,
"label.validate.function.funcFormat.LEFT":`LEFT(текст, num_chars)`,
"vue_label_SMS_notice_selectatleastone":`Пожалуйста, выберите хотя бы один провод или контакт`,
"label.appupload.install.error.choice5":`Немедленно остановите установку и выведите на экран конфликтующие компоненты.`,
"label.version.lookupmdfield":`Область магистрально-детальных отношений`,
"setup.layout.label.desc":`Поступающий`,
"vue_label_report_addsummaryformula":`Добавить сводную формулу`,
"label.done":`Готово`,
"label.input.samevalue":`Введите то же значение`,
"label.SMS.next":`Выберите объекты для SMS-уведомлений и нажмите "Далее". SMS-уведомления могут быть ассоциированы только с одним типом правил рабочего процесса и процессов утверждения.`,
"label.role.allunselectuser":`Все Назначенные пользователи`,
"label.loginhistory":`История входа`,
"vue_label_report_addpublicreportstofolder":`Добавить публичные отчеты в эту папку`,
"label.email.track.no.attachment":`Нет приложения`,
"label_network_connection_failure":`Не удалось установить сетевое соединение.`,
"vue_label_file_delete_lib_member":`Удалить член библиотеки файлов`,
"label_partner_step1":`Шаг 1 Выбор шаблона`,
"label.password":`Пароль`,
"label.select.the.fields.around.code":`Выберите поля, которые будут отображаться вокруг QR-кода/бар-кода.`,
"label.file.share.limit":`При превышении лимита акций новая акция не может быть добавлена!`,
"label.desktop":`Рабочий стол`,
"label.sendmail":`Отправить электронное сообщение`,
"label.quote.detail":`Строки котировок Пункты`,
"label.approvalstep2":`Шаг 2 Укажите критерии шага`,
"label_component_hotdeal_nodata":`Нет данных, связанных с бизнес-возможностями.`,
"lable.reset":`Сброс`,
"label.eventpagelayout":`Макеты страниц событий`,
"label.icon.100":`Канцтовары`,
"UG.quota.03":`Шаблон для цитирования`,
"label.calendar.week.view":`Вид на неделю`,
"component_chatter_file_button_save":`Опубликовать`,
"label.as":`Как`,
"template.chart.yqxypjz":`Средний ожидаемый ответ`,
"UG.Contract.03":`Заключить договор`,
"label.projectManagement.gantt":`Диаграмма Ганта`,
"label.forecast.edit.error0":`Ошибка: Вы должны выбрать хотя бы одну или корпоративную валюту.`,
"label.ccpeak.delete.sharetab":`Удалить совместную форму`,
"label.account.contact.goback":`Назад к счетам`,
"vue_label_email_insert_field":`Пожалуйста, выберите поле для вставки`,
"setup_object_field_dependency_label_fieldvalueoptions":`Доступные значения полей`,
"label.salescloud.opportunity.contactrole.optionlist.main":`Ниже приведен основной список параметров для поля "Контактные роли" по возможностям.`,
"label.huanxinconfig.tenantid.lost":`tenantid не может быть пустым`,
"label.mask.show.last_4":`Маска последние четыре символа`,
"label.targer.name":`Название показателя`,
"vue_label_commonobjects_detail_unlocksuccess":`успешно разблокирован`,
"front-kefu-moudle-length-min":`Продолжительность (минуты)`,
"label.chat.topic.my.favorite":`Темы моих закладок`,
"chatter.upload":`Загрузить`,
"message.cannotapproveit":`Запрос на утверждение не может быть обработан.`,
"label.weixin..xsld.order.by.jine":`Сортировать по договорам Сумма`,
"label.projectManagement.wait.test":`Ожидание тестирования.`,
"template.report.customer.contact.list":`Список контактов счетов`,
"label.empty.recycle.bin":`Чистый контейнер для мусора`,
"label.detail.approveprocess":`Процессы утверждения вида`,
"label.appexchange.uninstallpage.message4":`Постоянное удаление всех отчетов, представлений и пользовательских вкладок пользовательских объектов в данном пакете`,
"label.weixin.linkreport":`Связанный с этим сайт to→Report`,
"label.tianyancha.orgnumber":`Код организации`,
"Q":`Пиклист (мульти-выбор)`,
"pagecreator_systemstyle_message_save_fail":`Стиль спасения не удалось`,
"label.partner.new":`Облако партнеров: новое`,
"label.ems.accounttype":`Тип счета (а)`,
"label.weixin.next":`Следующий`,
"label.weixin.coach.interpret":`Aid-Max оставляет за собой право на пересмотр и окончательное толкование в рамках закона об услугах WeChat.`,
"label.some":`запись(и)`,
"label.currency.rate":`Редактирование валюты: курсы конвертации`,
"label.emailobject.template.name":`Наименование шаблона`,
"UG.Campaign.001":`Планирование кампаний`,
"label.mr.descreption.reDataList3":`группы данных, время запроса`,
"label.project.hit.nine":`Ежедневное напоминание о выпуске`,
"lable.PowerProcess.golist":`<<Задний список：Процесс получения права на наследство`,
"label.viewbuttonedit.remark":`Выберите стандартную и пользовательскую кнопки, отображаемые на переднем плане.`,
"label.component.helper":`Помощник`,
"lable.SalesCommitmentKanBan.contractAndReceipts":`Подписанный платеж`,
"chatter.group.userName":`Имя пользователя`,
"label.mobile.phone.business":`Возможности`,
"label.quickbooks.payments":`ОПЛАТА`,
"label.step6.total7":`Шаг 6 из 7`,
"label.forecast.detailforecast.revenue":`Прогноз доходов`,
"vue_label_commonobjects_view_chart_displayas":`Показать как`,
"label.recordeditoption":`Редактируемость записей Свойства`,
"label.sendemail.send.sendfailstandby":`Отправка электронной почты не удалась, пожалуйста, свяжитесь с вашим администратором (запасной почтовый ящик). (код ошибки:`,
"label.knowledgebase.reset.filter":`Сброс фильтра`,
"label.icon.111":`Еда`,
"label.standard.buttonandlink.firstsetting":`Отменить свойства`,
"front-filter-module-v1-filter-description":`Флешфильтр нельзя сохранить. Он применяется только к текущей операции, не оказывая никакого влияния на просмотры или других пользователей.`,
"label.showmore":`Подробнее`,
"UG_Lead_001":`Как внедрить подсказки?`,
"label.exchange.sync.state.setting.m1":`Предоставлен аккаунт службы Miscrosoft Exchange:`,
"label.please.enter.channel.name":`Пожалуйста, введите название канала.`,
"label.emailtocloudcc.edit":`Редактирование`,
"label.layout.tabdialog":`вкладки`,
"label.Emoji":`Emoji`,
"template.report.completed.tasks":`Выполненные задачи`,
"label.tabpage.enterviewname":`Шаг 1, пожалуйста, введите название вида`,
"label.mobile.phone.not.to.choose":`Никто Не выбран`,
"label.datamanage.contact.namenull":`Примечание: Если поле имени контакта является нулевым, запись не будет импортирована.`,
"LT":`Геолокация`,
"label.exchange.sync.state.task.m3":`Записи синхронизированы за последние 24 часа:`,
"lable.SalesCommitmentKanBan.contractOwner":`Контрактный владелец`,
"vue_label_chatter_write_review":`Написать комментарий`,
"label.h5.approval.enter.content":`Пожалуйста, введите примечания по утверждению`,
"label.location.display.type":`Метод отображения широты и долготы`,
"label.numberscannotnull":`Номер не может быть пустым`,
"label.icon.3":`Валюта`,
"setup_object_field_dependency_label_linkedfieldvalue":`Зависимое поле`,
"label.task.future":`Задачи на будущее`,
"label.look.more.record":`Показать больше`,
"vue_label_account_cases":`Перевести все случаи владельцев клиентов`,
"label.emailobject.emaildetail.title.ccaddress":`КК:`,
"label.setHistoryTrack":`Установить историю Отслеживание`,
"ObjectDetailed.ViewKeyInformation.Layout":`Редактирование ключевой информации`,
"label.layout.editsearchdistribute.tip":`Выберите поля для включения в эту схему поиска. Обратите внимание, что выбранные Вами варианты определяют только отображение результатов поиска и не влияют на поля, в которых фактически выполняется поиск.`,
"label.emailtoall":`Отправляйте электронные письма всем пользователям.`,
"label_partner_new":`Облако партнеров: новое`,
"label.direct.dashboard.me.not.approval":`Мои пункты для утверждения`,
"label.platform.customize.customizeui":`Пользовательский пользовательский интерфейс`,
"label.userinfo.pwderror.againinput":`Пароль, введенный дважды, не является одинаковым. Пожалуйста, введите заново.`,
"label.customsetting.introduce":`Используйте пользовательские настройки для создания и управления пользовательскими данными на уровне организации, профиля и пользователя. Данные пользовательских настроек хранятся в кэше приложений. Это означает, что вы можете получить к ним эффективный доступ без затрат на повторные запросы.`,
"label.file.owner":`Владелец`,
"label.icon.7":`Люди`,
"label.document.query.button":`Нажмите просмотр, чтобы найти файл`,
"label.tabpage.turnoffsz":`Закрыто  Преобразовано`,
"message.error.appid.appsecret.failed":`Не удалось получить ключи secrest!`,
"vue_label_commonobjects_view_to_display_fields":``,
"label.martrixreport.setlinetitle":`Укажите заголовки строк`,
"vue_label_chatter_applycertification":`Согласен "{имя}" присоединиться к групповому чату?`,
"front-electronic-export-success":`Экспорт прошел успешно, пожалуйста, проверьте его в списке Mailchimp`,
"label.emailsync.status.enable":`Активное подключение`,
"label.c_d":`От C до D Relationship:`,
"PageLayout_Search_MultiSearch_003":`Выберите хотя бы одно поле.`,
"label.tabpage.newInterfacez":`Новый интерфейс`,
"label.cutomsummaryfieldedit":`Редактирование настраиваемого суммарного поля`,
"label.usermanage.view.field.notexist":`Поле, соответствующее представлению, не существует.`,
"label.list.userinterface.dashboard.setup":`Настройка приборной панели`,
"label.knowledgebase.delete.article":`Удалить статью`,
"label.dataimport.type.update":`Обновление`,
"label.marketsea.new":`Новый бассейн`,
"label_tabpage_newlybuildz":`Новый сайт`,
"vue_label_helpcenter_report1":`1Создание отчета<br> Отчет Молнии в системе управления продажами Cloud CC является мощным инструментом анализа данных. Многие проблемы с продажами могут быть решены путем группировки, фильтрации и суммирования записей. Например: "Какой доход компания получила за последний квартал?". Графики отчетов могут быть добавлены на основе заполнения обзора данных. После завершения работы над отчетом нажмите кнопку "Запуск", чтобы просмотреть полные результаты данных. <br> Шаг 1: На вкладке отчета нажмите кнопку "Новый отчет";<br> Шаг 2: Выберите источник данных отчета, а затем нажмите кнопку "Далее";<br> Выбранный источник данных отчета позволяет определить, какие записи или поля можно использовать в отчете. Выберите или выполните поиск объекта в качестве основного. Вы можете выбрать до 4 объектов, которые имеют керлинг с основным объектом, а также выбрать связь между объектами. <br> Шаг 3: Войдите на страницу редактирования отчета и отобразите данные предварительного просмотра<br> В режиме редактирования вы можете настроить отчет, добавить поля в виде колонок в отчет, сгруппировать строки и столбцы, а также использовать фильтры для фильтрации данных отчета до тех пор, пока нужные вам данные не будут точно отображены<br>Добавить или удалить столбцы и настроить порядок<br> Добавить столбец: В режиме редактирования отчета нажмите на поле ввода "Колонка" в "Сводке" в левой части страницы и добавьте колонки отчета после поиска по полю или прокрутки выпадающего списка полей и выбора целевого поля. <br> Удалить колонку: <br> A. После нахождения "столбца", который необходимо удалить в списке "столбцов" слева, нажмите на поле "×". <br> B. Или найдите "столбец", который хотите удалить, в заголовке просмотра отчета справа, нажмите на "выпадающую кнопку", и нажмите на "удалить столбец".<br> Удаление столбца из отчета не удаляет поле. Если вы хотите восстановить колонку после удаления, просто добавьте ее еще раз. <br> Отрегулируйте порядок следования колонок: Перетащите поле "Колонка" в список "Колонка" слева вверх и вниз, чтобы настроить порядок расположения "Колонки". <br>Добавить и удалить группировку строк и столбцов<br> Добавить группировку строк: Щелкните поле ввода "Групповая строка" в "Сводке" в левой части страницы и добавьте поля группировки строк отчета для фильтрации данных после поиска по полю или прокрутки выпадающего списка полей с последующим выбором целевого поля. <br> Без добавления группировки столбцов можно добавить до трех групп строк. <br> Добавить группировку столбцов: когда группировка столбцов существует, вы можете добавить группировку столбцов. Щелкните поле ввода "Сгруппировать столбцы" в "Сводке" в левой части страницы, выберите поле после поиска или прокрутите выпадающий список полей и выберите нужное поле Способы добавления группировки столбцов отчета для фильтрации данных. <br> Вы можете добавить до двух групп колонок. В случае добавления групп колонок можно добавить до двух групп строк. Поля, добавленные как группы строк, не могут быть добавлены как группы колонок. <br>`,
"label.notification.event1":`【分配人】 назначил тебе событие.`,
"chatter.field":`Поле (поля)`,
"chatter.feed.menutype.feed.newscom":`Все, за чем я следую`,
"label.attendance.range":`Диапазон посещаемости`,
"vue_label_calendar_deleteconfirm":`Вы уверены, что удалите календарь?`,
"label.ems.createTask":`Новый {taskName}`,
"label.visualpage.wgd":`Нефилированные пользовательские страницы`,
"label.multilang.product.deleterederect1":`Ваша попытка удалить <font style="font-weight:bold;">{0}</font> не была завершена, так как она все еще связана со следующей записью. В этом случае мы рекомендуем отключить ее.`,
"label_emailtocloudcc_filed_servertype":`почтовый сервер`,
"label.umeng.insert.approval.dlsp.approvenew":`#actorname представляет #objAPIName#recordname на ваше одобрение`,
"label.tabpage.queue":`Очередь`,
"label.approval.step":`Этапы утверждения`,
"label.approvaldatamove.approvalprocessname":`Наименование процесса`,
"label.actualapprovedpeople":`Фактический утверждающий`,
"label.systemlog.f":`ФАЙЛУРА`,
"front-template-V1-addText":`Добавить текст`,
"label.chat.like":`Например,`,
"label.userinfo.oldpwd.notnull":`Старый пароль не может быть пустым.`,
"label.service.all.done.major.event":`Вы завершили все этапы.`,
"label_chatter_to":`На`,
"message.toomuchlinecannotoutput":`Слишком много столбцов отчета выбрано, и отчет не может быть выдан.`,
"maintenanceasset.assetid.maintenanceplanid.unique":`План обслуживания был назначен активу. Пожалуйста, не назначайте его повторно.`,
"lable.quote.syncing.firstsync.description":`Пункты котировок заменят альтернативные продукты`,
"lable.outlook.mcto.saveemail":`Обязательно сохраните вложения`,
"label.passwordPolicy.setup.pwdremember2":`2 пароля`,
"label.project.hit.five":`Уведомление об обновлении задания`,
"label.linkedin.setting.appid":`Секретный ключ`,
"label.dataimport.error.name.notnull":`Ошибка: имя не может быть нулевым`,
"label.knowledge.case.field.selected":`Выбранные поля дела`,
"label.version.datetime":`{0} поля даты/времени`,
"Dashboard_NoAccessRightToSee_Warning":`У вас нет разрешения на просмотр дашбоад {0}, которые установлены как defualt open, пожалуйста, сбросьте.`,
"label.login.access.permission":`Предоставить доступ к`,
"label.operatedata.import.tip":`1. Импортируемый файл должен быть в формате CSV. Файл должен содержать заголовок и не может быть импортирован без заголовка. 2. Рекомендуется экспортировать перед импортом, сопоставить данные, которые необходимо импортировать для шаблона данных, с экспортным документом, а затем импортировать.`,
"workflow.action.tasks.assignortype.rolename":`Имя роли`,
"vue_label_account_quotations":`Передайте все предложения клиента владельцу`,
"lable.account.CurrentCQ":`текущий CQ`,
"label.user.database.error":`Ошибка базы данных!`,
"label_emailtocloudcc_titel":`Электронная почта в CloudCC`,
"label_file_content":`Содержание текста`,
"label.button.behavior":`Поведение`,
"message.recordtype.new.tip":`Введите данные`,
"label.ccchat.message.new.error3":`Ошибка: нельзя выбрать более 9 получателей.`,
"vue_label_commonobject_notice_lessthanwords":`Имя файла должно быть меньше слов {FILE_NAME_COUNT}!`,
"label.stacked.verticalline":`Штабелируемые вертикальные колонны`,
"vue_label_SMS_messagebox":`Ящик для сообщений`,
"label.appexchange.installedpage.message3":`</b>В зависимости от ссылок рядом с установленным пакетом, вы можете предпринять различные действия с этой страницы. Чтобы удалить пакет, нажмите <b>Удалить</b>. Для управления пакетными лицензиями нажмите <b>Управление лицензиями</b>.`,
"label.unusedapproveprocess":`Неактивные процессы утверждения`,
"label.onlywithspecificconditions":`В расчет следует включать только записи, отвечающие определенным критериям.`,
"lable.outlook.mcto.formaterror":`Ошибка формата`,
"label.area.parent":`Материнская территория`,
"vue_label_chat_activesuccess":`Успешно активирован`,
"label.setting.intergrationlist.button.upgrade":`Обновление`,
"label.page_hidden":`Скрытые поля для страницы регистрации`,
"label.customsetting.manage.belong":`Владелец установки`,
"label.appointment.wizard.subtitle4-2-8":`7 дней`,
"template.chart.ydywjhxsje":`Ежемесячная сумма продаж бизнесвозможностей`,
"label.multilang.currencylist.after":`После {0}`,
"vue_label_commonobjects_view_chart_countby":`Посчитать по`,
"label.week":`Неделя`,
"label.emailtemplate.name":`Наименование шаблона`,
"label.umeng.sign":`зарегистрированный`,
"label.appupload.upload.details":`Подробности`,
"label.file.loading":`Загрузка`,
"label.newdetail.orgTitle":`Контактные роли`,
"label.salescloud.field.addoptionlist":`Добавить Значения Пиклиста`,
"pagecreator.page.funcpath":`/ конструктор / список страниц`,
"Account.News.Setting.001":`Настройки аккаунта`,
"label.marketsea.getnoconversiondays":`Дни, не конвертированные (должно быть больше, чем количество дней без последующих действий после получения)`,
"message.error.event.add":`аномалия нового события`,
"front-electronic-export-choseChimp":`Пожалуйста, выберите экспортируемый список Mailchimp`,
"vue_label_report_personothers":`Другие`,
"label.hierarchy.diagram":`Иерархическая структура`,
"label.stdashbord.xsld.business.yqsr":`Ожидаемый доход`,
"label.chat.topic.max.count":`Вы достигли максимального количества тем.`,
"label.sendemail.send.sendfail":`Отправка электронной почты не удалась, пожалуйста, свяжитесь с вашим администратором.`,
"registration.page.body.title":`Страница регистрации`,
"label.userphoto.back":`Назад`,
"label.service.without.timeslot":`Временных интервалов, похоже, нет, давайте добавим!`,
"label.processsetting.remaining.quantity":`Можно ввести до 255 символов:`,
"label.sure.delete":`Подтвердить удаление`,
"front-epwechat-module-v1-callback":`Конфигурация обратного вызова`,
"front-email-payment-failed":`Извините, платеж не прошел!`,
"label.icon.67":`Машина`,
"UG_Forcast_01":`Прогноз`,
"label.escalation.setup.newentries.step3":`Шаг 3 Укажите, как устанавливается время эскалации`,
"lable.account.NextCY":`Следующий CY`,
"report.type.label.quote":`Цитаты`,
"label.area.name":`Наименование территории`,
"component.setup.label.object":`Объекты`,
"label.customsetting.type":`Тип установки`,
"label.showdetail":`Показать детали`,
"label.department.prev":`Предыдущая страница`,
"label.select.data.source.report":`Пожалуйста, выберите Отчет об источнике данных`,
"UG_homepage_002":`Управляйте своими ключами, зацепками, воронками торговых операций и информацией об учетной записи с помощью интегрированных бизнес-инструментов`,
"vue_label_report_notice_exprot1":`Экспортируются только строки деталей. Используйте эти данные для дополнительных вычислений или загружайте в другие системы. Экспорт по страницам, до 5000 элементов на одной странице.`,
"message.error.task.phonecreate":`аномалия при создании телефонной задачи`,
"label_chatter_day":`День`,
"label.setinitialcommiter":`Шаг 6 Укажите первоначальных отправителей`,
"message.huanxinconfig.notfound":`Конфигурация Easemob не найдена`,
"label.customfields.file.count.tip":`Пожалуйста, введите количество файлов, которые могут быть введены в это поле, по умолчанию 1`,
"label.weixin.appmanage":`Управление приложениями`,
"label.approverautoconfirm":`Автоматический утверждающий орган, определяемый`,
"vue_label_CCChat_followers":`Писатели`,
"label.usermanage.notselect":`Пользователи не выбраны.`,
"label.item":`Объект(ы)`,
"label.sendemail.chat.linkurl":`URL ссылки:`,
"label.sendmail.step3.deliveroptions":`Опции доставки`,
"homepage.components.creationtime":`Дата создания`,
"label.pc.ui.2018.ccchat.setting":`настройка CCChat`,
"label.knowledge.search.result.highlight":`Выделите релевантные статьи в результатах поиска`,
"label.data.downpage.e.title.num2":`2、Если вы решили экспортировать данные одного объекта, вам нужно выбрать, как данные экспортируются: пользовательский экспорт, экспорт по шаблону и экспорт шаблона.`,
"label.field.duplicate.error.msg1":`Здесь приведены дублированные данные, пожалуйста, сначала проверьте дублированные данные, а затем настройте уникальное свойство.`,
"label.campaign.channel.input.number.error":`Ошибка формата номера`,
"label.goto.dashboard":`Перейти к Приборным панелям`,
"com.cloudcc.login.error.message.invalid.ip":`Ваш IP-адрес не находится в диапазоне IP-адресов.`,
"label.selectnewfieldvalue":`Укажите новое значение поля`,
"label.appointmentdetail.wizard.title11":`Дата окончания`,
"Opportunity_Detailed_Phase_Label_Popup_001":`Дата начала текущего этапа`,
"front-dynamiclayout-module-v1-readonly":`Поле {required} установлено как Read Only.`,
"vue_label_calendar_start_field":`Поле для старта`,
"label.weixin.recalculate.shared.failed":`Пересчет правила совместного использования объектов не удался.`,
"label.sendmail.step3.dealoptions":`Опции обработки`,
"setup_layout_label_modifypage":`Редактировать макет страницы`,
"homepage.components.select.wide":`Выберите "Широкие компоненты", чтобы показать`,
"label.import.page1.laststep":`Предыдущий`,
"label.weixin.donot.permission":`У вас нет разрешения на выполнение этой операции.`,
"message.error.name.null":`имя не может быть пустым!`,
"label.salescloud.teamrole.optionlist":`Команда Значения ролевого списка`,
"component_setup_label_titlefield":`поле заголовка`,
"vue_label_commonobjects_detail_have_been":`Ты был`,
"label.textmessage.vonage.setup":`Настройка вонажа`,
"label.recordtype.profile.enableit":`Включить для профиля`,
"UG.product.04":`Создать продукт`,
"label.knowledge.No.related.articles":`Нет соответствующей статьи...`,
"label.chat.muted":`Не беспокоить`,
"registration.page.field.selection":`Выберите поле страницы регистрации`,
"label.project.hit.eleven":`Выдача уведомления о назначении`,
"lable.newtabpage.advsearch":`Расширенный поиск`,
"label.report.share.roleandsub":`Роли и внутренние подчинённые`,
"component.salesperformance.label.nodata":`Добавьте свою бизнес-возможность и вернитесь сюда, чтобы просмотреть график производительности.`,
"label.submitted_on":`Представлено на`,
"label.file.create.link":`Создать ссылку`,
"label.contact":`Контакты`,
"label.tab.message.failtoopenleft":`В результате операции слияния не удалось открыть левый столбец.`,
"label.replaces":`Заменить`,
"label.customcomponent.check.tag.startwith":`Компонент должен начинать с ярлыка &lt;cc:component&gt;.`,
"label.tab.web":`Веб-вкладки`,
"message.success.task.add":`Успешное сохранение информации о новой задаче`,
"label.chatter.addresser":`Отправитель`,
"label.mobile.homepage":`Домашняя страница`,
"label.data.imp.su.ok":`Импорт`,
"label.knowledge.category.hint.one":`Группа категорий - это иерархия категорий данных. Например, группа категорий под названием "Местоположение" может содержать географическую иерархию континента, страны, региона и штата. Используйте эту страницу для управления группами категорий и подкатегориями.`,
"label.schedulejob.setup.schedule.weekly":`Еженедельный сайт`,
"label.tag.manage.description":`Все теги {0} следующие. Вы можете переименовывать или удалять доступные теги.`,
"label.tabcontrol":`Вкладки`,
"label.field.duplicate3":`Трактовать "ABC" и "abc" как дублирующие значения __(нечувствительные к регистру).`,
"label.customsetting.type.list":`Список`,
"lable.account.ovdate":`Дата окончания финансового квартала`,
"label_chatter_pastSevenday":`За последние 7 дней`,
"front-kefu-moudle-v1-lxndxsdb-free":`Обратитесь к своему торговому представителю и включите услугу "Свободный агент".`,
"label.termsforusage":`Условия использования`,
"label.forecast.settings.qijian.m":`Прогноз на месяц`,
"label_tabpage_viewname":`Название вида`,
"label.report.action.addtodashboard1":`Добавить в Приборную панель`,
"label_vue_create_edit_obj_create_event_dialog_desc":`Назначенный вами пользователь уже занимается расписанием:`,
"vue_label_report_standardfilter":`стандартный фильтр`,
"label.umeng.approval.submit":`#applyer представил запись #obj на утверждение.`,
"label.tab.mobile.sign":`Иконка мобильной стороны`,
"vue_label_commonobjects_detail_check_the_content":`Есть ошибка проверки, пожалуйста, проверьте содержание.`,
"UG_Campaign_001":`Планирование кампаний`,
"chatter.group.baseInformation":`Основные сведения`,
"label.sendemail.send.noreceiver":`Ни адрес получателя, ни адрес получателя не пустые.`,
"template.chart.yskje":`Сумма дебиторской задолженности`,
"label.textarea":`Текстовая область`,
"vue_label_statistics_value":`Статистическая ценность`,
"font-evaluate-module-v1-select-img":`Выберите изображение`,
"label.totalof":`Вы в общей сложности`,
"label.hangye":`Отрасли`,
"label.partner.common.setup":`Общие настройки`,
"label.icon.78":`Сельское хозяйство`,
"lable.outlook.detail.addemail":`Добавить Электронную почту`,
"label.ServiceCloud.fuwuquyu":`Территория обслуживания`,
"label.gb2312encoding":`китайский (GB2312)`,
"label.appointment.wizard.subtitle4-3-1":`10 мин`,
"label_emailtocloudcc_reauthorization":`Повторная авторизация`,
"label.approval.message":`Заключения об одобрении могут быть введены до 1000 знаков.`,
"label_component_helper":`Помощник`,
"label.editRate":`редактирование валютных курсов`,
"label.setuptemplate":`Шаблоны автоматизации`,
"label_emailsync_button_cancel":`Отменить`,
"label.marketseamemset.account.maxuser":`Максимальное количество клиентов`,
"label.someerror":`Из соображений безопасности, ваша сессия CloudCC скоро закончится.<br><br>Что вы собираетесь делать дальше?`,
"label_person_in_charge":`Супервайзер`,
"label.visualpage.reference.standard.style":`Вызовите стандартный стиль Платформы, пользовательский стиль.`,
"errormessage_email_relatedorreceivermusthaveone_z":`Необходимо выбрать хотя бы одного получателя или смежную тему.`,
"label.insert.field.empty.continue":`Записи с недействительным значением 【{resDataField}】 существуют, поэтому код не может быть сгенерирован. Хотите ли вы продолжить генерацию?`,
"component.newrecords.label.title":`Последние записи`,
"template.detail_info_link":`Ссылка на детали`,
"component_setup_tabs_label_default":`Страница по умолчанию`,
"label.emailobject.template.name.null":`Имя шаблона письма не может быть empty！.`,
"label.knowledge.field.changed":`{1} изменяется`,
"homepage.components.select.narrow":`Выберите узкие компоненты, чтобы показать`,
"label.mobile.phone.week":`Неделя`,
"component_chatter_button_like":`Например,`,
"label.brief.won":`Выиграл`,
"label.setup.profile.replaceme":`Заменить вещи обо мне`,
"label.knowledge.setting.enable.lightning":`Активировать знания о молнии`,
"label.middle":`Middle`,
"label.icon.109":`Люди`,
"vue_label_normal_activity_sf":`Деятельность`,
"chatter.poll.option6":`Выбор 6`,
"label.lanxin.setting":`Интеграция Lanxin H5 MiniApp`,
"label.stdashbord.xsld.business.totals":`Общие возможности`,
"label.emailobject.emaildetail.promptbutton1":`Подтвердить`,
"Opportunity.Detailed.Phase.Label.001":`Этап`,
"label.customcomponent.params.info":`Как использовать параметры.`,
"label.emailtocloudcc.button.next":`Следующий`,
"front-email-payment-billing-date":`Дата счетафактуры`,
"label.ems.with3day":`В течение 3 дней`,
"label.project.subtask.date":`Дата подзадачи должна находиться в диапазоне дат задачи, к которой она относится.`,
"label.role.allunselectanduseduser":`Все неназначенные и активные пользователи`,
"front-kefu-moudle-yes-wantbuy":`Да, я хочу приобрести`,
"label.looking_for":`Получили ли вы то, что искали?`,
"page.404.label.noresource":`К сожалению, ресурса, к которому вы хотите получить доступ, не существует.`,
"vue_label_ccchat_notice_deletecommentcertification":`Вы уверены, что хотите удалить этот комментарий?`,
"label.data.setok.e.desc1":`Экспорт успеха, вы будете получать системные сообщения оповещения, производные данные временно хранятся на сервере, система только для вас, чтобы сохранить 48 часов, пожалуйста, как можно скорее, чтобы`,
"label.weixin.confirm.delete":`Вы уверены, что хотите удалить эти данные?`,
"A":`Область текста (богатый текст)`,
"template.report.sales.cycle":`Продолжительность цикла продаж`,
"label.service.shift":`Рабочие смены`,
"label.visualpage.display.side.bar":`отображение боковой панели, false-do не отображать боковую панель`,
"label.list.userinterface.chatter.showall":`Домашняя страница CCChat показывает все сообщения по умолчанию.`,
"vue_label_systemSettings_set_course":`Настройте путь, добавив подсказки для каждого этапа, чтобы направлять пользователей шаг за шагом.`,
"label.icon.156":`Люди`,
"label.marketsea.button.move":`Переместить`,
"front-email-payment-select-email":`Пожалуйста, введите почтовый индекс`,
"front-electronic-signature-service-provider":`Поставщик услуг`,
"label.h5.add.checkin":`Зарегистрироваться`,
"vue_label_amount_total":`Общая сумма`,
"label.campaign.channel.new":`Campaigns: Новый маркетинговый канал`,
"label.knowledgebase.restore.creates.draft":`Восстановление создаст черновик из текущей версии. Вам необходимо опубликовать черновик для всеобщего обозрения.`,
"UG_Case_01":`Дело`,
"label.validate.function.funcExplain.CONTAINS":`Проверьте, содержит ли текст определенный символ, и если да, верните TRUE, в противном случае верните FALSE.`,
"label.data.exp.savetemp":`Сохранить как шаблон`,
"front-project-module-v1-template-newcreate":`Создание проекта из шаблона проекта`,
"label.field.default.count":`Номер строки по умолчанию`,
"page.note.acc":`Примечания`,
"label.close":`Закрыть`,
"label.app.detailbeforeedit":`Подробная информация о пользовательских приложениях приведена ниже. Нажмите кнопку "Правка", чтобы изменить пользовательские приложения.`,
"label.profile.standardfieldsafety":`Стандартная защита на полевом уровне`,
"vue_label_report_notice_deletefilter":`Пожалуйста, сначала удалите расширенный фильтр`,
"label.multilang.datamoveaction.movesuccess":`Всего было успешно передано {0} записей!：`,
"label.emailmerge.edittemplate.descirption":`Введите информацию о вашем шаблоне почтового объединения. Обратите внимание, что описание отображается только в CloudCC.com, а не в Word.`,
"label.visualpage.at.the.end":`Используйте метку на конце`,
"label.exchange.sync.state":`Состояние обмена синхронизировано`,
"label.newdashboardpage.new":`Добавить строку`,
"label.querydetailservice.profile.notsetup":`Профиль для вашего аккаунта не установлен.`,
"label.escalation.setup.detail.description":`Добавьте записи правил, которые определяют критерии, используемые для эскалации случаев. Вы можете переупорядочить записи правил на этой странице после их создания.`,
"lable.setup.mobilesetup.isenbaleh5newandedit":`Если включить h5 в мобильной стороне и отредактировать`,
"vue_label_file_upload_tip_msg":`Мы рекомендуем, чтобы загруженный файл был меньше 30MB, в противном случае это может привести к медленной загрузке страницы.`,
"label.eowechat.epdeptid":`Идентификатор отдела WeCom`,
"label.adminorapprover":`Администраторы <strong>OR</strong> назначенного в данный момент уполномоченного могут редактировать записи во время процесса утверждения.`,
"label_emailtocloudcc_email":`Email`,
"setup_main2018_label_norole":`У вас нет административных разрешений`,
"label.onlyone":`Уникальный сайт`,
"label.sso.saml.idp.config.nameidtype":`Тип темы`,
"vue_label_normal_campaign_sf":`Кампании`,
"label.icon.61":`Кран`,
"label.datatype":`Тип данных`,
"label.mobile.home.page.today.work":`Моя работа`,
"label.sendemail.chat.praiseFeedcommentsubject":`CloudCC CCChat понравился ваш комментарий.`,
"chatter.sel.p":`Выбран 0.`,
"label.b_c":`От Б до С. Отношения:`,
"label.tabcontrolnameandtaglib":`Имена и ярлыки на ярлыках`,
"label.globaloperation.tip":`Создавайте, редактируйте и просматривайте глобальную операцию, которая может быть использована для подробных страниц.`,
"R":`Типы записей`,
"label.initcommiteoperate":`Действия по первоначальному представлению`,
"front-kefu-moudle-v1-Operation-without0-permission":`Нет разрешения на использование этой записи, пожалуйста, свяжитесь с администратором`,
"button_partner_create":`Новый сайт`,
"label.document.name.length.cannot.than":`Длина наименования документа не может превышать 255 чередователей.`,
"label.area.donot.delete":`Не может удалить эту территорию, потому что текущая территория имеет подтерриторию.`,
"label.currency.activation":`Активировать`,
"label.connect":`&Concatenate`,
"button.partner.viewdetail":`Посмотреть`,
"setup_object_field_dependency_label_mustsetup":`Пожалуйста, сначала установите зависимость от полей и сохраните.`,
"label.SalesCommitmentKanBan.task":`Дебиторская задолженность Целевая сумма`,
"lable.quote.syncing.finishbutton":`Готово`,
"label.weixin.group.type":`Тип доступа`,
"vue_label_commonobjects_detail_relationship":`Степень родства`,
"vue_label_email_cc":`Bcc`,
"setup.object.field.dependency.label.fieldvalueoptions":`Доступные значения полей`,
"label.sso.lookAtTheKey":`Клавиша просмотра`,
"UG.opportunity.008":`Команда opportunities`,
"label.customfields.new.step1":`Шаг 1 Выберите тип поля`,
"lable.qrcodeOrbarcode.rule":`Правила генерации QRкода/штрихкода`,
"vue_label_notice_nopermission_delete":`К сожалению, у вас нет доступа к удалению этой записи, пожалуйста, свяжитесь с администратором.`,
"label.customerobj.tab":`Вкладки пользовательских объектов`,
"com.cloudcc.login.error.message.nolicens":`Лицензии не существует`,
"label.sendsms.batch.confirm":`Массовые SMS: Подтвердить`,
"label.forecast.settings.sos":`Доход и количество`,
"label.calendar.addevent.notice.opencalendarfirst":`Пожалуйста, откройте мой календарь или другие календари до добавления мероприятий.`,
"message.success.task.phonerecord":`Сохранять записи телефонных разговоров успешно`,
"label.knowledgebase.create.new.subtab":`Новая вкладка`,
"label.knowledge.article.recordid":`Идентификатор статьи знаний не может быть null`,
"Opportunity.Detailed.Phase.Label.Popup.003":`Дни на текущем этапе`,
"homepage.layout.nowpage":`Существующий макет страницы`,
"template.chart.khslph":`Количество счетов Рейтинг`,
"front-epwechat-module-v1-android-single":`Android Single Sign On:`,
"serviceresource.assignedresource.islacksr.lack":`Вы не можете удалить ресурс службы, поскольку ему назначены назначенцы службы. Вы можете отключить этот ресурс обслуживания.`,
"label.email.only.display.info":`В поле ниже отображаются только контакты или коллеги с сохраненными адресами электронной почты.`,
"label.weixin..xsld.yjhtje":`Ожидаемая сумма контракта`,
"label.permission.delete.permsets.error.prompt":`Набор разрешений не может быть удален, поскольку на него назначены пользователи.`,
"label.ccchat.enter.two.choices":`Пожалуйста, введите как минимум два варианта`,
"label.edit.field.select.style2":`Один вариант на линию`,
"vue_label_email_please_enter_email_subject":`Пожалуйста, введите тему письма`,
"batch.sendemail.f":`почта провалилась.`,
"label.sms.senderr":`Сбой отправки SMS`,
"label.batchadd.newbatchpage.save.em":`Недействительный формат электронной почты`,
"label.icon.96":`Компас`,
"message.recordtype.deleterecord.tip":`Используйте эту страницу, чтобы заменить все существующие типы пекордов на новые типы записей. Выберите тип записи ниже, чтобы переприсвоить любые записи, содержащие удаленные типы записей. Если вы хотите просто удалить тип записи из существующего типа записи, не заменяя его на новый тип записи, выберите "Нет".`,
"label.field.edit.max":`Максимальный балл`,
"label.partnerCloud.orderingPlatform.preferential":`Скидка`,
"label.callcenter.login.later":`Войти позже`,
"batch.change.owner":`Пожалуйста, выберите владельца`,
"label.version.allow.upload.size":`версия, максимально допустимая загрузка файла`,
"setup.mainpage.label.welcome17":`Настройки разрешений`,
"label.tag.sectionname":`Информация тегов`,
"label_partner_workspace_setup":`Настройки`,
"label.managecontrol":`Административные разрешения`,
"label.timetrigger.condition":`Условие оценки устанавливается каждый раз при создании или редактировании записи.`,
"label.reportsSubscriptionPage.schedulereport.monthly.week":`Неделя`,
"front-verkoop-bywerking-error":`Обновление не удалось`,
"label.allowcommittercallback":`Разрешение подателям запросов на отзыв запросов на утверждение`,
"vue_label_commonobjects_detail_lead_finishistatus":`Отметить статус Полный`,
"message.error.object.lookupmd":`В этом объекте создается поле отношений между матери и ребенком.`,
"label.stdashbord.xsld.business.img7":`Количество стадий с вероятностью 0% / (Количество стадий с вероятностью 100%   Количество стадий с вероятностью 0%)`,
"label.checkruleofevent":`Правила подтверждения событий`,
"front-epwechat-module-v1-single":`Единый вход в систему`,
"label.tabpage.save":`Сохранить`,
"label_emailtocloudcc_search":`Поиск`,
"label.tianyancha.h5.registeredPlace":`Зарегистрированное место (сокращение)`,
"label.field.addoptionlist":`Добавить значение Picklist Value: Пиклист`,
"label.schedule_anotherpost":`Планируйте другие посты`,
"label.customfields.searchrelation.tip":`Создает связь, которая связывает этот объект с другим объектом. Поле связи позволяет пользователям нажать на иконку поиска, чтобы выбрать значение из выпадающего списка. Другой объект является источником значений в списке.`,
"label.partnerCloud.partnerAccount.prepaidPhone":`Пополнение счета`,
"label.projectManagement.view.details":`Посмотреть детали`,
"label.sendemail.chat.praiseFeed":`Дорогой #name:\n\n hello! #userName понравился твой микропост.`,
"label.validate.function.category.Text":`Текст`,
"component.task.label.newevent":`Новая задача`,
"label.data.import.setup.operate":`Что вы хотите сделать, если найдете существующий record?`,
"label.salescloud.salesdashboard.clear.option":`Четкие параметры`,
"lable.account.PreviousCY":`Предыдущие 2 года`,
"label.appointment.wizard.subtitle8":`Название компании, видимое для приглашенного`,
"label_emailsync_status_viewlog":`Журнал просмотра`,
"message.duplication.label.filtertitle":`Поиск дублирующих фильтров`,
"label.custom.quarter.description":`На этой странице можно определить и отредактировать пользовательский квартал. Дата пользовательского квартала будет сгенерирована на основе вариантов, которые вы сделаете ниже.`,
"label_tabpage_filenamez":`Имя файла`,
"lable.currencyAdv.andbefordate":`и до`,
"label.version.nonsupport.sharerule":`Правила совместного пользования временно не поддерживаются.`,
"front-epwechat-module-v1-unbound":`Развернуть`,
"label.division":`Отдел`,
"label.data.import.setup.repeat":`Вы хотите предотвратить дублирование записей на сайте created?`,
"label.callcenter.makesure.Amazon.connect":`Примечание: Убедитесь, что вы создали экземпляр Amazon Connect`,
"label.version.lead.control":`Лид-менеджмент`,
"label.copying.reward.groups":`Клонировать группу линий котировок`,
"#label.severalorone":`Zip или отдельный файл#`,
"label.mailinginfo":`Почтовый адрес`,
"component.telerecord.label.title":`Зарегистрировать звонок`,
"label.godocumentlist":`Назад к списку: Документы`,
"APPIntegration.Dropbox.setting.01":`Включить`,
"label.tianyancha.website":`Веб-сайт`,
"label_tabpage_greaterequalz":`Больше или равно`,
"vue_label_campaign_influencedopportunity":`Влияние бизнес-возможность`,
"message.save.param.null":`Параметр пуст, спасти не удалось`,
"front-epwechat-module-v1-domain":`Доверенное доменное имяJSSDK：`,
"label.allowreport":`Разрешить Отчеты`,
"label.service.major.event":`Веха`,
"label.import.index.selectobjectandfiles":`Выберите объект и файл`,
"label.chatter.task":`Задача`,
"label.knowledge.setting.hint.twelve":`Введите категорию данных`,
"lable.account.CurrentandPreviousFY":`Текущий и предыдущий БЮ`,
"label.martrixreport.step3":`Шаг 3 Выберите сводные данные`,
"front-console-select-cases":`Выбранный номер дела не может превышать 10`,
"label.partnerCloud.partnerAccount.backHome":`Вернуться на домашнюю страницу`,
"label.me.assign":`Назначенный Мной`,
"label.appointment.wizard.subtitle3":`Время встречи`,
"label.edit_columns":`Редактирование столбцов`,
"label.partnerCloud.orderingPlatform.useRebates:":`Используйте возврат:`,
"label.projectManagement.enter.up.to.10.digits":`Можно ввести до 10 цифр.`,
"label.integrations.description.mailchimp":`Интеграция CloudCC с Mailchimp позволит вам импортировать выбранные лиды и контакты из вашей учетной записи CloudCC в Mailchimp и отправлять электронные письма целевым получателям. Ваши пользователи также смогут отслеживать результаты в Mailchimp.`,
"label.ccchat.person.error.requiredomain":`Ошибка: требуется хотя бы один домен`,
"label.projectManagement.Pleaseselectitem":`Пожалуйста, выберите проект`,
"label.netaccess":`Доступ к сети`,
"vue_label_SMS_searchobject":`Объект поиска`,
"label.role.viewintree":`Показать в виде дерева`,
"lable.SalesCommitmentKanBan.accountName":`Имя аккаунта`,
"label.please.contact.your.administrator":`Обратитесь к администратору, чтобы активировать правила для генерации QR-кода/бар-кода`,
"label.sso.saml.sp.idenitysource":`Местоположение идентификации SAML`,
"label.queue.delete":`Удалить`,
"label.service.miniProgram.jumpLink":`Перейти по ссылке`,
"label_set_ forecast_scope":`Установленный диапазон прогнозов`,
"label.weixin.success.sign":`Успешно зарегистрировался, пожалуйста, знайте.`,
"front-dialog-module-v1-error-code":`Код ошибки`,
"label.projectManagement.nodata.problem":`Отлично! Не нужно решать никаких сложных вопросов.`,
"label.myhomepage":`Моя домашняя страница`,
"label.exchange.sync.state.task.m1":`Last Synced activity:`,
"label.pw.config":`Пожалуйста, подтвердите свой пароль`,
"front-console-new-contact":`Новый контакт`,
"label.customfields.fielddependency.editexplain":`<li>Двойной щелчок по ячейке, чтобы переключить ее видимость для значения управляющего поля, показанного в заголовке столбца.</li><li>Для изменения нескольких ячеек одновременно, выделения нескольких ячеек и затем нажмите кнопку Include Values или Exclude Values, чтобы изменить видимость всех выбранных ячеек одновременно.</li><li>Пользовать SHIFT   щелчок, чтобы выбрать ряд соседних ячеек. Используйте CTRL   щелкните, чтобы выделить несколько ячеек, которые не являются соседними.</li><li>Пользоваться кнопкой Предварительный просмотр для проверки результатов.</li>.`,
"setup_mainpage_label_welcome7":`Инструкции: Щелкните по меню в левой части страницы → Настройки приложения → Создать → Объект → Название объекта → Пользовательское поле.`,
"message.validation.sum":`На странице одобрения отображается слишком много полей, можно выбрать до 190 полей.`,
"label.knowledge.attach.case":`Прикрепить к корпусу`,
"front-electronic-signature-custom-field-type":`Настраиваемые типы полей`,
"vue_label_pricebook_activated":`Прайс-лист активирован`,
"vue.schedule.pre":`Вот мое расписание, пожалуйста`,
"Lead_Tools_BatchScoring":`Свинцовая партия`,
"front-lightning-module-v1-details-page-chart-screening-based-on":`Фильтр по`,
"label.report.no.recently":`Никаких недавних записей.`,
"label.service.gantt.dangerous.sum":`Количество служебных назначений в опасности.`,
"label.main.field":`Основное поле`,
"label.weixin.optionfive":`Выбор 5`,
"homepage.wide":`Широкая (справа) колонка`,
"vue_label_notice_confirmdelatehomepage":`Вы хотите удалить домашнюю страницу?`,
"vue_label_report_exportpages":`Страницы экспорта: Нет.`,
"label.select_compaign":`Выберите кампанию`,
"attachment.button.massdownload":`Массовая загрузка`,
"label.chatter.incident":`Событие`,
"label_partner_new_step1":`Шаг 1 Выберите понравившийся шаблон`,
"button.partner.workspace.saveas.memo":`Сохранить текущее облако партнера как "шаблон".`,
"vue_label_pricebook_edit":`Редактировать прайс-лист`,
"label.weixin.privacy.rights":`Конфиденциальность Permissions: Approximate местоположение (на веб-сайте),Точное местоположение (GPS).`,
"label.please.codeType":`Пожалуйста, выберите тип кода.`,
"label.approveorrefuserequest":`Утвердить / Отклонить`,
"message.error.sharemember":`Переданный аккаунт не может быть пустым, пожалуйста, проверьте переданные параметры!`,
"label.file.folder.edit":`Папка редактирования`,
"label.data.import.setup.repeat.yes":`Да-Предотвратите создание дубликатов записей. Note: If хотите обновить существующую запись, вы должны выбрать этот опиум.`,
"label.approveBeforeTheOperation":`Работать до утверждения`,
"vue_label_file_already_checked_file":`{CheckedWork} файлы выбраны, можно добавить до 10 файлов за раз.`,
"vue_label_hidden_record_count":`Скрыть счетчик записей`,
"UG_product_01":`Перечислить продукты/услуги`,
"label.tabpage.clearoptionsz":`Четкие дополнительные опции`,
"label.partnercloud.num.overstep":`Превышено максимальное количество партнерских облаков.`,
"label.tianyancha.businessverify.msg8":`В настоящее время эта функция поддерживает только запросы предприятий, зарегистрированных для ведения бизнеса на материковой части Китая, и имеет определенную задержку.`,
"Lead_Scoring_DetailedPage_Popup_Title":`Свинцовое понимание`,
"label.emailtocloudcc.email":`Email`,
"vue_label_pool_highcost":`Высокая себестоимость продукции`,
"label.callcenter.enterprise.configuration":`Пожалуйста, скопируйте пару ключей в разделе Конфигурация предприятияСистемное взаимодействие в системе Tianrun`,
"label.view.edit.search.prompt":`Пожалуйста, введите ключевые слова`,
"label.ems.sms":`Отправить текст`,
"label.emailobject.list.new":`Составить`,
"label.salescloud.forenableteamsales":`Включить отдел продаж`,
"pagecreator.systemstyle.funcpath":`/ строитель / библиотека фирменного стиля`,
"label.partnerCloud.basicSetting.domain":`Домен верхнего уровня не может быть пустым`,
"label.projectManagement.Posttask":`После выполнения задания`,
"label.tianyancha.businessverify":`Включить проверку бизнес-данных`,
"label.tianyancha.h5.info":`Основные сведения`,
"september":`сентябрь`,
"chatter.poll.option9":`Выбор 9`,
"label.department.firstpage":`Это первая страница`,
"label.reportsSubscriptionPage.condition.button":`Добавить условие`,
"label.exchange.sync.state.task":`Задачи`,
"pagecreator.layout.button.splitall":`Разделите все`,
"vue_label_calendar_please_select_the_start":`Пожалуйста, выберите поле для начала`,
"label.tab.message.failtogettop":`Не удалось получить верхнюю вкладку`,
"label.sharerule.organizationscopesetshare":`Общие организационные параметры по умолчанию`,
"label.delete.rules":`Удалить правила`,
"label.recordtype.tabname.detail":`Нажмите кнопку "Правка", чтобы изменить свойства этого типа записи. Выберите доступные для данного типа записей значения пропикилиста, щелкнув по ссылке "Правка" в списке, связанном со значениями пропикилиста.`,
"label.knowledge.setting.hint.ten":`Не уверены в режиме оргнизации? Нет проблем. Вы можете выполнить его позже.`,
"vue_label_norm_undone":`Эта операция не может быть выведена`,
"label.trigger.line":`Линия:`,
"lable.info.queue.reason":`Причина стать членом`,
"label.validate.function.funcExplain.HOUR":`Reutrn Возвращает час дня (с полей Дата/Время), в диапазоне от 0 -11`,
"label.update.document.content":`мотивированное содержание документа`,
"lable.Existing.template":`Доступные шаблоны`,
"label.summaryreport.step3":`Шаг 3 Выбор метода группировки сводных данных`,
"label.emailmerge.list.filetype":`Тип документа`,
"label.customfields.helptext.tip":`Текст отображается на странице деталей и странице редактирования, когда пользователь навешивает курсор на значок информации рядом с этим полем.`,
"label.setting.intergrationlist.description":`Интеграция CloudCC позволяет просматривать данные и обмениваться ими между бизнес-приложениями, не выходя из CRM. Некоторые из интеграций, такие как QuickBooks и Zapier, требуют разрешений для того, чтобы сделать их доступными для пользователей. Другие средства интеграции, такие как Gmail, Outlook, могут настраиваться каждым отдельным пользователем под свою учетную запись.`,
"component_milestones_label_title":`Вехи`,
"label.custom.AntiRevocation":`Отмена Отменить`,
"label.mobile.app.new.task":`Позволяет создавать новые задачи и события на мобильном приложении`,
"vue_label_opportunity_related_chooseproduct":`Выберите хотя бы один продукт`,
"label.standardguest":`Стандартный гость`,
"label.icon.125":`Инструмент`,
"label.skipsomeset":`Так как это мастер прыжкового запуска, CloudCC автоматически выбирает некоторые настройки для вас.`,
"label.forecast.shrepage.fmanager":`Менеджер по прогнозированию`,
"label.mobile.quickcreate.default.work":`Офис`,
"label.projectManagement.nodata.team.members":`Не удается найти участника моего проекта`,
"label_social_media_account_settings":`Настройка аккаунта в социальных сетях`,
"UG.quota.05":`Бисинк с возможностями`,
"label.partner.workspace.tab.selectedoption":`Выбранные вкладки`,
"front-kefu-moudle-v1-clientID-reinput":`Пожалуйста, введите идентификатор клиента`,
"label.mobile.home.page.contract.value":`Ожидаемая сумма контракта`,
"december":`декабрь`,
"label.campagin.roi.dcrs":`Посещение`,
"label.currency.edits":`Редактирование валюты`,
"label.currency.company":`Корпоративная валюта`,
"label.customfields.newformula.nogrammererror":`Никаких синтаксических ошибок при объединении полей или функций.`,
"label.version.nonsupport.api":`Interfate API временно не поддерживается.`,
"label.data.file.i.title.num2":`2. Рекомендуется экспортировать данные при импорте, чтобы экспортный документ использовался в качестве шаблона для сопоставления импортируемых данных с последующим импортом. (Если импортируемые данные содержат запятую, замените ее на символ @).`,
"front-console-conversation-title":`Оценка услуг`,
"front-kefu-moudle-call":`Звоните на`,
"vue_label_systemSettings_pagefooter":`Настройка нижнего колонтитула`,
"label.newRule.successfully.added":`Новые правила успешно добавлены.`,
"label.trigger.direction.for.use":`Инструкции для триггеров платформы [версия 2.0].`,
"label.instrumentPanel.maxLabelname":`Это значение должно быть больше, чем минимальное значение, значение точки останова 1 и значение точки останова 2.`,
"label.same.month.report":`Отчет по г/г и м/м`,
"label.knowledge.language.american":`Американский`,
"label.paging.totalof":`Всего {0}`,
"label.tianyancha.businessverify.enable.error":`Получить информацию о том, включена ли проверка бизнес-данных, не удается, обратитесь к системному администратору!`,
"vue_label_commonobjects_detail_email_template":`Использовать шаблон электронной почты`,
"message.error.save.failed":`Спастись не удалось！`,
"advancedoptions":`Добавить логику фильтрации...`,
"setup_object_layout_message_selectedlayoutandrecordtype":`Пожалуйста, выберите макет и тип записи`,
"label.sendemail.recycle.operatesuccess":`вы успешно очистили корзину, удалив данные размера.`,
"J":`Текстовая область (длинная)`,
"message.validation.isnotmail":`Пожалуйста, введите неправильный адрес электронной почты.`,
"label.timetrigger.before.lasttime":`на 1 час раньше, чем последняя измененная дата`,
"label.tabpage.arecordtypez":`Доступный тип записи`,
"label.reportoption":`Варианты отчёта`,
"pagecreator.button.next":`Следующий шаг`,
"assetbom.transferowner.notpermission":`У вас нет полномочий для передачи BOM актива. Пожалуйста, свяжитесь с администратором.`,
"label.toptitle.lightning":`Молния`,
"label.copy.target":`Значение индикатора клонирования`,
"label.productsales.oppor.approach":`Предстоящие возможности`,
"label.email.template.select":`Пожалуйста, выберите шаблон электронной почты.`,
"label.edit.lower.bound.of.discount.per.tier.is.required.":`Нижняя граница для редактирования каждого уровня скидки.`,
"label.tabularreport.step3":`Шаг 3 Определите порядок столбцов в отчете`,
"label.multilang.cchttpservice.signin":`Дорогой {0}, ваш приглашенный гость {1} из {2} был успешно зарегистрирован.`,
"label.appexchange.uninstallpage.message3":`Постоянно удалять все данные пользовательских объектов в данном пакете`,
"label_tabpage_ownedz":`Всего`,
"label.tabularreport.2018.step2":`Шаг 2 Выбор критериев отчета`,
"label.object":`Объект`,
"template.report.contracted.customers":`Отраслевой анализ договорных счетов`,
"label.field.remark3":`Обратите внимание, что удаление пользовательского поля удалит все фильтры, которые используют пользовательское поле. Это также может привести к изменению результатов правил присвоения или эскалации, которые полагаются на данные пользовательского поля.`,
"label.eventview.issms":`SMS-сообщение`,
"label.knowledge.language.brazilian":`Португальский (Бразилия)`,
"vue_label_norm_viewfilter":`Применить фильтр`,
"label.forecast.settings.qijian":`Период прогнозирования`,
"label.startuploadfile.step.intruduce":`Нажмите кнопку "Выбрать файл", чтобы найти файл и отобразить выбранные файлы в нижней области.`,
"label.smstemplate":`шаблон SMS`,
"vue_label_chatter_no_permission":`У вас нет доступа к просмотру этого файла`,
"label.callcenter.Incorrect.data.filling":`Произошла ошибка при заполнении данных`,
"label.tag.search.button":`Поиск по меткам`,
"label.multiplyselectoptions":`Опции флажка`,
"lable.outlook.detail.mutual":`Двунаправленная синхронизация`,
"label.workflow.estimatecondition1":`созданный, и в любой момент отредактированный, чтобы впоследствии соответствовать критериям.`,
"label.validate.globalvariable.user.profileId":`ID профиля`,
"UG.Campaign.003":`Создать кампанию`,
"label.validate.function.funcExplain.ISNULL":`Выражение является нулевым и возвращает TRUE, в противном случае оно содержит значение и возвращает FALSE.`,
"label.setting.intergrationlist.status0":`СТАТУС ИНТЕГРАЦИИ`,
"label.copy_error":`Не удалось скопировать`,
"label.connectOtherNone":`У выбранного объекта больше нет объектов, которые можно было бы связать.`,
"label.bmap.beijing":`Пекин`,
"front-kefu-moudle-v1-hxzxybsc-again":`Easemob удален. Пожалуйста, подключитесь снова!`,
"label.wei.pollsubject":`Тема голосования`,
"APPIntegration_Social_twittererror":`Вы должны ввести действующий URL-адрес для twitter.com.`,
"label.appupload.install.apicannotuse":`Имя api все еще не доступно`,
"label.returntolist":`Назад к списку`,
"label.translation.start2":`Выберите компонент настройки.`,
"lable.edit.queue.alter":`Выберите объекты, которые вы хотите назначить этой очереди.`,
"label.campaign.channel.step3":`Step3: Выберите поля для отображения на странице регистрации канала сбыта.`,
"label.data.newtemplate.e.seltype":`Выберите метод экспорта данных`,
"front-kefu-moudle-hangup":`Повесить трубку`,
"label.forecast.forecastroleuserpage.shre.managerandother":`Администраторы и менеджеры по прогнозированию могут поделиться этим прогнозом.`,
"label.knowledgebase.mark.as.new.version":`Отметить как новый выпуск`,
"label.conditiontag.lookup":`Посмотреть`,
"label.import.page3.importsucceed":`Успешный импорт`,
"label.stdashbord.xsld.condtion":`Настройки условий`,
"label_emailtocloudcc_redmessage10":`Срок действия информации истек, пожалуйста, войдите еще раз.`,
"label.event.moveup.1hour":`1 час вперёд`,
"label.chat.topic.page.add.favorite":`Сохранить как закладку на странице CCChat.`,
"label.icon.88":`Консультационный сайт .`,
"page_404_label_noresource":`К сожалению, ресурса, к которому вы хотите получить доступ, не существует.`,
"label.quickbooks.refresh":`Обновить`,
"front-kefu-moudle-which-getphone-case":`Правила создания дел после ответа на звонок`,
"label.objecttab.edit":`Редактирование вкладки объекта`,
"label.data.file.the.trigger":`Исполнить триггер`,
"frame.personinfo.label.personimage":`Профиль Фото`,
"label_tabpage_turnoffsz":`Выключить - переоборудовать`,
"label.sendmail.batch.chose":`Массовая электронная почта: Выбрать получателей`,
"label.data.downpage.i_title":`Шаги импорта данных:`,
"label.recycle.clearconfirm":`Ты уверен?`,
"chatter.using":`Этот пользователь`,
"label.batchadd.newbatchpage.list":`Список данных массового добавления`,
"pagecreator.systemstyle.button.new":`новый стиль`,
"label.notification.serviceappointment.changestate":`Статус {1}{0} изменен на{2}{3}`,
"label.weixin.weipollname":`Микро Имя Голосующего`,
"label.tabpage.skip":`Перейти к`,
"label.edit.field":`Редактирование полей`,
"label.edit.new.rule":`Редактирование правил генерации`,
"label.approved.receiveApprovalEmail":`Получить запрос на утверждение по электронной почте`,
"label.dashboard.refreshNow":`Обновить сейчас`,
"label.lookup.introduce":`Пожалуйста, введите как минимум 1 символ для нечеткого поиска.`,
"homepage.components.newdes":`Убедитесь, что HTML-код, введенный ниже, действителен и хорошо сформирован. Неправильное написание HTML-кода в компоненте ay приводит к некорректному отображению всей вкладки главной страницы.`,
"label.role.giveuserrole":`Назначение ролей пользователям`,
"lable.opppdt.selPbk.subtitle":`Книга цен`,
"setup_mainpage_label_welcome19":`Инструкции:  Щелкните по меню в левой части этой страницы → Управление настройками → Управление пользователями → Пользователи, роли, профили.`,
"setup.mainpage.label.welcome22":`Инструкции: Щелкните по меню в левой части этой страницы → Управление настройками → Шаблон рассылки → Шаблон электронной почты.`,
"label.tianyancha.h5.zipcode":`Zip-код`,
"label_tabpage_allapplications":`Все приложения`,
"label.chatter.like":`Например,`,
"label.licence.noremainder":`Недостаточное количество лицензий`,
"lable.outlook.edit.dataset":`Настройки данных`,
"D":`Дата`,
"label.detail":`Читать`,
"label.globaloperation.operationtype.custom_page":`Пользовательская страница`,
"label.addattachment.down":`Скачать файл`,
"label.data.exportall.all_btn":`Экспорт всех данных`,
"label.recordtypeselect.current":`Тип текущей записи`,
"label.tabpage.entercusnamez":`Пожалуйста, введите имя клиента`,
"label.location.valunit.km":`км`,
"label.mobile.phone.week.plan":`следующая неделя`,
"vue_label_report_everyday":`Ежедневно`,
"label.weixin.broadcasting":`Отправляю...`,
"label.input.search.string":`Пожалуйста, введите строку поиска`,
"label.picandreporttype":`Тип графика`,
"label.setmulti":`Перенос нескольких`,
"label.visualpage.component.t":`Как использовать компоненты?`,
"label.knowledge.designate":`Назначить можно только статью знаний со статусом "Черновик".`,
"label.enable.barcode.only":`Активируйте только штрих-код`,
"vue_label_commonobjects_detail_a_group_strategy":`Эти данные не имеют владельца и не могут создать команду`,
"setup.layout.group.button":`Кнопки`,
"label.mini.layout.remark":`это макет, используемый в висячем окне на странице.`,
"setup.mainpage.label.welcome3":`Создание форм в облачной платформе CloudCC опирается на пользовательские базы данных (объекты), определяемые пользователем объекты - это таблицы баз данных, в которых хранятся данные, специфичные для вашей организации. Связи между таблицами могут быть легко установлены без разработки каких-либо программ.`,
"label.knowledge.draft.status":`Статус поста для статей о знаниях должен быть Черновик!`,
"label.manageAll.sel.one1":`Пункты для утверждения`,
"label.campagin.roi.bhydkhywjh":`Количество закрытых возможностей`,
"label_partner_template_thumbnail":`Эскиз`,
"label.loginip.setup":`Диапазон IP-адресов для входа в систему`,
"label.data.downpage.e.title.e.btn":`Перейдите на страницу экспорта и начните экспорт`,
"vue_label_appstore_project_management":`Управление проектами`,
"assetbom.delete.notpermission":`У вас нет полномочий для удаления BOM актива. Пожалуйста, свяжитесь с администратором.`,
"vue.dashboard.setdrill.inThe":`в зависимости от`,
"label.mobile.more.savephoto":`Сохранить фото`,
"label.customerinfo.PageTriggerFag":`Синхронизация`,
"label.commonobjects.Nopermission":`Извините, у вас нет прав на редактирование этих данных, обратитесь к системному администратору.`,
"label.searchlayout.opperationtab.xsldfield":`Поля, отображаемые при нажатии на ссылку Воронка продаж на главной странице вкладки "Возможности".`,
"label.emailsync.form.disconnect":`Отменить отзыв Концерт`,
"label.document.nofile.upload":`Никакой загрузки файлов.`,
"label.appointmentpage.wizard.subtitle3-3":`Телефон`,
"message.custom.field.donotdelete":`Поле используется и не может быть удалено.`,
"chatter.using0":`{0}ms был использован в этот момент...`,
"label.tabpage.multiple":`Многократный выбор`,
"label.attendance.setting.sy.alert":`Вы должны выбрать подходящих пользователей для посещения.`,
"label.refuse":`Отклонить`,
"label.log.button":`поиск по имени пользователя`,
"component_chatter_link_label_title":`Ссылка`,
"template.report.contract.collection":`Оплата по договору`,
"label.campaignmember.selectmember.step1":`Шаг 1 Выберите кампанию и статус участников кампании`,
"label.datamanage.warn.owner":`Предупреждение: если вы продолжите этот импорт, все записи будут импортированы с вами в качестве владельца записи.`,
"label.a.b":`Отношения "А" и "Б"`,
"label.app.step3.homeisfrist":`Домашняя страница должна быть первой.`,
"UG_Lead_003":`Социальный сайт`,
"label.partner.workspace.member.choice":`Выберите профиль`,
"lable.outlook.detail.emaping":`Поля событий на карте`,
"label.service.appointmentList.gantt.chart.shows":`Показать дату Ганта`,
"label.mr.caption.account.result":`Поиск дубликатов и слияние: Результаты для запроса дубликатов учетных записей`,
"vue_label_chatter_approve_members_join":`Утвердить членов для вступления в группу`,
"label.reportsSubscriptionPage.schedulereport.monthly.day":`День`,
"pagecreator.systemstyle.label.modifycolor":`Редактировать цвет`,
"label.tabpage.yesz":`Да`,
"label.fieldtoolongmessage":`Поле превышает предел`,
"lable.account.year.name":`Наименование финансового года`,
"label.mini.layout":`парящий макет`,
"label.icon.97":`Обучение`,
"vue_label_chat_smart_assistant":`Умный помощник`,
"label.marketingmanagementuser":`Маркетинговый пользователь`,
"label_emailtocloudcc_description2":`Подключить вашу электронную почту`,
"label.campaign.channel.input.name":`1.пожалуйста, введите название канала сбыта`,
"UG.homepage.007":`От отправки последующих электронных писем до автоматизации кампаний по продажам, от создания рабочих процессов с использованием нашей технологии Blueprint до запуска пользовательских макросов, автоматизации повседневных задач и большего внимания к построению отношений.`,
"label.share":`Совместный доступ`,
"label.step2.total6":`Шаг 2 из 6`,
"label.sendemail.chat.addComentspraise":`Дорогой #name:\n\n hello! #userName ответил на микропост, который тебе понравился.`,
"label.icon.20":`Файл`,
"label.service.gantt.absenteeism":`Абсентеизм`,
"message.error.color.nagatice":`Количество текущих страниц не может быть отрицательным.`,
"chatter.group.applyToJoin":`Подать заявление на вступление`,
"pagecreator_layout_message_delete":`Вы удаляете текущую выбранную раскладку?`,
"label.multilang.viewlist.count":`Всего {0} записей :`,
"message.notdesable.type":`Этот тип записи не может быть удален, так как следующий профиль использует этот тип записи в качестве значения по умолчанию.`,
"label.standard.time":`стандартное время`,
"label_chatter_newpost":`Последний пост`,
"front-epwechat-module-v1-binding":`Связать WeCom`,
"label.recent":`Недавний`,
"label.globaloperation.createfeeditem":`Создать сводный проект`,
"label_partner_common_roleNum":`Число ролей`,
"front-template-V1-quikSearch":`Введите имя поля и найдите`,
"label_tabpage_haschangedz":`Этот свинец был преобразован`,
"label.service.work.order.line":`Пункты рабочего заказа`,
"label.lead.score.ok":`OK`,
"Account_News_Setting_003":`Общие настройки`,
"label.event.moveup.15minutes":`15 минут вперёд`,
"vue_label_all_selected_objects":`Все`,
"label.visualpage.an.inline.style.relatedlist":`Встроенный пользовательский тип страницы в соответствующие списки`,
"label.umeng.approval.approvaling":`#applyer просит разрешения на #obj #objname #owner #`,
"lable.SalesCommitmentKanBan.digital":`Цифра`,
"label.appupload.img.max.size":`Загруженное изображение слишком большое, максимальный размер изображения не должен превышать 20K, пожалуйста, загрузите его еще раз.`,
"vue_label_normal_top":`Топ`,
"label.knowledge.language.traditional":`Традиционный китайский`,
"homepage.layout.edit":`Редактировать макет дома`,
"label.campagin.qrcode":`QR-код лагеря`,
"label.emailmerge.merge.emailmerge":`Объединять электронную почту`,
"label.icon.18":`Часы`,
"vue_label_homepage_taskview":`Вид задачи`,
"label.search.related.record":`Никаких записей не найдено.`,
"label.report.reports":`Доклады`,
"label.appointment.wizard.subtitle4-3-2":`15 минут`,
"label.forecast.condition":`Критерии прогнозирования`,
"label.westem.indonesia.time":`западноиндонезийское время`,
"front-epwechat-module-v1-callback-desc":`Скопируйте следующую информацию в внутреннюю часть WeCom.`,
"label.version.group":`Командная редакция`,
"label.allReportType":`Все источники данных пользовательских отчетов`,
"label.trigger.lastmodifydate":`Дата последнего изменения`,
"message.layout.unique.sectionfield":`Нарушено ограничение на уникальность поля в макетах страниц. Пожалуйста, проверьте и сохраните его еще раз.`,
"vue_label_systemSettings_mobelbottonsetting":`Настройка нижнего меню для мобильного приложения`,
"label.recordtype.selectonefield":`Выберите одно поле, по крайней мере то, что вы хотите добавить`,
"label.notification.group1":`【申请人】 подает заявку на вступление в общественную группу.`,
"component_todaytask_label_title":`Сегодня`,
"label.assignment.setup.list.description":`Автоматическое назначение выводов для пользователей на основе определенных вами критериев. Вы можете создать несколько правил с различными условиями.`,
"label.project.resource.data":`Этот сервисный ресурс был назначен на сервисный прием, пожалуйста, не добавляйте его повторно.`,
"label.emailmerge.newtemplate.file":`файл`,
"label.notification.task1":`【分配人】 назначил тебе задание`,
"label.ServiceCloud.Overlapping":`Отображение перекрывающихся диспетчеров`,
"label.globalselect.used":`Положение использования поля`,
"setup_layout_button_layoutprop":`Свойства`,
"label.quickbooks.retrivingdata":`Извлечение данных...`,
"component.button.ok":`Подтвердить`,
"message.pleaseinputformula":`Пожалуйста, введите формулу`,
"label.h5.whatifollow":`Что я понимаю`,
"label.new.crew.target":`Новая кадровая цель`,
"label_chatter_task":`Задача`,
"label.knowledge.setting.data.four":`Можно выбрать не более {count} групп категорий.`,
"label.rule.not.enabled":`Правила для инвалидов`,
"label_in_scope":`В пределах диапазона`,
"label.partnerCloud.orderingPlatform.bundle":`Пакет`,
"label.emailtocloudcc.redmessage10":`Срок действия информации истек, пожалуйста, войдите еще раз.`,
"label.knowledgebase.data.assignment.succeeded":`{a} данные присвоены успешно`,
"vue_label_commonobjects_view_nokanban":`Вид на Канбан еще не создан.`,
"label.knowledgebase.article.cancelled.attaching.case":`Статья {название} была отменена, чтобы прикрепить к делу！`,
"label.brief":`Резюме`,
"label.version.sum.app":`приложения`,
"label.commoninfo":`Общая информация`,
"vue_label_SMS_nodata":`Нет данных`,
"label.icon.153":`Информация`,
"label.conditiontag.lookup.false":`FALSE`,
"label.emailobject.view.unread":`Непрочитанная электронная почта`,
"label.staticresource.useful":`Где это используется?`,
"label.ems.connect.test":`Тест`,
"vue_label_chat_group_assistant_notification":`Уведомление помощника группы`,
"label.multipleactivity.total":`Всего`,
"vue_label_report_addtocomponentlibrary":`Добавить в библиотеку компонентов`,
"font-evaluate-module-v1-following-personnel":`Уведомлять следующих пользователей при получении оценки менее 3:`,
"label.setup.mobile.bottombutton.change.fail":`Не изменился`,
"front-epwechat-module-v1-unbound-item5":`и данные не могут быть получены, вы уверены, что нужно отвязать?`,
"label.customerinfo.smsUid":`UID шлюза SMS`,
"label.list.isOpenApprovalQueue":`Активировать очередь утверждения (недоступно при ручном выборе утверждающего)`,
"label.leadscore.setup.scorenumber":`Время(ы)`,
"label.workflow.selectobj.introduce":`Выберите объект, к которому применяется данное правило.`,
"label.visualpage.label.for.example":`Ярлыки на страницах, например:`,
"label.appointmentdetail.wizard.title17":`план на четверг`,
"label.projectManagement.timeFrame":`Время начала и время окончания задачи должно находиться в пределах временного диапазона вехи.`,
"lable.product.pricebooks.list":`Price Book - это список товаров со специальной ценой и определенной валютой. Price Book может быть установлен для нескольких валют. При занесении в прайс-книгу, возможности или котировки могут включать продукты только в один прайс-книгу. Для редактирования продукта в прайс-книге нажмите на название прайс-книги.`,
"font-trade-module-v1-delete-invoice":`Проверить счетфактуру`,
"vue_label_salesadvance_winamount":`Валовая сумма вон`,
"component.salesperformance.label.nopermission":`Для просмотра данных, связанных с бизнес-возможностями, обратитесь к своему системному администратору.`,
"vue_label_report_formatreport_desc":`Экспорт отчета с заголовками отчетов, группами и настройками фильтров.`,
"label.enable.qrcode.only":`Активируйте только QR-код`,
"label.smstemplate.edit":`Редактирование шаблона SMS`,
"label.qrcodeSetting.detailed.information":`QR-код может хранить больше данных, чем штрих-код, и линейное сканирование не требуется. Поэтому QR-код широко применяется для отслеживания продукции, идентификации товаров, управления документацией, маркетинга и т.д.`,
"label.event.moveup.1week":`1 неделя вперёд`,
"label.customize.memory.function.sorting.disable":`Деактивировать память о сортировке заголовков`,
"label.icon.195":`Ванна`,
"label.compact.layout.assign":`Распределение ключевой информации`,
"label.icon.183":`Дом`,
"front-kefu-moudle-v1-jchxzxzi-chat":`Интеграция онлайнчата с Easemob для предоставления более комплексного SaaSсервиса.`,
"label.mycontact":`Мои контакты`,
"label.tabularreport.2018.step3":`Шаг 3 Выберите критерии отчета`,
"chatter.group.uploadGroupPicture":`Загрузить фото группы`,
"label.total.forecast.setup":`сначала спрогнозировал и установил`,
"label.weixin.group.description":`Примечание`,
"label.edit_emailfooter":`Редактирование нижнего колонтитула электронной почты`,
"label.ems.create":`Новый сайт`,
"label.weixin.optionseven":`Выбор 7`,
"font-evaluate-module-v1-continue-work":`Ваша оценка воодушевила нас! Мы будем и дальше стараться работать лучше!`,
"label.close.multilingual":`Отключить мультиязычность`,
"component.chatter.post.button.user":`Добавлять людей`,
"label.use_QRcode":`Используйте QRкод`,
"label.operatedata.exportsuc":`Экспорт успешен. Пожалуйста, просмотрите электронную почту, чтобы получить ссылку на скачивание. Пожалуйста, загрузите экспортированные файлы в течение 48 часов. Рекомендуется удалить электронное письмо, содержащее ссылку на скачивание экспортированных файлов.`,
"label.page.step2.define.content":`Шаг 2 Определение содержания и свойств дисплея`,
"label_tabpage_groupingitem":`Пункт группировки`,
"label.customfields.placeholder":`Заполните образец`,
"vue_label_commonobjects_detail_enter_subject":`Пожалуйста, введите тему`,
"label.multilang.workflow.everyotherdayinmonth":`{1}дни каждые {0}месяцы*`,
"label.knowledgebase.data.archiving.failed":`{a} архив данных не удался`,
"vue_label_notice_nopermission_view":`К сожалению, у вас нет доступа к просмотру этой записи, пожалуйста, свяжитесь с администратором.`,
"vue_label_calendar_calendar_view":`Просмотр календаря`,
"lable.outlook.edit.des":`Если контакт Exchange совпадает с несколькими контактами CloudCC.com, синхронизируйте его с контактом CloudCC.com, который отвечает следующим критериям.`,
"label.custom.NextCQ":`Следующий звонок`,
"label.emailsync.form.stutas":`Статус`,
"label.nameandintro":`Имя и описание`,
"label.dashboardSetup.showdw":`Устройство отображения`,
"label.tianyancha.actualcapital":`Полученный капитал`,
"front-kefu-moudle-info-delete-calluser":`Информация была изменена, пожалуйста, свяжитесь с администратором`,
"label.emailobject.list.all":`Все`,
"label.campaign.channel.step7.send":`Пожалуйста, выберите пользователей для получения электронной почты`,
"label.formulafield.type":`Тип возврата формулы`,
"label.reportsSubscriptionPage.schedulereport.weekly.thursday":`четверг`,
"label.chosesubject.eat":`Расписание Ужин`,
"label.back":`Назад`,
"label.h5.allcompany":`Все облачные сообщения`,
"label.location.display.type.digital":`Цифровой`,
"label.datamanage.error.csv":`Неверный формат файла, система поддерживает только общий формат CSV, попробуйте еще раз.`,
"label.emailobject.mark":`Отметить`,
"setup_mainpage_label_welcome9":`Пользователи могут реализовать классификационное отображение и настройку макета всех элементов страницы, а также настройку доступных только для чтения и требуемых полей на странице, перетаскивая мышь без разработки кода.`,
"label.icon.56":`Измерительный прибор`,
"label.forecast.edit.fwcd":`Длина диапазона`,
"vue_label_email_Please_select_related_items_first":`Пожалуйста, сначала выберите соответствующие пункты`,
"label.icon.87":`Книга`,
"label.knowledgebase.recovery.was.successful":`Восстановление прошло успешно`,
"label.emailobject.emaildetail.promptcontent":`Вы уверены, что хотите удалить этот email？?`,
"label.delete.role":`Удалить роли`,
"label.multiselect":`Пиклист (мульти-выбор)`,
"label.customerinfo.mailisnull":`Адрес электронной почты компании не установлен.`,
"label.waitforamoment":`Загрузка страницы, пожалуйста, подождите...`,
"lable.edit.queue.tip":`Введите имя очереди и адрес электронной почты, который будет использоваться при отправке уведомлений (например, если случай был поставлен в очередь). Электронный адрес может быть для отдельного лица или списка рассылки. Когда объекту назначена очередь, уведомление будут получать только члены очереди.`,
"lable.custom.y.d":`На этой странице можно определить пользовательский рекорд года. Даты для пользовательского года будут сгенерированы на основе выбора, который вы сделаете ниже.`,
"chatter.feed.content.user.searchbutton":`Поиск`,
"label.data.downpage.i.list.desc3":`Пользователи могут просмотреть причину неудачи при импорте в последнем столбце файла после загрузки.`,
"label.tag.manage.createdby":`Созданный`,
"label.h5.similar.opportunity.last.months3":`последние 3 месяца`,
"chatter.group.members":`Члены`,
"label.knowledgebase.data.translation.failed":`Перевод {a} данных не удался`,
"label.log.look":`Проверка настроек аудиторские ключи`,
"label.service.gantt.week.timescale":`Шкала времени на недельном просмотре:`,
"label.userLicence":`Лицензия пользователя`,
"label.file.library.managemembers.permission":`Доступ`,
"label_emailtocloudcc_name":`Имя`,
"label.mr.mrSuccess":`Слияние завершено`,
"vue_label_commonobject_view_notice_selectadd":`Пожалуйста, выберите данные для добавления`,
"vue_label_commonobjects_detail_level":`Уровень`,
"CloudCCCRM_ST_Info_TypeIn_001":`Пожалуйста, введите`,
"label_chatter_list":`Список`,
"label_tabpage_optionsz":`Варианты`,
"UG_homepage_008":`Понимать текущее состояние бизнеса (брифинги по продажам, лидерские группы, воронки продаж и т.д.), рассматривать бизнес-возможности, которые могут быть проблематичными, прогнозировать будущие показатели, своевременно принимать и назначать важные вопросы, а также принимать обоснованные решения.`,
"label.myselfdashboard":`Мои личные приборные панели`,
"label.globaloperation.operationtype.record_phone":`Записывающий телефон`,
"label.field.standard":`Стандартные поля`,
"label.changemydisplay.appedit.check":`Перезапись личных пользовательских настроек пользовательских приложений`,
"label.tianyancha.h5.legalpersonnames":`юридический представитель`,
"label.tabpage.sorttypez":`Сортировочный тип`,
"label.newdashboard.folder":`Новая папка приборной панели`,
"label.campaign.channel.step6":`Шаг 6: Сгенерировать страницу регистрации канала сбыта`,
"label.ems.composeemail":`Отправить электронное сообщение`,
"label.app.step4.tabcanuse":`Доступные вкладки`,
"label.sendmail.batch":`Массовая электронная почта`,
"label.process.execute.title":`Дожидается`,
"lable.outlook.detail.lastup":`Последнее обновление`,
"label_emailtocloudcc_delete":`Удалить`,
"lable.opppdt.selPdt.leastone":`Пожалуйста, выберите хотя бы один ряд`,
"label.customfields.new.step2.opration.exid":`Внешний идентификатор`,
"label.assignment.setup.newrule.description":`Введите имя правила, а затем отметьте флажком опцию Включено, чтобы использовать это правило для автоматического назначения. Включение этого правила отключит текущее правило назначения.`,
"label.campaign.channel.input.to.isactivity":`7.Active the marketing Channel`,
"label.document.return":`Вернуться к документам`,
"label.data.downpage.i_title.num5":`5. Please проверить точность данных.`,
"label.taskinto":`Задачи - это шаблоны, которые правила документооборота используют при автоматическом назначении задач пользователям.`,
"label.customfields.formula.textexample":`Полное имя = Фамилия`,
"label.appointmentpage.wizard.subtitle1-1":`следующая неделя`,
"label.weixin.radio":`Одиночный выбор`,
"vue_label_file_replace_reason_check":`Причина замены (опция)`,
"label.sendemail.recycle.operateexception":`Опорожнить мусорный бак не удалось, пожалуйста, попробуйте еще раз.`,
"label.vlidaterule.formulaerror":`Отображать ошибку, если Скидка составляет более 30%.`,
"vue_label_campaign_existing_member_status":`Сохранять статус существующего члена`,
"label.service.miniProgram.fillSlideshowName":`Пожалуйста, заполните название карусели.`,
"label_partner_workspace_login_headerfooter":`Верхний и нижний колонтитулы`,
"label.quickbooks.viewlist.total2":`Есть {0} оценки на общую сумму {1}`,
"chatter.viewingResults":`См. результаты`,
"label_tabpage_allvisible":`Все пользователи`,
"label.quote":`Цитаты`,
"label.changemydisplay.list.des":`Настройте вкладки в соответствии с вашими потребностями`,
"label.leadscore.notimes":`Больше нет времени на забивание лидирующих позиций`,
"label.icon.51":`Выработка электроэнергии`,
"component.assistant.label.title":`Помощник`,
"label.emailobject.emailsent":`Email Sent！`,
"label.group.nofile":`Ни один файл не был отправлен в эту группу.`,
"label.foldervisitlimit2":`Все пользователи не могут получить доступ к этой папке`,
"label.dataoperate":`Работа с данными`,
"label.addattachment.size":`Размер`,
"label.not.double":`Дублирующие значения не допускаются.`,
"label.customfields.formula.number.tip":`Вычислите числовое значение.`,
"lable.opppdt.addpdt.table.description":`Описание линии`,
"label.sms.isactivity":`Активный сайт`,
"label.campaign.channel.input.owner":`4. Кто будет ведущим владельцем этого канала:`,
"label.visualpage.notfound.error":`Произошла неизвестная ошибка, обратитесь к администратору.`,
"label.mr.title.button.group3":`записи`,
"label_tabpage_beginz":`Начать`,
"label_tabpage_queue":`Очередь`,
"label.tabpage.advancedscreening":`Расширенный фильтр`,
"nogreate":`примерно равный`,
"chatter.fields":`Поля в`,
"button_partner_workspace_manage":`Управление`,
"label.partnerCloud.orderingPlatform.search":`Поиск продуктов`,
"message.password.isnull":`Пожалуйста, введите ваш пароль.`,
"label.fenbeitong.title":`Настройка FenBeiTong`,
"label.salescloud.contactrole.message.chooseatleastone":`Пожалуйста, выберите хотя бы контакт.`,
"label.knowledge.delete.election":`Ошибка при удалении выбора категории данных`,
"front-console-status-hoided":`Укладка`,
"label.lastmodifydate":`Последняя измененная дата`,
"vue_label_chat_deleting_chat":`После удаления история чата будет очищена и удалена из списка Команды. При получении нового сообщения оно снова появится в списке Команды.`,
"label.timeframe":`Временные рамки`,
"UG.opportunity.002":`Определите ваш торговый цикл, настройте стадию`,
"label.templates.merge":`Выберите шаблоны для объединения. Можно выбрать не более 20.`,
"label.generatepage.c2":`Максимальная длина - 30.`,
"label.appointment.wizard.subtitle4-1-6":`2 h`,
"label.passwordPolicy.setup.pwdremember3":`3 запомненные пароли`,
"button.partner.workspace.enable":`Включить облако партнера`,
"vue_label_pool_nopool_notice":`Вы еще не присоединились ни к одному пулу, пожалуйста, свяжитесь с администратором, чтобы создать или присоединиться к пулу.`,
"label.layout.required.field.select":`Выбранные необходимые поля`,
"label.loginhis.date":`Введите дату начала и окончания.`,
"vue_label_commonobjects_detail_and_overdue":`Преодоление и просрочка`,
"label_tabpage_advancedsearch":`Расширенный поиск`,
"label.custom.field.login.home.query":`Пожалуйста, перейдите на главную страницу и просмотрите детали задания.`,
"page":`Страница`,
"label_tabpage_onlymevisible":`Только я`,
"label.weixin.optionfour":`Выбор 4`,
"label.confirm.to.remove":`Подтвердите, чтобы удалить`,
"label.event.moveup.30minutes":`30 минут вперёд`,
"label.mail.merge.template.finish":`Объединить электронные шаблоны заполнены`,
"label.multilang.currencylist.before":`До того, как {0}`,
"label.goback":`перейти к предыдущему`,
"label.unknown.prefix":`Недействительный префикс, пожалуйста, введите заново.`,
"lable.account.CurrentandPreviousCYt":`Текущая и предыдущая 2 CY`,
"label.product.dent":`Введите ключевое слово и критерии фильтрации, затем нажмите Поиск, чтобы начать поиск. щелкните Больше фильтров, чтобы использовать более одного фильтра. результаты поиска включают в себя все записи, которые соответствуют как вашему ключевому слову и записи фильтра.`,
"label.ems.bcc":`Bcc`,
"label.import.index.operation":`Операция`,
"label.knowledge.setting.hint.eight":`Держите все в идеальном порядке!`,
"label.sso.saml.sp.idtype.fid":`Анкета содержит идентификатор федерации от объекта Пользователя`,
"vue_label_chat_voice":`Голос`,
"label.config.pw":`Подтверждение нового пароля`,
"lable.newtabpage.closesearchresult":`Свернуть результаты поиска`,
"lable.account.NextWeek":`следующая неделя`,
"label.ems.username":`Имя пользователя (u)`,
"vue_label_email_emails_from_potential":`Электронные сообщения от потенциальных клиентов и контактных лиц в вашем CRM, а также сообщения, содержащие их в получателях, будут классифицироваться здесь.`,
"lable.approval.shared":`Доля участия`,
"label.tabpage.allz":`Все`,
"label.file.uploadfiles":`Загрузить файлы`,
"label.emailobject.text":`Текст:`,
"label.version.allow.create":`Разрешить создать новое`,
"label.empty.field":`Поле не может быть пустым.`,
"label.emailsync.status.department":`Департамент`,
"label.pw.str":`5 персонажей`,
"label.attendance":`Посещаемость`,
"label_mobile_buttom_team":`Команда`,
"label.campaignmember.main.addcontactdesc":`Добавить все существующие контакты к этой кампании`,
"label.search.result":`Результаты поиска`,
"label.weixin.activity.account":`Гости мероприятия`,
"label_tabpage_clearoptionsz":`Четкие дополнительные опции`,
"UG.activity.01":`Как вы отслеживаете свои записи для взаимодействия с вашими учетными записями/группами?`,
"serviceappointment.new.status.limit":`Не удалось создать новую запись на обслуживание со статусом "запланировано" или "отправлено".`,
"label.notice.higher":`Отправить Email менеджеру`,
"label.passwordPolicy.setup.gletters":`символ(ы)`,
"label.data.exportsf.des":`Успешно экспортированные файлы будут автоматически удалены через 48 часов после сохранения на сервере.`,
"label.view.onlymecansee":`Видимо только для <b> меня</b>.`,
"UG.Lead.005":`Почтовый ящик`,
"label.umeng.approval.approvalfail":`...невиновен.`,
"label.huanxinconfig.clientid.lost":`clientid не может быть пустым`,
"label.campaignmember.main.updatecontactstatus":`Обновить статус - Существующие контакты`,
"component_chatter_button_delete":`Удалить`,
"label.weixin.no.pending.projects.qin":`Нечего утверждать.`,
"front-electronic-signature-auto-fill-field":`Автозаполнение поля`,
"message.resetpw":`Вы уверены, что хотите сбросить пароль?`,
"label.service.ganttBaiduMap.service.resourname":`Название службы Ресурсы`,
"vue_label_pricebook_deleted":`Прайс-лист удален`,
"label.icon.193":`Ванна`,
"label.validate.function.funcFormat.NOT":`НЕ(логично)`,
"label.address.city":`Город`,
"label.pc.ui.2018.searchs":`ИЩИ...`,
"label.yard":`Кодекс приглашения`,
"label.data.downpage.i_title.btn":`Перейдите на страницу импорта и начните импорт`,
"label.useablereceivers":`Доступные реципиенты`,
"label.cloudccsite.name.length":`Позволяет пользователям вводить до 255 символов`,
"label.secrecy":`Конфиденциальный`,
"label.campagin.roi.ydkhywjhzz":`Итого Сумма завершенных консультаций`,
"vue_label_report_conditiondesc_one":`Кроме подписки, вы можете установить условия для этого отчета. Вы будете уведомлены, если все условия будут выполнены. Это необязательно`,
"label.datamanage.select.contactfield":`(Выберите поле, соответствующее импортируемому контакту).`,
"label.emailtocloudcc.filed.action":`Действие`,
"label.smstemplate.new":`Новый шаблон SMS`,
"label.mobile.side.tab.app":`Приложения`,
"label.icon.118":`Часы`,
"label.customfields.selectcontainfieldlayout.tip":`Это поле будет добавлено в качестве последнего поля в первом 2-столбцевом разделе макетов этих страниц. Поле не будет отображаться ни на одной странице, если вы не выберете макет. Чтобы изменить расположение этого поля на странице, необходимо настроить макет страницы.`,
"Lead_Homepage_Tools_BatchScoring":`Пакетная оценка`,
"lable.quote.syncing.quote":`Цитаты`,
"pagecreator.button.preview":`Предварительный просмотр`,
"label.ccchat.am":`AM`,
"chatter.feed.menutype.user.nullrecent":`Нет последних записей`,
"lable.info.queue.showallmember":`Очередь просмотра членов`,
"label.multilang.campaign.selelctmember.desc":`Выберите вид и выберите участника, которого хотите добавить в кампанию. Статус участника {0}`,
"label.notification.ccchat3":`【评论用户名】 комментирует ваш пост.`,
"UG.product.03":`Мультивалютное руководство по ценам`,
"label.sso.saml.idp.config.pksize":`Ключевой размер`,
"label.defineCustomReportType":`Определите пользовательский источник данных отчета`,
"component.timeline.button.filter":`Фильтр`,
"label.mr.nextGroup":`Пропустите группу и переходите к следующей группе.`,
"label.quote.sprdz":`Адрес для выставления счёта`,
"label.total.refuse.forecast.have.priority":`Отказаться от всех прогнозных приоритетов`,
"lable.product.peep":`Пожалуйста, введите действительную цену.`,
"label.file.who.can.access":`Кто может получить доступ`,
"label.page.last":`Последняя страница`,
"label.icon.180":`Люди`,
"font-evaluate-module-v1-enabled-successfully":`Успешно включена опция оценки "Neural"`,
"label.appointment.wizard.subtitle4-2-2":`2 h`,
"label.passwordPolicy.setup.oneyear":`Один год`,
"label.login.bound.mfadevice.title":`Включить виртуальные MFA-устройства`,
"vue_label_dashboard_statisticalvalue":`Пожалуйста, выберите статистическую величину`,
"label.ishistory":`История`,
"component.timeline.label.title":`Сроки`,
"label.page.step3.of.step5":`Шаг 3 из 5`,
"label.assignment.setup.detail.section":`Правило Подробнее`,
"label.salescloud.opportunity.nothave.main.contactrole":`Нет крупных контактов`,
"label.import.page1.limitedcsv":`Формат CSV ТОЛЬКО для загрузки файлов`,
"label.icon.187":`Hammer`,
"label.emailobject.wizard.desc5":`Настройте свою подпись, чтобы ваша почта выглядела лучше.`,
"vue_label_report_notice_copy_success":`Скопируйте отчет успешно!`,
"label.dupicatecheck.repeatcondition.chooserulemsg":`Вы не выбрали правило повторной проверки.`,
"label.componentEditor.upper.limit":`До 100`,
"label.validate.function.funcExplain.ISNEW":`Проверьте, не является ли запись новой, и верните TRUE, если она новая, в противном случае верните FALSE.`,
"label.postalCode":`Почтовый индекс`,
"label.dashboard.snapshot.enable.flag":`Включить снимки приборной панели`,
"vue_label_file_upload_type_size":`Можно загружать только файлы {типа файлов}, и не более {размера}Mb`,
"label.appointment.wizard.subtitle3-6":`суббота`,
"homepage.narrow":`Узкая (слева) колонка`,
"chatter.addmute.confirm":`Ты уверен, что хочешь сохранить этот пост "не беспокоить"?`,
"label.lookup.account":`Поиск по аккаунтам`,
"message.lostthemanager":`Это представление требует одобрения менеджера пользователя, и значение менеджера пользователя является нулевым. Пожалуйста, свяжитесь с вашим администратором, чтобы узнать больше.`,
"label.exchange.sync.state.contact.m3":`Записи синхронизированы за последние 24 часа:`,
"label.version.phone.app":`Мобильное приложение`,
"label_tabpage_search":`Поиск`,
"vue_label_helpcenter_campaign":`В подробной информации нажмите кнопку древовидной диаграммы рядом с кампанией, чтобы просмотреть диаграмму иерархической структуры кампании и понять иерархию "родитель-потомок" кампании.<br> Управляйте контактами или лидами, вовлеченными в кампанию, с помощью связанного списка членов кампании.`,
"front-lightning-module-v1-dashborad-last-year":`Прошлый год`,
"label.campaign.channel.value":`значения`,
"vue_label_opportunity_contactrole_primarycontact_notice":`Чтобы выбрать основной контакт, сохраните данный шаг и выберите из меню "Управление".`,
"label.biaoqingfaxian.title":`Открытие конкурсных предложений`,
"label.approved":`Утверждено`,
"label.hong.kong.time":`время Гонконга`,
"label.customfields.file.cannotopen":`Не могу открыть файл`,
"lable.New.tips":`Нажмите кнопку "Новый", чтобы создать новый шаблон отчета об услугах на основе стандартного или любого выбранного шаблона. Активируйте шаблон и начните его использовать.`,
"component.setup.tabs.label.add":`Добавлен`,
"label.forecast.forehistory.replacebest":`Лучший переопределённый случай`,
"front-kefu-moudle-v1-jctrrt-call-serve":`Callцентр интегрирован с TRRT для предоставления более комплексных SaaSуслуг`,
"label.workflow.configrule":`Шаг 2 Настройка правила документооборота`,
"label.dashboard.snapshot.refresh.frequently":`Снимки приборной панели обновлять слишком часто, пожалуйста, попробуйте еще раз позже`,
"label.ems.editsetting":`Редактировать настройки электронной почты`,
"message.confirmdeleteAPP":`Вы уверены, что хотите удалить это приложение?`,
"label_chatter_activity":`Деятельность`,
"label.editsharerules":`Правила совместного пользования Редактирование`,
"label.loginservice.license.notuse.must":`Лицензия в настоящее время недоступна, вы должны`,
"label.import.step2.beforeexport":`1、Перед импортом, пожалуйста, убедитесь, что импортированы все связанные записи. Например, если вы импортируете записи контактов и хотите заполнить поле счета, которое является полем поиска, вам нужно сначала создать запись счета, которую вы заполняете, затем импортировать запись контакта и заполнить поле счета именем или ID соответствующего счета.`,
"label.chat.mute":`Не беспокоить`,
"label.icon.128":`Дом`,
"label.give":`и и`,
"label.hide":`Не показывать`,
"label.relationobject.wpr":`Удаленный уполномоченный представитель`,
"label.summation":`Сумма`,
"label.layout.availabletab.details":`Подробности`,
"label.circle":`Диаграмма пончиков`,
"vue_label_opportunity_contactrole_add":`Добавить контактные роли`,
"label.file.library.file2libsuccess":`Добавлено успешно!`,
"label.weixin.report.reportgenerated":`Генерируемый отчет`,
"label.icon.91":`Люди`,
"report.label.pleaseinput":`Введите то, что вы хотите найти`,
"label.escalation.setup.newaction.otheremail.tip":`Вы можете ввести до пяти (5) адресов электронной почты для уведомления. Каждый адрес электронной почты разделен на ",".`,
"label.area.donot.have.data":`Нет данных`,
"label.customcomponent.btn.reference":`Ссылка на компоненты`,
"label.appointmentdetail.wizard.title7":`Время напоминания`,
"label.ccchat.with":`Есть`,
"label.file.size":`Размер`,
"label.product.sort.beyond":`Можно установить максимум 10 уровней!`,
"label.ccchat.2018":`CCChat`,
"label.report.select.column":`Выберите столбцы`,
"label.appointmentpage.wizard.subtitle1_1":`Выберите дату и время`,
"label.passwordPolicy.setup.uppercasealpandnumsymbol":`Должны смешивать цифры и заглавные и строчные буквы, а также специальные символы.`,
"label_chatter_addressee":`Получатель`,
"label.profile.remark2":`Если ваша организация использует Типы записей, воспользуйтесь ссылкой Редактировать в разделе Настройки типов записей ниже, чтобы сделать один или несколько типов записей доступными для пользователей с этим профилем.`,
"UG_Account_01":`Кто ваш аккаунт?`,
"label.dataimport.error.contact.notnull":`Ошибка: имя контакта не может быть нулевым.`,
"lable.account.CalenderQuarter":`Календарный квартал`,
"vue_label_commonobjects_detail_empty":`Продажная цена не может быть пустой`,
"label.approveassigntemplate":`Одобрено назначение шаблонов электронной почты.`,
"label.objectRelationshipDescription1":`Источник данных этого отчета будет генерировать отчеты о`,
"vue_label_email_insertmergefield":`Вставить поле слияния`,
"label.mobile.home.page.check.team":`Команда`,
"lable.edit.queue.edit":`Редактирование очереди`,
"label.campagin.roi.query":`Показать окупаемость кампании`,
"label.dataimport.field.allow.access.to":`Доступ к полям данных запрещен, пожалуйста, удалите соответствующую запись вручную и повторите попытку.`,
"pagecreator.systemstyle.message.canntdelete":`Текущий стиль не разрешается удалять`,
"label.searchkey":`Пожалуйста, введите ключевые слова`,
"chatter.showall":`Показать все`,
"show":`Показать`,
"label.quote.choseproduct":`Выбрать продукт`,
"label.report.selected.field":`Избранные поля`,
"label.globaloperation.operationtype.create_data":`Создать запись`,
"label.knowledge.setting.data.seven":`Удалить группу категорий: {flzmc}`,
"chatter.email.mentionOrMessage":`Упоминания или сообщения`,
"label_tabpage_exclusivez":`Эксклюзивный`,
"chatter.en.userinfo":`Введите информацию о себе.`,
"label.log.orgid":`Организация`,
"label.dataimport.insertdata.error.fieldrepeat.update":`Поле $schemefield_name$ в записи не может быть найдено в БД и не может быть обновлено. Запись проигнорировала импорт.`,
"vue_label_chatter_add_link_success":`Добавлена ссылка успешно`,
"label.sender_details":`Чтобы добавить новые данные об отправителе, создайте пользователя в вашем`,
"label.ccpeak.addwhere.condition":`Критерии "где" могут быть добавлены`,
"label.datamove.total":`Всего`,
"label.tianyancha.businessverify.warning":`Пожалуйста, обратите внимание, что эта проверка поддерживает только деловые данные, зарегистрированные в Китае.`,
"label.emailmainbody":`Тело письма`,
"label.justadmin":`Только для администраторов`,
"label.data.downpage.e.list.desc1":`На этой странице отображаются успешно экспортированные файлы. Пожалуйста, загрузите экспортированные файлы вовремя, добавив ссылку на загрузку в вашем электронном письме.`,
"label.reportsSubscriptionPage.email.value":`Существующие значения`,
"message.error.serviceappointment":`Пожалуйста, заполните запланированное время начала и запланированное время окончания обслуживания.`,
"label.textMessageObject.selectone":`Пожалуйста, выберите хотя бы одну запись в качестве получателя текстового сообщения.`,
"label.schedulejob.setup.schedule.plan":`Расписание`,
"label.assignment.layout.field.isassigned":`Назначить согласно активным правилам назначения.`,
"label.captcha.error":`Ошибка верификации!`,
"mobel_web_not_more_data":`Больше никаких данных`,
"label.emailsync.form.emailaddress":`Адрес электронной почты`,
"label.loginservice.error":`Ошибка входа, пожалуйста, свяжитесь с администратором.`,
"label.integrations.description":`Подключите вашу учетную запись CloudCC к другим приложениям.`,
"vue_label_homepage_notice_selectone":`Пожалуйста, выберите хотя бы один провод или контакт`,
"label.chatter.default":`По умолчанию`,
"label.tabpage.datefield":`При равенстве поля даты он может использовать "вчера", "сегодня", "завтра", "в прошлом месяце", "в этом месяце", "в следующем месяце", "на прошлой неделе", "на этой неделе", "на следующей неделе" или "ГГГГГ-ММ-ДД, ММ/ДДД/ГГГГ" формат.`,
"front-kefu-moudle-myzdhsc-file":`Файл записи не найден или не создан`,
"label.createname":`Создатель`,
"label.mobile.phone.enter.plan":`Введите свой план`,
"report.label.highlevelreport":`Расширенные отчеты позволяют создавать связи между максимум 4 объектами.`,
"label.edit.select.label":`Режим редактирования`,
"label.partnerCloud.financeSetting.deduction":`После активации фунции будут добавлены в счет возврата, доход возврата и объект расхода возврата. Пользователипартнеры могут использовать счет возврата для вычета суммы, подлежащей оплате.`,
"message.duplication.label.updateoption":`Действие по обновлению`,
"label.custom.CurrentCQ":`текущий CQ`,
"front-kefu-moudle-wait":`Ожидание`,
"sunday":`воскресенье`,
"label.service.timezone":`Часовой пояс`,
"setup.layout.label.selectfield":`Выберите поля`,
"label_emailtocloudcc_filed_action":`Действие`,
"label.forecast.customforecast.mycommit":`Мое обязательство`,
"label.uploadsuc":`Загрузка успешная`,
"vue_label_commonobjects_view_notice_atleast1field":`Выберите по крайней мере 1 поле дисплея`,
"label.dataimport.khmc.length":`Ошибка: длина счета слишком велика.`,
"label.isemailnotification":`Отправить уведомление по электронной почте`,
"label.addAPPexchange":`Добавление приложений из CloudCC App Store`,
"label.partnerCloud.orderingPlatform.currency":`Валюта:`,
"UG_quota_02":`Стадия "Возможность изменения`,
"label.customer.tab.step2.same.option3":`Вкладка Скрытая`,
"H":`Телефон`,
"label_tabpage_searchz":`Поиск`,
"vue_label_homepage_deleted":`Удалено`,
"label.weixin.recent.view":`Недавно просмотренные виды`,
"template.report.opportunity.sales":`Объем продаж возможностей`,
"label.customfields.new.step2.opration.unique.info.v1":`Трактовать "ABC" и "abc" как дублирующие значения (нечувствительные к регистру).`,
"savesuccess":`Успешно спасённый`,
"label.partner.workspace.member.memo":`Все пользователи с выбранным профилем и правами доступа могут получить доступ к облаку партнера.`,
"label.icon.23":`Наркотик`,
"lable.batchadd.service.cfq.before":`Триггеры (перед установкой)`,
"label.instrumentPanel.breakpointTwoLabelname":`Это значение должно быть больше, чем минимальное значение и значение точки останова 1.`,
"message.selectgsummaryinformation":`Пожалуйста, выберите данные, которые Вы хотите обобщить`,
"label.tianyancha.businessverify.msg6":`Эта функция использует сторонние службы и может иметь нестабильную производительность или невозможность обслуживания из-за высокого одновременного использования. CloudCC не несет никакой ответственности.`,
"vue_label_helpcenter_report3":`3.A. Щелкните поле поиска, выберите нужное поле путем его поиска или прокрутки вниз по списку полей, выберите оператора поля, введите или выберите значение, нажмите кнопку Применить, и фильтр полей вступит в силу. <br> B. Щелкните значок " " над окошком поиска полей и введите в "Поле ввода условий фильтра" расширенное условие фильтрации, состоящее из цифр и букв. Например, (1 и 2) или3.<br>? Редактирование фильтров<br> Для редактирования фильтров включите стандартные фильтры и нажмите на них. <br>? Удалить фильтры<br> Нажмите на иконку "x" на фильтре, чтобы удалить его. <br>? Запустите отчет<br> Нажмите на кнопку "Запустить" в правом верхнем углу страницы редактирования, чтобы увидеть полные результаты отчета. <br>? Сохранить отчет<br> Нажмите кнопку "Сохранить" в правом верхнем углу страницы редактирования, введите имя отчета, выберите папку отчета и сохраните его. <br>2. Перед созданием папки отчета система по умолчанию генерирует папку "Мои пользовательские папки отчетов" и папку "Неархивированные публичные отчеты". <br> Шаг 1: На вкладке Reports (Отчеты) щелкните New Reports Folder (Новая папка отчетов)<br> Шаг 2: Во всплывающем окне New Reports Folder (Новая папка отчетов) вы можете выбрать перенос отчетов из папки Unarchived Public Reports (Неархивированные публичные отчеты) в эту папку. Вы можете выбрать, какие пользователи могут получить доступ к этой папке, а также права доступа. <br>3. Просмотр отчетов<br> Шаг 1: На вкладке Отчеты перейдите на страницу списка отчетов и найдите нужный отчет, нажав кнопки "Недавно просмотренные", "Я создал", "Все отчеты", или папку "Отчеты", или папку "Отчеты", чтобы найти нужный отчет. <br> Шаг 2: Щелкните по имени отчета для его просмотра. Или нажмите выпадающую кнопку в правом верхнем углу отчета и выберите пункт Выполнить, чтобы просмотреть отчет. <br>Если вы являетесь администратором, то на вкладке Отчеты перейдите на страницу Список отчетов и нажмите на значок шестеренки рядом с кнопкой Новая папка, чтобы выбрать поля для отображения в заголовке таблицы списка отчетов в каждой папке. <br>4. Экспорт отчетов<br> Шаг 1: На вкладке Отчеты перейдите на страницу списка отчетов, найдите отчет, который вы хотите экспортировать, и нажмите выпадающую кнопку в правом верхнем углу отчета. <br> Шаг 2: Выберите тип<br> Формат отчета: содержит заголовки, группировку, детали фильтрации. <br> Только детали отчета: Неформатированные строки деталей. <br> Шаг 3: Нажмите Экспорт. Отчет, содержащий только детали, необходимо экспортировать в виде страниц, с максимальным количеством данных на страницу 2000.  `,
"label.batchdelete.success":`Массовое удаление успешно`,
"label.newprocess5.seq":`Заказать`,
"label.knowledgebase.data.translated.successfully":`Перевести данные {a] успешно`,
"label_enable_range":`Диапазон активации`,
"label.ccchat.and":`И`,
"label.assignment.setup.list.norule":`Никаких правил не указано.`,
"vue_label_report_summaryformulacolumn":`Колонка сводной формулы`,
"label.field.edit.change1":`Максимальный балл не должен превышать 100`,
"syntaxerror":`Ошибка синтаксиса, пожалуйста, проверьте введенные критерии.`,
"label.icon.116":`Дом`,
"lable.asset.BOM.according.to.product":`Генерировать спецификацию активов в соответствии со структурой продукта`,
"chatter.like.post":`этот пост понравился людям`,
"label.trigger.page":`Страницы триггеров`,
"vue_label_email_contact_adminstrator":`В системе произошел сбой, обратитесь к администратору.`,
"label.workreport":`Рабочие заметки`,
"vue_label_homepage_edit_card_view":`Редактирование вида карты`,
"label_emailsync_status_disabel":`Неактивный сайт`,
"label.icon.54":`Экскаватор`,
"message.error.view.validerr.common":`Проверка не прошла.`,
"label.exchange.sync.account.username":`Имя пользователя учетной записи службы (Доменное имя пользователя или UPN):`,
"label.dataimport.error.date":`Ошибка: Дата`,
"label.orgname":`Организация`,
"label.weixin.group.owner":`Владелец`,
"vue_label_dashboard_colorrange":`Цветовой диапазон`,
"label.forecast.shrepage.tableth":`Прогноз Доступ`,
"label.related.disabled":`Связанные списки не включены, пожалуйста, свяжитесь с системным администратором, чтобы включить соответствующие списки в раскладках страниц.`,
"label.version.product.management":`Управление продукцией`,
"label.knowledge.new.article.published":`Статья публикуется как новая статья.`,
"label.sendsms.batch.step4":`Шаг 4 Ваше SMS было отправлено.`,
"vue_label_commonobjects_detail_and_tasks":`Поздравляю, все события и задачи обрабатываются.`,
"label.salescloud.ci":`время(ы)`,
"label.ccpeak.getapi.name.time":`Если вы хотите использовать методы в классе CCService, вам нужно инстанцировать.`,
"label.escalation.setup.detail.conditon":`Критерии`,
"label.lbs.isUseLbs":`Включить услуги по определению местоположения`,
"front-lightning-module-v1-dashborad-color-depth":`Глубина цвета`,
"date":`Дата`,
"label.select.personnel":`Выбор персонала`,
"label.appointmentpage.wizard.notif3":`Электронная почта обязательна!`,
"label.import.page1.pleaseselectwayofdealdata":`Пожалуйста, выберите режим обработки`,
"label.partner.all.memo":`В списке отображаются все облака партнеров в вашей организации. Для входа в систему нажмите url.`,
"label.appointment.wizard.subtitle4-3-3":`30 мин`,
"component_telerecord_label_subject":`Тема`,
"label.sendsms.batch.finish":`Массовые SMS: Заполнено`,
"label.login.access.myusername":`Мое имя пользователя`,
"label.weixin.wechatnumber":`Идентификатор WeChat`,
"label.eowechat.status":`Статус пользователя`,
"Lead_Scoring_Setting_Rule_Setup_Value":`Оценка`,
"label.appexchange.oldreport.noupload":`Старые отчеты - не загружать`,
"label.approverfieldediting":`Поле утверждения и редактируемость записей`,
"label_tabpage_customernamez":`Имя клиента`,
"vue_label_dashboard_linkagesettings":`Настройка соединения`,
"vue_label_ccchart_notice_deletecomment":`Вы уверены, что хотите удалить этот комментарий?`,
"label.allprofile":`Все профили`,
"label.campaignmember.main.addMember":`Добавить членов - Поиск`,
"label.projectManagement.subtask.list":`Список подзадач`,
"label.code.some.size":`Емкость кода: максимум 200KB символов, приблизительно 20,0000 байт.`,
"front-custom-service":`Service Cloud обеспечивает эффективные и гибкие индивидуальные услуги для клиентов, сокращает время решения вопросов обслуживания и увеличивает количество решений с помощью интеллектуальной системы рабочих заказов, повышает лояльность клиентов и увеличивает количество повторных покупок.`,
"label.SMS.det":`Детали SMS-уведомлений`,
"setup_layout_label_nobutton":`Нет доступных кнопок`,
"vue_label_email_Could_not_save_template":`Не удалось сохранить шаблон`,
"label.imgfield.height":`Высота`,
"label.leadscore":`Свинцовый балл`,
"setup_object_field_dependency_label_removefromlist":`Удалить выбранные значения`,
"message.error.code.null":`Код авторизации не может быть нулевым!`,
"label.tianyancha.businessscope":`Сфера деятельности`,
"vue_label_chat_empty_message":`Пустое сообщение`,
"label.total":`Всего`,
"label.delerror.list":`Неудаленные файлы Список`,
"label.selectedreceivers":`Отобранные реципиенты`,
"label.layout.availablepages":`Доступные страницы`,
"label.pc.ui.2018.personalinfo":`Личная информация`,
"label.chat.topic.edit.detial":`Редактировать детали`,
"label.mr.descreption.reDataList1":`В запросе на выполнение условий итого`,
"label.document.value.too.long":`Размер этого файла более 5M!`,
"lable.opppdt.addpdt.table.listprice":`Прейскурантная цена`,
"label.selectoperate":`Выберите действие`,
"label.icon.5":`Валюта`,
"label.icon.126":`больничная койка`,
"label.hiddensearch":`Скрытый поиск`,
"label.view.sortview.exportble":`Экспортируемый`,
"vue_label_homepage_noassignee":`Полномочный представитель не назначен`,
"label.knowledgebase.close.and.resolve":`Закрыто и решено`,
"label.licence.used":`Использованные лицензии`,
"label.newprocessstep5":`Шаг 5 Выбор полей для отображения в Макет страницы утверждения`,
"vue_label_appstore_all_applications":`Все приложения`,
"label.no.edit.permission":`Невозможно выбрать. Нет разрешения на редактирование выбранных записей.`,
"vue_label_calendar_calendar_added_successfully":`Календарь добавлен успешно`,
"report_line":`Поле данных`,
"component.chatter.link.label.name":`Имя ссылки`,
"label.data.expnode.e_desc1":`1. Custom Export: пользователи могут выбирать поля для экспорта и устанавливать условия фильтрации в соответствии со своими потребностями.`,
"label.tabularreport.step4":`Шаг 4 Выбор критериев отчета`,
"Opportunity.Detailed.Phase.Change.Text.001":`Стадия "Возможность изменения`,
"label.quickbooks.searchresault.action":`Действие`,
"component_timeline_label_today":`Сегодня`,
"label.callboard.remark":`Пожалуйста, введите ваше объявление о компании ниже.`,
"label.campagin.field.choose":`Выберите поля, которые необходимо включить в реестр участников кампании.`,
"front-gantt-module-rolling-temporary-tasks":`Переход к временному заданию`,
"label.file.des":`Описание`,
"Dashboard_View_RecentlyView":`Недавно просмотренный`,
"UG_Account_04":`Фильтрация учётных записей пассивных запросов`,
"chatter.refresh":`Обновить`,
"label.tianyancha.companyorgtype":`Тип компании`,
"label.chatter.dateRange":`Диапазон дат`,
"label.campagin.step3":`Шаг 3: aGenerate страницы`,
"label.appointmentdetail.wizard.title14":`план на понедельник`,
"setup.object.field.dependency.button.setdependency":`Настройки зависимости от поля`,
"serviceterritorymember.serviceterritory.isactive.notactive":`Эта территория обслуживания не включена. Вы можете добавлять членов только на включенной территории обслуживания.`,
"template.chart.ygydyj":`Выполнение приказа о победе сотрудника`,
"label.tag.edittags":`Метки редактирования`,
"label.clone":`Клон`,
"front-electronic-signature-setting-intro1":`Перед привязкой аккаунта рекомендуется сначала зарегистрироваться и пройти аутентификацию на платформе DocuSign.`,
"label_reach":`Производительность`,
"label.tabpage.havez":`Прилагается`,
"label.email.clearCase":`Только пустые электронные письма, не связанные с делами`,
"label.customer.tab.all":`All Tabs`,
"label.direct.dashboard.day.report":`Новая служебная записка`,
"label_tabpage_exportview":`Вид на экспорт`,
"label.passwordPolicy.setup.maxFailTimes":`Максимальное количество недействительных попыток входа`,
"label.processsetting.complete.enable":`Завершить и активировать`,
"label.marketsea.memberfield":`На поля могут претендовать члены`,
"label.report.export.format.title":`Форматные отчёты`,
"label.recycle.execute.title":`Очистка мусорного контейнера.`,
"label.file.use.most.user":`Пользователи с наибольшим количеством используемого места для хранения`,
"report_type_label_systemReport":`Системные отчёты`,
"label.customobjects.majorobject":`Основной объект`,
"label.file.delete.public.link":`Удалить общественную ссылку`,
"front-epwechat-module-v1-id":`WeCom ID`,
"label.partner.common.roleNum":`Число ролей`,
"label.sendtonextapprover":`Отправлено на следующий утверждение`,
"label.notification.tip3":`Загрузить 10 дополнительных уведомлений`,
"label.tabpage.placeenterz":`Пожалуйста, введите?`,
"label.mobile.phone.cc.people":`Cc`,
"component_setup_iframe_label_inputurlmemo":`Пожалуйста, введите URL-адрес импортируемой страницы`,
"label.umeng.activity.statuschange":`Статус задания, который вы присвоили #name, изменяется на #newstatus`,
"label.step3.restricted.visibility":`Шаг 3 Ограничение видимости`,
"label.multilang.datadelete.approvedata":`Записи утверждаются ({0}):`,
"label.reportsSubscription.save":`Сохранить`,
"label.emailobject.template.visibility":`Видимость`,
"label_partner_step3":`Шаг 3 Основная информация`,
"label.product.across":`Книги по перекрёстным ценам`,
"label.same.analyze.opportunity.name":`Имя возможности`,
"label.chatter.memotel":`Мемо-телефон`,
"label.recentview.seloption2":`Недавно созданный`,
"label.ccchat.message.search.desc1":`Мы не смогли найти никаких новостей с`,
"label.reportexport":`Экспорт`,
"label.service.gantt.drop.tip":`Разрешение отклонено: У вас недостаточно прав для работы. Пожалуйста, свяжитесь с администратором.`,
"label.australian.westem.standard.time":`Австралийское западное стандартное время （Australia）`,
"label.emailobject.email":`Email`,
"Homepage_Contract_FieldMissed_DoesntSupport":`На объекте договора нет полей "qdrq" и "htje", поэтому данные не могут быть показаны.`,
"label.email.cancel.upload.info":`Это отменит текущий процесс загрузки`,
"label.page.copy.merged.field.value":`Скопировать значение поля слияния`,
"UG.ST.006":`Введите напрямую`,
"label.trigger.service.connot.access":`недоступное утверждение`,
"label.projectManagement.new.tasks":`Новая задача`,
"lable.SalesCommitmentKanBan.receiptsRate":`Скорость завершения приема заявок`,
"label.productsales.oppor.overdue":`Превышение возможностей`,
"vue_label_pool_convertedbyme":`Обращенный мной`,
"label.loginip.pagecue.invalidt":`Начальный интернет-адрес находится дальше, чем конечный интернет-адрес или недействительный интернет-адрес.`,
"label.campagin.roi.xyzj":`Полный ответ`,
"label.visualpage.list.title":`Активный пользовательский доступ к странице`,
"chatter.feed.searchinitvalue":`Введите имя...`,
"label.export_submission":`Экспорт представленных данных`,
"this.season":`Этот квартал`,
"label.forecast.settings.gx":`Прогнозный обмен данными`,
"label.tag.addtags.tagcolour":`Цвет тега`,
"label.api":`имя API`,
"label.bulk.delete":`Массовое удаление (навсегда)`,
"label.reportsSubscriptionPage.condition.emailoption":`Настройки электронной почты`,
"vue_label_dashboard_newdashboardsuccessfully":`Успешно создать новую приборную панель`,
"three":`Три`,
"label.prompt":`Симптома`,
"label.same.analyze.contact.phone":`Мобильный`,
"label.icon.62":`Трубопровод`,
"label.forecast.shrepage.tableth.isnable":`Разрешить подачу`,
"label.multilang.polloption.vote":`{0} билет(ы)`,
"label.customfields.totalsummary.selecttotaltype":`Выберите тип рулона`,
"lable.SalesCommitmentKanBan.receivingCommitmentRate":`Поступления Ставка вознаграждения`,
"label.areaAndSub":`Территория и субтерритория`,
"vue_label_pool_recycle":`Рециклировать`,
"lable.outlook.detail.synset":`Настройки синхронизации`,
"label.quote.detail.introduce":`Введите ключевые слова, нажмите "Поиск" для поиска, после завершения поиска нажмите "Выбрать" для перехода к следующему шагу.`,
"label.profile.customappset":`Пользовательские настройки приложений`,
"label.changemylanguage":`Изменить язык`,
"message.approval.plzcapppor":`Выберите утверждающего`,
"vue_label_pool_operatecertification2":`{0}{1}{2}{3}？`,
"label.publiccalendarandresource":`Общественные календари и ресурсы`,
"label.wtd.changefields.title.desc1":`Выберите поля для включения в форму Web-to-CloudCC, введите указанный URL-адрес возврата и нажмите кнопку "Создать".`,
"label.weixin.voting.not.empty":`Варианты голосования не могут быть пустыми`,
"label.campaign.channel.equal":`Равный`,
"label.emailobject.emaildetail.button.back":`Назад`,
"label.ccchat.person.invite.allowemails":`В целях безопасности, пожалуйста, введите адрес электронной почты, который заканчивается только на следующей странице`,
"label.notEdit.message":`Извините, у вас нет доступа для редактирования этих данных, обратитесь к системному администратору.`,
"label.layout.selectedfields.relatedlist":`Избранные поля / связанные с ними списки`,
"label.weixin.voting.deadline":`Крайний срок`,
"label.document.upload":`Файл для загрузки`,
"label.import.page2.notmatchfiled":`Всего в файле {csvfiledlength} полей. Поля {difflength} не отображаются.`,
"label.data.exp.selzippwd":`Если вы не заполните форму, то по умолчанию сжатого пароля нет.`,
"label.user.step2.select.email.template":`Шаг 2 Выберите шаблон электронной почты`,
"label.currency.effective":`Активные валюты`,
"label.version.control.type":`Организационное издание`,
"label.projectManagement.Taskorproblem":`Задача/проблема`,
"label.everyweek":`Еженедельный сайт`,
"label.passwordPolicy.setup.pwdremember4":`4 запомненные пароли`,
"label.emailobject.groupemail":`Групповая электронная почта`,
"label.approvepagelayout1":`У всех одинаковый план`,
"label.integrations.mailchimp.massage5":`Импортируйте выбранные лиды и контакты из учетной записи CloudCC в Mailchimp и отправьте электронное письмо целевым получателям`,
"label.icon.22":`Добавить к`,
"Dashboard_View_All":`Все приборные панели`,
"label.import.page2.example":`Пример`,
"label.send.letter":`Отправить письмо-приглашение`,
"label.mobilesectionpart":`подвижная часть`,
"component_setup_tabs_label_title":`табличная страничка`,
"label.knowledgebase.results":`{результаты`,
"label.field.remark":`На этой странице можно указать поля, которые могут появляться на`,
"vue_label_systemSettings_url":`Настройка доменного имени`,
"vue_label_SMS_failed_find_view_list":`Не удалось найти список просмотра`,
"setup_layout_label_order":`Сортировать по`,
"label.customsetting.touse":`Использовать пользовательские настройки`,
"label.product.enter":`Введите ключевые слова, чтобы найти подходящие продукты.`,
"label.email.template.private.SMS":`Эксклюзивная папка шаблонов SMS`,
"vue_label_homepage_chart_deleted":`График или приборная панель были удалены`,
"label.conversion_pages":`Страница конверсии`,
"label.compact.layout.select":`Выберите ключевые поля макета информации`,
"report_label_folderandreport":`Отчеты и папки`,
"label.product.entry":`Прайслист на книгу`,
"label.campaignmember.main.manageMember":`Управлять членами`,
"front-QBtoCC-changing":`Обновление...`,
"vue_label_pool_abandonreason":`Причина отбрасывания`,
"template.report.customer.contract.statistics":`Анализ счетов по договору`,
"label.invoice.message.sendsuccessully":`Счет отправлен успешно`,
"label.addcurrentoperate":`Добавить действие по выходу`,
"label.customerinfo.mailpwd":`Пароль почтового ящика`,
"batch.nochange.owner":`Нет разрешения на смену владельца записи!`,
"label_tabpage_uploadfailez":`Загрузка не прошла, пожалуйста, перезагрузите.`,
"vue_label_systemSettings_mobelqrsetting":`Настройка сканирования мобильного приложения`,
"label.regular_field":`Домен формы`,
"label.tabpage.delsuccessz":`Удалить успех`,
"label.Days.Before.Horizontal.Date":`дата уровня до`,
"label.evaluation.general":`Хорошо`,
"chatter.notlike.p":`Хватит любить этот пост`,
"label.chatter.send":`Отправить`,
"label.emailsync.button.cancel":`Отменить`,
"label.notification.task4":`Ваша задача сегодня истекает.`,
"vue_label_helpcenter_detail1.2":`Быстро изменить статус задания: поставьте галочку перед заданием в модуле "Просроченное и предстоящее" и нажмите кнопку обновления, чтобы быстро изменить статус задания на "готовое".<br> Перед обновлением отмените галочку, и статус задания не изменится.<br> Задачи с высоким приоритетом будут отмечены иконкой "красный флаг" в хронологии деятельности.<br>Последовательность отображения времени выполнения задания<br>Сортировать в обратном порядке в соответствии с датой выполнения задания, датой выполнения записанного звонка, датой начала события, датой отправки и получения электронных сообщений, а также датой отправки и получения SMS. Если вышеперечисленные даты совпадают, то они будут отсортированы в обратном порядке по времени создания записи.<br>Фильтр хронологии деятельности<br> Используйте фильтры в хронологии событий, чтобы сузить круг видимых объектов, сфокусироваться на важных объектах и найти целевые объекты. Фильтр временной шкалы включает в себя три типа фильтров: диапазон дат, активность, которая будет отображаться, и тип активности.<br>Действия для отображения: все действия, мои действия<br> В фильтре временной шкалы событий, эта опция может сузить диапазон отображения события.<br>Мои действия: Показать работы, в которых вы участвовали как владелец или участник. Например, вы являетесь владельцем, который отправляет электронные письма или организовывает мероприятия. Например, когда вы являетесь получателем поля Cc или Bcc, это означает, что вы участвуете в мероприятии.<br>.`,
"component_chatter_post_label_title":`Опубликовать`,
"label.data.dataexptemplate.desc":`Для экспорта данных используется шаблон экспорта данных, созданный пользователями, что может сделать экспорт данных более удобным.`,
"label.helptext":`Текст справки`,
"vue_label_norm_removecomponent_certify":`Подтвердить удаление компонента`,
"front-template-V1-Click-new-template":`Нажмите "Новый", чтобы создать новый шаблон. Активируйте и начните использовать этот шаблон`,
"label.optional_fields":`Необязательные поля`,
"label.delete_about":`Вы собираетесь удалить`,
"chatter.feed.initvalue":`Над чем ты работаешь?`,
"label.mail.configure":`Настройка личного адреса электронной почты позволяет отправлять и получать сообщения на домашней странице CloudCC email, а также синхронизировать историю сообщений электронной почты с ведущими и контактами.`,
"label.project.hit.seven":`Напоминание об истечении срока действия задания`,
"label.button.upgrade":`УПРАВЛЕНИЕ или ИЗМЕНЕНЕНИЕ ОБРАЗОВАНИЯ`,
"lable.PowerProcess.event.name":`Название этапа`,
"label.weixin.confirm":`Подтвердить`,
"label.customfields.new.inputformula":`Формула ввода`,
"label.standard.buttonandlink.edit":`Переопределить стандартную кнопку или ссылку`,
"workflow.action.tasks.assignortype.createdtype":`Тип создателя`,
"front-email-payment-paypal-describe":`Нажмите "Продолжить", вы можете войти на сайт PayPal или создать учетную запись PayPal для завершения оплаты счета.`,
"label.selectexistingoperate":`Выберите Существующие действия`,
"label.workflow":`Рабочий процесс`,
"label.assignment.setup.detail.ruleentries":`Записи в правилах`,
"label.data.file.i.title.num3":`3. система предварительно считывает файл данных с сервера, затем запускает внутренний массовый импортер, о результатах которого пользователи будут уведомлены по почте, и вам не придется ждать на этой странице.`,
"label.use.view":`Использовать существующие виды`,
"label.forecast.settings.moren":`Семейство продуктов по умолчанию`,
"vue_label_calendar_add_share":`Добавить акцию`,
"label_tabpage_newview":`Создать новый вид`,
"label.recycle":`Корзина для мусора`,
"UG_solution_03":`Создать решение`,
"label.customfields.formula.text.tip":`Создайте текстовую строку, например, путем объединения других текстовых полей.`,
"vue_label_file_single_file_size":`Максимальная поддержка одного файла`,
"label.a.b.least":`Каждая запись типа "А" должна иметь, по крайней мере, одну связанную запись типа "В".`,
"label.validate.function.addtoformula":`Вставить выбранную функцию`,
"label_tabpage_pleaseSelectz":`Пожалуйста, выберите`,
"label.account.NextFQ":`Следующий FQ`,
"label.project.project.name":`Название проекта не может быть повторено.`,
"label.emailtocloudcc.filed.owner":`Владелец`,
"label.textmessage.template.message2":`Поле, вставленное в текущее письмо, не совпадает с соответствующей записью, что может привести к нулевым значениям.`,
"label.icon.92":`Книга`,
"label.trailerpage":`Хвостовая страница`,
"component_event_label_noevent":`Похоже, вы сегодня закончили свою работу.`,
"label.trigger.tip":`О триггерах`,
"label.knowledge.case.field.usable":`Доступные поля дела`,
"label.group.isusing.success":`Активировать успешно`,
"label.marketsea.nextnotfollowdays":`С момента последнего наблюдения`,
"component.todaytask.label.choicestate":`Выберите статус`,
"label.recordtype.main":`-Мастер--`,
"label.sendletter.step1":`Step1: Укажите получателей приглашений`,
"label_tabpage_saveviewfailed":`Просмотр сохранить не удалось`,
"vue_label_report_notiec_selectone":`Каждая запись родительского объекта должна иметь как минимум одну связанную запись объекта`,
"UG_opportunity_003":`Отслеживайте каналы сбыта, создавайте приборные панели.`,
"#label.importsourcestep4":`Шаг 4 Импорт ваших файлов#`,
"front-kefu-moudle-v1-trrt-tip":`Для получения функции "Click to Dial" необходимо связать пользователей (агентов по обслуживанию клиентов) с добавочными номерами TRRT.`,
"UG.Forcast.09":`Следующий шаг`,
"label.ggReleaseRange.subordinates":`Роль поиска и подчиненность`,
"label.log.desctiption":`Вы можете загрузить трассировку аудита, которая содержит дополнительную информацию (файл Excel.csv).`,
"label.submitted":`Представлено на .`,
"label.validate.function.funcExplain.BEGINS":`Проверяет, начинается ли текст с указанного символа, и если да, возвращает TRUE, в противном случае возвращает FALSE.`,
"label.campaign.channel.code":`Канал маркетинга QR-код`,
"chatter.group.theLastActivityDate":`Дата последней деятельности`,
"vue_label_dashboard_pleaseenterabreakpoint2value":`Пожалуйста, введите значение точки останова 2`,
"label.labeltranslation":`Перевод этикетки`,
"label.multilang.product.deleterederect":`Ваше удаление {0} не могло быть завершено, так как оно все еще связано с записями в других прайс-листах. Связанная с ней запись выглядит следующим образом.`,
"lable.currencyManage.manageRate.dis":`Для управления курсами обмена для других объектов, добавления новых валют, активации или деактивации валют, а также для изменения корпоративной валюты нажмите Управление валютами.`,
"setup.layout.label.modifypage":`Редактировать макет страницы`,
"label.import.page2.editforname":`Пожалуйста, отредактируйте отображение для поля {necessaryName} .`,
"label.searchlayout":`Макеты поиска`,
"label.chatter.loadmore":`Загружать больше`,
"label.trigger.folder.all":`Все триггерные папки`,
"label.export_submissions":`Отправка форм на экспорт`,
"lable.SalesCommitmentKanBan.allsignedTaskRate":`Общая скорость выполнения подписанной задачи`,
"KeyInformationLayout_DefaultLayout_Name":`По умолчанию системы`,
"label.h5.chatter.great":`сходный`,
"label.call.center.configuration.enable":`Для включения функции вызова центра обработки вызовов организации воспользуйтесь следующими настройками.`,
"label.overdate":`Дата окончания`,
"chatter.poll":`Опрос`,
"label.login.input.verification.code":`Пожалуйста, введите код безопасности:`,
"label.file.sharetype.cooperation":`Сотрудник`,
"label.app.step5":`Шаг 5 Назначение профилей`,
"front-gantt-module-save-order":`Сохранить заказ`,
"label.globalselect.toallrecord":`Добавить новые значения списка опций ко всем типам записей, которые используют этот глобальный набор значений.`,
"setup.mainpage.label.welcome24":`Облачная платформа CloudCC обеспечивает настройки безопасности доступа ко всем объектным данным в системе. Совместное использование данных и права доступа могут контролироваться путем установки различных правил и условий.`,
"homepage.layout.desctiption":`Эта страница позволяет создавать различные макеты вкладок для вкладки "Главная".`,
"vue_label_SMS_notice_send_sussess":`Отправленное SMS`,
"label.projectManagement.overdue":`Просроченные`,
"label.assignment.setup.list.lead.description":`Вы можете создать несколько правил с различными условиями.`,
"label.list.projectSetting.des":`Вы хотите отправлять сообщения по электронной почте в соответствии с настройками, приведенными ниже:`,
"setup.mainpage.label.welcome18":`Настройки прав доступа корпоративного уровня CloudCC позволяют контролировать права использования отдельных пользователей при работе с данными и модулями. Настройки прав доступа на основе ролей также включают в себя пользовательские позиции, группы, роли, правила совместного использования данных, а также контроль безопасности на полевом уровне для обеспечения совместного использования данных между различными сотрудниками и отделами предприятия.`,
"label.ratio":`г/г и м/м`,
"label.Xaxis":`X-Axis`,
"label.google.map":`Google Map`,
"Dashboard.SelectBoardToDisplay":`Пожалуйста, выберите приборные панели, которые вы хотите отобразить на странице вкладки "Ракетка".`,
"label.data.newtemplate.e_conditions":`Условия экспорта`,
"label.emailtocloudcc.description3":`Подключите учетную запись электронной почты предприятия, например, sales@company.com, info@company.com, support@company.com. Автоматически регистрировать полученные письма в CloudCC в качестве зацепок и записей по делам, чтобы обеспечить своевременное отслеживание писем клиентов.`,
"label.page.select.profile":`Выберите профили пользователей, для которых будет доступна новая пользовательская вкладка. Вы также можете просматривать или изменять видимость закладок из детали и редактировать страницы каждого профиля.`,
"label.chosen.button":`Избранные кнопки`,
"front-epwechat-module-v1-info":`Внутренняя информация WeCom`,
"label.translation.select":`Критерии фильтрации`,
"ten":`Десять`,
"label.barcode":`Штрих-код`,
"lable.product.nextdel":`Продолжайте и удалите отображаемую запись, или нажмите`,
"label.default":`По умолчанию`,
"label.chatter.theme":`Темы`,
"vue_label_commonobjects_view_split_screen_view":`Разделенный экранный вид`,
"label.ems.myemails":`Моя электронная почта`,
"label.email.clearPersonalEmail":`Вы хотите удалить все письма, синхронизированные с личным ящиком электронной почты?`,
"label.login.access.admin":`Администратор вашей компании`,
"label.emailobject.wizard.desc":`После подключения учетной записи электронной почты в CloudCC вы можете отправлять электронные письма непосредственно из CloudCC, автоматически связывая их с соответствующими лидами, контактами и возможностями. История коммуникаций четко упорядочена по временной шкале.`,
"label.passwordPolicy.setup.minpwdlength":`Минимальная длина пароля`,
"choserow":`Выбранные столбцы для отображения`,
"front-epwechat-module-v1-role-binding":`Связывание ролей`,
"lable.outlook.edit.newdata":`имеет самую древнюю дату создания`,
"label.schedulejob.setup.schedule.enddate":`Дата окончания`,
"label.quickbooks.view":`Посмотреть`,
"font-evaluate-module-v1-not-inform":`Нет уведомления`,
"chatter.poll.option3":`Выбор 3`,
"setup_layout_label_selectfield":`Выберите поля`,
"label.partner.common.roleSetup":`Роль партнера и настройки пользователя`,
"label_partner_new_step3":`Шаг 3 Введите имя и урлу`,
"label.transfer":`Перевод`,
"label.bmap.myaddress":`Мое местоположение`,
"label_tabpage_individual":`Индивидуальный выбор`,
"label.autoRegister.changepwd.setpwd.repassword":`Пожалуйста, введите еще раз пароль`,
"vue_label_commonobjects_detail_and_before":`Ранее`,
"front-kefu-moudle-v1-single-Login-area":`Доменное имя с единой регистрацией`,
"label.replacedocument":`Заменить документ`,
"label.validate.function.category.Logical":`Логика`,
"label.companyprofile.syncsuccess":`Sync Successful`,
"template.chart.rwzthyxj":`Тема и приоритет задачи`,
"label.product.clearcondition":`Четкие условия`,
"component_task_label_person":`* Назначенное лицо`,
"label.tabpage.as":`Как`,
"message.error.calendar.add":`Календарь уже добавлен`,
"label.marketsea.isrecycleleadcreatebyself":`Ты хочешь переработать самодельные провода.`,
"label.icon.57":`Барометр`,
"UG.Lead.010":`Или`,
"setup_object_field_dependency_label_configured":`Макеты страниц, назначенные для профиля`,
"label.tianyancha.regnumber":`Зарегистрированный код`,
"front-kefu-moudle-v1-Opened-chats":`Включить чат`,
"label_tabpage_converstatez":`Преобразованное состояние`,
"label.bmap.beijing.haidianqu":`Улица Шанди 10, район Хайдянь, Пекин.`,
"label.startimport":`Начало импорта`,
"label.knowledgebase.application.default.settings":`Настройка приложения Lightning по умолчанию`,
"lable.account.year.custom":`Нестандартные финансовые годы`,
"label.event.nextmonth":`Следующий месяц`,
"label.email.body":`Тело`,
"setup.object.field.dependency.label.mustsetup":`Пожалуйста, сначала установите зависимость от полей и сохраните.`,
"label_tabpage_multiple":`Многократный выбор`,
"label.task.this.month":`Этот месяц`,
"label.customfields.formula.moneyexample":`Валовая маржа = Сумма - Стоимость _вк`,
"label.tonewemailnotice":`Выберите объект для этой задачи и нажмите Далее. Задачи могут быть связаны только с правилами рабочего процесса и процессами утверждения того же типа.`,
"setup.mainpage.label.welcome11":`Индивидуальный отчёт`,
"label.layout.availabletab":`Доступные вкладки`,
"label.data.importef":`Импорт неудачных файлов`,
"label.appupload.upload.alert":`Пожалуйста, предоставьте подробную информацию об этом пакете перед загрузкой. Эти настройки определяют, какие требования должны быть выполнены, чтобы установить этот пакет.`,
"label.sales.accountteam.shared":`Совместное использование команды учетной записи`,
"lable.currency.addexchageRate":`Добавить обменные курсы`,
"label.page.simplified.chinese":`китайский (упрощённый)`,
"label.service.dispatchingUnits.search.service.area":`Поиск территории обслуживания`,
"lable.list.queue.name":`Имя очереди`,
"pagecreator.button.save":`Сохранить`,
"label.ccpeak.support.function":`Поддержка всех видов функций в одной форме`,
"label.tianyancha.legalpersonid":`Идентификатор юридического лица`,
"label.sendemail.chat.addPostmainPage":`Дорогой #name:\n\n hello! #userName сообщения на вашей домашней странице CCChat.`,
"batch.no.change":`Нет разрешений на передачу данных.`,
"label.the.referenced":`вызванный`,
"label.input.webtab.information":`Заполните информацию о веб-вкладке.`,
"vue_label_systemSettings_subscription":`Тип подписки`,
"label.login.access.title":`Грант-аккаунт Вход в систему`,
"label.schedulejob.setup.schedule.lastday":`последний день`,
"label.synchronize.department":`Синхронизировать пользователей`,
"label_tabpage_lessequalz":`Меньше или равно`,
"label.file.library.successmanagemember":`Спасены успешно`,
"label.service.major.event.oreder":`Последовательность`,
"label.desktopintegration":`Интеграция рабочего стола`,
"label.a_b":`Отношения "А" и "Б":`,
"every":`Каждый`,
"label.tabpage.bar":`Бар`,
"label.filecontentsnotnull":`Содержимое файла не может быть пустым.`,
"label.layout.detailoftestobj":`Детали тестового объекта`,
"label.summaryreport.2018.step3":`Шаг 3 Выбор заголовков столбцов`,
"UG.Lead.002":`Существует множество способов определить "зацепки" для вашего продукта или услуги.`,
"label_partner_workspace_member_selectedprofile":`Выбранный профиль`,
"label.newdescription":`Новая запись`,
"vue_label_normal_moveup":`Двигаться вверх`,
"label.mobile.quickcreate.default.logacall":`История звонков`,
"userterritory.serviceterritory.user.unique":`Этому пользователю уже была назначена данная территория обслуживания. Пожалуйста, не переназначайте.`,
"label.weixin.record":`Запись`,
"front-kefu-moudle-connecting":`Подключение`,
"label.monitorsys.recent.operation.log":`Последний журнал операций`,
"lable.outlook.detail.lmaping":`Свинцовые поля карты`,
"lable.account.year.ovdate":`Дата окончания финансового года`,
"vue.homepage.auditcard.record":`{всего записей} записей`,
"label.processsetting.delete.process.succeeded":`Удалите процесс успешно!`,
"label.customerinfo.smsPwd":`Пароль шлюза SMS`,
"label.tolead.object":`Импорт объектов`,
"label.data.downpage.i.list.desc2":`После импорта данных вы получите электронное письмо с напоминанием об успешном импорте.`,
"label.sharerule.ruletype":`Тип правила`,
"label.reportsSubscriptionPage.email.toothers":`Отправьте мне и некоторым группам пользователей`,
"label.emailobject.templates":`Шаблоны`,
"vue_label_checkduplicate_":`Анализ столкновений`,
"label.campaign.channel.lookup.example":`Образцовый вид`,
"label.login.verification.please.note":`Обратите внимание:`,
"label.version.charge":`Заряд`,
"label.ccdocument.show.trace":`Показать след`,
"label.sendemail.approval.submit":`Здравствуйте, #name:\n #actorname the #objLabel-# recordname submitted by #actordate is waiting for your approval. пожалуйста, нажмите на следующую ссылку или войдите в систему crm, чтобы войти в центр одобрения для одобрения:\n #path#appPath/query.action?id=#recordid&m=query\n#orgName`,
"setup.mainpage.label.welcome12":`Пользователь может завершить определение отчета щелчком мыши, без программирования и следуя инструкциям системы. Система имеет список отчетов, сводный отчет и матричный отчет на выбор. Также доступны опции отображения для всех полей. Удалите ненужную информацию о полях. В то же время, она предоставляет различные графические дисплеи, включая полосы, складки линий, кольца, воронки и торты, так что пользователи могут видеть с первого взгляда.`,
"UG_contact_06":`Импортные контакты`,
"message.success.event.add":`Успешное сохранение новой информации о событиях`,
"report.line":`Поле данных`,
"label.approvepagelayout2":`У каждого своя планировка`,
"vue_label_normal_contract_sf":`Договор`,
"label.tabpage.tpcustomersz":`Конвертируемые провода`,
"label.ccchat.message.new.error5":`Ошибка, ваше сообщение не может превышать 10000 символов.`,
"label.severalorone":`личное дело`,
"pagecreator_systemstyle_label_buttonfontcolor":`Текст кнопки`,
"label.customer.tab.step3.introduce":`Выберите пользовательские приложения, для которых будет доступна новая пользовательская вкладка. Вы также можете просматривать или изменять видимость вкладок из подробностей и редактировать страницы каждого пользовательского приложения.`,
"chatter.group.groupEdit":`Редактирование группы`,
"label.partnerCloud.partnerAccount.spending":`Расходы на возврат`,
"label.slip":`пункт)`,
"label.field.master.class":`Уровень отношений между главным и конечным пользователем превышает уровень 3.`,
"label.sendemail.chat.addComentsmyFeed":`Дорогой #name:\n\n hello! #userName ответил на твой микропост.`,
"label.service.ganttBaiduMap.selectingDispatchTime":`Выберите интервал отправки`,
"label.knowledgebase.remove.article":`Вы уверены, что удаляете архивы формы статьи?`,
"label.appupload.notmanaged":`Неконтролируемый`,
"label.report.goto.step":`Перейти к шагу`,
"label.publicgroup.save.mustbeselect":`Вы должны выбрать членов`,
"label.data.expnode.e.desc2":`2、Экспорт по шаблону: пользователи могут выбрать шаблон для экспорта данных.`,
"UG.product.02":`Продукты относятся к продуктам или услугам, которые продаются или покупаются.`,
"label.sendemailtouser":`Вы уверены, что хотите отправить электронную почту выбранным пользователям?`,
"label.knowledge.setting.hint.nine":`Если вы не знаете, как Знание принесет вам пользу? Отсортируйте похожие статьи как единственную категорию данных и накапливайте до более широкой категории. Теперь добавим категорию данных. Вы можете добавить больше категорий позже.`,
"front-asset-module-v1-view-asset-bom":`Просмотр спецификации активов`,
"label_partner_all_enable":`Включить`,
"label.processsetting.disable.process.successfully":`Успешное отключение процесса`,
"label.call.center.enable":`Включить колл-центр`,
"message.recordtype.applyitseparatly":`Для каждого профиля применяйте свой макет страницы.`,
"label.weixin.report.customize":`Настроить`,
"label.file.mongdb.file.is.not.exist":`Файл не существует`,
"label.chat.edit.topics":`Редактировать тему`,
"label.knowledge.delete.searchterm":`Ошибка при удалении продвигаемого поискового запроса`,
"label_emailtocloudcc_redmessage3":`Пожалуйста, введите адрес сервера`,
"use":`Использовать`,
"label.batchtransfer.transferfrom":`Перевод от`,
"label.recycle.my":`Моя корзина`,
"label_json_string_null":`Пустой`,
"label.version.lookupfield":`Поле поиска Отношения`,
"lable.tianyancha.h5.searchf":`Не найден`,
"label.validate.globalvariable.description":`$User.[API поля] eg: $User.id <br>Вы можете использовать are: id,name,roleId,roleName,profileId,profileName,department,title,email.`,
"UG.opportunity.006":`Гений возможностей`,
"label.applt.copy":`Клонирование одним нажатием`,
"chatter.emailMessageOrReply":`Сообщения или комментарии к моему сообщению`,
"label.newreport.self":`Выбранные поля`,
"label.visualpage.checkpinxie":`Пожалуйста, проверьте орфографию страницы.`,
"label.knowledgebase.article.attaching.case":`Статья {name} была прикреплена к делу!`,
"label.dialogbox":`Диалоговое окно`,
"label.summaryreport.step3.new":`Шаг 3 Выбор данных для подведения итогов`,
"label.confirm":`Подтвердить`,
"label.mobile.buttom.team":`Команда`,
"label.quickbooks.action.link":`Ссылка`,
"vue_label_commonobjects_view_support_to_datas":`Операция поддерживает до 10 данных`,
"vue_label_helpcenter_homepage":`У каждого пользователя есть две домашние страницы с самого начала, стандартная домашняя страница и персональная домашняя страница. Администратор может назначить пользователю соответствующую домашнюю страницу профиля в соответствии с его профилем. Обратите внимание, что домашняя страница версии Lightning и домашняя страница старой версии не являются взаимозаменяемыми.<br> 1. Стандартная домашняя страница<br> Содержание стандартной домашней страницы однородно и не подлежит редактированию. Включая ежеквартальный компонент производительности, недавно просмотренный компонент, компонент центра утверждения, компонент сегодняшних событий, компонент задач, компонент просроченных бизнес-возможностей, из 30 дней компонент бизнес-возможностей, и предстоящий компонент бизнес-возможностей<br> Ежеквартальный компонент производительности: каждый может установить свои ежеквартальные цели<br> Недавно просмотренный компонент: Отображение 10 последних просмотренных записей объектов<br> 30-дневный бесконтактный компонент "Возможности для бизнеса": Показать 5 бизнес-возможностей, чей срок бесконтактной работы превышает 30 дней, а вероятность не 0 или 100<br> 2. Персональная домашняя страница<br> У каждого человека есть персональная домашняя страница, а содержание персональной домашней страницы можно настроить на добавление или удаление компонентов, либо перетащить, чтобы скорректировать положение и размер компонентов<br> При открытии счета на персональной домашней странице по умолчанию будет компонент брифинг, компонент центр одобрения, компонент просроченные бизнес-возможности, а также компонент предстоящих бизнес-возможностей<br> Персональная домашняя страница допускает до 15 компонентов<br> 3. Главная страница профиля<br> Администраторы могут создавать/редактировать/удалять главные страницы профиля, настраивая главную страницу, а также назначать разные главные страницы разным профилям, чтобы пользователи с разными профилями могли видеть разные главные страницы<br> До 15 компонентов на главную страницу профиля<br> 4. Добавить компоненты<br> Домашнюю страницу и профильную домашнюю страницу можно настроить на добавление компонентов, можно добавить компоненты приборной панели, компоненты диаграммы приборной панели и компоненты просмотра карт<br> Компонент приборной панели: добавить на домашнюю страницу всю приборную панель в системе. Количество подкомпонентов в приборной панели представляет собой количество компонентов, которое занимает компонент приборной панели (домашняя страница поддерживает до 15 компонентов), а данные компонента приборной панели после добавления не будут ассоциироваться с оригинальной приборной панелью (то есть, если оригинальная приборная панель удалена, то компонент приборной панели все равно может функционировать) <br>компонент диаграммы в приборной панели: Вы можете добавить конкретный компонент диаграммы в приборной панели в системе на главную страницу, и функция связи компонента в это время будет недействительна<br>компонент просмотра карты: Вы можете добавить на главную страницу определенный вид объекта в качестве источника данных, а поля и операционные элементы могут быть настроены. Но имейте в виду, что в случае удаления вида вида карты как источника данных, вид карты не будет содержать никаких данных.`,
"label.usersandlimit":`Пользователи и разрешение`,
"label.sendmail.step3.introduce2":`получатель(и), выбранный(ые) для получения этого электронного письма.`,
"label.setupcustomfield":`Пользовательские поля`,
"label.layout.last.notdel":`Последний не имеет права удалять макет.`,
"label.emailtocloudcc.redmessage7":`Ошибка конфигурации, пожалуйста, свяжитесь с администратором.`,
"label.includedIn":`Содержится в {parentproductname}`,
"label.permission.detail.app.pagesetting":`Пользовательские настройки страницы`,
"label.addfile.tips":`Выбрано {selectedNum} файлов. За один раз может быть добавлено до {originNum} файлов.`,
"label.fieldinformation":`Сведения на местах`,
"label.campagin.roi.sjcb":`Фактическая стоимость`,
"label.email.all.works.company":`Все коллеги компании`,
"label.currencyDesc":`Используйте эту страницу, чтобы определить все валюты, используемые Вашей организацией. Корпоративная валюта должна быть установлена на валюту, в которой ваш корпоративный головной офис отчитывается о доходах. Если Вы определите другую валюту как корпоративную, все обменные курсы будут изменены, чтобы отразить это изменение.`,
"label.file.details":`Подробности`,
"label.foldervisitlimit3":`Только следующие пользователи могут получить доступ к этой папке:`,
"label.account.next.M":`Следующий месяц`,
"label.oweralias":`Владелец псевдоним`,
"label.projectManagement.entryname":`Название проекта`,
"label.customcomponent.page.add.title1":`Информация о компонентах`,
"label.projectManagement.PleaseenterCreator":`Пожалуйста, укажите создателя`,
"label.multipleactivity.memberselected":`Избранные члены`,
"label_chatter_memotel":`Мемо-телефон`,
"lable.Confirm.customers":`Подтвердите восстановление {num} выводов.`,
"front-email-payment-Invoice-number":`Счетфактура №.`,
"label.not.appoint.validation":`Для правила проверки не указано ни одного объекта, пожалуйста, укажите.`,
"label.peru.time":`Перуанское время`,
"label.setting.intergrationlist.status3":`Требуется вход в QuickBooks`,
"vue_label_display_number_field":`Показать поля номеров`,
"label_productline_count":`Количество серий продуктов`,
"label.data.downpage.i_title.num2":`2. Before вы начинаете импорт, убедитесь, что имя поля в файле, который вы хотите импортировать, совпадает с именем поля объекта в CloudCC.`,
"label.field.duplicate4":`Трактовать "ABC" и "abc" как разные значения __(с учетом регистра).`,
"message.approval.step.validation.invalid.levels":`Минимум 1 уровень`,
"label.tianyancha.businessverify.step1":`Включить проверку бизнес данных шаг 1`,
"label.hidedetail":`Скрыть детали`,
"UG_Lead_009":`История вызовов APP`,
"label.partnerCloud.newProductSeries":`Новое семейство продуктов`,
"label.brief.opportunities":`Всего`,
"label.user.mfa.unbind.remind":`Вы собираетесь развязать MFA с выбранными пользователями и должны переподключить устройство MFA после следующего входа в систему, вы уверены?`,
"vue_label_report_grouprow":`Групповой ряд`,
"setup.layout.label.newarea":`Новая область`,
"label.nostart":`Не началось`,
"UG_Lead_010":`Или`,
"label.emailmerge.mergepage.record.requeired":`Пожалуйста, выберите записи, которые вы хотите объединить.`,
"label.appointmentpage.wizard.notif1btn1":`Подтвердить`,
"UG.Account.02":`Некоторые компании предоставляют услуги другим компаниям, некоторые напрямую сотрудничают с конечными пользователями, а другие обслуживают НПО.`,
"label.address.country":`Страна/регион`,
"label.userinfo.updatepwd":`Изменить пароль`,
"label.salescloud.teamrole.optionlist.opportunity":`Добавить возможность член команды в`,
"lable.account.Current.FY":`Текущая версия`,
"chatter.coll.p":`Закладка на эту должность`,
"label.setupsms":`СМС`,
"label.atlantic.daylight.time":`Атлантическое летнее время`,
"label.recordslock":`Блокировка записи`,
"button_partner_search":`Задать вопрос`,
"vue_label_salesfunnel_notice4":`Количество возможностей для бизнеса с вероятностью 1% - 99%`,
"vue_label_report_statistics":`Статистика`,
"label.ccchat.notmember.active.group0":`Вы не являетесь членом ни одной из групп деятельности с {0} на их имя.`,
"label.tag.manage.newtag":`Новая метка`,
"label.customfileds.formula.dateandtime.tip":`Рассчитайте дату/время, например, путем добавления числа часов или дней к другой дате/времени.`,
"label.weixin.mobile.fly.ios":`Поделиться с мобильного устройства (IOS)`,
"vue_label_file_over_file_size":`Размер файла file.name  'превышает заданный системой!`,
"label.schedulejob.setup.schedule.last":`последний`,
"label.ccchat.whose.name.contains":`любой активной группы, имя которой содержит`,
"label.project.milestone.name":`В одном проекте не может быть двух вех с одинаковым названием.`,
"message.passwordPolicy.validate.reuse":`Ошибка: Вы не можете использовать этот старый пароль повторно.`,
"label.stdashbord.xsld.business.img3":`Вероятность 1-99% * Вероятность`,
"label.event.view.list":`Просмотр списка`,
"label.workflow.ruletriggertime":`Время срабатывания правила`,
"label.campaign.channel":`Маркетинговые каналы`,
"label.appexchange.emailnotice":`Оповещение по электронной почте`,
"label.icon.77":`Сельское хозяйство`,
"label.visualpage.display.value":`Введите значения, которые будут отображаться, и обратите внимание, что до или после них нет пробелов.`,
"label.forecast.customforecast.type.user":`Пользователем`,
"label_tabpage_lessz":`Менее чем`,
"label.same.analyze.contact.email":`Email`,
"vue_label_report_range":`диапазон`,
"lable.product.pricebooks.nr":`Вы можете клонировать содержимое из существующих прайс-книг, выбрав из приведенного ниже списка.`,
"label_mobile_buttom_team_setUp":`Настройки команды`,
"label.email.bcc.recipients":`получатели БОС`,
"vue_label_ccchat_notice_deletepostfail":`Не удалось удалить сообщение`,
"label_file_type":`Тип файла`,
"label.multilang.feedtrack.operateupdate":`Модифицирована запись {0} :`,
"label.contractmanager":`Менеджер по контрактам`,
"front-gantt-module-drag-one-task-sorting":`Задачи можно сортировать только в пределах одной вехи!`,
"label.partner.step2":`Шаг 2 подтвердить шаблон`,
"front-epwechat-module-v1-again-binding":`Переплести`,
"label.service.miniProgram.imageSize":`Можно загружать изображения размером не более 2 МБ!`,
"setup_main2018_label_managesetup":`Администрирование Настройки`,
"component_salesperformance_label_nopermission":`Для просмотра данных, связанных с бизнес-возможностями, обратитесь к своему системному администратору.`,
"lable.account.stadate":`Дата начала финансового квартала`,
"label.service.gantt.and.resourcestype":`и тип ресурса`,
"label.ems.attachfiles":`Добавить приложение`,
"label.data.expnode.e.desc1":`1、Настраиваемый экспорт: пользователи могут выбрать поля для экспорта и установить условия фильтрации в соответствии с их потребностями.`,
"vue_label_systemSettings_analyse":`Анализируйте`,
"label.project.all.date":`Дата окончания должна быть позже или равна дате начала!`,
"vue_label_commonobjects_view_summary_basis":`Основа агрегирования`,
"template.chart.yywjhdschd":`Кампании с возможностями`,
"vue_label_pool_notmeet":`Не соответствует требованиям заказчика`,
"label.attendance.manager":`Управление посещаемостью`,
"vue_labenl_normal_current":`Текущий`,
"label.projectManagement.completed.quantity":`Завершение Количество`,
"label.layout.testfield":`Испытательные поля`,
"label.customfields.selectcontainrelatelistlayout":`Выберите макеты страниц, которые должны включать в себя этот список.`,
"label.fiji.time":`время Фиджи`,
"message.error.domain.already.exists":`Доменное имя уже существует.`,
"label.accountandcontact":`Счета/Контакты`,
"label.dashboardSetup.right":`Справа`,
"label.view.appliedMobile.xgry":`Отметьте этот пункт, соответствующие пользователи смогут увидеть вид на домашней странице рабочего стола.`,
"label.file.share.all":`Любой пользователь в вашей компании`,
"vue_label_pool_summary":`Всего {0} записей, обновленных в {1}`,
"label.emailtemplate.new":`Новый шаблон электронной почты`,
"label.tag.manage.button1":`Создать новый тег`,
"label.data.exp.tempexppage":`Страница шаблона экспорта данных`,
"font-trade-module-v1-invoice-total":`Общая сумма счета`,
"label.folder.sort":`Сортировочная папка`,
"label.multilang.campaign.countnum":`{0} время(ы)`,
"label.homepagelayout":`Главная страница Макеты`,
"setup_layout_button_cancel":`Отменить`,
"lable.Search.in.QuickBook":`Поиск в QuickBook`,
"setup_fielddependency_label_pleaseclick":`Нажмите на значение Контролирующего поля для редактирования`,
"setup.fielddependency.label.pleaseclick":`Нажмите на значение Контролирующего поля для редактирования`,
"label.version.sum.field":`настраиваемые поля`,
"label.form.is.submitted.successful":`Сообщение об успешной подаче формы`,
"label.campaignmember.main.batchaddmember":`Участники кампании массового добавления`,
"label.sendemail.activity.newevent":`Дорогой #belongtoidccname, hello:\r\nyour коллега #createbyidccname назначил вам новое событие в #created, которое гласит: \r\n тема: #subject\r\n время начала: #begintime\r \n время окончания: #endtime\r\n связанные элементы: #relatedstr\r\n содержание: #remark\r\nfor подробнее см. ссылку:\r\n #path\r\n #orgNameCRM system`,
"label.knowledgebase.select.target":`Пожалуйста, выберите цель`,
"setup.layout.label.buttonlist":`Кнопки выбора`,
"pagecreator.page.label.pagedesc":`Описание страницы`,
"label.version.professional":`Профессиональное издание`,
"UG.Forcast.10":`Полный`,
"template.chart.schdyqsr":`Ожидаемый доход от кампаний`,
"front-filter-module-v1-quick-filter":`Фильтр вспышки`,
"label.notification.group2":`Вы успешно присоединились к общественной команде`,
"label.ServiceCloud.statistics.by.serviceArea":`Статистика по территории обслуживания`,
"label.validate.function.funcExplain.TIMENOW":`Возвращает время, представляющее текущий момент`,
"label.brief.lastmonth":`последний месяц`,
"label.weixin.member.states":`Статус члена`,
"template.chart.ljxsje":`Накопленная сумма продаж`,
"label.eidt.queue.label.hasused2":`Это имя очереди уже существует или использовалось ранее.`,
"label.textmessage.nophonenumber":`Этот контакт не имеет номера мобильного телефона в записи!`,
"label.task.new":`Новая задача`,
"label.tabpage.grid":`Сетчатый дисплей`,
"label.workbanch.setup.viewname":`Название вида`,
"front-gantt-module-temporary-tasks":`Временная задача`,
"label.reportTypeDescripe":`Используя пользовательский источник данных отчетов, вы можете позволить пользователям создавать отчеты из предопределенных объектов, отношений между объектами и полей, которые вы указываете.`,
"setup_layout_label_fieldlist":`Доступные поля`,
"label.ggReleaseRange.searchforRole":`Роль партнера по поиску`,
"label.datamanage.account.field":`Поля аккаунта`,
"label_tabpage_groupingemptyz":`Пункты группировки не могут быть пустыми`,
"label.permission.edit.insertinfo":`Введите информацию о наборе разрешений`,
"label.back_forms":`Назад к списку форм`,
"vue_label_calendar_step_2":`Шаг 2: Создайте календарь из стандартного или пользовательского объекта.`,
"lable.outlook.mcto.out":`Исключенные домены`,
"label.workflow.accessnext":`Используйте этот процесс утверждения, если`,
"label.data.exp.temppage":`Экспорт данных и создание шаблонов Страница`,
"label_tabpage_printview":`Вид на печать`,
"vue_label_report_preview":`Чтобы просмотреть последние изменения, обновите их для предварительного просмотра.`,
"frame_personinfo_label_personimage":`Профиль Фото`,
"component.chatter.button.like":`Например,`,
"label.ems.drafts":`Чертежи`,
"front-lightning-module-v1-details-page-chart-report-name":`Название отчета`,
"label.partner.workspace.login":`Страница входа`,
"include":`включает`,
"label_length_20":`Длина ограничения до 20 символов.`,
"component_event_button_save":`Сохранить`,
"label.weixin.recalculate.shared.success":`Успешный пересчет правил обмена объектами.`,
"message.duplication.errorinscript.lessthan2":`Для объединения необходимо выбрать как минимум две записи.`,
"label_my_forecast":`Мои прогнозы`,
"label.ems.to":`Получатель`,
"label_mobile_buttom_team_init":`Инициализация пользователя команды`,
"label.sendemail.send.codeerror":`Преобразование кода не удалось, пожалуйста, введите правильную кодировку.`,
"lable.quote.syncing.and":`и`,
"label.campaignmember.selectmember.step1oftotal":`Шаг 1 из 2`,
"label.ems.step3":`Шаг 3`,
"lable.PowerProcess.detail.message":`Информация о вехах процесса`,
"chatter.poll.option2":`Выбор 2`,
"front-view-module-v12-verify-number":`Ошибка числового формата. Пожалуйста, проверьте входные данные.`,
"label.setup.mobile.homepageshortcuts.savesuccess":`Настройки быстрой функции сохранены.`,
"lable.outlook.edit.zdyoutfi":`Настраиваемое имя поля обмена`,
"label.assignment.setup.newentries.inputentries":`Введите запись правила`,
"label.customfields.money.tip":`Позволяет пользователям вводить сумму в долларах или других валютах и автоматически форматирует поле как сумму в валюте. Это может быть полезно при экспорте данных в Excel или другую электронную таблицу.`,
"label.service.appointmentList.cancelThePlan":`Отменить план`,
"label.chat.topic.suggest.add.topic":`Никаких предложений, добавляйте свою тему.`,
"vue_label_commonobjects_detail_tips":`Советы`,
"message.error.view.nameexists":`Ошибка: Уникальное название вида уже существует.`,
"label_emailtocloudcc_step2_name":`Настройка права собственности на электронную почту`,
"label.field.validation.apiname":`Она должна начинаться с буквы, содержать только заглавные и строчные буквы, цифры и подчеркивание, а максимальная длина 50 символов, минимальная длина 2 символа. Обратите внимание, что это не может быть ключевым словом базы данных.`,
"page.field.masterinput.remark2":`Например, при создании нового ордера необходимо включить эту функцию, чтобы на той же странице вводились записи строки ордера. (эта функция хорошо подходит для объектов, находящихся в отношениях "мастер-деталь").`,
"label.rule.enabled.successfully":`Успешное включение правил`,
"label.role.createrolelist.tip":`Ниже приведен список ролей для вашей организации. Вы можете просмотреть дополнительную информацию, нажав на ссылку роли.`,
"label.multilang.datamanage.dataimport.redundantmsg":`Длина заголовка &nbsp;{0}&nbsp; но длина данных &nbsp;{1}&nbsp; система не может определить, какие &nbsp;{2}&nbsp; поля являются избыточными.`,
"label.visualpage.staticresource":`Ввести статический ресурс`,
"chatter.group.members01":`Члены`,
"label.planned.workname":`Имя работы`,
"label.service.dispatchingUnits.gantt.data":`Совпадение даты Ганта`,
"label.data.newtemplate.t.conditions":`Шаблонные условия`,
"label.accmarketsea.edit.title":`Редактирование пула аккаунтов`,
"label_chatter_priority":`Приоритет`,
"label_mobile_buttom_team_open":`Включить команду на ПК и приложения`,
"front-gantt-module-no-tasks-available":`Нет доступных задач`,
"component.newrecords.label.type":`Тип хранения`,
"label.version.ccdocument.and.remark":`Примечания и приложения`,
"label.martrixreport.step2":`Выберите режим группировки, используемый для расчета данных, которые вы хотите развернуть`,
"label.projectManagement.Scheduleinformation":`Информация о расписании`,
"label.emailmerge.mergeFolder.description":`На этой странице вы можете создать документ Microsoft Word, содержащий данные о ваших контактах. Пожалуйста, выберите шаблоны почтовых слияний, до 20.`,
"label.autoRegister.changepwd.setpwd.tip":`Пароль должен отвечать следующим условиям`,
"label.partnerCloud.orderingPlatform.shoppingEmpty":`Корзина пуста, пожалуйста, нажмите "Добавить товар" для добавления.`,
"label.marketcloud_seminar":`Семинар по маркетинговому облаку`,
"label.knowledgebase.no.results.knowledge.search":`Нет результатов о "{a}" в Знаниях`,
"label.createdate":`Дата создания`,
"vue_label_systemSettings_bazaar":`Рынок`,
"report_type_label_contractPayment":`Контракты и дебиторская задолженность`,
"label.myemailset":`Мои настройки электронной почты`,
"label.emailtype":`Тип электронной почты`,
"label.appexchange.uninstallpage.message5":`Постоянное удаление всех связей и связанных списков, связанных с пользовательскими объектами в данном пакете`,
"label.customerinfo.applicationlicencenum":`Количество лицензий на функции`,
"label.product":`Продукция`,
"lable.opppdt.selPdt.subtitle":`Выбор продукта Для`,
"label_emailtocloudcc_step1_lead1":`Электронная почта на имя лидера`,
"label.multilang.recentview.query":`Смотрите последние новости {0}`,
"label.cumstom":`Пользовательский`,
"lable.product.pep":`Пожалуйста, введите цену.`,
"label.suggestion":`Идеи`,
"vue_label_email_sentto":`отправленный`,
"label.email.cancel":`После отмены ассоциации почтовый ящик нельзя использовать для отправки или получения электронных писем. Вы уверены, что хотите отменить ассоциацию?`,
"component_timeline_label_1monthahead":`за 1 месяц до`,
"setup_mainpage_label_welcome31":`Инструкции: Щелкните по меню в левой части этой страницы → Управление настройками → Создание → Приложение`,
"label.weixin.settlement.rate":`Коэффициент выполнения расчетов`,
"front-lightning-module-v1-details-page-chart-add-report":` Можно добавить не более 4 графиков отчета.`,
"label_related_list_types":`Связанный Тип списка Версия для молнии`,
"label.tabpage.converstatez":`Преобразованное состояние`,
"label.chatter.ok":`Подтвердить`,
"lable.SalesCommitmentKanBan.contractRate":`Подписанная ставка`,
"component.setup.label.setupsavefail":`Не удалось сохранить настройки компонента`,
"label.email.form.text2":`[переключиться на html]`,
"UG.Lead.009":`История вызовов APP`,
"label.escalation.setup.newrule.title":`Правило эскалации дела`,
"label.field.available.value":`Доступные значения полей`,
"label.cannotuseaddtimetrigger":`<b>`,
"vue_label_chat_activefail":`Активированный отказ`,
"label.dashboard.show.total.percent":`Показать общее количество или показать %, пожалуйста, выберите по крайней мере один`,
"label.schedulejob.setup.schedule.jobprg":`Программы трудоустройства`,
"label.select.email.type":`Пожалуйста, выберите тип электронной почты!`,
"chatter.group.allTheMembers":`Все члены`,
"label.webtab.validation.apiname":`Она должна начинаться с буквы, содержать только прописные и строчные буквы, цифры и подчеркивание, а максимальная длина - 20 символов, минимальная длина - 2 символа.`,
"label_partner_new_step3_name":`Имя`,
"vue_label_chatter_remove_member":`Удалить члена`,
"label.customobjects.majorobject.tip":`Если Вы выбираете объект нестандартных отношений, суммарные данные не принимают разрешений`,
"label.forecast.edit.kjjd":`FQ`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.three":`Три`,
"label.weixin.senderror":`Отправить не удалось`,
"label.visiturl":`Посетить URL`,
"label.apply.img.error":`Символы, введенные в граффити, неправильны`,
"label.been.detained":`Сбросить скидку`,
"vue_label_helpcenter_dashboard2":`<br> Во вновь созданной приборной панели сначала необходимо добавить компоненты и выбрать источник данных отчета или источник данных просмотра списка. Затем определите тип используемой диаграммы и выберите соответствующую группировку и статистические данные для создания диаграммы<br> После добавления компонентов, можно нажать кнопку "Reorder" на приборной панели, чтобы настроить положение и размер компонентов. <br> Если необходимо установить условия временной фильтрации для некоторых компонентов, можно нажать кнопку "Настройки условий фильтрации", чтобы выбрать компонент для установки временного поля, которое необходимо отфильтровать. После задания можно произвести фильтрацию по времени на приборной панели и выбрать соответствующий временной диапазон для обновления выбранных данных. <br>Заметка: Приборная панель поддерживает до 10 компонентов. <br> 2. Проникновение и связывание компонентов<br>В той же панели инструментов компонент A может устанавливать компонент B и C из того же источника данных, что и его объекты связывания. После завершения установки нажмите на область данных компонента A, компонент B и компонент C одновременно выполнят пересчет данных, основываясь на условиях области данных компонента A. <br> Обратите внимание, что нажатие на область данных компонента B или компонента C не приведет к повторному подсчету данных компонента A. Для достижения этого эффекта необходимо установить компонент A в качестве объекта связи с компонентом B/C. <br> Для каждого компонента диаграммы на приборной панели данные поступают из представления или отчета. Поэтому предусмотрена функция проникновения, т.е. щелчок по области данных компонента может перейти к соответствующему отчету и просмотру списка. Обратите внимание, что если исходный источник данных выйдет из строя, компонент не будет иметь данных и функция проникновения также выйдет из строя. <br> Поскольку область данных компонента для щелчка и проникновения, и связывание являются областью данных компонента, они не могут действовать одновременно. Если компонент имеет и состояние проникновения, и состояние связывания, то компонент может иметь только одну функцию, которая будет действовать одновременно, и вы можете выбрать функцию, переключив состояние связывания и состояние проникновения.`,
"vue_label_commonobject_view_notice_delete_false":`Данные {0} не удалось удалить, причина - {1};`,
"label.weixin.newspaper.coverage.information":`Подробная информация о листе риска`,
"label.you.do.not.have.permission.to.operate.":`У вас нет доступа к управлению.`,
"label.checkfield.match":`Матч`,
"message.custom.field.donotdelete.ref":`На это поле ссылаются другие поля`,
"label.version.maxsum":`достигла верхнего предела.`,
"System.ChangeUser.Info.001":`Владелец изменился и нажмите, чтобы вернуться на предыдущую страницу.`,
"label.target":`Цель`,
"template.dashboard.behavior.analysis":`Анализ действий`,
"label.login.verification.enter.prompt":`Пожалуйста, введите 6-значный цифровой код безопасности`,
"label.am":`AM`,
"chatter.emailSetUp.remark":`Позвольте пользователям получать сообщения CCChat, когда кто-то следит за вами, комментирует ваше сообщение и многое другое.`,
"label.accmarketsea.grouplist.title":`Настройка группы пула учетных записей`,
"label.stdashbord.xsld.business.danwei":`Отряд: 10 тысяч`,
"label.app.step1.error.namenull":`Вы должны ввести название публичной группы.`,
"label.login.button.verification":`Представить для проверки`,
"label_tabpage_newWizardz":`Новый мастер добавления функций`,
"label.addattachment.step1.intruduce":`Введите путь к файлу или нажмите кнопку, чтобы найти файл.`,
"pagecreator.layout.funcpath":`/ строитель / библиотека макетов`,
"fourth":`Четвёртый`,
"label.timetrigger.after.lasttime":`На один день позже даты последнего изменения.`,
"vue_label_report_showme":`Покажите мне`,
"label.h5.similar.opportunity.end.date.in":`Дата окончания находится в пределах следующего периода`,
"label.turntonextstep":`Переходим к следующему шагу`,
"label.icon.106":`Расписание`,
"label.user.receivenewsbulletin":`Получайте новости`,
"label.mask.card.number":`Номер кредитной карты`,
"setup.object.layout.label.profileoptions":`Доступные профили`,
"vue_label_systemSettings_obj":`Объекты и поля`,
"label.call.center.history.open":`Автоматически открыть страницу истории звонков`,
"label.attendance.cityname":`Пожалуйста, введите название города`,
"label.newemailnotice.tip":`Создать оповещение по электронной почте для связи с одним или несколькими правилами рабочего процесса или процессами утверждения. При изменении оповещения по электронной почте, любые изменения будут применяться ко всем правилам или утверждениям, связанным с ним.`,
"label.app.step1.error.labelnull":`Error: Label не может быть пустым.`,
"front-kefu-moudle-connect-free-account":`Ассоциирование пользователей CloudCC с пробными счетами TRRT`,
"label.biaoqingfaxian.description":`С включенной функцией bid&tender discovery можно добавить меню bid&tender discovery во внешний интерфейс, где пользователи смогут просматривать информацию о заявках соответствующих отраслей и преобразовывать данные о заявках в лидирующие позиции в системе.`,
"label.filter":`Фильтр`,
"label.data.downpage.e.title.num1":`1、Выберите объекты, которые вы хотите экспортировать, или выберите экспортировать все.`,
"label.h5.similar.opportunity.last.months12":`Последние 9-12 месяцев`,
"label.chatter.name":`Имя`,
"vue_label_helpcenter_email":`1. Отправить почту<br> Выход из системы, чтобы перейти к вашему почтовому ящику для связи с контактами был устаревшим. На Cloud CC вы можете связать свой персональный адрес электронной почты для отправки писем непосредственно из Cloud CC. Когда вы вводите адрес электронной почты или имя получателя, оно может соответствовать вашему контакту или записи проводников для вас. Вы также можете связать записи электронной почты с соответствующими записями, которые были настроены, а отправленные вами сообщения будут синхронизированы на странице с подробной информацией о записях.<br> 2. 4 общие функции при отправке сообщений электронной почты<br> При отправке сообщения электронной почты вы можете использовать 4 функции, расположенные ниже текста сообщения.<br>Отслеживание почты<br> Когда вы включите отслеживание почты, мы поможем вам отследить количество раз, когда это сообщение было открыто и когда оно было открыто в последний раз. Вы можете навести курсор мыши на значок "глаз" в списке исходящих, чтобы просмотреть его.<br>Upload Attachment<br> Щелкните Upload attachment (Загрузить вложение), вы можете выбрать файл, который был загружен в систему, или вы можете выбрать загрузку файла. Вы можете выбрать несколько вложений, если размер вложения меньше 20M.<br>Вставить объединенные поля<br> Когда электронное письмо связано с записью объекта, вы можете нажать на кнопку вставить объединенное поле, выбрать связанный объект, выбрать поле, которое вы хотите вставить, и ввести текст замены после запятой в объединенном поле, например, {!Contact.FirstName,Sir или Madam }. При сохранении шаблона объединенные поля будут отображаться в тексте шаблона по электронной почте. Используйте объединенные поля для персонализации содержимого электронной почты. Вы можете добавить заменяющий текст в любое объединенное поле. Заменяющий текст отображается только в том случае, если объединенная запись не содержит данных поля.<br>Правка и включение подписи<br> При отправке рабочих сообщений электронной почты подпись, которая может представлять вашу личность, поможет повысить профессионализм вашей работы. Нажмите кнопку "Редактировать подпись", вы можете редактировать свою основную информацию, а также поддерживать вас вставка фотографий. Если Вы установите флажок "Включить подпись", то Ваша подпись будет прикрепляться к телу сообщения каждый раз, когда Вы будете составлять электронное сообщение. Вы можете отключить подпись в любое время.<br> 3. Фильтровать папку "Входящие"<br> Вы можете отфильтровать все непрочитанные письма в папке "Входящие", чтобы облегчить вашу работу. Когда вы хотите загрузить файлы по электронной почте, вы можете отфильтровать все письма с вложениями в папке "Входящие", чтобы быстро найти нужное вам письмо. Кроме того, вы можете быстро просматривать записи о клиентах в системе, которую вы отслеживаете по электронной почте, просеивая электронные письма, содержащие открытые возможности для бизнеса, или просеивая письма, отправленные ведущими или контактными лицами.<br> 4. Массовая рассылка<br> В правом верхнем углу списка ссылок и контактов есть кнопка для групповой рассылки. Вы можете отправлять массовые рассылки потенциальным клиентам или записи о контактах с адресами электронной почты. При наличии записи о маркетинговых мероприятиях, вы можете рассылать электронные письма участникам маркетинговых мероприятий партиями, что также удобно для вас, чтобы отправить приглашения на мероприятия.`,
"front-kefu-moudle-auto-callphone":`Автоматическое создание новых дел для подключенных вызовов`,
"label.fiscal.FQ":`финансовый квартал`,
"label_tabpage_groupsVisiblez":`Выбранные группы пользователей`,
"UG.product.01":`Перечислить продукты/услуги`,
"vue_label_commonobjects_view_members":`Факультативные члены`,
"label.organization.id":`Идентификатор организации`,
"label.tyle_preview":`Предварительный просмотр стиля`,
"label.campaign.channel.input.to.owner":`6.Пожалуйста, установите, следует ли уведомлять своих владельцев, когда участники кампании войдут в систему по адресу:`,
"label.appointmentconfirmpage.wizard.notif1":`Назначение отменено!`,
"lable.tianyancha.maping":`Полевое картирование`,
"front-kefu-moudle-v1-noadd-online-chats":`Онлайнагент не добавлен`,
"vue_label_commonobjects_detail_group_strategy":`Вы уверены, что войдете в команду клиентов?`,
"vue_label_report_deletegrouprow":`Удалить строку группы`,
"lable.account.y.d":`На этой странице можно определить пользовательскую запись финансового года. Даты для пользовательского финансового года будут сгенерированы на основе выбора, который вы сделаете ниже.`,
"label.visualpage.lllegal.definitions":`Недействительное определение`,
"label.tabpage.enterrecordnamez":`Пожалуйста, введите владельца записи`,
"vue_label_report_howmuchlines":`линии`,
"homepage.components.custom":`Пользовательские компоненты`,
"label.campaign.channel.upload.img":`Загрузить изображение`,
"UG_Case_03":`Автоматическое обновление корпуса`,
"label.approved.receiveApprovalEmail.option4":`Никогда`,
"System.Data.Import.Warning.MaxCount":`Ваша организация может импортировать только {0} фрагменты данных за один раз, что сейчас выходит за рамки, пожалуйста, настройте и повторите импорт.`,
"label.sent.sms":`отправил SMS`,
"vue_label_dashboard_statistictype":`Статистический тип`,
"label_report_last_year_same":`Аналогичный период прошлого года`,
"lable.Examle":`Примеры`,
"label.customerinfo.PageTriggerFagTitle":`Синхронизация занимает два часа.`,
"label.mobile.phone.read":`Пересмотреть`,
"label.product.gopage":`Перейти на страницу`,
"label.a_b_without":`Записи типа "А" могут иметь или не иметь соответствующие записи типа "В".`,
"front-kefu-moudle-callin-missphone":`Вызов пропущенных вызовов`,
"label.sso.saml.sp.idsource.attrname":`Атрибутное имя`,
"label.h5.chatter.colleagues2":`Коллеги`,
"label.approveprocess":`Процессы утверждения`,
"label.dataimport.error.name.null":`Ошибка: имя нулевое`,
"label.paging.countitems":`{0}`,
"vue_label_report_notice_filter":`Когда расширенная фильтрация не включена, в отчете отображаются "и" различные условия фильтрации, т.е. записи, удовлетворяющие общим характеристикам 1 и 2. Например: 1 - это бизнес-возможность с суммой, превышающей 1 миллион, а 2 - расчетная дата заключения контракта, равная этому месяцу, поэтому результат отчета - более 1 миллиона бизнес-возможностей в этом месяце.`,
"front-lightning-module-v1-dashborad-export-picture":`Экспорт изображения`,
"label.activity.disabled":`Активность не включена, пожалуйста, свяжитесь с Вашим системным администратором, чтобы включить историю активности и необработанных действий на макет страницы.`,
"message_chooseatleastonefield":`Пожалуйста, выберите хотя бы одно поле для отображения.`,
"label.case.text":`Формы заявок на обслуживание, поданные через вебсайт, могут генерировать записи дел в системе. Пожалуйста, выберите пользователя в качестве создателя записи дела, и выбранный пользователь должен иметь разрешение на создание объекта дела. Вебстраница доступна для компьютеров и мобильных телефонов.`,
"label.sendmail.step3.dealoption1":`Передай мне одно сообщение`,
"label.forecast.settings.title.remark":`Наилучшая оценка предполагаемой выручки для пользователя, которая обеспечивает полное представление о бизнесе для пользователей.`,
"label.apply.youxiaotime.finish.opperation":`У вас есть 5 минут, чтобы закончить действия. Пожалуйста, проигнорируйте это сообщение, если операция выполняется не лично.`,
"label.user":`Пользователь`,
"pagecreator.page.button.copy":`Скопировать`,
"label.userinfo.pwdupdate.or.reset":`Ваш пароль был последний раз изменен или сброшен`,
"label.fieldupdata":`Обновления полей`,
"label.sendemail.chat.followsubject":`CloudCC CCChat за кем-то следят`,
"component_task_label_enddate":`Дата истечения`,
"label.campaign.channel.step6.remark5":`Вы можете переназначить его через правила назначения свинца. Узнайте больше о правилах назначения на руководящие должности.`,
"label.mr.title.mobilePhone":`Мобильный`,
"label.notice":`Напоминание`,
"message.serviceappo.time.violation":`Нарушение доступного времени начала обслуживания: Назначенное время начала приема на обслуживание позже, чем самое раннее доступное время начала.`,
"label.account":`Счета`,
"front-kefu-moudle-callcenter-user":`Пользователи Callцентра`,
"label.usermanage.query.notexist":`Пользователь запроса не существует.`,
"label.forecast.userinfo.isnable":`Разрешить прогноз`,
"label_partner_workspace_member":`Член`,
"vue_label_dashboard_penetrationsetting":`Проникновение Установка`,
"chatter.fieldtrack.operatecreate":`создал`,
"label_tabpage_tpcustomersz":`Конвертируемые провода`,
"label.emailtocloudcc.redmessage6":`IMAP/SMTP аутентификация не прошла, пожалуйста, проверьте правильность адреса электронной почты и пароля.`,
"label.customfields.file.upload":`Загрузить`,
"label.forecast.isforecast":`Прогноз не включен`,
"label_benchmark":`Ссылка на`,
"label.exchange.sync.state.system":`Статус синхронизации системы`,
"UG.opportunity.003":`Отслеживайте каналы сбыта, создавайте приборные панели.`,
"label.campaign.matchway.select.error":`Для обновления данных, пожалуйста, выберите подходящий метод.`,
"vue_label_dashboard_located":`Папка приборной панели`,
"front-electronic-signature-enter-object":`Пожалуйста, введите объект`,
"vue_label_systemSettings_mobelquick":`Быстрая настройка мобильных приложений`,
"lable.outlook.list":`Конфигурации синхронизации Exchange`,
"label.sendemail.approval.dlsp":`Здравствуйте, #dlspr:\n #actorname#objapiname-# recordname submitted by #actordate has been set as your proxy approvalver by the original approvalver #spr and is waiting for your approval.\nplease нажмите на ссылку ниже или войдите в систему crm, чтобы войти в центр одобрения для одобрения:\n#url\n спасибо! \n#прогноз`,
"label.service.deleteCustomView.wanttoremove.filter":`Вы уверены, что хотите удалить фильтр "{name}"?`,
"component_task_label_newevent":`Новая задача`,
"vue_label_commonobjects_view_chart_groupby":`Группировка по`,
"front-kefu-moudle-v1-edit-chats":`Редактирование агента`,
"pagecreator_page_message_delete_fail":`Не удалось удалить страницу`,
"label.file.search":`Поисковые файлы...`,
"label.projectManagement.Addpredecessors":`Добавить предварительную задачу`,
"label_tabpage_norecordtypez":`Неиспользуемый тип записи`,
"label.come.recycle.bin":`Перейти в корзину`,
"label.reportsSubscriptionPage.schedulereport.monthly.time.relative":`Относительный`,
"label.customfields.address.tip":`Позволяет пользователю выбрать провинцию, город, графство поля, и ввести конкретную адресную информацию, которая может быть использована для расчета широты и долготы.`,
"label.weixin.optioneight":`Выбор 8`,
"label.recordtypeselect.modify":`Редактировать Тип записи`,
"label.forecast.settings.future3":`Будущие 3 цикла`,
"label.rename":`Переименовать`,
"label.emailtocloudcc.button.complete":`Закончить`,
"chatter.new.at":`Самая последняя деятельность`,
"component.setup.label.milestonesfield":`вехатое поле`,
"vue_label_commonobjects_detail_email_newaddress":`Отправить`,
"lable.PowerProcess.big.event":`Веха:`,
"label.appexchange.uninstallpage.confirm":`Yes, I хотят удалить этот пакет и навсегда удалить все связанные с ним компоненты.`,
"label_mobile_buttom_homepage":`Домашняя страница`,
"label.sso.saml.idp.config.logouturl":`Единый URL-адрес выхода`,
"lable.quote.pdf.button.savetoquote":`Сохранить в кавычках`,
"label.page.select.application":`Выберите пользовательские приложения, в которых вы хотите использовать новые пользовательские вкладки. Вы также можете просматривать или изменять, появляется ли вкладка на странице деталей и редактировать страницу каждого пользовательского приложения.`,
"chatter.down":`Скачать`,
"label.tabpage.searchz":`Поиск`,
"label.emailsync.form.action":`Действие`,
"label.campaignmember.setup.campaignmember.field":`Поля участников кампании`,
"label.version.remark":`Примечание: Бесплатная редакция позволяет создавать только 5 пользователей, 2000 записей, и вы не можете импортировать или экспортировать данные.`,
"label.selectoperateobject":`Выберите объект.`,
"label.appointmentdetail.wizard.title12":`Время книги`,
"label.submitforapproval":`Представление на утверждение`,
"label.the.lower.bound.of.each.layer.of.editing.discount.must.be.equal.to.the.upper.bound.of.the.upper.level.":`Нижняя граница редактирования каждого уровня скидки должна быть равна верхней границе последнего уровня.`,
"label.appupload.install.component.view":`Виды Компоненты`,
"label.profile.customobjcontrol":`Пользовательские разрешения объекта`,
"label.customfields.configprofilefieldsafety.tip":`Выберите профили, которым вы хотите предоставить доступ к редактированию этого поля через безопасность на уровне поля. Поле будет скрыто от всех профилей, если вы не добавите его в систему безопасности на уровне поля.`,
"label.service.gantt.service.resources":`Сервисные ресурсы`,
"label.input.right.emailaddress":`Пожалуйста, введите неправильный адрес электронной почты.`,
"label.ccdocument.folder.notedit":`Папка не редактируется.`,
"label.data.choses.i.desc":`В соответствии с вашими потребностями, импортируйте данные из одного объекта.`,
"label.icon.75":`Автомобиль`,
"label.summaryreport.step4":`Шаг 4 Выберите столбцы отчета`,
"label.appupload.upload.install":`Установить`,
"label.reportlist.newfolder":`Новая папка отчётов`,
"label.projectManagement.myproject":`Мой проект`,
"label.true":`TRUE`,
"label.tabpage.reallproplez":`Владелец записи`,
"label.change.lead.share.error":`Нет права на редактирование клиента`,
"F":`Дата/время`,
"lable.account.CurrentandNextCQ":`Текущий и следующий CQ`,
"UG.activity.06":`Хотите проследить за счетами`,
"UG.contact.03":`Отслеживать контакты в одном месте, сигналы продаж`,
"label.field.duplicate.error.msg2":`Уникальная настройка свойства не удалось`,
"label.sales.dashboard.reality":`Фактические платежи`,
"lable.PowerProcess.type":`Виды процесса получения прав`,
"batch.selected.data":`Избранные данные:`,
"#label.importsourcefilestep2":`Шаг 2 Сожмите ваш файл (необязательно) #`,
"label.emailtemplate.select":`Пожалуйста, выберите шаблон электронной почты, который вы хотите использовать.`,
"chatter.most.w":`Вы можете ввести до 500 символов`,
"vue_label_calendar_new_object_calendar":`Новый календарь объектов`,
"label.aggregated_formsdata":`Агрегированные данные форм`,
"label.knowledge.language.french":`Французский`,
"label.customfields.enc.tip":`Позволяет пользователям вводить любые комбинации букв и цифр и хранить их в зашифрованном виде. И их нельзя искать.`,
"label.icon.158":`Облако`,
"font-evaluate-module-v1-bad-review ":`Когда тип оценки  Негативный`,
"UG_quota_03":`Шаблон для цитирования`,
"label.eidt.queue.label.hasused":`Этикетка уже используется`,
"label.lookupfilter":`Поисковые фильтры`,
"label.callcenter.Instance.name":`Имя экземпляра`,
"label.commitertype":`Тип отправителя`,
"vue_label_checkduplicate_any_one":`Познакомьтесь с любым из них`,
"label.campaign.channel.input.img":`Пожалуйста, выберите изображение с вашего локального компьютера в качестве благодарственной страницы.`,
"vue_label_dashboard_pleaseenterafoldername":`Пожалуйста, введите имя папки`,
"label.tianyancha.look":`Посмотреть`,
"label.tabpage.lastone":`Выберите хотя бы одну операцию`,
"label.sendemail.approval.submit.title":`{!objLabel} - {!recordName} ждет твоего одобрения.`,
"label.chat.topic.delete.prompt1":`Удаление темы занимает время, тема будет сохраняться в сообщениях и записях до тех пор, пока процесс не будет завершен.`,
"component_setup_label_displaybutton":`Кнопка дисплея`,
"label.partnerCloud.backgroundImage":`Фоновое изображение`,
"label.mobile.phone.time.range":`Диапазон времени`,
"label.page.url.address.remark":`В поле "Link URL" введите адрес веб-страницы. Вы можете ввести простой URL-адрес так же, как он отображается в адресной строке браузера, или вы можете использовать одно или несколько полей слияния, чтобы вставить данные из CloudCC.com, относящиеся к конкретной организации, в параметры URL-адреса. Некоторые сайты могут не работать на вкладке Web из-за настроек безопасности браузера или из-за того, что сайт не позволял отображать себя в кадре.`,
"label.h5.copyemail":`Электронная почта была скопирована`,
"label.view.step3":`Шаг 3 Выбор полей для отображения`,
"label.quickbooks.view.moneyreceived":``,
"label.emailobject.attachment.preview":`Предварительный просмотр`,
"label.selectapprover":`Выберите утверждающее лицо`,
"vue_label_normal_opportunity_sf":`Возможность`,
"label_emailtocloudcc_filed_port":`Порт`,
"mesage.errorinsaving":`Во время сохранения произошла ошибка. Пожалуйста, свяжитесь с Вашим администратором.`,
"label.partnerCloud.partnerCloudName":`Пожалуйста, введите название партнерского облака`,
"lable.edit.queue.checkemail":`Ошибка: Недействительный адрес электронной почты.`,
"label_builder":`Создатель страницы`,
"component_setup_label_setupsavefail":`Не удалось сохранить настройки компонента`,
"label.icon.76":`Автомобиль`,
"label.reportsSubscriptionPage.schedulereport.monthly":`Ежемесячно`,
"message.nopermession":`Без разрешения`,
"label.view.groupscansee":`Видимый для <b>определенных групп пользователей</b>.`,
"label.leadscore.rule.new":`Правило выставления очков лидерам: New Правило`,
"label.new.ccpeakfolder.time":`Занятия по расписанию: Новая папка`,
"label.record":`Записи`,
"message.error.flabel":`Метки полей, которые вы предоставили, не могут содержать английские одинарные или двойные кавычки.`,
"label.emailobject.emaildetail.promptbutton2":`Отменить`,
"label.h5.phone":`Звоните на .`,
"label.visualpage.error.deal.with":`Произошла ошибка, пожалуйста, свяжитесь с вашим администратором`,
"label.button.step1.select.field":`Шаг 1 Выберите поля`,
"label.setsharerule.step1":`Шаг 1 Выберите тип правила`,
"component.chatter.file.label.title":`Загрузка файлов`,
"front-epwechat-module-v1-appname":`Название приложения`,
"chatter.error.notsel":`Ошибка:Пожалуйста, выберите изображение для загрузки.`,
"label.updatevalue":`Точное изменение стоимости от`,
"label.chatter.sendEmailToGroupMember.subject.D":`{0} размещены документы для всех в {1}`,
"label_tabpage_grid":`Сетчатый дисплей`,
"homepage.components.standard":`Стандартные компоненты`,
"label.movable":`Деятельность`,
"label.report.selected.field.cannot":`Выбранные поля не могут превышать 50.`,
"label.projectManagement.distribution.by.excess":`Назначение по сверхурочной работе`,
"addrow":`Добавить Ряд`,
"label.approvaldatamove.p":`Используйте следующие опции для управления несколькими запросами на утверждение. Нажмите "Найти", чтобы отфильтровать запрос на одобрение. Когда результаты отображаются в виде списка, укажите действие.`,
"label.passwordPolicy.setup.title":`Политики паролей`,
"label.appointmentpage.wizard.title1":`{0}({1}) приглашает тебя`,
"label.tippage.li1":`Постоянно удалять пользовательский источник данных отчета`,
"label.campagin.roi.dcl":`Посещаемость`,
"label.h5.new.errorbody":`Эти обязательные поля со знаком * должны быть заполнены.`,
"label.cy.enable":`Включить валюту`,
"label.currency.rate.e":`Отредактируйте конверсионные курсы валют Вашей организации.`,
"or":`Или`,
"lable.custom.Previous.CYt":`Предыдущие 2 года`,
"front-epwechat-module-v1-unbound-desc":`Снятие привязки очистит привязанный счет. Вы уверены, что хотите снять привязку?`,
"pagecreator_button_publish":`Опубликовать`,
"font-evaluate-module-v1-case-owners":`Уведомить владельца дела:`,
"label.pw.new":`Пожалуйста, введите новый пароль`,
"message.tabsearch.nokeywords":`Пожалуйста, введите ключевое слово длиной не менее одного символа`,
"label.sendemail.send.erroruser":`Неправильный пользователь`,
"label.personalinfo":`Моя личная информация`,
"label.case":`Дела`,
"lable.product.pricebooks.now":`Существующие ценовые книги`,
"label.ccpeak.take.notice":`Примечание: ID, Auto Number, Created By, Created Date и другие системные поля не требуют ввода значений.`,
"label.page.first":`1-я страница`,
"label.icon.168":`Достопримечательности`,
"label.choices":`Выберите`,
"label.is.delete.document":`Вы уверены, что хотите удалить этот файл?`,
"homepage.layout.custom":`Пользовательские макеты`,
"label.emailobject.template.insert.field":`Поля`,
"label.ccpeak.folder.all":`Все папки класса`,
"front-console-conversation-btn3":`Переслать электронную почту`,
"label.ems.port":`Порт`,
"label.app.introduce":`Приложение представляет собой группу вкладок, которые работают как единое целое для обеспечения функциональности. Пользователи могут переключаться между приложениями с помощью выпадающего меню в правом верхнем углу каждой страницы.`,
"label.file.library.managemembers.admin":`администратор библиотеки`,
"vue_label_salesadvance_win":`Выиграл`,
"label.email.click.complete.info":`Нажмите кнопку "закончить", чтобы вернуться на предыдущую страницу.`,
"label.umeng.activity.event.willbegin":`Твоё мероприятие начинается в #время.`,
"label.mobile.phone.week.summary":`Еженедельная сводка`,
"label.quickbooks.fieldlabel.terms":`Условия`,
"lable.currencyManage.advcurrencyEnabled.dis":`Позволяет управлять датированными курсами обмена, которые отображают курс обмена валюты к определенному диапазону дат. Датированные курсы обмена применяются к валютным полям о возможностях, альтернативных продуктах и отчетам, связанным с этими двумя объектами.`,
"label.weixin.data.save.failed":`Неспособность сохранить данные.`,
"label.service.gantt.filter.logic":`Логика фильтрации:`,
"vue_label_pool_adopt":`собирать`,
"label.emailobject.markasunread":`Отметить как непрочитанный`,
"label_please_select_a_member":`Пожалуйста, выберите участников.`,
"label.salescloud.unit.ci":`Единица(Время)`,
"vue_label_pool_obsolete":`отброшенный`,
"label.cancelall":`Отменить выделение всех`,
"label.exchange.sync.state.setting.m2":`Пользователи в активных конфигурациях CloudCC Exchange:`,
"vue_label_pool_claimtime":`Время предъявления претензий`,
"label.forecast.forehistory.history":`История прогнозов`,
"label.knowledge.article.record":`Статья "Знания" не имеет оговорок.`,
"label.setting.intergrationlist.button.uninstall":`Удаление интеграции`,
"label_tabpage_gotit":`Понял`,
"label.data.exp.csvform":`Действительно только для экспортированных данных.`,
"UG.Forcast.06":`Пожалуйста, выберите пользователей, которым разрешено прогнозировать`,
"vue_label_report_savereport":`Сохранить отчёт`,
"setup.object.field.dependency.label.mustone":`Вы должны выбрать хотя бы одно значение зависимого поля.`,
"label.batchadd.newbatchpage.des1":`Поле имени записи является обязательным, в противном случае запись не сохраняется.`,
"lable.custom.CurrentandPreviousCYt":`Текущая и предыдущая 2 CY`,
"label.versiontype.Professional":`Профессиональное издание`,
"label.customfields.configprofilefieldsafety":`Установить безопасность на полевом уровне`,
"label.ccpeak.wgd.time":`Неофициальные запланированные занятия`,
"component.telerecord.label.subject":`Тема`,
"label_year":`Год`,
"pagecreator_layout_label_modifylayout":`редактор макета`,
"label.compact.layout.frame.splitline":`Линия раздела правого и левого экрана`,
"lable.PowerProcess.enter.the.process":`{describeName} Процесс поступления`,
"label.emailobject.cc":`Cc:`,
"front-electronic-export-choseCount":`Пожалуйста, выберите импортированные данные`,
"label.setup.mobile.bottombutton.recovery.default.success":`Успешно восстановленное состояние по умолчанию`,
"label.datamanage.import.accountfield":`Выберите из списка ниже поля в файле импорта, которые необходимо импортировать в каждую учетную запись. Затем нажмите кнопку "Следующий шаг":`,
"vue_label_opportunity_related_list":`Добавить в соответствующий список`,
"label.group.recent":`Недавно просмотренные группы`,
"vue_label_pool_finalclaimtime":`Время окончательного утверждения претензии`,
"vue_label_homepage_30daysnocontact":`Возможности для бизнеса без контакта в течение 30 дней`,
"label.tianyancha.field.error":`Данные по Тяньянче не найдены, пожалуйста, свяжитесь с системным администратором для выполнения инициализации.`,
"label.product.go":`Перейти к Отчётам`,
"label.customsetting.manage.introduce":`Если пользовательская настройка представляет собой список, нажмите кнопку Создать, чтобы добавить новый набор данных. Например, если в вашем приложении есть настройка для кодов стран, каждый набор может включать название страны и код набора.`,
"label.task.dateadd":`Плюс`,
"label.email.recipients.select":`Пожалуйста, выберите получателей`,
"chatter.emailListMyChat":`Любит сообщения или комментарии, которые я сделал`,
"label.batchadd.newbatchpage.save.name":`Если имя нулевое, система не будет добавлять эту запись по умолчанию, убедитесь, что имя не нулевое, а затем сохраните.`,
"UG_Lead_011":`Создать подсказку`,
"vue_label_salesfunnel_notice2":`Всего текущих возможностей`,
"APPIntegration_Social_linkedinerror":`Вы должны ввести действующий URL-адрес для сайта linkedin.com.`,
"label.industrialandcommercialverification.enablestatus2":`Имя счета в режиме реального времени`,
"label.stdashbord.xsld.business.ajssx":`По ролям`,
"lable.info.queue.showalluser":`Просмотреть все пользователи`,
"label.generatepage.c1":`Она должна начинаться с буквы. Она должна содержать только заглавные и строчные буквы, цифры и подчеркивание.`,
"label.thenset":`А потом, согласно`,
"label.salescloud.salescloud.defaultteam":`Группа пользователей по умолчанию`,
"label_partner_workspace_tab_selectedoption":`Выбранные вкладки`,
"label.tippage.li":`Удалить пользовательский источник данных отчёта will：`,
"lable.quote.syncingfrom.syncingto":`Продукты возможностей были синхронизированы с пунктами цитирования.`,
"label.emailobject.delete":`Удалить`,
"label.data.selectimportobject":`Выберите объекты для импорта`,
"label.knowledge.language.dutch":`Голландский`,
"message.campaign.page.overtime":`Страница истекла.`,
"label.ccchat.message.search.desc4":`Проверь правописание поисковых слов.`,
"label.login.forgetPsd":`Забыть пароль`,
"vue_label_title_order":`Заказать`,
"template.report.contract.follow.status":`Последующие действия Статус контракта`,
"label.forecast.edit.kjnd":`финансовый год`,
"front-electronic-export-listTitle":`Список Mailchimp`,
"label.dataimport.error.khmc.notnull":`Ошибка: вы должны ввести название счета.`,
"label.testobject":`Тестовый объект`,
"label_chatter_nextStep":`Следующий шаг`,
"label.file.public.link.share":`Общественный обмен ссылками`,
"label.weixin.organization.name":`Название организации`,
"label.quote.email":`Email`,
"label.reg_field":`Обычное поле`,
"font-evaluate-module-v1-response":`Ответ после оценки:`,
"label.chatter.sendmail":`Отправить электронное сообщение`,
"label.weixin.start.incorrect":`Недействительный формат даты начала`,
"component_chatter_link_label_url":`Соединительный урл`,
"vue_label_pool_operatecertification1":`{0}{1}{2}`,
"lable.currencyManage.Enabledadvcurrency.agree":`Да, я хочу включить расширенный валютный менеджмент.`,
"label.east.africa.time":`восточноафриканское время`,
"label.product.proof.Three":`В {0} выберите минимум {1} вариантов товара, но не более {2}.`,
"label_emailtocloudcc_filed_password":`Пароль`,
"component.task.label.person":`* Назначенное лицо`,
"pagecreator_systemstyle_label_buttonareacolor":`Цвет рабочей зоны`,
"label.clearrule":`Четкие правила`,
"lable.customer.access":`Разрешение доступа к учетной записи`,
"label.finish.wait":`Ваш запрос был обработан, пожалуйста, будьте внимательны, чтобы проверить уведомление о завершении в вашем почтовом ящике.`,
"label.weixin.appr.auditor":`Утвердить`,
"label.tabpage.systemz":`Система (системы)`,
"label.file.nocan.process.desc":`Невозможно обработать запрос. Мы не можем обрабатывать доставку контента.`,
"label.relationobject.name":`Имя связанного объекта`,
"setup.layout.group.relatedlist":`Связанные с ними списки`,
"label.generatepage.title":`Страница Web to CloudCC`,
"label.page.step3.input.url.information":`Шаг 3 Введите URL-адрес`,
"label.change.to":`Изменить статус участника кампании На`,
"label.validate.function.funcFormat.TIMEVALUE":`ВРЕМЯ(дата)`,
"label.partnerCloud.seriesSettings":`Настройка семейства продуктов`,
"component.timeline.label.1monthahead":`за 1 месяц до`,
"label.batchadd.senumberpage.selnum":`Выберите количество записей для добавления`,
"label.downloadapp":`ДОСТУПНЫЙ ВКЛЮЧЕН`,
"label.dashboardSetup.showmainpage":`Отображается на домашней странице`,
"label.h5.nophoneprompt":`Коллега не ввел контактный телефон`,
"label.service.deleteCustomView.wanttoremove.theFilter":`Вы хотите удалить фильтр "{name}"?`,
"label.appupload.state1":`Загруженный`,
"component_timeline_button_filter":`Фильтр`,
"label.passwordPolicy.setup.subtitle":`Установите ограничения паролей и политики блокировки входа для всех пользователей.`,
"vue_label_normal_quote_sf":`Цитата`,
"label.productsales.today.noevttskaddall":`Нет открытых событий и истекающих заданий, вы можете нажать кнопку " " в правом верхнем углу, чтобы добавить новое событие и задание.`,
"label.projectManagement.no.end.date":`Нет даты окончания`,
"label.sendmail.batch.chosetemplate":`Массовая электронная почта: Выберите шаблон`,
"serviceterritorymember.serviceresource.isactive.notactive":`Этот ресурс обслуживания не включен. Вы можете назначить территории обслуживания включенному ресурсу обслуживания.`,
"label.notification.event.overlapEvent.continue":`Продолжить работу по адресу .`,
"label.appupload.component.type.obj":`Индивидуальный объект`,
"label.partnerCloud.financeSetting.basicConfiguration":`Путь доступа: Публичная платформа  Разработка  Базовая конфигурация`,
"lable.outlook.detail.info":`Синхронизация Exchange Подробности конфигурации`,
"vue_label_commonobjects_detail_activity_commingevents":`Предстоящее мероприятие`,
"coderules.nullvalue2":`Не удалось сгенерировать. Пожалуйста, введите значение для 【{0}】,【{1}】, используемое в правилах генерации.`,
"label.version.sum.workflowrule":`правило(и) документооборота`,
"label.sso.saml.idp.config.enable":`Включить поставщика идентификационных данных`,
"label.temp.exp.conf":`Вы уверены, что хотите экспортировать шаблон?`,
"label.department":`Департамент`,
"label.trigger.operation.email.template":`Получить информацию о шаблоне электронной почты`,
"label.page.content.frame.height":`Высота рамки содержания (пикселей)`,
"label.ServiceCloud.jinengyaoqiu":`Требования к квалификации`,
"PageLayout.Search.MultiSearch.001":`Выберите до 3 полей.`,
"label.error500":`Ой!Ошибка...<br />Пожалуйста, заключите договор с администратором....`,
"label.appexchange.download.stop":`Остановить установку с конфликтом`,
"label.service.dispatchingUnits.left.right.totalAll":`В настоящее время {left}-{right} записей, всего {totalCount} записей.`,
"label.tabpage.haschangedz":`Этот свинец был преобразован`,
"label.industrialandcommercialverification.button.cancel":`Отменить`,
"label.edit.role":`Редактирование ролей`,
"label.mr.descreption.condition2":`Правила - по первым нескольким символам: пожалуйста, введите номер, найдите дубликаты по первым нескольким символам введенного номера.`,
"label.testgrammer":`Проверить синтаксис`,
"label.age":`Возраст`,
"lable.real.time.chat":`Техническая поддержка чата в реальном времени предоставляется компанией Easemob. Пожалуйста, настройте расширенную настройку в Easmob.`,
"vue_label_opportunity_selected":`{сумма} выбрана`,
"label.weixin.optionone":`Выбор 1`,
"label.file.delete.public.link.desc":`Удаление публичной ссылки означает, что никто не сможет получить доступ к файлу с этим url.if вы создадите новый, то это будет другой URL.`,
"label_tabpage_cancel":`Отменить`,
"template.report.opportunity.analysis":`Анализ стадии возможностей`,
"label.escalation.setup.newrule.inputrule":`Введите имя правила`,
"label.ccpeak.getapi.name":`Во время получения значения записи задайте API-интерфейс поля:`,
"second":`Второй`,
"label_tabpage_uploadsz":`Загрузить`,
"label.description":`Примечания`,
"label.ccchat.person.invite.notsamepwd":`Неправильный пароль`,
"label.mobile.app.isEnableAblumWatermark":`Добавьте водяной знак к фотографии, выбранной из мобильных альбомов при регистрации на рейс`,
"vue_label_allsearch_searchable_items":`Поисковые объекты`,
"lable.outlook.detail.react":`Недавняя деятельность`,
"label.sales.team":`Команда opportunityity Team`,
"label.guif.standard.time":`стандартное время Гольфа`,
"label.emailobject.emaildetail.button.forward":`Форвард`,
"label.refused":`Отклонено`,
"homepage.components.one":`Шаг 1 Введите имя пользовательского компонента`,
"day":`День`,
"label.dataimport.error.number":`Ошибка: Номер`,
"label.customer.tab.step2.same.option2":`По умолчанию выключен`,
"component_button_ok":`Подтвердить`,
"label.allrecordmeetprocess":`Все рекорды должны быть введены на этом этапе`,
"label.version.onefile.size":`Размер каждого загруженного приложения`,
"label.partnerCloud.orderingPlatform.allProducts":`Все товары`,
"pagecreator.page.message.publish.success":`Страница успешно опубликована`,
"lable.currencyAdv.exchagecurrency.rate.pro":`Предыдущий диапазон`,
"label.attendance.persons":`Подходящие пользователи`,
"label.send.an.email":`Отправить электронное сообщение`,
"registration.page.browser.title":`Регистрация маркетингового канала Campagin`,
"label.importfilestep3":`Шаг 2 Выберите и загрузите файл (-ы)`,
"lable.currencyAdv.exchagecurrency.rate.next":`Следующий диапазон`,
"label.ems.no.sync.msg":`Вы еще не настроили информацию о почтовой синхронизации.`,
"label.total_views":`Предварительный просмотр представления формы`,
"label.knowledge.article.notnull":`Пожалуйста, выберите хотя бы одну статью.`,
"message.error.view.lastview.delete":`Невозможно удалить последний публичный список</br>Вы не можете удалить последний публичный список, который виден всем пользователям.<br><br>.`,
"label.integrations.second.half":`фрагмент(ы) данных, выберите импортированные данные`,
"vue_label_systemSettings_mobelparams":`Настройка параметров мобильного приложения`,
"message.choose.maximum":`Вы можете выбрать до 150 записей, чтобы поделиться, теперь`,
"vue_label_homepage_won&unprocessed":`Открытый Не обработанный`,
"UG.contact.01":`Как извлечь максимум пользы из ваших контактов?`,
"label.data.import.setup.remark":`Администратор может задавать правила, которые будут выполняться при импорте данных, в том числе выполнять ли правила проверки, триггеры и правила дублирования и совпадения.`,
"pagecreator_layout_message_delete_success":`Макет удален успешно`,
"lable.account.name":`Наименование финансового квартала`,
"label.userinfo.must.updatepwd":`В целях безопасности, вы должны изменить пароль.`,
"label.mobile.phone.subordinate.setup":`Не может содержать подчиненных, пожалуйста, выберите все и установите их, чтобы разрешить прогнозы.`,
"label.monitorsys.delete.date":`Удалить дату`,
"label_emailsync_form_emailaddress":`Адрес электронной почты`,
"label.projectManagement.cancelled":`Отменено`,
"label.partnerCloud.partnerAccount.rechargeAmount":`Сумма пополнения должна составлять от 0,1 до 100000000.`,
"label.select.relatedlist.approval.layout":`Выберите Связанные списки для отображения на Макет Страницы Утверждения`,
"label.userphoto.thumbnail":`Эскиз`,
"label.assignment.setup.list.rulename":`Имя правила`,
"label.emailtemplate.usemergefields":`Объединить поля в шаблоне электронной почты`,
"label.tabpage.enabletomobile":`Включить ли мобильную сторону`,
"setup_layout_label_desc":`Поступающий`,
"vue_label_pool_abandonreasondiscription":`Описание причины выброса`,
"label.ems.outputmails":`Отправить почтовый сервер (smtp)`,
"font-evaluate-module-v1-evall":`Вся оценка`,
"front-epwechat-module-v1-unbound-tips":`Следующие данные будут очищены после отвязки:`,
"label.weixin.number.data":`Данные`,
"front-objectTemplate-V1-UseObject":`Применяемый объект`,
"label.call.center.configuration":`Настройки колл-центра`,
"vue_label_systemSettings_website":`Вебпортал службы поддержки клиентов`,
"lable.currencyAdv.foreverdate":`Постоянная дата`,
"label.globalselect.view":`Просмотр значения списка опций`,
"component_newrecords_label_title":`Последние записи`,
"component_assistant_label_title":`Помощник`,
"label.equals.deletebut.bulk.delete":`Включает кнопку удаления, массового удаления (в Корзину)`,
"label.field.duplicate.error.msg4":`Ошибка:Неверные данные.`,
"label.input.right.date":`Пожалуйста, введите действительный формат даты`,
"file.error.notsel":`Ошибка: пожалуйста, выберите файл для загрузки`,
"label.customcomponent.page.add.title":`Новый пользовательский компонент`,
"message.chooseatleastthreefield":`Выберите 3 поля как минимум`,
"label.dataimport.system.unnecessary":`система не может определить несколько`,
"message.login.wrong":`Неправильное имя пользователя или пароль.`,
"label.appupload.install.recheck":`Проверьте еще раз`,
"label.ems.option":`Вариант`,
"label.wei.subject.img":`Иконка темы`,
"chatter.emailReceiveOrNotAccept":`Выберите эту опцию, чтобы разрешить CCChat напоминание, а сняв этот флажок, вы не сможете получать ccchat напоминание.`,
"label.icon.46":`Печь`,
"label.newpw":`Новый пароль`,
"font-evaluate-module-v1-praise":`Тип оценки  Положительная`,
"label.help.user":`руководство пользователя`,
"label.callcenter.no.searchs":`Нет соответствующего запроса к информации`,
"UG_homepage_007":`От отправки последующих электронных писем до автоматизации кампаний по продажам, от создания рабочих процессов с использованием нашей технологии Blueprint до запуска пользовательских макросов, автоматизации повседневных задач и большего внимания к построению отношений.`,
"label.saveandnew":`Сохранить`,
"component_salesperformance_label_70finish":`Завершено - необработано (>70%)`,
"lable.account.dp":`На этой странице можно определить пользовательские финансовые годы.`,
"label.notification.serviceappointment.injeopardy":`{1}{0} находится в критическом состоянии.{1} Пожалуйста, оформите как можно скорее`,
"label.workflow.edit.esimaterule":`Ошибка: вы не можете изменить критерии оценки на "каждый раз, когда создаете или редактируете запись", пока у вас есть триггеры времени, связанные с этим правилом.`,
"label.partnerCloud.basicSetting.feature":`Функциональные настройки`,
"label.sms.companyname.gm.infor":`C.M.W.L.SMS Info (Эта услуга только поддерживает материковый Китай)`,
"vue_label_homepage_components":`Пожалуйста, выберите компоненты`,
"label_chatter_allactivity":`Все действия`,
"label.quickcreate.title":`Быстрое создание макетов`,
"label.tabpage.exclusivez":`Исключить`,
"front-service-cloud-transfer-desc":`При передаче владельца BOM актива, текущий актив и собственные активы под активом будут изменены владельцем`,
"label.data.downpage.i.list.desc1":`Во время импорта данные, которые не были успешно импортированы из-за неправильного форматирования, или из-за неудачного правила триггера или проверки, генерируют CSV-файл для отображения на текущей странице. Успешно импортированные данные не будут отображаться на текущей странице.`,
"template.report.individual.case.status":`Состояние дел`,
"label.report.export.file.format":``,
"vue_label_filternotice1":`То есть каждое условие фильтрации выполняется одновременно, например: 1 бизнес-возможность с суммой, превышающей 1 миллион бизнес-возможностей, 2 - бизнес-возможность с предполагаемой датой заключения контракта, равной этому месяцу, а результат фильтрации показывает бизнес-возможности, превышающие 1 миллион в этом месяце; когда <span style="цвет: красный">фильтр расширенного фильтра включен</span> При необходимости ручной фильтрации условий в поле расширенного фильтра`,
"label.lead.score.confirm1":`Это может занять несколько минут. You получит подтверждение по электронной почте после завершения.`,
"label.scores":`Оценки`,
"label.dashboard.message.mainnoset":`Главная приборная панель не настроена`,
"label.customfields.optionlist.fieldvaluelist":`Пожалуйста, введите значения, при этом каждое значение будет отделено новой строкой.`,
"label.autosearch.title":`Полный поиск титула автоматически`,
"label.knowledge.setting.hint.seventeen":`Создайте несколько статей`,
"label_tabpage_closez":`Закрыть`,
"label.partnerCloud.orderingPlatform.shoppingCart":`Корзина`,
"label.recalculate":`Пересчитать`,
"label.umeng.approval.approvalmes4obj":`#numsucc записи были одобрены в #obj, #numfailed реокрды не были одобрены.`,
"label.appointment.wizard.subtitle2-2":`На`,
"label.validate.function.funcExplain.AND":`Проверьте, все ли параметры верны. Верните TRUE, если все параметры верны.`,
"label.recordtype.batchaddattachments.remark":`Шаг 1 Выберите файл, Шаг 2 Архив, Шаг 3 Нажмите кнопку "начать загрузку", загрузить файлы, Шаг 4 Нажмите кнопку, чтобы закончить.`,
"label.reportlist.findreport":`Поиск отчётов`,
"label.partnerCloud.financeSetting.enterAppsecret":`Пожалуйста, введите Appsecret`,
"label.campagin.roi.query2":`Просмотр маркетинговых каналов ROI`,
"label.sendmail.notice.immediately":`Отправлять уведомления по электронной почте`,
"label.file.library.managemembers1":`Управлять членами`,
"label.forecast.customforecast.foredis.yclb":`Категория прогноза`,
"label.no.target.model.available.":`Нет доступной модели индикатора. Пожалуйста, сначала создайте модель индикатора или обратитесь к системному администратору.`,
"label.quote.contactname":`Имя контакта`,
"label.customer.tab.step2.same":`Применить одну видимость вкладки ко всем профилям`,
"UG_product_03":`Мультивалютное руководство по ценам`,
"label.pc.system.prompt":`Системная оперативность`,
"homepage.components.description":`Описание компонента`,
"front-email-payment-safety-code":`Код безопасности`,
"label.the.extra.reward.group.describes":`Добавить описание группы строк котировок`,
"label.isEnableVisualpage.new.rightlist":`Активные пользовательские страницы`,
"label.icon.84":`Трансформатор`,
"label.chat.message.to":`Получатель`,
"lable.product.pricebooks.edit":`Редактирование ценовой книги`,
"label.partner.workspace.member.belong":`Принадлежит`,
"pagecreator_systemstyle_message_delete_success":`Стиль удален успешно`,
"label.salescloud.teamrole.message.chooseatleastone":`Пожалуйста, выберите хотя бы пользователя.`,
"label.knowledgebase.self.window":`Идентичное окно`,
"label.product.cost":`Стоимость`,
"label.imgfield.remove":`Четкие изображения`,
"label.event.lastweek":`прошлая неделя`,
"template.report.today.statistics":`Продажи сегодняшнего дня`,
"label.emailobject.recipients":`Получатели({0})`,
"vue_label_commonobjects_view_successfully":`Установка представления по умолчанию успешно`,
"label.uploadfail.typeerror":`Загрузка не прошла, тип файла недействителен.`,
"vue_label_lead_required_fields":`Пожалуйста, заполните необходимые поля`,
"front-console-reopen":`Открыть заново`,
"message.layout.unique.relatedlist":`Пожалуйста, вернитесь к уникальным ограничениям соответствующего списка в макете страницы, пожалуйста, подтвердите и сохраните еще раз.`,
"label.emailobject.emaildetail.nextactivity":`Следующая деятельность`,
"label.publicgroup.save.error":`Ошибка: одна из следующих групп уже является родительской группой этой группы.`,
"label.editdefaultshare.tip":`Отредактируйте настройки общего доступа по умолчанию в вашей организации, приведенные ниже. Изменение этих значений по умолчанию приведет к тому, что все правила совместного использования будут пересчитаны. Это может потребовать значительных системных ресурсов и времени в зависимости от объема данных в вашей организации.`,
"label.icon.53":`Автомобиль`,
"label.exchange.sync.state.setting.m3":`Пользователи со связанными адресами электронной почты Microsoft Exchange и CloudCC:`,
"label.currency.enable":`Валюты: Включить валюту`,
"component.timeline.label.past":`Прошлая деятельность`,
"workflow.action.tasks.assignortype.user":`Пользователь`,
"setup_layout_label_relatedlistsetup":`Параметры смежного списка`,
"label.systemadmin":`системный администратор`,
"label_tabpage_allz":`Все`,
"label.ems.subject":`Тема`,
"message.recordtype.selectlayout.tip":`Выберите макет страницы, который пользователи с этим профилем видят для записей с этим типом записи. После сохранения выберите те значения из списка, которые доступны для данного типа записи.`,
"label.current.version":`текущая версия программы`,
"label.sourceoffile":`Untranslated - Производит набор файлов, по языку, с текстом, который еще не переведен.`,
"label.file.versionerror":`Пожалуйста, используйте вкладку "Файловые возможности" в новой версии интерфейса.`,
"label.validate.function.funcExplain.MINUTE":`Возврат минуты дня (из полей Дата/Время)`,
"abel.setup.mobile.bottombutton.profile.setting":`Настроить нижнее меню профиля`,
"label.recycle.dis.tip3":`Выберите Моя корзина в раскрывающемся списке, чтобы просмотреть удаленные элементы. Администратор может выбрать корзину All Recycle Bin (Вся корзина) для просмотра всех удаленных данных организации.`,
"message.selectnothing":`Никто Не выбран`,
"label.develop":`Разработать .`,
"label.tab.lightningpage":`страница молниеносной версии`,
"label.chat.micropost.share.info":`Поделиться`,
"label.block.pricing.editor":`Редактор блочного ценообразования`,
"label.ccchat.file.unavailable":`Этот файл недоступен`,
"label_component_helper_businesschange_0UntreatActivity":`Возможности без необработанной деятельности`,
"label.search.setup.obj":`Может установить максимум 100 объектов.`,
"component.setup.button.cancel":`Отменить`,
"message.longtextareamaxlength":`Длина не может превышать 32 000 символов`,
"vue_label_chat_removedby":`Вы были удалены из группового чата "Администратором".`,
"label.autoRegister.changepwd.setpwd.tip.morechar":`Не может быть менее 8 символов`,
"label.informassigner":`Уведомить назначенное лицо`,
"font-evaluate-module-v1-not-received":`Никогда не получайте оценки удовлетворенности от контактов`,
"label.trigger.triggertime":`Время триггера`,
"label.attendance.cannot.make":`Невозможно отметить`,
"label.shouldallrecords":`Все записи должны быть включены в расчёт`,
"label.eidt.queue.alter1":`Пожалуйста, выберите членов очереди`,
"L":`Пиклист`,
"label_emailtocloudcc_filed_email":`Email`,
"label.productsales.contract.badversion":`Ваша текущая редакция не поддерживает просмотр объектов договора, поэтому вы не можете просматривать суммы договора.`,
"label.tabpage.operation":`Операция`,
"label.file.copy.public.link":`Общественная ссылка была скопирована`,
"label.all.SMS":`ВСЕ SMS-оповещения`,
"UG_opportunity_008":`Команда opportunities`,
"UG.Campaign.002":`Планирование, выполнение и мониторинг эффективности рыночной деятельности.`,
"label.jiandangfenpei.title":`Назначение профиля`,
"pagecreator.systemstyle.message.delete":`Вы удаляете текущий выбранный стиль?`,
"lable.outlook.mcto.repeat":`Если будут найдены дубликаты записей, электронная почта будет ассоциироваться с`,
"label.user.field":`Пользовательские поля`,
"vue_label_commonobjects_detail_market_hierarchy":`Иерархия рынка`,
"label.ems.emails":`Электронная почта`,
"label.tabpage.deleteviewfailed":`Просмотр удалить не удалось`,
"label.data.exp.new.expobjtemp":`Создать экспортируемый объект шаблон`,
"label.useformulassetval":`Используйте формулы для установки новых значений`,
"label.service.newBuildDialog.six.fields":`Можно выбрать до 6 полей.`,
"error":`Ошибка`,
"template.chart.sdyyfx":`Анализ потерянной причины`,
"label.icon.191":`Усы`,
"label.app.step3.tabused":`Избранные вкладки`,
"label.user.level":`Пользовательский уровень`,
"label.custombutton.querydata.notexist":`Данные не существуют.`,
"label.executestate.calculating":`Расчет...`,
"label.visualpage.folder.notdel2":`1. данная папка содержит файлы и не может быть удалена.2. данная папка содержит скрытые файлы и не может быть удалена. Скрытый файл освобождается от логического объекта удаления (удаление из Setup-Create-Obkects), который скрыт, так как на самом деле объект не удаляется.`,
"vue_label_report_conditiondesc_three":`Вы будете уведомлены, если все условия будут выполнены`,
"approval.request.email.subect":`Запрос на утверждение`,
"label.log.user.value":`Пожалуйста, введите имя пользователя для поиска!`,
"label.isCompanyCurrency":`Корпоративный сайт`,
"label.related.2018":`Связанные с ними списки`,
"label.tonga.time":`время Тонга`,
"message.actionfailed":`Действие не удалось`,
"label.’s":`'s`,
"label.custombutton.queryobj.notnull":`Идентификатор объекта запроса не может быть нулевым.`,
"label.list.userinterface.setup":`Пользовательский интерфейс`,
"front-kefu-moudle-v1-yxgsbzq-reinput":`Формат электронной почты неверен. Пожалуйста, введите заново`,
"label.chatter.content":`Содержание`,
"label.projectManagement.Addnotes":`Добавить заметки`,
"label.service.newBuildDialog.reservation":`Показывать заказанное`,
"label.ccchat.pm":`PM`,
"vue_label_chat_cannot_invite_users":`Владельцы, не входящие в группу, не могут приглашать пользователей присоединиться к групповым чатам.`,
"label_partner_workspace_member_belong":`Принадлежит`,
"label.task.modify":`Редактирование задач`,
"label.tabpage.transformationsz":`Конвертировать`,
"label.new.password.no.indexof":`Новый пароль не может содержать китайские символы и пробелы.`,
"label.ji.quarter":`Нет. Квартал`,
"label.sso.isActiveNo":`Нет`,
"label.mobile.phone.week.report":`Еженедельные рабочие заметки`,
"label.email.template.please.select.folder":`Пожалуйста, выберите папку`,
"label.pc.ui.2018.tab.groups":`группа меню`,
"label.h5.approval.status":`Состояние утверждения`,
"setup.mainpage.label.welcome27":`Облачная платформа CloudCC предоставляет такие функции, как импорт, экспорт, пакетное удаление и пакетная передача всех данных об объектах в системе.`,
"vue_label_systemSettings_setHomePage":`Настройка Главная`,
"label.select.button":`Доступные кнопки`,
"label_emailsync_status_enable":`Активное подключение`,
"label.trigger.triggerVersion.detail":`Это поле не редактируется. В настоящее время существует две версии триггеров, 1.0 и 2.0, и все новые триггеры - 2.0, версия 1.0 запрещена к созданию.`,
"pagecreator_layout_message_save_fail":`Макет сохранить не удалось`,
"label.salescloud.salesdashboard.10big":`Топ 10 возможностей в ближайшие 3 месяца`,
"label.file.share.size":`Максимальная доля и публичная ссылка на каждый файл составляет`,
"label.page.simple":`Простой`,
"pagecreator.page.message.delete":`Вы удаляете текущую выбранную страницу?`,
"label.weixin.newspaper.coverage.detailinfo":`Подробная информация в листе рисков`,
"label.list.userinterface.chattersetup":`Настройки CCChat`,
"lable.opppdt.addpdt.table.quantity":`Количество`,
"label.product.description":`Описание продукта`,
"button_partner_back":`Вернуться`,
"label.user.current.loginuser.sessionid":`Идентификатор сессии текущего зарегистрированного пользователя:`,
"label.otherreport":`Другие доклады`,
"pagecreator_button_mobilepage":`Мобильная сторона`,
"label.mobile.phone.state":`Статус`,
"lable.currencyManage.unenableCurrencyAdv":`Отключить расширенное управление валютой.`,
"lable.product.addp":`Добавить цену`,
"label.field.validate.notpass":`Никаких синтаксических ошибок.`,
"label.app.global.search.obj":`До 10 объектов, которые можно настроить для использования в глобальном поиске.`,
"label.group.archived":`Архив`,
"vue_label_approve_to_submit":`Чтобы представить`,
"showfrom":`Показать из`,
"chatter.emailNotification":`Уведомления по электронной почте`,
"label.callcenter.pleaseenter.enterprise.number":`Пожалуйста, введите номер предприятия.`,
"label.forecast.customforecast.forecastnumber":`Числа прогноза`,
"label.vlidaterule.messagelocation":`Местоположение ошибки`,
"label.h5.similar.opportunity.step3.conment":`Столбец "Соответствие", представляющий собой количество соответствующих полей, всегда будет отображаться на экране.`,
"label.ccchat.group.gd.setting.info":`Измените настройки группы CCChat`,
"label.knowledgebase.delete.article.succeeded":`Успешное удаление статьи`,
"message.layout.edit":`Управление версткой страницы - это отдельная функция добавления стоимости. Если организация подтверждает, что она приобрела функциональный модуль, обратитесь за паролем к системному администратору. Для получения более подробной информации свяжитесь с CloudCC.com.`,
"label.case.create":`Случай ({0}) создан`,
"label.icon.170":`Покупки`,
"message.error.contact.null":`Контакт не может быть пустым`,
"label.appupload.install.error.hasinstalled":`Этот программный пакет уже установлен в вашей организации. перед установкой новой версии необходимо сначала удалить установленную версию.`,
"label.service.miniProgram.imageType":`Поддерживаются форматы PNG, JPG и JPEG. Рекомендуется использовать фотографии размером 750*349 пикселей. Наведите курсор мыши на фотографию, чтобы повторно загрузить или удалить ее.`,
"label.leadscore.rule.edit":`Количество очков за лидерство Rule: Edit Правило`,
"vue_label_commonobject_anytime":`В любое время`,
"label.clearing.conditions":`Ясные условия`,
"label.campagin.roi.ydkhjhze":`Общее количество выигранных клиентских возможностей`,
"Lead_Auto_Scoring_Setting_001":`Автоматическая оценка при редактировании или сохранении (За исключением очков, которые импортируются в пакетном режиме или создаются по интерфейсу).`,
"pagecreator.systemstyle.label.buttonareacolor":`Цвет рабочей зоны`,
"label.batchregist.huanxinuser.finish":`Массовая регистрация пользователя завершена`,
"UG_opportunity_006":`Гений возможностей`,
"message.serviceappo.violation":`Нарушение срока назначения: он противоречит другому служебному назначению.`,
"label.recordtypeselect.selectnew":`Выберите новый тип записи`,
"Lead.Tools.BatchScoring":`Свинцовая партия`,
"label.partnerCloud.financeSetting.enterWechat":`Пожалуйста, введите торговый счет WeChat.`,
"label.philippine.time":`Филиппины Время`,
"five":`Пять`,
"label_average_value":`AVERAGE`,
"message.realdelete":`Ты уверен?`,
"label.currency.note":`Введите информацию для новой валюты. Обратите внимание, что вы не можете удалить валюту после ее активации.`,
"label.projectManagement.delete.prompt":`Удалить подсказку`,
"label.approval.present":`(Ток)`,
"label.escalation.setup.newrule.name":`Имя правила`,
"label.edit.list":`Редактируемый список данных`,
"label.partnerCloud.financeSetting.informationOne":`1. Посетите торговый центр Alipay (b.alipay.com) и войдите в систему с абонентом Alipay.`,
"label.customfields.numberText":`2. сумма длины введенного числа и количества знаков после запятой не должна превышать 18.`,
"label.biaoqing.businessverify.relation.tip":`Записывает возвращенное значение bid&tender в поле lead`,
"label.icon.149":`Робот`,
"System.btn.SaveAndCommit":`Сохранить и отправить`,
"label.calendar.many":`Многопользовательский`,
"label.ccchat.create.email":`Электронное письмо создано`,
"template.report.income.marketing.activities":`Отчет о доходах кампании`,
"label.ccchat.person.invite.needemail":`Введите адрес электронной почты.`,
"template.report.open.amount":`Незакрытая сумма`,
"label.currentoperate":`Выбранные действия`,
"label.finalapprove":`Окончательное одобрение`,
"label.emailmerge.mergepage.step2":`2. Выберите шаблон почтового объединения, до 20:`,
"label_tabpage_sorttypez":`Сортировочный тип`,
"label.workbanch":`Мой верстак`,
"font-evaluate-module-v1-disable":`Вы уверены, что хотите отключить эту функцию?`,
"label.ServiceCloud.distributionMap":`Карта распространения`,
"lable.Confirm.potential.customers":`Подтвердите сбор {num} лидов.`,
"label.mobile.quickcreate.default.nearby":`Рядом`,
"label.isremider.noremider":`Без напоминания`,
"label.approval.select.step":`Выберите, на каком этапе подтверждения нужно возвращать`,
"chatter.error.pm":`Ошибка:Размер файла слишком большой.`,
"UG_activity_08":`Зарезервировать расписание`,
"label.marketsea.notwinopportunitydays":`Количество дней без сделки (должно быть больше, чем количество дней без создания деловой возможности)`,
"label.selectpage":`Выберите существующую страницу`,
"label.dashboard.dispalyOnTheHomePage":`Испорченная домашняя страница`,
"front-lightning-module-v1-details-page-chart-set-report":`Настроить отчет`,
"vue_label_pool_mydeal":`Моя сделка`,
"vue_label_report_lastone":`последний`,
"label.tabpage.potentialcustomersz":`Свидетельства`,
"font-evaluate-module-v1-more-satisfied":`Мы не достаточно хорошо。 Мы сделаем вас более удовлетворенным в следующий раз!`,
"label.trigger.instructions":`<p>Инструкция по использованию:</p><p><li>Параметры могут быть прямо процитированы:(DataContext)context,(UserInfo)userInfo,(Map)record_old,(Map)record_new</li><li>Когда получить значение записи Пожалуйста, непосредственно "получите" API имя поля</li><li>Если создать новую запись, используйте "String id = IDGenerator".createID("ID Prefix")"</li><li>Если нужно вернуть сообщение об ошибке:Пожалуйста используйте "trigger.addErrorMessage(")";trigger Will Return At Current Line,No Longer Execut Down！</li></p><font color="red">Note:Максимальная поддержка 200KB Characters,Около 200,000 байт.</font><font size=3 color="red">【Key：Нужно добавить примечания!】</font>.`,
"lable.SalesCommitmentKanBan.commitmentToCompletionRate":`Скорость выполнения обязательств`,
"label.umeng.approval.dlsp.approvenew":`Удалено одобрение: #actorname is request approval #objapiname# recordname`,
"label.edit.visualpagefolder":`Пользовательская страница : Редактировать папку`,
"label.pc.flash.teach":`Обучение видео`,
"label.showsearch":`Показать поиск`,
"label.reportsSubscriptionPage.condition.title1":`Вы получите уведомление, когда все условия будут выполнены.`,
"label.h5.search.result":`Посчитать`,
"vue_label_commonobjects_view_chart_pie":`Круговая диаграмма`,
"label_please_enter_currency":`Пожалуйста, введите валюту`,
"chatter.share.to.profile":`Ваш профиль`,
"label.mykeeptouchset":`Мое нажатие кнопки "Мое нажатие" Настройки`,
"label.profile.mustcopyaprofile":`Для клонирования необходимо выбрать существующий профиль.`,
"label.managereport":`Управлять отчетами`,
"label.total.choice":`файлы, выбранные`,
"label_emailtocloudcc_help":`Пожалуйста, введите правильный электронный пароль или код авторизации. Если вашему почтовому серверу необходимо включить службу IMAP/SMTP для входа в систему с помощью учетной записи стороннего производителя, сначала необходимо войти в настройки учетной записи электронной почты, чтобы включить службу, и скопировать код авторизации для авторизации в это поле ввода пароля.`,
"label.trigger.sel":`Триггеры в этой папке`,
"label.dashboardLookUp":`Вид Приборные панели`,
"label.batchadd.newbatchpage.save.emptytext":`Пожалуйста, проверьте, не заполнена ли необходимая информация.`,
"setup.mainpage.label.welcome16":`Инструкции: Щелкните по меню в левой части страницы → Настройки приложения → Создать → Схема работы, Процесс утверждения, Задачи, Уведомление по электронной почте, Обновление полей и многое другое.`,
"vue_label_email_mark as":`Отметить как`,
"label.customobjdel.cannot.delete.try":`Объект не может быть удален, так как он связан со следующими отношениями других объектов.`,
"label.customsetting.visible.public":`Общественный`,
"label.log.bit":`Биты`,
"label.data.exportall.all.desc":`Экспортирует все данные для всех объектов, на просмотр которых у текущего пользователя есть разрешение.`,
"message.login.mfadevice.already.bound":`Пользователь уже привязал устройство MFA.`,
"label.campaign.channel.please.img":`Пожалуйста, загрузите изображение`,
"assetbom.manage.notpermission":`Пожалуйста, свяжитесь с вашим администратором для разрешения доступа к управлению BOM актива.`,
"schedstarttime.schedendtime.time.illegal":`Запланированное время начала приема на обслуживание должно быть меньше или равно фактическому времени окончания.`,
"label.referperson":`Владелец`,
"front-email-payment-area":`Округ`,
"label.c.d.least":`Каждая запись в букве "С" должна иметь как минимум одну соответствующую запись в букве "D".`,
"label.weixin.longitude.isnull":`Долгота и широта пусты или недействительны`,
"setup.layout.button.ok":`Подтвердить`,
"vue_label_fiter_component_date_customdate":`Индивидуальная дата`,
"label.enable.case.createarticle":`Разрешить пользователям создавать статьи из кейсов.`,
"label.event.moveup.8hour":`8 часов вперёд`,
"label.input.most.string":`Пожалуйста, введите до {0} символов`,
"lable.SalesCommitmentKanBan.contractEndDate":`Дата окончания контракта`,
"label.visualpage.function.name":`Назовите функцию:`,
"label_emailtocloudcc_redmessage1":`Недействительный адрес электронной почты`,
"message.aliasnameinput":`Ошибка: Имя должно быть уникальным и начинаться с буквы. Оно должно содержать только буквы и цифры.`,
"label.data.exp.selectedtemp":`Выберите шаблон, используемый для экспорта данных`,
"label.import.page1.suitedwayoflinkman":`Стиль соответствия контактов`,
"label.customsetting":`Пользовательские настройки`,
"label.versiontype.Free":`Свободный план`,
"setup.layout.label.norelatedlist":`Нет соответствующих списков`,
"label.forecast.edittotal.de.leiji":`Рулон от`,
"label.customfields.file.max":`Загруженный файл слишком большой, пожалуйста, не превышайте 5 м.`,
"label_partner_all_workspace":`Рабочее пространство`,
"label.searchrelation":`Поисковые отношения`,
"label.icon.185":`Консультационный сайт .`,
"label.service.gantt.effective":`Действителен`,
"label.newreportstp1":`Шаг 1 Выберите Табличный формат`,
"label.category.9":`Производство`,
"label.zuowei":`Как`,
"front-quotation-v1-select-quota":`Выберите цитату`,
"label.dashboard.refresh":`Обновить`,
"label.weixin.saveandnew.log":`Сохранить`,
"label.report.list":`Списки сообщений`,
"FL":`Файл`,
"label.h5.followingcolleagues":`Коллеги выпали`,
"template.report.conversions.number":`Количество конверсий лидов (по владельцам)`,
"label.validate.function.funcFormat.MONTH":`МЕСЯЦ (дата)`,
"front-kefu-moudle-v1-tenant-ID":`Идентификатор арендатора`,
"label.reportsSubscriptionPage.schedulereport.monthly.time":`Время`,
"label.multilang.workflow.everyotherday":`Каждые {0} дни`,
"label.chat.message.send.message":`Отправить информацию`,
"label.knowledgebase.fast.operation.error":`Быстрая работа Ошибка`,
"label.multilang.dupicatecheck.dumplicatedata":`В записях {0} всего найдены {1}группы дубликатов данных, удовлетворяющих условию, а запрос занял {2} миллисекунды. На каждой странице показаны {3} группы данных.`,
"vue_label_report_addFile_detail_Information":`Экспортируйте только 2000 подробных строк. Используйте эти данные для дополнительных расчетов или загрузите в другие системы.`,
"label.ccchat.message.search.desc3":`Советы по поиску`,
"message.deletereport.prompt":`Не могу удалить этот отчет`,
"pagecreator.page.message.save.success":`Страница сохранена успешно`,
"vue_label_rise":`Ascend`,
"label.appupload.install.error.choicehead":`Как поступить, если существующие компоненты системы конфликтуют с компонентами, которые будут установлены?`,
"message.dispatch.violation":`Нарушение времени выполнения задания: период выполнения задания не входит в диапазон рабочего времени ресурсов.`,
"label.tool":`Инструменты`,
"label.sso.saml.idp.downloadcert":`Скачать сертификат`,
"label.chatter.detailinfo":`Подробная информация`,
"label.area.tree":`Территории Вид на дерево Иерархии`,
"label.partnerCloud.priceOfManual.notEnabled":`Не активировать`,
"label.chosesubject.call":`Звоните на .`,
"label.leadscore.rule.detail":`Скоринг лидов: Деталь правил`,
"front-welcome-to-try":`Приветствуйте испытание`,
"label.umeng.activity.event.willbegin1":`Событие начинается во время.`,
"component.event.label.noevent":`Похоже, вы сегодня закончили свою работу.`,
"label.document.templatesetof.folder":`Шаблонный набор папок`,
"label.quickbooks.none":`Нет найденных совпадений，Пожалуйста, введите имя для поиска или создания нового клиента`,
"label.assignment.setup.newrule.inputrule":`Введите имя правила назначения`,
"label.appointmentdetail.wizard.title4":`Название компании`,
"label.malaysia.time":`малайзийское время`,
"label.partnerCloud.partnerAccount.way":`Метод пополнения`,
"label.roleoflinkman":` Контактная роль`,
"mesage.error.role.delate.user":`Роль не может быть удалена, так как она назначила пользователей.`,
"chatter.warning":`Внимание: Если вы выберете другой объект, ваши изменения не будут сохранены. Вы уверены, что хотите это сделать?`,
"label.service.gantt.violations.sum":`Служебные назначения с нарушениями`,
"label.permission.objectpermission.recordfenpei1":`Назначенные типы записей`,
"label.mobile.phone.required.plan":`Требуется план`,
"label.after_leaving":`Текущие данные не будут сохранены после выхода`,
"label.cpq.opportunity.mainquote.trasnfer.order":`Была проведена первичная котировка под возможностью и переведена в заказ.`,
"component.setup.iframe.label.title":`Настроить страницу`,
"visit.dispatchplatform.nopermission":`Разрешение отклонено: Вы не авторизованы для доступа к диспетчерской консоли. Пожалуйста, свяжитесь с администратором.`,
"label.validate.function.funcExplain.RIGHT":`Возвращает указанное количество символов из конца текста`,
"component.chatter.link.button.save":`Опубликовать`,
"label.knowledge.selection":`В каждом Knowledge можно выбрать максимум 8 групп данных.`,
"chatter.email.homePage":`Отправьте мне сообщение на моей домашней странице CCChat.`,
"vue_label_commonobjects_view_copy_view":`Скопированный вид`,
"label.documentmessage":`Подробности документа`,
"label.emailtocloudcc.step1":`Шаг 1`,
"label.user.mfa.unbind":`Развяжите МИД к выбранным пользователям.`,
"label.stdashbord.xsld.business.sdzje":`Итого Сумма (Закрытые возможности)`,
"vue.please.select.the.total.method":`Пожалуйста, выберите способ суммирования.`,
"label.stdashbord.xsld.business.img1":`Количество этапов с вероятностью 1%  99%`,
"label.reportsSubscriptionPage.condition.title":`В дополнение к подписке, вы можете настроить условия в этом отчете. Вы будете уведомлены о выполнении условий. Это необязательно.`,
"chatter.sel.field":`Ошибка: Выбрано более 20 полей.`,
"label.login.access.year":`Год`,
"label.dashboard.all":`Все приборные панели`,
"label.approver":`Утвердить`,
"Lead.Homepage.Tools.BatchScoring":`Пакетная оценка`,
"lable.opppdt.selPdt.lesscondtions":`Меньше фильтров`,
"label.integrations.action.export":`Экспорт`,
"label.datamanage.lookupandsure":`(Просмотр и подтверждение)`,
"label.email.attach.to.mail":`Прикрепить к электронной почте`,
"message.nodataordeleted":`Данные не существуют или были удалены`,
"component_newrecords_label_all":`Посмотреть все`,
"lable.currencyAdv.startdate.rate":`Отображать все тарифы, определенные для даты начала в следующем диапазоне`,
"label.callbackoperate":`Действия по отзыву`,
"label.knowledge.setting.hint.eighteen":`Начните создавать статью для знаний`,
"label.user.step4.submit.email":`Шаг 4 Ваша повторная отправка по электронной почте отправила`,
"label.appointment.wizard.subtitle4-1":`Время в пути между событиями`,
"component.assistant.button.newtask":`Новая задача`,
"label.icon.129":`Карта`,
"label.relatedlist":`Связанные с ними списки`,
"label.report.recently":`Недавно просмотренный`,
"label.batchadd":`Массовое добавление`,
"front-template-V1-Delete-succeeded":`"{currentTelmplateName}" успешно удален`,
"label.appupload.upload.otherdetail":`Дополнительная информация`,
"label.emailobject.link":`Связь:`,
"label.quickbooks.createcustomer":`Создайте Клиента в QuickBooks`,
"report.label.projectcount":`элементы, сортировать по названию отчёта`,
"vue_label_normal_contact_sf":`Контактная информация`,
"chatter.group.groupActivities":`Все группы`,
"label_tabpage_addoptionsz":`Добавить опции`,
"label.knowledgebase.submit.for.translation":`Отправить на перевод`,
"vue_label_pool_notallowed":`Природа бизнеса не допускается`,
"label.icon.80":`Производство бумаги`,
"label.readonlys":`Только для чтения`,
"label.recordsediting":`Редактирование записей`,
"label.mr.title.email":`Email`,
"label.partner.all.enable":`Включить`,
"label.customsetting.manage.errmessage":`Сохраняйте пользовательские поля, прежде чем управлять данными.`,
"label.cloudccclass.list.cls":`Класс`,
"label.weixin.click.loadall":`Нажмите, чтобы загрузить все`,
"label.weixin.appr.initialtime":`Представленное время`,
"UG_ST_002":`Определить`,
"setup_mainpage_label_welcome17":`Настройки разрешений`,
"label.appupload.state0":`Незагруженный`,
"label.icon.115":`Дом`,
"setup_mainpage_label_welcome5":`Настраиваемое поле`,
"lable.custom.year.ovdate":`Нестандартная дата окончания года`,
"label_tabpage_findz":`Поиск`,
"label.appupload.uploading":`Загрузка...`,
"setup.mainpage.label.welcome1":`Нужно соответствующее разрешение`,
"label.file.folder.delete2":`Удалить библиотеку?`,
"2018UI_Homepage_DataNoAccess_Info":`У вас нет разрешения на просмотр этой записи, пожалуйста, нажмите, чтобы вернуться к предыдущему шагу.`,
"label.ems.google":`Google`,
"label.hawaii.aleutian.standard.time":`Гавайско-алеутское стандартное время`,
"template.report.unfinished.tasks":`Невыполненные задачи`,
"vue_label_calendar_add_calendar":`Добавить календарь`,
"label.button.sel.useremail":`Отправить электронную почту выбранным пользователям`,
"user.email.template":`Уважаемый{username}：<br>Код приглашения [{Campaign.name}] выглядит следующим образом<br>{Campaign.ColleagueInvitationLetter}<br>а URL：<br>{Campaign.ColleagueInvitationLetterLink}<br> Регистрация кода QR и регистрация ссылки URL поддерживаются для данной кампании! Спасибо за вашу поддержку! <br> Руководитель отдела маркетинга:{Campaign.Owner}`,
"label.forecast.settings.shouru":`Доход`,
"label.casesensitive":`Относитесь к "ABC" и "abc" как к разным значениям (с учетом регистра).`,
"message.pleaseinputrightdistanceweek":`Пожалуйста, заполните правильную интервальную неделю.`,
"label.linellae-group":`группировка столбцов`,
"label.showdefault_times":`Показать время публикации по умолчанию`,
"label.smstemplate.finishmessagedetailinfo":`Заполните детали шаблона SMS`,
"label.service.miniProgram.backgroundImage":`Фоновый рисунок`,
"label.recentview.news":`Последние рекорды`,
"label.reportType.chose.and.form":`Выберите источник данных отчета и формат отчета`,
"setup.layout.button.additem":`Добавить выбранные пункты`,
"front-epwechat-module-v1-auto-mate":`Automatch`,
"vue_label_helpcenter_contract&plan":`? Контракт - это письменное соглашение между сторонами. Многие компании используют контракты для определения условий ведения бизнеса с другими компаниями. Используйте Cloud CC для создания и документирования существующих контрактов с вашими клиентами и бизнес-возможностями. Отслеживайте договор через процесс утверждения.<br>Помощь в работе с контрактами и управление вашими сделками через план инкассации.`,
"label_mobile_version_nonsupport_feature":`Эта функция не поддерживается в текущей версии. Пожалуйста, обновите ее до последней версии.`,
"label.icon.44":`Пожар`,
"label.data.downpage.i.title.num3":`3、Перед импортом, не забудьте импортировать все соответствующие записи. Например: если есть поиск отношений между объектами, которые вы в настоящее время импортируете и контакты, вы должны сначала импортировать контакты, а затем импортировать ваши данные.`,
"label.mr.object.customer":`Счета`,
"label.social.user.null":`Информация о пользователе Social не может быть пустой`,
"front-epwechat-module-v1-unbound-item2":` все данные настроек приложения`,
"label.partnerCloud.partnerAccount.noempty":`Сумма пополнения не может быть пустой.`,
"label.weixin.myapproval":`Мои одобрения`,
"label.data.setok.e_desc1":`Экспорт успеха, вы будете получать системные сообщения оповещения, производные данные временно хранятся на сервере, система только для вас, чтобы сохранить 48 часов, пожалуйста, как можно скорее, чтобы`,
"lable.batchadd.service.cfq.after":`Триггеры (после вставки)`,
"label.umeng.activity.youhaveanevent":`У тебя новое мероприятие.`,
"label_emailsync_status_connectaccounts":`Подключенный аккаунт электронной почты`,
"label.multilang.shenpi.count":`Всего {0} записей :`,
"pagecreator.page.message.delete.fail":`Не удалось удалить страницу`,
"label.version.sum.lookupmdfield":`Поля для взаимодействия с клиентами`,
"vue_label_pool_clueduplication":`Дублировать разгадку`,
"label.system.setup.log":`Журнал системного поведения`,
"label.globaloperation.operationtype.send.e-mail":`Отправить электронное сообщение`,
"vue_label_pricebook_entry":`Вступление в новый прайс-лист`,
"label.forecast.forehistory.submit.date":`Представленная дата/время`,
"chatter.handle":`Над чем ты работаешь?`,
"lable.SalesCommitmentKanBan.complete":`Завершенная сумма`,
"label.weixin.upload.pictures":`Загрузить изображение`,
"label.create.document":`новый документ`,
"vue_label_commonobjects_detail_unlockconfirm":`Подтверждаете разблокировку?`,
"label.customer.page":`Пользовательские вкладки страницы`,
"button.partner.workspace.saveas":`Сохранить как`,
"setup.layout.label.asc":`Восходящий`,
"label.ccpeak.folder.time":`Неофициальные запланированные папки классов`,
"label_tabpage_includez":`Включить`,
"label.custom.button":`Пользовательские кнопки`,
"label.weixin.binding":`Привязать`,
"P":`Процент`,
"chatter.stop.n":`Прекратите следовать этой записи`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.wednesday":`среда`,
"template.report.revenue.marketing.activities":`Доход от кампании`,
"lable.SalesCommitmentKanBan.theActualReceipts":`Фактические поступления`,
"vue_label_popularresults":`Популярные результаты`,
"label.log.belongs":`Подчиненная часть`,
"label.profile.remark":`Пользователи с этим профилем имеют права и макеты страниц, перечисленные ниже. Администраторы могут изменить свой профиль, отредактировав личные данные пользователей.`,
"label.appupload.component.type.button":`Кнопка`,
"label.partner.all.operate":`Операция`,
"vue_label_notice_modify_fail":`Невозможность редактирования`,
"label.icon.137":`Земля`,
"front-dialog-module-v1-nosupport-copy":`Клонирование не поддерживается`,
"label.integrations.mailchimp.massage3":`Интеграция успешно деинсталлирована`,
"UG.opportunity.010":`Создать сделку`,
"front-lightning-module-v1-details-page-chart-selecting-reports":` Вы можете выбрать только публичные отчеты, т.е. отчеты с доступом для всех пользователей, и незаполненные публичные отчеты.`,
"System_btn_SaveAndCommit":`Сохранить и отправить`,
"vue_label_dashboard_statisticaltype":`Пожалуйста, выберите тип статистики`,
"label.mr.object.opportunity":`Возможности`,
"label.area.detail.remark":`Просмотр пользователей на этой территории`,
"label.view.sortview.index":`Заказать`,
"label.mobile.quickcreate.default.events":`События`,
"label.product.price":`Цена продажи`,
"label.leadmarketsea.edit.title":`Редактирование свинцового пула`,
"pagecreator.layout.button.edit":`Редактировать макет`,
"label.addressee":`Получатели`,
"label.movablesearchlayout":`Макеты поиска активности`,
"label.ems.confirm":`Подтвердить`,
"vue_label_file_save_to_file":`Сохранить в файл`,
"component_chatter_button_more":`Подробнее`,
"label.ccdocument.hidden.trace":`Скрытый след`,
"label.partnerCloud.maximumTwo":`Поддерживается файл размером не более 2 М.`,
"label.event.moveup.4hour":`4 часа вперёд`,
"label.batchadd.save":`Добавить ошибку совместного использования`,
"label.passwordPolicy.setup.expireDate":`Срок действия пароля пользователя истекает`,
"label.workflowrule":`Правила документооборота`,
"vue_label_notice_pleaseselecview":`Пожалуйста, выберите вид`,
"label.h5.chatter.colleagues":`О коллегах`,
"lable.opppdt.addpdt.subtitle":`Добавить продукт к`,
"label.data.import.setup.repeat.no":`Не вставлять все записи в мой файл импорта.`,
"label.changeCorporate":`Изменить валюту компании`,
"label.customfields.dateandtime.tip":`Позволяет пользователям вводить дату и время или выбирать дату из всплывающего календаря. Когда пользователи нажимают на дату во всплывающем окне, эта дата и текущее время вводятся в поле Дата/Время.`,
"label.integrations.mailchimp.massage1":`Пожалуйста, выберите 1 запись, по крайней мере, для экспорта`,
"lable.PowerProcess.custom":`На основе пользовательского условия`,
"label.service.editDialog.displays.service.appointmentsFordays":`Показать назначения на обслуживание за {} дней до даты уровня и {} дней после даты уровня.`,
"label.Receivables.ActualMoneyTime":`Фактическая дата получения`,
"label.matrixreport.intro":`Матричные отчеты показывают суммарные данные, рассчитанные в горизонтальной и вертикальной плоскостях в виде сетки.`,
"message.validation.isnotnumber":`Пожалуйста, введите недействительный номер.`,
"label.partner.workspace.member.search":`Поиск`,
"label.customfields.deletewill":`Удаление пользовательского поля будет выполнено:`,
"label.content":`Содержание`,
"component.setup.button.weburl":`Внешний урнал`,
"setup.mainpage.label.welcome28":`Инструкции: Щелкните по меню в левой части этой страницы → Управление настройками → Управление данными → Импорт и экспорт данных, Пакетная передача, Пакетное удаление.`,
"label.related.setup":`Установка задач и событий`,
"label.weixin.sign":`Дорогая, ты уже зарегистрировалась, не нужно делать это снова.`,
"label.norecord":`Нет Записей`,
"label.emailmerge.detail.emailtempldatemerge":`Шаблоны для объединения писем`,
"label_emailsync_status_role":`Роль`,
"label.mobileapp.modelsetting2":`Выберите модули, которые отвечают потребностям вашего бизнеса<br>Активировать: позволяет выбранным модулям отображаться в More Standard Function<br>Деактивировать: выбранные модули не смогут отображаться в More  Standard Function.`,
"component.sendmail.label.title":`Отправить электронное сообщение`,
"component_assistant_button_newevent":`Новое событие`,
"label.chatter.input":`Пожалуйста, введите содержание`,
"message.error.view.operate.rtnlink":`Щелкните<a href='javascript:history.back();'>где</a>, чтобы вернуться назад.`,
"lable.new.profile":`Новый профиль`,
"label.custom.field.null":`Нет доступных`,
"label.reportsSubscriptionPage.schedulereport.weekly.saturday":`суббота`,
"label.stdashbord.xsld.business.img4":`Общее количество стадий с вероятностью 100%`,
"pagecreator_layout_button_splitall":`Разделите все`,
"label.mobile.phone.total.amount":`Total Amount (ten thousand)`,
"label.ratifyhistory":`История утверждения`,
"label.projectManagement.Antecedents":`Предварительная задача`,
"label.projectManagement.Newserviceappointment":`Назначение новой услуги`,
"label.delete.record.is.approval":`Записи, которые вы хотите удалить, запрашивают одобрение, вы уверены, что хотите удалить?`,
"front-gantt-module-no-tasks-describe":`Вы можете просмотреть, как рабочие элементы организованы во времени, как они пересекаются и как они связаны между собой на диаграмме Ганта.`,
"vue_label_visualize_data":`Данные из TianYanCha заполнены. Пожалуйста, сохраните изменения.`,
"UG.activity.02":`Назначение задач`,
"label.field.duplicate2":`Дублированные значения не допускаются`,
"label.cloudccclass.list.tip":`Позволяет разработчикам разрабатывать на платформе CloudCC.com классы, которые могут быть использованы для настройки страниц и триггеров.`,
"before":`До`,
"UG.ST.001":`Симптома`,
"label_tabpage_userGuidez":`руководство пользователя`,
"vue_label_account_looking_for":`Пожалуйста, введите то, что вы ищете`,
"vue_label_calendar_notice_timecantmove":`Время календаря не может быть изменено путем перетаскивания`,
"label.mobile.phone.enter.summary":`Введите ваше резюме`,
"label.object.api.existed":`Это имя API объекта уже существует, пожалуйста, измените другое имя API.`,
"label.weixin..xsld.order.by.time":`Заказ по дате закрытия`,
"label.h5.chatter.whether":`Независимо от того`,
"label.file.delete.success":`Файл успешно удален`,
"label.imgfield.type.url.tip1":`Пользователь может ввести ссылку, которая ссылается на картинку, и установить размер картинки, добавив`,
"label.tomanyrecords":`Более 5000 наименований.`,
"label.save.partnercloud":`Ошибка при сохранении Partner Cloud`,
"vue_label_homepage_fliteritems":`Элементы конфигурации фильтра`,
"pagecreator_page_button_new":`Новая страница`,
"label.sharerule.baseofcondition":`На основе критериев`,
"label.dashboard.snapshot":`Снимки приборной панели`,
"label.appointmentpage.wizard.subtitle1.1":`Выберите дату и время`,
"label.reportsSubscriptionPage.condition.emailsummary":`Только резюме`,
"chatter.group.showAll":`Показать все`,
"label.tabpage.helpNavigationz":`Помощь и навигация`,
"label.emailtocloudcc.button.back":`Отменить`,
"approval_request_email_subect":`Запрос на утверждение`,
"label.lookup.error":`Во время поиска произошла ошибка`,
"label.publicgroup.save.groupisnull":`Данные группы во время сохранения являются нулевыми. Пожалуйста, сохраните их снова. Если произошла ошибка, пожалуйста, свяжитесь с Вашим администратором.`,
"label.pie":`Круговая диаграмма`,
"chatter.feed.is":`это корпоративная сеть, которая позволяет вашим пользователям работать вместе, общаться друг с другом и обмениваться информацией в режиме реального времени.`,
"label.customfields.file.max5m":`Максимальный размер файла 5 м`,
"com.cloudcc.login.error.message.vaildauthfail":`Недействительная аутентификация логина`,
"label.profile.appsetuppermission":`Управление настройками приложений`,
"label.customfields.file.totalmax":`Загруженный файл слишком большой, пожалуйста, не превышайте 500 м.`,
"label.sms.list":`Список интерфейсов SMS`,
"message.error.referencedcolumnIdnotexist":`Поля ссылок на отчет удалены и не могут быть отображены должным образом. Пожалуйста, обратитесь за помощью к своему администратору.`,
"front-lightning-module-v1-details-page-chart-setting-chart":`Настройка диаграммы отчета`,
"label.recordtype.profile.enables":`Типы записей В настоящее время доступны`,
"chatter.this.n":`эта запись`,
"label.only.upload.file":`Разрешается загружать только jpg/png файл и не более 500 кб.`,
"vue_label_lead_conversion_failed":`Преобразование не удалось`,
"label.file.share.file.success":`Успешный обмен файлами`,
"label.processsetting.delete.process":`Вы уверены, что хотите удалить процесс?`,
"message.uniquenamevalidate":`Он должен попрошайничать с буквой. Он должен попрошайничать с буквой. Он должен содержать только буквы, цифры и подчеркивание.`,
"label.group.archived.desc.info":`Эта группа была заархивирована, поэтому вы не можете создавать новые сообщения или обмениваться файлами с этой группой. Включение группы включает все функции.`,
"label.customer.maincontact":`Главный контакт`,
"label.appointment.wizard.subtitle1-9":`4 h`,
"label_productline_income":`Серийная выручка`,
"label.dashboardSetup.tz.ybb":`Перейти к приборным панелям`,
"label.recordowner":`Владелец рекорда`,
"message.approval.othersdoing":`Кто-то другой работает над этим процессом, пожалуйста, обновите его, чтобы получить последние данные.`,
"Opportunity_Detailed_Phase_Label_002":`{0}день(ы) в текущей стадии`,
"label.field.validating.rule.isnot.passed":`Не удалось скомпилировать правило проверки, пожалуйста, проверьте синтаксис.`,
"label.textmessage.fieldskong":`Некоторые из вставленных полей в сообщении нулевые, пожалуйста, отредактируйте и повторно отправьте!`,
"com.cloudcc.login.error.message.islocked":`Твой идентификатор заперт.`,
"label.forecast.customforecast.foredis.debfb":`% Квота`,
"lable.opppdt.selPbk.changepbk.worning":`Измените ценник для этой возможности, и альтернативный продукт, связанный с этой связью, будет удален. Вы уверены?`,
"label.mr.backLookReData":`назад, Просмотреть список дубликатов данных`,
"label.quickbooks.searchqb":`Поиск в КвикБуках`,
"label.service.gantt.searchSkills":`Навыки поиска`,
"label.account.Current.and.NexttFQ":`Текущий и следующий 3 FQ`,
"customer.notopen.chat":`Организация не активировала функцию чата, пожалуйста, свяжитесь с администратором`,
"vue_label_commonobjects_view_sum":`Всего {всего} рекорд(ы)`,
"label.partnerCloud.orderingPlatform.adjust":`Настроить заказ продукта`,
"label.emailmerge.mergeFolder.tips":`На этой странице можно создать файл Microsoft Word с контактными данными. Пожалуйста, выберите шаблоны электронной почты для объединения, можно выбрать не более 20 шаблонов.`,
"vue_label_ccchat_notice_deletecommentfail":`Не удалось удалить комментарий`,
"label.emailsync.status":`Статус электронной почты пользователя`,
"label.forecast.forecastroleuserpage.desc":`Назначьте на эту роль менеджера по прогнозированию. Прогнозы его подчиненных будут объединены в прогнозы его менеджера.`,
"label.step1.total4":`Шаг 1 из 4`,
"front-kefu-moudle-confirm-fjcase":`Вы уверены, что разделить это дело`,
"label.icon.60":`Кран`,
"label.appointmentpage.wizard.subtitle3":`Введите свою инфомацию`,
"label.loginservice.license.exceed.time":`Лицензия истекла.`,
"label.customcomponent.check.tag.lastrow":`Последняя строка должна быть`,
"label.product.code":`Код товара`,
"label.salescloud.salesdashboard.phone":`Телефон`,
"label_please_input_price_list_price":`Пожалуйста, введите прейскурантную цену.`,
"label.multilang.page3":`страница(и)`,
"label.file.lastmodifydate":`Модифицированное время`,
"label.icon.121":`Компьютер`,
"message.error.system.service.unknow":`Неизвестные услуги, пожалуйста, свяжитесь с вашим администратором.`,
"label.thesecond":`Вторая колонна`,
"vue_label_report_conditiondesc_two":`Добавить условия к этому отчету`,
"label.exchange.serverUrl":`Адрес сервера`,
"RL":`ссылка на`,
"label.emailobject.emailsend.sendindividuallyprompt":`Каждая квитанция будет получать сообщение только ему. Вы sure？`,
"label.appointmentconfirmpage.wizard.subtitle4":`Треники`,
"message.save.opportunity.team.save.failed":`Группа по предоставлению бизнес возможностей потерпела неудачу`,
"vue_labenl_normal_notice_share_success":`Успешно разделили`,
"label.triggerfolder":`Папки триггеров`,
"label.more":`Подробнее`,
"label.file.num":`Количество`,
"label.dashboard.list.sortBy":`пункт(ы), сортировать по времени доступа`,
"c":`Валюты`,
"label.weixin.detail.edit":`Редактирование`,
"label.escalation.setup.newentries.step2":`Шаг 2 Выберите критерии для этой записи правила`,
"label.report.error.prompt":`Не удалось выполнить конфигурацию. Поддерживается только серийный отчет с набором строк. Пожалуйста, убедитесь, что это публичный отчет и он не удален!`,
"label.notification.new":`Новый сайт`,
"label_tabpage_releaseTourz":`Опубликовать руководство`,
"label.icon.41":`Позиционирование`,
"label.sendsms.hello.new":`Здравствуйте, у вас новый`,
"label.custom.combination":`Объединить`,
"label.project.hit.fifteen":`Уведомление о назначении вех`,
"label.campaign.channel.step6.mobile":`Создать мобильную страницу`,
"label.goback.N.step":`Вернуться к предыдущему шагу N`,
"label_partner_all_name":`Облачное имя партнёра`,
"label.usermanage.loginusername.exist":`Имя пользователя уже существует.`,
"template.chart.cpxse":`Продажа продукции`,
"chatter.feed.deletecomments":`Вы уверены, что хотите удалить этот комментарий?`,
"label.list.userinterface.show.newrcords.enable":`Отключить последнюю запись`,
"label.sso.saml.idp.config.enablelogout":`Включить одиночный выход`,
"label.file.library.create":`Новая библиотека`,
"label.event.moveup.half.day":`0,5 день вперёд`,
"label.stdashbord.xsld.business.jhzje":`Общее количество возможностей`,
"label.partnerCloud.orderingPlatform.unitPrice":`Стоимость единицы продукции`,
"label.recordtype.edit.attribute":`Общие свойства`,
"front-template-V1-TemplatePreview":`Предварительный просмотр шаблона`,
"label.tabpage.personalCenterz":`персональный центр`,
"label.setuplookuplayout":`Макеты поиска`,
"label.no.merge.records":`Никакие записи не могут быть объединены`,
"label.attachementNew.set2":`Шаг 2 Архив`,
"label.publicgroup.detail.showmembers":`Члены Просмотровой группы`,
"UG.Forcast.03":`Начать планирование и реализацию бизнес-стратегий. <br> Желаю Вам счастливого прогноза!`,
"label.h5.manageprompt":`Выберите вкладку, чтобы добавить домашнюю страницу, или нажмите на вкладку, чтобы открыть ее.`,
"label.icon.145":`Связанный с этим сайт`,
"label.select":`Выберите`,
"label.publicgroup":`Общественные группы`,
"label.customcomponent.usewhere.title":`Где используется этот компонент:`,
"label.custom.page.button.name":`Имя кнопки`,
"pagecreator_layout_button_vertical":`Продольная разборка`,
"label.marketsea.autorecyclerule":`Правила автоматической переработки`,
"label.reportsSubscription.entrance.attachment":`Формат Excel .xlsx`,
"component_chatter_button_collect":`Закладка`,
"label.page.step2.of.step5":`Шаг 2 из 5`,
"label.reportsSubscription.addfile.helptext":`Вы можете установить, добавлять ли вложения отчетов в электронные письма подписки, а также формат вложенных отчетов.`,
"label.oldpw":`Старый пароль`,
"lable.SalesCommitmentKanBan.contractAmount":`Количество подписей`,
"lable.Bundle":`Улучшенный пакет`,
"label.weixin.unit.million":`Единица (десять тысяч юаней)`,
"label.app.choseprofile":`Назначить профиль`,
"label_tabpage_editz":`Редактирование`,
"label.email.attachement.size.info":`Файл не может быть больше`,
"label.chatter.pastSevenday":`За последние 7 дней`,
"label.weixin.end.later.start":`Дата окончания должна быть позже даты начала.`,
"label.passwordPolicy.setup.lockoutPeriod":`Период действия блокировки`,
"pagecreator_page_funcpath":`/ конструктор / список страниц`,
"label.emailobject.apperror":`Почтовая служба недоступна, пожалуйста, свяжитесь с администратором.`,
"label.custom.page.button.broadband":`Размер кнопки (пиксель)`,
"label.weixin.contract.rate":`Коэффициент выполнения контрактов`,
"label.brief.payments":`Платежи`,
"lable.approvaldatamove.transfermsg":`Массовая передача всех ожидающих одобрения запросов новому пользователю.`,
"label.datamanage.account.namenull":`Примечание: Если поле имени учетной записи является нулевым, запись не будет импортирована.`,
"lable.SalesCommitmentKanBan.allTotalPaymentAmount":`Итого Поступления от продажи Рулонов Сумма`,
"Opportunity_Detailed_Phase_Label_001":`Этап`,
"vue_label_helpcenter_calendar2":`<br> Календари объектов: Календари, которые вы создаете с объектами, отображают данные записи в виде календарных записей в поле даты на просмотре календаря. Вы можете редактировать или удалять объектные календари, а также настраивать цвет для каждого объектного календаря. <br> Новое событие<br> Вы можете создать новое событие в просмотре календаря двумя способами. <br> (1) Нажмите кнопку Новое событие в правом верхнем углу просмотра календаря, чтобы создать новое событие. В новом событии вы можете связать его с другими объектами, такими как бизнес-возможности, выбрав другие объекты в полях "Сопряженные объекты" и "Имя". Записи о событиях, связанные с другими объектами, синхронизируются в модуле "Действия" на странице "Детали других объектов". <br> (2) Или вы можете создать новое событие, нажав на сетку календаря. <br> Новый Календарь объектов<br> Шаг 1: Нажмите на вкладку Календарь в меню навигации, чтобы перейти на страницу просмотра Календаря. <br> Шаг 2: Найдите Мои календари в правой части экрана, щелкните по значку рядом с Моими календарями и перейдите к всплывающему окну "Новый объектный календарь". <br> Шаг 3: Начните с наименования созданного календаря объекта. Выберите объект, который является основой календаря, и выберите поля, которые определяют содержание отображения календаря, "Стартовое поле", "Фильтр просмотра", "Поле отображения". Поле "Пуск" определяет временной диапазон, в котором отображаются данные, можно отфильтровать данные с помощью фильтров просмотра, а поле "Отображение" определяет, что отображается на записи календаря. <br> Другие календари<br> Другие календари содержат календари других добавленных пользователей. Вы можете добавлять календари людей, которые находятся в подчинении у вас и делиться с вами календарями. <br> Поделиться календарем моих мероприятий<br> Шаг 1: Перейдите на вкладку Календарь в навигационном меню, чтобы перейти на страницу просмотра календаря. <br> Шаг 2: Найдите раздел "Мои мероприятия" в правой части просмотра календаря в разделе "Мои календари", нажмите выпадающую кнопку справа от раздела "Мои мероприятия" и выберите раздел "Поделиться календарем". <br> Шаг 3: Во всплывающем окне Общий календарь выберите пользователей и права доступа, с которыми вы хотите предоставить общий доступ к календарю. Кроме того, вы также можете просмотреть общие записи календаря, нажав на кнопку "Кто в настоящее время имеет доступ", и удалить общие записи, нажав на иконку "x" справа от общих записей. <br> После предоставления общего доступа к календарю подчиненные коллеги могут добавить календарь событий в другие календари, а затем просмотреть календарь событий. <br> Добавить календарь<br> Шаг 1: Перейдите на вкладку "Календарь" в меню навигации на страницу просмотра календаря. <br> Шаг 2: Нажмите выпадающую кнопку для других календарей в правой части просмотра календаря и выберите Добавить календарь. <br> Шаг 3: Во всплывающем окне Общие календари выберите календари событий тех людей, которых вы хотите добавить. Вы можете выбрать календари событий ваших подчиненных, а также календари событий, которые будут общими для вас. Нажмите кнопку Добавить, чтобы добавить успешно. <br> Удалить добавленный календарь<br> Нажмите выпадающую кнопку справа от календаря, который вы хотите удалить под другими календарями, и выберите Удалить.`,
"label.callcenter.Seat.number":`Номер места`,
"vue_label_commonobjects_view_change_all_selected_records":`Изменить все выбранные записи`,
"label.user.notinuse":`Пользователь неактивен, пожалуйста, свяжитесь с вашим администратором.`,
"label.usermanage.hasbeen.reached":`Максимальное количество лицензированных пользователей достигнуто, пожалуйста, свяжитесь с поставщиком услуг для получения дополнительных лицензий.`,
"vue_label_help_list":`Просмотр списка`,
"label.infomation.edit":`Редактирование основной информации`,
"label.ccchat.person.setting.info":`Откройте свою деловую сеть бесплатно! Разрешите пользователям CloudCC приглашать коллег, у которых нет лицензии CloudCC для CCChat. Пользователи, которые принимают приглашения, могут видеть только профили, файлы и группы, но не могут видеть детали объектов, пока вы не предоставите им полную лицензию CloudCC.`,
"label.sso.isDelete":`Is Delete`,
"label.unique.identification.number":`Уникальный идентификационный код`,
"label.weixin.no.pending.projects":`Пункты, подлежащие утверждению, отсутствуют`,
"label.projectManagement.Pleaseenteramember":`Пожалуйста, введите участника`,
"label.salescloud.salesdashboard.visit":`Посетите сайт`,
"label.weixin.user.registered":`Регистрация пользователя`,
"message.loginhistory.downloadcsv":`Загрузите историю входа в систему за последние шесть месяцев. (CSV)`,
"label.icon.37":`Позиционирование`,
"template.chart.schdyqyx":`Ожидаемая реакция от кампаний`,
"label.tel.ten":`Вы можете ввести до 10 телефонных номеров для уведомления посредством SMS, при этом каждый телефонный номер отделяется знаком ";".`,
"label.data.exp.objdata":`Вы экспортируете данные для этого объекта в соответствии со следующими условиями`,
"label.loginservice.after.use":`после этого ты можешь использовать.`,
"pagecreator_systemstyle_message_delete":`Вы удаляете текущий выбранный стиль?`,
"label.globalselect.deleteerror":`Так как это значение в списке опций используется для следующих полей, оно не может быть временно удалено.`,
"label.department.add":`Добавить новый отдел`,
"label.attendance.dingwei":`Местоположение`,
"label.workflow.editrule":`Редактировать Правило`,
"lable.product.pecm":`Пожалуйста, введите правильную сумму.`,
"label.icon.182":`Краткий кейс`,
"label.help.release.notes":`Информация о выпуске CloudCC R7.1`,
"UG.product.05":`импортная продукция`,
"label.email2":`Email`,
"label.weekrepeat":`Недельный повтор`,
"label.mr.descreption.oneGroupReData2":`набор(ы)`,
"chatter.at.d":`Вклад`,
"label.mr.descreption.oneGroupReData1":`Поиск дубликатов и процесс слияния: итого`,
"label.weixin.mobile.fly.android":`Поделиться на Android Mobile App`,
"label.brackets.right":`)Близкая скобка`,
"message.recordtype.applytoAllProfiles":`Применить макет страницы ко всем профилям`,
"label.customcomponent.page.index.tip":`Подобно тому, как функция работает на языке программирования, пользовательские компоненты позволяют инкапсулировать общие шаблоны дизайна, а затем повторно использовать их на одной или нескольких пользовательских страницах.`,
"lable.List.properties":`Атрибуты списка`,
"label.fieldinfo":`Сведения на местах`,
"label.ems.error.fail":`Загрузка не удалась, попробуйте еще раз или свяжитесь с системным администратором.`,
"label_emailsync_form_email":`Email`,
"lable.currencyManage.button.manageRate":`Управление валютами`,
"component_salesperformance_label_100finish":`Завершено`,
"label.knowledgebase.data.assignment.failed":`{a} data assign failed`,
"label.custom.buttonandlink.remark":`Выберите поведение: Отображение в существующем окне/Отображение в новом окне (Существующее окно:дисплей в текущем окне. Новое окно: отображение в новом окне)`,
"label.list.userinterface.watermark.setup":`Установка водяных знаков`,
"component_timeline_label_7daysahead":`7 дней до`,
"label.sendemail.chat.replyinchat":`Комментарии по почте:`,
"component.salesperformance.label.title":`Показатели продаж`,
"label.data.downpage.e.list.desc2":`После завершения процесса вы получите электронное письмо с напоминанием об успешном экспорте данных.`,
"vue_label_campaign_fromclosedopprotunities":`Из {sjcb} закрытых бизнес-возможностей`,
"label.umeng.activity.taskviewed":`Просмотр задания, которое вы назначили на #name`,
"vue_label_salesadvance_retentions":`Сохраняемый номер`,
"label.fieldtag":`Полевая этикетка`,
"label.quickbooks.button.searchinquickbooks":`Поиск в QuickBooks`,
"label.quickbooks.viewlist.action":`ДЕЙСТВИЕ`,
"label.weixin.sysapp":`Системные приложения`,
"label.approval.examine.level":`Утверждать и отклонять по уровню пользователя, максимальный уровень пользователя является`,
"label.appupload.upload.error":`Это Приложение не может быть установлено. Пожалуйста, отмените установку или измените API в вашей системе и установите его снова.`,
"label.emailtemplate":`Шаблон электронной почты`,
"front-email-payment-Invoice-amount":`Сумма счетафактуры`,
"label.viewselectedproducts":`Посмотреть избранные продукты`,
"label.tianyancha.businessverify.openfirst":`Пожалуйста, включите проверку бизнес-данных`,
"lable.SalesCommitmentKanBan.returnAList":`Назад к списку: Коллеги`,
"label.knowledgebase.nopublished.draft.translations":`Отсутствие опубликованной или черновой версии перевода`,
"vue_label_calendar_day_view":`Просмотр календаря на день`,
"label.globalselect.remark":`Набор значений глобального списка опций позволяет разделить значения между объектами.`,
"label.orderby":`Сортировать по`,
"lable.weixin.LastaDaysFinished":`Завершено за последние 7 дней`,
"lable.currencyManage.Enabledadvcurrency.discripation":`Позволяет управлять датированными курсами обмена, которые отображают курс обмена валюты к определенному диапазону дат. Датированные курсы обмена применяются к валютным полям о возможностях, альтернативных продуктах и отчетам, связанным с этими двумя объектами. Они не применяются к полям на других объектах или к другим типам отчетов. Например, курс на 1 января составлял 1 USD - 6.68 CNY, а на 6 февраля он изменился на 1 USD - 6.70 CNY. Ваши возможности, которые закрылись в период с 1 января по 6 февраля, используют первый обменный курс (1 = 1,68), в то время как возможности, которые закрылись после 6 февраля, используют второй обменный курс (1 = 6,70).`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.one":`Один`,
"label.leadtoobjectfield":`Карта Пользовательские свинцовые поля`,
"label.dashboardSetup.shujuyuan":`Источники данных`,
"label.tabpage.userz":`Пользователи`,
"label.sms.companyname.dsf":`Настройка SMS-1`,
"label.step2.total3":`Шаг 2 из 3`,
"front-gantt-module-Drag-dropt- reorder-tasks":`Перетаскивайте, чтобы изменить порядок задач!`,
"label.dashboard.snapshot.no.enabled":`Функция моментального снимка приборной панели не включена`,
"label.dashboard.unit3":`Единица измерения: целое число`,
"label.forecast.shrepage.desc2":`Пользователи, роли и территории с общим доступом.`,
"label.commonobjects.new":`New {eventName}`,
"label.view.nameonlyone":`Просмотр уникального имени`,
"label.assignment.setup.newentries.user":`Пользователи`,
"label.otheremails":`Дополнительные электронные письма`,
"component_sendmail_button_send":`Отправить`,
"vue_label_accountpool":`Пул аккаунтов`,
"label.h5.approval.actortime":`Дата отправления`,
"message.approval.cannotsubmit":`Невозможно отправить на утверждение`,
"vue_label_pool_createdbyme":`Созданный мной`,
"label.change.event":`Вид на события`,
"vue_label_homepage_personalpage":`Личный кабинет`,
"label.new.collect.target":`Новый совокупный показатель`,
"label.ServiceCloud.zichanxuhao":`Активы №.`,
"label.product.userl":`Колонки для всех пользователей`,
"label.syslog":`Системный журнал`,
"label.reportcreatestatus":`Статус формирования отчета`,
"label.datamanage.account.novalue":`Примечание: Поле имени счета является нулевым, записи по счету не будут импортированы.`,
"label.letter.body":`Текст приглашения`,
"label.select.please":`Пожалуйста, выберите`,
"label.escalation.setup.entrydetail.description":`1.Нажмите Изменить, чтобы изменить записи правил. <br/>2.Нажмите кнопку Создать, чтобы добавить операцию обновления.`,
"label.component.salesDashboard.nodata":`Добавьте бизнес-возможность, которую вы используете, а затем вернитесь сюда, чтобы увидеть производительность.`,
"vue_label_helpcenter_account":`В подробной информации, нажмите кнопку дерево диаграммы рядом с клиентом, чтобы просмотреть диаграмму иерархии клиентов, понять отношения между детьми и родителями связанных с клиентами, и просмотреть некоторые поля информации о каждом клиенте.<br>>В случае смены владельца клиента, вы можете выбрать, чтобы изменить владельца связанных с клиентом бизнес-возможностей, случаев и другой информации в то же время.`,
"front-kefu-moudle-v1-awshjzx-intelligent":`AWS Интеллектуальный центр обслуживания вызовов`,
"label.productby":`Созданный`,
"label.operation.date":`Дата эксплуатации`,
"label.name.donot.delete":`Имя не может быть удалено`,
"label.validate.function.funcFormat.DATETIMEVALUE":`ДАТИМЕВАЛЬНОСТЬ (дата)`,
"label.escalation.setup.entrydetail.howescalationtime":`Как устанавливается время эскалации`,
"label.view.step2":`Шаг 2 Укажите критерии фильтра`,
"lable.outlook.edit.notnull":`Вы должны ввести имя поля.`,
"label.knowledgebase.createnewbrowser":`Новая вкладка браузера`,
"label.partner.all.name":`Облачное имя партнёра`,
"chatter.group.groupSetUp":`Групповые настройки`,
"label.reportlist.findfolder":`Найти папку...`,
"component.setup.tabs.label.title":`табличная страничка`,
"label.passwordPolicy.setup.pswComplexReq":`Требование к сложности пароля`,
"label.emaildocument":`Отправить документ в виде электронного письма.`,
"message.selectgsummaryconditon":`пожалуйста, выберите сводные критерии`,
"component_todaytask_label_notask":`Сегодня нет задачи по истечению срока годности, выпей кофе.`,
"label.user.organization.notexists":`Организация не найдена.`,
"label.isEnableVisualpage.new.leftlist":`Доступные пользовательские страницы`,
"label.mobile.phone.write.week.report":`Новые еженедельные рабочие заметки`,
"label.emailmerge.edittemplate.edit":`Редактирование шаблона почтового объединения`,
"template.dashboard.folder.sales.manage":`Управление продажами`,
"label.confirm.order.productsToassets":`Вы уверены, что хотите конвертировать заказ товара в актив?`,
"label.service.dispatchingUnits.leftRight.total":`В настоящее время {{ left }}-{{ right }} записей, всего {{ totalCount }} записей.`,
"label.import.step1.chooseidorother":`2、Вы можете выбрать ID или имя для сопоставления с записью и заполнить поле поиска. Если вам нужен соответствующий ID записи и другая информация, вы можете создать отчет и установить имя записи и ID записи в качестве групповых столбцов, а затем экспортировать отчет.`,
"label_tabpage_completez":`Отметьте выбранное состояние для завершения`,
"chatter.c.adr":`Адрес`,
"label.account.d":`На этой странице можно определить и отредактировать пользовательский фискальный квартал. Дата пользовательского финансового квартала будет сгенерирована на основе вариантов, которые вы сделаете ниже.`,
"label.tag.more50":`Создать до 50 тегов`,
"setup.layout.label.areashow":`Вкл. заголовок раздела дисплея`,
"label.partnerCloud.basicSetting.rebate":`Активировать возврат`,
"label.tabpage.greaterequalz":`Больше или равно`,
"vue.please.select.the.aggregate.basis":`Пожалуйста, выберите параметры SUM BY.`,
"label.form":`Формы`,
"label.chatter.colleagues.list.beizhu":`Включить`,
"label.priority":`Приоритет`,
"vue_label_checkduplicate_set_repeat_rules":`Установить правила повторения`,
"label.share_form":`Поделитесь своей формой`,
"label_relation_shareholder":`Акционеры и дочерние компании не могут быть одним и тем же.`,
"label.project.hit.sixteen":`Напоминание об истечении срока действия выпуска`,
"label.service.miniProgram.imageFormat":`Для загрузки поддерживаются только изображения PNG, JPG и JPEG.`,
"label.summary.mode":`Метод суммирования`,
"vue_label_beforeverification":``,
"label.data.newtemplate.desc":`Сохраняйте поля и критерии, выбранные пользователями в качестве шаблона, и пользователи могут экспортировать данные непосредственно по шаблону экспорта данных.`,
"lable.evaluation.badreview":`Плохой`,
"label.total.tabs":`{0} Всего {1}`,
"label.emailmerge.mergeFolder.foldertemplate":`Шаблоны в этой папке`,
"vue_label_normal_notice_repeated":`Пожалуйста, не добавляйте несколько раз`,
"label.icon.140":`Данные`,
"label.fromonetoanother":`от одного пользователя к другому`,
"label.user.list":`Все пользователи`,
"label.file.prevent.share.operate":`Не позволять другим делиться и не делиться`,
"label.app.detail":`Приложение Подробнее`,
"label.h5.similar.opportunity.correlation":`Относительность`,
"label_emailtocloudcc_filed_username":`Адрес электронной почты`,
"vue_labe_account_shareholdingratio":`Коэффициент владения акциями`,
"label.data.dataexpalltype.all_desc3":`3. Exported Успешные данные сгенерируют сжатый файл, который пользователи могут загрузить со страницы списка успешных экспортов в соответствии с информацией в почте.`,
"label.callcenter.please.select .seatID":`Пожалуйста, выберите номер места`,
"label.remark.length.cannot.than":`Описание не может включать более 255 харекеров.`,
"label.batchtransfer.dateandtimetype.tip":`Для полей даты/времени введите значение в следующем формате:`,
"label.component.helper.businesschange.0UntreatActivity":`Возможности без необработанной деятельности`,
"front-project-module-v1-plase-input-start-time":`Пожалуйста, введите дату начала`,
"label.event.moveup.6hour":`6 часов вперёд`,
"label.data.exp.tempexp":`Экспорт по шаблону`,
"label.schedulejob.setup.schedule.afternoon":`PM`,
"label.ems.format":`Формат`,
"label.objectHasBeenDeleted":`Удаленные объекты`,
"label.ServiceCloud.chaxunchenggong":`Успешный поиск`,
"label.campaign.channel.input.notice.owner":`Уведомить владельца`,
"label.bajisitan.time":`пакистанское время`,
"label.warnMes":`Ссылка на объект, удалить не удалось.`,
"lable.Up.to.ten.fields":`Выберите объект и добавьте на график до 10 полей. Нажмите на стрелки вверх и вниз, чтобы отсортировать порядок полей.`,
"label.approverule":`Правила утверждения`,
"message.error.specific":`Возврат конкретного сообщения об ошибке`,
"front-template-V1-saveUse":`Сохранение и предварительный просмотр`,
"label.uploadfile.success":`успешно выгруженный`,
"label.tabname.donot.database.key":`Имя вкладки не может быть ключевым словом базы данных`,
"message.recordtype.selectlayout.select":`-Выберите майорат страницы...`,
"front-detail-module-v1-list-cardview":`Просмотр списка/карты`,
"label.product.maintenance":`Техническое обслуживание`,
"vue_label_helpcenter_approve":`1. Позиции, подлежащие утверждению<br> Перечислите все позиции, которые нуждаются в вашем одобрении. Вы можете искать записи для утверждения по дате начала, дате окончания, подателю заявки, типу записи и связанным с ними пунктам записи утверждения.<br>Обработайте единую запись: Нажмите левую кнопку каждой записи.<br>А. Утверждение<br>Шаг 1: Нажмите кнопку "Утвердить", чтобы открыть страницу запроса на утверждение<br>Шаг 2: Нажмите кнопку "Утвердить" или "Отказать", чтобы завершить операцию утверждения.<br> Если на следующем этапе утверждения в конфигурации процесса утверждения необходимо вручную выбрать утверждающее лицо, то после "Утверждения"<br>Шаг 3: Выберите следующего утверждающее лицо, чтобы завершить операцию утверждения.<br> Если необходимо выбрать возвращаемый этап после отклонения утверждения в конфигурации процесса утверждения, перейдите к шагу 4 после "Отклонить"<br> Шаг 4: Выбор возвращаемого этапа утверждения для завершения операции по завершению утверждения.<br> B. Переадресация<br> Шаг 1: Нажмите "Переадресация"<br> Шаг 2: Найдите переадресатора<br> Шаг 3: Нажмите "Переадресация запроса на утверждение" для завершения операции переназначения уполномоченных.<br>Заметка: Если вы являетесь заместителем уполномоченного по записям, вы не можете выполнить операцию переназначения.<br> Пакетная обработка нескольких записей: После выбора нескольких записей, подлежащих утверждению, нажмите кнопку операции над списком.<br> C. Утверждение<br>Шаг 1: Выберите несколько записей, подлежащих утверждению<br>Шаг 2: Нажмите кнопку "Утвердить"<br>Шаг 3: Нажмите кнопку "Утвердить" или "Отклонить", чтобы завершить операцию утверждения.<br> Если вам необходимо выбрать шаг возврата после отклонения утверждения в конфигурации процесса утверждения, перейдите к шагу 4 после "Отклонить".<br> Шаг 4: Выберите шаг возврата для завершения операции по утверждению.<br> D. Перераспределение<br> Шаг 1: Выберите несколько записей, подлежащих утверждению<br> Шаг 2: Нажмите "Перераспределить"<br> Шаг 3: Найти переадресаторов<br> Шаг 4: Нажмите "Перераспределить запрос на утверждение" для завершения операции по переадресации переадресации переадресаторов.<br> 2. Представленные проекты<br> Перечисляет все утвержденные проекты, которые вы представили. Вы можете быстро найти запись, которую хотите просмотреть, по дате начала, дате окончания, отправителю, типу записи, связанным позициям, а также по статусу утверждения записи.<br> 3. Мои утвержденные проекты<br> Перечисляет все утвержденные проекты, которые вы одобрили. Вы можете быстро найти запись, которую хотите просмотреть, по дате начала, дате окончания, отправителю, типу записи, связанным позициям, а также по статусу утверждения записи.<br> 4. Отклонить записи <br> Перечисляет все утвержденные записи, которые вы отклонили. Вы можете быстро найти запись, которую хотите просмотреть, по дате начала, дате окончания, отправителю, типу записи, связанным позициям, а также по статусу утверждения записи.`,
"label.knowledgebase.knowledge.article":`Статья знаний`,
"march":`март`,
"label.accraditation":`Утвердить`,
"vue_label_pool_cantreach":`Не может связаться с клиентом`,
"label.service.appointmentList.startOf.maturityPeriod":`Начало периода погашения`,
"message.huanxin.closed":`Неактивная функция чата`,
"label.implementation.time.operation":`Выполнять запланированные задания`,
"label.setting.intergrationlist.permissions":`РАЗРЕШЕНИЯ НА ИНТЕГРАЦИЮ`,
"label.translation.norecord":`Нет Записей`,
"label.lack.expression":`Выражение потеряно`,
"setup.layout.message.relatedlistfield":`Выберите поля для отображения в соответствующем списке.`,
"label.group.file":`Групповые файлы`,
"message.error.id.null":`Нет такой идентификационной информации`,
"label.a_b_least":`Каждая запись типа "А" должна иметь, по крайней мере, одну связанную запись типа "В".`,
"label.addattachment.step3":`Шаг 4 Нажмите "Завершить", чтобы вернуться на предыдущую страницу.`,
"label.data.exportsf":`Экспортируемые файлы`,
"label.callcenter.call.out":`Вызов`,
"front-electronic-export-exportIntro":`Выбранные данные будут экспортированы в выбранный вами список Mailchimp`,
"label.custombutton.deletedata.notnull":`Удаленные данные не могут быть пустыми.`,
"UG.homepage.002":`Управляйте своими ключами, зацепками, воронками торговых операций и информацией об учетной записи с помощью интегрированных бизнес-инструментов`,
"label.globaloperation":`Глобальная операция`,
"label.icon.58":`Рабочий`,
"vue_label_salesadvance_lostrate":`Темпы оттока`,
"chatter.from":`с`,
"front-epwechat-module-v1-account-binding":`Привязка к счету`,
"label.list.userinterface.old.page.setup":`Старая страница`,
"label.forecast.settings.periods":`&nbsp;цикл(ы)`,
"label.file.share.email.content":`#sharedBy поделился с вами файлом на #orgname.`,
"label.knowledge.category.hint.five":`Настройка категории данных`,
"setup.layout.label.selectedfield":`Выберите поля`,
"label_business_income":`Доход от расширения возможностей для бизнеса`,
"vue_label_display_options_field":`Показать поля пиклиста`,
"label.emailtocloudcc.set":`Установить информацию о почтовом ящике`,
"label.knowledge.setting.data.five":`Удалить категорию: {lbmc}`,
"front-epwechat-module-v1-bound-enterprise":`Облигационное предприятие`,
"label.ccpeak.delete.recycle":`Запись будет удалена в мусорный бак.`,
"label.leadconvers.tip":`Свинция не может быть конвертирована в учетные записи, контакты, возможности и последующие задачи. Вы должны конвертировать свинец только после того, как вы определили его как квалифицированный.`,
"label.rsa.key.invalid":`Открытый ключ недействителен, пожалуйста, войдите снова.`,
"label.mobile.bind.success":`Успешное связывание`,
"label.emailtocloudcc.filed.servertype":`почтовый сервер`,
"label.user.new":`Новый пользователь`,
"label.setup.mobile.homepageshortcuts.remark":`Организации могут настроить быстрые функции на уровне организации, отображаемые на верхней части домашней страницы в соответствии с бизнес-сценарием.`,
"label_emailtocloudcc_select2":`Выберите тип дисплея`,
"page.send.email":`Отправить электронное сообщение`,
"label.service.newBuildDialog.field.display":`Поля для отображения`,
"vue_label_homepage_card_impending":`Предстоящие возможности`,
"label.message.contactispartner.delete":`Пользователь-партнер связан с этим контактом, не может быть удален.`,
"label.attendance.checkout":`Оформить заказ`,
"label.emailmerge.newtemplate.description":`Введите информацию о вашем шаблоне почтового объединения. Обратите внимание, что описание отображается только в CloudCC.com, а не в Word.`,
"laebe.data.exp.success":`После успешного экспорта вы получите напоминание по электронной почте. Экспортированные данные будут храниться на сервере в течение 48 часов. Пожалуйста, скачайте со страницы списка экспортированных данных как можно скорее.`,
"lable.Maximum.number":`Для имени шаблона допускается не более 50 символов.`,
"label.projectManagement.drag.and.drop.existing.tasks":`Перетащите существующую задачу в текущую категорию`,
"label.forecast.tree.desc":`Иерархия прогнозов определяет, как прогнозы развертываются внутри организации, и кто может их просматривать и корректировать. Она автоматически генерируется на основе иерархии ролей, но вам может понадобиться добавить или отредактировать менеджеров, представителей отдела продаж или других пользователей.`,
"vue_label_chatter_upload_file_type":`Выбранный тип загружаемого сообщения`,
"front-lightning-module-v1-dashborad-analysis-dimension":`Размерность анализа`,
"vue_label_homepage_custom_homepage":`Пользовательская домашняя страница`,
"label.icon.39":`Позиционирование`,
"label.appointmentpage.wizard.notif1":`Пожалуйста, сначала выберите время!`,
"vue_label_report_filterby":`Фильтр {screenCondition}`,
"label.argentina.time":`аргентинское время`,
"label.role.assign.notremove":`Невозможно удалить пользователей из <b>Выбранные пользователи</b> в "Все неназначенные и активные пользователи" или "Все неназначенные пользователи".`,
"label.sharerule.detailsetshare":`Совместное использование правил Подробности`,
"label.file.publicview.error1":`Файл удаляется или общедоступная ссылка не включается`,
"label.data.downpage.e_title.num4":`4. Файлы экспорта имеют два формата: CSV формат и формат сжатия. Формат сжатия разделен на два типа: один - для автоматической генерации пароля к сжатому файлу, другой - для ручного ввода пароля к сжатому файлу.`,
"label.knowledge.case.article":`Статья по делу`,
"label.data.newtemplate.e.conditions":`Условия экспорта`,
"front-object-change-owner":`Владелец записи связанных списков, которая соответствует этому владельцу счета, также будет изменен на нового владельца`,
"label.newdashboardpage.edittitle":`Редактировать название`,
"label.datamove.end.query.no.record":`Конец запроса, никаких квалифицированных записей.`,
"lable.SalesCommitmentKanBan.receiptsTarget":`Поступления Цель`,
"label.orderagain":`Заказать`,
"vue_report_dashboard_transfer":`Переместить папку`,
"label.view.sortview.default":`Вид по умолчанию`,
"label.brasilia.time":`летнее время в Бразилиа`,
"label.industrialandcommercialverification.instructions":`Включите проверку промышленных и коммерческих данных, чтобы помочь пользователю ввести правильную информацию о регистрации клиента в промышленной и коммерческой сфере. Обратите внимание, что эта функция поддерживает только запрос информации о регистрации в промышленной и коммерческой сфере в материковом Китае.`,
"label.chatter":`Облачный пост`,
"label.sso.goBackToList":`Назад на List: key Управление`,
"label.mobile.side.tab.state":`Запустить пользовательский ползунок`,
"label.weixin.addbus":`Добавить транспортные средства`,
"label.dropbox.description":`Соедините вашу учетную запись DropBox, чтобы использовать ее в CloudCC.`,
"label.service.newBuildDialog.available.tousers":`Установите этот фильтр доступным для всех пользователей.`,
"label.knowledge.language.thai":`Тайский`,
"label.passwordPolicy.setup.foreverlock":`Навсегда (должен быть сброшен администратором)`,
"label.bmap.unreported.location":`Вы не поделились информацией о своем местоположении. Пожалуйста, зарегистрируйтесь в официальном аккаунте WeChat .`,
"label.tag.field":`Теги`,
"label.addyourlanguage":`Нажмите кнопку Добавить, чтобы добавить языки, поддерживаемые вашей организацией.`,
"label.chat.topic.my.use":`Темы, которые я использую`,
"UG.contact.06":`Импортные контакты`,
"label.embed_code":`Код встраивания`,
"label.campaign.channel.input.chenben":`3. Фактическая стоимость:`,
"label.quickbooks.estimates":`Оценки`,
"label.report.items.i.created":`Отчеты, которые я создал`,
"label.forecast.edit.fwqd":`Старт диапазона`,
"label.validate.function.funcExplain.DATEVALUE":`Создать дату из своего времени`,
"vue_label_helpcenter_calendar1.1":`События - это мощный инструмент, гарантирующий, что Вы всегда будете понимать отношения с клиентами и заключать сделки. Вы можете ассоциировать мероприятия с возможностями, ведущими позициями, клиентами и контактами. В просмотре календаря в основном отображаются записи о событиях.<br> 1. Просмотр календаря и списка<br>Просмотр календаря<br> Нажмите на вкладку календаря в меню навигации, чтобы перейти на страницу календаря. <br>Просмотр календаря<br>Классификация просмотров календаря: Просмотр календаря разделен на просмотр месяца, недели, дня и доступности. Записанные данные различных временных диапазонов могут быть отображены отдельно с помощью различных стилей сетки. Представление наличия отображает ежедневные данные записи с каждым календарем в качестве размера, включая мой календарь и другие календари. Нажмите значок "Календарь" в правом верхнем углу страницы календаря, чтобы переключить просмотры. <br> Что можно просматривать в режиме просмотра календаря: Календарь включает в себя мой календарь и другие календари. Мой календарь можно просматривать в режиме просмотра календаря, включая все записанные данные календаря событий и календаря объектов. Мы называем эти записи "календарными записями". <br> Вы можете просмотреть все события в просмотре календаря. Календарь, созданный с помощью объекта, будет отображать данные в виде календарных записей в просмотре календаря в поле даты. На просмотре календаря можно также просматривать другие календари, т.е. можно просматривать любые календарные записи, совместно используемые коллегами, которые были добавлены в представление. <br>`,
"label.tabpage.rowsz":`Удалить строки`,
"label.file.library.managemembers.memberlist":`Действующие члены`,
"label.report.action.addtodashboard4":`Добавить на выходную панель`,
"label.chat.send.voice":`Отправить голосовое сообщение`,
"label.home.dashboard.add":`Добавить в панели управления Homepage`,
"front-dialog-module-v1-copied-requestid":`Идентификатор запроса клонирован`,
"label.customfields.exportdata":`Экспорт данных`,
"label.emailobject.signature":`Подпись`,
"label.hide.source":`Скрыть исходный код`,
"label.icon.71":`Сервис`,
"vue_label_help_whatslightning":`Что такое молния`,
"report.type.label.systemReport":`Системные отчёты`,
"front-kefu-moudle-v1-input-email":`Пожалуйста, введите адрес электронной почты`,
"label.event.moveup.5minutes":`5 минут вперёд`,
"message.error.postsid.null":`Идентификатор сообщения не может быть пустым!`,
"UG.Account.05":`Структурная схема контактов`,
"label_emailtocloudcc_description3":`Подключите учетную запись электронной почты предприятия, например, sales@company.com, info@company.com, support@company.com. Автоматически регистрировать полученные письма в CloudCC в качестве зацепок и записей по делам, чтобы обеспечить своевременное отслеживание писем клиентов.`,
"report.label.searchresult":`Результаты поиска`,
"vue_label_report_detailsonly_desc":`Экспортировать только строки деталей. Используйте эти данные для дополнительных расчетов или для загрузки в другие системы.`,
"label.partnerCloud.partnerAccount.payment":`Сумма платежа:`,
"vue_label_commonobjects_view_select_member":`Выбрать члена`,
"label.emailtocloudcc.step1.lead1":`Электронная почта на имя лидера`,
"label.forecast.settings.current":`текущий период`,
"label.canceluploadfile":`Отменить загрузку`,
"label.manual.shared":`Совместное использование вручную`,
"label.document.uniquename.length.cannot.than":`Длина уникального имени документа не может превышать 255 чередователей.`,
"vue_label_lead_notcreateopportunity":`Не создавать возможности`,
"APPIntegration.Social.twittererror":`Вы должны ввести действующий URL-адрес для twitter.com.`,
"message.duplication.label.errormessage":`сообщение об ошибке`,
"label.file.img":`Изображение`,
"label.tabpage.sum":`Полный счет?`,
"label.permission.systempermission.fenpei":`Назначение разрешения`,
"template.dashboard.folder.data":`Анализ данных`,
"label.sms.account":`аккаунт пользователя`,
"label.product.filter":`Фильтр продуктов`,
"label.file.content":`Содержание текста`,
"label.percent":`Процент`,
"label.single.attachment":`Единый`,
"label.processsetting.failed.enable.process":`Не удалось активировать процесс`,
"label.view.modify":`Редактирование`,
"label.knowledgebase.enter.keywords.filter":`Пожалуйста, введите ключевые слова для фильтрации`,
"label.tabpage.uploadfailez":`Загрузка не прошла, пожалуйста, перезагрузите.`,
"label.please.enter.the.target.model.name":`Пожалуйста, введите название целевой модели.`,
"label.layout.availabletab.related":`соответствующий веб-сайт`,
"label.label":`Ярлык`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.saturday":`суббота`,
"label.addattachment.unit":`байт`,
"vue_label_commonobjects_view_selected":`Выбрана запись(и) {checkedLength}`,
"label.view.sortview.printble":`Возможность печати`,
"label.umeng.insert.approval.approvaling":`#заявитель представляет #obj #objname на ваше одобрение`,
"label.forecast.customforecast.tztotal":`Скорректированная общая сумма`,
"label.ccchat.failtoset":`ошибка установки чатов`,
"label.ccchat.message.new.error2":`Пользователь CCChat`,
"label.validate.function.category.Advanced":`Расширенный сайт`,
"label.projectManagement.team.members":`Члены команды`,
"vue_label_report_clickcrosstofliter":`Щелкните перекрестки в таблице выше, чтобы отфильтровать детали.`,
"lable.opppdt.selPdt.leasttwenty":`Вы можете выбрать до 25 строк`,
"label.campaign.channel.download":`Скачать HD QR-код`,
"component_event_label_person":`Назначенное лицо`,
"vue_label_homepage_new_homepage":`Новая домашняя страница`,
"label.version.sum.vlidaterule":`Правила проверки`,
"vue_label_chat_click_for_details":`Нажмите для получения более подробной информации`,
"label.fold":`Сохранить`,
"label.readonly":`Только для чтения`,
"label.h5.similar.opportunity.result":`Аналогичная возможность`,
"label.yourimportsuc":`Ваш запрос на импорт был обработан, пожалуйста, просмотрите вашу электронную почту.`,
"label.report.line.yixuan":`Выбранная колонка отчёта`,
"setup_layout_label_areaname":`Наименование секции`,
"label.forecast.edit.title":`Цель`,
"label.chatter.allweather":`Всепогодный`,
"label.service.ganttBaiduMap.scheduled.endtime":`Планируемая дата окончания`,
"lable.create.new.list":`Новый список`,
"label.emailobject.groupemail.msg3":`{0}почта`,
"lable.opppdt.selPdt.description":`Введите ключевое слово и критерии фильтрации, а затем нажмите Поиск, чтобы начать поиск.`,
"label.file.versionerror1":`Вы можете нажать на ссылку ниже, чтобы перейти непосредственно на новую закладку файла интерфейса, или вы можете использовать функцию закладки файла после ручного переключения на новый интерфейс`,
"label.under.approve.record":`Дожидается`,
"front-epwechat-module-v1-open":`Включить`,
"label.projectManagement.delete.task":`Вся связанная информация этой задачи также будет удалена, если вы удалите эту задачу, и данные не смогут быть восстановлены. Вы уверены, что хотите подтвердить удаление?`,
"label.reportforms":`Доклады`,
"label.tabpage.onlymevisible":`Только я`,
"label.customer.tab.please.name":`Пожалуйста, введите имя вкладки`,
"label_emailsync_form_stutas":`Статус`,
"message.recordtype.nolist":`Типы записей не определены.`,
"label.version.forecasting.sales":`Прогнозы`,
"chatter.sel.mostfield":`Вы можете выбрать до`,
"label.data.derived":`Экспорт данных`,
"label.component.helper.businesschange.expiredtask":`Возможности с просроченными заданиями`,
"label.cycle":`Цикл`,
"lable.product.standp":`стандартная цена`,
"label.sendemail.batchapproval":`Операция утверждения партии`,
"message.organization.not.open.mffverification":`Организация не дает возможности пройти вторичную сертификацию.`,
"label.icon.131":`Зонт`,
"UG.activity.08":`Зарезервировать расписание`,
"label_partner_workspace_member_choicepermission":`Выберите набор разрешений`,
"label.reportTypeCategory":`Источник данных отчёта`,
"label.exporttwotype":`Вы можете экспортировать два вида текста`,
"message.oppdt.selectpricebook":`Пожалуйста, выберите ценник`,
"vue_label_dashboard_generatefromlistview":`Сгенерировать из просмотра списка`,
"label.quote.title":`Название`,
"label.tianyancha.businessverify.cancel.sure":`После отключения верификации бизнес-данных, при создании/редактировании клиента невозможно заново заполнить регистрационную информацию о бизнесе. подтверждается ли это?`,
"label.save":`Сохранить`,
"label.mobile.quickcreate.default.appstore":`Приложения`,
"label.partnerCloud.orderingPlatform.configure":`{a} продукты не настроены, пожалуйста, сохраните после настройки.`,
"front-epwechat-module-v1-unbound-role":`Несвязанные роли`,
"label.partnerCloud.financeSetting.enterAlipay":`Пожалуйста, введите корпоративный acocunt от Alipay.`,
"label.validate.function.funcExplain.TODAY":`Вернуться к текущей дате`,
"label.visualpage.parameter.values":`Отображение значений параметров непосредственно на странице:`,
"label.version.task.and.activity":`Подбор задач и видов деятельности`,
"label.audit.history":`История утверждения`,
"setup.object.field.dependency.label.addtolist":`Добавить выбранные значения`,
"vue_label_report_exportquantity":`Количество экспорта:`,
"label_tabpage_havez":`Прилагается`,
"label.partnerCloud.partnerAccount.amountOfRebate":`Доступная сумма возврата`,
"label.createralias":`Созданный псевдонимом`,
"label.created_followup":`Создание последующей электронной почты`,
"label_chatter_mygroups":`Мои группы`,
"label.chat.topic.no.display":`Нет отображаемых тем`,
"vue_label_calendar_month_view":`Просмотр календарного месяца`,
"label.service.gantt.resources.assigned.work":`Ресурс с назначенной работой`,
"UG_activity_07":`Создать задачу`,
"label.quote.xsjg":`Цена продажи`,
"message.toomanyrows":`Слишком много записей для запроса.`,
"label.importsourcestep1":`Шаг 1 Подготовка переведенного файла с раздельными вкладками`,
"vue_label_normal_appointment_sf":`Назначение`,
"lable.list.queue.message":`Очередь не может быть удалена, так как в ней находятся записи объектов.`,
"label.service.major.event.desc":`Веха представляет собой зависящие от времени шаги в процессе поддержки. Его можно добавить в начало процесса получения прав. Затем вы можете применить процесс к учетным записям и создать на их основе дело или рабочий заказ.`,
"label.ems.hostorport.null":`И сервер, и порт не могут быть пустыми.`,
"chatter.group.private":`Частный`,
"label.icon.192":`Мыльный батончик`,
"vue_label_systemSettings_list":`Связанный список Настройка дисплея`,
"label.activity.saveobj.notnull":`Сохраненный объект не может быть пустым.`,
"vue_label_chatter_current_no_people_approval":`В настоящее время нет людей, нуждающихся в одобрении`,
"label.tianyancha.reglocation":`Зарегистрированный адрес`,
"UG_ST_005":`Я понял, не показывай мне эту страницу снова и в следующий раз войди прямо в систему.`,
"label.vlidaterule.example.truetodisplay":`Это сообщение появится, если формула условия ошибки верна.`,
"label.icon.99":`Примечания`,
"label.whenselectmoreapprover":`Когда Вы выбираете более одного исполнителя`,
"label.forecast.customforecast.directorbest":`Лучший случай прямого подчинения`,
"label.customsetting.view.introduce":`Предоставьте значения для созданных вами полей. Эти данные кэшируются вместе с приложением.`,
"label.there.are.no.unenabled.rules":`Все правила включены.`,
"front-project-module-v1-plase-selectemplat":`Пожалуйста, выберите шаблон проекта`,
"label.campaignmember.selectmember.from":`С`,
"setup_layout_button_quicksave":`Быстрая экономия`,
"label.setup.service.report":`Настройка шаблона отчета об обслуживании`,
"label.visualpage.direction.for.use":`Инструкции по хранению страниц [версия 2.0]`,
"message.modify":`Вы уверены, что хотите изменить?`,
"label.sms.inside":`Интерьер`,
"label.category.3":`Образование`,
"label.login.mfadevice.verification.title":`Проверка устройств MFA`,
"UG_Forcast_08":`Предыдущий шаг`,
"label.projectManagement.unable.to.complete":`Невозможно завершить`,
"front-kefu-moudle-all-missphone":`Все пропущенные звонки`,
"font-evaluate-module-v1-emergency":`Предупреждение`,
"label.sso.saml.sp.idsource.attr":`Идентичность находится в элементе атрибута`,
"chatter.not.meg":`Не могу отправить пустое сообщение.`,
"label.chatter.startDate":`Стартовые данные`,
"label.emailobject.track.times":`Тотал открывается: {0}`,
"label.customsetting.fieldhasbeendeleted":`Удаленные поля`,
"label.knowledge.setting.hint.thirteen":`Добавить категорию других данных`,
"message.duplication.label.newfiltertitle":`Новое дубликатное правило`,
"setup_object_field_dependency_label_selectedfieldvalue":`Доступные значения полей`,
"vue_label_calendar_who_currently_has_access":`Кто в настоящее время имеет доступ`,
"message.passwordPolicy.validate.minlengthe":`символ(ы)`,
"label.emailsync.status.disconnect":`Отменить отзыв Концерт`,
"label.applt.down.one":`Скачать одним нажатием`,
"label.manageAll.sel.one2":`Пункты, которые я представил`,
"message.error.SQLTimeout":`Из-за неправильной конфигурации системы или неоптимизированных пользовательских SQL-запросов, система превысила допустимые возможности запроса, что вызвало сбой запроса. Пожалуйста, обратитесь к системному администратору для настройки системы.`,
"label.global.search.obj.setup":`Глобальные параметры объектов с возможностью поиска`,
"vue_label_commonobjects_view_chat":`Команда`,
"vue_label_systemSettings_startSet":`Начальная установка`,
"label.quickbooks.viewlist.balance":`БАЛАНС`,
"message.error.fieldid.null":`Филдид не может быть пустым! Идентификатор содержания файла`,
"label.replaceallnullvalue":`Заменить все пустые значения`,
"label.georgia.time":`Джорджия Тайм`,
"label.hastransfer":`Содержит Переведено`,
"label.partner.all.description":`Описание`,
"font-evaluate-module-v1-following-peopple":`Когда вы получили отрицательный отзыв, уведомите об этом следующих пользователей`,
"label_business_count":`Объем возможностей для бизнеса`,
"vue_label_ccchat_closedetail":`Закрыть`,
"label.partner.all.disable":`Отключить`,
"label.view.relationship":`Связи между объектами`,
"label.noless":`>=Требовательнее или равнее`,
"label.sendsms.batch.step2":`Шаг 2 Выберите шаблон или настройте SMS-контент`,
"label.stdashbord.xsld.business.jieduan":`Название сцены`,
"label.appupload.component.type.trigger":`Триггер`,
"label.knowledge.setting.data.two":`Имя категории является обязательным.`,
"label.color.display.of.completion.rate":`Цветное отображение скорости выполнения`,
"label.loginhis.default":`Перечислить последние 200 истории по умолчанию`,
"vue_label_pricebook_book":`Текущий прайс-лист`,
"label.knowledgebase.data.deletion.failed":`{a} удаление данных не удалось`,
"label_partner_workspace_member_permission":`Набор доступных разрешений`,
"label.list.userinterface.approval.setup":`Утверждение Установка`,
"label.weixin.binding.effect":`Привязка недействительна, пожалуйста, войдите еще раз.`,
"label.appupload.install.newapicannotnull":`Новое имя api не может быть пустым`,
"chatter.feed.menutype.feed.company":`Вся компания`,
"label.assignment.setup.detail.email":`Email`,
"label_tabpage_selectcontentz":`Пожалуйста, выберите содержание`,
"template.report.converted.leads.campaign":`Конвертированные лиды из кампаний`,
"label.forecast.season":`Этот квартал`,
"label.post":`Пост`,
"label.knowledge.setting.hint.fifteen":`Фундамент заложен. Теперь вы и ваша команда можете писать и организовывать свои статьи о знаниях.`,
"front-kefu-moudle-v1-Seats-name":`Прозвище агента`,
"label.weixin.leadname":`Имя свинца`,
"label.account.quarter":`Кварталы`,
"label.detail.field":`Поля просмотра`,
"label.icon.189":`Косметика`,
"label.appointment.disable.reappointment":`Деактивировать Перенести на другой день`,
"label.appointmentconfirmpage.wizard.subtitle1":`Название мероприятия`,
"label.campaign.channel.step6.remark3":`Система сгенерирует уникальный QR-код для приглашения на работу, который может быть использован сотрудниками, а выполненные приглашения могут быть засчитаны для их личных выступлений.`,
"System.AddressFieldType.Post":`Почтовый индекс`,
"label_partner_new_step2":`Шаг 2 Подтвердить шаблон`,
"vue_label_helpcenter_file":`Просмотр и управление файлами<br> Используйте новую версию файлового объекта для просмотра и управления файлами, принадлежащими вам или совместно используемыми другими людьми. Вы можете просматривать файлы в некоторых форматах онлайн. <br>Файловая библиотека<br> Используйте функцию файловой библиотеки, чтобы создать базу знаний команды, настроить различных администраторов и участников для удобного управления; используйте функцию папок для классификации файлов.`,
"label.locateddowncurrentvalue":`Значение ниже текущего`,
"label.tianyancha.businessverify.msg5":`2. надёжность сервиса`,
"label.setup.mobile.bottombutton.change.success":`Успешно изменившийся`,
"label.appointmentconfirmail.wizard.subtitle2":`Время`,
"label.email.address.lookup":`Адрес электронной почты для поиска`,
"setup.mainpage.label.welcome":`Добро пожаловать на платформу CloudCC PaaS, основные функции платформы следующие:`,
"label.icon.55":`Бульдозер`,
"label_tabpage_enterrecordnamez":`Пожалуйста, введите владельца записи`,
"label.tabpage.andz":`И`,
"label.selectfiletoimport":`Выберите файл для импорта`,
"label.version.sum.trigger":`триггер(ы)`,
"label.multi.layout":`Компактные макеты`,
"pagecreator.button.back":`Последний шаг`,
"label.imgfield.truetype":`Пожалуйста, загрузите правильный тип изображения`,
"front-kefu-moudle-v1-publicKey":`Общий ключ`,
"label.data.exp.newtemp":`Шаблон Создать`,
"label.martrixreport.2018.step4.new":`Шаг 4 Выбор заголовков столбцов`,
"label.sendemail.chat.addComentsatsubject":`Я был упомянут в сообщении CloudCC CCChat.`,
"vue_label_applauncher_description_leadpool":`Используйте Ведущий пул для удобного управления последующим статусом в организации и мотивации персонала к завершению операций.`,
"label.knowledgebase.archive.published.articles.without.drafts":`Вы можете архивировать только опубликованные статьи без черновиков.`,
"label.projectManagement.bar.chart":`Гистограмма`,
"label.ccpeak.condition.return.sort":`Возврат и сортировка по условиям`,
"label.salescloud.opportunity.contactrole":`Возможность Контакт Роль`,
"label.language":`Язык`,
"message.error.view.badprevilege":`К сожалению, вам не разрешается обслуживать эту услугу, пожалуйста, свяжитесь с вашим администратором.`,
"label.textmessage.managetemplates":`Управление шаблонами`,
"message.error.type.null":`Тип не может быть нулевым!`,
"setup.mainpage.label.welcome9":`Пользователи могут реализовать классификационное отображение и настройку макета всех элементов страницы, а также настройку доступных только для чтения и требуемых полей на странице, перетаскивая мышь без разработки кода.`,
"label.appupload.component.type.page":`Пользовательские страницы`,
"label.textmessage.bookschedule":`Нажмите на ссылку ниже, чтобы увидеть и забронировать мое расписание:`,
"component_chatter_post_button_save":`Опубликовать`,
"lable.oppt.jieduan.signcomplete":`Отметить статус как завершенный`,
"label.help.notes":`ХЕЛП И ГУИД`,
"label_tabpage_reallproplez":`Запишите всех людей`,
"label.obtain.authorization.failure":`Не удалось получить код авторизации. Пожалуйста, повторите авторизацию.`,
"label.account.FiscalQuarter":`финансовый квартал`,
"label.customsetting.savecustomvalue":`Данные для этого места уже существуют, пожалуйста, измените их и сохраните еще раз.`,
"label.maximum":`Максимум`,
"component_chatter_file_label_maxsize":`Максимальный размер файла 20 м`,
"c218":`Ваше сообщение было сохранено как черновик`,
"c875":`Новый пост для разговора`,
"c1623":`Удостоверить поставщика`,
"c183":`Тегфильтр`,
"c366":`Настройка пула`,
"c91":`Оценка взаимодействия с электронной почтой`,
"c184":`Продвижение по этапу`,
"c1957":``,
"c750":`Инициатор:`,
"c1016":`Имя параметра`,
"c2084":``,
"c619":`Сообщения в Twitter должны содержать не более 280 символов. Попробуйте использовать сокращения, чтобы сократить текст.`,
"c1261":`Серия пробных продуктов`,
"c1172":`Кнопки выбора`,
"c1220":`Выбранный пользовательский компонент(ы)`,
"c69":`Кредиторская задолженность`,
"c675":`Выровненный по левому краю`,
"c1280":`Назначенные пользователи в Восточном Китае`,
"c1880":``,
"c533":`Количество модернизированных корпусов`,
"c1662":`Записи о посещаемости`,
"c167":`Необходима длина заказа`,
"c682":`Квадрат`,
"c1572":`Создайте файл, содержащий этикетку и перевод для каждого языка, который вы хотите импортировать.`,
"c960":`Супервыпуск`,
"c1797":`10 дней`,
"c1966":``,
"c1126":`Редактировать тип валюты: Новая валюта (Выберите новую валюту из списка)`,
"c1033":`Не менее 2 вариантов под каждым вопросом!`,
"c850":`Здесь отображается текущее количество подписчиков для каждого из ваших социальных аккаунтов, за исключением Facebook, где отображается текущее количество лайков страницы.`,
"c343":`Добавить участников проекта`,
"c1007":`Копия Общая цена`,
"c8":`Выберите форму`,
"c1548":`Добавить предварительно определенный выбор`,
"c157":`Открытый режим приема заказов`,
"c1039":`Посмотреть электронную почту`,
"c1656":`Счетафактуры`,
"c1482":`Четкие координаты`,
"c1359":`Наведение макета`,
"c1832":``,
"c397":`Сервисный экипаж`,
"c556":`изображения не могут быть размещены`,
"c563":`Активное время`,
"c179":`Логотип партнера`,
"c1856":``,
"c147":`Правила приема заказов`,
"c1787":`Напоминание о пробивке`,
"c303":`Юридическое обязательство`,
"c1491":`Свойства`,
"c885":`Скрыть боковую панель`,
"c1849":``,
"c1012":`Стандартная цена`,
"c1503":`Высота панели в пикселях (Диапазон вводимых значений: 12560px)`,
"c808":`Вставить изображение`,
"c718":`Продолжить настройку`,
"c414":`Спасибо, что уделили время его заполнению.`,
"c9":`Привлечение сотрудников`,
"c1066":`Язык основной этикетки`,
"c1683":`Объекты`,
"c1974":``,
"c1844":``,
"c1448":`Максимальное количество не может быть пустым.`,
"c15":`На него был выставлен счет. Пожалуйста, выберите заново`,
"c1806":``,
"c1226":`Действие спускового крючка`,
"c1179":`Утверждение или отклонение на основании первого ответа`,
"c1919":`Загружайте файлы Word после создания шаблонов.`,
"c59":`Пожалуйста, сначала привяжитесь как место администратора Easemob, а затем войдите в расширенную настройку.`,
"c1529":`< span style='color: '# ff0000' > ошибка: неправильный формат поля < / span >`,
"c504":`Планируйте проекты, распределяйте работу, управляйте ресурсами и сотрудничайте со своей командой для достижения целей проекта, контролируйте ход проекта, выполняйте проект в срок и в рамках бюджета.`,
"c836":`Привязать счет Фадада`,
"c187":`Страница благодарности`,
"c208":`Скачать пакет`,
"c1851":``,
"c952":`Бразилия`,
"c104":`Ответить один раз`,
"c1171":`Доступные кнопки`,
"c1834":``,
"c1847":``,
"c346":`Расчет ресурсов задачи`,
"c1801":``,
"c1322":`Показать колонки`,
"c1194":`2 цикла назад`,
"c913":`Расширить боковую панель`,
"c571":`Выбрана форма (формы) {selectnumber}`,
"c1749":`Нажмите Выйти из системы`,
"c1558":`Подробные данные`,
"c44":`Выберите сеть для подключения`,
"label.social.posts.content.null":`Содержимое поста пустое`,
"c1799":`Никогда не истекает
`,
"c852":`Название компании (незаполненное)`,
"c561":`Применить фильтр`,
"c1072":`Замена ролей в команде по ведению дела`,
"c1626":`Инструменты для работы с вебстраницами`,
"c1058":`Скрыть историю`,
"c1881":``,
"obtain.contract.envelopeid.fail":`Не удалось получить информацию о конверте или информацию о несвязанном сообщении`,
"c465":`Только заказы, использующие одну и ту же валюту, могут генерировать счетфактуру`,
"c982":`Текущая книга цен деактивирована`,
"c350":`Сортировка задач`,
"c352":`Календарь кадровых ресурсов`,
"c670":`Графические иконки`,
"front-electronic-signature-given":`Доставка`,
"c542":`Оценка удовлетворенности`,
"c314":`Создать файл счетафактуры`,
"c148":`Настройка уведомлений по электронной почте`,
"c47":`Подключить домен`,
"c1745":` Пределы полномочий`,
"c1440":`Пожалуйста, введите название бассейна`,
"c754":`Заполнить`,
"c326":`Комплектация активов`,
"c289":`Предпочтения`,
"c196":`Уведомление об ограничении`,
"c1306":`Направление синхронизации задач`,
"c63":`Открыть {objName}`,
"c769":`Инициированный подписанный документ задачи будет очищен после отмены. Продолжить отмену?`,
"c216":`Ваше сообщение было запланировано`,
"c842":`Отправить уведомление о подаче по электронной почте`,
"c389":`Территория обслуживания родителей`,
"c7":`Владелец промоушена`,
"c981":`Тяньцзинь`,
"c143":`Выберите пользователя для получения уведомлений. Этот параметр можно изменить на всех целевых страницах, на которых используется форма.`,
"c930":`Выключатель позиционирования сотрудников`,
"c1861":`Новый тип записи`,
"c1621":`Пользователь и контроль`,
"c515":`Добавить резюме работы`,
"c393":`Член территории обслуживания`,
"c1162":`Удалить поле`,
"c1235":`Набор прогнозных данных`,
"c357":`Тариф`,
"c1660":`Отсутствие сервисных ресурсов`,
"c597":`Целевой манометр`,
"front-electronic-signature-cancelIntro1":`Электронная подпись DocuSign будет недоступна после отвязки. Вы уверены, что хотите отвязать?`,
"c271":`У вас произошел таймаут при приеме заказа, номер: {0}. Просим оперативно разобраться с ним и отнестись с пониманием к задержке работы. Нажмите, чтобы увидеть больше >`,
"c1292":`Различные цвета используются для отображения различных состояний.`,
"c1059":`Пункт счетафактуры`,
"label.gaode.map.cannot.work.normally.please.check.whether.the.secret.key.is.correct":`Amap не работает должным образом. Пожалуйста, проверьте правильность секретного ключа!`,
"c424":`Управление территорией обслуживания`,
"c1729":`Свойства поля времени`,
"c995":`Пожалуйста, выберите бассейн!`,
"c711":`Подключите свои социальные аккаунты и откройте для себя совершенно новый мир поклонников.`,
"c1658":`Облачные объекты полевой службы`,
"c1770":`Измерение времени`,
"c197":`Вы достигли максимального количества присланных работ. Спасибо за участие!`,
"front-electronic-signature-save-success":`Успешное сохранение отображения`,
"c765":`Заблокировано`,
"c1852":``,
"c1445":`Другие настройки`,
"c1575":`Пожалуйста, загружайте файлы в формате CSV`,
"c1383":`{n} Цикл(ы)`,
"c1244":`Максимальная длина превышена`,
"c286":`Несоблюдение`,
"c145":`Представленные рабочие часы для одного/нескольких заданий на одного человека в день не могут превышать 24 часов.`,
"c264":`Управление персональными полями`,
"label.china":`Китай`,
"label.no.bind.mobile":`Нет мобильного. Пожалуйста, перейдите к личной информации и привяжите`,
"c95":`Удалить выбранные продукты`,
"front-electronic-signature-open-signInfo1":`Электронная подпись и штамп DocuSign включены. Пожалуйста, отключите его, затем включите электронную подпись и штамп Fadada.`,
"c1342":`Обратите внимание, что данная проверка поддерживает только данные промышленных и коммерческих предприятий, зарегистрированных на материковой части Китая.`,
"c1393":`Загрузить историю входа в систему (последние 6 месяцев)`,
"c1501":`Высота панели`,
"c1077":`Имена членов`,
"c1661":`Ресурс обслуживания Человекочасы`,
"c1659":`Сервисные контракты`,
"c1283":`Картографическое поле`,
"c391":`Посмотреть комментарий`,
"c1499":`3 раза`,
"c1802":``,
"c106":`Взаимодействия`,
"c1120":`Выберите поле и нажмите кнопку Вставить. Метки, за которыми следует '>', означают, что доступны дополнительные поля.`,
"c1736":`Тип провайдера`,
"c519":`Вся связанная информация этого табеля также будет удалена, если вы удалите этот табель, и данные не смогут быть восстановлены. Вы уверены, что хотите подтвердить удаление?`,
"c528":`Журнал учета рабочего времени`,
"c1000":`Есть!`,
"c78":`Заказ №.`,
"c983":`URL ссылки`,
"c41":`Развязать успешно`,
"c1495":`10 персонажей`,
"c517":`Пожалуйста, введите действующую ставку налога`,
"c1624":`Разрешить управление ссылками`,
"c774":`Прогресс подписи`,
"c296":`Пожалуйста, заполните название поля`,
"c996":`Пожалуйста, выберите причину!`,
"c1112":`Ожидание ввода`,
"c757":`Принять`,
"c1251":`Ниже показан список допустимых и недопустимых процессов утверждения для 220309субчеков.
Чтобы создать процесс утверждения, нажмите кнопку Создать новый процесс утверждения, а затем выберите Использовать мастер быстрого запуска, чтобы настроить процесс утверждения всего за несколько шагов. В качестве альтернативы выберите Использовать стандартное руководство для настройки всех параметров утверждения.`,
"front-electronic-signature-confirmintro":`Привязка прошла успешно. Теперь вы можете инициировать подписание из объекта Contracts.`,
"c1434":`Макет мобильной страницы: применяется к макету министраниц WeChat и отображению мобильной версии`,
"c1169":`Перевернутый`,
"c1006":`Общая цена продукта`,
"c1805":``,
"c1543":`Лицензия CloudCC`,
"c1950":`Автор`,
"c1561":`Имя почтового шаблона`,
"c1737":`Имя провайдера`,
"c446":`Статус задачи`,
"c238":`{!ServiceResource.name} Принят заказ. Счет: "{!ServiceAppointment.accountid.name}", Subject: "{!ServiceAppointment.subject}", Number: "{!ServiceAppointment.name}".`,
"c980":`Шанхай`,
"c802":`Каждый пользователь может быть добавлен только в качестве ресурса службы`,
"c1895":``,
"c1312":`Проверка пройдена`,
"c387":`Навыки использования сервисных ресурсов`,
"c965":`Сервис EaseMob не включен`,
"c1070":`Доступ к делу`,
"c480":`В какой список мы должны отправить?`,
"c937":`Изменить номер телефона`,
"c1229":`Идентификатор объекта`,
"c1920":`Просмотрите учебник по созданию файлов Word.`,
"c632":`Посмотреть на Facebook`,
"c131":`Поле счета в счетефактуре пустое, пожалуйста, добавьте информацию.`,
"c1088":`Записи для применения правил`,
"c1632":`Настроить портал`,
"c680":`Белый`,
"c806":`Когда`,
"c1873":``,
"c1971":``,
"c649":`Вы прочитали все, что было в вашем почтовом ящике.`,
"c797":`Последние контакты`,
"c616":`Открыть ссылку в новом окне`,
"c987":`Запланированное время`,
"c169":`Извините, у вас нет разрешения на просмотр этого графика`,
"c1545":`Партнерская лицензия CloudCC`,
"c1923":`Пожалуйста, загружайте файлы .docx при объединении связанных полей записи.`,
"c1316":`Имя пользователя учетной записи службы (имя пользователя домена или UPN)`,
"c1577":`Английский язык`,
"c1214":`Меню "Новый пользовательский объект`,
"c21":`Количество товара не может быть меньше суммы счетафактуры`,
"c1512":`Пожалуйста, не добавляйте дублирующийся компонент.`,
"c1432":`Раскладка строк: раскладка, отображаемая при применении к входу ведущеговедомого на переднем плане и пакетном добавлении`,
"c231":`Не может быть меньше, чем количество упакованных продуктов`,
"c1057":`Смотреть подробнее`,
"c1900":``,
"c1009":`Активировать/деактивировать книгу цен`,
"c1110":`Все модули`,
"c555":`Изображение вашего сообщения не удалось опубликовать.`,
"c583":`Карта Китая`,
"c1629":`Портал самообслуживания`,
"c1932":`Создание категорий данных`,
"c1633":`Пользователь портала`,
"c1869":``,
"c1218":`Создать действие`,
"c1488":`Добавьте инструменты нижнего колонтитула`,
"front-electronic-signature-open-signInfo2":`Электронная подпись и печать Fadada включена. Пожалуйста, отключите его, а затем включите электронную подпись и штамп DocuSign`,
"c822":`Новые внешние контакты`,
"c600":`Числовая диаграмма`,
"c1918":`Загрузите шаблон Word.`,
"c442":`Всесторонняя система управления проектами`,
"c1136":`Добавить задания`,
"c762":`Подписать`,
"label.user.not.permission":`Текущий пользователь не имеет разрешения на работу`,
"c35":`Имя подписчика`,
"c1477":`Правило обновления кейса: Новый`,
"c1916":`Текущий объект`,
"c921":`роль (роли)`,
"c1207":`Скопируйте следующий скрипт и вставьте его в исходный HTMLкод сайта перед закрывающим тегом, который должен быть вставлен на каждой странице, где будет отображаться виджет окна.`,
"c305":`Общественные интересы`,
"c1836":`Пожалуйста, выберите тип провайдера`,
"c730":`Вы не можете повторно использовать старый пароль`,
"c1885":`URL Центра обработки вызовов`,
"c1638":`Настройки облака проекта`,
"c1223":`Состояние без названия 1`,
"c1155":`Имя должно быть уникальным.`,
"c525":`Отключить пользователя портала`,
"c942":`Америка`,
"c780":`Процесс подписания`,
"c1202":`действие. Продолжать?`,
"c447":`Источник конечного канала`,
"c1408":`Настройте домашнюю страницу организации в соответствии с реальным сценарием использования.
Вы можете отключить или выключить из конфигурации по умолчанию компоненты, которые не имеют отношения к бизнесу предприятия.
Включено: включенные модули отображаются на домашних страницах всех членов организации.
Disabled: отключенные модули не отображаются на домашних страницах всех членов, а также не поддерживаются в списке configure my Home Page на мобильных устройствах.
Выключен: по умолчанию модуль не отображается на домашней странице всех членов организации. Пользователи могут открыть модуль через "настроить мою домашнюю страницу" на мобильной стороне.`,
"c1200":`Удаление отменено`,
"c369":`Отправить файл с цитатой`,
"c702":`Составить проект`,
"c22":`Оплаченная сумма в счетефактуре будет больше, чем общая сумма, если вы продолжите создавать этот платежный реквизит. Пожалуйста, скорректируйте сумму и сохраните снова.`,
"c79":`Дата заказа`,
"c785":`Настоящее имя (необязательно)`,
"label.insert.approval.reassign.error":`Утверждение в статусе вставляющего утверждения не может быть переназначено`,
"c1096":`Это правило будет применяться ко всем записям`,
"c998":`Модуль`,
"c273":`Таймаут при приеме заказа. Отмените отправку.`,
"c3":`Успешное удаление графика`,
"c448":`Чатсессия`,
"c495":`Все, что нужно, чтобы продавать быстрее и умнее`,
"c429":`KPI диспетчерской службы`,
"c1977":``,
"c1811":`Разработчик`,
"c1147":`Имя разрешения`,
"c1269":`Вариант`,
"c16":`Существует более одного счетафактуры. Пожалуйста, выберите заново`,
"c1087":`Используйте следующие стратегии`,
"c1644":`Настройки группы учетных записей`,
"c1084":`Сумма налога должна быть числом`,
"c1708":`Отключено: отключенные модули не отображаются на домашних страницах всех пользователей, а также не поддерживаются в списке "Настроить мою домашнюю страницу" на мобильных устройствах.`,
"c128":`Можно добавить до 5 рядов`,
"c955":`Минимальная ширина {label} равна {minWidth}px`,
"c1427":`AUD`,
"c1556":`Название группы`,
"c716":`Вы готовы начать публиковать сообщения прямо из CloudCC`,
"c1702":`Загрузить фотографии？`,
"c1724":`Ошибка формата. Пожалуйста, используйте формат yyyy/MM/dd HH: mm: ss или yyyyMMdd HH: mm: ss, или функцию: Today()`,
"c638":`Параметры публикации`,
"c746":`Отозвать запрос на уничтожение`,
"c534":`Количество закрытых дел`,
"c1685":`План проекта`,
"c948":`Италия`,
"c1710":`Верификация не прошла`,
"c317":`Отправить файл заказа на поставку`,
"c426":`Управление ресурсами услуг`,
"c1252":`Используйте эту страницу для создания различных макетов страниц для отображения пользовательских данных. После создания макета страницы нажмите кнопку Назначение макета страницы, чтобы контролировать, какой макет страницы пользователь видит по умолчанию.`,
"c1831":``,
"c1219":`Доступные пользовательские компоненты`,
"c457":`Совокупная сумма контракта Рейтинг`,
"c263":`Личные поля`,
"c372":`Сформировать заказ`,
"c1930":`Перевод статьи  Редактировать`,
"c907":`Доступно только в версии с молнией`,
"c1795":`Кнопки, отображаемые в нижней части страницы детализации`,
"c771":`Ход заполнения`,
"c408":`Настраиваемое приложение для полевого обслуживания`,
"c1522":`Пользовательские кнопки и ссылки`,
"c12":`Темпы роста`,
"c1827":``,
"c379":`Платежные реквизиты`,
"c410":`Тип работы`,
"c510":`Заказ партнеров`,
"c1928":`Просмотр черновиков`,
"c701":`Назначить кампанию`,
"c617":`Текст необходим для публикации сообщения`,
"c1630":`Реконструкция бренда`,
"c213":`Формат EPS`,
"c1649":`Настройки баллов`,
"c473":`Система сгенерирует уникальный код приглашения для сотрудников, которые могут использовать его для приглашений и засчитывать как личные показатели. Обратите внимание, что владельцем лида будет текущий владелец кампании или пригласитель маркетингового канала.`,
"c975":`Утверждение и планирование проекта`,
"c1239":`Поделиться`,
"c1975":``,
"c1921":`Просмотр значения поля`,
"c168":`Пожалуйста, выберите график!`,
"c121":`Uncategorized`,
"label.send.invoice":`Отправить счетфактуру`,
"c792":`Подтверждение Инициирование`,
"c1309":`Пожалуйста, введите название рабочего процесса`,
"c686":`Размер`,
"c1373":`1 колонка`,
"c1295":`Правила рабочего процесса позволяют выполнять определенные автоматические действия над конкретными записями на основе условий фильтра.
Автоматизация рабочего процесса может отправлять электронные письма, обновлять поля, создавать записи и так далее.`,
"c1108":`Пожалуйста, проверьте, завершена ли конфигурация условий`,
"c1603":`Свойства поля изображения`,
"c1959":``,
"c652":`Здесь показано количество сообщений, которые были опубликованы в ваших учетных записях за выбранный период. Сюда также входят сообщения, которые были опубликованы в ваших подключенных аккаунтах за пределами CloudCC.`,
"c136":`Пожалуйста, укажите здесь краткое представление`,
"c1970":``,
"c662":`Пользовательский значок`,
"c1191":`Выберите Окончательное утверждение Блокировка записей`,
"c2082":``,
"c1865":`Пользователь 2`,
"label.invoice.customer.is.error":`Формирование счетовфактур поддерживается только для заказов, размещенных одним и тем же клиентом.`,
"c580":`Пузырьковая диаграмма`,
"c1101":`Новый вебкрючок`,
"c894":`Назначьте кампанию для поста, и вы сможете просматривать все связанные посты в той же кампании. Это используется для удивительных маркетинговых усилий.`,
"c1297":`Новый рабочий процесс`,
"c570":`Дизайн`,
"c1597":`Свойства поля Picklist (MultiSelect)`,
"c1613":`Импорт моих счетов`,
"c133":`превышать`,
"c564":`Уважаемый пользователь: <br/> Добро пожаловать в систему CloudCC. Вы запросили сброс пароля в {!operatetime}, пожалуйста, войдите в систему, используя нижеприведенный проверочный код в течение 15 минут.<br/>Случайный проверочный код: <b>{!authcode}</b><br/><br/> <b>Важно: </b><br/>Если вы не запрашивали эту операцию, или вы считаете, что это сообщение не должно дойти до вас, пожалуйста, немедленно свяжитесь с вашим администратором!`,
"c854":`Похоже, что ничего не опубликовано.`,
"c1947":`Тип упаковки`,
"c1248":`Какой макет вы хотите скопировать?`,
"c1243":`Создать новый макет`,
"c1798":`15 дней`,
"c775":`Снято с производства`,
"c105":`Воспроизведение более одного раза`,
"c1948":`Включить подсчеты`,
"c1078":`Обновление членов команды по делу`,
"c729":`Пожалуйста, подтвердите, настроена ли у вас социальная платформа или нет. Перейдите в настройки бэкенда  Интеграции  Включить (Twitter/Facebook/LinkedIn)`,
"c1275":`Максимальный`,
"c1475":`Используйте правила назначения для автоматической отправки записей соответствующим пользователям.
Правило назначения состоит из условий и нескольких записей правил, определенных для записи.`,
"c491":`Деактивировано`,
"c609":`Торговая марка`,
"c1469":`Дата окончания финансового года не может быть пустой.`,
"c611":`Ссылка на`,
"c843":`Посмотреть представление`,
"c933":`Страница конверсии`,
"c383":`Продукты возможностей`,
"c186":`Уникальный идентификатор уже существует. Пожалуйста, не добавляйте его повторно`,
"c1305":`Конфликтное поведение`,
"c608":`Заменить`,
"c149":`Включить уведомления из Outlook (поддерживается только часть почтовых служб)`,
"c1028":`Поставщики`,
"c1350":`Настройки Vonage`,
"c1606":`Свойства загрузки файлов`,
"c1931":`Перевод статьи  Опубликовать`,
"c486":`Ответить на адрес электронной почты:`,
"c1555":`Создано успешно`,
"c1186":`3 цикла`,
"c598":`Диаграмма пончиков`,
"c726":`Запрос успешно уничтожен`,
"c645":`Утвердить проект`,
"label.verificationCode.is.invalid":`Код проверки был недействительным. Пожалуйста, получите его повторно`,
"c1284":`Назначение успешно!`,
"c1410":`5 мин`,
"c904":`Между`,
"c1397":`Запрос не прошел`,
"c594":`Двумерная линейная диаграмма`,
"c103":`Нажмите несколько раз`,
"c188":`комментарий(ы)`,
"c891":`Запись не может быть контактом, возможностью, лидом или аккаунтом`,
"c1254":`2. Макет страницы при наведении: применяется к макету, отображаемому в окне наведения на передний план`,
"c902":`Расстояние между адресом регистрации и посетителем`,
"c1539":`Зрелость`,
"c484":`Электронные письма:`,
"c421":`Метод генерации рабочих заказов`,
"c1889":``,
"c406":`Автоматизированное управление продажами`,
"c1426":`Один и тот же язык не может быть добавлен многократно.`,
"c1113":`Проверка формулы не удалась, проверьте синтаксис`,
"c1654":`Объекты`,
"c1100":`Файл изображения должен быть меньше 20k`,
"c1246":`Примечания и приложения`,
"c1228":`Функция находится в стадии разработки.`,
"c739":`Кампания: Привлечение сотрудников`,
"c1511":`Инструменты автоматического входа в систему после входа пользователя в систему.`,
"c1181":`Уникальное имя должно быть строкой.`,
"c329":`Замена активов`,
"c1857":``,
"c1011":`Тип продукта`,
"c351":`Частота рецидивов`,
"c622":`Статистика сети последний раз обновлялась в`,
"c1367":`Заголовок виден только на странице подробностей.`,
"2":`Успешная настройка параметров фильтрации`,
"c463":`Мои возможности`,
"c268":`Успешное слияние информации`,
"label.mobile.no.letter.blankcharacter":`Номер телефона не может содержать букв и пустых символов`,
"c1531":`Меньше или равно`,
"c1637":`Облако услуг Мобильная связь`,
"c1855":``,
"c1125":`При включенном расширенном управлении валютой вы можете сопоставить курсы обмена валют с курсами с истекшим сроком действия в определенном диапазоне дат.
Курс с истекшим сроком действия используется для возможностей бизнеса, продуктов возможностей и отчетов, связанных с этими двумя объектами.
Курс обмена с истекшим сроком действия нельзя использовать для полей других объектов или других типов отчетов.
Например, курс обмена на 1 января составляет 1 USD равняется 6,68 CNY, но 6 февраля курс обмена меняется на 1 USD равняется 6,70 CNY.
Возможности с датой окончания с 1 января по 6 февраля используют первый обменный курс (1 = 6,68), а возможности с датой окончания после 6 февраля используют второй курс (1 = 6,70).`,
"c438":`Передача`,
"c581":`Таблица`,
"c953":`Южная Корея`,
"c90":`Тема`,
"c2":`Удалите приборную панель успешно!`,
"c1618":`Настройки печати шаблонов`,
"c1680":`Запрос продукции Каталог строк`,
"c1964":``,
"c1201":`Это приведет к удалению всего`,
"c1691":`Счет возврата`,
"c897":``,
"c444":`Первый канал Источник`,
"c1286":`Отменен и не может быть завершен.`,
"c1544":`CCChat Свободная лицензия`,
"c242":`{!ServiceResource.name} отклонил заказ. Счет: "{!ServiceAppointment.accountid.name}", Номер: "{!ServiceAppointment.name}".`,
"c135":`Пустой шаблон`,
"c659":`Следуй за мной`,
"c773":`Доработка`,
"c11":`Маркетинг по формам`,
"c1209":`Go Enable`,
"c1580":`Корейский`,
"c799":`Внешние контакты`,
"c1260":`Пожалуйста, введите описание`,
"c1014":`Книга цен недоступна в данной организации. Для включения обратитесь к администратору.`,
"c1075":`Количество членов`,
"c1830":``,
"c880":`редактировать социальные посты`,
"c890":`Успешная отправка приглашения по электронной почте`,
"c1614":`Импорт моих контактов`,
"c846":`Пожалуйста, выберите подходящую услугу`,
"front-electronic-signature-sucessSign":`Успешное начало подписания`,
"c472":`Выберите форму для применения плаката`,
"c1384":`Финансовый квартал {n}`,
"c963":`Поле "Имя" является обязательным`,
"c1076":`Роли членов`,
"c390":`Территория обслуживания детей`,
"c248":`Ожидается принятие передачи заказа`,
"c1505":`60 дней`,
"c1675":`Запись сканирования активов`,
"c1875":``,
"c646":`Поток входящих сообщений`,
"c1665":`Стратегия планирования Цель`,
"c1425":`Вы можете сопоставить курс обмена валюты с истекшим курсом в определенном диапазоне дат.
Курс с истекшим сроком действия используется для возможностей, продуктов возможностей и отчетов, связанных с этими двумя объектами.`,
"c308":`Выберите хотя бы одну информацию`,
"c858":`Вы уверены, что хотите сохранить {a} посты как черновики? Эти сообщения не будут опубликованы, пока вы не запланируете их снова.`,
"c152":`Количество выполненных сервисных назначений в выбранном в данный момент временном диапазоне / Количество всех сервисных назначений в выбранном в данный момент временном диапазоне`,
"c1754":`Одновременно начать выхватывать?`,
"c1666":`Стратегия планирования`,
"c1925":`Просмотр черновиков`,
"c1403":`Папки: Новый`,
"c1118":`Пожалуйста, выберите хотя бы одну существующую операцию`,
"c1571":`Шаг 1: Подготовьте переведенный файл (перед импортом убедитесь, что файл соответствует следующим условиям)`,
"c316":`Просмотреть ход дела`,
"c2081":``,
"c1828":``,
"c1808":``,
"c1381":`Добавить расширенный фильтр`,
"c1270":`Закрыть все`,
"c1602":`Свойства текстовой области (длинного) поля`,
"c1492":`Свойства инструмента`,
"c1444":`Выберите пользователя слева и добавьте его в список Selected Users.`,
"c1904":`Готовность к настройке хоста`,
"c435":`Просмотр версии`,
"c1053":`Пожалуйста, выберите шаблон, который вы хотите использовать`,
"c1409":`Когда эта функция включена, члены организации могут создавать, просматривать, редактировать и удалять записи в свободном от сети состоянии на мобильной стороне.
Выбранное меню будет включено в качестве меню автономного кэширования по умолчанию на мобильной стороне всей организации. Каждый пользователь может настроить меню автономного кэширования организационных настроек на мобильной стороне в соответствии с различными потребностями сцены или переключиться на включение других необходимых меню.`,
"c1304":`Поведение при конфликте событий: Обмен всегда предпочтительнее`,
"c1190":`6 циклов`,
"c1109":`Результат не найден`,
"c362":`Прикрепленные ограничения на продукцию`,
"c1299":`Конфликтное поведение при контакте: CloudCC.com всегда предпочтительнее`,
"c800":`Пожалуйста, введите имя или название компании`,
"c415":`Запланированный старт`,
"c1395":`Заменить значение списка опций`,
"c1790":`Ассоциированный пользователь`,
"c1149":`Скрывать по умолчанию`,
"c1523":`Пожалуйста, введите действительный адрес электронной почты.`,
"c1276":`Продукт не связан ни с какими налогами`,
"c735":`Имя не может быть повторено`,
"c903":`Выберите значок приложения`,
"c1222":`Редактировать условия`,
"c1023":`Извините! Доступ заблокирован, поскольку этот URLадрес может нанести ущерб безопасности сайта.`,
"c1082":`Специальные символы не разрешены`,
"c1655":`Заказ`,
"c1417":`Ошибка формата по умолчанию`,
"label.insert.approval.massreassign.error":`Пакетные утверждения, существующие в утверждении "Вставка", не могут быть переназначены. Система будет автоматически фильтровать за вас`,
"c1516":`Регионы и подчиненные регионы`,
"c1898":``,
"c354":`Редактирование табеля учета рабочего времени`,
"c409":`Единая платформа для обслуживания клиентов`,
"c1945":``,
"c651":`Здесь показано количество текущих фолловеров для каждого из ваших социальных аккаунтов, кроме Facebook, где показано количество текущих лайков страницы.`,
"c1667":`Цели обслуживания`,
"c1121":`При создании записей`,
"c582":`Карта мира`,
"c1360":`Время начала не может быть позже времени окончания`,
"c994":`Пользовательские компоненты Lightning`,
"c1826":``,
"c1374":`2 колонки`,
"c1199":`Поля, которые необходимо обновить`,
"c826":`Вы уверены, что хотите отменить изменения?`,
"c1361":`Время окончания не может быть позже времени начала`,
"c781":`Предприятие: Пожалуйста, введите название компании, указанное в лицензии на ведение бизнеса. Проверка будет произведена при подписании.`,
"c1139":`Редактирование набора разрешений`,
"c1845":``,
"c873":`Подробнее`,
"c1612":`Импорт моих лидов`,
"c837":`После отвязки функция электронной подписи Fadada не может быть использована, а функция автозаполнения и обратного заполнения полей, которые были установлены, будут удалены. Вы уверены, что хотите отвязать счет?`,
"label.diedirect.sale":`Прямое снижение цен`,
"c798":`Внутренние контакты`,
"c368":`Создать файл котировок`,
"c770":`Инициировано`,
"c1551":`Другие электронные письма`,
"c882":`Условия предоставления услуг`,
"front-setting-dialog-title-two":`Настройте со страницы личной информации, если она не была введена в этот раз. Привязка по мере ввода номера`,
"c1449":`Неправильная информация`,
"c535":`Нераскрытые`,
"front-electronic-signature-look-account":`Просмотр счета`,
"c1972":``,
"c19":`Режим отображения деталей записи`,
"c1890":`Добавить пользователя`,
"c52":`Наименование налога`,
"c388":`Право на ассоциирование и использование`,
"c1451":`SGD`,
"c1648":`Контакт по возможностям`,
"c1156":`Если тип интервала  минута, интервал должен быть больше или равен 30 минутам и меньше или равен 59 минутам.`,
"c1390":`Создайте зависимость, которая приведет к динамической фильтрации значений в списке опций или мультисписке выбора на основе значений, выбранных пользователем в другом поле.`,
"c18":`Существует более одного неактивного заказа, пожалуйста, выберите заново`,
"c820":`Пожалуйста, введите номер телефона/почтовый ящик`,
"c285":`Обзор`,
"c1245":`Шаттлбокс`,
"c1552":`Текущий пользователь Email`,
"c478":`Аутентификация Mailchimp`,
"c1608":`Свойства поля зашифрованного текста (шифрование при хранении)`,
"c1206":`Имбеддинг`,
"c164":`Пожалуйста, введите целочисленное значение от 060`,
"label.tip.excess.quota":`Использование ресурса превышено`,
"c318":`Создать файл заказа на поставку`,
"c698":`Социальная сеть`,
"c1116":`Добавить описания`,
"c1092":`При выполнении условий`,
"c1915":`Выберите поля для объединения и копирования в Word (Поддерживает показ записей связанного списка по условиям)`,
"c312":`Многократные заказы пока не действуют, пожалуйста, выберите еще раз`,
"c110":`Группировка по проектам`,
"c549":`Диапазон дат не может превышать 31 день!`,
"c1128":`Текущая валюта`,
"c1896":``,
"c845":`Пожалуйста, выберите хотя бы одну запись на обслуживание`,
"c1329":`Пиклист (более одного)`,
"c282":`Управление персональными данными клиентов в CRM`,
"c1587":`Свойства поля отношения поиска`,
"c1969":``,
"c270":`Таймаут при приеме заказа`,
"c288":`Изменение основы обработки данных`,
"c1231":`Чтение/запись  пользователи могут просматривать и перезаписывать данные прогноза.`,
"c878":`Текущий адрес`,
"c1287":`Состояние по умолчанию`,
"c1698":`Настройки мобильного модуля для функции рекомендаций`,
"c1651":`Настройки посещаемости`,
"c1161":`Вы уверены, что хотите удалить это поле из представления "Визитная карточка"?`,
"c324":`Добавление очередей к случаям`,
"c1099":`Пожалуйста, выберите изображения в формате .jpg или .png`,
"c1145":`Видны всем пользователям`,
"c1462":`Не разрешается удалять пользователей из Избранных пользователей во всех неназначенных и включенных пользователей, а также во всех неназначенных пользователей.`,
"c1840":``,
"c1616":`Импорт учетных записей / контактов`,
"c129":`Это действие приведет к окончательному удалению файла. Вы хотите продолжить?`,
"c1510":`Автозапуск`,
"c339":`GDPR Уничтожение данных`,
"c1106":`Операция предназначена для связи со сторонними приложениями и отправки вебуведомлений сторонним приложениям непосредственно при наступлении определенных событий/действий.`,
"c1303":`Поведение при конфликте событий: CloudCC.com всегда предпочтительнее`,
"c405":`Размер экипажа`,
"c848":`Аккаунты Linkedin`,
"c1524":`Операционная колонка`,
"c345":`Шаблон проекта`,
"c591":`Карта Австралии`,
"c180":`Язык на странице входа в систему`,
"c126":`Доставлено`,
"c1824":``,
"c1404":`Папки: Редактировать`,
"c311":`Неэффективно, пожалуйста, выберите еще раз`,
"c587":`Карта Мексики`,
"c37":`Это текст, который будет отображаться на странице предпочтений при общении с вашим клиентом`,
"c1914":`Выберите значение объединяемых полей`,
"c840":`Ура! Нет неудачных постов.`,
"c1866":``,
"c1355":`Выберите роль, которой вы хотите назначить это разрешение на компоновку.`,
"c1183":`1 цикл`,
"c2087":``,
"c1371":`Некоторые имена отображаются на`,
"c1519":`Свойства поля текстовой области (Rich Text)`,
"c241":`{!ServiceResource.name} отклонил заказ. Счет: "{!ServiceAppointment.accountid.name}", Subject: "{!ServiceAppointment.subject}", Number: "{!ServiceAppointment.name}".`,
"c1215":`Выберите источник изображения для пользовательского значка приложения.`,
"c141":`Сообщение с благодарностью является обязательным`,
"c1466":`Нажмите кнопку Новый, чтобы задать новый пользовательский год.`,
"c1205":`Утверждение пакетной передачи успешно запрошено.`,
"c1430":`Диапазон между временем начала и временем окончания не может превышать 2 месяцев.`,
"c1689":`Партнерский счет`,
"c1540":`Отношение к нашей компании`,
"c1271":`Открыть все`,
"c1337":`Номер группы каналов (MD5)`,
"obtain.contract.fail":`Не удалось получить информацию о контракте`,
"c1541":`Оценка количества посещений`,
"c1129":`CNY`,
"c1786":`Пожалуйста, выбейте. (игнорировать, если уже выбито)`,
"c945":`Россия`,
"c1321":`Проверка формы не удалась`,
"c454":`Сумма контракта Ежемесячно`,
"c34":`У вас в корзине 100 товаров. Пожалуйста, очистите хотя бы один товар перед добавлением нового.`,
"c1550":`Значение операции не может быть пустым`,
"c243":`{!ServiceResource.name} отклонил заказ. Тема: "{!ServiceAppointment.subject}", Number: "{!ServiceAppointment.name}".`,
"c548":`Задача/проблема, подзадача и проект не могут быть отредактированы из табеля учета рабочего времени`,
"c1640":`Настройки свинцового бассейна`,
"c807":`Отправить сейчас`,
"c590":`Карта Германии`,
"c831":`Сертификация`,
"c198":`Ваша форма надежно опубликована и может быть использована по следующему URL, чтобы поделиться своей формой как публичной ссылкой.`,
"c1437":`Пожалуйста, выберите время начала и время окончания.`,
"c977":`Вот как ваше сообщение будет отображаться на {0}. Возможны незначительные различия, если {1} внесет какиелибо изменения в макет.`,
"c1927":`Управление статьями`,
"c66":`Информация о логистике продукта обновлена до Delivered`,
"c1327":`Действие приведет к удалению этих данных. Продолжить?`,
"c1599":`Свойства поля отношения мастердеталь`,
"c1829":`Процессор регистрации`,
"c1756":`Включить полнотекстовый поиск`,
"label.twitter.title.setting":`Интегрированная информация Twitter`,
"c922":`Обратитесь к администратору для включения команды`,
"c1926":`Просмотр архивных статей`,
"c1538":`Роль 1`,
"c1705":`Поле, значение которого фильтруется, называется зависимым полем.
Пользовательские списки опций и списки множественного выбора могут быть зависимыми полями`,
"front-email-payment-Invoice-Tips":`Пожалуйста, свяжитесь с администратором, чтобы включить PayPal или VISA, а затем инициировать онлайноплату`,
"c605":`	
Адрес для выставления счетов по умолчанию`,
"c1704":`Уникальное имя типа записи`,
"c1871":``,
"c403":`Проекты`,
"c1891":`Пакетное удаление`,
"c1793":`Шифровать с помощью sha512?`,
"c156":`Правила приема заказов для мобильной стороны`,
"c1485":`Инструменты нижнего колонтитула`,
"c635":`Запланировать еще один пост`,
"c1810":`Бесплатно`,
"c1249":`Названия макетов`,
"c1628":`Истории и информация о бренде`,
"c1755":`После запуска пользователи, забронированные диспетчерской службой, могут получать заказы в приложении CloudCC Service.`,
"c1153":`Если режим совместного использования всех объектов в очереди  Public Read/Write/Transfer, вам не нужно назначать пользователей в очередь, поскольку все пользователи уже имеют доступ к записям этих объектов.`,
"c753":`Участник`,
"c1822":``,
"c1196":`Уведомления по электронной почте позволяют пользователям узнать о конкретных событиях/действиях.`,
"c1433":`Макет страницы при наведении: применяется к макету, отображаемому в окне наведения на передний план`,
"c1042":`4. Как сохранять файлы`,
"c1641":`Групповые настройки`,
"c1036":`При использовании API от вашей компании для входа в систему необходим токен безопасности. Что такое маркер безопасности? Это чувствительный к регистру буквенноцифровой код, который связан с паролем.`,
"c1777":`Пожалуйста, сначала войдите в Call Center`,
"c1676":`Отчет о расходах`,
"c647":`Вся деятельность`,
"c295":`После отключения вся маркировка персональных полей, основа обработки данных и другая информация, необходимая для соблюдения DGPR, будет удалена, за исключением истории операций для записей. Вы уверены, что хотите отключиться?`,
"c915":`Открытый бассейн`,
"front-electronic-signature-signStatus":`Вы начали онлайнподписание. Статус контракта  {подписать}`,
"c568":`Настройте макет`,
"c1051":`С помощью этой функции вы можете создать документ на основе выбранного вами шаблона слияния, в котором поле слияния ссылается на поле CloudCC. Для слияния связанных полей списка загрузите шаблон слияния в формате docx.`,
"c1256":`Другие телефонные номера`,
"c744":`Пожалуйста, введите действительное число от 0 до 100`,
"c1285":`Планируемая продолжительность`,
"c1480":`Установить координаты`,
"c1278":`Схема, определяемая системой`,
"c1358":`Разметка страниц ПК`,
"c464":`пост(ы) удалены`,
"c385":`Резюме работы`,
"c1973":``,
"c1839":``,
"c1419":`Шаг 2: На следующей странице отредактируйте правила фильтрации, которые управляют значениями, появляющимися в зависимом поле для каждого значения в поле управления.`,
"c392":`Выберите решение, которое вам нужно`,
"c1858":``,
"c418":`Назначенные сервисные ресурсы`,
"c256":`Изменение счета приведет к очистке заказа с выбранными товарами. Вы уверены, что хотите изменить?`,
"c1751":`Если эта функция включена, пользователи, забронированные диспетчерской службой, могут принимать и отклонять заказы в CloudCC Service APP.`,
"c1188":`4 цикла`,
"c690":`Загрузка изображения`,
"c261":`Уничтожить данные`,
"c1407":`< span style="color: red"> Совет: настроенное нижнее меню профиля будет накладываться на единые настройки нижнего меню компании </span>.`,
"c62":`Привлечение сотрудников`,
"c1365":`Одиночная колонка`,
"c892":`Текущая запись не найдена`,
"c909":`Определения цен для этой валюты были добавлены. Пожалуйста, не добавляйте снова!`,
"c883":`&`,
"c1617":`Стиль связанного списка`,
"c1739":`Получить код авторизации`,
"c1154":`Имя должно начинаться с буквы, может содержать только заглавные и строчные буквы, цифры, знаки подчеркивания и не может быть больше 40 в длину.`,
"c1672":`Отношения с активами`,
"c134":`Верхний предел членов пула`,
"c1671":`Форма заявления на поездку`,
"c896":`Запись заблокирована и не поддерживает добавление файлов. Пожалуйста, свяжитесь с администратором для разблокировки`,
"c974":`Опубликуйте новое сообщение, чтобы начать новую беседу.`,
"c209":`Средний размер`,
"c185":`Статистика на этой странице`,
"c796":`Пожалуйста, свяжитесь с администратором для установки шаблона договора на платформе Fadada перед началом подписания.`,
"c60":`Подсчет проектов`,
"c991":`Правила обмена данными`,
"c1573":`Верхняя часть каждого файла должна содержать атрибуты языка (импорт китайского языка не поддерживается).
Языковые атрибуты, такие как: Language=en_US.`,
"c866":`Настройка приложения`,
"c666":`Дисплей`,
"c219":`Ваше сообщение было удалено`,
"c732":`Плакат`,
"c1048":`Пожалуйста, включите хотя бы один шаблон`,
"c1854":``,
"c1345":`Получение необходимой информации (включая контакты) о предприятии`,
"c1595":`Установка обязательна или доступна только для чтения`,
"c155":`{name} Имя`,
"c1328":` Установить эту интеграцию сейчас?`,
"c511":`Электронный договор`,
"c1598":`Свойства числового поля`,
"c240":`Отклонено`,
"c1454":`Выберите фотографии`,
"c1024":`Обменный курс`,
"c1730":`Формат url по умолчанию неверен!`,
"c468":`Тип сортировки пуст`,
"c961":`Q{квартал} {год}`,
"c1455":`Пожалуйста, введите название мероприятия`,
"c1420":`Настроенное содержимое (Пожалуйста, нажмите на значение 'Поля управления' для редактирования).`,
"c404":`Инструмент для маркетинга и генерации лидов`,
"c1234":`Все неназначенные и активированные пользователи`,
"c586":`Карта Сингапура`,
"c1062":`Пользовательская этикетка`,
"c694":`Ширина/Высота`,
"c1025":`Пересчитайте цену продукта по курсу обмена валют, указанному выше`,
"c1536":`Максимальное количество баллов по каждому пункту  20 (с возможностью повторения).`,
"c1897":``,
"c1909":`2. Введите значения объединяемых полей: Просмотр значений текущего поля и связанных с ним полей, а также выбор значений полей для объединения и копирование в локальные шаблоны Word`,
"c297":`Пожалуйста, введите тип персональных данных`,
"c860":`Изменить адрес`,
"c1740":`Получить токен`,
"c58":`Домашняя страница проекта`,
"c1791":`Не связан с группой посещаемости, не требуется пробивать.`,
"c1650":`Правила обновления`,
"c920":`Если настроены правила автопереработки, система будет автоматически перерабатывать записи в пул, если лид не конвертировался по истечении установленного срока. Это повышает эффективность последующей работы с лидами.`,
"c27":`Введите плавающую сумму для корректировки валовой суммы, например,  10 или 10.`,
"c94":`3 раза вверх`,
"c1":`Только мобильная связь`,
"c557":`Полученные случаи`,
"c1127":`Число десятичных знаков (Введите число десятичных знаков, которые могут отображаться при отображении данных в новой валюте (число знаков справа от десятичной точки), которое должно быть целым числом от 0 до 6).`,
"c294":`Выключите настройки соответствия GDPR`,
"c1842":`Пожалуйста, введите регистрационный процессор`,
"c970":`Вы должны выбрать как минимум одну ценовую книгу.`,
"c1727":`Свойства текстового поля`,
"c1324":`DingTalk  Минипрограмма H5`,
"c565":`Назначьте это задание`,
"c668":`Выравнивание`,
"c972":`Название маркетинговой акции`,
"c660":`Авторское право`,
"c433":`Отслеживание полей пула лидеров`,
"c443":`Архив Все`,
"c1372":`Столбцы отображаются частично`,
"c1105":`Все макеты`,
"c275":`У {0} истек срок приема заказа, и отправка отменяется. Номер: {1}. Нажмите, чтобы увидеть больше >`,
"c691":`Ссылка (необязательно)`,
"c956":`Вы еще не активировали свой аккаунт Mailchimp. Пожалуйста, перейдите в настройки>Интеграция>Список интеграций для активации аккаунта Mailchimp или свяжитесь с администратором.`,
"c1750":`Начните получать`,
"c910":`Новый рабочий заказ`,
"c692":`Браузер по умолчанию`,
"c1067":`Основной текст этикетки`,
"c355":`Пакетное добавление временных листов`,
"c1289":`Отображение правил политики рекомендаций`,
"c122":`Изображение продукта`,
"c395":`Тип территории`,
"c689":`Максимальная высота`,
"c344":`Просмотр проекта с помощью диаграммы Ганта`,
"c1150":`Введите имя очереди и Email, который будет использоваться при отправке уведомлений (например, о постановке дела в очередь). Email может быть не заполнен, и уведомление не будет отправлено.`,
"c1663":`Зона обслуживания Тип работы`,
"c1483":`Пожалуйста, отправляйте после заполнения формы.`,
"c656":`Время обновления`,
"c943":`Япония`,
"c1450":`Общий вид`,
"c1813":`Скриншот`,
"c1490":`Постоянный (для разблокировки требуется администратор)`,
"c1104":`Разъем`,
"front-electronic-signature-outerSinger":`Внешний подписант`,
"front-generate-v1-invoiceDetail":`Детализация счетафактуры`,
"front-electronic-signature-open-vertify":`Пожалуйста, введите код проверки`,
"c1775":`Владелец дела`,
"c291":`Тип персональных данных`,
"c1471":`Часовой пояс Китая`,
"front-setting-phone-message":`Пожалуйста, введите номер телефона`,
"c559":`Эскалированные случаи`,
"c1453":`Отправлять электронные письма членам клуба?`,
"c990":`Синхронизация электронной почты`,
"c1102":`Тип авторизации`,
"label.google.map.cannot.work.normally.please.check.whether.the.secret.key.is.correct":`Карта Google не работает должным образом. Пожалуйста, проверьте правильность секретного ключа!`,
"c259":`Основы обработки данных`,
"c1924":`Разрешено просматривать знания`,
"c1722":`Свойства поля даты`,
"c1065":`Основная этикетка`,
"c1346":`Зависимое от времени срабатывание`,
"c1838":``,
"c488":`Приглашенное время`,
"c6":`Название акции`,
"front-electronic-signature-signerInfo":`Настройка информации о подписантах`,
"c1168":`Стиль навигации`,
"c512":`Члены проекта`,
"c507":`Выращивание свинца`,
"c1385":`Последнее изменение`,
"c760":`Отклонено`,
"c756":`Не отправлять`,
"c321":`Требуется или нет`,
"c817":`Просмотр параметров разрешения меню пользовательской страницы`,
"c949":`Испания`,
"c1133":`Пожалуйста, выберите лицензию`,
"label.biaoqing.field.relation.tip":`Поле для выявления заявок и тендеров`,
"c382":`Скоринговая сеть отношений`,
"c265":`Этот приказ не может быть изменен, так как он еще не вступил в силу`,
"c417":`Сервис Ресурс Работа Информация`,
"c847":`Аккаунты Facebook`,
"c1521":`Стандартные кнопки и ссылки`,
"c494":`Обеспечьте единое управление всеми каналами в CloudCC Marketing Cloud. Создавайте связи и длительное доверие с вашими клиентами, повышайте рентабельность инвестиций с помощью аналитики и превращайте охват в доход.`,
"c86":`Кампания: Редактировать направление сотрудника`,
"c1098":`Обрезать изображение`,
"c1080":`Команда дела`,
"c1138":`Пожалуйста, выберите пользователя (пользователей) для удаления`,
"c776":`Отменить успешно`,
"c709":`Выберите сеть для подключения`,
"label.mobile.orVerificationCode.is.error":`Ошибка номера телефона или кода проверки`,
"c579":`Радарная диаграмма`,
"c1037":`После сброса токена вы не сможете использовать старый токен в приложении API и настольном приложении.`,
"c413":`Статус назначения на службу`,
"c950":`Нидерланды`,
"c1493":`8 персонажей`,
"c1785":`Напоминание о перфорации`,
"c1735":`Диаграмма кейсов по обслуживанию клиентов`,
"c1841":``,
"c1178":`Выберите связанные списки для отображения на макете страницы при наведении (выберите не более 3 связанных списков, слишком большое количество повлияет на макет страницы)`,
"c1236":`Выбор пользователей`,
"c573":`Двумерная гистограмма`,
"label.choose.is.tax":`Выберите тип налога`,
"c768":`Начатое задание по подписанию контракта не выполнено. Пожалуйста, загрузите документ после подписания контракта.`,
"c604":`Адрес для выставления счетов уже существует, сохраните текущий как новый адрес для выставления счетов`,
"c160":`Просроченное лечение`,
"c1158":`Тип интервала указан неверно. Пожалуйста, подтвердите тип.`,
"c239":`Принято`,
"c1210":`Открытая запись`,
"c988":`Текущая запись в книге цен используется и не может быть удалена`,
"c1699":`Электронный забор`,
"c834":`Предварительно пройдено`,
"c113":`Отправить {имя}`,
"c146":`Соответствующие товары будут очищены после изменения валюты. Вы хотите продолжить изменения?`,
"c313":`Отправить файл счетафактуры`,
"c140":`Выберите объект и шаблон`,
"c1311":`Проверка синтаксиса`,
"c298":`Несоответствующий`,
"c1399":`Шаблоны для объединения электронной почты: Редактировать`,
"c681":`Круг`,
"c870":`Вы уверены в пакетном удалении?`,
"c551":`<span style="fontsize: 16px; fontweight: bold; color: #fe8a14"> {days} </span> дней, оставшихся до суда`,
"c1481":`Выберите шаг, чтобы начать редактирование`,
"c88":`Оставшиеся дни в судебном процессе`,
"c1694":`Многоязычный верстак
`,
"c1298":`Направление синхронизации контактов`,
"c1819":``,
"c175":`Не удалось получить подробную информацию`,
"c64":`Открывать или нет {objName}`,
"c319":`Настройка стиля формы`,
"label.pay.online":`Инициировать онлайнплатеж`,
"c941":`Китай  Тайвань`,
"c550":`Пожалуйста, выберите дату начала или дату окончания`,
"c1546":`Пожалуйста, введите формулу условия`,
"c365":`Синхронизация строки предложения с продуктом возможности`,
"c908":`Выберите значок`,
"c260":`Запрос на уничтожение`,
"c1238":`Активировать пользователя`,
"c50":`Налоговая ставка`,
"c869":`Вы уверены, что архивируете все данные`,
"c1468":`Дата начала финансового года не может быть пустой.`,
"c93":`Открывать повторно`,
"c280":`Удалить электронную почту`,
"c1526":`CCChat  это корпоративная социальная сеть, в которой сотрудники могут обмениваться информацией на работе.`,
"c23":`Оплаченная сумма в счетефактуре будет больше суммы заказа, если вы продолжите создавать этот платежный реквизит. Пожалуйста, скорректируйте сумму и сохраните снова.`,
"front-console-v1-see-contacts":`Определил несколько контактов. Пожалуйста, выберите`,
"c607":`Адрес доставки уже существует, сохраните текущий в качестве нового адреса для выставления счетов`,
"c1472":`Электронная почта`,
"c1056":`Пожалуйста, включите полнотекстовый поиск`,
"c1639":`Объекты`,
"c1711":`Пожалуйста, проверьте следующие поля`,
"c1542":`Длина составляет от 1 до 16 символов.`,
"c229":`Удалить веху`,
"front-filter-v1-filter-by-name":`Фильтр по '{имя}'`,
"c125":`В пути`,
"c1952":`Нажмите для поиска`,
"c1679":`Запрос продукта`,
"c513":`Временные листы`,
"c80":`Адрес для выставления счетов`,
"c1833":``,
"c1954":``,
"c1422":`Превышено максимальное количество полей отслеживания (20).`,
"c648":`Разговоры`,
"c521":`Количество заказанных`,
"c560":`Закрытые дела`,
"c973":`Вы прочитали все, что было в вашем почтовом ящике`,
"c1882":``,
"c509":`Упаковочный лист`,
"c685":`Добавить новый адрес`,
"c178":`Формат загруженного изображения не поддерживается. Пожалуйста, загружайте изображения в формате png, jpg и jpeg.`,
"c1003":`Благодаря возможностям совместной работы DingTalk, CCDing помогает вам более полно управлять трафиком частных доменов, отслеживать и управлять полным жизненным циклом отношений с клиентами, а также повышать эффективность работы и прибыльность предприятия.`,
"c436":`Подробности для посетителей`,
"front-electronic-signature-prepareTemplate":`Пожалуйста, свяжитесь с администратором для предварительной установки шаблона договора в системе перед началом подписания.`,
"c749":`Процесс подписания`,
"c1894":`Конкретный пользователь`,
"c114":`Пожалуйста, нажмите кнопку Generate {name}, чтобы сгенерировать {name} перед отправкой.`,
"c1446":`Удаление пользователя из списка Selected Users назначит его на роль, выбранную выше.`,
"c898":``,
"c279":`Продажи`,
"c232":`Не может превышать количество упаковываемых продуктов`,
"c1282":`urlтест`,
"c911":`Отправка отменена`,
"c901":`Количество поданных вами заявок достигло предела.`,
"c1366":`Двойная колонка`,
"c1934":`Создание классификации данных`,
"c663":`Альтернативный текст`,
"c1657":`Заказы на поставку`,
"c541":`Статистика текущего дела`,
"c1584":`Перевод метки поля`,
"c1340":`Выберите условия создания`,
"c536":`Получено`,
"front-project-v1-batch-deletion-confirmation-information":`При пакетном удалении выбранных записей удаляется также вся информация, связанная с выбранными записями, и данные не могут быть восстановлены. Вы уверены, что хотите удалить?`,
"c1809":`Рекомендуемые применения`,
"c1301":`Формула подтверждает истинность`,
"c1318":`Это действие включит рабочий процесс, продолжать или нет?`,
"c893":`Текущий пользователь не может иметь доступ к редактированию поля адреса детализации счета`,
"c623":`Монитор`,
"c1956":``,
"c1198":`Обновление полей позволяет автоматически изменить значение поля на заданное. Обновление полей  это действия, связанные с правилами рабочего процесса и процессом утверждения.`,
"c493":`Формируйте цифровой маркетинг, используйте все возможности`,
"c1557":`Правило обновления кейса: Новый`,
"c1937":`В текущей доступной версии в дополнение к {!language} допускается максимум {!count} языков.`,
"c1377":`Удалить навсегда`,
"c1063":`Китайские символы не могут быть использованы для условий фильтрации`,
"c327":`Иерархия активов`,
"c747":`Ваше общее количество продуктов переполнено. Пожалуйста, сначала удалите некоторые продукты, а затем продолжайте добавлять продукты.`,
"c728":`Конфиденциальность данных`,
"c1423":`Связанный список не может быть пустым.`,
"c1581":`Французский`,
"front-reportlist-v1-optimizedReport":`отчеты оптимизируются после запроса. Пожалуйста, не изменяйте их произвольно.`,
"c1265":`Добавить в профиль`,
"c1143":`Отображаемые поля`,
"c741":`Пожалуйста, заполните содержание письма!`,
"c643":`Подробности в посте`,
"c537":`Среднее время отклика`,
"front-electronic-signature-add-field":`Добавить поле для обратной засыпки`,
"c1574":`Убедитесь, что файл, который вы импортировали, имеет правильный формат кодировки, и если вы не укажете систему, он будет закодирован в UTF8.`,
"c1152":`Чтобы добавить участника в эту очередь, выберите тип участника, затем выберите роль или пользователя из Available Members и переместите его в Selected Members.`,
"c626":`Все пользователи`,
"c199":`Ссылка на форму`,
"c1300":`Новый`,
"c1611":`Импорт данных`,
"c917":`Используйте пул для стимулирования потенциала команды и повышения эффективности контроля за работой аккаунтов. Администратор пула осуществляет единое управление счетами и пакетными назначениями. Сотрудники отдела продаж также могут отбирать потенциальных клиентов и получать последующие запросы.`,
"c1414":`Ошибка формата длины (не может быть 0)`,
"c1773":`Тип дела Название`,
"c1412":`60 мин`,
"c1933":`Управление категориями данных`,
"c159":`Длина заказа не должна превышать максимум`,
"c640":`Расписание Пост`,
"c1001":`Попробуйте настройки интегрированной внутренней системы DingTalk`,
"c192":`Текущий макет страницы:`,
"c978":`Нет информации о счете`,
"c969":`{0} Избранное`,
"c871":`Именно так ваше сообщение будет отображаться на {a}. Возможны незначительные различия, если {a} внесет какиелибо изменения в макет.`,
"c1264":`Результат формулы не соответствует ожидаемому типу данных (true или false).`,
"c814":`1{0} выбран`,
"c1559":`0 мин`,
"c235":`{!ServiceResource.name} Принят заказ. Тема: "{!ServiceAppointment.subject}", Number: "{!ServiceAppointment.name}".`,
"c215":`Ваше сообщение было опубликовано`,
"c425":`Управление назначением услуг`,
"c182":`Невозможно одновременно подключить заказнаряд и историю болезни`,
"c194":`Ограничить количество поданных заявок`,
"c657":`Нет разрешения на эксплуатацию, пожалуйста, свяжитесь с администратором`,
"c1352":`Пожалуйста, заполните форму правильно перед сохранением`,
"c855":`Похоже, ничего не запланировано.`,
"c1204":`ПодсказкаУдалить`,
"c333":`Бюджет Стоимость`,
"c1518":`Запрос не прошел`,
"c1091":`Правило исполнения`,
"c1043":`Сохранить в документе`,
"c338":`Поставщик  Уничтожить`,
"c1421":`Эта страница позволяет выбрать поля для отслеживания в связанном списке Field tracking.
Когда пользователь изменяет любое из выбранных ниже полей, старые и новые значения полей, а также дата, время, измененные свойства и пользователь, внесший изменения, будут добавлены в список отслеживания полей. Примечание: отслеживаются только поля, отображаемые в разделе изменений, а при отслеживании значений полей отображается только "изменено".`,
"c431":`Иерархия кампаний`,
"c374":`Цена Книга Продукт`,
"c506":`Автоматизированное расписание`,
"font-trade-module-invoice-totalMoney":`Итого дебиторская задолженность по счетам`,
"c203":`Распространяйте свои формы через Mailchimp`,
"c962":`{месяц} {год}`,
"c786":`Номер телефона/почтовый ящик`,
"c1487":`Должны содержать прописные и строчные буквы и цифры`,
"c469":`Страница находится в состоянии редактирования. Текущие данные не могут быть сохранены, если вы покинете страницу`,
"c137":`Выберите шаблон для формы`,
"c993":`Хранение данных (все объекты)`,
"c1905":`Инструкции по эксплуатации:`,
"c483":`Информация о кампании`,
"c1396":`Шаблон для объединения писем: Новый`,
"c1876":``,
"c947":`Франция`,
"c190":`Валюта элементов оплаты должна соответствовать валюте заказа, счета и платежа. Пожалуйста, уточните валюту и сохраните снова.`,
"c386":`Выполнено`,
"c803":`Счета: Все счета`,
"c1119":`Пожалуйста, заполните форму полностью перед сохранением`,
"c759":`Для заполнения`,
"c1917":`Фильтр связанных объектов`,
"c1678":`Правила работы`,
"c823":`Установление порядка`,
"c1187":`Список вебхуков`,
"c1498":`Выберите значок для своих инструментов. Рекомендуемый размер  x px*y px.`,
"c422":`Метод формирования назначений на обслуживание`,
"c1686":`Знания`,
"c1326":`Действие удалит этот временной триггер. Продолжить?`,
"c782":`Как принять участие`,
"c1461":`При удалении пользователя из списка избранных пользователей ему будет назначена роль, выбранная выше.`,
"c416":`Отчет об обслуживании Запись нажатия`,
"c1494":`Назовите свои инструменты, чтобы пользователям было легко понять их функции. Названия отображаются в нижнем колонтитуле приложения.`,
"c758":`Принято`,
"c407":`Член обслуживающего экипажа`,
"c51":`Новый налог`,
"c844":`Привязать учетную запись DocuSign`,
"c1086":`Стратегия кандидата`,
"c361":`Меню редактирования`,
"c602":`Матричная диаграмма`,
"c1257":`Установите редактор макетов`,
"c191":`Требуется разрешение на редактирование текущего представления`,
"c299":`Выберите хотя бы один объект`,
"c432":`История кампании`,
"c650":`Опубликуйте новое сообщение, чтобы начать новую беседу`,
"c1038":`Сброс маркера безопасности`,
"c1721":`Свойства поля сводной таблицы сворачивания`,
"c1681":`Объекты`,
"c531":`Количество принятых дел`,
"c13":`Текущий пользователь не имеет права редактировать`,
"c162":`Одновременно информировать цедента и цессионария`,
"c1620":`Налоговые настройки`,
"c1182":`Пожалуйста, введите уникальное имя.`,
"c1045":`Сохранить и скачать`,
"c992":`Хранение файлов`,
"c1307":`Поведение при конфликте задач: CloudCC.com всегда предпочтительнее`,
"c171":`Владение акциями`,
"c230":`Удалить задачу`,
"c470":`Автозаполнение полей`,
"c367":`Генерировать контракт`,
"c1338":`Не`,
"c26":`Установить скидку`,
"c1517":`Требуемые элементы не могут быть пустыми`,
"c989":`Прогнозы Руководство пользователя`,
"c1424":`Используйте эту страницу для определения всех валют, используемых в вашей организации.
Валюта компании должна быть установлена на валюту, используемую головным офисом компании для отчетности о доходах.
Если вы укажете другую валюту в качестве валюты компании, все обменные курсы будут изменены, чтобы отразить это изменение.`,
"c1314":`Это действие приведет к окончательному удалению данного рабочего процесса. Продолжить?`,
"c705":`Опубликованные сообщения`,
"c1949":`Предыдущий пользователь`,
"c613":`Внешняя страница`,
"front-electronic-signature-openSign":`Начать подписывать`,
"c349":`Перетаскивание`,
"c683":`Загрузка Подробнее`,
"c1253":`1. Раскладка строк: раскладка, отображаемая при применении к ведущемуведомому входу переднего плана и пакетному добавлению`,
"c679":`Серый`,
"c1741":`Получить информацию о пользователе`,
"c1386":`Редактирование свойств поля`,
"c914":`Свернуть боковую панель`,
"c1725":`Свойства отношения поиска (мультивыбор)`,
"c1585":`Проверьте уровень мастерства`,
"c224":`Перейти к вехам`,
"c220":`Ваше сообщение было опубликовано неудачно`,
"c498":`CloudCC Inventory эффективно поддерживает онлайн и офлайн омниканальный бизнес, реализуя движение и управление товарами и средствами. Многочисленные модули эффективно сочетаются, и пользователи могут достичь совершенного управления заказами для создания взаимовыгодных ситуаций с партнерами.`,
"c566":`Автоматическое получение адреса учетной записи после сохранения`,
"c1978":``,
"front-electronic-signature-ContractTemplate":`Выберите шаблон договора`,
"c1976":``,
"c1951":`Короткая заметка`,
"c540":`Решение проблемы времени по каналам`,
"c793":`Шаблоны документов`,
"c293":`Настройка объектов для обеспечения соответствия требованиям GDPR`,
"front-invoice-online-pay-again":`Вы уже инициировали онлайнплатеж. Пожалуйста, не пытайтесь сделать это снова.`,
"front-electronic-signature-open-password":`Пожалуйста, введите пароль`,
"front-v1-partner-background-tooltip":`Поддерживается файл размером не более 2М. Рекомендуется загружать четкие изображения.`,
"c449":`История чата`,
"c30":`Классика`,
"c1195":`Уведомить назначающее лицо`,
"c1497":`5 раз`,
"c1645":`Параметры оценки сети взаимоотношений`,
"c245":`{!oldServiceResource.name} передал заказ на работу с номером {!ServiceAppointment.name} в {!newServiceResource.name}`,
"c923":`Вот ваша команда`,
"c24":`Показать карту`,
"c1712":`Шаг 1: Выберите одно управляющее поле и зависимое поле. Нажмите кнопку Продолжить после завершения.`,
"c872":`Имя (незаполненное)`,
"c886":`Открыть боковую панель`,
"c1074":`Предварительное определение команды дела`,
"c1259":`Пожалуйста, выберите шаблон для электронного письма`,
"c1820":`Суффикс URL`,
"c1068":`Отставание от квоты`,
"c1596":`С учетом регистра`,
"c1389":`Встроенная пользовательская страница Lightning Detail page`,
"c1892":``,
"c1435":`Пожалуйста, введите название макета страницы`,
"c485":`Название формы:`,
"c1554":`Замена удалась`,
"c1780":`Новый процесс утверждения`,
"c101":`шт.`,
"c1883":``,
"c816":`Посмотреть сообщение`,
"c1814":``,
"c1652":`Внешние контакты DingTalk`,
"c445":`Роль проекта`,
"c1911":`Скачать шаблон`,
"c1677":`Каталог отчетов о расходах`,
"c1046":`Пожалуйста, выберите тип файла!`,
"c1429":`Установить разрешения`,
"c1094":`Когда`,
"c1004":`CCDing обладает мощными возможностями настройки CloudCC и может быстро и гибко конфигурировать расширения в соответствии с индивидуальными потребностями вашего бизнеса.`,
"c1035":`К сожалению, у вас нет текущих полномочий на управление. Пожалуйста, свяжитесь с администратором!`,
"c1267":`Вариант 1`,
"c1653":`Контакт WeCom`,
"c853":`Здесь отображается количество лайков и комментариев к опубликованным вами постам.`,
"c398":`Начать сейчас`,
"c522":`Количество выставленных счетов`,
"c1763":`Процессор регистрации`,
"c287":`Соответствие требованиям`,
"c578":`Числовая диаграмма "м/м и г/г`,
"c40":`Пожалуйста, введите пароль`,
"c631":`Посмотреть в Twitter`,
"c489":`Время деактивации`,
"c819":`Номер телефона/почтовый ящик`,
"c1380":`Примечание: Все поля в этом разделе будут перемещены в раздел Неиспользуемые элементы.`,
"c935":`Тип формы`,
"c625":`Все кампании`,
"c471":`Кампания: Направление сотрудников`,
"front-electronic-signature-writen":`Заполненный`,
"c1148":`Разрешения объектов`,
"c1015":`Параметры формата, определяемые пользователем`,
"c889":`Успешная деактивация учетной записи пользователя`,
"c201":`Поделитесь этой формой в своих социальных сетях`,
"c467":`Поле сортировки пустое`,
"label.mobile.no.null":`Номер телефона не может быть пустым`,
"c307":`Право собственности`,
"c1796":`Первые 5 кнопок закреплены внизу. Доступ к другим кнопкам можно получить в разделе "Еще".`,
"c1489":`Инструменты нижнего колонтитула закреплены внизу.`,
"c1019":`Добавьте параметры заголовка (например, ключи API, токены и т.д.).`,
"c1163":`Визитная карточка скрыта, поэтому не может быть персонализирована.`,
"front-kefu-moudle-wait-calling":`Звонок в процессе, пожалуйста, повторите попытку позже`,
"c784":`Пожалуйста, укажите название компании, указанное в лицензии на ведение бизнеса`,
"c490":`Время последнего входа в систему`,
"c790":`Собственноручная подпись`,
"c336":`Свинец  уничтожить`,
"c453":`Домашняя страница Канбан`,
"c1157":`Если тип интервала  час, интервал должен быть больше или равен 1 часу и меньше или равен 23 часам.`,
"c1738":`Суффикс`,
"c1760":`Количество имен файлов не соответствует количеству загруженных фотографий!`,
"c1177":`Параметр оператора "{! parameter.type1}" имеет неправильный тип.
Ожидалось {! parameter.type2}, а получено {! parameter.type3}`,
"c1960":``,
"c1765":`Можно загрузить не более {n} файлов.`,
"c1013":`Параметры стандартного формата`,
"c1083":`Имя не может быть пустым`,
"c1208":`Учетная запись онлайнчата не активирована. Пожалуйста, сначала включите функцию чата.`,
"c530":`Пожалуйста, сначала настройте почтовый ящик компании`,
"c1268":`Вариант 2`,
"c610":`Значок будет ссылаться на основной домен, если вы не указали URLадрес`,
"c359":`График`,
"c1438":`Пожалуйста, выберите макет страницы`,
"c1279":`● Чтение/запись  пользователи могут просматривать и перезаписывать данные прогноза`,
"c193":`Ограничения`,
"label.mobile.verificationCode.exceeded.times":`Количество повторных запросов превышено. Пожалуйста, запросите еще раз`,
"c138":`Шаблон компании`,
"c821":`Новые внутренние контакты`,
"c381":`Запрос на оплату онлайн`,
"c1590":`Разрешено ли повторение`,
"c1484":`Должны содержать прописные и строчные буквы, цифры и символы`,
"c761":`Подпись`,
"c1370":`Некоторые имена`,
"c964":`Поле связи мастердеталь является обязательным`,
"c585":`Карта Соединенного Королевства`,
"c500":`Предоставляйте универсальные решения по обслуживанию клиентов с помощью стандартизированных процессов и эффективного управления, координируйте сервисные ресурсы для обеспечения наилучшей поддержки ваших клиентов.`,
"c1502":`Ширина панели в пикселях (Диапазон вводимых значений: 11920px)`,
"c214":`Включите растровые изображения трех размеров и векторную графику во всех форматах`,
"c714":`Планируйте публикацию постов в нужное время.`,
"c1341":`Установите флажок, чтобы включить проверку промышленных и коммерческих данных. Когда пользователи вводят информацию о клиенте предприятия, они могут помочь пользователям ввести правильную промышленную и коммерческую регистрационную информацию клиента.`,
"c1718":`Он уже был отправлен на {0} и не может быть отправлен повторно.`,
"c1044":`Загрузить в документ`,
"c1846":``,
"c1789":`Присутствующий персонал`,
"c552":`Отклонено`,
"c684":`{sumTotalCount} больше`,
"c54":`Пожалуйста, заполните тип налога`,
"c320":`Выберите поля формы`,
"c1008":`Копирование информации о продукте`,
"c236":`{!ServiceResource.name} принят заказ. Счет: "{!ServiceAppointment.accountid.name}", Номер: "{!ServiceAppointment.name}".`,
"c1592":`Свойства поля автонумерации`,
"c1588":`Значение не может быть ключевым словом базы данных`,
"c1901":``,
"c123":`Информация о логистике`,
"c654":`Назад к списку приборных панелей`,
"c1442":`Чтобы назначить других пользователей на эту роль`,
"c1779":`Общий размер фотографий не может превышать 20М.`,
"c1363":`Некоторые из названий представлены на сайте`,
"c335":`Маржа прибыли`,
"c267":`Не удалось зафиксировать изменения, так как критерий не выполнен`,
"c1818":``,
"c1803":`Пожалуйста, введите URL`,
"c226":`Перейти к подзадаче`,
"c102":`Нажмите один раз`,
"c637":`Сохранить как черновики`,
"c1336":`Конечный персонаж`,
"c633":`Создавайте новые социальные посты`,
"c1103":`Обычный`,
"c777":`Настройка информации об участнике`,
"c223":`Добавить в проект`,
"c592":`Диаграмма водопада`,
"c1714":`Выбор модулей, отвечающих требованиям бизнеса, на основе реальных сценариев`,
"c1439":`Нечего спасать`,
"c1402":`Значение категории прогноза не может быть пустым.`,
"c315":`Только действующие заказы могут генерировать счетафактуры`,
"c89":`Email Название мероприятия`,
"c108":`Автомат успешно`,
"c1507":`180 дней`,
"c402":`Поле`,
"c748":`Пожалуйста, выберите прайслист для {название}. Вы можете добавлять продукты только из одного прайсбука. Изменение выбранного прайслиста приведет к удалению всех существующих продуктов.`,
"c1293":`После настройки учетной записи службы с разрешениями на имперсонацию для пользователя в Microsoft Exchange введите учетные данные учетной записи службы, чтобы CloudCC мог взаимодействовать с сервером Exchange.
Если вы сохранили учетные данные учетной записи службы, но пользователь попрежнему не может синхронизировать записи, убедитесь, что вы правильно настроили Exchange Sync.`,
"c1625":`Канал связи`,
"c501":`Обеспечьте качественное полевое обслуживание своих клиентов`,
"c1877":``,
"c269":`Не удалось объединить информацию`,
"front-electronic-signature-open-confirm":`Привязать счет`,
"c584":`Карта Соединенных Штатов`,
"c437":`Неудачный`,
"c738":`Дата отправки`,
"c274":`У вас истек срок приема заказа, и отправка отменена. Номер: {0}. Нажмите, чтобы увидеть больше >`,
"c83":`Данные поиска`,
"c206":`Формат PNG`,
"c1903":`Как создавать файлы Word`,
"c309":`Отправить файл заказа`,
"c1899":``,
"c539":`Наибольшая доля источников`,
"c304":`Основные интересы`,
"c1835":``,
"c1413":`Метка поля не может быть пустой`,
"c1348":`URL расширенного интерфейса`,
"c1452":`Метка очереди`,
"c1064":`Защищенные компоненты`,
"c151":`Кратко опишите основное содержание формы`,
"c1912":`Просмотр шаблонов для различных объектов (Поддерживается загрузка)`,
"c1294":`Конфигурации синхронизации Exchange`,
"c639":`Отправить сейчас`,
"c1401":`Значение списка опций не может быть пустым`,
"c1535":`Правила подсчета баллов, используемые для настройки пятизвездочной диаграммы контактов на диаграмме структуры контактов с клиентами`,
"c720":`Нет, спасибо`,
"c1913":`Скачать шаблоны Word`,
"c801":`Новые контакты`,
"c900":`Информация об адресе посетителя отсутствует, поэтому расстояние до места регистрации не может быть рассчитано.`,
"c1669":`Расходные материалы`,
"c1069":`Роли команды по ведению дела`,
"c695":`Оригинальный размер`,
"c864":`Выберите форму`,
"c1443":`Выберите из списка для просмотра доступных пользователей`,
"c881":`Я прочитал и согласился`,
"c794":`Шаблон для подписи`,
"c543":`Полученные оценки`,
"c1400":`Управляющее или зависимое поле не может быть пустым`,
"c1217":`Конфигурация меню пользовательских компонентов`,
"c466":`Только заказы, использующие одну и ту же книгу цен, могут генерировать счетфактуру`,
"c1783":`Кроме того, когда запись находится в процессе утверждения, она всегда заблокирована и может быть отредактирована только администратором. Однако вы можете разрешить редактирование этой записи назначенному в данный момент утверждающему лицу.`,
"c867":`{имя пользователя} получит приглашение по электронной почте, в котором будет предложено создать пароль для доступа к вашему Справочному центру.
Продолжить?`,
"c1185":`2 цикла`,
"c529":`Нет доступных способов пополнения, пожалуйста, свяжитесь с администратором`,
"c2079":``,
"c742":`Можно выбрать максимум 4 изображения, каждое из которых не может превышать 200K. Нажмите на изображение для выбора.`,
"c430":`Срок выполнения поиска`,
"c1180":`Смежные роли`,
"c553":`Время последнего приглашения`,
"c575":`Колоночная диаграмма`,
"c124":`Доставка ожидается`,
"c1664":`Стратегия планирования Правила работы`,
"c1525":`Поле Lead связано с полем Campaign Member.`,
"c629":`Неудачный`,
"c554":`Время первого приглашения`,
"c547":`Последние 7 дней`,
"c1682":`Записи о времени`,
"c1368":`Заголовок виден только на странице редактирования`,
"c599":`Настольная таблица`,
"c588":`Карта Канады`,
"c703":`Через сайт`,
"c1357":`Выберите дату окончания`,
"c1031":`Добавьте хотя бы один продукт`,
"c713":`Создавайте социальные посты из CloudCC.`,
"c142":`Это действие, которое будет выполнено после того, как посетитель отправит форму на вашем сайте`,
"c1111":`Уведомления URL`,
"c153":`После очистки товаров, связанных с текущей записью, вы можете изменить валюту.`,
"c1942":`Мобильный URL`,
"c1431":`Используйте эту страницу для создания различных макетов страниц для отображения пользовательских данных.
После создания макета страницы нажмите кнопку Назначение макета страницы, чтобы контролировать, какой макет страницы пользователь видит по умолчанию.`,
"c253":`Соблюдение требований GDPR`,
"c1479":`Ошибка в формуле. Пожалуйста, проверьте!`,
"c1313":`Ошибка: проверка усложнения правила не удалась. Пожалуйста, проверьте синтаксис.`,
"c1771":`Заявка на обслуживание, поданная через вебсайт, может генерировать записи дел в системе, где вы можете настроить страницу Заявки на обслуживание. Вебстраницы для компьютеров и мобильных телефонов`,
"c1079":`Члены команды дела`,
"c612":`Внутренняя страница`,
"c1382":`Очистить расширенный фильтр`,
"c1716":`Будет принят`,
"c400":`Расположение сервисных ресурсов`,
"c1176":`Отменить обязательные поля`,
"c1398":`Нажмите, чтобы загрузить`,
"c671":`Икона и слово`,
"c1227":`Выберите пользователей`,
"c20":`Не может превышать количество, которое должно быть выставлено в счете по связанному заказу.`,
"c514":`Графики отчета`,
"c1055":`Параметр RequestBody не в формате json`,
"c946":`Великобритания`,
"c1635":`Правила использования QRкодов активов`,
"c1506":`90 дней`,
"c1351":`Создав учетную запись Nexmo API, пользователи могут получить доступ к учетным записям Vonage API на платформе CloudCC для отправки и получения текстовых сообщений.`,
"c1719":` Интеграция DingTalk`,
"c717":`Новая почта`,
"c1308":`Поведение при конфликте задач: Обмен всегда предпочтительнее`,
"c174":`Все отредактировано успешно`,
"c1330":`Список с несколькими вариантами выбора`,
"c1465":`Часовой пояс Марса`,
"c940":`Китай  Гонконг`,
"c1553":`Адрес электронной почты владельца записи`,
"c743":`Пожалуйста, введите действительные цифры`,
"c1232":`Выберите пользователей, показанных в списке Available User List, чтобы назначить их на роль CEO`,
"c1940":`Требуется URL на компьютере/URL на мобильном устройстве.`,
"c2085":``,
"c1963":``,
"c441":`Умный бизнес и финансовое управление`,
"c1794":`Процесс таймаута`,
"c1910":`3. Загрузка шаблонов комбинирования электронной почты: Загрузка файлов Word после изменения шаблонов Word в автономном режиме`,
"c1406":`Пожалуйста, загрузите файлы`,
"c1197":`Другие электронные письма`,
"c423":`Диспетчерская платформа`,
"c723":`Подтвердить запрос на уничтожение`,
"c664":`Нет социальной сети`,
"c1071":`Замена ролей для команды по ведению дела`,
"c859":`Пожалуйста, введите {0}`,
"c356":`Планируемая стоимость`,
"c221":`Перейти к проекту`,
"c1225":`Значок на компьютерах`,
"c1906":`Пропустить инструкции?`,
"c1569":`Ваш запрос на экспорт был обработан, пожалуйста, проверьте свой Email.`,
"c1339":`Выберите объект для создания шаблона`,
"c1837":`Пожалуйста, введите суффикс URL`,
"front-email-payment-Invoice-Tips1":`Пожалуйста, свяжитесь с администратором, чтобы включить WeChat, Alipay, PayPal или VISA, а затем инициировать онлайноплату`,
"c99":`Количество продуктов`,
"c278":`Хотите ли вы удалить следующие письма?`,
"c364":`Линия цитат`,
"c572":`Выбранные поля не могут быть пустыми, пожалуйста, добавьте поле (поля)`,
"c2080":``,
"c310":`Создать файл заказа`,
"c247":`Переведено`,
"c158":`Назначить временной порог`,
"c325":`Шаблон уведомления о назначении дела`,
"c1600":`Свойства поля геолокации`,
"c985":`Сеть отключена. Пожалуйста, проверьте сетевое подключение`,
"c1277":`Новый набор списков глобальных опций`,
"c877":`Заполнение Не упорядоченное`,
"c1364":`Расположение колонок`,
"c1564":`Свойства поля флажка`,
"front-filter-v1-press":`Нажмите`,
"c505":`Отслеживание посетителей`,
"c523":`Добавить в качестве пользователя портала`,
"c727":`Успешное уничтожение данных`,
"front-electronic-signature-sended":`Отправлено`,
"c150":`Пожалуйста, заполните необходимую информацию`,
"c700":`ВРЕМЯ ПОСЛЕДНЕГО ОБНОВЛЕНИЯ`,
"c1325":`WeCom  Минипрограмма H5`,
"c1263":`Зависимости полей: Редактирование`,
"c1700":`Радиус действия электронного ограждения`,
"c824":`Войти в систему`,
"c710":`Один дом для управления всеми вашими социальными сетями`,
"c1320":`Проверка формы не удалась на текущем шаге, пожалуйста, проверьте перед следующим шагом`,
"c1130":`Редактирование обменного курса между валютами, используемыми вашей организацией, и другими валютами`,
"c1610":`Свойства поля валюты`,
"c358":`Бюджет`,
"c1537":`Введите количество посещений пользователя, а показатель количества посещений рассчитывается по правилам.`,
"c1530":`Новая схема размещения основной информации`,
"c1968":``,
"c544":`Каналы`,
"c1211":`Стандартный стиль`,
"c212":`Формат SVG`,
"c1255":`3. Макет мобильной страницы: применяется к макету малых вебстраниц Wechat и отображению мобильной версии`,
"c165":`Пожалуйста, введите целочисленное значение от 024`,
"c1081":`Команда`,
"c1922":`Поддержка файлов размером до 5 МБ`,
"c1463":`Часовой пояс США`,
"c1583":`Испанский`,
"c1415":`Ошибка формата длины`,
"c932":`Спам`,
"c888":`Успешная активация учетной записи пользователя`,
"c838":`Оператор`,
"c98":`Категория продукта`,
"c830":`СОЗДАН`,
"c661":`Сеть`,
"c1073":`Дело Роль для замены`,
"c1509":`пароль(и)`,
"c818":`Настройки меню пользовательской страницы`,
"c861":`Выберите на карте`,
"c736":`Posted By`,
"c204":`Стандарт`,
"c1962":``,
"c1753":`При запуске можно установить максимально допустимую длину заказа и режим таймаута постобработки.`,
"c1563":`Свойства поля адреса`,
"c1709":`Выключен: по умолчанию он не отображается на домашней странице всех членов организации. Пользователи могут открыть модуль через "настройку моей домашней страницы" на мобильной стороне.`,
"c1049":`Генерация не удалась. В настоящее время для генерации PDFфайлов поддерживаются только шаблоны типа docx.`,
"c1961":``,
"c1123":`При создании или редактировании записей`,
"c839":`Похоже, ничего не запланировано.`,
"c1473":`Новые правила назначения`,
"c456":`Оплаченная сумма`,
"c1697":`Новый пакет программного обеспечения`,
"c1151":`Если выбрана опция Send Email to Members, члены очереди будут получать уведомления о назначении объектов в очередь, а опция Don't Notify не будет выбрана.`,
"c341":`Заключительные счета`,
"c1281":`Выставленные изделия`,
"c724":`Подтвердите уничтожение данных`,
"c1017":`Описание значения`,
"c1668":`Регион пользователя`,
"c1943":`Достигнуто максимальное количество статей. Пожалуйста, свяжитесь с администратором для обновления.`,
"c865":`Я прочитал и согласен с {0} и {1}`,
"c1193":`3 цикла назад`,
"c1744":`Пользовательский класс обработки регистрации`,
"c1142":`Условия фильтрации`,
"c1164":`Снять, чтобы настроить отображение на странице подробностей.`,
"c332":`Сумма не может превышать заказ, на который выставляется счет`,
"c520":`Платеж не прошел. Недостаточно доступной скидки`,
"c906":`Минус`,
"c1174":`Настроить параметры`,
"c482":`Назовите своего компаньона:`,
"c49":`Обновление настроек безопасности домена`,
"c1290":`Список кандидатов`,
"c725":`Успешно отозвать запрос на уничтожение`,
"c76":`ОПЛАТА`,
"c1622":`Поставщик идентификационных данных`,
"c1331":`Не пустой`,
"c1134":`Пожалуйста, выберите набор разрешений`,
"c558":`Дела в режиме ожидания`,
"c1884":``,
"c1690":`История пополнения`,
"c876":`Знак Непорядок`,
"front-invoices-v1-nofilles-tocreate":`Пожалуйста, нажмите кнопку Generate Invoice, чтобы сформировать счетфактуру и затем отправить его.`,
"c779":`Крайний срок подписания`,
"c1095":`Добавить еще один вариант`,
"c603":`Двухосный график MoM&YoY`,
"c1527":`Настройки CCChat`,
"c1752":`Порог продолжительности заказа`,
"c1093":`Когда условия не выполняются`,
"c1144":`Видимость`,
"c1203":`Сначала выберите данные, которые необходимо передать.`,
"c1496":`10 раз`,
"c455":`Цель контракта`,
"c1766":`Нажмите здесь или перетащите файл сюда, чтобы прикрепить его`,
"c1731":`Диспетчер не справился`,
"c428":`Диспетчер в режиме карты`,
"c55":`Пожалуйста, заполните налоговую стоимость`,
"c1604":`Представленные изображения`,
"c899":`Расстояние регистрации`,
"c1887":``,
"label.facebook.title":`FacebookH5 MiniApp`,
"c487":`Имя получателя:`,
"label.social.posts.info":`Содержание сообщения не найдено`,
"c704":`Аудитория`,
"c1005":`Для использования CCDing, пожалуйста, свяжитесь с нами.`,
"c673":`Вебизображение`,
"front-electronic-signature-singed":`Подписание начато`,
"c722":`Подключен 1 счет`,
"c595":`Диаграмма территории`,
"c1886":``,
"c1054":`В этом шаблоне нет содержимого. Пожалуйста, сохраните после установки шаблона.`,
"c1344":`Редактирование рабочего процесса`,
"c120":`тип(ы)`,
"c68":`Платежное поручение`,
"c479":`CloudCC Forms Mailchimp`,
"front-electronic-signature-explain-mainTitle":`Электронная подпись и штамп`,
"c5":`Налог`,
"c1022":`Посмотреть PDF`,
"c976":`Утверждать и планировать посты {0}`,
"c812":`КОММЕНТАРИИ`,
"c532":`Количество случаев отдыха`,
"c330":`Статья контракта`,
"c1296":`Новые правила`,
"c249":`пост выходит сейчас`,
"c630":`Посмотреть на LinkedIn`,
"c1160":`Первое время выполнения  #time, а затем каждый #number час(ов).`,
"c1356":`Выберите дату начала`,
"c958":`Post Like ID не может быть пустым`,
"c1378":`Переход к невыбранным полям`,
"c170":`Не удалось создать данные с идентификатором записи {0}, причина неудачи: {1};`,
"c810":`REPLIES`,
"c783":`Требования к подписи`,
"c968":`Отключить`,
"c752":`Инициировать задачу подписания`,
"c1040":`Мы отправили новый маркер безопасности на адрес электронной почты клиента {0}.`,
"c439":`Посетитель`,
"c1002":`Приложение CCDing  это интегрированное решение для маркетинга, продаж и услуг, созданное на базе платформы CloudCC и DingTalk.`,
"c1470":`Обязательные поля не заполнены.`,
"c1184":`Конфигурации вебхуков`,
"c1707":`Вы можете отключить или отключить компоненты, не относящиеся к бизнесу предприятия, из конфигурации по умолчанию`,
"c67":`Отправить заказ успешно!`,
"front-generate-v1-invoice":`Сгенерировать счетфактуру`,
"c477":`Вы должны авторизоваться в своей учетной записи Mailchimp. Пожалуйста, нажмите кнопку "Authenticate Mailchimp", и вы будете перенаправлены в Mailchimp для отправки кампаний.`,
"c1315":`Поведение в контактном конфликте`,
"c966":`Пожалуйста, свяжитесь с администратором`,
"c1726":`Свойства процентного поля`,
"c764":`Отклонено`,
"c301":`Можно ввести до 200 символов`,
"c1027":`Пожалуйста, проверьте правильность пары ключей или их деактивацию`,
"c61":`Пожалуйста, сначала откройте Знание, а затем используйте его`,
"c815":`Архив все`,
"c827":`У вас есть несохраненные изменения на этой странице, которые будут потеряны, если вы продолжите.`,
"c1460":`Выберите пользователя слева и добавьте его в список Избранные пользователи`,
"c688":`Максимальная ширина`,
"c1693":`Настройки интеграции DingTalk`,
"c1692":`Действие`,
"c1939":`В текущей версии поддерживается максимум {!count} статей.`,
"c1237":`Пожалуйста, выберите статус`,
"c33":`Редактировать тип подписки`,
"c217":`post is going out {date}`,
"c721":`Отключить учетную запись`,
"c284":`Обработка запросов данных от клиентов в CRM`,
"c1273":`Видимость меню`,
"c939":`Китай  Макао`,
"c503":`Следите за ходом реализации проекта`,
"c1090":`Выбор по условиям`,
"c1800":``,
"c492":`Приглашенные`,
"c1428":`Отметить по мере необходимости`,
"c73":`Текущий баланс`,
"label.the.peoples.republic.of.china":`Китайская Народная Республика`,
"c828":`ПОСТ`,
"c36":`Предварительный просмотр`,
"c954":`Новый номер телефона`,
"c1504":`30 дней`,
"c1520":`Ниже приведен список кнопок и ссылок. Чтобы добавить кнопку или ссылку, отредактируйте макет страницы.
Кнопки можно отображать на странице сведений, связанных списках и представлениях списков:
1. Чтобы настроить кнопки или ссылки на странице сведений, отредактируйте макет страницы.
2. Чтобы настроить кнопки или ссылки в связанном списке, отредактируйте свойства связанного списка, где он отображается на макете страницы.
3. Чтобы настроить кнопки или ссылки в представлении списка, отредактируйте макет представления списка в макете поиска.`,
"front-electronic-signature-innerSinger":`Внутреннее подписавшее лицо`,
"c1457":`Выберите из списка, чтобы просмотреть доступных пользователей.`,
"c508":`Анализ рентабельности инвестиций`,
"c833":`Сертификация пройдена`,
"c1872":`Поддомен`,
"c1804":``,
"c1212":`На этой странице можно выполнить пакетное удаление записей.`,
"c207":`Векторный формат`,
"c1441":`Используйте эту страницу для определения всех валют, используемых в вашей организации.
Валюта компании должна быть установлена на валюту, используемую головным офисом компании для отчетности о доходах.
Если вы укажете другую валюту в качестве валюты компании, все обменные курсы будут изменены, чтобы отразить это изменение.`,
"c31":`Полуэкран`,
"c71":`Пожалуйста, выберите способ оплаты`,
"c1061":`Пост`,
"c373":`Стандартный справочник цен`,
"c545":`Время решения (ч)`,
"c77":`Модуль настройки`,
"label.lastcompiledate":`Время последней компиляции`,
"c1216":`Не загружено`,
"c119":`Подтвердить получение`,
"c1047":`Пожалуйста, выберите способ сохранения файла!`,
"c281":`Обработка данных`,
"c1713":`Шаг 2: На странице ниже отредактируйте условия фильтрации, которые управляют значениями, появляющимися в зависимом поле для каждого значения в поле управления`,
"c1332":`Пустой`,
"c1189":`5 циклов`,
"c715":`Отслеживайте упоминания бренда и быстро реагируйте на них.`,
"c1347":`Периодический временной триггер`,
"c127":`Управление колонками`,
"c1500":`Ширина панели`,
"c1391":`Поля, которые управляют фильтрацией, называются управляющими полями.
Стандартные и пользовательские флажки и списки опций с хотя бы одним значением и менее 300 значений могут быть полями управления`,
"c1173":`Невозможно отобразить предварительный просмотр списка`,
"c283":`Запрос данных`,
"c1464":`Часовой пояс Великобритании`,
"c919":`Используйте пул для стимулирования потенциала команды и повышения коэффициента конверсии лидов. Администратор пула осуществляет единое управление лидами и пакетными назначениями. Сотрудники отдела продаж также могут отбирать лиды и получать последующие запросы.`,
"c1979":``,
"c82":`Только для молнии`,
"front-file-delete-intro":`Файл был удален`,
"c1634":`Удовлетворенность клиентов`,
"c1213":`Консольный стиль`,
"c606":`Адрес доставки по умолчанию`,
"c1250":`Вы уверены, что хотите удалить этот макет?`,
"c1474":`Имя правила не может быть пустым`,
"c1732":`Не удалось выполнить распределение`,
"c905":`Добавить`,
"c644":`ПУБЛИКУЕМОЕ ВРЕМЯ`,
"c1560":`Нужно ли включать команду`,
"c75":`Баланс возврата`,
"c1026":`Пожалуйста, проверьте, обновлен ли маркер безопасности пользователя`,
"c1586":`Свойства поля формулы`,
"c884":`Политика конфиденциальности`,
"c538":`Среднее время решения`,
"c322":`Новый счетфактура`,
"c1140":`Имя набора разрешений`,
"c1135":`Назначение пользовательских страниц`,
"c1167":`В визитную карточку можно добавить до 10 полей.`,
"c461":`Тенденция платежей`,
"c825":`Предприятия`,
"c56":`Общая сумма дебиторской задолженности по счетам и сумма дебиторской задолженности не совпадают. Пожалуйста, заполните еще раз.`,
"c931":`Вы не включили переключатель позиционирования сотрудников и не можете использовать интервал совместного использования местоположения. Продолжить?`,
"c1981":``,
"c1673":`Временной интервал`,
"c276":`Обеспечение соответствия требованиям GDPR`,
"c334":`Бюджет Сумма`,
"c733":`Кампания: Новый плакат`,
"c1146":`Применять к мобильному терминалу?`,
"c384":`Новый список упаковки`,
"c139":`Шаблон собрания`,
"c1908":`Просмотр записей DNS`,
"c1576":`Уже добавлено`,
"c1568":`Уже существующие`,
"c957":`Идентификатор комментария не может быть пустым`,
"c1060":`Пункт заказа на поставку`,
"front-electronic-signature-nosign":`Ваша организация не выбрала ни одного поставщика услуг электронной подписи. Пожалуйста, свяжитесь с администратором, чтобы включить эту услугу.`,
"c1411":`20 мин`,
"c1050":`Сгенерировано успешно. Документ сохранен в списке файлов`,
"c419":`План технического обслуживания`,
"c1230":`На этой странице перечислены пользователи, роли и области, которые имеют общий доступ к CEO`,
"c934":`Название преобразования`,
"c1020":`1. После включения прайсбука система будет генерировать один стандартный прайсбук, содержащий все продукты по умолчанию.`,
"c677":`Выровненный по правому краю`,
"c593":`Линейная диаграмма`,
"c272":`{0} имеет таймаут в приеме заказа. Счет: {1}, Тема: {2}, Номер: {3}. Нажмите, чтобы увидеть больше >`,
"c1742":`Пользовательские страницы ошибок`,
"c811":`RETWEETS`,
"c451":`Раздельный корпус`,
"c277":`После удаления письма следующие письма также будут удалены и не будут отправляться последующим контактам. Это необратимо.`,
"c244":`{!ServiceResource.name} отклонил заказ. Номер: "{!ServiceAppointment.name}"`,
"c627":`Опубликовано`,
"c1862":`URLадрес предварительного просмотра`,
"c1578":`Японский`,
"c601":`Диаграмма целей`,
"c251":`публикация поста(ов) не удалась`,
"c202":`Поделиться в Mailchimp`,
"font-social-prohibit-create":`Вы не можете создать новое сообщение во время редактирования`,
"c394":`CloudCC поможет вам управлять бизнесом онлайн и повысить эффективность. Пожалуйста, выберите приложение, которое вы хотите использовать, и следуйте вводным инструкциям.`,
"c1642":`Настройки участника`,
"c1684":`Объекты`,
"c1362":`Пустой`,
"c1124":`Диапазон обменных курсов: 20220531 до Tue May 31 00:00:00 CST 2022`,
"c1323":`Показать обязательные поля`,
"c323":`Формат PDF`,
"front-setting-dialog-title-one":`Чтобы предотвратить потерю счета, быстро войти в систему и легко получить информацию, пожалуйста, привяжите номер телефона`,
"front-electronic-signature-cancelIntro2":`Если вы впервые привязываете учетную запись, нажмите Продолжить, чтобы перейти к следующему шагу. Если вы перепривязываетесь после отвязки, рекомендуется нажать Отмена и перепривязаться после очистки данных просмотра.`,
"c1715":`Включить: Модуль будет отображаться в разделе "Еще"  "Стандартные возможности" на мобильной стороне после установки флажка
Отключить: Модуль больше не будет отображаться в "More"  "Standard Features" на мобильной стороне после установки флажка`,
"c1379":`Удалить эту подколонку сейчас?`,
"c353":`Отображение табелей учета рабочего времени`,
"c621":`Насыщенный текстовый контент`,
"front-v1-partner-image-tooltip":`Поддерживается файл размером не более 2 М. Изображение будет уменьшено до {размер}. Рекомендуется загружать четкие изображения с похожими пропорциями.`,
"c1967":``,
"c772":`Доработанный`,
"c1018":`Добавить параметры сущности`,
"c734":`Название канала плаката`,
"c380":`Новый платеж`,
"c1291":`Цвет состояния Легенда`,
"c979":`Чунцин`,
"c1723":`Ошибка формата. Пожалуйста, используйте формат yyyy/MM/dd или yyyyMMdd, или функцию: Today()`,
"c1247":`Требуется единогласное одобрение всех выбранных утверждающих лиц`,
"c1514":`Роль: Shandong One`,
"c233":`Вы не можете удалить упаковочный лист состояния отгрузки`,
"c458":`Карта распределения счетов`,
"c697":`Выберите адрес учетной записи{имя}`,
"c1701":`Базисный адрес`,
"c476":`Выберите сотрудника, которому нужно отправить код приглашения`,
"c634":`Создайте увлекательный пост и общайтесь со всем миром`,
"c1567":`Пожалуйста, введите правильный номер с максимальной длиной 8 цифр`,
"c1288":`Правила рекомендательной политики`,
"c1607":`Свойства поля даты и времени`,
"c1166":`Настроить`,
"c144":`Время окончания не может превышать 2038 года. Пожалуйста, выберите новое время окончания.`,
"c1032":`Пересчитано по курсу обмена валют`,
"c474":`Переназначение можно выполнить с помощью правил назначения ведущих. Правила назначения см.`,
"c371":`Синхронизация с возможностями`,
"c420":`Эксплуатационные активы`,
"c620":`Это используется для группировки нескольких частей контента для анализа в рамках одного маркетингового усилия.`,
"c1643":`Замена групповых ролей`,
"c708":`Унифицировать шкалу или нет`,
"c100":`Скидка`,
"c576":`Двухмерная столбчатая диаграмма`,
"c751":`Крайний срок подписания:`,
"c1132":`Пожалуйста, введите этикетку`,
"c252":`Настройки соответствия`,
"c1562":`Нечего менять`,
"c699":`Только новые`,
"c74":`Оплата через возврат`,
"c1778":`Допустимое количество снимков`,
"c805":`Выберите социальную сеть для начала работы:`,
"c452":`История болезни`,
"c740":`Пожалуйста, выберите сотрудника для отправки приглашения`,
"c596":`Двухосная диаграмма`,
"c1508":`Помните`,
"c1137":`Удаление заданий`,
"c1636":`Шаблоны отчетов об обслуживании`,
"c1792":`Переназначение операции`,
"c832":`Просмотр`,
"c971":`Планируемый выпуск`,
"c262":`История`,
"c363":`Чувствительный`,
"c1117":`Операция навсегда удалит это правило рабочего процесса. Продолжить?`,
"label.singleSignOn.is.invalid":`Логинбесплатный был недействительным`,
"c1941":`Молниеносная версия на ПК`,
"c72":`Оплата третьим лицом`,
"c1870":``,
"c292":`Маркетинг`,
"c1874":``,
"c1131":`Новый набор разрешений`,
"c1807":``,
"c1349":`Рабочий процесс копирования`,
"c499":`Эффективное обслуживание клиентов, чтобы произвести на них впечатление`,
"c574":`Сложенные столбчатые диаграммы`,
"c1593":`Свойства поля URL`,
"c618":`Измените содержание или время публикации этого сообщения.  Twitter не позволяет публиковать более одного сообщения с одинаковым содержанием в течение 24 часов.`,
"front-setting-phone-format":`Пожалуйста, введите номер телефона в правильном формате`,
"c460":`Рейтинг по размеру счета`,
"c189":`Валюта счетафактуры должна соответствовать валюте заказа. Пожалуйста, уточните валюту и сохраните снова.`,
"label.exe.supported.request.rejected":`exe. файл не поддерживается для отправки. Запрос отклонен!`,
"c835":`Для этой котировки уже существует счетфактура. Продолжать или нет?`,
"c1907":`1. Загрузить шаблон: Выберите объект (Поддерживается загрузка шаблонов для текущего объекта)`,
"c1720":`Поиск вспомогательных полей`,
"c1850":``,
"c655":`Сообщение от`,
"c1513":`Владелец приравнивается к бийчанам обыкновенным`,
"c1781":`При определении этапов утверждения запросы на утверждение могут быть назначены различным пользователям. Одним из вариантов является автоматическая отправка этих запросов с использованием поля пользователя.`,
"c1392":`Пожалуйста, введите дату окончания`,
"c45":`Подключение`,
"c1821":``,
"c43":`Подключить счет`,
"c1534":`Поле макета существенной информации не может быть пустым`,
"c481":`Войдите в систему под другим пользователем`,
"c674":`Внешний адрес`,
"c266":`Этот заказ не может быть изменен, поскольку он уже выполнен`,
"c967":`Вы собираетесь отключить {0} аккаунт. Это приведет к удалению всех настроек социальных сетей и возможностей публикации, связанных с этим аккаунтом`,
"c1010":`Деактивировано`,
"c1769":`Истекает до {дата}`,
"c154":`Пожалуйста, выполните поиск по прайслистам после выбора продукции`,
"c841":`Есть идеи? Выдвигайте.   `,
"c615":`Счет не выбран`,
"c1416":`Ошибка десятичного формата`,
"c84":`Выберите сотрудника для отправки кода приглашения`,
"c401":`Сервис`,
"c290":`Включенные объекты`,
"c1733":`Диспетчер`,
"c205":`Скачать QRкод`,
"c928":`Можно выбрать до 10 полей.`,
"c195":`Лимит подачи`,
"1":`Нет доступных действий`,
"c1224":`Недостаточно прав, пожалуйста, обратитесь к системному администратору для настройки роли в соответствии с информацией таблицы пользователей библиотеки конфигурации мультиорганизации, идентификатор роли: {id}`,
"c46":`Авторизация прошла успешно`,
"c459":`Подписанный контракт Сумма`,
"c1387":`Неиспользуемые поля`,
"c1394":`Редактирование значения списка опций`,
"c1274":`Редактирование набора списков глобальных опций`,
"c1528":`Больше или равно`,
"c2083":``,
"c250":`сообщения сохраняются как черновики`,
"c399":`Инвентаризация`,
"c1107":`Проверка состояния расширенного фильтра не удалась, пожалуйста, проверьте повторно`,
"c1589":`Свойства поля текстовой области`,
"c1774":`Настроенные поля`,
"c1034":`Слишком длинное имя объекта`,
"c518":`Запись #recordName из #label не прошла утверждение по причине #failReason`,
"c396":`Выбирайте различные решения`,
"c300":`Уничтожить по требованию`,
"c789":`Метод подписи без ограничений`,
"c874":`Вы прочитали все, что было в вашем почтовом ящике.`,
"c1955":``,
"c38":`Номер квартала сообщества`,
"c228":`Добавить подзадачу`,
"c1122":`Когда условие правила встречается впервые при создании или редактировании записей`,
"c342":`Прибыль`,
"c1747":`Нажмите Вход для инициализации`,
"c1703":`Разрешено ли загружать изображения из альбома`,
"c879":`Клонирование социальных постов`,
"c173":`Успешное переплетение`,
"c1089":`Все записи`,
"c1354":`Название макета страницы`,
"c778":`Инициатор`,
"c1594":`Требуется`,
"c1334":`Пароль SMSшлюза (MD5)`,
"c1946":``,
"c1515":`Переписывание стандартных кнопок и ссылок изменяет значение URL CloudCC и всех обращений к этому URL, таких как страницы CloudCC, ярлыки браузера или внешние системы.
Вы можете заменить стандартные кнопки или связанные CloudCC URL на пользовательскую страницу CloudCC.
Пожалуйста, выберите пользовательскую страницу для замены стандартной кнопки или ссылки CloudCC URL.`,
"c211":`Небольшой размер`,
"c1601":`Свойства поля Picklist`,
"c1159":`Первое время выполнения  # время, а затем каждые #число минут.`,
"c1825":``,
"c1478":`Введите имя правила и установите флажок Включено, чтобы использовать это правило для автоматического обновления случая.
Включение этого правила отключает текущее правило обновления случая.`,
"c1388":`Создать новое поле`,
"c496":`CloudCC Sales Cloud  интеллектуальная CRM для всех сценариев, которая поможет вам достичь целей в области продаж`,
"c1085":`Редактировать профиль`,
"c427":`Диспетчеризация в режиме диаграммы Ганта`,
"c851":`Здесь показано количество сообщений, которые были опубликованы в ваших аккаунтах за выбранный период.`,
"c32":`Новый тип подписки`,
"c1953":``,
"c1165":`Визитная карточка`,
"c28":`Рост за год`,
"c2088":``,
"c163":`Одновременное информирование и отмена отправки`,
"c1772":`Онлайнкейс`,
"c1743":`Пользовательская страница выхода из системы`,
"c1863":``,
"c225":`Перейти к заданию`,
"c569":`Пожалуйста, сначала выберите счет`,
"c1317":`Действие отключит этот рабочий процесс. Продолжить?`,
"c92":`Открыть один раз`,
"c1706":`Настройка домашней страницы на уровне организации по реальному сценарию`,
"c412":`Автоматическое создание назначений на обслуживание`,
"c81":`Добавить в корзину`,
"c999":`Неправильный номер мобильного телефона или пароль`,
"c653":`Здесь отображается количество лайков, реакций и комментариев к опубликованным вами сообщениям. Сюда также входят сообщения, которые были опубликованы на ваших подключенных аккаунтах за пределами CloudCC Если вы ищете ретвиты в Twitter, вы найдете их в Shares.`,
"c1762":`Поле расширения`,
"c1467":`Имя финансового года должно быть целым положительным числом.`,
"c1647":`Настройки группы возможностей`,
"c516":`Посещаемость`,
"c1241":`Разрешить или передать пользователям право редактировать личную информацию`,
"c1459":`Загрузите и сохраните в файл.`,
"c918":`Если настроены правила автоциклирования, система будет автоматически отправлять записи в пул, если аккаунт не закрыл сделку по истечении установленного срока. Это повышает эффективность последующей работы со счетами.`,
"c809":`LIKES`,
"c1570":`Исключения при экспорте`,
"c1532":`Выберите функцию`,
"c1192":`Это задачи, которые назначаются пользователям при выполнении правил рабочего процесса, чертежей и процессов утверждения.`,
"c181":`Пожалуйста, заполните заказнаряд или историю болезни`,
"c745":`Пожалуйста, введите до 2 знаков после запятой`,
"c669":`Цвет`,
"c929":`Пожалуйста, проверьте сетевое подключение`,
"c117":`Сохранить и оплатить`,
"c1240":`Роли и настройки пользователей Partner Cloud  Количество ролей пользователей`,
"c938":`материковый Китай`,
"c112":`Все шаблоны {name} в настоящее время отключены. Пожалуйста, обратитесь к администратору, чтобы включить шаблон перед генерацией {name}.`,
"c347":`Изменение рабочего времени задачи проекта`,
"c795":`Пожалуйста, выберите шаблон договора`,
"c1631":`Настройки доступа`,
"c17":`Неактивны. Пожалуйста, выберите заново`,
"c787":`Подписано оператором`,
"c829":`КАМПАНИЯ`,
"c1929":`Перевод статей  Отправить перевод`,
"c1041":`3. Тип файла`,
"c161":`Также сообщите`,
"c1936":`Все записи отображаются, если условие поля не задано.`,
"c65":`Вы хотите изменить логистический статус продукта на Доставлен`,
"c1958":``,
"c1843":`Подключение`,
"c1823":``,
"c665":`Добавьте еще один`,
"c767":`Проверка хода подписания`,
"c87":`QRкод формы кампании`,
"c589":`Карта Франции`,
"c1343":`В настоящее время вы используете бесплатную версию. Максимальное количество запросов к API в день составляет 10 000.
Если вам необходимо расширить количество запросов, рекомендуется приобрести услуги.
После приобретения услуги получите токен от производителя для настройки на этой странице, а производитель предоставит вам соответствующую платную услугу.
По вопросам приобретения или запроса, пожалуйста, обращайтесь по телефону 4006422008`,
"c1405":`Шаблон для объединения электронной почты представляет собой документ Microsoft Word, где поле объединения относится к полю CloudCC. Нажмите кнопку Новый шаблон, чтобы загрузить новый шаблон слияния по электронной почте.`,
"front-electronic-signature-newTime":`Последнее обновление`,
"c813":`ПОДЕЛИТЬСЯ`,
"c85":`{выбранный пригласитель`,
"c951":`Польша`,
"c1853":``,
"c1788":`Введите и нажмите ENTER для поиска`,
"c29":`Рост по сравнению с предыдущим месяцем`,
"c1170":`Выберите стандартные кнопки, отображаемые в связанном списке. Можно также изменить порядок выбранных кнопок.`,
"c210":`Большой размер`,
"c1615":`Импортная квота`,
"c39":`Архивировано`,
"c672":`Слово`,
"c97":`Этот список должен содержать, по крайней мере, один вариант "Преобразован"`,
"c687":`Максимальный размер`,
"c1646":`Название типа записи`,
"c916":`Закрыть бассейн`,
"c475":`Пожалуйста, заполните данные о владельце кампании`,
"c1376":`Что бы вы хотели сделать?`,
"c1097":`Правила применения`,
"c1812":`Введение`,
"c1486":`Время начала`,
"c628":`Запланировано`,
"c788":`Книга цен для этой возможности в настоящее время отключена. Пожалуйста, включите книгу цен перед созданием нового заказа.`,
"c1030":`Продукт(ы) в упаковке`,
"c1670":`Предпочтения по ресурсам`,
"c1436":`Выберите макет`,
"c1302":`Направление синхронизации событий`,
"c1768":`Изменить`,
"c1902":`Назад`,
"c177":`Предлагаемый размер: 390*210`,
"c1980":``,
"c1859":``,
"c856":`Ура! Нет неудачных постов.`,
"c1782":`Чтобы применить эту опцию к любым этапам утверждения, выберите поле из списка ниже.`,
"c70":`Информация о заказе`,
"c1533":`Этикетка не может быть пустой`,
"c1141":`Тип лицензии`,
"c546":`Последние 24 часа`,
"c1447":`Не разрешается удалять пользователей из списка выбранных пользователей всем неназначенным и включенным пользователям, а также всем неназначенным пользователям`,
"c331":`Конвертировать активы`,
"label.order.paidamount.greater.than.total":`После создания новых платежных реквизитов возвращаемая сумма заказа будет больше, чем сумма заказа. Пожалуйста, скорректируйте платеж, а затем сохраните его.`,
"c524":`Reinvite`,
"c1456":`Чтобы назначить других пользователей на эту роль:`,
"c1758":`Общий размер фотографий не должен превышать 20MB`,
"c1175":`Установить как обязательное поле`,
"c1547":`Просмотр/добавление неиспользуемых значений`,
"c1717":`Вы получили новый рабочий заказ {0}. Пожалуйста, нажмите, чтобы просмотреть и своевременно обработать его.`,
"c246":`{!oldServiceResource.name} передал вам заказ на работу под номером {!ServiceAppointment.name}.`,
"c986":`Скачать руководства`,
"c1748":`Существующий пользователь`,
"label.parameter.is.incorrect":`Неправильные параметры`,
"c1242":`Имя связанного списка`,
"c1982":``,
"c1687":`Темы`,
"c1591":`Имя поля должно начинаться с буквы и может содержать только прописные и строчные буквы, цифры, подчеркивания, максимальная длина {maxApinameLength} и минимум 2 цифры`,
"c667":`Промежуток между значками`,
"c1817":``,
"c1375":`Удалите поля, которые вы хотите удалить в этом макете, или переместите их в панель "Неиспользуемые поля" слева.`,
"c737":`Социальная платформа`,
"c1695":`Пространство разработчика`,
"c48":`Отключить`,
"c111":`Создать {имя}`,
"c1582":`Немецкий`,
"c755":`По порядку`,
"c1333":`Добавить триггер`,
"c526":`Включить пользователя портала`,
"c450":`Объединить дела`,
"front-electronic-export-reChoseChimp":`Текущее представление не содержит записей данных и не может быть экспортировано. Пожалуйста, выберите новое представление`,
"c1759":`Значок облака мобильных услуг`,
"label.invoice.paidamount.greater.than.total":`После создания новых платежных реквизитов возвращаемая сумма счета будет больше, чем общая стоимость. Пожалуйста, скорректируйте платеж, а затем сохраните его.`,
"c1688":`Объекты`,
"c222":`Редактировать проект`,
"c849":`Аккаунты в Twitter`,
"c1549":`Выбор пакетного добавления`,
"c1369":`Заголовок не виден`,
"c678":`Черное и белое`,
"c502":`Предлагает комплексные решения для обработки всех процессов, связанных с полевыми услугами, для оптимизации операций, повышения производительности, увеличения лояльности и удовлетворенности клиентов.`,
"c1476":`Удалено!`,
"c1052":`Изменить шаблон макета страницы`,
"c497":`Более разумная инвентаризация, более эффективное управление бизнесом и финансами`,
"c1458":`Сохранить в файл`,
"c1815":``,
"c200":`Поделиться в социальных сетях`,
"c1893":``,
"c1258":`Пожалуйста, выберите шаблон для SMSуведомления`,
"c1272":`Скрыть все`,
"c658":`Насыщенный текст`,
"c434":`Новый связанный контакт`,
"c1848":``,
"c641":`Вы можете выбрать не более 4 изображений, нажмите на выбранное изображение, чтобы отменить выбор. Размер загружаемого изображения не должен превышать 200 кб.`,
"c944":`Германия`,
"c1221":`Вы уверены, что удалите?`,
"c411":`Смещение сроков исполнения`,
"c1114":`Выберите поле для вставки`,
"c1353":`Чтобы найти ключи API и секреты API, вы можете войти в свою учетную запись Vonage API и перейти в раздел Настройки под именем вашей учетной записи.
Чтобы найти номер телефона в вашей учетной записи Vonage API, перейдите в раздел Номер под продуктами, а затем нажмите на свой номер, чтобы увидеть все имеющиеся у вас телефонные номера.`,
"c1776":`Срок действия ссылки по умолчанию`,
"c1565":`Новый пользовательский объект`,
"c1619":`Настройки онлайнплатежей`,
"c1115":`Введите имя правила рабочего процесса`,
"c624":` Все счета`,
"label.twitter.title":`TwitterH5 MiniApp`,
"c1319":`Ограничение снято`,
"c1696":`Установленные пакеты программного обеспечения`,
"c1746":`Уполномоченный эмитент`,
"c791":`Стандартная подпись`,
"c1965":``,
"c1728":`Свойства поля оценки`,
"c306":`Согласитесь`,
"c14":`Текущий пользователь не имеет права на удаление`,
"c176":`Для загрузки поддерживаются только изображения в формате png, jpg и jpeg. Размер загружаемого изображения не может превышать 2 Мб.`,
"c1335":`Стартовый символ`,
"c997":`Список функций SKU`,
"c1233":`Все неназначенные пользователи`,
"c1566":`Должен начинаться с буквы, может содержать только заглавные и строчные буквы, цифры, знаки подчеркивания, максимальная длина 30, минимальная 2 цифры, и не может быть ключевым словом в базе данных`,
"c166":`Пожалуйста, введите максимальную длину заказа в соответствии с правилами`,
"c731":`Изменение выбранного справочника цен также приведет к удалению всех существующих продуктов. Вы уверены, что хотите перейти на новый справочник цен?`,
"c2086":``,
"c237":`{!ServiceResource.name} принял заказ. Номер: "{!ServiceAppointment.name}"`,
"c887":`Повторное успешное приглашение пользователя`,
"c1418":`Шаг 1: Выберите управляющее поле и зависимое поле.
После завершения нажмите кнопку Продолжить.`,
"c227":`Редактировать подзадачу`,
"c1674":`Пункт оценки`,
"c257":`Доступный контакт`,
"c1867":``,
"c1864":`Пользователь 1`,
"c712":`Составлять отчеты и сравнивать эффективность работы сетей, постов и кампаний.`,
"c107":`Поиск пользователей по имени, учетной записи и номеру мобильного телефона`,
"c1767":`Дата истечения срока действия ссылки`,
"c1310":`Поведение в условиях конфликта задач`,
"c1627":`Минипрограммы WeChat`,
"c1266":`Добавить в пользовательские приложения`,
"c1262":`Последняя правка`,
"c370":`Контракт`,
"c1878":``,
"c1784":`Пожалуйста, введите. (игнорировать, если уже введен)`,
"c895":`Расчет расстояния не удался, пожалуйста, введите полный адрес`,
"c1029":`Конфигурация продукта`,
"c693":`Ауторегуляция`,
"c763":`Подписано`,
"c302":`Законные интересы`,
"c577":`Диаграмма со сложенными столбцами`,
"c258":`Подать жалобу`,
"c1757":`Разрешить ограничения на изображения`,
"c1879":``,
"c676":`Центр`,
"c1609":`Свойства поля Email`,
"c868":`После деактивации этой учетной записи система ограничит ее доступ или операции на вашем портале. Продолжить?`,
"c53":`Соотношение (%)`,
"c527":`#userName назначил вам задание на утверждение`,
"c1816":``,
"c1579":`Японский`,
"c984":`Сеть подключена`,
"c1021":`2. Книга цен может влиять на цену продукта в возможностях, котировках, заказах, счетах и заказах на покупку. Если 5 вышеуказанных объектов связаны с книгой цен, сотрудники отдела продаж могут выбрать в книге цен только те продукты, цена которых принята по умолчанию.`,
"label.facebook.title.setting":`Интегрированная информация Facebook`,
"c1888":``,
"c340":`Изменение владельца плана проекта`,
"c1764":`QRкод онлайнкейса`,
"c1868":`Пожалуйста, введите правильный адрес электронной почты`,
"c706":`О графиках`,
"label.mobile.used":`Номер мобильного телефона был использован`,
"c328":`QRкод актива`,
"c1761":`Индивидуальный клиент`,
"c337":`Контакты  Уничтожить`,
"c1605":`Свойства поля "Телефон`,
"c1935":`Нет разрешения. Пожалуйста, свяжитесь с администратором.`,
"c642":`Последние изображения`
}